import _defineProperty from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _slicedToArray from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _assertThisInitialized from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _asyncToGenerator from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _wrapNativeSuper from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _get from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _toConsumableArray from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createClass from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import "core-js/modules/es.promise.finally.js";
import _regeneratorRuntime from "/var/www/www-root/data/www/modular-house.by/modular-house/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e404) { throw _e404; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e405) { didErr = true; err = _e405; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
var t = "undefined" != typeof window && null != window.customElements && void 0 !== window.customElements.polyfillWrapFlushCallback,
    e = function e(t, _e2) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  for (; _e2 !== n;) {
    var _n2 = _e2.nextSibling;
    t.removeChild(_e2), _e2 = _n2;
  }
},
    n = "{{lit-".concat(String(Math.random()).slice(2), "}}"),
    i = "<!--".concat(n, "-->"),
    r = new RegExp("".concat(n, "|").concat(i));

var s = function s(t, e) {
  _classCallCheck(this, s);

  this.parts = [], this.element = e;
  var i = [],
      _s2 = [],
      o = document.createTreeWalker(e.content, 133, null, !1);
  var c = 0,
      u = -1,
      d = 0;
  var p = t.strings,
      m = t.values.length;

  for (; d < m;) {
    var _t2 = o.nextNode();

    if (null !== _t2) {
      if (u++, 1 === _t2.nodeType) {
        if (_t2.hasAttributes()) {
          var _e3 = _t2.attributes,
              _n3 = _e3.length;
          var _i2 = 0;

          for (var _t3 = 0; _t3 < _n3; _t3++) {
            a(_e3[_t3].name, "$lit$") && _i2++;
          }

          for (; _i2-- > 0;) {
            var _e4 = p[d],
                _n4 = h.exec(_e4)[2],
                _i3 = _n4.toLowerCase() + "$lit$",
                _s5 = _t2.getAttribute(_i3);

            _t2.removeAttribute(_i3);

            var _a2 = _s5.split(r);

            this.parts.push({
              type: "attribute",
              index: u,
              name: _n4,
              strings: _a2
            }), d += _a2.length - 1;
          }
        }

        "TEMPLATE" === _t2.tagName && (_s2.push(_t2), o.currentNode = _t2.content);
      } else if (3 === _t2.nodeType) {
        var _e5 = _t2.data;

        if (_e5.indexOf(n) >= 0) {
          var _n5 = _t2.parentNode,
              _s6 = _e5.split(r),
              _o2 = _s6.length - 1;

          for (var _e6 = 0; _e6 < _o2; _e6++) {
            var _i4 = void 0,
                _r2 = _s6[_e6];

            if ("" === _r2) _i4 = l();else {
              var _t4 = h.exec(_r2);

              null !== _t4 && a(_t4[2], "$lit$") && (_r2 = _r2.slice(0, _t4.index) + _t4[1] + _t4[2].slice(0, -"$lit$".length) + _t4[3]), _i4 = document.createTextNode(_r2);
            }
            _n5.insertBefore(_i4, _t2), this.parts.push({
              type: "node",
              index: ++u
            });
          }

          "" === _s6[_o2] ? (_n5.insertBefore(l(), _t2), i.push(_t2)) : _t2.data = _s6[_o2], d += _o2;
        }
      } else if (8 === _t2.nodeType) if (_t2.data === n) {
        var _e7 = _t2.parentNode;
        null !== _t2.previousSibling && u !== c || (u++, _e7.insertBefore(l(), _t2)), c = u, this.parts.push({
          type: "node",
          index: u
        }), null === _t2.nextSibling ? _t2.data = "" : (i.push(_t2), u--), d++;
      } else {
        var _e8 = -1;

        for (; -1 !== (_e8 = _t2.data.indexOf(n, _e8 + 1));) {
          this.parts.push({
            type: "node",
            index: -1
          }), d++;
        }
      }
    } else o.currentNode = _s2.pop();
  }

  for (var _i6 = 0, _i5 = i; _i6 < _i5.length; _i6++) {
    var _t5 = _i5[_i6];

    _t5.parentNode.removeChild(_t5);
  }
};

var a = function a(t, e) {
  var n = t.length - e.length;
  return n >= 0 && t.slice(n) === e;
},
    o = function o(t) {
  return -1 !== t.index;
},
    l = function l() {
  return document.createComment("");
},
    h = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;

function c(t, e) {
  var n = t.element.content,
      i = t.parts,
      r = document.createTreeWalker(n, 133, null, !1);
  var s = d(i),
      a = i[s],
      o = -1,
      l = 0;
  var h = [];
  var c = null;

  for (; r.nextNode();) {
    o++;
    var _t6 = r.currentNode;

    for (_t6.previousSibling === c && (c = null), e.has(_t6) && (h.push(_t6), null === c && (c = _t6)), null !== c && l++; void 0 !== a && a.index === o;) {
      a.index = null !== c ? -1 : a.index - l, s = d(i, s), a = i[s];
    }
  }

  h.forEach(function (t) {
    return t.parentNode.removeChild(t);
  });
}

var u = function u(t) {
  var e = 11 === t.nodeType ? 0 : 1;
  var n = document.createTreeWalker(t, 133, null, !1);

  for (; n.nextNode();) {
    e++;
  }

  return e;
},
    d = function d(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

  for (var _n6 = e + 1; _n6 < t.length; _n6++) {
    var _e9 = t[_n6];
    if (o(_e9)) return _n6;
  }

  return -1;
};
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var p = new WeakMap(),
    m = function m(t) {
  return "function" == typeof t && p.has(t);
},
    f = {},
    g = {};
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var v = /*#__PURE__*/function () {
  function v(t, e, n) {
    _classCallCheck(this, v);

    this.__parts = [], this.template = t, this.processor = e, this.options = n;
  }

  _createClass(v, [{
    key: "update",
    value: function update(t) {
      var e = 0;

      var _iterator = _createForOfIteratorHelper(this.__parts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _n7 = _step.value;
          void 0 !== _n7 && _n7.setValue(t[e]), e++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.__parts),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t7 = _step2.value;
          void 0 !== _t7 && _t7.commit();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_clone",
    value: function _clone() {
      var e = t ? this.template.element.content.cloneNode(!0) : document.importNode(this.template.element.content, !0),
          n = [],
          i = this.template.parts,
          r = document.createTreeWalker(e, 133, null, !1);
      var s,
          a = 0,
          l = 0,
          h = r.nextNode();

      for (; a < i.length;) {
        if (s = i[a], o(s)) {
          var _this$__parts;

          for (; l < s.index;) {
            l++, "TEMPLATE" === h.nodeName && (n.push(h), r.currentNode = h.content), null === (h = r.nextNode()) && (r.currentNode = n.pop(), h = r.nextNode());
          }

          if ("node" === s.type) {
            var _t8 = this.processor.handleTextExpression(this.options);

            _t8.insertAfterNode(h.previousSibling), this.__parts.push(_t8);
          } else (_this$__parts = this.__parts).push.apply(_this$__parts, _toConsumableArray(this.processor.handleAttributeExpressions(h, s.name, s.strings, this.options)));

          a++;
        } else this.__parts.push(void 0), a++;
      }

      return t && (document.adoptNode(e), customElements.upgrade(e)), e;
    }
  }]);

  return v;
}();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var y = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
  createHTML: function createHTML(t) {
    return t;
  }
}),
    x = " ".concat(n, " ");

var _ = /*#__PURE__*/function () {
  function _(t, e, n, i) {
    _classCallCheck(this, _);

    this.strings = t, this.values = e, this.type = n, this.processor = i;
  }

  _createClass(_, [{
    key: "getHTML",
    value: function getHTML() {
      var t = this.strings.length - 1;
      var e = "",
          r = !1;

      for (var _s7 = 0; _s7 < t; _s7++) {
        var _t9 = this.strings[_s7],
            _a3 = _t9.lastIndexOf("\x3c!--");

        r = (_a3 > -1 || r) && -1 === _t9.indexOf("--\x3e", _a3 + 1);

        var _o3 = h.exec(_t9);

        e += null === _o3 ? _t9 + (r ? x : i) : _t9.substr(0, _o3.index) + _o3[1] + _o3[2] + "$lit$" + _o3[3] + n;
      }

      return e += this.strings[t], e;
    }
  }, {
    key: "getTemplateElement",
    value: function getTemplateElement() {
      var t = document.createElement("template");
      var e = this.getHTML();
      return void 0 !== y && (e = y.createHTML(e)), t.innerHTML = e, t;
    }
  }]);

  return _;
}();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var b = function b(t) {
  return null === t || !("object" == typeof t || "function" == typeof t);
},
    w = function w(t) {
  return Array.isArray(t) || !(!t || !t[Symbol.iterator]);
};

var M = /*#__PURE__*/function () {
  function M(t, e, n) {
    _classCallCheck(this, M);

    this.dirty = !0, this.element = t, this.name = e, this.strings = n, this.parts = [];

    for (var _t10 = 0; _t10 < n.length - 1; _t10++) {
      this.parts[_t10] = this._createPart();
    }
  }

  _createClass(M, [{
    key: "_createPart",
    value: function _createPart() {
      return new S(this);
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var t = this.strings,
          e = t.length - 1,
          n = this.parts;

      if (1 === e && "" === t[0] && "" === t[1]) {
        var _t11 = n[0].value;
        if ("symbol" == typeof _t11) return String(_t11);
        if ("string" == typeof _t11 || !w(_t11)) return _t11;
      }

      var i = "";

      for (var _r3 = 0; _r3 < e; _r3++) {
        i += t[_r3];
        var _e10 = n[_r3];

        if (void 0 !== _e10) {
          var _t12 = _e10.value;
          if (b(_t12) || !w(_t12)) i += "string" == typeof _t12 ? _t12 : String(_t12);else {
            var _iterator3 = _createForOfIteratorHelper(_t12),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _e11 = _step3.value;
                i += "string" == typeof _e11 ? _e11 : String(_e11);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      }

      return i += t[e], i;
    }
  }, {
    key: "commit",
    value: function commit() {
      this.dirty && (this.dirty = !1, this.element.setAttribute(this.name, this._getValue()));
    }
  }]);

  return M;
}();

var S = /*#__PURE__*/function () {
  function S(t) {
    _classCallCheck(this, S);

    this.value = void 0, this.committer = t;
  }

  _createClass(S, [{
    key: "setValue",
    value: function setValue(t) {
      t === f || b(t) && t === this.value || (this.value = t, m(t) || (this.committer.dirty = !0));
    }
  }, {
    key: "commit",
    value: function commit() {
      for (; m(this.value);) {
        var _t13 = this.value;
        this.value = f, _t13(this);
      }

      this.value !== f && this.committer.commit();
    }
  }]);

  return S;
}();

var T = /*#__PURE__*/function () {
  function T(t) {
    _classCallCheck(this, T);

    this.value = void 0, this.__pendingValue = void 0, this.options = t;
  }

  _createClass(T, [{
    key: "appendInto",
    value: function appendInto(t) {
      this.startNode = t.appendChild(l()), this.endNode = t.appendChild(l());
    }
  }, {
    key: "insertAfterNode",
    value: function insertAfterNode(t) {
      this.startNode = t, this.endNode = t.nextSibling;
    }
  }, {
    key: "appendIntoPart",
    value: function appendIntoPart(t) {
      t.__insert(this.startNode = l()), t.__insert(this.endNode = l());
    }
  }, {
    key: "insertAfterPart",
    value: function insertAfterPart(t) {
      t.__insert(this.startNode = l()), this.endNode = t.endNode, t.endNode = this.startNode;
    }
  }, {
    key: "setValue",
    value: function setValue(t) {
      this.__pendingValue = t;
    }
  }, {
    key: "commit",
    value: function commit() {
      if (null === this.startNode.parentNode) return;

      for (; m(this.__pendingValue);) {
        var _t14 = this.__pendingValue;
        this.__pendingValue = f, _t14(this);
      }

      var t = this.__pendingValue;
      t !== f && (b(t) ? t !== this.value && this.__commitText(t) : t instanceof _ ? this.__commitTemplateResult(t) : t instanceof Node ? this.__commitNode(t) : w(t) ? this.__commitIterable(t) : t === g ? (this.value = g, this.clear()) : this.__commitText(t));
    }
  }, {
    key: "__insert",
    value: function __insert(t) {
      this.endNode.parentNode.insertBefore(t, this.endNode);
    }
  }, {
    key: "__commitNode",
    value: function __commitNode(t) {
      this.value !== t && (this.clear(), this.__insert(t), this.value = t);
    }
  }, {
    key: "__commitText",
    value: function __commitText(t) {
      var e = this.startNode.nextSibling,
          n = "string" == typeof (t = null == t ? "" : t) ? t : String(t);
      e === this.endNode.previousSibling && 3 === e.nodeType ? e.data = n : this.__commitNode(document.createTextNode(n)), this.value = t;
    }
  }, {
    key: "__commitTemplateResult",
    value: function __commitTemplateResult(t) {
      var e = this.options.templateFactory(t);
      if (this.value instanceof v && this.value.template === e) this.value.update(t.values);else {
        var _n8 = new v(e, t.processor, this.options),
            _i7 = _n8._clone();

        _n8.update(t.values), this.__commitNode(_i7), this.value = _n8;
      }
    }
  }, {
    key: "__commitIterable",
    value: function __commitIterable(t) {
      Array.isArray(this.value) || (this.value = [], this.clear());
      var e = this.value;
      var n,
          i = 0;

      var _iterator4 = _createForOfIteratorHelper(t),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _r4 = _step4.value;
          n = e[i], void 0 === n && (n = new T(this.options), e.push(n), 0 === i ? n.appendIntoPart(this) : n.insertAfterPart(e[i - 1])), n.setValue(_r4), n.commit(), i++;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      i < e.length && (e.length = i, this.clear(n && n.endNode));
    }
  }, {
    key: "clear",
    value: function clear() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startNode;
      e(this.startNode.parentNode, t.nextSibling, this.endNode);
    }
  }]);

  return T;
}();

var E = /*#__PURE__*/function () {
  function E(t, e, n) {
    _classCallCheck(this, E);

    if (this.value = void 0, this.__pendingValue = void 0, 2 !== n.length || "" !== n[0] || "" !== n[1]) throw new Error("Boolean attributes can only contain a single expression");
    this.element = t, this.name = e, this.strings = n;
  }

  _createClass(E, [{
    key: "setValue",
    value: function setValue(t) {
      this.__pendingValue = t;
    }
  }, {
    key: "commit",
    value: function commit() {
      for (; m(this.__pendingValue);) {
        var _t15 = this.__pendingValue;
        this.__pendingValue = f, _t15(this);
      }

      if (this.__pendingValue === f) return;
      var t = !!this.__pendingValue;
      this.value !== t && (t ? this.element.setAttribute(this.name, "") : this.element.removeAttribute(this.name), this.value = t), this.__pendingValue = f;
    }
  }]);

  return E;
}();

var A = /*#__PURE__*/function (_M) {
  _inherits(A, _M);

  var _super = _createSuper(A);

  function A(t, e, n) {
    var _this;

    _classCallCheck(this, A);

    _this = _super.call(this, t, e, n), _this.single = 2 === n.length && "" === n[0] && "" === n[1];
    return _this;
  }

  _createClass(A, [{
    key: "_createPart",
    value: function _createPart() {
      return new R(this);
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      return this.single ? this.parts[0].value : _get(_getPrototypeOf(A.prototype), "_getValue", this).call(this);
    }
  }, {
    key: "commit",
    value: function commit() {
      this.dirty && (this.dirty = !1, this.element[this.name] = this._getValue());
    }
  }]);

  return A;
}(M);

var R = /*#__PURE__*/function (_S) {
  _inherits(R, _S);

  var _super2 = _createSuper(R);

  function R() {
    _classCallCheck(this, R);

    return _super2.apply(this, arguments);
  }

  return R;
}(S);

var C = !1;

(function () {
  try {
    var _t16 = {
      get capture() {
        return C = !0, !1;
      }

    };
    window.addEventListener("test", _t16, _t16), window.removeEventListener("test", _t16, _t16);
  } catch (t) {}
})();

var L = /*#__PURE__*/function () {
  function L(t, e, n) {
    var _this2 = this;

    _classCallCheck(this, L);

    this.value = void 0, this.__pendingValue = void 0, this.element = t, this.eventName = e, this.eventContext = n, this.__boundHandleEvent = function (t) {
      return _this2.handleEvent(t);
    };
  }

  _createClass(L, [{
    key: "setValue",
    value: function setValue(t) {
      this.__pendingValue = t;
    }
  }, {
    key: "commit",
    value: function commit() {
      for (; m(this.__pendingValue);) {
        var _t17 = this.__pendingValue;
        this.__pendingValue = f, _t17(this);
      }

      if (this.__pendingValue === f) return;
      var t = this.__pendingValue,
          e = this.value,
          n = null == t || null != e && (t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive),
          i = null != t && (null == e || n);
      n && this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options), i && (this.__options = P(t), this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options)), this.value = t, this.__pendingValue = f;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(t) {
      "function" == typeof this.value ? this.value.call(this.eventContext || this.element, t) : this.value.handleEvent(t);
    }
  }]);

  return L;
}();

var P = function P(t) {
  return t && (C ? {
    capture: t.capture,
    passive: t.passive,
    once: t.once
  } : t.capture);
}
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
;

function D(t) {
  var e = I.get(t.type);
  void 0 === e && (e = {
    stringsArray: new WeakMap(),
    keyString: new Map()
  }, I.set(t.type, e));
  var i = e.stringsArray.get(t.strings);
  if (void 0 !== i) return i;
  var r = t.strings.join(n);
  return i = e.keyString.get(r), void 0 === i && (i = new s(t, t.getTemplateElement()), e.keyString.set(r, i)), e.stringsArray.set(t.strings, i), i;
}

var I = new Map(),
    O = new WeakMap(),
    N = function N(t, n, i) {
  var r = O.get(n);
  void 0 === r && (e(n, n.firstChild), O.set(n, r = new T(Object.assign({
    templateFactory: D
  }, i))), r.appendInto(n)), r.setValue(t), r.commit();
};
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var F = new (
/*#__PURE__*/

/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: "handleAttributeExpressions",
    value: function handleAttributeExpressions(t, e, n, i) {
      var r = e[0];

      if ("." === r) {
        return new A(t, e.slice(1), n).parts;
      }

      if ("@" === r) return [new L(t, e.slice(1), i.eventContext)];
      if ("?" === r) return [new E(t, e.slice(1), n)];
      return new M(t, e, n).parts;
    }
  }, {
    key: "handleTextExpression",
    value: function handleTextExpression(t) {
      return new T(t);
    }
  }]);

  return _class;
}())();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

"undefined" != typeof window && (window.litHtmlVersions || (window.litHtmlVersions = [])).push("1.4.1");

var U = function U(t) {
  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }

  return new _(t, e, "html", F);
}
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
,
    k = function k(t, e) {
  return "".concat(t, "--").concat(e);
};

var B = !0;
void 0 === window.ShadyCSS ? B = !1 : void 0 === window.ShadyCSS.prepareTemplateDom && (console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1."), B = !1);

var z = function z(t) {
  return function (e) {
    var i = k(e.type, t);
    var r = I.get(i);
    void 0 === r && (r = {
      stringsArray: new WeakMap(),
      keyString: new Map()
    }, I.set(i, r));
    var a = r.stringsArray.get(e.strings);
    if (void 0 !== a) return a;
    var o = e.strings.join(n);

    if (a = r.keyString.get(o), void 0 === a) {
      var _n9 = e.getTemplateElement();

      B && window.ShadyCSS.prepareTemplateDom(_n9, t), a = new s(e, _n9), r.keyString.set(o, a);
    }

    return r.stringsArray.set(e.strings, a), a;
  };
},
    H = ["html", "svg"],
    V = new Set(),
    G = function G(t, e, n) {
  V.add(t);
  var i = n ? n.element : document.createElement("template"),
      r = e.querySelectorAll("style"),
      s = r.length;
  if (0 === s) return void window.ShadyCSS.prepareTemplateStyles(i, t);
  var a = document.createElement("style");

  for (var _t18 = 0; _t18 < s; _t18++) {
    var _e12 = r[_t18];
    _e12.parentNode.removeChild(_e12), a.textContent += _e12.textContent;
  }

  (function (t) {
    H.forEach(function (e) {
      var n = I.get(k(e, t));
      void 0 !== n && n.keyString.forEach(function (t) {
        var e = t.element.content,
            n = new Set();
        Array.from(e.querySelectorAll("style")).forEach(function (t) {
          n.add(t);
        }), c(t, n);
      });
    });
  })(t);

  var o = i.content;
  n ? function (t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var i = t.element.content,
        r = t.parts;
    if (null == n) return void i.appendChild(e);
    var s = document.createTreeWalker(i, 133, null, !1);
    var a = d(r),
        o = 0,
        l = -1;

    for (; s.nextNode();) {
      for (l++, s.currentNode === n && (o = u(e), n.parentNode.insertBefore(e, n)); -1 !== a && r[a].index === l;) {
        if (o > 0) {
          for (; -1 !== a;) {
            r[a].index += o, a = d(r, a);
          }

          return;
        }

        a = d(r, a);
      }
    }
  }(n, a, o.firstChild) : o.insertBefore(a, o.firstChild), window.ShadyCSS.prepareTemplateStyles(i, t);
  var l = o.querySelector("style");
  if (window.ShadyCSS.nativeShadow && null !== l) e.insertBefore(l.cloneNode(!0), e.firstChild);else if (n) {
    o.insertBefore(a, o.firstChild);

    var _t19 = new Set();

    _t19.add(a), c(n, _t19);
  }
};

window.JSCompiler_renameProperty = function (t, e) {
  return t;
};

var W = {
  toAttribute: function toAttribute(t, e) {
    switch (e) {
      case Boolean:
        return t ? "" : null;

      case Object:
      case Array:
        return null == t ? t : JSON.stringify(t);
    }

    return t;
  },
  fromAttribute: function fromAttribute(t, e) {
    switch (e) {
      case Boolean:
        return null !== t;

      case Number:
        return null === t ? null : Number(t);

      case Object:
      case Array:
        return JSON.parse(t);
    }

    return t;
  }
},
    j = function j(t, e) {
  return e !== t && (e == e || t == t);
},
    q = {
  attribute: !0,
  type: String,
  converter: W,
  reflect: !1,
  hasChanged: j
};

var X = /*#__PURE__*/function (_HTMLElement) {
  _inherits(X, _HTMLElement);

  var _super3 = _createSuper(X);

  function X() {
    var _this3;

    _classCallCheck(this, X);

    _this3 = _super3.call(this), _this3.initialize();
    return _this3;
  }

  _createClass(X, [{
    key: "initialize",
    value: function initialize() {
      var _this4 = this;

      this._updateState = 0, this._updatePromise = new Promise(function (t) {
        return _this4._enableUpdatingResolver = t;
      }), this._changedProperties = new Map(), this._saveInstanceProperties(), this.requestUpdateInternal();
    }
  }, {
    key: "_saveInstanceProperties",
    value: function _saveInstanceProperties() {
      var _this5 = this;

      this.constructor._classProperties.forEach(function (t, e) {
        if (_this5.hasOwnProperty(e)) {
          var _t20 = _this5[e];
          delete _this5[e], _this5._instanceProperties || (_this5._instanceProperties = new Map()), _this5._instanceProperties.set(e, _t20);
        }
      });
    }
  }, {
    key: "_applyInstanceProperties",
    value: function _applyInstanceProperties() {
      var _this6 = this;

      this._instanceProperties.forEach(function (t, e) {
        return _this6[e] = t;
      }), this._instanceProperties = void 0;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.enableUpdating();
    }
  }, {
    key: "enableUpdating",
    value: function enableUpdating() {
      void 0 !== this._enableUpdatingResolver && (this._enableUpdatingResolver(), this._enableUpdatingResolver = void 0);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {}
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(t, e, n) {
      e !== n && this._attributeToProperty(t, n);
    }
  }, {
    key: "_propertyToAttribute",
    value: function _propertyToAttribute(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : q;

      var i = this.constructor,
          r = i._attributeNameForProperty(t, n);

      if (void 0 !== r) {
        var _t21 = i._propertyValueToAttribute(e, n);

        if (void 0 === _t21) return;
        this._updateState = 8 | this._updateState, null == _t21 ? this.removeAttribute(r) : this.setAttribute(r, _t21), this._updateState = -9 & this._updateState;
      }
    }
  }, {
    key: "_attributeToProperty",
    value: function _attributeToProperty(t, e) {
      if (8 & this._updateState) return;

      var n = this.constructor,
          i = n._attributeToPropertyMap.get(t);

      if (void 0 !== i) {
        var _t22 = n.getPropertyOptions(i);

        this._updateState = 16 | this._updateState, this[i] = n._propertyValueFromAttribute(e, _t22), this._updateState = -17 & this._updateState;
      }
    }
  }, {
    key: "requestUpdateInternal",
    value: function requestUpdateInternal(t, e, n) {
      var i = !0;

      if (void 0 !== t) {
        var _r5 = this.constructor;
        n = n || _r5.getPropertyOptions(t), _r5._valueHasChanged(this[t], e, n.hasChanged) ? (this._changedProperties.has(t) || this._changedProperties.set(t, e), !0 !== n.reflect || 16 & this._updateState || (void 0 === this._reflectingProperties && (this._reflectingProperties = new Map()), this._reflectingProperties.set(t, n))) : i = !1;
      }

      !this._hasRequestedUpdate && i && (this._updatePromise = this._enqueueUpdate());
    }
  }, {
    key: "requestUpdate",
    value: function requestUpdate(t, e) {
      return this.requestUpdateInternal(t, e), this.updateComplete;
    }
  }, {
    key: "_enqueueUpdate",
    value: function () {
      var _enqueueUpdate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var t;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._updateState = 4 | this._updateState;
                _context.prev = 1;
                _context.next = 4;
                return this._updatePromise;

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);

              case 8:
                t = this.performUpdate();
                _context.t1 = null != t;

                if (!_context.t1) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return t;

              case 13:
                return _context.abrupt("return", !this._hasRequestedUpdate);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function _enqueueUpdate() {
        return _enqueueUpdate2.apply(this, arguments);
      }

      return _enqueueUpdate;
    }()
  }, {
    key: "_hasRequestedUpdate",
    get: function get() {
      return 4 & this._updateState;
    }
  }, {
    key: "hasUpdated",
    get: function get() {
      return 1 & this._updateState;
    }
  }, {
    key: "performUpdate",
    value: function performUpdate() {
      if (!this._hasRequestedUpdate) return;
      this._instanceProperties && this._applyInstanceProperties();
      var t = !1;
      var e = this._changedProperties;

      try {
        t = this.shouldUpdate(e), t ? this.update(e) : this._markUpdated();
      } catch (e) {
        throw t = !1, this._markUpdated(), e;
      }

      t && (1 & this._updateState || (this._updateState = 1 | this._updateState, this.firstUpdated(e)), this.updated(e));
    }
  }, {
    key: "_markUpdated",
    value: function _markUpdated() {
      this._changedProperties = new Map(), this._updateState = -5 & this._updateState;
    }
  }, {
    key: "updateComplete",
    get: function get() {
      return this._getUpdateComplete();
    }
  }, {
    key: "_getUpdateComplete",
    value: function _getUpdateComplete() {
      return this.getUpdateComplete();
    }
  }, {
    key: "getUpdateComplete",
    value: function getUpdateComplete() {
      return this._updatePromise;
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(t) {
      return !0;
    }
  }, {
    key: "update",
    value: function update(t) {
      var _this7 = this;

      void 0 !== this._reflectingProperties && this._reflectingProperties.size > 0 && (this._reflectingProperties.forEach(function (t, e) {
        return _this7._propertyToAttribute(e, _this7[e], t);
      }), this._reflectingProperties = void 0), this._markUpdated();
    }
  }, {
    key: "updated",
    value: function updated(t) {}
  }, {
    key: "firstUpdated",
    value: function firstUpdated(t) {}
  }], [{
    key: "observedAttributes",
    get: function get() {
      var _this8 = this;

      this.finalize();
      var t = [];
      return this._classProperties.forEach(function (e, n) {
        var i = _this8._attributeNameForProperty(n, e);

        void 0 !== i && (_this8._attributeToPropertyMap.set(i, n), t.push(i));
      }), t;
    }
  }, {
    key: "_ensureClassProperties",
    value: function _ensureClassProperties() {
      var _this9 = this;

      if (!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties", this))) {
        this._classProperties = new Map();

        var _t23 = Object.getPrototypeOf(this)._classProperties;

        void 0 !== _t23 && _t23.forEach(function (t, e) {
          return _this9._classProperties.set(e, t);
        });
      }
    }
  }, {
    key: "createProperty",
    value: function createProperty(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : q;
      if (this._ensureClassProperties(), this._classProperties.set(t, e), e.noAccessor || this.prototype.hasOwnProperty(t)) return;
      var n = "symbol" == typeof t ? Symbol() : "__".concat(t),
          i = this.getPropertyDescriptor(t, n, e);
      void 0 !== i && Object.defineProperty(this.prototype, t, i);
    }
  }, {
    key: "getPropertyDescriptor",
    value: function getPropertyDescriptor(t, e, n) {
      return {
        get: function get() {
          return this[e];
        },
        set: function set(i) {
          var r = this[t];
          this[e] = i, this.requestUpdateInternal(t, r, n);
        },
        configurable: !0,
        enumerable: !0
      };
    }
  }, {
    key: "getPropertyOptions",
    value: function getPropertyOptions(t) {
      return this._classProperties && this._classProperties.get(t) || q;
    }
  }, {
    key: "finalize",
    value: function finalize() {
      var t = Object.getPrototypeOf(this);

      if (t.hasOwnProperty("finalized") || t.finalize(), this.finalized = !0, this._ensureClassProperties(), this._attributeToPropertyMap = new Map(), this.hasOwnProperty(JSCompiler_renameProperty("properties", this))) {
        var _t24 = this.properties,
            _e13 = [].concat(_toConsumableArray(Object.getOwnPropertyNames(_t24)), _toConsumableArray("function" == typeof Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(_t24) : []));

        var _iterator5 = _createForOfIteratorHelper(_e13),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _n10 = _step5.value;
            this.createProperty(_n10, _t24[_n10]);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "_attributeNameForProperty",
    value: function _attributeNameForProperty(t, e) {
      var n = e.attribute;
      return !1 === n ? void 0 : "string" == typeof n ? n : "string" == typeof t ? t.toLowerCase() : void 0;
    }
  }, {
    key: "_valueHasChanged",
    value: function _valueHasChanged(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : j;
      return n(t, e);
    }
  }, {
    key: "_propertyValueFromAttribute",
    value: function _propertyValueFromAttribute(t, e) {
      var n = e.type,
          i = e.converter || W,
          r = "function" == typeof i ? i : i.fromAttribute;
      return r ? r(t, n) : t;
    }
  }, {
    key: "_propertyValueToAttribute",
    value: function _propertyValueToAttribute(t, e) {
      if (void 0 === e.reflect) return;
      var n = e.type,
          i = e.converter;
      return (i && i.toAttribute || W.toAttribute)(t, n);
    }
  }]);

  return X;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

X.finalized = !0;
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

var Y = function Y(t, e) {
  return "method" === e.kind && e.descriptor && !("value" in e.descriptor) ? Object.assign(Object.assign({}, e), {
    finisher: function finisher(n) {
      n.createProperty(e.key, t);
    }
  }) : {
    kind: "field",
    key: Symbol(),
    placement: "own",
    descriptor: {},
    initializer: function initializer() {
      "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
    },
    finisher: function finisher(n) {
      n.createProperty(e.key, t);
    }
  };
};

function J(t) {
  return function (e, n) {
    return void 0 !== n ? function (t, e, n) {
      e.constructor.createProperty(n, t);
    }(t, e, n) : Y(t, e);
  };
}
/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/


var Z = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
    $ = Symbol();

var K = /*#__PURE__*/function () {
  function K(t, e) {
    _classCallCheck(this, K);

    if (e !== $) throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t;
  }

  _createClass(K, [{
    key: "styleSheet",
    get: function get() {
      return void 0 === this._styleSheet && (Z ? (this._styleSheet = new CSSStyleSheet(), this._styleSheet.replaceSync(this.cssText)) : this._styleSheet = null), this._styleSheet;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.cssText;
    }
  }]);

  return K;
}();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


(window.litElementVersions || (window.litElementVersions = [])).push("2.5.1");
var Q = {};

var tt = /*#__PURE__*/function (_X) {
  _inherits(tt, _X);

  var _super4 = _createSuper(tt);

  function tt() {
    _classCallCheck(this, tt);

    return _super4.apply(this, arguments);
  }

  _createClass(tt, [{
    key: "initialize",
    value: function initialize() {
      _get(_getPrototypeOf(tt.prototype), "initialize", this).call(this), this.constructor._getUniqueStyles(), this.renderRoot = this.createRenderRoot(), window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot && this.adoptStyles();
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this.attachShadow(this.constructor.shadowRootOptions);
    }
  }, {
    key: "adoptStyles",
    value: function adoptStyles() {
      var t = this.constructor._styles;
      0 !== t.length && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow ? Z ? this.renderRoot.adoptedStyleSheets = t.map(function (t) {
        return t instanceof CSSStyleSheet ? t : t.styleSheet;
      }) : this._needsShimAdoptedStyleSheets = !0 : window.ShadyCSS.ScopingShim.prepareAdoptedCssText(t.map(function (t) {
        return t.cssText;
      }), this.localName));
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(tt.prototype), "connectedCallback", this).call(this), this.hasUpdated && void 0 !== window.ShadyCSS && window.ShadyCSS.styleElement(this);
    }
  }, {
    key: "update",
    value: function update(t) {
      var _this10 = this;

      var e = this.render();
      _get(_getPrototypeOf(tt.prototype), "update", this).call(this, t), e !== Q && this.constructor.render(e, this.renderRoot, {
        scopeName: this.localName,
        eventContext: this
      }), this._needsShimAdoptedStyleSheets && (this._needsShimAdoptedStyleSheets = !1, this.constructor._styles.forEach(function (t) {
        var e = document.createElement("style");
        e.textContent = t.cssText, _this10.renderRoot.appendChild(e);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return Q;
    }
  }], [{
    key: "getStyles",
    value: function getStyles() {
      return this.styles;
    }
  }, {
    key: "_getUniqueStyles",
    value: function _getUniqueStyles() {
      if (this.hasOwnProperty(JSCompiler_renameProperty("_styles", this))) return;
      var t = this.getStyles();

      if (Array.isArray(t)) {
        var _e14 = function _e14(t, n) {
          return t.reduceRight(function (t, n) {
            return Array.isArray(n) ? _e14(n, t) : (t.add(n), t);
          }, n);
        },
            _n11 = _e14(t, new Set()),
            _i8 = [];

        _n11.forEach(function (t) {
          return _i8.unshift(t);
        }), this._styles = _i8;
      } else this._styles = void 0 === t ? [] : [t];

      this._styles = this._styles.map(function (t) {
        if (t instanceof CSSStyleSheet && !Z) {
          var _e15 = Array.prototype.slice.call(t.cssRules).reduce(function (t, e) {
            return t + e.cssText;
          }, "");

          return new K(String(_e15), $);
        }

        return t;
      });
    }
  }]);

  return tt;
}(X);

tt.finalized = !0, tt.render = function (t, n, i) {
  if (!i || "object" != typeof i || !i.scopeName) throw new Error("The `scopeName` option is required.");
  var r = i.scopeName,
      s = O.has(n),
      a = B && 11 === n.nodeType && !!n.host,
      o = a && !V.has(r),
      l = o ? document.createDocumentFragment() : n;

  if (N(t, l, Object.assign({
    templateFactory: z(r)
  }, i)), o) {
    var _t25 = O.get(l);

    O.delete(l);

    var _i9 = _t25.value instanceof v ? _t25.value.template : void 0;

    G(r, l, _i9), e(n, n.firstChild), n.appendChild(l), O.set(n, _t25);
  }

  !s && a && window.ShadyCSS.styleElement(n.host);
}, tt.shadowRootOptions = {
  mode: "open"
};

var et = /*#__PURE__*/function () {
  function et() {
    _classCallCheck(this, et);
  }

  _createClass(et, [{
    key: "addEventListener",
    value: function addEventListener(t, e) {
      void 0 === this._listeners && (this._listeners = {});
      var n = this._listeners;
      void 0 === n[t] && (n[t] = []), -1 === n[t].indexOf(e) && n[t].push(e);
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(t, e) {
      if (void 0 === this._listeners) return !1;
      var n = this._listeners;
      return void 0 !== n[t] && -1 !== n[t].indexOf(e);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(t, e) {
      if (void 0 === this._listeners) return;
      var n = this._listeners[t];

      if (void 0 !== n) {
        var _t26 = n.indexOf(e);

        -1 !== _t26 && n.splice(_t26, 1);
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(t) {
      if (void 0 === this._listeners) return;
      var e = this._listeners[t.type];

      if (void 0 !== e) {
        t.target = this;

        var _n12 = e.slice(0);

        for (var _e16 = 0, _i10 = _n12.length; _e16 < _i10; _e16++) {
          _n12[_e16].call(this, t);
        }

        t.target = null;
      }
    }
  }]);

  return et;
}();

var nt = [];

for (var _t27 = 0; _t27 < 256; _t27++) {
  nt[_t27] = (_t27 < 16 ? "0" : "") + _t27.toString(16);
}

var it = 1234567;
var rt = Math.PI / 180,
    st = 180 / Math.PI;

function at() {
  var t = 4294967295 * Math.random() | 0,
      e = 4294967295 * Math.random() | 0,
      n = 4294967295 * Math.random() | 0,
      i = 4294967295 * Math.random() | 0;
  return (nt[255 & t] + nt[t >> 8 & 255] + nt[t >> 16 & 255] + nt[t >> 24 & 255] + "-" + nt[255 & e] + nt[e >> 8 & 255] + "-" + nt[e >> 16 & 15 | 64] + nt[e >> 24 & 255] + "-" + nt[63 & n | 128] + nt[n >> 8 & 255] + "-" + nt[n >> 16 & 255] + nt[n >> 24 & 255] + nt[255 & i] + nt[i >> 8 & 255] + nt[i >> 16 & 255] + nt[i >> 24 & 255]).toLowerCase();
}

function ot(t, e, n) {
  return Math.max(e, Math.min(n, t));
}

function lt(t, e) {
  return (t % e + e) % e;
}

function ht(t, e, n) {
  return (1 - n) * t + n * e;
}

function ct(t) {
  return 0 == (t & t - 1) && 0 !== t;
}

function ut(t) {
  return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
}

function dt(t) {
  return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
}

var pt = Object.freeze({
  __proto__: null,
  DEG2RAD: rt,
  RAD2DEG: st,
  generateUUID: at,
  clamp: ot,
  euclideanModulo: lt,
  mapLinear: function mapLinear(t, e, n, i, r) {
    return i + (t - e) * (r - i) / (n - e);
  },
  inverseLerp: function inverseLerp(t, e, n) {
    return t !== e ? (n - t) / (e - t) : 0;
  },
  lerp: ht,
  damp: function damp(t, e, n, i) {
    return ht(t, e, 1 - Math.exp(-n * i));
  },
  pingpong: function pingpong(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return e - Math.abs(lt(t, 2 * e) - e);
  },
  smoothstep: function smoothstep(t, e, n) {
    return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e)) * t * (3 - 2 * t);
  },
  smootherstep: function smootherstep(t, e, n) {
    return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e)) * t * t * (t * (6 * t - 15) + 10);
  },
  randInt: function randInt(t, e) {
    return t + Math.floor(Math.random() * (e - t + 1));
  },
  randFloat: function randFloat(t, e) {
    return t + Math.random() * (e - t);
  },
  randFloatSpread: function randFloatSpread(t) {
    return t * (.5 - Math.random());
  },
  seededRandom: function seededRandom(t) {
    void 0 !== t && (it = t);
    var e = it += 1831565813;
    return e = Math.imul(e ^ e >>> 15, 1 | e), e ^= e + Math.imul(e ^ e >>> 7, 61 | e), ((e ^ e >>> 14) >>> 0) / 4294967296;
  },
  degToRad: function degToRad(t) {
    return t * rt;
  },
  radToDeg: function radToDeg(t) {
    return t * st;
  },
  isPowerOfTwo: ct,
  ceilPowerOfTwo: ut,
  floorPowerOfTwo: dt,
  setQuaternionFromProperEuler: function setQuaternionFromProperEuler(t, e, n, i, r) {
    var s = Math.cos,
        a = Math.sin,
        o = s(n / 2),
        l = a(n / 2),
        h = s((e + i) / 2),
        c = a((e + i) / 2),
        u = s((e - i) / 2),
        d = a((e - i) / 2),
        p = s((i - e) / 2),
        m = a((i - e) / 2);

    switch (r) {
      case "XYX":
        t.set(o * c, l * u, l * d, o * h);
        break;

      case "YZY":
        t.set(l * d, o * c, l * u, o * h);
        break;

      case "ZXZ":
        t.set(l * u, l * d, o * c, o * h);
        break;

      case "XZX":
        t.set(o * c, l * m, l * p, o * h);
        break;

      case "YXY":
        t.set(l * p, o * c, l * m, o * h);
        break;

      case "ZYZ":
        t.set(l * m, l * p, o * c, o * h);
        break;

      default:
        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
    }
  },
  normalize: function normalize(t, e) {
    switch (e.constructor) {
      case Float32Array:
        return t;

      case Uint16Array:
        return Math.round(65535 * t);

      case Uint8Array:
        return Math.round(255 * t);

      case Int16Array:
        return Math.round(32767 * t);

      case Int8Array:
        return Math.round(127 * t);

      default:
        throw new Error("Invalid component type.");
    }
  },
  denormalize: function denormalize(t, e) {
    switch (e.constructor) {
      case Float32Array:
        return t;

      case Uint16Array:
        return t / 65535;

      case Uint8Array:
        return t / 255;

      case Int16Array:
        return Math.max(t / 32767, -1);

      case Int8Array:
        return Math.max(t / 127, -1);

      default:
        throw new Error("Invalid component type.");
    }
  }
});

var mt = /*#__PURE__*/function (_Symbol$iterator) {
  function mt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, mt);

    this.x = t, this.y = e;
  }

  _createClass(mt, [{
    key: "width",
    get: function get() {
      return this.x;
    },
    set: function set(t) {
      this.x = t;
    }
  }, {
    key: "height",
    get: function get() {
      return this.y;
    },
    set: function set(t) {
      this.y = t;
    }
  }, {
    key: "set",
    value: function set(t, e) {
      return this.x = t, this.y = e, this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.x = t, this.y = t, this;
    }
  }, {
    key: "setX",
    value: function setX(t) {
      return this.x = t, this;
    }
  }, {
    key: "setY",
    value: function setY(t) {
      return this.y = t, this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(t, e) {
      switch (t) {
        case 0:
          this.x = e;
          break;

        case 1:
          this.y = e;
          break;

        default:
          throw new Error("index is out of range: " + t);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(t) {
      switch (t) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        default:
          throw new Error("index is out of range: " + t);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.x = t.x, this.y = t.y, this;
    }
  }, {
    key: "add",
    value: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this);
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.x += t, this.y += t, this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this;
    }
  }, {
    key: "sub",
    value: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this);
    }
  }, {
    key: "subScalar",
    value: function subScalar(t) {
      return this.x -= t, this.y -= t, this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.x *= t.x, this.y *= t.y, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this;
    }
  }, {
    key: "divide",
    value: function divide(t) {
      return this.x /= t.x, this.y /= t.y, this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(t) {
      var e = this.x,
          n = this.y,
          i = t.elements;
      return this.x = i[0] * e + i[3] * n + i[6], this.y = i[1] * e + i[4] * n + i[7], this;
    }
  }, {
    key: "min",
    value: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }
  }, {
    key: "max",
    value: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }
  }, {
    key: "clamp",
    value: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(t, e) {
      return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(t, e) {
      var n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.x = -this.x, this.y = -this.y, this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this.x * t.x + this.y * t.y;
    }
  }, {
    key: "cross",
    value: function cross(t) {
      return this.x * t.y - this.y * t.x;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "angle",
    value: function angle() {
      return Math.atan2(-this.y, -this.x) + Math.PI;
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(t) {
      return Math.sqrt(this.distanceToSquared(t));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(t) {
      var e = this.x - t.x,
          n = this.y - t.y;
      return e * e + n * n;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(t) {
      return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }
  }, {
    key: "setLength",
    value: function setLength(t) {
      return this.normalize().multiplyScalar(t);
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(t, e, n) {
      return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.x === this.x && t.y === this.y;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.x = t[e], this.y = t[e + 1], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.x, t[e + 1] = this.y, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e, n) {
      return void 0 !== n && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this;
    }
  }, {
    key: "rotateAround",
    value: function rotateAround(t, e) {
      var n = Math.cos(e),
          i = Math.sin(e),
          r = this.x - t.x,
          s = this.y - t.y;
      return this.x = r * n - s * i + t.x, this.y = r * i + s * n + t.y, this;
    }
  }, {
    key: "random",
    value: function random() {
      return this.x = Math.random(), this.y = Math.random(), this;
    }
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.x;

            case 2:
              _context2.next = 4;
              return this.y;

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, value, this);
    })
  }]);

  return mt;
}(Symbol.iterator);

mt.prototype.isVector2 = !0;

var ft = /*#__PURE__*/function () {
  function ft() {
    _classCallCheck(this, ft);

    this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
  }

  _createClass(ft, [{
    key: "set",
    value: function set(t, e, n, i, r, s, a, o, l) {
      var h = this.elements;
      return h[0] = t, h[1] = i, h[2] = a, h[3] = e, h[4] = r, h[5] = o, h[6] = n, h[7] = s, h[8] = l, this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = this.elements,
          n = t.elements;
      return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], this;
    }
  }, {
    key: "extractBasis",
    value: function extractBasis(t, e, n) {
      return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
    }
  }, {
    key: "setFromMatrix4",
    value: function setFromMatrix4(t) {
      var e = t.elements;
      return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.multiplyMatrices(this, t);
    }
  }, {
    key: "premultiply",
    value: function premultiply(t) {
      return this.multiplyMatrices(t, this);
    }
  }, {
    key: "multiplyMatrices",
    value: function multiplyMatrices(t, e) {
      var n = t.elements,
          i = e.elements,
          r = this.elements,
          s = n[0],
          a = n[3],
          o = n[6],
          l = n[1],
          h = n[4],
          c = n[7],
          u = n[2],
          d = n[5],
          p = n[8],
          m = i[0],
          f = i[3],
          g = i[6],
          v = i[1],
          y = i[4],
          x = i[7],
          _ = i[2],
          b = i[5],
          w = i[8];
      return r[0] = s * m + a * v + o * _, r[3] = s * f + a * y + o * b, r[6] = s * g + a * x + o * w, r[1] = l * m + h * v + c * _, r[4] = l * f + h * y + c * b, r[7] = l * g + h * x + c * w, r[2] = u * m + d * v + p * _, r[5] = u * f + d * y + p * b, r[8] = u * g + d * x + p * w, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      var e = this.elements;
      return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      var t = this.elements,
          e = t[0],
          n = t[1],
          i = t[2],
          r = t[3],
          s = t[4],
          a = t[5],
          o = t[6],
          l = t[7],
          h = t[8];
      return e * s * h - e * a * l - n * r * h + n * a * o + i * r * l - i * s * o;
    }
  }, {
    key: "invert",
    value: function invert() {
      var t = this.elements,
          e = t[0],
          n = t[1],
          i = t[2],
          r = t[3],
          s = t[4],
          a = t[5],
          o = t[6],
          l = t[7],
          h = t[8],
          c = h * s - a * l,
          u = a * o - h * r,
          d = l * r - s * o,
          p = e * c + n * u + i * d;
      if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var m = 1 / p;
      return t[0] = c * m, t[1] = (i * l - h * n) * m, t[2] = (a * n - i * s) * m, t[3] = u * m, t[4] = (h * e - i * o) * m, t[5] = (i * r - a * e) * m, t[6] = d * m, t[7] = (n * o - l * e) * m, t[8] = (s * e - n * r) * m, this;
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var t;
      var e = this.elements;
      return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }
  }, {
    key: "getNormalMatrix",
    value: function getNormalMatrix(t) {
      return this.setFromMatrix4(t).invert().transpose();
    }
  }, {
    key: "transposeIntoArray",
    value: function transposeIntoArray(t) {
      var e = this.elements;
      return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }
  }, {
    key: "setUvTransform",
    value: function setUvTransform(t, e, n, i, r, s, a) {
      var o = Math.cos(r),
          l = Math.sin(r);
      return this.set(n * o, n * l, -n * (o * s + l * a) + s + t, -i * l, i * o, -i * (-l * s + o * a) + a + e, 0, 0, 1), this;
    }
  }, {
    key: "scale",
    value: function scale(t, e) {
      var n = this.elements;
      return n[0] *= t, n[3] *= t, n[6] *= t, n[1] *= e, n[4] *= e, n[7] *= e, this;
    }
  }, {
    key: "rotate",
    value: function rotate(t) {
      var e = Math.cos(t),
          n = Math.sin(t),
          i = this.elements,
          r = i[0],
          s = i[3],
          a = i[6],
          o = i[1],
          l = i[4],
          h = i[7];
      return i[0] = e * r + n * o, i[3] = e * s + n * l, i[6] = e * a + n * h, i[1] = -n * r + e * o, i[4] = -n * s + e * l, i[7] = -n * a + e * h, this;
    }
  }, {
    key: "translate",
    value: function translate(t, e) {
      var n = this.elements;
      return n[0] += t * n[2], n[3] += t * n[5], n[6] += t * n[8], n[1] += e * n[2], n[4] += e * n[5], n[7] += e * n[8], this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      var e = this.elements,
          n = t.elements;

      for (var _t28 = 0; _t28 < 9; _t28++) {
        if (e[_t28] !== n[_t28]) return !1;
      }

      return !0;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var _n13 = 0; _n13 < 9; _n13++) {
        this.elements[_n13] = t[_n13 + e];
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.elements;
      return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().fromArray(this.elements);
    }
  }]);

  return ft;
}();

function gt(t) {
  for (var _e17 = t.length - 1; _e17 >= 0; --_e17) {
    if (t[_e17] > 65535) return !0;
  }

  return !1;
}

function vt(t) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", t);
}

function yt(t) {
  return t < .04045 ? .0773993808 * t : Math.pow(.9478672986 * t + .0521327014, 2.4);
}

function xt(t) {
  return t < .0031308 ? 12.92 * t : 1.055 * Math.pow(t, .41666) - .055;
}

ft.prototype.isMatrix3 = !0;
var _t = {
  srgb: {
    "srgb-linear": yt
  },
  "srgb-linear": {
    srgb: xt
  }
},
    bt = {
  legacyMode: !0,

  get workingColorSpace() {
    return "srgb-linear";
  },

  set workingColorSpace(t) {
    console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
  },

  convert: function convert(t, e, n) {
    if (this.legacyMode || e === n || !e || !n) return t;

    if (_t[e] && void 0 !== _t[e][n]) {
      var _i11 = _t[e][n];
      return t.r = _i11(t.r), t.g = _i11(t.g), t.b = _i11(t.b), t;
    }

    throw new Error("Unsupported color space conversion.");
  },
  fromWorkingColorSpace: function fromWorkingColorSpace(t, e) {
    return this.convert(t, this.workingColorSpace, e);
  },
  toWorkingColorSpace: function toWorkingColorSpace(t, e) {
    return this.convert(t, e, this.workingColorSpace);
  }
},
    wt = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
},
    Mt = {
  r: 0,
  g: 0,
  b: 0
},
    St = {
  h: 0,
  s: 0,
  l: 0
},
    Tt = {
  h: 0,
  s: 0,
  l: 0
};

function Et(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + 6 * (e - t) * (2 / 3 - n) : t;
}

function At(t, e) {
  return e.r = t.r, e.g = t.g, e.b = t.b, e;
}

var Rt = /*#__PURE__*/function () {
  function Rt(t, e, n) {
    _classCallCheck(this, Rt);

    return void 0 === e && void 0 === n ? this.set(t) : this.setRGB(t, e, n);
  }

  _createClass(Rt, [{
    key: "set",
    value: function set(t) {
      return t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t), this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.r = t, this.g = t, this.b = t, this;
    }
  }, {
    key: "setHex",
    value: function setHex(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "srgb";
      return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (255 & t) / 255, bt.toWorkingColorSpace(this, e), this;
    }
  }, {
    key: "setRGB",
    value: function setRGB(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "srgb-linear";
      return this.r = t, this.g = e, this.b = n, bt.toWorkingColorSpace(this, i), this;
    }
  }, {
    key: "setHSL",
    value: function setHSL(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "srgb-linear";
      if (t = lt(t, 1), e = ot(e, 0, 1), n = ot(n, 0, 1), 0 === e) this.r = this.g = this.b = n;else {
        var _i12 = n <= .5 ? n * (1 + e) : n + e - n * e,
            _r6 = 2 * n - _i12;

        this.r = Et(_r6, _i12, t + 1 / 3), this.g = Et(_r6, _i12, t), this.b = Et(_r6, _i12, t - 1 / 3);
      }
      return bt.toWorkingColorSpace(this, i), this;
    }
  }, {
    key: "setStyle",
    value: function setStyle(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "srgb";

      function n(e) {
        void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
      }

      var i;

      if (i = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t)) {
        var _t29;

        var _r7 = i[1],
            _s8 = i[2];

        switch (_r7) {
          case "rgb":
          case "rgba":
            if (_t29 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_s8)) return this.r = Math.min(255, parseInt(_t29[1], 10)) / 255, this.g = Math.min(255, parseInt(_t29[2], 10)) / 255, this.b = Math.min(255, parseInt(_t29[3], 10)) / 255, bt.toWorkingColorSpace(this, e), n(_t29[4]), this;
            if (_t29 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_s8)) return this.r = Math.min(100, parseInt(_t29[1], 10)) / 100, this.g = Math.min(100, parseInt(_t29[2], 10)) / 100, this.b = Math.min(100, parseInt(_t29[3], 10)) / 100, bt.toWorkingColorSpace(this, e), n(_t29[4]), this;
            break;

          case "hsl":
          case "hsla":
            if (_t29 = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_s8)) {
              var _i13 = parseFloat(_t29[1]) / 360,
                  _r8 = parseInt(_t29[2], 10) / 100,
                  _s9 = parseInt(_t29[3], 10) / 100;

              return n(_t29[4]), this.setHSL(_i13, _r8, _s9, e);
            }

        }
      } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t)) {
        var _t30 = i[1],
            _n14 = _t30.length;
        if (3 === _n14) return this.r = parseInt(_t30.charAt(0) + _t30.charAt(0), 16) / 255, this.g = parseInt(_t30.charAt(1) + _t30.charAt(1), 16) / 255, this.b = parseInt(_t30.charAt(2) + _t30.charAt(2), 16) / 255, bt.toWorkingColorSpace(this, e), this;
        if (6 === _n14) return this.r = parseInt(_t30.charAt(0) + _t30.charAt(1), 16) / 255, this.g = parseInt(_t30.charAt(2) + _t30.charAt(3), 16) / 255, this.b = parseInt(_t30.charAt(4) + _t30.charAt(5), 16) / 255, bt.toWorkingColorSpace(this, e), this;
      }

      return t && t.length > 0 ? this.setColorName(t, e) : this;
    }
  }, {
    key: "setColorName",
    value: function setColorName(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "srgb";
      var n = wt[t.toLowerCase()];
      return void 0 !== n ? this.setHex(n, e) : console.warn("THREE.Color: Unknown color " + t), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.r, this.g, this.b);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }
  }, {
    key: "copySRGBToLinear",
    value: function copySRGBToLinear(t) {
      return this.r = yt(t.r), this.g = yt(t.g), this.b = yt(t.b), this;
    }
  }, {
    key: "copyLinearToSRGB",
    value: function copyLinearToSRGB(t) {
      return this.r = xt(t.r), this.g = xt(t.g), this.b = xt(t.b), this;
    }
  }, {
    key: "convertSRGBToLinear",
    value: function convertSRGBToLinear() {
      return this.copySRGBToLinear(this), this;
    }
  }, {
    key: "convertLinearToSRGB",
    value: function convertLinearToSRGB() {
      return this.copyLinearToSRGB(this), this;
    }
  }, {
    key: "getHex",
    value: function getHex() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "srgb";
      return bt.fromWorkingColorSpace(At(this, Mt), t), ot(255 * Mt.r, 0, 255) << 16 ^ ot(255 * Mt.g, 0, 255) << 8 ^ ot(255 * Mt.b, 0, 255) << 0;
    }
  }, {
    key: "getHexString",
    value: function getHexString() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "srgb";
      return ("000000" + this.getHex(t).toString(16)).slice(-6);
    }
  }, {
    key: "getHSL",
    value: function getHSL(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "srgb-linear";
      bt.fromWorkingColorSpace(At(this, Mt), e);
      var n = Mt.r,
          i = Mt.g,
          r = Mt.b,
          s = Math.max(n, i, r),
          a = Math.min(n, i, r);
      var o, l;
      var h = (a + s) / 2;
      if (a === s) o = 0, l = 0;else {
        var _t31 = s - a;

        switch (l = h <= .5 ? _t31 / (s + a) : _t31 / (2 - s - a), s) {
          case n:
            o = (i - r) / _t31 + (i < r ? 6 : 0);
            break;

          case i:
            o = (r - n) / _t31 + 2;
            break;

          case r:
            o = (n - i) / _t31 + 4;
        }

        o /= 6;
      }
      return t.h = o, t.s = l, t.l = h, t;
    }
  }, {
    key: "getRGB",
    value: function getRGB(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "srgb-linear";
      return bt.fromWorkingColorSpace(At(this, Mt), e), t.r = Mt.r, t.g = Mt.g, t.b = Mt.b, t;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "srgb";
      return bt.fromWorkingColorSpace(At(this, Mt), t), "srgb" !== t ? "color(".concat(t, " ").concat(Mt.r, " ").concat(Mt.g, " ").concat(Mt.b, ")") : "rgb(".concat(255 * Mt.r | 0, ",").concat(255 * Mt.g | 0, ",").concat(255 * Mt.b | 0, ")");
    }
  }, {
    key: "offsetHSL",
    value: function offsetHSL(t, e, n) {
      return this.getHSL(St), St.h += t, St.s += e, St.l += n, this.setHSL(St.h, St.s, St.l), this;
    }
  }, {
    key: "add",
    value: function add(t) {
      return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }
  }, {
    key: "addColors",
    value: function addColors(t, e) {
      return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.r += t, this.g += t, this.b += t, this;
    }
  }, {
    key: "sub",
    value: function sub(t) {
      return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.r *= t, this.g *= t, this.b *= t, this;
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }
  }, {
    key: "lerpColors",
    value: function lerpColors(t, e, n) {
      return this.r = t.r + (e.r - t.r) * n, this.g = t.g + (e.g - t.g) * n, this.b = t.b + (e.b - t.b) * n, this;
    }
  }, {
    key: "lerpHSL",
    value: function lerpHSL(t, e) {
      this.getHSL(St), t.getHSL(Tt);
      var n = ht(St.h, Tt.h, e),
          i = ht(St.s, Tt.s, e),
          r = ht(St.l, Tt.l, e);
      return this.setHSL(n, i, r), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.r === this.r && t.g === this.g && t.b === this.b;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e) {
      return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), !0 === t.normalized && (this.r /= 255, this.g /= 255, this.b /= 255), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.getHex();
    }
  }]);

  return Rt;
}();

var Ct;
Rt.NAMES = wt, Rt.prototype.isColor = !0, Rt.prototype.r = 1, Rt.prototype.g = 1, Rt.prototype.b = 1;

var Lt = /*#__PURE__*/function () {
  function Lt() {
    _classCallCheck(this, Lt);
  }

  _createClass(Lt, null, [{
    key: "getDataURL",
    value: function getDataURL(t) {
      if (/^data:/i.test(t.src)) return t.src;
      if ("undefined" == typeof HTMLCanvasElement) return t.src;
      var e;
      if (t instanceof HTMLCanvasElement) e = t;else {
        void 0 === Ct && (Ct = vt("canvas")), Ct.width = t.width, Ct.height = t.height;

        var _n15 = Ct.getContext("2d");

        t instanceof ImageData ? _n15.putImageData(t, 0, 0) : _n15.drawImage(t, 0, 0, t.width, t.height), e = Ct;
      }
      return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
  }, {
    key: "sRGBToLinear",
    value: function sRGBToLinear(t) {
      if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
        var _e18 = vt("canvas");

        _e18.width = t.width, _e18.height = t.height;

        var _n16 = _e18.getContext("2d");

        _n16.drawImage(t, 0, 0, t.width, t.height);

        var _i14 = _n16.getImageData(0, 0, t.width, t.height),
            _r9 = _i14.data;

        for (var _t32 = 0; _t32 < _r9.length; _t32++) {
          _r9[_t32] = 255 * yt(_r9[_t32] / 255);
        }

        return _n16.putImageData(_i14, 0, 0), _e18;
      }

      if (t.data) {
        var _e19 = t.data.slice(0);

        for (var _t33 = 0; _t33 < _e19.length; _t33++) {
          _e19 instanceof Uint8Array || _e19 instanceof Uint8ClampedArray ? _e19[_t33] = Math.floor(255 * yt(_e19[_t33] / 255)) : _e19[_t33] = yt(_e19[_t33]);
        }

        return {
          data: _e19,
          width: t.width,
          height: t.height
        };
      }

      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
    }
  }]);

  return Lt;
}();

var Pt = /*#__PURE__*/function () {
  function Pt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, Pt);

    this.uuid = at(), this.data = t, this.version = 0;
  }

  _createClass(Pt, [{
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = void 0 === t || "string" == typeof t;
      if (!e && void 0 !== t.images[this.uuid]) return t.images[this.uuid];
      var n = {
        uuid: this.uuid,
        url: ""
      },
          i = this.data;

      if (null !== i) {
        var _t34;

        if (Array.isArray(i)) {
          _t34 = [];

          for (var _e20 = 0, _n17 = i.length; _e20 < _n17; _e20++) {
            i[_e20].isDataTexture ? _t34.push(Dt(i[_e20].image)) : _t34.push(Dt(i[_e20]));
          }
        } else _t34 = Dt(i);

        n.url = _t34;
      }

      return e || (t.images[this.uuid] = n), n;
    }
  }]);

  return Pt;
}();

function Dt(t) {
  return "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap ? Lt.getDataURL(t) : t.data ? {
    data: Array.prototype.slice.call(t.data),
    width: t.width,
    height: t.height,
    type: t.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}

Pt.prototype.isSource = !0;
var It = 0;

var Ot = /*#__PURE__*/function (_et) {
  _inherits(Ot, _et);

  var _super5 = _createSuper(Ot);

  function Ot() {
    var _this11;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Ot.DEFAULT_IMAGE;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Ot.DEFAULT_MAPPING;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1001;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1001;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1006;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1008;
    var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1023;
    var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1009;
    var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;
    var h = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 3e3;

    _classCallCheck(this, Ot);

    _this11 = _super5.call(this), Object.defineProperty(_assertThisInitialized(_this11), "id", {
      value: It++
    }), _this11.uuid = at(), _this11.name = "", _this11.source = new Pt(t), _this11.mipmaps = [], _this11.mapping = e, _this11.wrapS = n, _this11.wrapT = i, _this11.magFilter = r, _this11.minFilter = s, _this11.anisotropy = l, _this11.format = a, _this11.internalFormat = null, _this11.type = o, _this11.offset = new mt(0, 0), _this11.repeat = new mt(1, 1), _this11.center = new mt(0, 0), _this11.rotation = 0, _this11.matrixAutoUpdate = !0, _this11.matrix = new ft(), _this11.generateMipmaps = !0, _this11.premultiplyAlpha = !1, _this11.flipY = !0, _this11.unpackAlignment = 4, _this11.encoding = h, _this11.userData = {}, _this11.version = 0, _this11.onUpdate = null, _this11.isRenderTargetTexture = !1, _this11.needsPMREMUpdate = !1;
    return _this11;
  }

  _createClass(Ot, [{
    key: "image",
    get: function get() {
      return this.source.data;
    },
    set: function set(t) {
      this.source.data = t;
    }
  }, {
    key: "updateMatrix",
    value: function updateMatrix() {
      this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = void 0 === t || "string" == typeof t;
      if (!e && void 0 !== t.textures[this.uuid]) return t.textures[this.uuid];
      var n = {
        metadata: {
          version: 4.5,
          type: "Texture",
          generator: "Texture.toJSON"
        },
        uuid: this.uuid,
        name: this.name,
        image: this.source.toJSON(t).uuid,
        mapping: this.mapping,
        repeat: [this.repeat.x, this.repeat.y],
        offset: [this.offset.x, this.offset.y],
        center: [this.center.x, this.center.y],
        rotation: this.rotation,
        wrap: [this.wrapS, this.wrapT],
        format: this.format,
        type: this.type,
        encoding: this.encoding,
        minFilter: this.minFilter,
        magFilter: this.magFilter,
        anisotropy: this.anisotropy,
        flipY: this.flipY,
        premultiplyAlpha: this.premultiplyAlpha,
        unpackAlignment: this.unpackAlignment
      };
      return "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), e || (t.textures[this.uuid] = n), n;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }, {
    key: "transformUv",
    value: function transformUv(t) {
      if (300 !== this.mapping) return t;
      if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch (this.wrapS) {
        case 1e3:
          t.x = t.x - Math.floor(t.x);
          break;

        case 1001:
          t.x = t.x < 0 ? 0 : 1;
          break;

        case 1002:
          1 === Math.abs(Math.floor(t.x) % 2) ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
      }
      if (t.y < 0 || t.y > 1) switch (this.wrapT) {
        case 1e3:
          t.y = t.y - Math.floor(t.y);
          break;

        case 1001:
          t.y = t.y < 0 ? 0 : 1;
          break;

        case 1002:
          1 === Math.abs(Math.floor(t.y) % 2) ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
      }
      return this.flipY && (t.y = 1 - t.y), t;
    }
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && (this.version++, this.source.needsUpdate = !0);
    }
  }]);

  return Ot;
}(et);

Ot.DEFAULT_IMAGE = null, Ot.DEFAULT_MAPPING = 300, Ot.prototype.isTexture = !0;

var Nt = /*#__PURE__*/function (_Symbol$iterator2) {
  function Nt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Nt);

    this.x = t, this.y = e, this.z = n, this.w = i;
  }

  _createClass(Nt, [{
    key: "width",
    get: function get() {
      return this.z;
    },
    set: function set(t) {
      this.z = t;
    }
  }, {
    key: "height",
    get: function get() {
      return this.w;
    },
    set: function set(t) {
      this.w = t;
    }
  }, {
    key: "set",
    value: function set(t, e, n, i) {
      return this.x = t, this.y = e, this.z = n, this.w = i, this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }
  }, {
    key: "setX",
    value: function setX(t) {
      return this.x = t, this;
    }
  }, {
    key: "setY",
    value: function setY(t) {
      return this.y = t, this;
    }
  }, {
    key: "setZ",
    value: function setZ(t) {
      return this.z = t, this;
    }
  }, {
    key: "setW",
    value: function setW(t) {
      return this.w = t, this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(t, e) {
      switch (t) {
        case 0:
          this.x = e;
          break;

        case 1:
          this.y = e;
          break;

        case 2:
          this.z = e;
          break;

        case 3:
          this.w = e;
          break;

        default:
          throw new Error("index is out of range: " + t);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(t) {
      switch (t) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        case 2:
          return this.z;

        case 3:
          return this.w;

        default:
          throw new Error("index is out of range: " + t);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y, this.z, this.w);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.x = t.x, this.y = t.y, this.z = t.z, this.w = void 0 !== t.w ? t.w : 1, this;
    }
  }, {
    key: "add",
    value: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this);
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }
  }, {
    key: "sub",
    value: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this);
    }
  }, {
    key: "subScalar",
    value: function subScalar(t) {
      return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = this.w,
          s = t.elements;
      return this.x = s[0] * e + s[4] * n + s[8] * i + s[12] * r, this.y = s[1] * e + s[5] * n + s[9] * i + s[13] * r, this.z = s[2] * e + s[6] * n + s[10] * i + s[14] * r, this.w = s[3] * e + s[7] * n + s[11] * i + s[15] * r, this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }
  }, {
    key: "setAxisAngleFromQuaternion",
    value: function setAxisAngleFromQuaternion(t) {
      this.w = 2 * Math.acos(t.w);
      var e = Math.sqrt(1 - t.w * t.w);
      return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }
  }, {
    key: "setAxisAngleFromRotationMatrix",
    value: function setAxisAngleFromRotationMatrix(t) {
      var e, n, i, r;
      var s = .01,
          a = .1,
          o = t.elements,
          l = o[0],
          h = o[4],
          c = o[8],
          u = o[1],
          d = o[5],
          p = o[9],
          m = o[2],
          f = o[6],
          g = o[10];

      if (Math.abs(h - u) < s && Math.abs(c - m) < s && Math.abs(p - f) < s) {
        if (Math.abs(h + u) < a && Math.abs(c + m) < a && Math.abs(p + f) < a && Math.abs(l + d + g - 3) < a) return this.set(1, 0, 0, 0), this;
        e = Math.PI;

        var _t35 = (l + 1) / 2,
            _o4 = (d + 1) / 2,
            _v2 = (g + 1) / 2,
            _y2 = (h + u) / 4,
            _x2 = (c + m) / 4,
            _2 = (p + f) / 4;

        return _t35 > _o4 && _t35 > _v2 ? _t35 < s ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(_t35), i = _y2 / n, r = _x2 / n) : _o4 > _v2 ? _o4 < s ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(_o4), n = _y2 / i, r = _2 / i) : _v2 < s ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(_v2), n = _x2 / r, i = _2 / r), this.set(n, i, r, e), this;
      }

      var v = Math.sqrt((f - p) * (f - p) + (c - m) * (c - m) + (u - h) * (u - h));
      return Math.abs(v) < .001 && (v = 1), this.x = (f - p) / v, this.y = (c - m) / v, this.z = (u - h) / v, this.w = Math.acos((l + d + g - 1) / 2), this;
    }
  }, {
    key: "min",
    value: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }
  }, {
    key: "max",
    value: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }
  }, {
    key: "clamp",
    value: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(t, e) {
      return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(t, e) {
      var n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "setLength",
    value: function setLength(t) {
      return this.normalize().multiplyScalar(t);
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(t, e, n) {
      return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this.w = t.w + (e.w - t.w) * n, this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e, n) {
      return void 0 !== n && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    }
  }, {
    key: "random",
    value: function random() {
      return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
  }, {
    key: _Symbol$iterator2,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.x;

            case 2:
              _context3.next = 4;
              return this.y;

            case 4:
              _context3.next = 6;
              return this.z;

            case 6:
              _context3.next = 8;
              return this.w;

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Nt;
}(Symbol.iterator);

Nt.prototype.isVector4 = !0;

var Ft = /*#__PURE__*/function (_et2) {
  _inherits(Ft, _et2);

  var _super6 = _createSuper(Ft);

  function Ft(t, e) {
    var _this12;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Ft);

    _this12 = _super6.call(this), _this12.width = t, _this12.height = e, _this12.depth = 1, _this12.scissor = new Nt(0, 0, t, e), _this12.scissorTest = !1, _this12.viewport = new Nt(0, 0, t, e);
    var i = {
      width: t,
      height: e,
      depth: 1
    };
    _this12.texture = new Ot(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.encoding), _this12.texture.isRenderTargetTexture = !0, _this12.texture.flipY = !1, _this12.texture.generateMipmaps = void 0 !== n.generateMipmaps && n.generateMipmaps, _this12.texture.internalFormat = void 0 !== n.internalFormat ? n.internalFormat : null, _this12.texture.minFilter = void 0 !== n.minFilter ? n.minFilter : 1006, _this12.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer, _this12.stencilBuffer = void 0 !== n.stencilBuffer && n.stencilBuffer, _this12.depthTexture = void 0 !== n.depthTexture ? n.depthTexture : null, _this12.samples = void 0 !== n.samples ? n.samples : 0;
    return _this12;
  }

  _createClass(Ft, [{
    key: "setSize",
    value: function setSize(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      this.width === t && this.height === e && this.depth === n || (this.width = t, this.height = e, this.depth = n, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.isRenderTargetTexture = !0, this.texture.image = Object.assign({}, t.texture.image), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, null !== t.depthTexture && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }]);

  return Ft;
}(et);

Ft.prototype.isWebGLRenderTarget = !0;

var Ut = /*#__PURE__*/function (_Ot) {
  _inherits(Ut, _Ot);

  var _super7 = _createSuper(Ut);

  function Ut() {
    var _this13;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Ut);

    _this13 = _super7.call(this, null), _this13.image = {
      data: t,
      width: e,
      height: n,
      depth: i
    }, _this13.magFilter = 1003, _this13.minFilter = 1003, _this13.wrapR = 1001, _this13.generateMipmaps = !1, _this13.flipY = !1, _this13.unpackAlignment = 1;
    return _this13;
  }

  return Ut;
}(Ot);

Ut.prototype.isDataArrayTexture = !0;

/*#__PURE__*/
(function (_Ft) {
  _inherits(_class2, _Ft);

  var _super8 = _createSuper(_class2);

  function _class2(t, e, n) {
    var _this14;

    _classCallCheck(this, _class2);

    _this14 = _super8.call(this, t, e), _this14.depth = n, _this14.texture = new Ut(null, t, e, n), _this14.texture.isRenderTargetTexture = !0;
    return _this14;
  }

  return _class2;
})(Ft).prototype.isWebGLArrayRenderTarget = !0;

var kt = /*#__PURE__*/function (_Ot2) {
  _inherits(kt, _Ot2);

  var _super9 = _createSuper(kt);

  function kt() {
    var _this15;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, kt);

    _this15 = _super9.call(this, null), _this15.image = {
      data: t,
      width: e,
      height: n,
      depth: i
    }, _this15.magFilter = 1003, _this15.minFilter = 1003, _this15.wrapR = 1001, _this15.generateMipmaps = !1, _this15.flipY = !1, _this15.unpackAlignment = 1;
    return _this15;
  }

  return kt;
}(Ot);

kt.prototype.isData3DTexture = !0;

/*#__PURE__*/
(function (_Ft2) {
  _inherits(_class3, _Ft2);

  var _super10 = _createSuper(_class3);

  function _class3(t, e, n) {
    var _this16;

    _classCallCheck(this, _class3);

    _this16 = _super10.call(this, t, e), _this16.depth = n, _this16.texture = new kt(null, t, e, n), _this16.texture.isRenderTargetTexture = !0;
    return _this16;
  }

  return _class3;
})(Ft).prototype.isWebGL3DRenderTarget = !0;

/*#__PURE__*/
(function (_Ft3) {
  _inherits(_class4, _Ft3);

  var _super11 = _createSuper(_class4);

  function _class4(t, e, n) {
    var _this17;

    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, _class4);

    _this17 = _super11.call(this, t, e, i);
    var r = _this17.texture;
    _this17.texture = [];

    for (var _t36 = 0; _t36 < n; _t36++) {
      _this17.texture[_t36] = r.clone(), _this17.texture[_t36].isRenderTargetTexture = !0;
    }

    return _this17;
  }

  _createClass(_class4, [{
    key: "setSize",
    value: function setSize(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (this.width !== t || this.height !== e || this.depth !== n) {
        this.width = t, this.height = e, this.depth = n;

        for (var _i15 = 0, _r10 = this.texture.length; _i15 < _r10; _i15++) {
          this.texture[_i15].image.width = t, this.texture[_i15].image.height = e, this.texture[_i15].image.depth = n;
        }

        this.dispose();
      }

      return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.depthTexture = t.depthTexture, this.texture.length = 0;

      for (var _e21 = 0, _n18 = t.texture.length; _e21 < _n18; _e21++) {
        this.texture[_e21] = t.texture[_e21].clone();
      }

      return this;
    }
  }]);

  return _class4;
})(Ft).prototype.isWebGLMultipleRenderTargets = !0;

var Bt = /*#__PURE__*/function () {
  function Bt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Bt);

    this._x = t, this._y = e, this._z = n, this._w = i;
  }

  _createClass(Bt, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(t) {
      this._x = t, this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(t) {
      this._y = t, this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(t) {
      this._z = t, this._onChangeCallback();
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(t) {
      this._w = t, this._onChangeCallback();
    }
  }, {
    key: "set",
    value: function set(t, e, n, i) {
      return this._x = t, this._y = e, this._z = n, this._w = i, this._onChangeCallback(), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._w);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
    }
  }, {
    key: "setFromEuler",
    value: function setFromEuler(t, e) {
      if (!t || !t.isEuler) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
      var n = t._x,
          i = t._y,
          r = t._z,
          s = t._order,
          a = Math.cos,
          o = Math.sin,
          l = a(n / 2),
          h = a(i / 2),
          c = a(r / 2),
          u = o(n / 2),
          d = o(i / 2),
          p = o(r / 2);

      switch (s) {
        case "XYZ":
          this._x = u * h * c + l * d * p, this._y = l * d * c - u * h * p, this._z = l * h * p + u * d * c, this._w = l * h * c - u * d * p;
          break;

        case "YXZ":
          this._x = u * h * c + l * d * p, this._y = l * d * c - u * h * p, this._z = l * h * p - u * d * c, this._w = l * h * c + u * d * p;
          break;

        case "ZXY":
          this._x = u * h * c - l * d * p, this._y = l * d * c + u * h * p, this._z = l * h * p + u * d * c, this._w = l * h * c - u * d * p;
          break;

        case "ZYX":
          this._x = u * h * c - l * d * p, this._y = l * d * c + u * h * p, this._z = l * h * p - u * d * c, this._w = l * h * c + u * d * p;
          break;

        case "YZX":
          this._x = u * h * c + l * d * p, this._y = l * d * c + u * h * p, this._z = l * h * p - u * d * c, this._w = l * h * c - u * d * p;
          break;

        case "XZY":
          this._x = u * h * c - l * d * p, this._y = l * d * c - u * h * p, this._z = l * h * p + u * d * c, this._w = l * h * c + u * d * p;
          break;

        default:
          console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + s);
      }

      return !1 !== e && this._onChangeCallback(), this;
    }
  }, {
    key: "setFromAxisAngle",
    value: function setFromAxisAngle(t, e) {
      var n = e / 2,
          i = Math.sin(n);
      return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
    }
  }, {
    key: "setFromRotationMatrix",
    value: function setFromRotationMatrix(t) {
      var e = t.elements,
          n = e[0],
          i = e[4],
          r = e[8],
          s = e[1],
          a = e[5],
          o = e[9],
          l = e[2],
          h = e[6],
          c = e[10],
          u = n + a + c;

      if (u > 0) {
        var _t37 = .5 / Math.sqrt(u + 1);

        this._w = .25 / _t37, this._x = (h - o) * _t37, this._y = (r - l) * _t37, this._z = (s - i) * _t37;
      } else if (n > a && n > c) {
        var _t38 = 2 * Math.sqrt(1 + n - a - c);

        this._w = (h - o) / _t38, this._x = .25 * _t38, this._y = (i + s) / _t38, this._z = (r + l) / _t38;
      } else if (a > c) {
        var _t39 = 2 * Math.sqrt(1 + a - n - c);

        this._w = (r - l) / _t39, this._x = (i + s) / _t39, this._y = .25 * _t39, this._z = (o + h) / _t39;
      } else {
        var _t40 = 2 * Math.sqrt(1 + c - n - a);

        this._w = (s - i) / _t40, this._x = (r + l) / _t40, this._y = (o + h) / _t40, this._z = .25 * _t40;
      }

      return this._onChangeCallback(), this;
    }
  }, {
    key: "setFromUnitVectors",
    value: function setFromUnitVectors(t, e) {
      var n = t.dot(e) + 1;
      return n < Number.EPSILON ? (n = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = n)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = n), this.normalize();
    }
  }, {
    key: "angleTo",
    value: function angleTo(t) {
      return 2 * Math.acos(Math.abs(ot(this.dot(t), -1, 1)));
    }
  }, {
    key: "rotateTowards",
    value: function rotateTowards(t, e) {
      var n = this.angleTo(t);
      if (0 === n) return this;
      var i = Math.min(1, e / n);
      return this.slerp(t, i), this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(0, 0, 0, 1);
    }
  }, {
    key: "invert",
    value: function invert() {
      return this.conjugate();
    }
  }, {
    key: "conjugate",
    value: function conjugate() {
      return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var t = this.length();
      return 0 === t ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
    }
  }, {
    key: "multiply",
    value: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(t, e)) : this.multiplyQuaternions(this, t);
    }
  }, {
    key: "premultiply",
    value: function premultiply(t) {
      return this.multiplyQuaternions(t, this);
    }
  }, {
    key: "multiplyQuaternions",
    value: function multiplyQuaternions(t, e) {
      var n = t._x,
          i = t._y,
          r = t._z,
          s = t._w,
          a = e._x,
          o = e._y,
          l = e._z,
          h = e._w;
      return this._x = n * h + s * a + i * l - r * o, this._y = i * h + s * o + r * a - n * l, this._z = r * h + s * l + n * o - i * a, this._w = s * h - n * a - i * o - r * l, this._onChangeCallback(), this;
    }
  }, {
    key: "slerp",
    value: function slerp(t, e) {
      if (0 === e) return this;
      if (1 === e) return this.copy(t);
      var n = this._x,
          i = this._y,
          r = this._z,
          s = this._w;
      var a = s * t._w + n * t._x + i * t._y + r * t._z;
      if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1) return this._w = s, this._x = n, this._y = i, this._z = r, this;
      var o = 1 - a * a;

      if (o <= Number.EPSILON) {
        var _t41 = 1 - e;

        return this._w = _t41 * s + e * this._w, this._x = _t41 * n + e * this._x, this._y = _t41 * i + e * this._y, this._z = _t41 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
      }

      var l = Math.sqrt(o),
          h = Math.atan2(l, a),
          c = Math.sin((1 - e) * h) / l,
          u = Math.sin(e * h) / l;
      return this._w = s * c + this._w * u, this._x = n * c + this._x * u, this._y = i * c + this._y * u, this._z = r * c + this._z * u, this._onChangeCallback(), this;
    }
  }, {
    key: "slerpQuaternions",
    value: function slerpQuaternions(t, e, n) {
      return this.copy(t).slerp(e, n);
    }
  }, {
    key: "random",
    value: function random() {
      var t = Math.random(),
          e = Math.sqrt(1 - t),
          n = Math.sqrt(t),
          i = 2 * Math.PI * Math.random(),
          r = 2 * Math.PI * Math.random();
      return this.set(e * Math.cos(i), n * Math.sin(r), n * Math.cos(r), e * Math.sin(i));
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e) {
      return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
    }
  }, {
    key: "_onChange",
    value: function _onChange(t) {
      return this._onChangeCallback = t, this;
    }
  }, {
    key: "_onChangeCallback",
    value: function _onChangeCallback() {}
  }], [{
    key: "slerp",
    value: function slerp(t, e, n, i) {
      return console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead."), n.slerpQuaternions(t, e, i);
    }
  }, {
    key: "slerpFlat",
    value: function slerpFlat(t, e, n, i, r, s, a) {
      var o = n[i + 0],
          l = n[i + 1],
          h = n[i + 2],
          c = n[i + 3];
      var u = r[s + 0],
          d = r[s + 1],
          p = r[s + 2],
          m = r[s + 3];
      if (0 === a) return t[e + 0] = o, t[e + 1] = l, t[e + 2] = h, void (t[e + 3] = c);
      if (1 === a) return t[e + 0] = u, t[e + 1] = d, t[e + 2] = p, void (t[e + 3] = m);

      if (c !== m || o !== u || l !== d || h !== p) {
        var _t42 = 1 - a;

        var _e22 = o * u + l * d + h * p + c * m,
            _n19 = _e22 >= 0 ? 1 : -1,
            _i16 = 1 - _e22 * _e22;

        if (_i16 > Number.EPSILON) {
          var _r12 = Math.sqrt(_i16),
              _s10 = Math.atan2(_r12, _e22 * _n19);

          _t42 = Math.sin(_t42 * _s10) / _r12, a = Math.sin(a * _s10) / _r12;
        }

        var _r11 = a * _n19;

        if (o = o * _t42 + u * _r11, l = l * _t42 + d * _r11, h = h * _t42 + p * _r11, c = c * _t42 + m * _r11, _t42 === 1 - a) {
          var _t43 = 1 / Math.sqrt(o * o + l * l + h * h + c * c);

          o *= _t43, l *= _t43, h *= _t43, c *= _t43;
        }
      }

      t[e] = o, t[e + 1] = l, t[e + 2] = h, t[e + 3] = c;
    }
  }, {
    key: "multiplyQuaternionsFlat",
    value: function multiplyQuaternionsFlat(t, e, n, i, r, s) {
      var a = n[i],
          o = n[i + 1],
          l = n[i + 2],
          h = n[i + 3],
          c = r[s],
          u = r[s + 1],
          d = r[s + 2],
          p = r[s + 3];
      return t[e] = a * p + h * c + o * d - l * u, t[e + 1] = o * p + h * u + l * c - a * d, t[e + 2] = l * p + h * d + a * u - o * c, t[e + 3] = h * p - a * c - o * u - l * d, t;
    }
  }]);

  return Bt;
}();

Bt.prototype.isQuaternion = !0;

var zt = /*#__PURE__*/function (_Symbol$iterator3) {
  function zt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, zt);

    this.x = t, this.y = e, this.z = n;
  }

  _createClass(zt, [{
    key: "set",
    value: function set(t, e, n) {
      return void 0 === n && (n = this.z), this.x = t, this.y = e, this.z = n, this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.x = t, this.y = t, this.z = t, this;
    }
  }, {
    key: "setX",
    value: function setX(t) {
      return this.x = t, this;
    }
  }, {
    key: "setY",
    value: function setY(t) {
      return this.y = t, this;
    }
  }, {
    key: "setZ",
    value: function setZ(t) {
      return this.z = t, this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(t, e) {
      switch (t) {
        case 0:
          this.x = e;
          break;

        case 1:
          this.y = e;
          break;

        case 2:
          this.z = e;
          break;

        default:
          throw new Error("index is out of range: " + t);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(t) {
      switch (t) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        case 2:
          return this.z;

        default:
          throw new Error("index is out of range: " + t);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y, this.z);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }
  }, {
    key: "add",
    value: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this);
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.x += t, this.y += t, this.z += t, this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }
  }, {
    key: "sub",
    value: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this);
    }
  }, {
    key: "subScalar",
    value: function subScalar(t) {
      return this.x -= t, this.y -= t, this.z -= t, this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(t, e)) : (this.x *= t.x, this.y *= t.y, this.z *= t.z, this);
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this.z *= t, this;
    }
  }, {
    key: "multiplyVectors",
    value: function multiplyVectors(t, e) {
      return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }
  }, {
    key: "applyEuler",
    value: function applyEuler(t) {
      return t && t.isEuler || console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), this.applyQuaternion(Vt.setFromEuler(t));
    }
  }, {
    key: "applyAxisAngle",
    value: function applyAxisAngle(t, e) {
      return this.applyQuaternion(Vt.setFromAxisAngle(t, e));
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.elements;
      return this.x = r[0] * e + r[3] * n + r[6] * i, this.y = r[1] * e + r[4] * n + r[7] * i, this.z = r[2] * e + r[5] * n + r[8] * i, this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(t) {
      return this.applyMatrix3(t).normalize();
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.elements,
          s = 1 / (r[3] * e + r[7] * n + r[11] * i + r[15]);
      return this.x = (r[0] * e + r[4] * n + r[8] * i + r[12]) * s, this.y = (r[1] * e + r[5] * n + r[9] * i + r[13]) * s, this.z = (r[2] * e + r[6] * n + r[10] * i + r[14]) * s, this;
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.x,
          s = t.y,
          a = t.z,
          o = t.w,
          l = o * e + s * i - a * n,
          h = o * n + a * e - r * i,
          c = o * i + r * n - s * e,
          u = -r * e - s * n - a * i;
      return this.x = l * o + u * -r + h * -a - c * -s, this.y = h * o + u * -s + c * -r - l * -a, this.z = c * o + u * -a + l * -s - h * -r, this;
    }
  }, {
    key: "project",
    value: function project(t) {
      return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
    }
  }, {
    key: "unproject",
    value: function unproject(t) {
      return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.elements;
      return this.x = r[0] * e + r[4] * n + r[8] * i, this.y = r[1] * e + r[5] * n + r[9] * i, this.z = r[2] * e + r[6] * n + r[10] * i, this.normalize();
    }
  }, {
    key: "divide",
    value: function divide(t) {
      return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }
  }, {
    key: "min",
    value: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }
  }, {
    key: "max",
    value: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }
  }, {
    key: "clamp",
    value: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(t, e) {
      return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(t, e) {
      var n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this.x * t.x + this.y * t.y + this.z * t.z;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "setLength",
    value: function setLength(t) {
      return this.normalize().multiplyScalar(t);
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(t, e, n) {
      return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this;
    }
  }, {
    key: "cross",
    value: function cross(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(t, e)) : this.crossVectors(this, t);
    }
  }, {
    key: "crossVectors",
    value: function crossVectors(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z,
          s = e.x,
          a = e.y,
          o = e.z;
      return this.x = i * o - r * a, this.y = r * s - n * o, this.z = n * a - i * s, this;
    }
  }, {
    key: "projectOnVector",
    value: function projectOnVector(t) {
      var e = t.lengthSq();
      if (0 === e) return this.set(0, 0, 0);
      var n = t.dot(this) / e;
      return this.copy(t).multiplyScalar(n);
    }
  }, {
    key: "projectOnPlane",
    value: function projectOnPlane(t) {
      return Ht.copy(this).projectOnVector(t), this.sub(Ht);
    }
  }, {
    key: "reflect",
    value: function reflect(t) {
      return this.sub(Ht.copy(t).multiplyScalar(2 * this.dot(t)));
    }
  }, {
    key: "angleTo",
    value: function angleTo(t) {
      var e = Math.sqrt(this.lengthSq() * t.lengthSq());
      if (0 === e) return Math.PI / 2;
      var n = this.dot(t) / e;
      return Math.acos(ot(n, -1, 1));
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(t) {
      return Math.sqrt(this.distanceToSquared(t));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(t) {
      var e = this.x - t.x,
          n = this.y - t.y,
          i = this.z - t.z;
      return e * e + n * n + i * i;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(t) {
      return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }
  }, {
    key: "setFromSpherical",
    value: function setFromSpherical(t) {
      return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
    }
  }, {
    key: "setFromSphericalCoords",
    value: function setFromSphericalCoords(t, e, n) {
      var i = Math.sin(e) * t;
      return this.x = i * Math.sin(n), this.y = Math.cos(e) * t, this.z = i * Math.cos(n), this;
    }
  }, {
    key: "setFromCylindrical",
    value: function setFromCylindrical(t) {
      return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
    }
  }, {
    key: "setFromCylindricalCoords",
    value: function setFromCylindricalCoords(t, e, n) {
      return this.x = t * Math.sin(e), this.y = n, this.z = t * Math.cos(e), this;
    }
  }, {
    key: "setFromMatrixPosition",
    value: function setFromMatrixPosition(t) {
      var e = t.elements;
      return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
  }, {
    key: "setFromMatrixScale",
    value: function setFromMatrixScale(t) {
      var e = this.setFromMatrixColumn(t, 0).length(),
          n = this.setFromMatrixColumn(t, 1).length(),
          i = this.setFromMatrixColumn(t, 2).length();
      return this.x = e, this.y = n, this.z = i, this;
    }
  }, {
    key: "setFromMatrixColumn",
    value: function setFromMatrixColumn(t, e) {
      return this.fromArray(t.elements, 4 * e);
    }
  }, {
    key: "setFromMatrix3Column",
    value: function setFromMatrix3Column(t, e) {
      return this.fromArray(t.elements, 3 * e);
    }
  }, {
    key: "setFromEuler",
    value: function setFromEuler(t) {
      return this.x = t._x, this.y = t._y, this.z = t._z, this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.x === this.x && t.y === this.y && t.z === this.z;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e, n) {
      return void 0 !== n && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    }
  }, {
    key: "random",
    value: function random() {
      return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
  }, {
    key: "randomDirection",
    value: function randomDirection() {
      var t = 2 * (Math.random() - .5),
          e = Math.random() * Math.PI * 2,
          n = Math.sqrt(1 - Math.pow(t, 2));
      return this.x = n * Math.cos(e), this.y = n * Math.sin(e), this.z = t, this;
    }
  }, {
    key: _Symbol$iterator3,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.x;

            case 2:
              _context4.next = 4;
              return this.y;

            case 4:
              _context4.next = 6;
              return this.z;

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, value, this);
    })
  }]);

  return zt;
}(Symbol.iterator);

zt.prototype.isVector3 = !0;
var Ht = new zt(),
    Vt = new Bt();

var Gt = /*#__PURE__*/function () {
  function Gt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt(1 / 0, 1 / 0, 1 / 0);
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt(-1 / 0, -1 / 0, -1 / 0);

    _classCallCheck(this, Gt);

    this.min = t, this.max = e;
  }

  _createClass(Gt, [{
    key: "set",
    value: function set(t, e) {
      return this.min.copy(t), this.max.copy(e), this;
    }
  }, {
    key: "setFromArray",
    value: function setFromArray(t) {
      var e = 1 / 0,
          n = 1 / 0,
          i = 1 / 0,
          r = -1 / 0,
          s = -1 / 0,
          a = -1 / 0;

      for (var _o5 = 0, _l2 = t.length; _o5 < _l2; _o5 += 3) {
        var _l3 = t[_o5],
            _h2 = t[_o5 + 1],
            _c2 = t[_o5 + 2];
        _l3 < e && (e = _l3), _h2 < n && (n = _h2), _c2 < i && (i = _c2), _l3 > r && (r = _l3), _h2 > s && (s = _h2), _c2 > a && (a = _c2);
      }

      return this.min.set(e, n, i), this.max.set(r, s, a), this;
    }
  }, {
    key: "setFromBufferAttribute",
    value: function setFromBufferAttribute(t) {
      var e = 1 / 0,
          n = 1 / 0,
          i = 1 / 0,
          r = -1 / 0,
          s = -1 / 0,
          a = -1 / 0;

      for (var _o6 = 0, _l4 = t.count; _o6 < _l4; _o6++) {
        var _l5 = t.getX(_o6),
            _h3 = t.getY(_o6),
            _c3 = t.getZ(_o6);

        _l5 < e && (e = _l5), _h3 < n && (n = _h3), _c3 < i && (i = _c3), _l5 > r && (r = _l5), _h3 > s && (s = _h3), _c3 > a && (a = _c3);
      }

      return this.min.set(e, n, i), this.max.set(r, s, a), this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(t) {
      this.makeEmpty();

      for (var _e23 = 0, _n20 = t.length; _e23 < _n20; _e23++) {
        this.expandByPoint(t[_e23]);
      }

      return this;
    }
  }, {
    key: "setFromCenterAndSize",
    value: function setFromCenterAndSize(t, e) {
      var n = jt.copy(e).multiplyScalar(.5);
      return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
    }
  }, {
    key: "setFromObject",
    value: function setFromObject(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return this.makeEmpty(), this.expandByObject(t, e);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.min.copy(t.min), this.max.copy(t.max), this;
    }
  }, {
    key: "makeEmpty",
    value: function makeEmpty() {
      return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
  }, {
    key: "getCenter",
    value: function getCenter(t) {
      return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
  }, {
    key: "getSize",
    value: function getSize(t) {
      return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
  }, {
    key: "expandByPoint",
    value: function expandByPoint(t) {
      return this.min.min(t), this.max.max(t), this;
    }
  }, {
    key: "expandByVector",
    value: function expandByVector(t) {
      return this.min.sub(t), this.max.add(t), this;
    }
  }, {
    key: "expandByScalar",
    value: function expandByScalar(t) {
      return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
  }, {
    key: "expandByObject",
    value: function expandByObject(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      t.updateWorldMatrix(!1, !1);
      var n = t.geometry;
      if (void 0 !== n) if (e && null != n.attributes && void 0 !== n.attributes.position) {
        var _e24 = n.attributes.position;

        for (var _n21 = 0, _i17 = _e24.count; _n21 < _i17; _n21++) {
          jt.fromBufferAttribute(_e24, _n21).applyMatrix4(t.matrixWorld), this.expandByPoint(jt);
        }
      } else null === n.boundingBox && n.computeBoundingBox(), qt.copy(n.boundingBox), qt.applyMatrix4(t.matrixWorld), this.union(qt);
      var i = t.children;

      for (var _t44 = 0, _n22 = i.length; _t44 < _n22; _t44++) {
        this.expandByObject(i[_t44], e);
      }

      return this;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }
  }, {
    key: "containsBox",
    value: function containsBox(t) {
      return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
  }, {
    key: "getParameter",
    value: function getParameter(t, e) {
      return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      return this.clampPoint(t.center, jt), jt.distanceToSquared(t.center) <= t.radius * t.radius;
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(t) {
      var e, n;
      return t.normal.x > 0 ? (e = t.normal.x * this.min.x, n = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, n = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, n += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, n += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, n += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, n += t.normal.z * this.min.z), e <= -t.constant && n >= -t.constant;
    }
  }, {
    key: "intersectsTriangle",
    value: function intersectsTriangle(t) {
      if (this.isEmpty()) return !1;
      this.getCenter(Qt), te.subVectors(this.max, Qt), Xt.subVectors(t.a, Qt), Yt.subVectors(t.b, Qt), Jt.subVectors(t.c, Qt), Zt.subVectors(Yt, Xt), $t.subVectors(Jt, Yt), Kt.subVectors(Xt, Jt);
      var e = [0, -Zt.z, Zt.y, 0, -$t.z, $t.y, 0, -Kt.z, Kt.y, Zt.z, 0, -Zt.x, $t.z, 0, -$t.x, Kt.z, 0, -Kt.x, -Zt.y, Zt.x, 0, -$t.y, $t.x, 0, -Kt.y, Kt.x, 0];
      return !!ie(e, Xt, Yt, Jt, te) && (e = [1, 0, 0, 0, 1, 0, 0, 0, 1], !!ie(e, Xt, Yt, Jt, te) && (ee.crossVectors(Zt, $t), e = [ee.x, ee.y, ee.z], ie(e, Xt, Yt, Jt, te)));
    }
  }, {
    key: "clampPoint",
    value: function clampPoint(t, e) {
      return e.copy(t).clamp(this.min, this.max);
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return jt.copy(t).clamp(this.min, this.max).sub(t).length();
    }
  }, {
    key: "getBoundingSphere",
    value: function getBoundingSphere(t) {
      return this.getCenter(t.center), t.radius = .5 * this.getSize(jt).length(), t;
    }
  }, {
    key: "intersect",
    value: function intersect(t) {
      return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
  }, {
    key: "union",
    value: function union(t) {
      return this.min.min(t.min), this.max.max(t.max), this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      return this.isEmpty() || (Wt[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), Wt[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), Wt[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), Wt[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), Wt[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), Wt[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), Wt[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), Wt[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(Wt)), this;
    }
  }, {
    key: "translate",
    value: function translate(t) {
      return this.min.add(t), this.max.add(t), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.min.equals(this.min) && t.max.equals(this.max);
    }
  }]);

  return Gt;
}();

Gt.prototype.isBox3 = !0;
var Wt = [new zt(), new zt(), new zt(), new zt(), new zt(), new zt(), new zt(), new zt()],
    jt = new zt(),
    qt = new Gt(),
    Xt = new zt(),
    Yt = new zt(),
    Jt = new zt(),
    Zt = new zt(),
    $t = new zt(),
    Kt = new zt(),
    Qt = new zt(),
    te = new zt(),
    ee = new zt(),
    ne = new zt();

function ie(t, e, n, i, r) {
  for (var _s11 = 0, _a4 = t.length - 3; _s11 <= _a4; _s11 += 3) {
    ne.fromArray(t, _s11);

    var _a5 = r.x * Math.abs(ne.x) + r.y * Math.abs(ne.y) + r.z * Math.abs(ne.z),
        _o7 = e.dot(ne),
        _l6 = n.dot(ne),
        _h4 = i.dot(ne);

    if (Math.max(-Math.max(_o7, _l6, _h4), Math.min(_o7, _l6, _h4)) > _a5) return !1;
  }

  return !0;
}

var re = new Gt(),
    se = new zt(),
    ae = new zt(),
    oe = new zt();

var le = /*#__PURE__*/function () {
  function le() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    _classCallCheck(this, le);

    this.center = t, this.radius = e;
  }

  _createClass(le, [{
    key: "set",
    value: function set(t, e) {
      return this.center.copy(t), this.radius = e, this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(t, e) {
      var n = this.center;
      void 0 !== e ? n.copy(e) : re.setFromPoints(t).getCenter(n);
      var i = 0;

      for (var _e25 = 0, _r13 = t.length; _e25 < _r13; _e25++) {
        i = Math.max(i, n.distanceToSquared(t[_e25]));
      }

      return this.radius = Math.sqrt(i), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.center.copy(t.center), this.radius = t.radius, this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.radius < 0;
    }
  }, {
    key: "makeEmpty",
    value: function makeEmpty() {
      return this.center.set(0, 0, 0), this.radius = -1, this;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return t.distanceTo(this.center) - this.radius;
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      var e = this.radius + t.radius;
      return t.center.distanceToSquared(this.center) <= e * e;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return t.intersectsSphere(this);
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(t) {
      return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
  }, {
    key: "clampPoint",
    value: function clampPoint(t, e) {
      var n = this.center.distanceToSquared(t);
      return e.copy(t), n > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(t) {
      return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
  }, {
    key: "translate",
    value: function translate(t) {
      return this.center.add(t), this;
    }
  }, {
    key: "expandByPoint",
    value: function expandByPoint(t) {
      oe.subVectors(t, this.center);
      var e = oe.lengthSq();

      if (e > this.radius * this.radius) {
        var _t45 = Math.sqrt(e),
            _n23 = .5 * (_t45 - this.radius);

        this.center.add(oe.multiplyScalar(_n23 / _t45)), this.radius += _n23;
      }

      return this;
    }
  }, {
    key: "union",
    value: function union(t) {
      return !0 === this.center.equals(t.center) ? ae.set(0, 0, 1).multiplyScalar(t.radius) : ae.subVectors(t.center, this.center).normalize().multiplyScalar(t.radius), this.expandByPoint(se.copy(t.center).add(ae)), this.expandByPoint(se.copy(t.center).sub(ae)), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.center.equals(this.center) && t.radius === this.radius;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return le;
}();

var he = new zt(),
    ce = new zt(),
    ue = new zt(),
    de = new zt(),
    pe = new zt(),
    me = new zt(),
    fe = new zt();

var ge = /*#__PURE__*/function () {
  function ge() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt(0, 0, -1);

    _classCallCheck(this, ge);

    this.origin = t, this.direction = e;
  }

  _createClass(ge, [{
    key: "set",
    value: function set(t, e) {
      return this.origin.copy(t), this.direction.copy(e), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
  }, {
    key: "at",
    value: function at(t, e) {
      return e.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
  }, {
    key: "lookAt",
    value: function lookAt(t) {
      return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
  }, {
    key: "recast",
    value: function recast(t) {
      return this.origin.copy(this.at(t, he)), this;
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(t, e) {
      e.subVectors(t, this.origin);
      var n = e.dot(this.direction);
      return n < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(n).add(this.origin);
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return Math.sqrt(this.distanceSqToPoint(t));
    }
  }, {
    key: "distanceSqToPoint",
    value: function distanceSqToPoint(t) {
      var e = he.subVectors(t, this.origin).dot(this.direction);
      return e < 0 ? this.origin.distanceToSquared(t) : (he.copy(this.direction).multiplyScalar(e).add(this.origin), he.distanceToSquared(t));
    }
  }, {
    key: "distanceSqToSegment",
    value: function distanceSqToSegment(t, e, n, i) {
      ce.copy(t).add(e).multiplyScalar(.5), ue.copy(e).sub(t).normalize(), de.copy(this.origin).sub(ce);
      var r = .5 * t.distanceTo(e),
          s = -this.direction.dot(ue),
          a = de.dot(this.direction),
          o = -de.dot(ue),
          l = de.lengthSq(),
          h = Math.abs(1 - s * s);
      var c, u, d, p;
      if (h > 0) {
        if (c = s * o - a, u = s * a - o, p = r * h, c >= 0) {
          if (u >= -p) {
            if (u <= p) {
              var _t46 = 1 / h;

              c *= _t46, u *= _t46, d = c * (c + s * u + 2 * a) + u * (s * c + u + 2 * o) + l;
            } else u = r, c = Math.max(0, -(s * u + a)), d = -c * c + u * (u + 2 * o) + l;
          } else u = -r, c = Math.max(0, -(s * u + a)), d = -c * c + u * (u + 2 * o) + l;
        } else u <= -p ? (c = Math.max(0, -(-s * r + a)), u = c > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -c * c + u * (u + 2 * o) + l) : u <= p ? (c = 0, u = Math.min(Math.max(-r, -o), r), d = u * (u + 2 * o) + l) : (c = Math.max(0, -(s * r + a)), u = c > 0 ? r : Math.min(Math.max(-r, -o), r), d = -c * c + u * (u + 2 * o) + l);
      } else u = s > 0 ? -r : r, c = Math.max(0, -(s * u + a)), d = -c * c + u * (u + 2 * o) + l;
      return n && n.copy(this.direction).multiplyScalar(c).add(this.origin), i && i.copy(ue).multiplyScalar(u).add(ce), d;
    }
  }, {
    key: "intersectSphere",
    value: function intersectSphere(t, e) {
      he.subVectors(t.center, this.origin);
      var n = he.dot(this.direction),
          i = he.dot(he) - n * n,
          r = t.radius * t.radius;
      if (i > r) return null;
      var s = Math.sqrt(r - i),
          a = n - s,
          o = n + s;
      return a < 0 && o < 0 ? null : a < 0 ? this.at(o, e) : this.at(a, e);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
  }, {
    key: "distanceToPlane",
    value: function distanceToPlane(t) {
      var e = t.normal.dot(this.direction);
      if (0 === e) return 0 === t.distanceToPoint(this.origin) ? 0 : null;
      var n = -(this.origin.dot(t.normal) + t.constant) / e;
      return n >= 0 ? n : null;
    }
  }, {
    key: "intersectPlane",
    value: function intersectPlane(t, e) {
      var n = this.distanceToPlane(t);
      return null === n ? null : this.at(n, e);
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(t) {
      var e = t.distanceToPoint(this.origin);
      if (0 === e) return !0;
      return t.normal.dot(this.direction) * e < 0;
    }
  }, {
    key: "intersectBox",
    value: function intersectBox(t, e) {
      var n, i, r, s, a, o;
      var l = 1 / this.direction.x,
          h = 1 / this.direction.y,
          c = 1 / this.direction.z,
          u = this.origin;
      return l >= 0 ? (n = (t.min.x - u.x) * l, i = (t.max.x - u.x) * l) : (n = (t.max.x - u.x) * l, i = (t.min.x - u.x) * l), h >= 0 ? (r = (t.min.y - u.y) * h, s = (t.max.y - u.y) * h) : (r = (t.max.y - u.y) * h, s = (t.min.y - u.y) * h), n > s || r > i ? null : ((r > n || n != n) && (n = r), (s < i || i != i) && (i = s), c >= 0 ? (a = (t.min.z - u.z) * c, o = (t.max.z - u.z) * c) : (a = (t.max.z - u.z) * c, o = (t.min.z - u.z) * c), n > o || a > i ? null : ((a > n || n != n) && (n = a), (o < i || i != i) && (i = o), i < 0 ? null : this.at(n >= 0 ? n : i, e)));
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return null !== this.intersectBox(t, he);
    }
  }, {
    key: "intersectTriangle",
    value: function intersectTriangle(t, e, n, i, r) {
      pe.subVectors(e, t), me.subVectors(n, t), fe.crossVectors(pe, me);
      var s,
          a = this.direction.dot(fe);

      if (a > 0) {
        if (i) return null;
        s = 1;
      } else {
        if (!(a < 0)) return null;
        s = -1, a = -a;
      }

      de.subVectors(this.origin, t);
      var o = s * this.direction.dot(me.crossVectors(de, me));
      if (o < 0) return null;
      var l = s * this.direction.dot(pe.cross(de));
      if (l < 0) return null;
      if (o + l > a) return null;
      var h = -s * de.dot(fe);
      return h < 0 ? null : this.at(h / a, r);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return ge;
}();

var ve = /*#__PURE__*/function () {
  function ve() {
    _classCallCheck(this, ve);

    this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
  }

  _createClass(ve, [{
    key: "set",
    value: function set(t, e, n, i, r, s, a, o, l, h, c, u, d, p, m, f) {
      var g = this.elements;
      return g[0] = t, g[4] = e, g[8] = n, g[12] = i, g[1] = r, g[5] = s, g[9] = a, g[13] = o, g[2] = l, g[6] = h, g[10] = c, g[14] = u, g[3] = d, g[7] = p, g[11] = m, g[15] = f, this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ve().fromArray(this.elements);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = this.elements,
          n = t.elements;
      return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], e[9] = n[9], e[10] = n[10], e[11] = n[11], e[12] = n[12], e[13] = n[13], e[14] = n[14], e[15] = n[15], this;
    }
  }, {
    key: "copyPosition",
    value: function copyPosition(t) {
      var e = this.elements,
          n = t.elements;
      return e[12] = n[12], e[13] = n[13], e[14] = n[14], this;
    }
  }, {
    key: "setFromMatrix3",
    value: function setFromMatrix3(t) {
      var e = t.elements;
      return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "extractBasis",
    value: function extractBasis(t, e, n) {
      return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
    }
  }, {
    key: "makeBasis",
    value: function makeBasis(t, e, n) {
      return this.set(t.x, e.x, n.x, 0, t.y, e.y, n.y, 0, t.z, e.z, n.z, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "extractRotation",
    value: function extractRotation(t) {
      var e = this.elements,
          n = t.elements,
          i = 1 / ye.setFromMatrixColumn(t, 0).length(),
          r = 1 / ye.setFromMatrixColumn(t, 1).length(),
          s = 1 / ye.setFromMatrixColumn(t, 2).length();
      return e[0] = n[0] * i, e[1] = n[1] * i, e[2] = n[2] * i, e[3] = 0, e[4] = n[4] * r, e[5] = n[5] * r, e[6] = n[6] * r, e[7] = 0, e[8] = n[8] * s, e[9] = n[9] * s, e[10] = n[10] * s, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
  }, {
    key: "makeRotationFromEuler",
    value: function makeRotationFromEuler(t) {
      t && t.isEuler || console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
      var e = this.elements,
          n = t.x,
          i = t.y,
          r = t.z,
          s = Math.cos(n),
          a = Math.sin(n),
          o = Math.cos(i),
          l = Math.sin(i),
          h = Math.cos(r),
          c = Math.sin(r);

      if ("XYZ" === t.order) {
        var _t47 = s * h,
            _n24 = s * c,
            _i18 = a * h,
            _r14 = a * c;

        e[0] = o * h, e[4] = -o * c, e[8] = l, e[1] = _n24 + _i18 * l, e[5] = _t47 - _r14 * l, e[9] = -a * o, e[2] = _r14 - _t47 * l, e[6] = _i18 + _n24 * l, e[10] = s * o;
      } else if ("YXZ" === t.order) {
        var _t48 = o * h,
            _n25 = o * c,
            _i19 = l * h,
            _r15 = l * c;

        e[0] = _t48 + _r15 * a, e[4] = _i19 * a - _n25, e[8] = s * l, e[1] = s * c, e[5] = s * h, e[9] = -a, e[2] = _n25 * a - _i19, e[6] = _r15 + _t48 * a, e[10] = s * o;
      } else if ("ZXY" === t.order) {
        var _t49 = o * h,
            _n26 = o * c,
            _i20 = l * h,
            _r16 = l * c;

        e[0] = _t49 - _r16 * a, e[4] = -s * c, e[8] = _i20 + _n26 * a, e[1] = _n26 + _i20 * a, e[5] = s * h, e[9] = _r16 - _t49 * a, e[2] = -s * l, e[6] = a, e[10] = s * o;
      } else if ("ZYX" === t.order) {
        var _t50 = s * h,
            _n27 = s * c,
            _i21 = a * h,
            _r17 = a * c;

        e[0] = o * h, e[4] = _i21 * l - _n27, e[8] = _t50 * l + _r17, e[1] = o * c, e[5] = _r17 * l + _t50, e[9] = _n27 * l - _i21, e[2] = -l, e[6] = a * o, e[10] = s * o;
      } else if ("YZX" === t.order) {
        var _t51 = s * o,
            _n28 = s * l,
            _i22 = a * o,
            _r18 = a * l;

        e[0] = o * h, e[4] = _r18 - _t51 * c, e[8] = _i22 * c + _n28, e[1] = c, e[5] = s * h, e[9] = -a * h, e[2] = -l * h, e[6] = _n28 * c + _i22, e[10] = _t51 - _r18 * c;
      } else if ("XZY" === t.order) {
        var _t52 = s * o,
            _n29 = s * l,
            _i23 = a * o,
            _r19 = a * l;

        e[0] = o * h, e[4] = -c, e[8] = l * h, e[1] = _t52 * c + _r19, e[5] = s * h, e[9] = _n29 * c - _i23, e[2] = _i23 * c - _n29, e[6] = a * h, e[10] = _r19 * c + _t52;
      }

      return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
  }, {
    key: "makeRotationFromQuaternion",
    value: function makeRotationFromQuaternion(t) {
      return this.compose(_e, t, be);
    }
  }, {
    key: "lookAt",
    value: function lookAt(t, e, n) {
      var i = this.elements;
      return Se.subVectors(t, e), 0 === Se.lengthSq() && (Se.z = 1), Se.normalize(), we.crossVectors(n, Se), 0 === we.lengthSq() && (1 === Math.abs(n.z) ? Se.x += 1e-4 : Se.z += 1e-4, Se.normalize(), we.crossVectors(n, Se)), we.normalize(), Me.crossVectors(Se, we), i[0] = we.x, i[4] = Me.x, i[8] = Se.x, i[1] = we.y, i[5] = Me.y, i[9] = Se.y, i[2] = we.z, i[6] = Me.z, i[10] = Se.z, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(t, e)) : this.multiplyMatrices(this, t);
    }
  }, {
    key: "premultiply",
    value: function premultiply(t) {
      return this.multiplyMatrices(t, this);
    }
  }, {
    key: "multiplyMatrices",
    value: function multiplyMatrices(t, e) {
      var n = t.elements,
          i = e.elements,
          r = this.elements,
          s = n[0],
          a = n[4],
          o = n[8],
          l = n[12],
          h = n[1],
          c = n[5],
          u = n[9],
          d = n[13],
          p = n[2],
          m = n[6],
          f = n[10],
          g = n[14],
          v = n[3],
          y = n[7],
          x = n[11],
          _ = n[15],
          b = i[0],
          w = i[4],
          M = i[8],
          S = i[12],
          T = i[1],
          E = i[5],
          A = i[9],
          R = i[13],
          C = i[2],
          L = i[6],
          P = i[10],
          D = i[14],
          I = i[3],
          O = i[7],
          N = i[11],
          F = i[15];
      return r[0] = s * b + a * T + o * C + l * I, r[4] = s * w + a * E + o * L + l * O, r[8] = s * M + a * A + o * P + l * N, r[12] = s * S + a * R + o * D + l * F, r[1] = h * b + c * T + u * C + d * I, r[5] = h * w + c * E + u * L + d * O, r[9] = h * M + c * A + u * P + d * N, r[13] = h * S + c * R + u * D + d * F, r[2] = p * b + m * T + f * C + g * I, r[6] = p * w + m * E + f * L + g * O, r[10] = p * M + m * A + f * P + g * N, r[14] = p * S + m * R + f * D + g * F, r[3] = v * b + y * T + x * C + _ * I, r[7] = v * w + y * E + x * L + _ * O, r[11] = v * M + y * A + x * P + _ * N, r[15] = v * S + y * R + x * D + _ * F, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      var e = this.elements;
      return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      var t = this.elements,
          e = t[0],
          n = t[4],
          i = t[8],
          r = t[12],
          s = t[1],
          a = t[5],
          o = t[9],
          l = t[13],
          h = t[2],
          c = t[6],
          u = t[10],
          d = t[14];
      return t[3] * (+r * o * c - i * l * c - r * a * u + n * l * u + i * a * d - n * o * d) + t[7] * (+e * o * d - e * l * u + r * s * u - i * s * d + i * l * h - r * o * h) + t[11] * (+e * l * c - e * a * d - r * s * c + n * s * d + r * a * h - n * l * h) + t[15] * (-i * a * h - e * o * c + e * a * u + i * s * c - n * s * u + n * o * h);
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var t = this.elements;
      var e;
      return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
    }
  }, {
    key: "setPosition",
    value: function setPosition(t, e, n) {
      var i = this.elements;
      return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = n), this;
    }
  }, {
    key: "invert",
    value: function invert() {
      var t = this.elements,
          e = t[0],
          n = t[1],
          i = t[2],
          r = t[3],
          s = t[4],
          a = t[5],
          o = t[6],
          l = t[7],
          h = t[8],
          c = t[9],
          u = t[10],
          d = t[11],
          p = t[12],
          m = t[13],
          f = t[14],
          g = t[15],
          v = c * f * l - m * u * l + m * o * d - a * f * d - c * o * g + a * u * g,
          y = p * u * l - h * f * l - p * o * d + s * f * d + h * o * g - s * u * g,
          x = h * m * l - p * c * l + p * a * d - s * m * d - h * a * g + s * c * g,
          _ = p * c * o - h * m * o - p * a * u + s * m * u + h * a * f - s * c * f,
          b = e * v + n * y + i * x + r * _;

      if (0 === b) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
      var w = 1 / b;
      return t[0] = v * w, t[1] = (m * u * r - c * f * r - m * i * d + n * f * d + c * i * g - n * u * g) * w, t[2] = (a * f * r - m * o * r + m * i * l - n * f * l - a * i * g + n * o * g) * w, t[3] = (c * o * r - a * u * r - c * i * l + n * u * l + a * i * d - n * o * d) * w, t[4] = y * w, t[5] = (h * f * r - p * u * r + p * i * d - e * f * d - h * i * g + e * u * g) * w, t[6] = (p * o * r - s * f * r - p * i * l + e * f * l + s * i * g - e * o * g) * w, t[7] = (s * u * r - h * o * r + h * i * l - e * u * l - s * i * d + e * o * d) * w, t[8] = x * w, t[9] = (p * c * r - h * m * r - p * n * d + e * m * d + h * n * g - e * c * g) * w, t[10] = (s * m * r - p * a * r + p * n * l - e * m * l - s * n * g + e * a * g) * w, t[11] = (h * a * r - s * c * r - h * n * l + e * c * l + s * n * d - e * a * d) * w, t[12] = _ * w, t[13] = (h * m * i - p * c * i + p * n * u - e * m * u - h * n * f + e * c * f) * w, t[14] = (p * a * i - s * m * i - p * n * o + e * m * o + s * n * f - e * a * f) * w, t[15] = (s * c * i - h * a * i + h * n * o - e * c * o - s * n * u + e * a * u) * w, this;
    }
  }, {
    key: "scale",
    value: function scale(t) {
      var e = this.elements,
          n = t.x,
          i = t.y,
          r = t.z;
      return e[0] *= n, e[4] *= i, e[8] *= r, e[1] *= n, e[5] *= i, e[9] *= r, e[2] *= n, e[6] *= i, e[10] *= r, e[3] *= n, e[7] *= i, e[11] *= r, this;
    }
  }, {
    key: "getMaxScaleOnAxis",
    value: function getMaxScaleOnAxis() {
      var t = this.elements,
          e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2],
          n = t[4] * t[4] + t[5] * t[5] + t[6] * t[6],
          i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
      return Math.sqrt(Math.max(e, n, i));
    }
  }, {
    key: "makeTranslation",
    value: function makeTranslation(t, e, n) {
      return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, n, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationX",
    value: function makeRotationX(t) {
      var e = Math.cos(t),
          n = Math.sin(t);
      return this.set(1, 0, 0, 0, 0, e, -n, 0, 0, n, e, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationY",
    value: function makeRotationY(t) {
      var e = Math.cos(t),
          n = Math.sin(t);
      return this.set(e, 0, n, 0, 0, 1, 0, 0, -n, 0, e, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationZ",
    value: function makeRotationZ(t) {
      var e = Math.cos(t),
          n = Math.sin(t);
      return this.set(e, -n, 0, 0, n, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationAxis",
    value: function makeRotationAxis(t, e) {
      var n = Math.cos(e),
          i = Math.sin(e),
          r = 1 - n,
          s = t.x,
          a = t.y,
          o = t.z,
          l = r * s,
          h = r * a;
      return this.set(l * s + n, l * a - i * o, l * o + i * a, 0, l * a + i * o, h * a + n, h * o - i * s, 0, l * o - i * a, h * o + i * s, r * o * o + n, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeScale",
    value: function makeScale(t, e, n) {
      return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeShear",
    value: function makeShear(t, e, n, i, r, s) {
      return this.set(1, n, r, 0, t, 1, s, 0, e, i, 1, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "compose",
    value: function compose(t, e, n) {
      var i = this.elements,
          r = e._x,
          s = e._y,
          a = e._z,
          o = e._w,
          l = r + r,
          h = s + s,
          c = a + a,
          u = r * l,
          d = r * h,
          p = r * c,
          m = s * h,
          f = s * c,
          g = a * c,
          v = o * l,
          y = o * h,
          x = o * c,
          _ = n.x,
          b = n.y,
          w = n.z;
      return i[0] = (1 - (m + g)) * _, i[1] = (d + x) * _, i[2] = (p - y) * _, i[3] = 0, i[4] = (d - x) * b, i[5] = (1 - (u + g)) * b, i[6] = (f + v) * b, i[7] = 0, i[8] = (p + y) * w, i[9] = (f - v) * w, i[10] = (1 - (u + m)) * w, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
    }
  }, {
    key: "decompose",
    value: function decompose(t, e, n) {
      var i = this.elements;
      var r = ye.set(i[0], i[1], i[2]).length();
      var s = ye.set(i[4], i[5], i[6]).length(),
          a = ye.set(i[8], i[9], i[10]).length();
      this.determinant() < 0 && (r = -r), t.x = i[12], t.y = i[13], t.z = i[14], xe.copy(this);
      var o = 1 / r,
          l = 1 / s,
          h = 1 / a;
      return xe.elements[0] *= o, xe.elements[1] *= o, xe.elements[2] *= o, xe.elements[4] *= l, xe.elements[5] *= l, xe.elements[6] *= l, xe.elements[8] *= h, xe.elements[9] *= h, xe.elements[10] *= h, e.setFromRotationMatrix(xe), n.x = r, n.y = s, n.z = a, this;
    }
  }, {
    key: "makePerspective",
    value: function makePerspective(t, e, n, i, r, s) {
      void 0 === s && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
      var a = this.elements,
          o = 2 * r / (e - t),
          l = 2 * r / (n - i),
          h = (e + t) / (e - t),
          c = (n + i) / (n - i),
          u = -(s + r) / (s - r),
          d = -2 * s * r / (s - r);
      return a[0] = o, a[4] = 0, a[8] = h, a[12] = 0, a[1] = 0, a[5] = l, a[9] = c, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = u, a[14] = d, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
    }
  }, {
    key: "makeOrthographic",
    value: function makeOrthographic(t, e, n, i, r, s) {
      var a = this.elements,
          o = 1 / (e - t),
          l = 1 / (n - i),
          h = 1 / (s - r),
          c = (e + t) * o,
          u = (n + i) * l,
          d = (s + r) * h;
      return a[0] = 2 * o, a[4] = 0, a[8] = 0, a[12] = -c, a[1] = 0, a[5] = 2 * l, a[9] = 0, a[13] = -u, a[2] = 0, a[6] = 0, a[10] = -2 * h, a[14] = -d, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      var e = this.elements,
          n = t.elements;

      for (var _t53 = 0; _t53 < 16; _t53++) {
        if (e[_t53] !== n[_t53]) return !1;
      }

      return !0;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var _n30 = 0; _n30 < 16; _n30++) {
        this.elements[_n30] = t[_n30 + e];
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.elements;
      return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t[e + 9] = n[9], t[e + 10] = n[10], t[e + 11] = n[11], t[e + 12] = n[12], t[e + 13] = n[13], t[e + 14] = n[14], t[e + 15] = n[15], t;
    }
  }]);

  return ve;
}();

ve.prototype.isMatrix4 = !0;

var ye = new zt(),
    xe = new ve(),
    _e = new zt(0, 0, 0),
    be = new zt(1, 1, 1),
    we = new zt(),
    Me = new zt(),
    Se = new zt(),
    Te = new ve(),
    Ee = new Bt();

var Ae = /*#__PURE__*/function () {
  function Ae() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Ae.DefaultOrder;

    _classCallCheck(this, Ae);

    this._x = t, this._y = e, this._z = n, this._order = i;
  }

  _createClass(Ae, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(t) {
      this._x = t, this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(t) {
      this._y = t, this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(t) {
      this._z = t, this._onChangeCallback();
    }
  }, {
    key: "order",
    get: function get() {
      return this._order;
    },
    set: function set(t) {
      this._order = t, this._onChangeCallback();
    }
  }, {
    key: "set",
    value: function set(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this._order;
      return this._x = t, this._y = e, this._z = n, this._order = i, this._onChangeCallback(), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._order);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
  }, {
    key: "setFromRotationMatrix",
    value: function setFromRotationMatrix(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var i = t.elements,
          r = i[0],
          s = i[4],
          a = i[8],
          o = i[1],
          l = i[5],
          h = i[9],
          c = i[2],
          u = i[6],
          d = i[10];

      switch (e) {
        case "XYZ":
          this._y = Math.asin(ot(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-h, d), this._z = Math.atan2(-s, r)) : (this._x = Math.atan2(u, l), this._z = 0);
          break;

        case "YXZ":
          this._x = Math.asin(-ot(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(a, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-c, r), this._z = 0);
          break;

        case "ZXY":
          this._x = Math.asin(ot(u, -1, 1)), Math.abs(u) < .9999999 ? (this._y = Math.atan2(-c, d), this._z = Math.atan2(-s, l)) : (this._y = 0, this._z = Math.atan2(o, r));
          break;

        case "ZYX":
          this._y = Math.asin(-ot(c, -1, 1)), Math.abs(c) < .9999999 ? (this._x = Math.atan2(u, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-s, l));
          break;

        case "YZX":
          this._z = Math.asin(ot(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-h, l), this._y = Math.atan2(-c, r)) : (this._x = 0, this._y = Math.atan2(a, d));
          break;

        case "XZY":
          this._z = Math.asin(-ot(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(u, l), this._y = Math.atan2(a, r)) : (this._x = Math.atan2(-h, d), this._y = 0);
          break;

        default:
          console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
      }

      return this._order = e, !0 === n && this._onChangeCallback(), this;
    }
  }, {
    key: "setFromQuaternion",
    value: function setFromQuaternion(t, e, n) {
      return Te.makeRotationFromQuaternion(t), this.setFromRotationMatrix(Te, e, n);
    }
  }, {
    key: "setFromVector3",
    value: function setFromVector3(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
      return this.set(t.x, t.y, t.z, e);
    }
  }, {
    key: "reorder",
    value: function reorder(t) {
      return Ee.setFromEuler(this), this.setFromQuaternion(Ee, t);
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      return this._x = t[0], this._y = t[1], this._z = t[2], void 0 !== t[3] && (this._order = t[3]), this._onChangeCallback(), this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
  }, {
    key: "_onChange",
    value: function _onChange(t) {
      return this._onChangeCallback = t, this;
    }
  }, {
    key: "_onChangeCallback",
    value: function _onChangeCallback() {}
  }]);

  return Ae;
}();

Ae.prototype.isEuler = !0, Ae.DefaultOrder = "XYZ", Ae.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];

var Re = /*#__PURE__*/function () {
  function Re() {
    _classCallCheck(this, Re);

    this.mask = 1;
  }

  _createClass(Re, [{
    key: "set",
    value: function set(t) {
      this.mask = (1 << t | 0) >>> 0;
    }
  }, {
    key: "enable",
    value: function enable(t) {
      this.mask |= 1 << t | 0;
    }
  }, {
    key: "enableAll",
    value: function enableAll() {
      this.mask = -1;
    }
  }, {
    key: "toggle",
    value: function toggle(t) {
      this.mask ^= 1 << t | 0;
    }
  }, {
    key: "disable",
    value: function disable(t) {
      this.mask &= ~(1 << t | 0);
    }
  }, {
    key: "disableAll",
    value: function disableAll() {
      this.mask = 0;
    }
  }, {
    key: "test",
    value: function test(t) {
      return 0 != (this.mask & t.mask);
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(t) {
      return 0 != (this.mask & (1 << t | 0));
    }
  }]);

  return Re;
}();

var Ce = 0;
var Le = new zt(),
    Pe = new Bt(),
    De = new ve(),
    Ie = new zt(),
    Oe = new zt(),
    Ne = new zt(),
    Fe = new Bt(),
    Ue = new zt(1, 0, 0),
    ke = new zt(0, 1, 0),
    Be = new zt(0, 0, 1),
    ze = {
  type: "added"
},
    He = {
  type: "removed"
};

var Ve = /*#__PURE__*/function (_et3) {
  _inherits(Ve, _et3);

  var _super12 = _createSuper(Ve);

  function Ve() {
    var _this18;

    _classCallCheck(this, Ve);

    _this18 = _super12.call(this), Object.defineProperty(_assertThisInitialized(_this18), "id", {
      value: Ce++
    }), _this18.uuid = at(), _this18.name = "", _this18.type = "Object3D", _this18.parent = null, _this18.children = [], _this18.up = Ve.DefaultUp.clone();
    var t = new zt(),
        e = new Ae(),
        n = new Bt(),
        i = new zt(1, 1, 1);
    e._onChange(function () {
      n.setFromEuler(e, !1);
    }), n._onChange(function () {
      e.setFromQuaternion(n, void 0, !1);
    }), Object.defineProperties(_assertThisInitialized(_this18), {
      position: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      modelViewMatrix: {
        value: new ve()
      },
      normalMatrix: {
        value: new ft()
      }
    }), _this18.matrix = new ve(), _this18.matrixWorld = new ve(), _this18.matrixAutoUpdate = Ve.DefaultMatrixAutoUpdate, _this18.matrixWorldNeedsUpdate = !1, _this18.layers = new Re(), _this18.visible = !0, _this18.castShadow = !1, _this18.receiveShadow = !1, _this18.frustumCulled = !0, _this18.renderOrder = 0, _this18.animations = [], _this18.userData = {};
    return _this18;
  }

  _createClass(Ve, [{
    key: "onBeforeRender",
    value: function onBeforeRender() {}
  }, {
    key: "onAfterRender",
    value: function onAfterRender() {}
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(t) {
      return this.quaternion.premultiply(t), this;
    }
  }, {
    key: "setRotationFromAxisAngle",
    value: function setRotationFromAxisAngle(t, e) {
      this.quaternion.setFromAxisAngle(t, e);
    }
  }, {
    key: "setRotationFromEuler",
    value: function setRotationFromEuler(t) {
      this.quaternion.setFromEuler(t, !0);
    }
  }, {
    key: "setRotationFromMatrix",
    value: function setRotationFromMatrix(t) {
      this.quaternion.setFromRotationMatrix(t);
    }
  }, {
    key: "setRotationFromQuaternion",
    value: function setRotationFromQuaternion(t) {
      this.quaternion.copy(t);
    }
  }, {
    key: "rotateOnAxis",
    value: function rotateOnAxis(t, e) {
      return Pe.setFromAxisAngle(t, e), this.quaternion.multiply(Pe), this;
    }
  }, {
    key: "rotateOnWorldAxis",
    value: function rotateOnWorldAxis(t, e) {
      return Pe.setFromAxisAngle(t, e), this.quaternion.premultiply(Pe), this;
    }
  }, {
    key: "rotateX",
    value: function rotateX(t) {
      return this.rotateOnAxis(Ue, t);
    }
  }, {
    key: "rotateY",
    value: function rotateY(t) {
      return this.rotateOnAxis(ke, t);
    }
  }, {
    key: "rotateZ",
    value: function rotateZ(t) {
      return this.rotateOnAxis(Be, t);
    }
  }, {
    key: "translateOnAxis",
    value: function translateOnAxis(t, e) {
      return Le.copy(t).applyQuaternion(this.quaternion), this.position.add(Le.multiplyScalar(e)), this;
    }
  }, {
    key: "translateX",
    value: function translateX(t) {
      return this.translateOnAxis(Ue, t);
    }
  }, {
    key: "translateY",
    value: function translateY(t) {
      return this.translateOnAxis(ke, t);
    }
  }, {
    key: "translateZ",
    value: function translateZ(t) {
      return this.translateOnAxis(Be, t);
    }
  }, {
    key: "localToWorld",
    value: function localToWorld(t) {
      return t.applyMatrix4(this.matrixWorld);
    }
  }, {
    key: "worldToLocal",
    value: function worldToLocal(t) {
      return t.applyMatrix4(De.copy(this.matrixWorld).invert());
    }
  }, {
    key: "lookAt",
    value: function lookAt(t, e, n) {
      t.isVector3 ? Ie.copy(t) : Ie.set(t, e, n);
      var i = this.parent;
      this.updateWorldMatrix(!0, !1), Oe.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? De.lookAt(Oe, Ie, this.up) : De.lookAt(Ie, Oe, this.up), this.quaternion.setFromRotationMatrix(De), i && (De.extractRotation(i.matrixWorld), Pe.setFromRotationMatrix(De), this.quaternion.premultiply(Pe.invert()));
    }
  }, {
    key: "add",
    value: function add(t) {
      if (arguments.length > 1) {
        for (var _t54 = 0; _t54 < arguments.length; _t54++) {
          this.add(arguments[_t54]);
        }

        return this;
      }

      return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (null !== t.parent && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent(ze)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
  }, {
    key: "remove",
    value: function remove(t) {
      if (arguments.length > 1) {
        for (var _t55 = 0; _t55 < arguments.length; _t55++) {
          this.remove(arguments[_t55]);
        }

        return this;
      }

      var e = this.children.indexOf(t);
      return -1 !== e && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(He)), this;
    }
  }, {
    key: "removeFromParent",
    value: function removeFromParent() {
      var t = this.parent;
      return null !== t && t.remove(this), this;
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var _t56 = 0; _t56 < this.children.length; _t56++) {
        var _e26 = this.children[_t56];
        _e26.parent = null, _e26.dispatchEvent(He);
      }

      return this.children.length = 0, this;
    }
  }, {
    key: "attach",
    value: function attach(t) {
      return this.updateWorldMatrix(!0, !1), De.copy(this.matrixWorld).invert(), null !== t.parent && (t.parent.updateWorldMatrix(!0, !1), De.multiply(t.parent.matrixWorld)), t.applyMatrix4(De), this.add(t), t.updateWorldMatrix(!1, !0), this;
    }
  }, {
    key: "getObjectById",
    value: function getObjectById(t) {
      return this.getObjectByProperty("id", t);
    }
  }, {
    key: "getObjectByName",
    value: function getObjectByName(t) {
      return this.getObjectByProperty("name", t);
    }
  }, {
    key: "getObjectByProperty",
    value: function getObjectByProperty(t, e) {
      if (this[t] === e) return this;

      for (var _n31 = 0, _i24 = this.children.length; _n31 < _i24; _n31++) {
        var _i25 = this.children[_n31].getObjectByProperty(t, e);

        if (void 0 !== _i25) return _i25;
      }
    }
  }, {
    key: "getWorldPosition",
    value: function getWorldPosition(t) {
      return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
  }, {
    key: "getWorldQuaternion",
    value: function getWorldQuaternion(t) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Oe, t, Ne), t;
    }
  }, {
    key: "getWorldScale",
    value: function getWorldScale(t) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Oe, Fe, t), t;
    }
  }, {
    key: "getWorldDirection",
    value: function getWorldDirection(t) {
      this.updateWorldMatrix(!0, !1);
      var e = this.matrixWorld.elements;
      return t.set(e[8], e[9], e[10]).normalize();
    }
  }, {
    key: "raycast",
    value: function raycast() {}
  }, {
    key: "traverse",
    value: function traverse(t) {
      t(this);
      var e = this.children;

      for (var _n32 = 0, _i26 = e.length; _n32 < _i26; _n32++) {
        e[_n32].traverse(t);
      }
    }
  }, {
    key: "traverseVisible",
    value: function traverseVisible(t) {
      if (!1 === this.visible) return;
      t(this);
      var e = this.children;

      for (var _n33 = 0, _i27 = e.length; _n33 < _i27; _n33++) {
        e[_n33].traverseVisible(t);
      }
    }
  }, {
    key: "traverseAncestors",
    value: function traverseAncestors(t) {
      var e = this.parent;
      null !== e && (t(e), e.traverseAncestors(t));
    }
  }, {
    key: "updateMatrix",
    value: function updateMatrix() {
      this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
      var e = this.children;

      for (var _n34 = 0, _i28 = e.length; _n34 < _i28; _n34++) {
        e[_n34].updateMatrixWorld(t);
      }
    }
  }, {
    key: "updateWorldMatrix",
    value: function updateWorldMatrix(t, e) {
      var n = this.parent;

      if (!0 === t && null !== n && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
        var _t57 = this.children;

        for (var _e27 = 0, _n35 = _t57.length; _e27 < _n35; _e27++) {
          _t57[_e27].updateWorldMatrix(!1, !0);
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = void 0 === t || "string" == typeof t,
          n = {};
      e && (t = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {}
      }, n.metadata = {
        version: 4.5,
        type: "Object",
        generator: "Object3D.toJSON"
      });
      var i = {};

      function r(e, n) {
        return void 0 === e[n.uuid] && (e[n.uuid] = n.toJSON(t)), n.uuid;
      }

      if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), "{}" !== JSON.stringify(this.userData) && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && (i.environment = this.environment.toJSON(t).uuid);else if (this.isMesh || this.isLine || this.isPoints) {
        i.geometry = r(t.geometries, this.geometry);
        var _e28 = this.geometry.parameters;

        if (void 0 !== _e28 && void 0 !== _e28.shapes) {
          var _n36 = _e28.shapes;
          if (Array.isArray(_n36)) for (var _e29 = 0, _i29 = _n36.length; _e29 < _i29; _e29++) {
            var _i30 = _n36[_e29];
            r(t.shapes, _i30);
          } else r(t.shapes, _n36);
        }
      }
      if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) if (Array.isArray(this.material)) {
        var _e30 = [];

        for (var _n37 = 0, _i31 = this.material.length; _n37 < _i31; _n37++) {
          _e30.push(r(t.materials, this.material[_n37]));
        }

        i.material = _e30;
      } else i.material = r(t.materials, this.material);

      if (this.children.length > 0) {
        i.children = [];

        for (var _e31 = 0; _e31 < this.children.length; _e31++) {
          i.children.push(this.children[_e31].toJSON(t).object);
        }
      }

      if (this.animations.length > 0) {
        i.animations = [];

        for (var _e32 = 0; _e32 < this.animations.length; _e32++) {
          var _n38 = this.animations[_e32];
          i.animations.push(r(t.animations, _n38));
        }
      }

      if (e) {
        var _e33 = s(t.geometries),
            _i32 = s(t.materials),
            _r20 = s(t.textures),
            _a6 = s(t.images),
            _o8 = s(t.shapes),
            _l7 = s(t.skeletons),
            _h5 = s(t.animations),
            _c4 = s(t.nodes);

        _e33.length > 0 && (n.geometries = _e33), _i32.length > 0 && (n.materials = _i32), _r20.length > 0 && (n.textures = _r20), _a6.length > 0 && (n.images = _a6), _o8.length > 0 && (n.shapes = _o8), _l7.length > 0 && (n.skeletons = _l7), _h5.length > 0 && (n.animations = _h5), _c4.length > 0 && (n.nodes = _c4);
      }

      return n.object = i, n;

      function s(t) {
        var e = [];

        for (var _n39 in t) {
          var _i33 = t[_n39];
          delete _i33.metadata, e.push(_i33);
        }

        return e;
      }
    }
  }, {
    key: "clone",
    value: function clone(t) {
      return new this.constructor().copy(this, t);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), !0 === e) for (var _e34 = 0; _e34 < t.children.length; _e34++) {
        var _n40 = t.children[_e34];
        this.add(_n40.clone());
      }
      return this;
    }
  }]);

  return Ve;
}(et);

Ve.DefaultUp = new zt(0, 1, 0), Ve.DefaultMatrixAutoUpdate = !0, Ve.prototype.isObject3D = !0;
var Ge = new zt(),
    We = new zt(),
    je = new zt(),
    qe = new zt(),
    Xe = new zt(),
    Ye = new zt(),
    Je = new zt(),
    Ze = new zt(),
    $e = new zt(),
    Ke = new zt();

var Qe = /*#__PURE__*/function () {
  function Qe() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new zt();

    _classCallCheck(this, Qe);

    this.a = t, this.b = e, this.c = n;
  }

  _createClass(Qe, [{
    key: "set",
    value: function set(t, e, n) {
      return this.a.copy(t), this.b.copy(e), this.c.copy(n), this;
    }
  }, {
    key: "setFromPointsAndIndices",
    value: function setFromPointsAndIndices(t, e, n, i) {
      return this.a.copy(t[e]), this.b.copy(t[n]), this.c.copy(t[i]), this;
    }
  }, {
    key: "setFromAttributeAndIndices",
    value: function setFromAttributeAndIndices(t, e, n, i) {
      return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, n), this.c.fromBufferAttribute(t, i), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      return Ge.subVectors(this.c, this.b), We.subVectors(this.a, this.b), .5 * Ge.cross(We).length();
    }
  }, {
    key: "getMidpoint",
    value: function getMidpoint(t) {
      return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
  }, {
    key: "getNormal",
    value: function getNormal(t) {
      return Qe.getNormal(this.a, this.b, this.c, t);
    }
  }, {
    key: "getPlane",
    value: function getPlane(t) {
      return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
  }, {
    key: "getBarycoord",
    value: function getBarycoord(t, e) {
      return Qe.getBarycoord(t, this.a, this.b, this.c, e);
    }
  }, {
    key: "getUV",
    value: function getUV(t, e, n, i, r) {
      return Qe.getUV(t, this.a, this.b, this.c, e, n, i, r);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      return Qe.containsPoint(t, this.a, this.b, this.c);
    }
  }, {
    key: "isFrontFacing",
    value: function isFrontFacing(t) {
      return Qe.isFrontFacing(this.a, this.b, this.c, t);
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return t.intersectsTriangle(this);
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(t, e) {
      var n = this.a,
          i = this.b,
          r = this.c;
      var s, a;
      Xe.subVectors(i, n), Ye.subVectors(r, n), Ze.subVectors(t, n);
      var o = Xe.dot(Ze),
          l = Ye.dot(Ze);
      if (o <= 0 && l <= 0) return e.copy(n);
      $e.subVectors(t, i);
      var h = Xe.dot($e),
          c = Ye.dot($e);
      if (h >= 0 && c <= h) return e.copy(i);
      var u = o * c - h * l;
      if (u <= 0 && o >= 0 && h <= 0) return s = o / (o - h), e.copy(n).addScaledVector(Xe, s);
      Ke.subVectors(t, r);
      var d = Xe.dot(Ke),
          p = Ye.dot(Ke);
      if (p >= 0 && d <= p) return e.copy(r);
      var m = d * l - o * p;
      if (m <= 0 && l >= 0 && p <= 0) return a = l / (l - p), e.copy(n).addScaledVector(Ye, a);
      var f = h * p - d * c;
      if (f <= 0 && c - h >= 0 && d - p >= 0) return Je.subVectors(r, i), a = (c - h) / (c - h + (d - p)), e.copy(i).addScaledVector(Je, a);
      var g = 1 / (f + m + u);
      return s = m * g, a = u * g, e.copy(n).addScaledVector(Xe, s).addScaledVector(Ye, a);
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
  }], [{
    key: "getNormal",
    value: function getNormal(t, e, n, i) {
      i.subVectors(n, e), Ge.subVectors(t, e), i.cross(Ge);
      var r = i.lengthSq();
      return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
    }
  }, {
    key: "getBarycoord",
    value: function getBarycoord(t, e, n, i, r) {
      Ge.subVectors(i, e), We.subVectors(n, e), je.subVectors(t, e);
      var s = Ge.dot(Ge),
          a = Ge.dot(We),
          o = Ge.dot(je),
          l = We.dot(We),
          h = We.dot(je),
          c = s * l - a * a;
      if (0 === c) return r.set(-2, -1, -1);
      var u = 1 / c,
          d = (l * o - a * h) * u,
          p = (s * h - a * o) * u;
      return r.set(1 - d - p, p, d);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t, e, n, i) {
      return this.getBarycoord(t, e, n, i, qe), qe.x >= 0 && qe.y >= 0 && qe.x + qe.y <= 1;
    }
  }, {
    key: "getUV",
    value: function getUV(t, e, n, i, r, s, a, o) {
      return this.getBarycoord(t, e, n, i, qe), o.set(0, 0), o.addScaledVector(r, qe.x), o.addScaledVector(s, qe.y), o.addScaledVector(a, qe.z), o;
    }
  }, {
    key: "isFrontFacing",
    value: function isFrontFacing(t, e, n, i) {
      return Ge.subVectors(n, e), We.subVectors(t, e), Ge.cross(We).dot(i) < 0;
    }
  }]);

  return Qe;
}();

var tn = 0;

var en = /*#__PURE__*/function (_et4) {
  _inherits(en, _et4);

  var _super13 = _createSuper(en);

  function en() {
    var _this19;

    _classCallCheck(this, en);

    _this19 = _super13.call(this), Object.defineProperty(_assertThisInitialized(_this19), "id", {
      value: tn++
    }), _this19.uuid = at(), _this19.name = "", _this19.type = "Material", _this19.fog = !0, _this19.blending = 1, _this19.side = 0, _this19.vertexColors = !1, _this19.opacity = 1, _this19.transparent = !1, _this19.blendSrc = 204, _this19.blendDst = 205, _this19.blendEquation = 100, _this19.blendSrcAlpha = null, _this19.blendDstAlpha = null, _this19.blendEquationAlpha = null, _this19.depthFunc = 3, _this19.depthTest = !0, _this19.depthWrite = !0, _this19.stencilWriteMask = 255, _this19.stencilFunc = 519, _this19.stencilRef = 0, _this19.stencilFuncMask = 255, _this19.stencilFail = 7680, _this19.stencilZFail = 7680, _this19.stencilZPass = 7680, _this19.stencilWrite = !1, _this19.clippingPlanes = null, _this19.clipIntersection = !1, _this19.clipShadows = !1, _this19.shadowSide = null, _this19.colorWrite = !0, _this19.precision = null, _this19.polygonOffset = !1, _this19.polygonOffsetFactor = 0, _this19.polygonOffsetUnits = 0, _this19.dithering = !1, _this19.alphaToCoverage = !1, _this19.premultipliedAlpha = !1, _this19.visible = !0, _this19.toneMapped = !0, _this19.userData = {}, _this19.version = 0, _this19._alphaTest = 0;
    return _this19;
  }

  _createClass(en, [{
    key: "alphaTest",
    get: function get() {
      return this._alphaTest;
    },
    set: function set(t) {
      this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
    }
  }, {
    key: "onBuild",
    value: function onBuild() {}
  }, {
    key: "onBeforeRender",
    value: function onBeforeRender() {}
  }, {
    key: "onBeforeCompile",
    value: function onBeforeCompile() {}
  }, {
    key: "customProgramCacheKey",
    value: function customProgramCacheKey() {
      return this.onBeforeCompile.toString();
    }
  }, {
    key: "setValues",
    value: function setValues(t) {
      if (void 0 !== t) for (var _e35 in t) {
        var _n41 = t[_e35];

        if (void 0 === _n41) {
          console.warn("THREE.Material: '" + _e35 + "' parameter is undefined.");
          continue;
        }

        if ("shading" === _e35) {
          console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === _n41;
          continue;
        }

        var _i34 = this[_e35];
        void 0 !== _i34 ? _i34 && _i34.isColor ? _i34.set(_n41) : _i34 && _i34.isVector3 && _n41 && _n41.isVector3 ? _i34.copy(_n41) : this[_e35] = _n41 : console.warn("THREE." + this.type + ": '" + _e35 + "' is not a property of this material.");
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = void 0 === t || "string" == typeof t;
      e && (t = {
        textures: {},
        images: {}
      });
      var n = {
        metadata: {
          version: 4.5,
          type: "Material",
          generator: "Material.toJSON"
        }
      };

      function i(t) {
        var e = [];

        for (var _n42 in t) {
          var _i35 = t[_n42];
          delete _i35.metadata, e.push(_i35);
        }

        return e;
      }

      if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), void 0 !== this.sheen && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t).uuid), void 0 !== this.attenuationDistance && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (n.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (n.blending = this.blending), 0 !== this.side && (n.side = this.side), this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, n.colorWrite = this.colorWrite, n.stencilWrite = this.stencilWrite, n.stencilWriteMask = this.stencilWriteMask, n.stencilFunc = this.stencilFunc, n.stencilRef = this.stencilRef, n.stencilFuncMask = this.stencilFuncMask, n.stencilFail = this.stencilFail, n.stencilZFail = this.stencilZFail, n.stencilZPass = this.stencilZPass, void 0 !== this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaToCoverage && (n.alphaToCoverage = this.alphaToCoverage), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.wireframe && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = this.flatShading), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), e) {
        var _e36 = i(t.textures),
            _r21 = i(t.images);

        _e36.length > 0 && (n.textures = _e36), _r21.length > 0 && (n.images = _r21);
      }

      return n;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      this.name = t.name, this.fog = t.fog, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
      var e = t.clippingPlanes;
      var n = null;

      if (null !== e) {
        var _t58 = e.length;
        n = new Array(_t58);

        for (var _i36 = 0; _i36 !== _t58; ++_i36) {
          n[_i36] = e[_i36].clone();
        }
      }

      return this.clippingPlanes = n, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }]);

  return en;
}(et);

en.prototype.isMaterial = !0, en.fromType = function () {
  return null;
};

var nn = /*#__PURE__*/function (_en) {
  _inherits(nn, _en);

  var _super14 = _createSuper(nn);

  function nn(t) {
    var _this20;

    _classCallCheck(this, nn);

    _this20 = _super14.call(this), _this20.type = "MeshBasicMaterial", _this20.color = new Rt(16777215), _this20.map = null, _this20.lightMap = null, _this20.lightMapIntensity = 1, _this20.aoMap = null, _this20.aoMapIntensity = 1, _this20.specularMap = null, _this20.alphaMap = null, _this20.envMap = null, _this20.combine = 0, _this20.reflectivity = 1, _this20.refractionRatio = .98, _this20.wireframe = !1, _this20.wireframeLinewidth = 1, _this20.wireframeLinecap = "round", _this20.wireframeLinejoin = "round", _this20.setValues(t);
    return _this20;
  }

  _createClass(nn, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(nn.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
    }
  }]);

  return nn;
}(en);

nn.prototype.isMeshBasicMaterial = !0;
var rn = new zt(),
    sn = new mt();

var an = /*#__PURE__*/function () {
  function an(t, e, n) {
    _classCallCheck(this, an);

    if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.name = "", this.array = t, this.itemSize = e, this.count = void 0 !== t ? t.length / e : 0, this.normalized = !0 === n, this.usage = 35044, this.updateRange = {
      offset: 0,
      count: -1
    }, this.version = 0;
  }

  _createClass(an, [{
    key: "onUploadCallback",
    value: function onUploadCallback() {}
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }, {
    key: "setUsage",
    value: function setUsage(t) {
      return this.usage = t, this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this;
    }
  }, {
    key: "copyAt",
    value: function copyAt(t, e, n) {
      t *= this.itemSize, n *= e.itemSize;

      for (var _i37 = 0, _r22 = this.itemSize; _i37 < _r22; _i37++) {
        this.array[t + _i37] = e.array[n + _i37];
      }

      return this;
    }
  }, {
    key: "copyArray",
    value: function copyArray(t) {
      return this.array.set(t), this;
    }
  }, {
    key: "copyColorsArray",
    value: function copyColorsArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i38 = 0, _r23 = t.length; _i38 < _r23; _i38++) {
        var _r24 = t[_i38];
        void 0 === _r24 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", _i38), _r24 = new Rt()), e[n++] = _r24.r, e[n++] = _r24.g, e[n++] = _r24.b;
      }

      return this;
    }
  }, {
    key: "copyVector2sArray",
    value: function copyVector2sArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i39 = 0, _r25 = t.length; _i39 < _r25; _i39++) {
        var _r26 = t[_i39];
        void 0 === _r26 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", _i39), _r26 = new mt()), e[n++] = _r26.x, e[n++] = _r26.y;
      }

      return this;
    }
  }, {
    key: "copyVector3sArray",
    value: function copyVector3sArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i40 = 0, _r27 = t.length; _i40 < _r27; _i40++) {
        var _r28 = t[_i40];
        void 0 === _r28 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", _i40), _r28 = new zt()), e[n++] = _r28.x, e[n++] = _r28.y, e[n++] = _r28.z;
      }

      return this;
    }
  }, {
    key: "copyVector4sArray",
    value: function copyVector4sArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i41 = 0, _r29 = t.length; _i41 < _r29; _i41++) {
        var _r30 = t[_i41];
        void 0 === _r30 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", _i41), _r30 = new Nt()), e[n++] = _r30.x, e[n++] = _r30.y, e[n++] = _r30.z, e[n++] = _r30.w;
      }

      return this;
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(t) {
      if (2 === this.itemSize) for (var _e37 = 0, _n43 = this.count; _e37 < _n43; _e37++) {
        sn.fromBufferAttribute(this, _e37), sn.applyMatrix3(t), this.setXY(_e37, sn.x, sn.y);
      } else if (3 === this.itemSize) for (var _e38 = 0, _n44 = this.count; _e38 < _n44; _e38++) {
        rn.fromBufferAttribute(this, _e38), rn.applyMatrix3(t), this.setXYZ(_e38, rn.x, rn.y, rn.z);
      }
      return this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      for (var _e39 = 0, _n45 = this.count; _e39 < _n45; _e39++) {
        rn.fromBufferAttribute(this, _e39), rn.applyMatrix4(t), this.setXYZ(_e39, rn.x, rn.y, rn.z);
      }

      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(t) {
      for (var _e40 = 0, _n46 = this.count; _e40 < _n46; _e40++) {
        rn.fromBufferAttribute(this, _e40), rn.applyNormalMatrix(t), this.setXYZ(_e40, rn.x, rn.y, rn.z);
      }

      return this;
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(t) {
      for (var _e41 = 0, _n47 = this.count; _e41 < _n47; _e41++) {
        rn.fromBufferAttribute(this, _e41), rn.transformDirection(t), this.setXYZ(_e41, rn.x, rn.y, rn.z);
      }

      return this;
    }
  }, {
    key: "set",
    value: function set(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.array.set(t, e), this;
    }
  }, {
    key: "getX",
    value: function getX(t) {
      return this.array[t * this.itemSize];
    }
  }, {
    key: "setX",
    value: function setX(t, e) {
      return this.array[t * this.itemSize] = e, this;
    }
  }, {
    key: "getY",
    value: function getY(t) {
      return this.array[t * this.itemSize + 1];
    }
  }, {
    key: "setY",
    value: function setY(t, e) {
      return this.array[t * this.itemSize + 1] = e, this;
    }
  }, {
    key: "getZ",
    value: function getZ(t) {
      return this.array[t * this.itemSize + 2];
    }
  }, {
    key: "setZ",
    value: function setZ(t, e) {
      return this.array[t * this.itemSize + 2] = e, this;
    }
  }, {
    key: "getW",
    value: function getW(t) {
      return this.array[t * this.itemSize + 3];
    }
  }, {
    key: "setW",
    value: function setW(t, e) {
      return this.array[t * this.itemSize + 3] = e, this;
    }
  }, {
    key: "setXY",
    value: function setXY(t, e, n) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this;
    }
  }, {
    key: "setXYZ",
    value: function setXYZ(t, e, n, i) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this;
    }
  }, {
    key: "setXYZW",
    value: function setXYZW(t, e, n, i, r) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this.array[t + 3] = r, this;
    }
  }, {
    key: "onUpload",
    value: function onUpload(t) {
      return this.onUploadCallback = t, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: Array.prototype.slice.call(this.array),
        normalized: this.normalized
      };
      return "" !== this.name && (t.name = this.name), 35044 !== this.usage && (t.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (t.updateRange = this.updateRange), t;
    }
  }]);

  return an;
}();

an.prototype.isBufferAttribute = !0;

var on = /*#__PURE__*/function (_an) {
  _inherits(on, _an);

  var _super15 = _createSuper(on);

  function on(t, e, n) {
    _classCallCheck(this, on);

    return _super15.call(this, new Uint16Array(t), e, n);
  }

  return on;
}(an);

var ln = /*#__PURE__*/function (_an2) {
  _inherits(ln, _an2);

  var _super16 = _createSuper(ln);

  function ln(t, e, n) {
    _classCallCheck(this, ln);

    return _super16.call(this, new Uint32Array(t), e, n);
  }

  return ln;
}(an);

/*#__PURE__*/
(function (_an3) {
  _inherits(_class5, _an3);

  var _super17 = _createSuper(_class5);

  function _class5(t, e, n) {
    _classCallCheck(this, _class5);

    return _super17.call(this, new Uint16Array(t), e, n);
  }

  return _class5;
})(an).prototype.isFloat16BufferAttribute = !0;

var hn = /*#__PURE__*/function (_an4) {
  _inherits(hn, _an4);

  var _super18 = _createSuper(hn);

  function hn(t, e, n) {
    _classCallCheck(this, hn);

    return _super18.call(this, new Float32Array(t), e, n);
  }

  return hn;
}(an);

var cn = 0;
var un = new ve(),
    dn = new Ve(),
    pn = new zt(),
    mn = new Gt(),
    fn = new Gt(),
    gn = new zt();

var vn = /*#__PURE__*/function (_et5) {
  _inherits(vn, _et5);

  var _super19 = _createSuper(vn);

  function vn() {
    var _this21;

    _classCallCheck(this, vn);

    _this21 = _super19.call(this), Object.defineProperty(_assertThisInitialized(_this21), "id", {
      value: cn++
    }), _this21.uuid = at(), _this21.name = "", _this21.type = "BufferGeometry", _this21.index = null, _this21.attributes = {}, _this21.morphAttributes = {}, _this21.morphTargetsRelative = !1, _this21.groups = [], _this21.boundingBox = null, _this21.boundingSphere = null, _this21.drawRange = {
      start: 0,
      count: 1 / 0
    }, _this21.userData = {};
    return _this21;
  }

  _createClass(vn, [{
    key: "getIndex",
    value: function getIndex() {
      return this.index;
    }
  }, {
    key: "setIndex",
    value: function setIndex(t) {
      return Array.isArray(t) ? this.index = new (gt(t) ? ln : on)(t, 1) : this.index = t, this;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(t) {
      return this.attributes[t];
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(t, e) {
      return this.attributes[t] = e, this;
    }
  }, {
    key: "deleteAttribute",
    value: function deleteAttribute(t) {
      return delete this.attributes[t], this;
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(t) {
      return void 0 !== this.attributes[t];
    }
  }, {
    key: "addGroup",
    value: function addGroup(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.groups.push({
        start: t,
        count: e,
        materialIndex: n
      });
    }
  }, {
    key: "clearGroups",
    value: function clearGroups() {
      this.groups = [];
    }
  }, {
    key: "setDrawRange",
    value: function setDrawRange(t, e) {
      this.drawRange.start = t, this.drawRange.count = e;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      var e = this.attributes.position;
      void 0 !== e && (e.applyMatrix4(t), e.needsUpdate = !0);
      var n = this.attributes.normal;

      if (void 0 !== n) {
        var _e42 = new ft().getNormalMatrix(t);

        n.applyNormalMatrix(_e42), n.needsUpdate = !0;
      }

      var i = this.attributes.tangent;
      return void 0 !== i && (i.transformDirection(t), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(t) {
      return un.makeRotationFromQuaternion(t), this.applyMatrix4(un), this;
    }
  }, {
    key: "rotateX",
    value: function rotateX(t) {
      return un.makeRotationX(t), this.applyMatrix4(un), this;
    }
  }, {
    key: "rotateY",
    value: function rotateY(t) {
      return un.makeRotationY(t), this.applyMatrix4(un), this;
    }
  }, {
    key: "rotateZ",
    value: function rotateZ(t) {
      return un.makeRotationZ(t), this.applyMatrix4(un), this;
    }
  }, {
    key: "translate",
    value: function translate(t, e, n) {
      return un.makeTranslation(t, e, n), this.applyMatrix4(un), this;
    }
  }, {
    key: "scale",
    value: function scale(t, e, n) {
      return un.makeScale(t, e, n), this.applyMatrix4(un), this;
    }
  }, {
    key: "lookAt",
    value: function lookAt(t) {
      return dn.lookAt(t), dn.updateMatrix(), this.applyMatrix4(dn.matrix), this;
    }
  }, {
    key: "center",
    value: function center() {
      return this.computeBoundingBox(), this.boundingBox.getCenter(pn).negate(), this.translate(pn.x, pn.y, pn.z), this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(t) {
      var e = [];

      for (var _n48 = 0, _i42 = t.length; _n48 < _i42; _n48++) {
        var _i43 = t[_n48];
        e.push(_i43.x, _i43.y, _i43.z || 0);
      }

      return this.setAttribute("position", new hn(e, 3)), this;
    }
  }, {
    key: "computeBoundingBox",
    value: function computeBoundingBox() {
      null === this.boundingBox && (this.boundingBox = new Gt());
      var t = this.attributes.position,
          e = this.morphAttributes.position;
      if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new zt(-1 / 0, -1 / 0, -1 / 0), new zt(1 / 0, 1 / 0, 1 / 0));

      if (void 0 !== t) {
        if (this.boundingBox.setFromBufferAttribute(t), e) for (var _t59 = 0, _n49 = e.length; _t59 < _n49; _t59++) {
          var _n50 = e[_t59];
          mn.setFromBufferAttribute(_n50), this.morphTargetsRelative ? (gn.addVectors(this.boundingBox.min, mn.min), this.boundingBox.expandByPoint(gn), gn.addVectors(this.boundingBox.max, mn.max), this.boundingBox.expandByPoint(gn)) : (this.boundingBox.expandByPoint(mn.min), this.boundingBox.expandByPoint(mn.max));
        }
      } else this.boundingBox.makeEmpty();

      (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
  }, {
    key: "computeBoundingSphere",
    value: function computeBoundingSphere() {
      null === this.boundingSphere && (this.boundingSphere = new le());
      var t = this.attributes.position,
          e = this.morphAttributes.position;
      if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new zt(), 1 / 0);

      if (t) {
        var _n51 = this.boundingSphere.center;
        if (mn.setFromBufferAttribute(t), e) for (var _t60 = 0, _n52 = e.length; _t60 < _n52; _t60++) {
          var _n53 = e[_t60];
          fn.setFromBufferAttribute(_n53), this.morphTargetsRelative ? (gn.addVectors(mn.min, fn.min), mn.expandByPoint(gn), gn.addVectors(mn.max, fn.max), mn.expandByPoint(gn)) : (mn.expandByPoint(fn.min), mn.expandByPoint(fn.max));
        }
        mn.getCenter(_n51);
        var _i44 = 0;

        for (var _e43 = 0, _r31 = t.count; _e43 < _r31; _e43++) {
          gn.fromBufferAttribute(t, _e43), _i44 = Math.max(_i44, _n51.distanceToSquared(gn));
        }

        if (e) for (var _r32 = 0, _s12 = e.length; _r32 < _s12; _r32++) {
          var _s13 = e[_r32],
              _a7 = this.morphTargetsRelative;

          for (var _e44 = 0, _r33 = _s13.count; _e44 < _r33; _e44++) {
            gn.fromBufferAttribute(_s13, _e44), _a7 && (pn.fromBufferAttribute(t, _e44), gn.add(pn)), _i44 = Math.max(_i44, _n51.distanceToSquared(gn));
          }
        }
        this.boundingSphere.radius = Math.sqrt(_i44), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }, {
    key: "computeTangents",
    value: function computeTangents() {
      var t = this.index,
          e = this.attributes;
      if (null === t || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      var n = t.array,
          i = e.position.array,
          r = e.normal.array,
          s = e.uv.array,
          a = i.length / 3;
      !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new an(new Float32Array(4 * a), 4));
      var o = this.getAttribute("tangent").array,
          l = [],
          h = [];

      for (var _t61 = 0; _t61 < a; _t61++) {
        l[_t61] = new zt(), h[_t61] = new zt();
      }

      var c = new zt(),
          u = new zt(),
          d = new zt(),
          p = new mt(),
          m = new mt(),
          f = new mt(),
          g = new zt(),
          v = new zt();

      function y(t, e, n) {
        c.fromArray(i, 3 * t), u.fromArray(i, 3 * e), d.fromArray(i, 3 * n), p.fromArray(s, 2 * t), m.fromArray(s, 2 * e), f.fromArray(s, 2 * n), u.sub(c), d.sub(c), m.sub(p), f.sub(p);
        var r = 1 / (m.x * f.y - f.x * m.y);
        isFinite(r) && (g.copy(u).multiplyScalar(f.y).addScaledVector(d, -m.y).multiplyScalar(r), v.copy(d).multiplyScalar(m.x).addScaledVector(u, -f.x).multiplyScalar(r), l[t].add(g), l[e].add(g), l[n].add(g), h[t].add(v), h[e].add(v), h[n].add(v));
      }

      var x = this.groups;
      0 === x.length && (x = [{
        start: 0,
        count: n.length
      }]);

      for (var _t62 = 0, _e45 = x.length; _t62 < _e45; ++_t62) {
        var _e46 = x[_t62],
            _i45 = _e46.start;

        for (var _t63 = _i45, _r34 = _i45 + _e46.count; _t63 < _r34; _t63 += 3) {
          y(n[_t63 + 0], n[_t63 + 1], n[_t63 + 2]);
        }
      }

      var _ = new zt(),
          b = new zt(),
          w = new zt(),
          M = new zt();

      function S(t) {
        w.fromArray(r, 3 * t), M.copy(w);
        var e = l[t];
        _.copy(e), _.sub(w.multiplyScalar(w.dot(e))).normalize(), b.crossVectors(M, e);
        var n = b.dot(h[t]) < 0 ? -1 : 1;
        o[4 * t] = _.x, o[4 * t + 1] = _.y, o[4 * t + 2] = _.z, o[4 * t + 3] = n;
      }

      for (var _t64 = 0, _e47 = x.length; _t64 < _e47; ++_t64) {
        var _e48 = x[_t64],
            _i46 = _e48.start;

        for (var _t65 = _i46, _r35 = _i46 + _e48.count; _t65 < _r35; _t65 += 3) {
          S(n[_t65 + 0]), S(n[_t65 + 1]), S(n[_t65 + 2]);
        }
      }
    }
  }, {
    key: "computeVertexNormals",
    value: function computeVertexNormals() {
      var t = this.index,
          e = this.getAttribute("position");

      if (void 0 !== e) {
        var _n54 = this.getAttribute("normal");

        if (void 0 === _n54) _n54 = new an(new Float32Array(3 * e.count), 3), this.setAttribute("normal", _n54);else for (var _t66 = 0, _e49 = _n54.count; _t66 < _e49; _t66++) {
          _n54.setXYZ(_t66, 0, 0, 0);
        }

        var _i47 = new zt(),
            _r36 = new zt(),
            _s14 = new zt(),
            _a8 = new zt(),
            _o9 = new zt(),
            _l8 = new zt(),
            _h6 = new zt(),
            _c5 = new zt();

        if (t) for (var _u2 = 0, _d2 = t.count; _u2 < _d2; _u2 += 3) {
          var _d3 = t.getX(_u2 + 0),
              _p2 = t.getX(_u2 + 1),
              _m2 = t.getX(_u2 + 2);

          _i47.fromBufferAttribute(e, _d3), _r36.fromBufferAttribute(e, _p2), _s14.fromBufferAttribute(e, _m2), _h6.subVectors(_s14, _r36), _c5.subVectors(_i47, _r36), _h6.cross(_c5), _a8.fromBufferAttribute(_n54, _d3), _o9.fromBufferAttribute(_n54, _p2), _l8.fromBufferAttribute(_n54, _m2), _a8.add(_h6), _o9.add(_h6), _l8.add(_h6), _n54.setXYZ(_d3, _a8.x, _a8.y, _a8.z), _n54.setXYZ(_p2, _o9.x, _o9.y, _o9.z), _n54.setXYZ(_m2, _l8.x, _l8.y, _l8.z);
        } else for (var _t67 = 0, _a9 = e.count; _t67 < _a9; _t67 += 3) {
          _i47.fromBufferAttribute(e, _t67 + 0), _r36.fromBufferAttribute(e, _t67 + 1), _s14.fromBufferAttribute(e, _t67 + 2), _h6.subVectors(_s14, _r36), _c5.subVectors(_i47, _r36), _h6.cross(_c5), _n54.setXYZ(_t67 + 0, _h6.x, _h6.y, _h6.z), _n54.setXYZ(_t67 + 1, _h6.x, _h6.y, _h6.z), _n54.setXYZ(_t67 + 2, _h6.x, _h6.y, _h6.z);
        }
        this.normalizeNormals(), _n54.needsUpdate = !0;
      }
    }
  }, {
    key: "merge",
    value: function merge(t, e) {
      if (!t || !t.isBufferGeometry) return void console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", t);
      void 0 === e && (e = 0, console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."));
      var n = this.attributes;

      for (var _i48 in n) {
        if (void 0 === t.attributes[_i48]) continue;

        var _r37 = n[_i48].array,
            _s15 = t.attributes[_i48],
            _a10 = _s15.array,
            _o10 = _s15.itemSize * e,
            _l9 = Math.min(_a10.length, _r37.length - _o10);

        for (var _t68 = 0, _e50 = _o10; _t68 < _l9; _t68++, _e50++) {
          _r37[_e50] = _a10[_t68];
        }
      }

      return this;
    }
  }, {
    key: "normalizeNormals",
    value: function normalizeNormals() {
      var t = this.attributes.normal;

      for (var _e51 = 0, _n55 = t.count; _e51 < _n55; _e51++) {
        gn.fromBufferAttribute(t, _e51), gn.normalize(), t.setXYZ(_e51, gn.x, gn.y, gn.z);
      }
    }
  }, {
    key: "toNonIndexed",
    value: function toNonIndexed() {
      function t(t, e) {
        var n = t.array,
            i = t.itemSize,
            r = t.normalized,
            s = new n.constructor(e.length * i);
        var a = 0,
            o = 0;

        for (var _r38 = 0, _l10 = e.length; _r38 < _l10; _r38++) {
          a = t.isInterleavedBufferAttribute ? e[_r38] * t.data.stride + t.offset : e[_r38] * i;

          for (var _t69 = 0; _t69 < i; _t69++) {
            s[o++] = n[a++];
          }
        }

        return new an(s, i, r);
      }

      if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
      var e = new vn(),
          n = this.index.array,
          i = this.attributes;

      for (var _r39 in i) {
        var _s16 = t(i[_r39], n);

        e.setAttribute(_r39, _s16);
      }

      var r = this.morphAttributes;

      for (var _i49 in r) {
        var _s17 = [],
            _a11 = r[_i49];

        for (var _e52 = 0, _i50 = _a11.length; _e52 < _i50; _e52++) {
          var _i51 = t(_a11[_e52], n);

          _s17.push(_i51);
        }

        e.morphAttributes[_i49] = _s17;
      }

      e.morphTargetsRelative = this.morphTargetsRelative;
      var s = this.groups;

      for (var _t70 = 0, _n56 = s.length; _t70 < _n56; _t70++) {
        var _n57 = s[_t70];
        e.addGroup(_n57.start, _n57.count, _n57.materialIndex);
      }

      return e;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        metadata: {
          version: 4.5,
          type: "BufferGeometry",
          generator: "BufferGeometry.toJSON"
        }
      };

      if (t.uuid = this.uuid, t.type = this.type, "" !== this.name && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), void 0 !== this.parameters) {
        var _e53 = this.parameters;

        for (var _n58 in _e53) {
          void 0 !== _e53[_n58] && (t[_n58] = _e53[_n58]);
        }

        return t;
      }

      t.data = {
        attributes: {}
      };
      var e = this.index;
      null !== e && (t.data.index = {
        type: e.array.constructor.name,
        array: Array.prototype.slice.call(e.array)
      });
      var n = this.attributes;

      for (var _e54 in n) {
        var _i52 = n[_e54];
        t.data.attributes[_e54] = _i52.toJSON(t.data);
      }

      var i = {};
      var r = !1;

      for (var _e55 in this.morphAttributes) {
        var _n59 = this.morphAttributes[_e55],
            _s18 = [];

        for (var _e56 = 0, _i53 = _n59.length; _e56 < _i53; _e56++) {
          var _i54 = _n59[_e56];

          _s18.push(_i54.toJSON(t.data));
        }

        _s18.length > 0 && (i[_e55] = _s18, r = !0);
      }

      r && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
      var s = this.groups;
      s.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(s)));
      var a = this.boundingSphere;
      return null !== a && (t.data.boundingSphere = {
        center: a.center.toArray(),
        radius: a.radius
      }), t;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
      var e = {};
      this.name = t.name;
      var n = t.index;
      null !== n && this.setIndex(n.clone(e));
      var i = t.attributes;

      for (var _t71 in i) {
        var _n60 = i[_t71];
        this.setAttribute(_t71, _n60.clone(e));
      }

      var r = t.morphAttributes;

      for (var _t72 in r) {
        var _n61 = [],
            _i55 = r[_t72];

        for (var _t73 = 0, _r40 = _i55.length; _t73 < _r40; _t73++) {
          _n61.push(_i55[_t73].clone(e));
        }

        this.morphAttributes[_t72] = _n61;
      }

      this.morphTargetsRelative = t.morphTargetsRelative;
      var s = t.groups;

      for (var _t74 = 0, _e57 = s.length; _t74 < _e57; _t74++) {
        var _e58 = s[_t74];
        this.addGroup(_e58.start, _e58.count, _e58.materialIndex);
      }

      var a = t.boundingBox;
      null !== a && (this.boundingBox = a.clone());
      var o = t.boundingSphere;
      return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, void 0 !== t.parameters && (this.parameters = Object.assign({}, t.parameters)), this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }]);

  return vn;
}(et);

vn.prototype.isBufferGeometry = !0;

var yn = new ve(),
    xn = new ge(),
    _n = new le(),
    bn = new zt(),
    wn = new zt(),
    Mn = new zt(),
    Sn = new zt(),
    Tn = new zt(),
    En = new zt(),
    An = new zt(),
    Rn = new zt(),
    Cn = new zt(),
    Ln = new mt(),
    Pn = new mt(),
    Dn = new mt(),
    In = new zt(),
    On = new zt();

var Nn = /*#__PURE__*/function (_Ve) {
  _inherits(Nn, _Ve);

  var _super20 = _createSuper(Nn);

  function Nn() {
    var _this22;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new vn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new nn();

    _classCallCheck(this, Nn);

    _this22 = _super20.call(this), _this22.type = "Mesh", _this22.geometry = t, _this22.material = e, _this22.updateMorphTargets();
    return _this22;
  }

  _createClass(Nn, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Nn.prototype), "copy", this).call(this, t), void 0 !== t.morphTargetInfluences && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), void 0 !== t.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var t = this.geometry;

      if (t.isBufferGeometry) {
        var _e59 = t.morphAttributes,
            _n62 = Object.keys(_e59);

        if (_n62.length > 0) {
          var _t75 = _e59[_n62[0]];

          if (void 0 !== _t75) {
            this.morphTargetInfluences = [], this.morphTargetDictionary = {};

            for (var _e60 = 0, _n63 = _t75.length; _e60 < _n63; _e60++) {
              var _n64 = _t75[_e60].name || String(_e60);

              this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n64] = _e60;
            }
          }
        }
      } else {
        var _e61 = t.morphTargets;
        void 0 !== _e61 && _e61.length > 0 && console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.geometry,
          i = this.material,
          r = this.matrixWorld;
      if (void 0 === i) return;
      if (null === n.boundingSphere && n.computeBoundingSphere(), _n.copy(n.boundingSphere), _n.applyMatrix4(r), !1 === t.ray.intersectsSphere(_n)) return;
      if (yn.copy(r).invert(), xn.copy(t.ray).applyMatrix4(yn), null !== n.boundingBox && !1 === xn.intersectsBox(n.boundingBox)) return;
      var s;

      if (n.isBufferGeometry) {
        var _r41 = n.index,
            _a12 = n.attributes.position,
            _o11 = n.morphAttributes.position,
            _l11 = n.morphTargetsRelative,
            _h7 = n.attributes.uv,
            _c6 = n.attributes.uv2,
            _u3 = n.groups,
            _d4 = n.drawRange;
        if (null !== _r41) {
          if (Array.isArray(i)) for (var _n65 = 0, _p3 = _u3.length; _n65 < _p3; _n65++) {
            var _p4 = _u3[_n65],
                _m3 = i[_p4.materialIndex];

            for (var _n66 = Math.max(_p4.start, _d4.start), _i56 = Math.min(_r41.count, Math.min(_p4.start + _p4.count, _d4.start + _d4.count)); _n66 < _i56; _n66 += 3) {
              var _i57 = _r41.getX(_n66),
                  _u4 = _r41.getX(_n66 + 1),
                  _d5 = _r41.getX(_n66 + 2);

              s = Fn(this, _m3, t, xn, _a12, _o11, _l11, _h7, _c6, _i57, _u4, _d5), s && (s.faceIndex = Math.floor(_n66 / 3), s.face.materialIndex = _p4.materialIndex, e.push(s));
            }
          } else {
            for (var _n67 = Math.max(0, _d4.start), _u5 = Math.min(_r41.count, _d4.start + _d4.count); _n67 < _u5; _n67 += 3) {
              var _u6 = _r41.getX(_n67),
                  _d6 = _r41.getX(_n67 + 1),
                  _p5 = _r41.getX(_n67 + 2);

              s = Fn(this, i, t, xn, _a12, _o11, _l11, _h7, _c6, _u6, _d6, _p5), s && (s.faceIndex = Math.floor(_n67 / 3), e.push(s));
            }
          }
        } else if (void 0 !== _a12) if (Array.isArray(i)) for (var _n68 = 0, _r42 = _u3.length; _n68 < _r42; _n68++) {
          var _r43 = _u3[_n68],
              _p6 = i[_r43.materialIndex];

          for (var _n69 = Math.max(_r43.start, _d4.start), _i58 = Math.min(_a12.count, Math.min(_r43.start + _r43.count, _d4.start + _d4.count)); _n69 < _i58; _n69 += 3) {
            s = Fn(this, _p6, t, xn, _a12, _o11, _l11, _h7, _c6, _n69, _n69 + 1, _n69 + 2), s && (s.faceIndex = Math.floor(_n69 / 3), s.face.materialIndex = _r43.materialIndex, e.push(s));
          }
        } else {
          for (var _n70 = Math.max(0, _d4.start), _r44 = Math.min(_a12.count, _d4.start + _d4.count); _n70 < _r44; _n70 += 3) {
            s = Fn(this, i, t, xn, _a12, _o11, _l11, _h7, _c6, _n70, _n70 + 1, _n70 + 2), s && (s.faceIndex = Math.floor(_n70 / 3), e.push(s));
          }
        }
      } else n.isGeometry && console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }]);

  return Nn;
}(Ve);

function Fn(t, e, n, i, r, s, a, o, l, h, c, u) {
  bn.fromBufferAttribute(r, h), wn.fromBufferAttribute(r, c), Mn.fromBufferAttribute(r, u);
  var d = t.morphTargetInfluences;

  if (s && d) {
    An.set(0, 0, 0), Rn.set(0, 0, 0), Cn.set(0, 0, 0);

    for (var _t76 = 0, _e62 = s.length; _t76 < _e62; _t76++) {
      var _e63 = d[_t76],
          _n71 = s[_t76];
      0 !== _e63 && (Sn.fromBufferAttribute(_n71, h), Tn.fromBufferAttribute(_n71, c), En.fromBufferAttribute(_n71, u), a ? (An.addScaledVector(Sn, _e63), Rn.addScaledVector(Tn, _e63), Cn.addScaledVector(En, _e63)) : (An.addScaledVector(Sn.sub(bn), _e63), Rn.addScaledVector(Tn.sub(wn), _e63), Cn.addScaledVector(En.sub(Mn), _e63)));
    }

    bn.add(An), wn.add(Rn), Mn.add(Cn);
  }

  t.isSkinnedMesh && (t.boneTransform(h, bn), t.boneTransform(c, wn), t.boneTransform(u, Mn));

  var p = function (t, e, n, i, r, s, a, o) {
    var l;
    if (l = 1 === e.side ? i.intersectTriangle(a, s, r, !0, o) : i.intersectTriangle(r, s, a, 2 !== e.side, o), null === l) return null;
    On.copy(o), On.applyMatrix4(t.matrixWorld);
    var h = n.ray.origin.distanceTo(On);
    return h < n.near || h > n.far ? null : {
      distance: h,
      point: On.clone(),
      object: t
    };
  }(t, e, n, i, bn, wn, Mn, In);

  if (p) {
    o && (Ln.fromBufferAttribute(o, h), Pn.fromBufferAttribute(o, c), Dn.fromBufferAttribute(o, u), p.uv = Qe.getUV(In, bn, wn, Mn, Ln, Pn, Dn, new mt())), l && (Ln.fromBufferAttribute(l, h), Pn.fromBufferAttribute(l, c), Dn.fromBufferAttribute(l, u), p.uv2 = Qe.getUV(In, bn, wn, Mn, Ln, Pn, Dn, new mt()));
    var _t77 = {
      a: h,
      b: c,
      c: u,
      normal: new zt(),
      materialIndex: 0
    };
    Qe.getNormal(bn, wn, Mn, _t77.normal), p.face = _t77;
  }

  return p;
}

Nn.prototype.isMesh = !0;

var Un = /*#__PURE__*/function (_vn) {
  _inherits(Un, _vn);

  var _super21 = _createSuper(Un);

  function Un() {
    var _this23;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

    _classCallCheck(this, Un);

    _this23 = _super21.call(this), _this23.type = "BoxGeometry", _this23.parameters = {
      width: t,
      height: e,
      depth: n,
      widthSegments: i,
      heightSegments: r,
      depthSegments: s
    };

    var a = _assertThisInitialized(_this23);

    i = Math.floor(i), r = Math.floor(r), s = Math.floor(s);
    var o = [],
        l = [],
        h = [],
        c = [];
    var u = 0,
        d = 0;

    function p(t, e, n, i, r, s, p, m, f, g, v) {
      var y = s / f,
          x = p / g,
          _ = s / 2,
          b = p / 2,
          w = m / 2,
          M = f + 1,
          S = g + 1;

      var T = 0,
          E = 0;
      var A = new zt();

      for (var _s19 = 0; _s19 < S; _s19++) {
        var _a13 = _s19 * x - b;

        for (var _o12 = 0; _o12 < M; _o12++) {
          var _u7 = _o12 * y - _;

          A[t] = _u7 * i, A[e] = _a13 * r, A[n] = w, l.push(A.x, A.y, A.z), A[t] = 0, A[e] = 0, A[n] = m > 0 ? 1 : -1, h.push(A.x, A.y, A.z), c.push(_o12 / f), c.push(1 - _s19 / g), T += 1;
        }
      }

      for (var _t78 = 0; _t78 < g; _t78++) {
        for (var _e64 = 0; _e64 < f; _e64++) {
          var _n72 = u + _e64 + M * _t78,
              _i59 = u + _e64 + M * (_t78 + 1),
              _r45 = u + (_e64 + 1) + M * (_t78 + 1),
              _s20 = u + (_e64 + 1) + M * _t78;

          o.push(_n72, _i59, _s20), o.push(_i59, _r45, _s20), E += 6;
        }
      }

      a.addGroup(d, E, v), d += E, u += T;
    }

    p("z", "y", "x", -1, -1, n, e, t, s, r, 0), p("z", "y", "x", 1, -1, n, e, -t, s, r, 1), p("x", "z", "y", 1, 1, t, n, e, i, s, 2), p("x", "z", "y", 1, -1, t, n, -e, i, s, 3), p("x", "y", "z", 1, -1, t, e, n, i, r, 4), p("x", "y", "z", -1, -1, t, e, -n, i, r, 5), _this23.setIndex(o), _this23.setAttribute("position", new hn(l, 3)), _this23.setAttribute("normal", new hn(h, 3)), _this23.setAttribute("uv", new hn(c, 2));
    return _this23;
  }

  _createClass(Un, null, [{
    key: "fromJSON",
    value: function fromJSON(t) {
      return new Un(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
    }
  }]);

  return Un;
}(vn);

function kn(t) {
  var e = {};

  for (var _n73 in t) {
    e[_n73] = {};

    for (var _i60 in t[_n73]) {
      var _r46 = t[_n73][_i60];
      _r46 && (_r46.isColor || _r46.isMatrix3 || _r46.isMatrix4 || _r46.isVector2 || _r46.isVector3 || _r46.isVector4 || _r46.isTexture || _r46.isQuaternion) ? e[_n73][_i60] = _r46.clone() : Array.isArray(_r46) ? e[_n73][_i60] = _r46.slice() : e[_n73][_i60] = _r46;
    }
  }

  return e;
}

function Bn(t) {
  var e = {};

  for (var _n74 = 0; _n74 < t.length; _n74++) {
    var _i61 = kn(t[_n74]);

    for (var _t79 in _i61) {
      e[_t79] = _i61[_t79];
    }
  }

  return e;
}

var zn = {
  clone: kn,
  merge: Bn
};

var Hn = /*#__PURE__*/function (_en2) {
  _inherits(Hn, _en2);

  var _super22 = _createSuper(Hn);

  function Hn(t) {
    var _this24;

    _classCallCheck(this, Hn);

    _this24 = _super22.call(this), _this24.type = "ShaderMaterial", _this24.defines = {}, _this24.uniforms = {}, _this24.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", _this24.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", _this24.linewidth = 1, _this24.wireframe = !1, _this24.wireframeLinewidth = 1, _this24.fog = !1, _this24.lights = !1, _this24.clipping = !1, _this24.extensions = {
      derivatives: !1,
      fragDepth: !1,
      drawBuffers: !1,
      shaderTextureLOD: !1
    }, _this24.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv2: [0, 0]
    }, _this24.index0AttributeName = void 0, _this24.uniformsNeedUpdate = !1, _this24.glslVersion = null, void 0 !== t && (void 0 !== t.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), _this24.setValues(t));
    return _this24;
  }

  _createClass(Hn, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Hn.prototype), "copy", this).call(this, t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = kn(t.uniforms), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(Hn.prototype), "toJSON", this).call(this, t);

      e.glslVersion = this.glslVersion, e.uniforms = {};

      for (var _n75 in this.uniforms) {
        var _i62 = this.uniforms[_n75].value;
        _i62 && _i62.isTexture ? e.uniforms[_n75] = {
          type: "t",
          value: _i62.toJSON(t).uuid
        } : _i62 && _i62.isColor ? e.uniforms[_n75] = {
          type: "c",
          value: _i62.getHex()
        } : _i62 && _i62.isVector2 ? e.uniforms[_n75] = {
          type: "v2",
          value: _i62.toArray()
        } : _i62 && _i62.isVector3 ? e.uniforms[_n75] = {
          type: "v3",
          value: _i62.toArray()
        } : _i62 && _i62.isVector4 ? e.uniforms[_n75] = {
          type: "v4",
          value: _i62.toArray()
        } : _i62 && _i62.isMatrix3 ? e.uniforms[_n75] = {
          type: "m3",
          value: _i62.toArray()
        } : _i62 && _i62.isMatrix4 ? e.uniforms[_n75] = {
          type: "m4",
          value: _i62.toArray()
        } : e.uniforms[_n75] = {
          value: _i62
        };
      }

      Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
      var n = {};

      for (var _t80 in this.extensions) {
        !0 === this.extensions[_t80] && (n[_t80] = !0);
      }

      return Object.keys(n).length > 0 && (e.extensions = n), e;
    }
  }]);

  return Hn;
}(en);

Hn.prototype.isShaderMaterial = !0;

var Vn = /*#__PURE__*/function (_Ve2) {
  _inherits(Vn, _Ve2);

  var _super23 = _createSuper(Vn);

  function Vn() {
    var _this25;

    _classCallCheck(this, Vn);

    _this25 = _super23.call(this), _this25.type = "Camera", _this25.matrixWorldInverse = new ve(), _this25.projectionMatrix = new ve(), _this25.projectionMatrixInverse = new ve();
    return _this25;
  }

  _createClass(Vn, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(Vn.prototype), "copy", this).call(this, t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this;
    }
  }, {
    key: "getWorldDirection",
    value: function getWorldDirection(t) {
      this.updateWorldMatrix(!0, !1);
      var e = this.matrixWorld.elements;
      return t.set(-e[8], -e[9], -e[10]).normalize();
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      _get(_getPrototypeOf(Vn.prototype), "updateMatrixWorld", this).call(this, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
  }, {
    key: "updateWorldMatrix",
    value: function updateWorldMatrix(t, e) {
      _get(_getPrototypeOf(Vn.prototype), "updateWorldMatrix", this).call(this, t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Vn;
}(Ve);

Vn.prototype.isCamera = !0;

var Gn = /*#__PURE__*/function (_Vn) {
  _inherits(Gn, _Vn);

  var _super24 = _createSuper(Gn);

  function Gn() {
    var _this26;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2e3;

    _classCallCheck(this, Gn);

    _this26 = _super24.call(this), _this26.type = "PerspectiveCamera", _this26.fov = t, _this26.zoom = 1, _this26.near = n, _this26.far = i, _this26.focus = 10, _this26.aspect = e, _this26.view = null, _this26.filmGauge = 35, _this26.filmOffset = 0, _this26.updateProjectionMatrix();
    return _this26;
  }

  _createClass(Gn, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(Gn.prototype), "copy", this).call(this, t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = null === t.view ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }
  }, {
    key: "setFocalLength",
    value: function setFocalLength(t) {
      var e = .5 * this.getFilmHeight() / t;
      this.fov = 2 * st * Math.atan(e), this.updateProjectionMatrix();
    }
  }, {
    key: "getFocalLength",
    value: function getFocalLength() {
      var t = Math.tan(.5 * rt * this.fov);
      return .5 * this.getFilmHeight() / t;
    }
  }, {
    key: "getEffectiveFOV",
    value: function getEffectiveFOV() {
      return 2 * st * Math.atan(Math.tan(.5 * rt * this.fov) / this.zoom);
    }
  }, {
    key: "getFilmWidth",
    value: function getFilmWidth() {
      return this.filmGauge * Math.min(this.aspect, 1);
    }
  }, {
    key: "getFilmHeight",
    value: function getFilmHeight() {
      return this.filmGauge / Math.max(this.aspect, 1);
    }
  }, {
    key: "setViewOffset",
    value: function setViewOffset(t, e, n, i, r, s) {
      this.aspect = t / e, null === this.view && (this.view = {
        enabled: !0,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
    }
  }, {
    key: "clearViewOffset",
    value: function clearViewOffset() {
      null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
  }, {
    key: "updateProjectionMatrix",
    value: function updateProjectionMatrix() {
      var t = this.near;
      var e = t * Math.tan(.5 * rt * this.fov) / this.zoom,
          n = 2 * e,
          i = this.aspect * n,
          r = -.5 * i;
      var s = this.view;

      if (null !== this.view && this.view.enabled) {
        var _t81 = s.fullWidth,
            _a14 = s.fullHeight;
        r += s.offsetX * i / _t81, e -= s.offsetY * n / _a14, i *= s.width / _t81, n *= s.height / _a14;
      }

      var a = this.filmOffset;
      0 !== a && (r += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, e, e - n, t, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(Gn.prototype), "toJSON", this).call(this, t);

      return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
  }]);

  return Gn;
}(Vn);

Gn.prototype.isPerspectiveCamera = !0;

var Wn = /*#__PURE__*/function (_Ve3) {
  _inherits(Wn, _Ve3);

  var _super25 = _createSuper(Wn);

  function Wn(t, e, n) {
    var _this27;

    _classCallCheck(this, Wn);

    if (_this27 = _super25.call(this), _this27.type = "CubeCamera", !0 !== n.isWebGLCubeRenderTarget) return _possibleConstructorReturn(_this27, void console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter."));
    _this27.renderTarget = n;
    var i = new Gn(90, 1, t, e);
    i.layers = _this27.layers, i.up.set(0, -1, 0), i.lookAt(new zt(1, 0, 0)), _this27.add(i);
    var r = new Gn(90, 1, t, e);
    r.layers = _this27.layers, r.up.set(0, -1, 0), r.lookAt(new zt(-1, 0, 0)), _this27.add(r);
    var s = new Gn(90, 1, t, e);
    s.layers = _this27.layers, s.up.set(0, 0, 1), s.lookAt(new zt(0, 1, 0)), _this27.add(s);
    var a = new Gn(90, 1, t, e);
    a.layers = _this27.layers, a.up.set(0, 0, -1), a.lookAt(new zt(0, -1, 0)), _this27.add(a);
    var o = new Gn(90, 1, t, e);
    o.layers = _this27.layers, o.up.set(0, -1, 0), o.lookAt(new zt(0, 0, 1)), _this27.add(o);
    var l = new Gn(90, 1, t, e);
    l.layers = _this27.layers, l.up.set(0, -1, 0), l.lookAt(new zt(0, 0, -1)), _this27.add(l);
    return _possibleConstructorReturn(_this27);
  }

  _createClass(Wn, [{
    key: "update",
    value: function update(t, e) {
      null === this.parent && this.updateMatrixWorld();

      var n = this.renderTarget,
          _this$children = _slicedToArray(this.children, 6),
          i = _this$children[0],
          r = _this$children[1],
          s = _this$children[2],
          a = _this$children[3],
          o = _this$children[4],
          l = _this$children[5],
          h = t.getRenderTarget(),
          c = t.outputEncoding,
          u = t.toneMapping,
          d = t.xr.enabled;

      t.outputEncoding = 3e3, t.toneMapping = 0, t.xr.enabled = !1;
      var p = n.texture.generateMipmaps;
      n.texture.generateMipmaps = !1, t.setRenderTarget(n, 0), t.render(e, i), t.setRenderTarget(n, 1), t.render(e, r), t.setRenderTarget(n, 2), t.render(e, s), t.setRenderTarget(n, 3), t.render(e, a), t.setRenderTarget(n, 4), t.render(e, o), n.texture.generateMipmaps = p, t.setRenderTarget(n, 5), t.render(e, l), t.setRenderTarget(h), t.outputEncoding = c, t.toneMapping = u, t.xr.enabled = d, n.texture.needsPMREMUpdate = !0;
    }
  }]);

  return Wn;
}(Ve);

var jn = /*#__PURE__*/function (_Ot3) {
  _inherits(jn, _Ot3);

  var _super26 = _createSuper(jn);

  function jn(t, e, n, i, r, s, a, o, l, h) {
    var _this28;

    _classCallCheck(this, jn);

    _this28 = _super26.call(this, t = void 0 !== t ? t : [], e = void 0 !== e ? e : 301, n, i, r, s, a, o, l, h), _this28.flipY = !1;
    return _this28;
  }

  _createClass(jn, [{
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(t) {
      this.image = t;
    }
  }]);

  return jn;
}(Ot);

jn.prototype.isCubeTexture = !0;

var qn = /*#__PURE__*/function (_Ft4) {
  _inherits(qn, _Ft4);

  var _super27 = _createSuper(qn);

  function qn(t) {
    var _this29;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, qn);

    _this29 = _super27.call(this, t, t, e);
    var n = {
      width: t,
      height: t,
      depth: 1
    },
        i = [n, n, n, n, n, n];
    _this29.texture = new jn(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), _this29.texture.isRenderTargetTexture = !0, _this29.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, _this29.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : 1006;
    return _this29;
  }

  _createClass(qn, [{
    key: "fromEquirectangularTexture",
    value: function fromEquirectangularTexture(t, e) {
      this.texture.type = e.type, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
      var n = {
        uniforms: {
          tEquirect: {
            value: null
          }
        },
        vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
        fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
      },
          i = new Un(5, 5, 5),
          r = new Hn({
        name: "CubemapFromEquirect",
        uniforms: kn(n.uniforms),
        vertexShader: n.vertexShader,
        fragmentShader: n.fragmentShader,
        side: 1,
        blending: 0
      });
      r.uniforms.tEquirect.value = e;
      var s = new Nn(i, r),
          a = e.minFilter;
      1008 === e.minFilter && (e.minFilter = 1006);
      return new Wn(1, 10, this).update(t, s), e.minFilter = a, s.geometry.dispose(), s.material.dispose(), this;
    }
  }, {
    key: "clear",
    value: function clear(t, e, n, i) {
      var r = t.getRenderTarget();

      for (var _r47 = 0; _r47 < 6; _r47++) {
        t.setRenderTarget(this, _r47), t.clear(e, n, i);
      }

      t.setRenderTarget(r);
    }
  }]);

  return qn;
}(Ft);

qn.prototype.isWebGLCubeRenderTarget = !0;
var Xn = new zt(),
    Yn = new zt(),
    Jn = new ft();

var Zn = /*#__PURE__*/function () {
  function Zn() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt(1, 0, 0);
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Zn);

    this.normal = t, this.constant = e;
  }

  _createClass(Zn, [{
    key: "set",
    value: function set(t, e) {
      return this.normal.copy(t), this.constant = e, this;
    }
  }, {
    key: "setComponents",
    value: function setComponents(t, e, n, i) {
      return this.normal.set(t, e, n), this.constant = i, this;
    }
  }, {
    key: "setFromNormalAndCoplanarPoint",
    value: function setFromNormalAndCoplanarPoint(t, e) {
      return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
  }, {
    key: "setFromCoplanarPoints",
    value: function setFromCoplanarPoints(t, e, n) {
      var i = Xn.subVectors(n, e).cross(Yn.subVectors(t, e)).normalize();
      return this.setFromNormalAndCoplanarPoint(i, t), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var t = 1 / this.normal.length();
      return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.constant *= -1, this.normal.negate(), this;
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return this.normal.dot(t) + this.constant;
    }
  }, {
    key: "distanceToSphere",
    value: function distanceToSphere(t) {
      return this.distanceToPoint(t.center) - t.radius;
    }
  }, {
    key: "projectPoint",
    value: function projectPoint(t, e) {
      return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t);
    }
  }, {
    key: "intersectLine",
    value: function intersectLine(t, e) {
      var n = t.delta(Xn),
          i = this.normal.dot(n);
      if (0 === i) return 0 === this.distanceToPoint(t.start) ? e.copy(t.start) : null;
      var r = -(t.start.dot(this.normal) + this.constant) / i;
      return r < 0 || r > 1 ? null : e.copy(n).multiplyScalar(r).add(t.start);
    }
  }, {
    key: "intersectsLine",
    value: function intersectsLine(t) {
      var e = this.distanceToPoint(t.start),
          n = this.distanceToPoint(t.end);
      return e < 0 && n > 0 || n < 0 && e > 0;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return t.intersectsPlane(this);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      return t.intersectsPlane(this);
    }
  }, {
    key: "coplanarPoint",
    value: function coplanarPoint(t) {
      return t.copy(this.normal).multiplyScalar(-this.constant);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t, e) {
      var n = e || Jn.getNormalMatrix(t),
          i = this.coplanarPoint(Xn).applyMatrix4(t),
          r = this.normal.applyMatrix3(n).normalize();
      return this.constant = -i.dot(r), this;
    }
  }, {
    key: "translate",
    value: function translate(t) {
      return this.constant -= t.dot(this.normal), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.normal.equals(this.normal) && t.constant === this.constant;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Zn;
}();

Zn.prototype.isPlane = !0;
var $n = new le(),
    Kn = new zt();

var Qn = /*#__PURE__*/function () {
  function Qn() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Zn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Zn();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Zn();
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Zn();
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Zn();
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Zn();

    _classCallCheck(this, Qn);

    this.planes = [t, e, n, i, r, s];
  }

  _createClass(Qn, [{
    key: "set",
    value: function set(t, e, n, i, r, s) {
      var a = this.planes;
      return a[0].copy(t), a[1].copy(e), a[2].copy(n), a[3].copy(i), a[4].copy(r), a[5].copy(s), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = this.planes;

      for (var _n76 = 0; _n76 < 6; _n76++) {
        e[_n76].copy(t.planes[_n76]);
      }

      return this;
    }
  }, {
    key: "setFromProjectionMatrix",
    value: function setFromProjectionMatrix(t) {
      var e = this.planes,
          n = t.elements,
          i = n[0],
          r = n[1],
          s = n[2],
          a = n[3],
          o = n[4],
          l = n[5],
          h = n[6],
          c = n[7],
          u = n[8],
          d = n[9],
          p = n[10],
          m = n[11],
          f = n[12],
          g = n[13],
          v = n[14],
          y = n[15];
      return e[0].setComponents(a - i, c - o, m - u, y - f).normalize(), e[1].setComponents(a + i, c + o, m + u, y + f).normalize(), e[2].setComponents(a + r, c + l, m + d, y + g).normalize(), e[3].setComponents(a - r, c - l, m - d, y - g).normalize(), e[4].setComponents(a - s, c - h, m - p, y - v).normalize(), e[5].setComponents(a + s, c + h, m + p, y + v).normalize(), this;
    }
  }, {
    key: "intersectsObject",
    value: function intersectsObject(t) {
      var e = t.geometry;
      return null === e.boundingSphere && e.computeBoundingSphere(), $n.copy(e.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere($n);
    }
  }, {
    key: "intersectsSprite",
    value: function intersectsSprite(t) {
      return $n.center.set(0, 0, 0), $n.radius = .7071067811865476, $n.applyMatrix4(t.matrixWorld), this.intersectsSphere($n);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      var e = this.planes,
          n = t.center,
          i = -t.radius;

      for (var _t82 = 0; _t82 < 6; _t82++) {
        if (e[_t82].distanceToPoint(n) < i) return !1;
      }

      return !0;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      var e = this.planes;

      for (var _n77 = 0; _n77 < 6; _n77++) {
        var _i63 = e[_n77];
        if (Kn.x = _i63.normal.x > 0 ? t.max.x : t.min.x, Kn.y = _i63.normal.y > 0 ? t.max.y : t.min.y, Kn.z = _i63.normal.z > 0 ? t.max.z : t.min.z, _i63.distanceToPoint(Kn) < 0) return !1;
      }

      return !0;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      var e = this.planes;

      for (var _n78 = 0; _n78 < 6; _n78++) {
        if (e[_n78].distanceToPoint(t) < 0) return !1;
      }

      return !0;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Qn;
}();

function ti() {
  var t = null,
      e = !1,
      n = null,
      i = null;

  function r(e, s) {
    n(e, s), i = t.requestAnimationFrame(r);
  }

  return {
    start: function start() {
      !0 !== e && null !== n && (i = t.requestAnimationFrame(r), e = !0);
    },
    stop: function stop() {
      t.cancelAnimationFrame(i), e = !1;
    },
    setAnimationLoop: function setAnimationLoop(t) {
      n = t;
    },
    setContext: function setContext(e) {
      t = e;
    }
  };
}

function ei(t, e) {
  var n = e.isWebGL2,
      i = new WeakMap();
  return {
    get: function get(t) {
      return t.isInterleavedBufferAttribute && (t = t.data), i.get(t);
    },
    remove: function remove(e) {
      e.isInterleavedBufferAttribute && (e = e.data);
      var n = i.get(e);
      n && (t.deleteBuffer(n.buffer), i.delete(e));
    },
    update: function update(e, r) {
      if (e.isGLBufferAttribute) {
        var _t83 = i.get(e);

        return void ((!_t83 || _t83.version < e.version) && i.set(e, {
          buffer: e.buffer,
          type: e.type,
          bytesPerElement: e.elementSize,
          version: e.version
        }));
      }

      e.isInterleavedBufferAttribute && (e = e.data);
      var s = i.get(e);
      void 0 === s ? i.set(e, function (e, i) {
        var r = e.array,
            s = e.usage,
            a = t.createBuffer();
        var o;
        if (t.bindBuffer(i, a), t.bufferData(i, r, s), e.onUploadCallback(), r instanceof Float32Array) o = 5126;else if (r instanceof Uint16Array) {
          if (e.isFloat16BufferAttribute) {
            if (!n) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            o = 5131;
          } else o = 5123;
        } else if (r instanceof Int16Array) o = 5122;else if (r instanceof Uint32Array) o = 5125;else if (r instanceof Int32Array) o = 5124;else if (r instanceof Int8Array) o = 5120;else if (r instanceof Uint8Array) o = 5121;else {
          if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
          o = 5121;
        }
        return {
          buffer: a,
          type: o,
          bytesPerElement: r.BYTES_PER_ELEMENT,
          version: e.version
        };
      }(e, r)) : s.version < e.version && (!function (e, i, r) {
        var s = i.array,
            a = i.updateRange;
        t.bindBuffer(r, e), -1 === a.count ? t.bufferSubData(r, 0, s) : (n ? t.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s, a.offset, a.count) : t.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s.subarray(a.offset, a.offset + a.count)), a.count = -1);
      }(s.buffer, e, r), s.version = e.version);
    }
  };
}

var ni = /*#__PURE__*/function (_vn2) {
  _inherits(ni, _vn2);

  var _super28 = _createSuper(ni);

  function ni() {
    var _this30;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, ni);

    _this30 = _super28.call(this), _this30.type = "PlaneGeometry", _this30.parameters = {
      width: t,
      height: e,
      widthSegments: n,
      heightSegments: i
    };
    var r = t / 2,
        s = e / 2,
        a = Math.floor(n),
        o = Math.floor(i),
        l = a + 1,
        h = o + 1,
        c = t / a,
        u = e / o,
        d = [],
        p = [],
        m = [],
        f = [];

    for (var _t84 = 0; _t84 < h; _t84++) {
      var _e65 = _t84 * u - s;

      for (var _n79 = 0; _n79 < l; _n79++) {
        var _i64 = _n79 * c - r;

        p.push(_i64, -_e65, 0), m.push(0, 0, 1), f.push(_n79 / a), f.push(1 - _t84 / o);
      }
    }

    for (var _t85 = 0; _t85 < o; _t85++) {
      for (var _e66 = 0; _e66 < a; _e66++) {
        var _n80 = _e66 + l * _t85,
            _i65 = _e66 + l * (_t85 + 1),
            _r48 = _e66 + 1 + l * (_t85 + 1),
            _s21 = _e66 + 1 + l * _t85;

        d.push(_n80, _i65, _s21), d.push(_i65, _r48, _s21);
      }
    }

    _this30.setIndex(d), _this30.setAttribute("position", new hn(p, 3)), _this30.setAttribute("normal", new hn(m, 3)), _this30.setAttribute("uv", new hn(f, 2));
    return _this30;
  }

  _createClass(ni, null, [{
    key: "fromJSON",
    value: function fromJSON(t) {
      return new ni(t.width, t.height, t.widthSegments, t.heightSegments);
    }
  }]);

  return ni;
}(vn);

var ii = {
  alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif",
  alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
  alphatest_fragment: "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif",
  alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
  aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
  aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
  begin_vertex: "vec3 transformed = vec3( position );",
  beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
  bsdfs: "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif",
  bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
  clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif",
  clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
  clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
  clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
  color_fragment: "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
  color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
  color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif",
  color_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif",
  common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}",
  cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 ) + 0.5;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
  defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
  displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
  displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif",
  emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
  emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
  encodings_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
  encodings_pars_fragment: "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
  envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
  envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
  envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
  envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
  envmap_physical_pars_fragment: "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif",
  envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
  fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
  fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
  fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
  fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
  gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}",
  lightmap_fragment: "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
  lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
  lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointLightInfo( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotLightInfo( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif",
  lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
  lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
  lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)",
  lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
  lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)",
  lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARCOLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n\t#endif\n#endif",
  lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\tvec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
  lights_fragment_begin: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
  lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
  lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif",
  logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
  logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
  logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif",
  logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif",
  map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
  map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
  map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
  map_particle_pars_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
  metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
  metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
  morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
  morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif",
  morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif",
  morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif",
  normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;",
  normal_fragment_maps: "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
  normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
  normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
  normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
  normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif",
  clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif",
  clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif",
  clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif",
  output_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
  packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}",
  premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
  project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
  dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
  dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
  roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
  roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
  shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif",
  shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
  shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif",
  shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
  skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
  skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif",
  skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
  skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
  specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
  specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
  tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
  tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
  transmission_fragment: "#ifdef USE_TRANSMISSION\n\tfloat transmissionAlpha = 1.0;\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n\ttransmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif",
  transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef texture2DLodEXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( attenuationDistance == 0.0 ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif",
  uv_pars_fragment: "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif",
  uv_pars_vertex: "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif",
  uv_vertex: "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif",
  uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
  uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif",
  uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif",
  worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
  background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
  background_frag: "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tgl_FragColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tgl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );\n\t#endif\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
  cube_frag: "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
  depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}",
  distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
  distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
  equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
  equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
  linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
  meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
  meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
  meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
  meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
  meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
  meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
  points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
  shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
  sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
  sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}"
},
    ri = {
  common: {
    diffuse: {
      value: new Rt(16777215)
    },
    opacity: {
      value: 1
    },
    map: {
      value: null
    },
    uvTransform: {
      value: new ft()
    },
    uv2Transform: {
      value: new ft()
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    }
  },
  specularmap: {
    specularMap: {
      value: null
    }
  },
  envmap: {
    envMap: {
      value: null
    },
    flipEnvMap: {
      value: -1
    },
    reflectivity: {
      value: 1
    },
    ior: {
      value: 1.5
    },
    refractionRatio: {
      value: .98
    }
  },
  aomap: {
    aoMap: {
      value: null
    },
    aoMapIntensity: {
      value: 1
    }
  },
  lightmap: {
    lightMap: {
      value: null
    },
    lightMapIntensity: {
      value: 1
    }
  },
  emissivemap: {
    emissiveMap: {
      value: null
    }
  },
  bumpmap: {
    bumpMap: {
      value: null
    },
    bumpScale: {
      value: 1
    }
  },
  normalmap: {
    normalMap: {
      value: null
    },
    normalScale: {
      value: new mt(1, 1)
    }
  },
  displacementmap: {
    displacementMap: {
      value: null
    },
    displacementScale: {
      value: 1
    },
    displacementBias: {
      value: 0
    }
  },
  roughnessmap: {
    roughnessMap: {
      value: null
    }
  },
  metalnessmap: {
    metalnessMap: {
      value: null
    }
  },
  gradientmap: {
    gradientMap: {
      value: null
    }
  },
  fog: {
    fogDensity: {
      value: 25e-5
    },
    fogNear: {
      value: 1
    },
    fogFar: {
      value: 2e3
    },
    fogColor: {
      value: new Rt(16777215)
    }
  },
  lights: {
    ambientLightColor: {
      value: []
    },
    lightProbe: {
      value: []
    },
    directionalLights: {
      value: [],
      properties: {
        direction: {},
        color: {}
      }
    },
    directionalLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    directionalShadowMap: {
      value: []
    },
    directionalShadowMatrix: {
      value: []
    },
    spotLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        direction: {},
        distance: {},
        coneCos: {},
        penumbraCos: {},
        decay: {}
      }
    },
    spotLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    spotShadowMap: {
      value: []
    },
    spotShadowMatrix: {
      value: []
    },
    pointLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        decay: {},
        distance: {}
      }
    },
    pointLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {},
        shadowCameraNear: {},
        shadowCameraFar: {}
      }
    },
    pointShadowMap: {
      value: []
    },
    pointShadowMatrix: {
      value: []
    },
    hemisphereLights: {
      value: [],
      properties: {
        direction: {},
        skyColor: {},
        groundColor: {}
      }
    },
    rectAreaLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        width: {},
        height: {}
      }
    },
    ltc_1: {
      value: null
    },
    ltc_2: {
      value: null
    }
  },
  points: {
    diffuse: {
      value: new Rt(16777215)
    },
    opacity: {
      value: 1
    },
    size: {
      value: 1
    },
    scale: {
      value: 1
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    },
    uvTransform: {
      value: new ft()
    }
  },
  sprite: {
    diffuse: {
      value: new Rt(16777215)
    },
    opacity: {
      value: 1
    },
    center: {
      value: new mt(.5, .5)
    },
    rotation: {
      value: 0
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    },
    uvTransform: {
      value: new ft()
    }
  }
},
    si = {
  basic: {
    uniforms: Bn([ri.common, ri.specularmap, ri.envmap, ri.aomap, ri.lightmap, ri.fog]),
    vertexShader: ii.meshbasic_vert,
    fragmentShader: ii.meshbasic_frag
  },
  lambert: {
    uniforms: Bn([ri.common, ri.specularmap, ri.envmap, ri.aomap, ri.lightmap, ri.emissivemap, ri.fog, ri.lights, {
      emissive: {
        value: new Rt(0)
      }
    }]),
    vertexShader: ii.meshlambert_vert,
    fragmentShader: ii.meshlambert_frag
  },
  phong: {
    uniforms: Bn([ri.common, ri.specularmap, ri.envmap, ri.aomap, ri.lightmap, ri.emissivemap, ri.bumpmap, ri.normalmap, ri.displacementmap, ri.fog, ri.lights, {
      emissive: {
        value: new Rt(0)
      },
      specular: {
        value: new Rt(1118481)
      },
      shininess: {
        value: 30
      }
    }]),
    vertexShader: ii.meshphong_vert,
    fragmentShader: ii.meshphong_frag
  },
  standard: {
    uniforms: Bn([ri.common, ri.envmap, ri.aomap, ri.lightmap, ri.emissivemap, ri.bumpmap, ri.normalmap, ri.displacementmap, ri.roughnessmap, ri.metalnessmap, ri.fog, ri.lights, {
      emissive: {
        value: new Rt(0)
      },
      roughness: {
        value: 1
      },
      metalness: {
        value: 0
      },
      envMapIntensity: {
        value: 1
      }
    }]),
    vertexShader: ii.meshphysical_vert,
    fragmentShader: ii.meshphysical_frag
  },
  toon: {
    uniforms: Bn([ri.common, ri.aomap, ri.lightmap, ri.emissivemap, ri.bumpmap, ri.normalmap, ri.displacementmap, ri.gradientmap, ri.fog, ri.lights, {
      emissive: {
        value: new Rt(0)
      }
    }]),
    vertexShader: ii.meshtoon_vert,
    fragmentShader: ii.meshtoon_frag
  },
  matcap: {
    uniforms: Bn([ri.common, ri.bumpmap, ri.normalmap, ri.displacementmap, ri.fog, {
      matcap: {
        value: null
      }
    }]),
    vertexShader: ii.meshmatcap_vert,
    fragmentShader: ii.meshmatcap_frag
  },
  points: {
    uniforms: Bn([ri.points, ri.fog]),
    vertexShader: ii.points_vert,
    fragmentShader: ii.points_frag
  },
  dashed: {
    uniforms: Bn([ri.common, ri.fog, {
      scale: {
        value: 1
      },
      dashSize: {
        value: 1
      },
      totalSize: {
        value: 2
      }
    }]),
    vertexShader: ii.linedashed_vert,
    fragmentShader: ii.linedashed_frag
  },
  depth: {
    uniforms: Bn([ri.common, ri.displacementmap]),
    vertexShader: ii.depth_vert,
    fragmentShader: ii.depth_frag
  },
  normal: {
    uniforms: Bn([ri.common, ri.bumpmap, ri.normalmap, ri.displacementmap, {
      opacity: {
        value: 1
      }
    }]),
    vertexShader: ii.meshnormal_vert,
    fragmentShader: ii.meshnormal_frag
  },
  sprite: {
    uniforms: Bn([ri.sprite, ri.fog]),
    vertexShader: ii.sprite_vert,
    fragmentShader: ii.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: {
        value: new ft()
      },
      t2D: {
        value: null
      }
    },
    vertexShader: ii.background_vert,
    fragmentShader: ii.background_frag
  },
  cube: {
    uniforms: Bn([ri.envmap, {
      opacity: {
        value: 1
      }
    }]),
    vertexShader: ii.cube_vert,
    fragmentShader: ii.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: {
        value: null
      }
    },
    vertexShader: ii.equirect_vert,
    fragmentShader: ii.equirect_frag
  },
  distanceRGBA: {
    uniforms: Bn([ri.common, ri.displacementmap, {
      referencePosition: {
        value: new zt()
      },
      nearDistance: {
        value: 1
      },
      farDistance: {
        value: 1e3
      }
    }]),
    vertexShader: ii.distanceRGBA_vert,
    fragmentShader: ii.distanceRGBA_frag
  },
  shadow: {
    uniforms: Bn([ri.lights, ri.fog, {
      color: {
        value: new Rt(0)
      },
      opacity: {
        value: 1
      }
    }]),
    vertexShader: ii.shadow_vert,
    fragmentShader: ii.shadow_frag
  }
};

function ai(t, e, n, i, r, s) {
  var a = new Rt(0);
  var o,
      l,
      h = !0 === r ? 0 : 1,
      c = null,
      u = 0,
      d = null;

  function p(t, e) {
    n.buffers.color.setClear(t.r, t.g, t.b, e, s);
  }

  return {
    getClearColor: function getClearColor() {
      return a;
    },
    setClearColor: function setClearColor(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      a.set(t), h = e, p(a, h);
    },
    getClearAlpha: function getClearAlpha() {
      return h;
    },
    setClearAlpha: function setClearAlpha(t) {
      h = t, p(a, h);
    },
    render: function render(n, r) {
      var s = !1,
          m = !0 === r.isScene ? r.background : null;
      m && m.isTexture && (m = e.get(m));
      var f = t.xr,
          g = f.getSession && f.getSession();
      g && "additive" === g.environmentBlendMode && (m = null), null === m ? p(a, h) : m && m.isColor && (p(m, 1), s = !0), (t.autoClear || s) && t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil), m && (m.isCubeTexture || 306 === m.mapping) ? (void 0 === l && (l = new Nn(new Un(1, 1, 1), new Hn({
        name: "BackgroundCubeMaterial",
        uniforms: kn(si.cube.uniforms),
        vertexShader: si.cube.vertexShader,
        fragmentShader: si.cube.fragmentShader,
        side: 1,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function (t, e, n) {
        this.matrixWorld.copyPosition(n.matrixWorld);
      }, Object.defineProperty(l.material, "envMap", {
        get: function get() {
          return this.uniforms.envMap.value;
        }
      }), i.update(l)), l.material.uniforms.envMap.value = m, l.material.uniforms.flipEnvMap.value = m.isCubeTexture && !1 === m.isRenderTargetTexture ? -1 : 1, c === m && u === m.version && d === t.toneMapping || (l.material.needsUpdate = !0, c = m, u = m.version, d = t.toneMapping), n.unshift(l, l.geometry, l.material, 0, 0, null)) : m && m.isTexture && (void 0 === o && (o = new Nn(new ni(2, 2), new Hn({
        name: "BackgroundMaterial",
        uniforms: kn(si.background.uniforms),
        vertexShader: si.background.vertexShader,
        fragmentShader: si.background.fragmentShader,
        side: 0,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })), o.geometry.deleteAttribute("normal"), Object.defineProperty(o.material, "map", {
        get: function get() {
          return this.uniforms.t2D.value;
        }
      }), i.update(o)), o.material.uniforms.t2D.value = m, !0 === m.matrixAutoUpdate && m.updateMatrix(), o.material.uniforms.uvTransform.value.copy(m.matrix), c === m && u === m.version && d === t.toneMapping || (o.material.needsUpdate = !0, c = m, u = m.version, d = t.toneMapping), n.unshift(o, o.geometry, o.material, 0, 0, null));
    }
  };
}

function oi(t, e, n, i) {
  var r = t.getParameter(34921),
      s = i.isWebGL2 ? null : e.get("OES_vertex_array_object"),
      a = i.isWebGL2 || null !== s,
      o = {},
      l = p(null);
  var h = l,
      c = !1;

  function u(e) {
    return i.isWebGL2 ? t.bindVertexArray(e) : s.bindVertexArrayOES(e);
  }

  function d(e) {
    return i.isWebGL2 ? t.deleteVertexArray(e) : s.deleteVertexArrayOES(e);
  }

  function p(t) {
    var e = [],
        n = [],
        i = [];

    for (var _t86 = 0; _t86 < r; _t86++) {
      e[_t86] = 0, n[_t86] = 0, i[_t86] = 0;
    }

    return {
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: e,
      enabledAttributes: n,
      attributeDivisors: i,
      object: t,
      attributes: {},
      index: null
    };
  }

  function m() {
    var t = h.newAttributes;

    for (var _e67 = 0, _n81 = t.length; _e67 < _n81; _e67++) {
      t[_e67] = 0;
    }
  }

  function f(t) {
    g(t, 0);
  }

  function g(n, r) {
    var s = h.newAttributes,
        a = h.enabledAttributes,
        o = h.attributeDivisors;

    if (s[n] = 1, 0 === a[n] && (t.enableVertexAttribArray(n), a[n] = 1), o[n] !== r) {
      (i.isWebGL2 ? t : e.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), o[n] = r;
    }
  }

  function v() {
    var e = h.newAttributes,
        n = h.enabledAttributes;

    for (var _i66 = 0, _r49 = n.length; _i66 < _r49; _i66++) {
      n[_i66] !== e[_i66] && (t.disableVertexAttribArray(_i66), n[_i66] = 0);
    }
  }

  function y(e, n, r, s, a, o) {
    !0 !== i.isWebGL2 || 5124 !== r && 5125 !== r ? t.vertexAttribPointer(e, n, r, s, a, o) : t.vertexAttribIPointer(e, n, r, a, o);
  }

  function x() {
    _(), c = !0, h !== l && (h = l, u(h.object));
  }

  function _() {
    l.geometry = null, l.program = null, l.wireframe = !1;
  }

  return {
    setup: function setup(r, l, d, x, _) {
      var b = !1;

      if (a) {
        var _e68 = function (e, n, r) {
          var a = !0 === r.wireframe;
          var l = o[e.id];
          void 0 === l && (l = {}, o[e.id] = l);
          var h = l[n.id];
          void 0 === h && (h = {}, l[n.id] = h);
          var c = h[a];
          void 0 === c && (c = p(i.isWebGL2 ? t.createVertexArray() : s.createVertexArrayOES()), h[a] = c);
          return c;
        }(x, d, l);

        h !== _e68 && (h = _e68, u(h.object)), b = function (t, e) {
          var n = h.attributes,
              i = t.attributes;
          var r = 0;

          for (var _t87 in i) {
            var _e69 = n[_t87],
                _s22 = i[_t87];
            if (void 0 === _e69) return !0;
            if (_e69.attribute !== _s22) return !0;
            if (_e69.data !== _s22.data) return !0;
            r++;
          }

          return h.attributesNum !== r || h.index !== e;
        }(x, _), b && function (t, e) {
          var n = {},
              i = t.attributes;
          var r = 0;

          for (var _t88 in i) {
            var _e70 = i[_t88],
                _s23 = {};
            _s23.attribute = _e70, _e70.data && (_s23.data = _e70.data), n[_t88] = _s23, r++;
          }

          h.attributes = n, h.attributesNum = r, h.index = e;
        }(x, _);
      } else {
        var _t89 = !0 === l.wireframe;

        h.geometry === x.id && h.program === d.id && h.wireframe === _t89 || (h.geometry = x.id, h.program = d.id, h.wireframe = _t89, b = !0);
      }

      !0 === r.isInstancedMesh && (b = !0), null !== _ && n.update(_, 34963), (b || c) && (c = !1, function (r, s, a, o) {
        if (!1 === i.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
        m();
        var l = o.attributes,
            h = a.getAttributes(),
            c = s.defaultAttributeValues;

        for (var _e71 in h) {
          var _i67 = h[_e71];

          if (_i67.location >= 0) {
            var _s24 = l[_e71];

            if (void 0 === _s24 && ("instanceMatrix" === _e71 && r.instanceMatrix && (_s24 = r.instanceMatrix), "instanceColor" === _e71 && r.instanceColor && (_s24 = r.instanceColor)), void 0 !== _s24) {
              var _e72 = _s24.normalized,
                  _a15 = _s24.itemSize,
                  _l12 = n.get(_s24);

              if (void 0 === _l12) continue;
              var _h8 = _l12.buffer,
                  _c7 = _l12.type,
                  _u8 = _l12.bytesPerElement;

              if (_s24.isInterleavedBufferAttribute) {
                var _n82 = _s24.data,
                    _l13 = _n82.stride,
                    _d7 = _s24.offset;

                if (_n82.isInstancedInterleavedBuffer) {
                  for (var _t90 = 0; _t90 < _i67.locationSize; _t90++) {
                    g(_i67.location + _t90, _n82.meshPerAttribute);
                  }

                  !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = _n82.meshPerAttribute * _n82.count);
                } else for (var _t91 = 0; _t91 < _i67.locationSize; _t91++) {
                  f(_i67.location + _t91);
                }

                t.bindBuffer(34962, _h8);

                for (var _t92 = 0; _t92 < _i67.locationSize; _t92++) {
                  y(_i67.location + _t92, _a15 / _i67.locationSize, _c7, _e72, _l13 * _u8, (_d7 + _a15 / _i67.locationSize * _t92) * _u8);
                }
              } else {
                if (_s24.isInstancedBufferAttribute) {
                  for (var _t93 = 0; _t93 < _i67.locationSize; _t93++) {
                    g(_i67.location + _t93, _s24.meshPerAttribute);
                  }

                  !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = _s24.meshPerAttribute * _s24.count);
                } else for (var _t94 = 0; _t94 < _i67.locationSize; _t94++) {
                  f(_i67.location + _t94);
                }

                t.bindBuffer(34962, _h8);

                for (var _t95 = 0; _t95 < _i67.locationSize; _t95++) {
                  y(_i67.location + _t95, _a15 / _i67.locationSize, _c7, _e72, _a15 * _u8, _a15 / _i67.locationSize * _t95 * _u8);
                }
              }
            } else if (void 0 !== c) {
              var _n83 = c[_e71];
              if (void 0 !== _n83) switch (_n83.length) {
                case 2:
                  t.vertexAttrib2fv(_i67.location, _n83);
                  break;

                case 3:
                  t.vertexAttrib3fv(_i67.location, _n83);
                  break;

                case 4:
                  t.vertexAttrib4fv(_i67.location, _n83);
                  break;

                default:
                  t.vertexAttrib1fv(_i67.location, _n83);
              }
            }
          }
        }

        v();
      }(r, l, d, x), null !== _ && t.bindBuffer(34963, n.get(_).buffer));
    },
    reset: x,
    resetDefaultState: _,
    dispose: function dispose() {
      x();

      for (var _t96 in o) {
        var _e73 = o[_t96];

        for (var _t97 in _e73) {
          var _n84 = _e73[_t97];

          for (var _t98 in _n84) {
            d(_n84[_t98].object), delete _n84[_t98];
          }

          delete _e73[_t97];
        }

        delete o[_t96];
      }
    },
    releaseStatesOfGeometry: function releaseStatesOfGeometry(t) {
      if (void 0 === o[t.id]) return;
      var e = o[t.id];

      for (var _t99 in e) {
        var _n85 = e[_t99];

        for (var _t100 in _n85) {
          d(_n85[_t100].object), delete _n85[_t100];
        }

        delete e[_t99];
      }

      delete o[t.id];
    },
    releaseStatesOfProgram: function releaseStatesOfProgram(t) {
      for (var _e74 in o) {
        var _n86 = o[_e74];
        if (void 0 === _n86[t.id]) continue;
        var _i68 = _n86[t.id];

        for (var _t101 in _i68) {
          d(_i68[_t101].object), delete _i68[_t101];
        }

        delete _n86[t.id];
      }
    },
    initAttributes: m,
    enableAttribute: f,
    disableUnusedAttributes: v
  };
}

function li(t, e, n, i) {
  var r = i.isWebGL2;
  var s;
  this.setMode = function (t) {
    s = t;
  }, this.render = function (e, i) {
    t.drawArrays(s, e, i), n.update(i, s, 1);
  }, this.renderInstances = function (i, a, o) {
    if (0 === o) return;
    var l, h;
    if (r) l = t, h = "drawArraysInstanced";else if (l = e.get("ANGLE_instanced_arrays"), h = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
    l[h](s, i, a, o), n.update(a, s, o);
  };
}

function hi(t, e, n) {
  var i;

  function r(e) {
    if ("highp" === e) {
      if (t.getShaderPrecisionFormat(35633, 36338).precision > 0 && t.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
      e = "mediump";
    }

    return "mediump" === e && t.getShaderPrecisionFormat(35633, 36337).precision > 0 && t.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
  }

  var s = "undefined" != typeof WebGL2RenderingContext && t instanceof WebGL2RenderingContext || "undefined" != typeof WebGL2ComputeRenderingContext && t instanceof WebGL2ComputeRenderingContext;
  var a = void 0 !== n.precision ? n.precision : "highp";
  var o = r(a);
  o !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", o, "instead."), a = o);
  var l = s || e.has("WEBGL_draw_buffers"),
      h = !0 === n.logarithmicDepthBuffer,
      c = t.getParameter(34930),
      u = t.getParameter(35660),
      d = t.getParameter(3379),
      p = t.getParameter(34076),
      m = t.getParameter(34921),
      f = t.getParameter(36347),
      g = t.getParameter(36348),
      v = t.getParameter(36349),
      y = u > 0,
      x = s || e.has("OES_texture_float");
  return {
    isWebGL2: s,
    drawBuffers: l,
    getMaxAnisotropy: function getMaxAnisotropy() {
      if (void 0 !== i) return i;

      if (!0 === e.has("EXT_texture_filter_anisotropic")) {
        var _n87 = e.get("EXT_texture_filter_anisotropic");

        i = t.getParameter(_n87.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
      } else i = 0;

      return i;
    },
    getMaxPrecision: r,
    precision: a,
    logarithmicDepthBuffer: h,
    maxTextures: c,
    maxVertexTextures: u,
    maxTextureSize: d,
    maxCubemapSize: p,
    maxAttributes: m,
    maxVertexUniforms: f,
    maxVaryings: g,
    maxFragmentUniforms: v,
    vertexTextures: y,
    floatFragmentTextures: x,
    floatVertexTextures: y && x,
    maxSamples: s ? t.getParameter(36183) : 0
  };
}

function ci(t) {
  var e = this;
  var n = null,
      i = 0,
      r = !1,
      s = !1;
  var a = new Zn(),
      o = new ft(),
      l = {
    value: null,
    needsUpdate: !1
  };

  function h() {
    l.value !== n && (l.value = n, l.needsUpdate = i > 0), e.numPlanes = i, e.numIntersection = 0;
  }

  function c(t, n, i, r) {
    var s = null !== t ? t.length : 0;
    var h = null;

    if (0 !== s) {
      if (h = l.value, !0 !== r || null === h) {
        var _e75 = i + 4 * s,
            _r50 = n.matrixWorldInverse;

        o.getNormalMatrix(_r50), (null === h || h.length < _e75) && (h = new Float32Array(_e75));

        for (var _e76 = 0, _n88 = i; _e76 !== s; ++_e76, _n88 += 4) {
          a.copy(t[_e76]).applyMatrix4(_r50, o), a.normal.toArray(h, _n88), h[_n88 + 3] = a.constant;
        }
      }

      l.value = h, l.needsUpdate = !0;
    }

    return e.numPlanes = s, e.numIntersection = 0, h;
  }

  this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function (t, e, s) {
    var a = 0 !== t.length || e || 0 !== i || r;
    return r = e, n = c(t, s, 0), i = t.length, a;
  }, this.beginShadows = function () {
    s = !0, c(null);
  }, this.endShadows = function () {
    s = !1, h();
  }, this.setState = function (e, a, o) {
    var u = e.clippingPlanes,
        d = e.clipIntersection,
        p = e.clipShadows,
        m = t.get(e);
    if (!r || null === u || 0 === u.length || s && !p) s ? c(null) : h();else {
      var _t102 = s ? 0 : i,
          _e77 = 4 * _t102;

      var _r51 = m.clippingState || null;

      l.value = _r51, _r51 = c(u, a, _e77, o);

      for (var _t103 = 0; _t103 !== _e77; ++_t103) {
        _r51[_t103] = n[_t103];
      }

      m.clippingState = _r51, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += _t102;
    }
  };
}

function ui(t) {
  var e = new WeakMap();

  function n(t, e) {
    return 303 === e ? t.mapping = 301 : 304 === e && (t.mapping = 302), t;
  }

  function i(t) {
    var n = t.target;
    n.removeEventListener("dispose", i);
    var r = e.get(n);
    void 0 !== r && (e.delete(n), r.dispose());
  }

  return {
    get: function get(r) {
      if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
        var _s25 = r.mapping;

        if (303 === _s25 || 304 === _s25) {
          if (e.has(r)) {
            return n(e.get(r).texture, r.mapping);
          }

          {
            var _s26 = r.image;

            if (_s26 && _s26.height > 0) {
              var _a16 = new qn(_s26.height / 2);

              return _a16.fromEquirectangularTexture(t, r), e.set(r, _a16), r.addEventListener("dispose", i), n(_a16.texture, r.mapping);
            }

            return null;
          }
        }
      }

      return r;
    },
    dispose: function dispose() {
      e = new WeakMap();
    }
  };
}

si.physical = {
  uniforms: Bn([si.standard.uniforms, {
    clearcoat: {
      value: 0
    },
    clearcoatMap: {
      value: null
    },
    clearcoatRoughness: {
      value: 0
    },
    clearcoatRoughnessMap: {
      value: null
    },
    clearcoatNormalScale: {
      value: new mt(1, 1)
    },
    clearcoatNormalMap: {
      value: null
    },
    sheen: {
      value: 0
    },
    sheenColor: {
      value: new Rt(0)
    },
    sheenColorMap: {
      value: null
    },
    sheenRoughness: {
      value: 1
    },
    sheenRoughnessMap: {
      value: null
    },
    transmission: {
      value: 0
    },
    transmissionMap: {
      value: null
    },
    transmissionSamplerSize: {
      value: new mt()
    },
    transmissionSamplerMap: {
      value: null
    },
    thickness: {
      value: 0
    },
    thicknessMap: {
      value: null
    },
    attenuationDistance: {
      value: 0
    },
    attenuationColor: {
      value: new Rt(0)
    },
    specularIntensity: {
      value: 1
    },
    specularIntensityMap: {
      value: null
    },
    specularColor: {
      value: new Rt(1, 1, 1)
    },
    specularColorMap: {
      value: null
    }
  }]),
  vertexShader: ii.meshphysical_vert,
  fragmentShader: ii.meshphysical_frag
};

var di = /*#__PURE__*/function (_Vn2) {
  _inherits(di, _Vn2);

  var _super29 = _createSuper(di);

  function di() {
    var _this31;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : .1;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2e3;

    _classCallCheck(this, di);

    _this31 = _super29.call(this), _this31.type = "OrthographicCamera", _this31.zoom = 1, _this31.view = null, _this31.left = t, _this31.right = e, _this31.top = n, _this31.bottom = i, _this31.near = r, _this31.far = s, _this31.updateProjectionMatrix();
    return _this31;
  }

  _createClass(di, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(di.prototype), "copy", this).call(this, t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = null === t.view ? null : Object.assign({}, t.view), this;
    }
  }, {
    key: "setViewOffset",
    value: function setViewOffset(t, e, n, i, r, s) {
      null === this.view && (this.view = {
        enabled: !0,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
    }
  }, {
    key: "clearViewOffset",
    value: function clearViewOffset() {
      null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
  }, {
    key: "updateProjectionMatrix",
    value: function updateProjectionMatrix() {
      var t = (this.right - this.left) / (2 * this.zoom),
          e = (this.top - this.bottom) / (2 * this.zoom),
          n = (this.right + this.left) / 2,
          i = (this.top + this.bottom) / 2;
      var r = n - t,
          s = n + t,
          a = i + e,
          o = i - e;

      if (null !== this.view && this.view.enabled) {
        var _t104 = (this.right - this.left) / this.view.fullWidth / this.zoom,
            _e78 = (this.top - this.bottom) / this.view.fullHeight / this.zoom;

        r += _t104 * this.view.offsetX, s = r + _t104 * this.view.width, a -= _e78 * this.view.offsetY, o = a - _e78 * this.view.height;
      }

      this.projectionMatrix.makeOrthographic(r, s, a, o, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(di.prototype), "toJSON", this).call(this, t);

      return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
    }
  }]);

  return di;
}(Vn);

di.prototype.isOrthographicCamera = !0;
var pi = [.125, .215, .35, .446, .526, .582],
    mi = new di(),
    fi = new Rt();
var gi = null;
var vi = (1 + Math.sqrt(5)) / 2,
    yi = 1 / vi,
    xi = [new zt(1, 1, 1), new zt(-1, 1, 1), new zt(1, 1, -1), new zt(-1, 1, -1), new zt(0, vi, yi), new zt(0, vi, -yi), new zt(yi, 0, vi), new zt(-yi, 0, vi), new zt(vi, yi, 0), new zt(-vi, yi, 0)];

var _i = /*#__PURE__*/function () {
  function _i(t) {
    _classCallCheck(this, _i);

    this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }

  _createClass(_i, [{
    key: "fromScene",
    value: function fromScene(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
      gi = this._renderer.getRenderTarget(), this._setSize(256);

      var r = this._allocateTargets();

      return r.depthBuffer = !0, this._sceneToCubeUV(t, n, i, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
    }
  }, {
    key: "fromEquirectangular",
    value: function fromEquirectangular(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this._fromTexture(t, e);
    }
  }, {
    key: "fromCubemap",
    value: function fromCubemap(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this._fromTexture(t, e);
    }
  }, {
    key: "compileCubemapShader",
    value: function compileCubemapShader() {
      null === this._cubemapMaterial && (this._cubemapMaterial = Si(), this._compileMaterial(this._cubemapMaterial));
    }
  }, {
    key: "compileEquirectangularShader",
    value: function compileEquirectangularShader() {
      null === this._equirectMaterial && (this._equirectMaterial = Mi(), this._compileMaterial(this._equirectMaterial));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
    }
  }, {
    key: "_setSize",
    value: function _setSize(t) {
      this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();

      for (var _t105 = 0; _t105 < this._lodPlanes.length; _t105++) {
        this._lodPlanes[_t105].dispose();
      }
    }
  }, {
    key: "_cleanup",
    value: function _cleanup(t) {
      this._renderer.setRenderTarget(gi), t.scissorTest = !1, wi(t, 0, 0, t.width, t.height);
    }
  }, {
    key: "_fromTexture",
    value: function _fromTexture(t, e) {
      301 === t.mapping || 302 === t.mapping ? this._setSize(0 === t.image.length ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), gi = this._renderer.getRenderTarget();

      var n = e || this._allocateTargets();

      return this._textureToCubeUV(t, n), this._applyPMREM(n), this._cleanup(n), n;
    }
  }, {
    key: "_allocateTargets",
    value: function _allocateTargets() {
      var t = 3 * Math.max(this._cubeSize, 112),
          e = 4 * this._cubeSize - 32,
          n = {
        magFilter: 1006,
        minFilter: 1006,
        generateMipmaps: !1,
        type: 1016,
        format: 1023,
        encoding: 3e3,
        depthBuffer: !1
      },
          i = bi(t, e, n);

      if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== t) {
        var _ref;

        null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = bi(t, e, n);
        var _i69 = this._lodMax;
        (_ref = function (t) {
          var e = [],
              n = [],
              i = [];
          var r = t;
          var s = t - 4 + 1 + pi.length;

          for (var _a17 = 0; _a17 < s; _a17++) {
            var _s27 = Math.pow(2, r);

            n.push(_s27);

            var _o13 = 1 / _s27;

            _a17 > t - 4 ? _o13 = pi[_a17 - t + 4 - 1] : 0 === _a17 && (_o13 = 0), i.push(_o13);

            var _l14 = 1 / (_s27 - 1),
                _h9 = -_l14 / 2,
                _c8 = 1 + _l14 / 2,
                _u9 = [_h9, _h9, _c8, _h9, _c8, _c8, _h9, _h9, _c8, _c8, _h9, _c8],
                _d8 = 6,
                _p7 = 6,
                _m4 = 3,
                _f2 = 2,
                _g2 = 1,
                _v3 = new Float32Array(_m4 * _p7 * _d8),
                _y3 = new Float32Array(_f2 * _p7 * _d8),
                _x3 = new Float32Array(_g2 * _p7 * _d8);

            for (var _t106 = 0; _t106 < _d8; _t106++) {
              var _e79 = _t106 % 3 * 2 / 3 - 1,
                  _n89 = _t106 > 2 ? 0 : -1,
                  _i70 = [_e79, _n89, 0, _e79 + 2 / 3, _n89, 0, _e79 + 2 / 3, _n89 + 1, 0, _e79, _n89, 0, _e79 + 2 / 3, _n89 + 1, 0, _e79, _n89 + 1, 0];

              _v3.set(_i70, _m4 * _p7 * _t106), _y3.set(_u9, _f2 * _p7 * _t106);
              var _r52 = [_t106, _t106, _t106, _t106, _t106, _t106];

              _x3.set(_r52, _g2 * _p7 * _t106);
            }

            var _3 = new vn();

            _3.setAttribute("position", new an(_v3, _m4)), _3.setAttribute("uv", new an(_y3, _f2)), _3.setAttribute("faceIndex", new an(_x3, _g2)), e.push(_3), r > 4 && r--;
          }

          return {
            lodPlanes: e,
            sizeLods: n,
            sigmas: i
          };
        }(_i69), this._sizeLods = _ref.sizeLods, this._lodPlanes = _ref.lodPlanes, this._sigmas = _ref.sigmas, _ref), this._blurMaterial = function (t, e, n) {
          var i = new Float32Array(20),
              r = new zt(0, 1, 0);
          return new Hn({
            name: "SphericalGaussianBlur",
            defines: {
              n: 20,
              CUBEUV_TEXEL_WIDTH: 1 / e,
              CUBEUV_TEXEL_HEIGHT: 1 / n,
              CUBEUV_MAX_MIP: "".concat(t, ".0")
            },
            uniforms: {
              envMap: {
                value: null
              },
              samples: {
                value: 1
              },
              weights: {
                value: i
              },
              latitudinal: {
                value: !1
              },
              dTheta: {
                value: 0
              },
              mipInt: {
                value: 0
              },
              poleAxis: {
                value: r
              }
            },
            vertexShader: Ti(),
            fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
            blending: 0,
            depthTest: !1,
            depthWrite: !1
          });
        }(_i69, t, e);
      }

      return i;
    }
  }, {
    key: "_compileMaterial",
    value: function _compileMaterial(t) {
      var e = new Nn(this._lodPlanes[0], t);

      this._renderer.compile(e, mi);
    }
  }, {
    key: "_sceneToCubeUV",
    value: function _sceneToCubeUV(t, e, n, i) {
      var r = new Gn(90, 1, e, n),
          s = [1, -1, 1, 1, 1, 1],
          a = [1, 1, 1, -1, -1, -1],
          o = this._renderer,
          l = o.autoClear,
          h = o.toneMapping;
      o.getClearColor(fi), o.toneMapping = 0, o.autoClear = !1;
      var c = new nn({
        name: "PMREM.Background",
        side: 1,
        depthWrite: !1,
        depthTest: !1
      }),
          u = new Nn(new Un(), c);
      var d = !1;
      var p = t.background;
      p ? p.isColor && (c.color.copy(p), t.background = null, d = !0) : (c.color.copy(fi), d = !0);

      for (var _e80 = 0; _e80 < 6; _e80++) {
        var _n90 = _e80 % 3;

        0 === _n90 ? (r.up.set(0, s[_e80], 0), r.lookAt(a[_e80], 0, 0)) : 1 === _n90 ? (r.up.set(0, 0, s[_e80]), r.lookAt(0, a[_e80], 0)) : (r.up.set(0, s[_e80], 0), r.lookAt(0, 0, a[_e80]));
        var _l15 = this._cubeSize;
        wi(i, _n90 * _l15, _e80 > 2 ? _l15 : 0, _l15, _l15), o.setRenderTarget(i), d && o.render(u, r), o.render(t, r);
      }

      u.geometry.dispose(), u.material.dispose(), o.toneMapping = h, o.autoClear = l, t.background = p;
    }
  }, {
    key: "_textureToCubeUV",
    value: function _textureToCubeUV(t, e) {
      var n = this._renderer,
          i = 301 === t.mapping || 302 === t.mapping;
      i ? (null === this._cubemapMaterial && (this._cubemapMaterial = Si()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === t.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = Mi());
      var r = i ? this._cubemapMaterial : this._equirectMaterial,
          s = new Nn(this._lodPlanes[0], r);
      r.uniforms.envMap.value = t;
      var a = this._cubeSize;
      wi(e, 0, 0, 3 * a, 2 * a), n.setRenderTarget(e), n.render(s, mi);
    }
  }, {
    key: "_applyPMREM",
    value: function _applyPMREM(t) {
      var e = this._renderer,
          n = e.autoClear;
      e.autoClear = !1;

      for (var _e81 = 1; _e81 < this._lodPlanes.length; _e81++) {
        var _n91 = Math.sqrt(this._sigmas[_e81] * this._sigmas[_e81] - this._sigmas[_e81 - 1] * this._sigmas[_e81 - 1]),
            _i71 = xi[(_e81 - 1) % xi.length];

        this._blur(t, _e81 - 1, _e81, _n91, _i71);
      }

      e.autoClear = n;
    }
  }, {
    key: "_blur",
    value: function _blur(t, e, n, i, r) {
      var s = this._pingPongRenderTarget;
      this._halfBlur(t, s, e, n, i, "latitudinal", r), this._halfBlur(s, t, n, n, i, "longitudinal", r);
    }
  }, {
    key: "_halfBlur",
    value: function _halfBlur(t, e, n, i, r, s, a) {
      var o = this._renderer,
          l = this._blurMaterial;
      "latitudinal" !== s && "longitudinal" !== s && console.error("blur direction must be either latitudinal or longitudinal!");
      var h = new Nn(this._lodPlanes[i], l),
          c = l.uniforms,
          u = this._sizeLods[n] - 1,
          d = isFinite(r) ? Math.PI / (2 * u) : 2 * Math.PI / 39,
          p = r / d,
          m = isFinite(r) ? 1 + Math.floor(3 * p) : 20;
      m > 20 && console.warn("sigmaRadians, ".concat(r, ", is too large and will clip, as it requested ").concat(m, " samples when the maximum is set to 20"));
      var f = [];
      var g = 0;

      for (var _t107 = 0; _t107 < 20; ++_t107) {
        var _e82 = _t107 / p,
            _n92 = Math.exp(-_e82 * _e82 / 2);

        f.push(_n92), 0 === _t107 ? g += _n92 : _t107 < m && (g += 2 * _n92);
      }

      for (var _t108 = 0; _t108 < f.length; _t108++) {
        f[_t108] = f[_t108] / g;
      }

      c.envMap.value = t.texture, c.samples.value = m, c.weights.value = f, c.latitudinal.value = "latitudinal" === s, a && (c.poleAxis.value = a);
      var v = this._lodMax;
      c.dTheta.value = d, c.mipInt.value = v - n;
      var y = this._sizeLods[i];
      wi(e, 3 * y * (i > v - 4 ? i - v + 4 : 0), 4 * (this._cubeSize - y), 3 * y, 2 * y), o.setRenderTarget(e), o.render(h, mi);
    }
  }]);

  return _i;
}();

function bi(t, e, n) {
  var i = new Ft(t, e, n);
  return i.texture.mapping = 306, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
}

function wi(t, e, n, i, r) {
  t.viewport.set(e, n, i, r), t.scissor.set(e, n, i, r);
}

function Mi() {
  return new Hn({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: {
        value: null
      }
    },
    vertexShader: Ti(),
    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}

function Si() {
  return new Hn({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: {
        value: null
      },
      flipEnvMap: {
        value: -1
      }
    },
    vertexShader: Ti(),
    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}

function Ti() {
  return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
}

function Ei(t) {
  var e = new WeakMap(),
      n = null;

  function i(t) {
    var n = t.target;
    n.removeEventListener("dispose", i);
    var r = e.get(n);
    void 0 !== r && (e.delete(n), r.dispose());
  }

  return {
    get: function get(r) {
      if (r && r.isTexture) {
        var _s28 = r.mapping,
            _a18 = 303 === _s28 || 304 === _s28,
            _o14 = 301 === _s28 || 302 === _s28;

        if (_a18 || _o14) {
          if (r.isRenderTargetTexture && !0 === r.needsPMREMUpdate) {
            r.needsPMREMUpdate = !1;

            var _i72 = e.get(r);

            return null === n && (n = new _i(t)), _i72 = _a18 ? n.fromEquirectangular(r, _i72) : n.fromCubemap(r, _i72), e.set(r, _i72), _i72.texture;
          }

          if (e.has(r)) return e.get(r).texture;
          {
            var _s29 = r.image;

            if (_a18 && _s29 && _s29.height > 0 || _o14 && _s29 && function (t) {
              var e = 0;
              var n = 6;

              for (var _i73 = 0; _i73 < n; _i73++) {
                void 0 !== t[_i73] && e++;
              }

              return e === n;
            }(_s29)) {
              null === n && (n = new _i(t));

              var _s30 = _a18 ? n.fromEquirectangular(r) : n.fromCubemap(r);

              return e.set(r, _s30), r.addEventListener("dispose", i), _s30.texture;
            }

            return null;
          }
        }
      }

      return r;
    },
    dispose: function dispose() {
      e = new WeakMap(), null !== n && (n.dispose(), n = null);
    }
  };
}

function Ai(t) {
  var e = {};

  function n(n) {
    if (void 0 !== e[n]) return e[n];
    var i;

    switch (n) {
      case "WEBGL_depth_texture":
        i = t.getExtension("WEBGL_depth_texture") || t.getExtension("MOZ_WEBGL_depth_texture") || t.getExtension("WEBKIT_WEBGL_depth_texture");
        break;

      case "EXT_texture_filter_anisotropic":
        i = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;

      case "WEBGL_compressed_texture_s3tc":
        i = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;

      case "WEBGL_compressed_texture_pvrtc":
        i = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;

      default:
        i = t.getExtension(n);
    }

    return e[n] = i, i;
  }

  return {
    has: function has(t) {
      return null !== n(t);
    },
    init: function init(t) {
      t.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
    },
    get: function get(t) {
      var e = n(t);
      return null === e && console.warn("THREE.WebGLRenderer: " + t + " extension not supported."), e;
    }
  };
}

function Ri(t, e, n, i) {
  var r = {},
      s = new WeakMap();

  function a(t) {
    var o = t.target;
    null !== o.index && e.remove(o.index);

    for (var _t109 in o.attributes) {
      e.remove(o.attributes[_t109]);
    }

    o.removeEventListener("dispose", a), delete r[o.id];
    var l = s.get(o);
    l && (e.remove(l), s.delete(o)), i.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, n.memory.geometries--;
  }

  function o(t) {
    var n = [],
        i = t.index,
        r = t.attributes.position;
    var a = 0;

    if (null !== i) {
      var _t110 = i.array;
      a = i.version;

      for (var _e83 = 0, _i74 = _t110.length; _e83 < _i74; _e83 += 3) {
        var _i75 = _t110[_e83 + 0],
            _r53 = _t110[_e83 + 1],
            _s31 = _t110[_e83 + 2];
        n.push(_i75, _r53, _r53, _s31, _s31, _i75);
      }
    } else {
      var _t111 = r.array;
      a = r.version;

      for (var _e84 = 0, _i76 = _t111.length / 3 - 1; _e84 < _i76; _e84 += 3) {
        var _t112 = _e84 + 0,
            _i77 = _e84 + 1,
            _r54 = _e84 + 2;

        n.push(_t112, _i77, _i77, _r54, _r54, _t112);
      }
    }

    var o = new (gt(n) ? ln : on)(n, 1);
    o.version = a;
    var l = s.get(t);
    l && e.remove(l), s.set(t, o);
  }

  return {
    get: function get(t, e) {
      return !0 === r[e.id] || (e.addEventListener("dispose", a), r[e.id] = !0, n.memory.geometries++), e;
    },
    update: function update(t) {
      var n = t.attributes;

      for (var _t113 in n) {
        e.update(n[_t113], 34962);
      }

      var i = t.morphAttributes;

      for (var _t114 in i) {
        var _n93 = i[_t114];

        for (var _t115 = 0, _i78 = _n93.length; _t115 < _i78; _t115++) {
          e.update(_n93[_t115], 34962);
        }
      }
    },
    getWireframeAttribute: function getWireframeAttribute(t) {
      var e = s.get(t);

      if (e) {
        var _n94 = t.index;
        null !== _n94 && e.version < _n94.version && o(t);
      } else o(t);

      return s.get(t);
    }
  };
}

function Ci(t, e, n, i) {
  var r = i.isWebGL2;
  var s, a, o;
  this.setMode = function (t) {
    s = t;
  }, this.setIndex = function (t) {
    a = t.type, o = t.bytesPerElement;
  }, this.render = function (e, i) {
    t.drawElements(s, i, a, e * o), n.update(i, s, 1);
  }, this.renderInstances = function (i, l, h) {
    if (0 === h) return;
    var c, u;
    if (r) c = t, u = "drawElementsInstanced";else if (c = e.get("ANGLE_instanced_arrays"), u = "drawElementsInstancedANGLE", null === c) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
    c[u](s, l, a, i * o, h), n.update(l, s, h);
  };
}

function Li(t) {
  var e = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  return {
    memory: {
      geometries: 0,
      textures: 0
    },
    render: e,
    programs: null,
    autoReset: !0,
    reset: function reset() {
      e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
    },
    update: function update(t, n, i) {
      switch (e.calls++, n) {
        case 4:
          e.triangles += i * (t / 3);
          break;

        case 1:
          e.lines += i * (t / 2);
          break;

        case 3:
          e.lines += i * (t - 1);
          break;

        case 2:
          e.lines += i * t;
          break;

        case 0:
          e.points += i * t;
          break;

        default:
          console.error("THREE.WebGLInfo: Unknown draw mode:", n);
      }
    }
  };
}

function Pi(t, e) {
  return t[0] - e[0];
}

function Di(t, e) {
  return Math.abs(e[1]) - Math.abs(t[1]);
}

function Ii(t, e) {
  var n = 1;
  var i = e.isInterleavedBufferAttribute ? e.data.array : e.array;
  i instanceof Int8Array ? n = 127 : i instanceof Int16Array ? n = 32767 : i instanceof Int32Array ? n = 2147483647 : console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", i), t.divideScalar(n);
}

function Oi(t, e, n) {
  var i = {},
      r = new Float32Array(8),
      s = new WeakMap(),
      a = new Nt(),
      o = [];

  for (var _t116 = 0; _t116 < 8; _t116++) {
    o[_t116] = [_t116, 0];
  }

  return {
    update: function update(l, h, c, u) {
      var d = l.morphTargetInfluences;

      if (!0 === e.isWebGL2) {
        var _i79 = h.morphAttributes.position || h.morphAttributes.normal || h.morphAttributes.color,
            _r55 = void 0 !== _i79 ? _i79.length : 0;

        var _o15 = s.get(h);

        if (void 0 === _o15 || _o15.count !== _r55) {
          void 0 !== _o15 && _o15.texture.dispose();

          var _t117 = void 0 !== h.morphAttributes.position,
              _n95 = void 0 !== h.morphAttributes.normal,
              _i80 = void 0 !== h.morphAttributes.color,
              _l17 = h.morphAttributes.position || [],
              _c10 = h.morphAttributes.normal || [],
              _u10 = h.morphAttributes.color || [];

          var _d9 = 0;
          !0 === _t117 && (_d9 = 1), !0 === _n95 && (_d9 = 2), !0 === _i80 && (_d9 = 3);

          var _p8 = h.attributes.position.count * _d9,
              _m5 = 1;

          _p8 > e.maxTextureSize && (_m5 = Math.ceil(_p8 / e.maxTextureSize), _p8 = e.maxTextureSize);

          var _f3 = new Float32Array(_p8 * _m5 * 4 * _r55),
              _g3 = new Ut(_f3, _p8, _m5, _r55);

          _g3.type = 1015, _g3.needsUpdate = !0;

          var _v4 = 4 * _d9;

          for (var _e85 = 0; _e85 < _r55; _e85++) {
            var _r56 = _l17[_e85],
                _s32 = _c10[_e85],
                _o16 = _u10[_e85],
                _h10 = _p8 * _m5 * 4 * _e85;

            for (var _e86 = 0; _e86 < _r56.count; _e86++) {
              var _l18 = _e86 * _v4;

              !0 === _t117 && (a.fromBufferAttribute(_r56, _e86), !0 === _r56.normalized && Ii(a, _r56), _f3[_h10 + _l18 + 0] = a.x, _f3[_h10 + _l18 + 1] = a.y, _f3[_h10 + _l18 + 2] = a.z, _f3[_h10 + _l18 + 3] = 0), !0 === _n95 && (a.fromBufferAttribute(_s32, _e86), !0 === _s32.normalized && Ii(a, _s32), _f3[_h10 + _l18 + 4] = a.x, _f3[_h10 + _l18 + 5] = a.y, _f3[_h10 + _l18 + 6] = a.z, _f3[_h10 + _l18 + 7] = 0), !0 === _i80 && (a.fromBufferAttribute(_o16, _e86), !0 === _o16.normalized && Ii(a, _o16), _f3[_h10 + _l18 + 8] = a.x, _f3[_h10 + _l18 + 9] = a.y, _f3[_h10 + _l18 + 10] = a.z, _f3[_h10 + _l18 + 11] = 4 === _o16.itemSize ? a.w : 1);
            }
          }

          _o15 = {
            count: _r55,
            texture: _g3,
            size: new mt(_p8, _m5)
          }, s.set(h, _o15), h.addEventListener("dispose", function t() {
            _g3.dispose(), s.delete(h), h.removeEventListener("dispose", t);
          });
        }

        var _l16 = 0;

        for (var _t118 = 0; _t118 < d.length; _t118++) {
          _l16 += d[_t118];
        }

        var _c9 = h.morphTargetsRelative ? 1 : 1 - _l16;

        u.getUniforms().setValue(t, "morphTargetBaseInfluence", _c9), u.getUniforms().setValue(t, "morphTargetInfluences", d), u.getUniforms().setValue(t, "morphTargetsTexture", _o15.texture, n), u.getUniforms().setValue(t, "morphTargetsTextureSize", _o15.size);
      } else {
        var _e87 = void 0 === d ? 0 : d.length;

        var _n96 = i[h.id];

        if (void 0 === _n96 || _n96.length !== _e87) {
          _n96 = [];

          for (var _t119 = 0; _t119 < _e87; _t119++) {
            _n96[_t119] = [_t119, 0];
          }

          i[h.id] = _n96;
        }

        for (var _t120 = 0; _t120 < _e87; _t120++) {
          var _e88 = _n96[_t120];
          _e88[0] = _t120, _e88[1] = d[_t120];
        }

        _n96.sort(Di);

        for (var _t121 = 0; _t121 < 8; _t121++) {
          _t121 < _e87 && _n96[_t121][1] ? (o[_t121][0] = _n96[_t121][0], o[_t121][1] = _n96[_t121][1]) : (o[_t121][0] = Number.MAX_SAFE_INTEGER, o[_t121][1] = 0);
        }

        o.sort(Pi);
        var _s33 = h.morphAttributes.position,
            _a19 = h.morphAttributes.normal;
        var _l19 = 0;

        for (var _t122 = 0; _t122 < 8; _t122++) {
          var _e89 = o[_t122],
              _n97 = _e89[0],
              _i81 = _e89[1];
          _n97 !== Number.MAX_SAFE_INTEGER && _i81 ? (_s33 && h.getAttribute("morphTarget" + _t122) !== _s33[_n97] && h.setAttribute("morphTarget" + _t122, _s33[_n97]), _a19 && h.getAttribute("morphNormal" + _t122) !== _a19[_n97] && h.setAttribute("morphNormal" + _t122, _a19[_n97]), r[_t122] = _i81, _l19 += _i81) : (_s33 && !0 === h.hasAttribute("morphTarget" + _t122) && h.deleteAttribute("morphTarget" + _t122), _a19 && !0 === h.hasAttribute("morphNormal" + _t122) && h.deleteAttribute("morphNormal" + _t122), r[_t122] = 0);
        }

        var _c11 = h.morphTargetsRelative ? 1 : 1 - _l19;

        u.getUniforms().setValue(t, "morphTargetBaseInfluence", _c11), u.getUniforms().setValue(t, "morphTargetInfluences", r);
      }
    }
  };
}

function Ni(t, e, n, i) {
  var r = new WeakMap();

  function s(t) {
    var e = t.target;
    e.removeEventListener("dispose", s), n.remove(e.instanceMatrix), null !== e.instanceColor && n.remove(e.instanceColor);
  }

  return {
    update: function update(t) {
      var a = i.render.frame,
          o = t.geometry,
          l = e.get(t, o);
      return r.get(l) !== a && (e.update(l), r.set(l, a)), t.isInstancedMesh && (!1 === t.hasEventListener("dispose", s) && t.addEventListener("dispose", s), n.update(t.instanceMatrix, 34962), null !== t.instanceColor && n.update(t.instanceColor, 34962)), l;
    },
    dispose: function dispose() {
      r = new WeakMap();
    }
  };
}

var Fi = new Ot(),
    Ui = new Ut(),
    ki = new kt(),
    Bi = new jn(),
    zi = [],
    Hi = [],
    Vi = new Float32Array(16),
    Gi = new Float32Array(9),
    Wi = new Float32Array(4);

function ji(t, e, n) {
  var i = t[0];
  if (i <= 0 || i > 0) return t;
  var r = e * n;
  var s = zi[r];

  if (void 0 === s && (s = new Float32Array(r), zi[r] = s), 0 !== e) {
    i.toArray(s, 0);

    for (var _i82 = 1, _r57 = 0; _i82 !== e; ++_i82) {
      _r57 += n, t[_i82].toArray(s, _r57);
    }
  }

  return s;
}

function qi(t, e) {
  if (t.length !== e.length) return !1;

  for (var _n98 = 0, _i83 = t.length; _n98 < _i83; _n98++) {
    if (t[_n98] !== e[_n98]) return !1;
  }

  return !0;
}

function Xi(t, e) {
  for (var _n99 = 0, _i84 = e.length; _n99 < _i84; _n99++) {
    t[_n99] = e[_n99];
  }
}

function Yi(t, e) {
  var n = Hi[e];
  void 0 === n && (n = new Int32Array(e), Hi[e] = n);

  for (var _i85 = 0; _i85 !== e; ++_i85) {
    n[_i85] = t.allocateTextureUnit();
  }

  return n;
}

function Ji(t, e) {
  var n = this.cache;
  n[0] !== e && (t.uniform1f(this.addr, e), n[0] = e);
}

function Zi(t, e) {
  var n = this.cache;
  if (void 0 !== e.x) n[0] === e.x && n[1] === e.y || (t.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);else {
    if (qi(n, e)) return;
    t.uniform2fv(this.addr, e), Xi(n, e);
  }
}

function $i(t, e) {
  var n = this.cache;
  if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z || (t.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);else if (void 0 !== e.r) n[0] === e.r && n[1] === e.g && n[2] === e.b || (t.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);else {
    if (qi(n, e)) return;
    t.uniform3fv(this.addr, e), Xi(n, e);
  }
}

function Ki(t, e) {
  var n = this.cache;
  if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z && n[3] === e.w || (t.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);else {
    if (qi(n, e)) return;
    t.uniform4fv(this.addr, e), Xi(n, e);
  }
}

function Qi(t, e) {
  var n = this.cache,
      i = e.elements;

  if (void 0 === i) {
    if (qi(n, e)) return;
    t.uniformMatrix2fv(this.addr, !1, e), Xi(n, e);
  } else {
    if (qi(n, i)) return;
    Wi.set(i), t.uniformMatrix2fv(this.addr, !1, Wi), Xi(n, i);
  }
}

function tr(t, e) {
  var n = this.cache,
      i = e.elements;

  if (void 0 === i) {
    if (qi(n, e)) return;
    t.uniformMatrix3fv(this.addr, !1, e), Xi(n, e);
  } else {
    if (qi(n, i)) return;
    Gi.set(i), t.uniformMatrix3fv(this.addr, !1, Gi), Xi(n, i);
  }
}

function er(t, e) {
  var n = this.cache,
      i = e.elements;

  if (void 0 === i) {
    if (qi(n, e)) return;
    t.uniformMatrix4fv(this.addr, !1, e), Xi(n, e);
  } else {
    if (qi(n, i)) return;
    Vi.set(i), t.uniformMatrix4fv(this.addr, !1, Vi), Xi(n, i);
  }
}

function nr(t, e) {
  var n = this.cache;
  n[0] !== e && (t.uniform1i(this.addr, e), n[0] = e);
}

function ir(t, e) {
  var n = this.cache;
  qi(n, e) || (t.uniform2iv(this.addr, e), Xi(n, e));
}

function rr(t, e) {
  var n = this.cache;
  qi(n, e) || (t.uniform3iv(this.addr, e), Xi(n, e));
}

function sr(t, e) {
  var n = this.cache;
  qi(n, e) || (t.uniform4iv(this.addr, e), Xi(n, e));
}

function ar(t, e) {
  var n = this.cache;
  n[0] !== e && (t.uniform1ui(this.addr, e), n[0] = e);
}

function or(t, e) {
  var n = this.cache;
  qi(n, e) || (t.uniform2uiv(this.addr, e), Xi(n, e));
}

function lr(t, e) {
  var n = this.cache;
  qi(n, e) || (t.uniform3uiv(this.addr, e), Xi(n, e));
}

function hr(t, e) {
  var n = this.cache;
  qi(n, e) || (t.uniform4uiv(this.addr, e), Xi(n, e));
}

function cr(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture2D(e || Fi, r);
}

function ur(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(e || ki, r);
}

function dr(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(e || Bi, r);
}

function pr(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(e || Ui, r);
}

function mr(t, e) {
  t.uniform1fv(this.addr, e);
}

function fr(t, e) {
  var n = ji(e, this.size, 2);
  t.uniform2fv(this.addr, n);
}

function gr(t, e) {
  var n = ji(e, this.size, 3);
  t.uniform3fv(this.addr, n);
}

function vr(t, e) {
  var n = ji(e, this.size, 4);
  t.uniform4fv(this.addr, n);
}

function yr(t, e) {
  var n = ji(e, this.size, 4);
  t.uniformMatrix2fv(this.addr, !1, n);
}

function xr(t, e) {
  var n = ji(e, this.size, 9);
  t.uniformMatrix3fv(this.addr, !1, n);
}

function _r(t, e) {
  var n = ji(e, this.size, 16);
  t.uniformMatrix4fv(this.addr, !1, n);
}

function br(t, e) {
  t.uniform1iv(this.addr, e);
}

function wr(t, e) {
  t.uniform2iv(this.addr, e);
}

function Mr(t, e) {
  t.uniform3iv(this.addr, e);
}

function Sr(t, e) {
  t.uniform4iv(this.addr, e);
}

function Tr(t, e) {
  t.uniform1uiv(this.addr, e);
}

function Er(t, e) {
  t.uniform2uiv(this.addr, e);
}

function Ar(t, e) {
  t.uniform3uiv(this.addr, e);
}

function Rr(t, e) {
  t.uniform4uiv(this.addr, e);
}

function Cr(t, e, n) {
  var i = e.length,
      r = Yi(n, i);
  t.uniform1iv(this.addr, r);

  for (var _t123 = 0; _t123 !== i; ++_t123) {
    n.setTexture2D(e[_t123] || Fi, r[_t123]);
  }
}

function Lr(t, e, n) {
  var i = e.length,
      r = Yi(n, i);
  t.uniform1iv(this.addr, r);

  for (var _t124 = 0; _t124 !== i; ++_t124) {
    n.setTexture3D(e[_t124] || ki, r[_t124]);
  }
}

function Pr(t, e, n) {
  var i = e.length,
      r = Yi(n, i);
  t.uniform1iv(this.addr, r);

  for (var _t125 = 0; _t125 !== i; ++_t125) {
    n.setTextureCube(e[_t125] || Bi, r[_t125]);
  }
}

function Dr(t, e, n) {
  var i = e.length,
      r = Yi(n, i);
  t.uniform1iv(this.addr, r);

  for (var _t126 = 0; _t126 !== i; ++_t126) {
    n.setTexture2DArray(e[_t126] || Ui, r[_t126]);
  }
}

function Ir(t, e, n) {
  this.id = t, this.addr = n, this.cache = [], this.setValue = function (t) {
    switch (t) {
      case 5126:
        return Ji;

      case 35664:
        return Zi;

      case 35665:
        return $i;

      case 35666:
        return Ki;

      case 35674:
        return Qi;

      case 35675:
        return tr;

      case 35676:
        return er;

      case 5124:
      case 35670:
        return nr;

      case 35667:
      case 35671:
        return ir;

      case 35668:
      case 35672:
        return rr;

      case 35669:
      case 35673:
        return sr;

      case 5125:
        return ar;

      case 36294:
        return or;

      case 36295:
        return lr;

      case 36296:
        return hr;

      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return cr;

      case 35679:
      case 36299:
      case 36307:
        return ur;

      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return dr;

      case 36289:
      case 36303:
      case 36311:
      case 36292:
        return pr;
    }
  }(e.type);
}

function Or(t, e, n) {
  this.id = t, this.addr = n, this.cache = [], this.size = e.size, this.setValue = function (t) {
    switch (t) {
      case 5126:
        return mr;

      case 35664:
        return fr;

      case 35665:
        return gr;

      case 35666:
        return vr;

      case 35674:
        return yr;

      case 35675:
        return xr;

      case 35676:
        return _r;

      case 5124:
      case 35670:
        return br;

      case 35667:
      case 35671:
        return wr;

      case 35668:
      case 35672:
        return Mr;

      case 35669:
      case 35673:
        return Sr;

      case 5125:
        return Tr;

      case 36294:
        return Er;

      case 36295:
        return Ar;

      case 36296:
        return Rr;

      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return Cr;

      case 35679:
      case 36299:
      case 36307:
        return Lr;

      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return Pr;

      case 36289:
      case 36303:
      case 36311:
      case 36292:
        return Dr;
    }
  }(e.type);
}

function Nr(t) {
  this.id = t, this.seq = [], this.map = {};
}

Or.prototype.updateCache = function (t) {
  var e = this.cache;
  t instanceof Float32Array && e.length !== t.length && (this.cache = new Float32Array(t.length)), Xi(e, t);
}, Nr.prototype.setValue = function (t, e, n) {
  var i = this.seq;

  for (var _r58 = 0, _s34 = i.length; _r58 !== _s34; ++_r58) {
    var _s35 = i[_r58];

    _s35.setValue(t, e[_s35.id], n);
  }
};
var Fr = /(\w+)(\])?(\[|\.)?/g;

function Ur(t, e) {
  t.seq.push(e), t.map[e.id] = e;
}

function kr(t, e, n) {
  var i = t.name,
      r = i.length;

  for (Fr.lastIndex = 0;;) {
    var _s36 = Fr.exec(i),
        _a20 = Fr.lastIndex;

    var _o17 = _s36[1];

    var _l20 = "]" === _s36[2],
        _h11 = _s36[3];

    if (_l20 && (_o17 |= 0), void 0 === _h11 || "[" === _h11 && _a20 + 2 === r) {
      Ur(n, void 0 === _h11 ? new Ir(_o17, t, e) : new Or(_o17, t, e));
      break;
    }

    {
      var _t127 = n.map[_o17];
      void 0 === _t127 && (_t127 = new Nr(_o17), Ur(n, _t127)), n = _t127;
    }
  }
}

function Br(t, e) {
  this.seq = [], this.map = {};
  var n = t.getProgramParameter(e, 35718);

  for (var _i86 = 0; _i86 < n; ++_i86) {
    var _n100 = t.getActiveUniform(e, _i86);

    kr(_n100, t.getUniformLocation(e, _n100.name), this);
  }
}

function zr(t, e, n) {
  var i = t.createShader(e);
  return t.shaderSource(i, n), t.compileShader(i), i;
}

Br.prototype.setValue = function (t, e, n, i) {
  var r = this.map[e];
  void 0 !== r && r.setValue(t, n, i);
}, Br.prototype.setOptional = function (t, e, n) {
  var i = e[n];
  void 0 !== i && this.setValue(t, n, i);
}, Br.upload = function (t, e, n, i) {
  for (var _r59 = 0, _s37 = e.length; _r59 !== _s37; ++_r59) {
    var _s38 = e[_r59],
        _a21 = n[_s38.id];
    !1 !== _a21.needsUpdate && _s38.setValue(t, _a21.value, i);
  }
}, Br.seqWithValue = function (t, e) {
  var n = [];

  for (var _i87 = 0, _r60 = t.length; _i87 !== _r60; ++_i87) {
    var _r61 = t[_i87];
    _r61.id in e && n.push(_r61);
  }

  return n;
};
var Hr = 0;

function Vr(t, e, n) {
  var i = t.getShaderParameter(e, 35713),
      r = t.getShaderInfoLog(e).trim();
  if (i && "" === r) return "";
  var s = parseInt(/ERROR: 0:(\d+)/.exec(r)[1]);
  return n.toUpperCase() + "\n\n" + r + "\n\n" + function (t, e) {
    var n = t.split("\n"),
        i = [],
        r = Math.max(e - 6, 0),
        s = Math.min(e + 6, n.length);

    for (var _t128 = r; _t128 < s; _t128++) {
      i.push(_t128 + 1 + ": " + n[_t128]);
    }

    return i.join("\n");
  }(t.getShaderSource(e), s);
}

function Gr(t, e) {
  var n = function (t) {
    switch (t) {
      case 3e3:
        return ["Linear", "( value )"];

      case 3001:
        return ["sRGB", "( value )"];

      default:
        return console.warn("THREE.WebGLProgram: Unsupported encoding:", t), ["Linear", "( value )"];
    }
  }(e);

  return "vec4 " + t + "( vec4 value ) { return LinearTo" + n[0] + n[1] + "; }";
}

function Wr(t, e) {
  var n;

  switch (e) {
    case 1:
      n = "Linear";
      break;

    case 2:
      n = "Reinhard";
      break;

    case 3:
      n = "OptimizedCineon";
      break;

    case 4:
      n = "ACESFilmic";
      break;

    case 5:
      n = "Custom";
      break;

    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
  }

  return "vec3 " + t + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}

function jr(t) {
  return "" !== t;
}

function qr(t, e) {
  return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}

function Xr(t, e) {
  return t.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}

var Yr = /^[ \t]*#include +<([\w\d./]+)>/gm;

function Jr(t) {
  return t.replace(Yr, Zr);
}

function Zr(t, e) {
  var n = ii[e];
  if (void 0 === n) throw new Error("Can not resolve #include <" + e + ">");
  return Jr(n);
}

var $r = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g,
    Kr = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

function Qr(t) {
  return t.replace(Kr, es).replace($r, ts);
}

function ts(t, e, n, i) {
  return console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead."), es(t, e, n, i);
}

function es(t, e, n, i) {
  var r = "";

  for (var _t129 = parseInt(e); _t129 < parseInt(n); _t129++) {
    r += i.replace(/\[\s*i\s*\]/g, "[ " + _t129 + " ]").replace(/UNROLLED_LOOP_INDEX/g, _t129);
  }

  return r;
}

function ns(t) {
  var e = "precision " + t.precision + " float;\nprecision " + t.precision + " int;";
  return "highp" === t.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t.precision && (e += "\n#define LOW_PRECISION"), e;
}

function is(t, e, n, i) {
  var r = t.getContext(),
      s = n.defines;
  var a = n.vertexShader,
      o = n.fragmentShader;

  var l = function (t) {
    var e = "SHADOWMAP_TYPE_BASIC";
    return 1 === t.shadowMapType ? e = "SHADOWMAP_TYPE_PCF" : 2 === t.shadowMapType ? e = "SHADOWMAP_TYPE_PCF_SOFT" : 3 === t.shadowMapType && (e = "SHADOWMAP_TYPE_VSM"), e;
  }(n),
      h = function (t) {
    var e = "ENVMAP_TYPE_CUBE";
    if (t.envMap) switch (t.envMapMode) {
      case 301:
      case 302:
        e = "ENVMAP_TYPE_CUBE";
        break;

      case 306:
        e = "ENVMAP_TYPE_CUBE_UV";
    }
    return e;
  }(n),
      c = function (t) {
    var e = "ENVMAP_MODE_REFLECTION";
    t.envMap && 302 === t.envMapMode && (e = "ENVMAP_MODE_REFRACTION");
    return e;
  }(n),
      u = function (t) {
    var e = "ENVMAP_BLENDING_NONE";
    if (t.envMap) switch (t.combine) {
      case 0:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;

      case 1:
        e = "ENVMAP_BLENDING_MIX";
        break;

      case 2:
        e = "ENVMAP_BLENDING_ADD";
    }
    return e;
  }(n),
      d = function (t) {
    var e = t.envMapCubeUVHeight;
    if (null === e) return null;
    var n = Math.log2(e / 32 + 1) + 3,
        i = 1 / e;
    return {
      texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
      texelHeight: i,
      maxMip: n
    };
  }(n),
      p = n.isWebGL2 ? "" : function (t) {
    return [t.extensionDerivatives || t.envMapCubeUVHeight || t.bumpMap || t.tangentSpaceNormalMap || t.clearcoatNormalMap || t.flatShading || "physical" === t.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "", (t.extensionFragDepth || t.logarithmicDepthBuffer) && t.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "", t.extensionDrawBuffers && t.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "", (t.extensionShaderTextureLOD || t.envMap || t.transmission) && t.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter(jr).join("\n");
  }(n),
      m = function (t) {
    var e = [];

    for (var _n101 in t) {
      var _i88 = t[_n101];
      !1 !== _i88 && e.push("#define " + _n101 + " " + _i88);
    }

    return e.join("\n");
  }(s),
      f = r.createProgram();

  var g,
      v,
      y = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
  n.isRawShaderMaterial ? (g = [m].filter(jr).join("\n"), g.length > 0 && (g += "\n"), v = [p, m].filter(jr).join("\n"), v.length > 0 && (v += "\n")) : (g = [ns(n), "#define SHADER_NAME " + n.shaderName, m, n.instancing ? "#define USE_INSTANCING" : "", n.instancingColor ? "#define USE_INSTANCING_COLOR" : "", n.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "", "#define MAX_BONES " + n.maxBones, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + c : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.displacementMap && n.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "", n.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "", n.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUvs ? "#define USE_UV" : "", n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.skinning ? "#define USE_SKINNING" : "", n.useVertexTexture ? "#define BONE_TEXTURE" : "", n.morphTargets ? "#define USE_MORPHTARGETS" : "", n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "", n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + l : "", n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", "#ifdef USE_INSTANCING", "\tattribute mat4 instanceMatrix;", "#endif", "#ifdef USE_INSTANCING_COLOR", "\tattribute vec3 instanceColor;", "#endif", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_TANGENT", "\tattribute vec4 tangent;", "#endif", "#if defined( USE_COLOR_ALPHA )", "\tattribute vec4 color;", "#elif defined( USE_COLOR )", "\tattribute vec3 color;", "#endif", "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter(jr).join("\n"), v = [p, ns(n), "#define SHADER_NAME " + n.shaderName, m, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.matcap ? "#define USE_MATCAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + h : "", n.envMap ? "#define " + c : "", n.envMap ? "#define " + u : "", d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "", d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "", d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "", n.clearcoat ? "#define USE_CLEARCOAT" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "", n.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.alphaTest ? "#define USE_ALPHATEST" : "", n.sheen ? "#define USE_SHEEN" : "", n.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "", n.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUvs ? "#define USE_UV" : "", n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "", n.gradientMap ? "#define USE_GRADIENTMAP" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + l : "", n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", n.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", 0 !== n.toneMapping ? "#define TONE_MAPPING" : "", 0 !== n.toneMapping ? ii.tonemapping_pars_fragment : "", 0 !== n.toneMapping ? Wr("toneMapping", n.toneMapping) : "", n.dithering ? "#define DITHERING" : "", n.opaque ? "#define OPAQUE" : "", ii.encodings_pars_fragment, Gr("linearToOutputTexel", n.outputEncoding), n.depthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "", "\n"].filter(jr).join("\n")), a = Jr(a), a = qr(a, n), a = Xr(a, n), o = Jr(o), o = qr(o, n), o = Xr(o, n), a = Qr(a), o = Qr(o), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (y = "#version 300 es\n", g = ["precision mediump sampler2DArray;", "#define attribute in", "#define varying out", "#define texture2D texture"].join("\n") + "\n" + g, v = ["#define varying in", "300 es" === n.glslVersion ? "" : "layout(location = 0) out highp vec4 pc_fragColor;", "300 es" === n.glslVersion ? "" : "#define gl_FragColor pc_fragColor", "#define gl_FragDepthEXT gl_FragDepth", "#define texture2D texture", "#define textureCube texture", "#define texture2DProj textureProj", "#define texture2DLodEXT textureLod", "#define texture2DProjLodEXT textureProjLod", "#define textureCubeLodEXT textureLod", "#define texture2DGradEXT textureGrad", "#define texture2DProjGradEXT textureProjGrad", "#define textureCubeGradEXT textureGrad"].join("\n") + "\n" + v);

  var x = y + v + o,
      _ = zr(r, 35633, y + g + a),
      b = zr(r, 35632, x);

  if (r.attachShader(f, _), r.attachShader(f, b), void 0 !== n.index0AttributeName ? r.bindAttribLocation(f, 0, n.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(f, 0, "position"), r.linkProgram(f), t.debug.checkShaderErrors) {
    var _t130 = r.getProgramInfoLog(f).trim(),
        _e90 = r.getShaderInfoLog(_).trim(),
        _n102 = r.getShaderInfoLog(b).trim();

    var _i89 = !0,
        _s39 = !0;

    if (!1 === r.getProgramParameter(f, 35714)) {
      _i89 = !1;

      var _e91 = Vr(r, _, "vertex"),
          _n103 = Vr(r, b, "fragment");

      console.error("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(f, 35715) + "\n\nProgram Info Log: " + _t130 + "\n" + _e91 + "\n" + _n103);
    } else "" !== _t130 ? console.warn("THREE.WebGLProgram: Program Info Log:", _t130) : "" !== _e90 && "" !== _n102 || (_s39 = !1);

    _s39 && (this.diagnostics = {
      runnable: _i89,
      programLog: _t130,
      vertexShader: {
        log: _e90,
        prefix: g
      },
      fragmentShader: {
        log: _n102,
        prefix: v
      }
    });
  }

  var w, M;
  return r.deleteShader(_), r.deleteShader(b), this.getUniforms = function () {
    return void 0 === w && (w = new Br(r, f)), w;
  }, this.getAttributes = function () {
    return void 0 === M && (M = function (t, e) {
      var n = {},
          i = t.getProgramParameter(e, 35721);

      for (var _r62 = 0; _r62 < i; _r62++) {
        var _i90 = t.getActiveAttrib(e, _r62),
            _s40 = _i90.name;

        var _a22 = 1;
        35674 === _i90.type && (_a22 = 2), 35675 === _i90.type && (_a22 = 3), 35676 === _i90.type && (_a22 = 4), n[_s40] = {
          type: _i90.type,
          location: t.getAttribLocation(e, _s40),
          locationSize: _a22
        };
      }

      return n;
    }(r, f)), M;
  }, this.destroy = function () {
    i.releaseStatesOfProgram(this), r.deleteProgram(f), this.program = void 0;
  }, this.name = n.shaderName, this.id = Hr++, this.cacheKey = e, this.usedTimes = 1, this.program = f, this.vertexShader = _, this.fragmentShader = b, this;
}

var rs = 0;

var ss = /*#__PURE__*/function () {
  function ss() {
    _classCallCheck(this, ss);

    this.shaderCache = new Map(), this.materialCache = new Map();
  }

  _createClass(ss, [{
    key: "update",
    value: function update(t) {
      var e = t.vertexShader,
          n = t.fragmentShader,
          i = this._getShaderStage(e),
          r = this._getShaderStage(n),
          s = this._getShaderCacheForMaterial(t);

      return !1 === s.has(i) && (s.add(i), i.usedTimes++), !1 === s.has(r) && (s.add(r), r.usedTimes++), this;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      var e = this.materialCache.get(t);

      var _iterator6 = _createForOfIteratorHelper(e),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t131 = _step6.value;
          _t131.usedTimes--, 0 === _t131.usedTimes && this.shaderCache.delete(_t131.code);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return this.materialCache.delete(t), this;
    }
  }, {
    key: "getVertexShaderID",
    value: function getVertexShaderID(t) {
      return this._getShaderStage(t.vertexShader).id;
    }
  }, {
    key: "getFragmentShaderID",
    value: function getFragmentShaderID(t) {
      return this._getShaderStage(t.fragmentShader).id;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.shaderCache.clear(), this.materialCache.clear();
    }
  }, {
    key: "_getShaderCacheForMaterial",
    value: function _getShaderCacheForMaterial(t) {
      var e = this.materialCache;
      return !1 === e.has(t) && e.set(t, new Set()), e.get(t);
    }
  }, {
    key: "_getShaderStage",
    value: function _getShaderStage(t) {
      var e = this.shaderCache;

      if (!1 === e.has(t)) {
        var _n104 = new as(t);

        e.set(t, _n104);
      }

      return e.get(t);
    }
  }]);

  return ss;
}();

var as = function as(t) {
  _classCallCheck(this, as);

  this.id = rs++, this.code = t, this.usedTimes = 0;
};

function os(t, e, n, i, r, s, a) {
  var o = new Re(),
      l = new ss(),
      h = [],
      c = r.isWebGL2,
      u = r.logarithmicDepthBuffer,
      d = r.floatVertexTextures,
      p = r.maxVertexUniforms,
      m = r.vertexTextures;
  var f = r.precision;
  var g = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  return {
    getParameters: function getParameters(s, o, h, v, y) {
      var x = v.fog,
          _ = y.geometry,
          b = s.isMeshStandardMaterial ? v.environment : null,
          w = (s.isMeshStandardMaterial ? n : e).get(s.envMap || b),
          M = w && 306 === w.mapping ? w.image.height : null,
          S = g[s.type],
          T = y.isSkinnedMesh ? function (t) {
        var e = t.skeleton.bones;
        if (d) return 1024;
        {
          var _t132 = p,
              _n105 = Math.floor((_t132 - 20) / 4),
              _i91 = Math.min(_n105, e.length);

          return _i91 < e.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + e.length + " bones. This GPU supports " + _i91 + "."), 0) : _i91;
        }
      }(y) : 0;
      null !== s.precision && (f = r.getMaxPrecision(s.precision), f !== s.precision && console.warn("THREE.WebGLProgram.getParameters:", s.precision, "not supported, using", f, "instead."));
      var E = _.morphAttributes.position || _.morphAttributes.normal || _.morphAttributes.color,
          A = void 0 !== E ? E.length : 0;
      var R,
          C,
          L,
          P,
          D = 0;

      if (void 0 !== _.morphAttributes.position && (D = 1), void 0 !== _.morphAttributes.normal && (D = 2), void 0 !== _.morphAttributes.color && (D = 3), S) {
        var _t133 = si[S];
        R = _t133.vertexShader, C = _t133.fragmentShader;
      } else R = s.vertexShader, C = s.fragmentShader, l.update(s), L = l.getVertexShaderID(s), P = l.getFragmentShaderID(s);

      var I = t.getRenderTarget(),
          O = s.alphaTest > 0,
          N = s.clearcoat > 0;
      return {
        isWebGL2: c,
        shaderID: S,
        shaderName: s.type,
        vertexShader: R,
        fragmentShader: C,
        defines: s.defines,
        customVertexShaderID: L,
        customFragmentShaderID: P,
        isRawShaderMaterial: !0 === s.isRawShaderMaterial,
        glslVersion: s.glslVersion,
        precision: f,
        instancing: !0 === y.isInstancedMesh,
        instancingColor: !0 === y.isInstancedMesh && null !== y.instanceColor,
        supportsVertexTextures: m,
        outputEncoding: null === I ? t.outputEncoding : !0 === I.isXRRenderTarget ? I.texture.encoding : 3e3,
        map: !!s.map,
        matcap: !!s.matcap,
        envMap: !!w,
        envMapMode: w && w.mapping,
        envMapCubeUVHeight: M,
        lightMap: !!s.lightMap,
        aoMap: !!s.aoMap,
        emissiveMap: !!s.emissiveMap,
        bumpMap: !!s.bumpMap,
        normalMap: !!s.normalMap,
        objectSpaceNormalMap: 1 === s.normalMapType,
        tangentSpaceNormalMap: 0 === s.normalMapType,
        decodeVideoTexture: !!s.map && !0 === s.map.isVideoTexture && 3001 === s.map.encoding,
        clearcoat: N,
        clearcoatMap: N && !!s.clearcoatMap,
        clearcoatRoughnessMap: N && !!s.clearcoatRoughnessMap,
        clearcoatNormalMap: N && !!s.clearcoatNormalMap,
        displacementMap: !!s.displacementMap,
        roughnessMap: !!s.roughnessMap,
        metalnessMap: !!s.metalnessMap,
        specularMap: !!s.specularMap,
        specularIntensityMap: !!s.specularIntensityMap,
        specularColorMap: !!s.specularColorMap,
        opaque: !1 === s.transparent && 1 === s.blending,
        alphaMap: !!s.alphaMap,
        alphaTest: O,
        gradientMap: !!s.gradientMap,
        sheen: s.sheen > 0,
        sheenColorMap: !!s.sheenColorMap,
        sheenRoughnessMap: !!s.sheenRoughnessMap,
        transmission: s.transmission > 0,
        transmissionMap: !!s.transmissionMap,
        thicknessMap: !!s.thicknessMap,
        combine: s.combine,
        vertexTangents: !!s.normalMap && !!_.attributes.tangent,
        vertexColors: s.vertexColors,
        vertexAlphas: !0 === s.vertexColors && !!_.attributes.color && 4 === _.attributes.color.itemSize,
        vertexUvs: !!(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatMap || s.clearcoatRoughnessMap || s.clearcoatNormalMap || s.displacementMap || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularColorMap || s.sheenColorMap || s.sheenRoughnessMap),
        uvsVertexOnly: !(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatNormalMap || s.transmission > 0 || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularColorMap || s.sheen > 0 || s.sheenColorMap || s.sheenRoughnessMap || !s.displacementMap),
        fog: !!x,
        useFog: s.fog,
        fogExp2: x && x.isFogExp2,
        flatShading: !!s.flatShading,
        sizeAttenuation: s.sizeAttenuation,
        logarithmicDepthBuffer: u,
        skinning: !0 === y.isSkinnedMesh && T > 0,
        maxBones: T,
        useVertexTexture: d,
        morphTargets: void 0 !== _.morphAttributes.position,
        morphNormals: void 0 !== _.morphAttributes.normal,
        morphColors: void 0 !== _.morphAttributes.color,
        morphTargetsCount: A,
        morphTextureStride: D,
        numDirLights: o.directional.length,
        numPointLights: o.point.length,
        numSpotLights: o.spot.length,
        numRectAreaLights: o.rectArea.length,
        numHemiLights: o.hemi.length,
        numDirLightShadows: o.directionalShadowMap.length,
        numPointLightShadows: o.pointShadowMap.length,
        numSpotLightShadows: o.spotShadowMap.length,
        numClippingPlanes: a.numPlanes,
        numClipIntersection: a.numIntersection,
        dithering: s.dithering,
        shadowMapEnabled: t.shadowMap.enabled && h.length > 0,
        shadowMapType: t.shadowMap.type,
        toneMapping: s.toneMapped ? t.toneMapping : 0,
        physicallyCorrectLights: t.physicallyCorrectLights,
        premultipliedAlpha: s.premultipliedAlpha,
        doubleSided: 2 === s.side,
        flipSided: 1 === s.side,
        depthPacking: void 0 !== s.depthPacking && s.depthPacking,
        index0AttributeName: s.index0AttributeName,
        extensionDerivatives: s.extensions && s.extensions.derivatives,
        extensionFragDepth: s.extensions && s.extensions.fragDepth,
        extensionDrawBuffers: s.extensions && s.extensions.drawBuffers,
        extensionShaderTextureLOD: s.extensions && s.extensions.shaderTextureLOD,
        rendererExtensionFragDepth: c || i.has("EXT_frag_depth"),
        rendererExtensionDrawBuffers: c || i.has("WEBGL_draw_buffers"),
        rendererExtensionShaderTextureLod: c || i.has("EXT_shader_texture_lod"),
        customProgramCacheKey: s.customProgramCacheKey()
      };
    },
    getProgramCacheKey: function getProgramCacheKey(e) {
      var n = [];
      if (e.shaderID ? n.push(e.shaderID) : (n.push(e.customVertexShaderID), n.push(e.customFragmentShaderID)), void 0 !== e.defines) for (var _t134 in e.defines) {
        n.push(_t134), n.push(e.defines[_t134]);
      }
      return !1 === e.isRawShaderMaterial && (!function (t, e) {
        t.push(e.precision), t.push(e.outputEncoding), t.push(e.envMapMode), t.push(e.envMapCubeUVHeight), t.push(e.combine), t.push(e.vertexUvs), t.push(e.fogExp2), t.push(e.sizeAttenuation), t.push(e.maxBones), t.push(e.morphTargetsCount), t.push(e.morphAttributeCount), t.push(e.numDirLights), t.push(e.numPointLights), t.push(e.numSpotLights), t.push(e.numHemiLights), t.push(e.numRectAreaLights), t.push(e.numDirLightShadows), t.push(e.numPointLightShadows), t.push(e.numSpotLightShadows), t.push(e.shadowMapType), t.push(e.toneMapping), t.push(e.numClippingPlanes), t.push(e.numClipIntersection);
      }(n, e), function (t, e) {
        o.disableAll(), e.isWebGL2 && o.enable(0);
        e.supportsVertexTextures && o.enable(1);
        e.instancing && o.enable(2);
        e.instancingColor && o.enable(3);
        e.map && o.enable(4);
        e.matcap && o.enable(5);
        e.envMap && o.enable(6);
        e.lightMap && o.enable(7);
        e.aoMap && o.enable(8);
        e.emissiveMap && o.enable(9);
        e.bumpMap && o.enable(10);
        e.normalMap && o.enable(11);
        e.objectSpaceNormalMap && o.enable(12);
        e.tangentSpaceNormalMap && o.enable(13);
        e.clearcoat && o.enable(14);
        e.clearcoatMap && o.enable(15);
        e.clearcoatRoughnessMap && o.enable(16);
        e.clearcoatNormalMap && o.enable(17);
        e.displacementMap && o.enable(18);
        e.specularMap && o.enable(19);
        e.roughnessMap && o.enable(20);
        e.metalnessMap && o.enable(21);
        e.gradientMap && o.enable(22);
        e.alphaMap && o.enable(23);
        e.alphaTest && o.enable(24);
        e.vertexColors && o.enable(25);
        e.vertexAlphas && o.enable(26);
        e.vertexUvs && o.enable(27);
        e.vertexTangents && o.enable(28);
        e.uvsVertexOnly && o.enable(29);
        e.fog && o.enable(30);
        t.push(o.mask), o.disableAll(), e.useFog && o.enable(0);
        e.flatShading && o.enable(1);
        e.logarithmicDepthBuffer && o.enable(2);
        e.skinning && o.enable(3);
        e.useVertexTexture && o.enable(4);
        e.morphTargets && o.enable(5);
        e.morphNormals && o.enable(6);
        e.morphColors && o.enable(7);
        e.premultipliedAlpha && o.enable(8);
        e.shadowMapEnabled && o.enable(9);
        e.physicallyCorrectLights && o.enable(10);
        e.doubleSided && o.enable(11);
        e.flipSided && o.enable(12);
        e.depthPacking && o.enable(13);
        e.dithering && o.enable(14);
        e.specularIntensityMap && o.enable(15);
        e.specularColorMap && o.enable(16);
        e.transmission && o.enable(17);
        e.transmissionMap && o.enable(18);
        e.thicknessMap && o.enable(19);
        e.sheen && o.enable(20);
        e.sheenColorMap && o.enable(21);
        e.sheenRoughnessMap && o.enable(22);
        e.decodeVideoTexture && o.enable(23);
        e.opaque && o.enable(24);
        t.push(o.mask);
      }(n, e), n.push(t.outputEncoding)), n.push(e.customProgramCacheKey), n.join();
    },
    getUniforms: function getUniforms(t) {
      var e = g[t.type];
      var n;

      if (e) {
        var _t135 = si[e];
        n = zn.clone(_t135.uniforms);
      } else n = t.uniforms;

      return n;
    },
    acquireProgram: function acquireProgram(e, n) {
      var i;

      for (var _t136 = 0, _e92 = h.length; _t136 < _e92; _t136++) {
        var _e93 = h[_t136];

        if (_e93.cacheKey === n) {
          i = _e93, ++i.usedTimes;
          break;
        }
      }

      return void 0 === i && (i = new is(t, n, e, s), h.push(i)), i;
    },
    releaseProgram: function releaseProgram(t) {
      if (0 == --t.usedTimes) {
        var _e94 = h.indexOf(t);

        h[_e94] = h[h.length - 1], h.pop(), t.destroy();
      }
    },
    releaseShaderCache: function releaseShaderCache(t) {
      l.remove(t);
    },
    programs: h,
    dispose: function dispose() {
      l.dispose();
    }
  };
}

function ls() {
  var t = new WeakMap();
  return {
    get: function get(e) {
      var n = t.get(e);
      return void 0 === n && (n = {}, t.set(e, n)), n;
    },
    remove: function remove(e) {
      t.delete(e);
    },
    update: function update(e, n, i) {
      t.get(e)[n] = i;
    },
    dispose: function dispose() {
      t = new WeakMap();
    }
  };
}

function hs(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id;
}

function cs(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id;
}

function us() {
  var t = [];
  var e = 0;
  var n = [],
      i = [],
      r = [];

  function s(n, i, r, s, a, o) {
    var l = t[e];
    return void 0 === l ? (l = {
      id: n.id,
      object: n,
      geometry: i,
      material: r,
      groupOrder: s,
      renderOrder: n.renderOrder,
      z: a,
      group: o
    }, t[e] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = s, l.renderOrder = n.renderOrder, l.z = a, l.group = o), e++, l;
  }

  return {
    opaque: n,
    transmissive: i,
    transparent: r,
    init: function init() {
      e = 0, n.length = 0, i.length = 0, r.length = 0;
    },
    push: function push(t, e, a, o, l, h) {
      var c = s(t, e, a, o, l, h);
      a.transmission > 0 ? i.push(c) : !0 === a.transparent ? r.push(c) : n.push(c);
    },
    unshift: function unshift(t, e, a, o, l, h) {
      var c = s(t, e, a, o, l, h);
      a.transmission > 0 ? i.unshift(c) : !0 === a.transparent ? r.unshift(c) : n.unshift(c);
    },
    finish: function finish() {
      for (var _n106 = e, _i92 = t.length; _n106 < _i92; _n106++) {
        var _e95 = t[_n106];
        if (null === _e95.id) break;
        _e95.id = null, _e95.object = null, _e95.geometry = null, _e95.material = null, _e95.group = null;
      }
    },
    sort: function sort(t, e) {
      n.length > 1 && n.sort(t || hs), i.length > 1 && i.sort(e || cs), r.length > 1 && r.sort(e || cs);
    }
  };
}

function ds() {
  var t = new WeakMap();
  return {
    get: function get(e, n) {
      var i;
      return !1 === t.has(e) ? (i = new us(), t.set(e, [i])) : n >= t.get(e).length ? (i = new us(), t.get(e).push(i)) : i = t.get(e)[n], i;
    },
    dispose: function dispose() {
      t = new WeakMap();
    }
  };
}

function ps() {
  var t = {};
  return {
    get: function get(e) {
      if (void 0 !== t[e.id]) return t[e.id];
      var n;

      switch (e.type) {
        case "DirectionalLight":
          n = {
            direction: new zt(),
            color: new Rt()
          };
          break;

        case "SpotLight":
          n = {
            position: new zt(),
            direction: new zt(),
            color: new Rt(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;

        case "PointLight":
          n = {
            position: new zt(),
            color: new Rt(),
            distance: 0,
            decay: 0
          };
          break;

        case "HemisphereLight":
          n = {
            direction: new zt(),
            skyColor: new Rt(),
            groundColor: new Rt()
          };
          break;

        case "RectAreaLight":
          n = {
            color: new Rt(),
            position: new zt(),
            halfWidth: new zt(),
            halfHeight: new zt()
          };
      }

      return t[e.id] = n, n;
    }
  };
}

var ms = 0;

function fs(t, e) {
  return (e.castShadow ? 1 : 0) - (t.castShadow ? 1 : 0);
}

function gs(t, e) {
  var n = new ps(),
      i = function () {
    var t = {};
    return {
      get: function get(e) {
        if (void 0 !== t[e.id]) return t[e.id];
        var n;

        switch (e.type) {
          case "DirectionalLight":
          case "SpotLight":
            n = {
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new mt()
            };
            break;

          case "PointLight":
            n = {
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new mt(),
              shadowCameraNear: 1,
              shadowCameraFar: 1e3
            };
        }

        return t[e.id] = n, n;
      }
    };
  }(),
      r = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotShadow: [],
    spotShadowMap: [],
    spotShadowMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: []
  };

  for (var _t137 = 0; _t137 < 9; _t137++) {
    r.probe.push(new zt());
  }

  var s = new zt(),
      a = new ve(),
      o = new ve();
  return {
    setup: function setup(s, a) {
      var o = 0,
          l = 0,
          h = 0;

      for (var _t138 = 0; _t138 < 9; _t138++) {
        r.probe[_t138].set(0, 0, 0);
      }

      var c = 0,
          u = 0,
          d = 0,
          p = 0,
          m = 0,
          f = 0,
          g = 0,
          v = 0;
      s.sort(fs);
      var y = !0 !== a ? Math.PI : 1;

      for (var _t139 = 0, _e96 = s.length; _t139 < _e96; _t139++) {
        var _e97 = s[_t139],
            _a23 = _e97.color,
            _x4 = _e97.intensity,
            _4 = _e97.distance,
            _b = _e97.shadow && _e97.shadow.map ? _e97.shadow.map.texture : null;

        if (_e97.isAmbientLight) o += _a23.r * _x4 * y, l += _a23.g * _x4 * y, h += _a23.b * _x4 * y;else if (_e97.isLightProbe) for (var _t140 = 0; _t140 < 9; _t140++) {
          r.probe[_t140].addScaledVector(_e97.sh.coefficients[_t140], _x4);
        } else if (_e97.isDirectionalLight) {
          var _t141 = n.get(_e97);

          if (_t141.color.copy(_e97.color).multiplyScalar(_e97.intensity * y), _e97.castShadow) {
            var _t142 = _e97.shadow,
                _n107 = i.get(_e97);

            _n107.shadowBias = _t142.bias, _n107.shadowNormalBias = _t142.normalBias, _n107.shadowRadius = _t142.radius, _n107.shadowMapSize = _t142.mapSize, r.directionalShadow[c] = _n107, r.directionalShadowMap[c] = _b, r.directionalShadowMatrix[c] = _e97.shadow.matrix, f++;
          }

          r.directional[c] = _t141, c++;
        } else if (_e97.isSpotLight) {
          var _t143 = n.get(_e97);

          if (_t143.position.setFromMatrixPosition(_e97.matrixWorld), _t143.color.copy(_a23).multiplyScalar(_x4 * y), _t143.distance = _4, _t143.coneCos = Math.cos(_e97.angle), _t143.penumbraCos = Math.cos(_e97.angle * (1 - _e97.penumbra)), _t143.decay = _e97.decay, _e97.castShadow) {
            var _t144 = _e97.shadow,
                _n108 = i.get(_e97);

            _n108.shadowBias = _t144.bias, _n108.shadowNormalBias = _t144.normalBias, _n108.shadowRadius = _t144.radius, _n108.shadowMapSize = _t144.mapSize, r.spotShadow[d] = _n108, r.spotShadowMap[d] = _b, r.spotShadowMatrix[d] = _e97.shadow.matrix, v++;
          }

          r.spot[d] = _t143, d++;
        } else if (_e97.isRectAreaLight) {
          var _t145 = n.get(_e97);

          _t145.color.copy(_a23).multiplyScalar(_x4), _t145.halfWidth.set(.5 * _e97.width, 0, 0), _t145.halfHeight.set(0, .5 * _e97.height, 0), r.rectArea[p] = _t145, p++;
        } else if (_e97.isPointLight) {
          var _t146 = n.get(_e97);

          if (_t146.color.copy(_e97.color).multiplyScalar(_e97.intensity * y), _t146.distance = _e97.distance, _t146.decay = _e97.decay, _e97.castShadow) {
            var _t147 = _e97.shadow,
                _n109 = i.get(_e97);

            _n109.shadowBias = _t147.bias, _n109.shadowNormalBias = _t147.normalBias, _n109.shadowRadius = _t147.radius, _n109.shadowMapSize = _t147.mapSize, _n109.shadowCameraNear = _t147.camera.near, _n109.shadowCameraFar = _t147.camera.far, r.pointShadow[u] = _n109, r.pointShadowMap[u] = _b, r.pointShadowMatrix[u] = _e97.shadow.matrix, g++;
          }

          r.point[u] = _t146, u++;
        } else if (_e97.isHemisphereLight) {
          var _t148 = n.get(_e97);

          _t148.skyColor.copy(_e97.color).multiplyScalar(_x4 * y), _t148.groundColor.copy(_e97.groundColor).multiplyScalar(_x4 * y), r.hemi[m] = _t148, m++;
        }
      }

      p > 0 && (e.isWebGL2 || !0 === t.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = ri.LTC_FLOAT_1, r.rectAreaLTC2 = ri.LTC_FLOAT_2) : !0 === t.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = ri.LTC_HALF_1, r.rectAreaLTC2 = ri.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = h;
      var x = r.hash;
      x.directionalLength === c && x.pointLength === u && x.spotLength === d && x.rectAreaLength === p && x.hemiLength === m && x.numDirectionalShadows === f && x.numPointShadows === g && x.numSpotShadows === v || (r.directional.length = c, r.spot.length = d, r.rectArea.length = p, r.point.length = u, r.hemi.length = m, r.directionalShadow.length = f, r.directionalShadowMap.length = f, r.pointShadow.length = g, r.pointShadowMap.length = g, r.spotShadow.length = v, r.spotShadowMap.length = v, r.directionalShadowMatrix.length = f, r.pointShadowMatrix.length = g, r.spotShadowMatrix.length = v, x.directionalLength = c, x.pointLength = u, x.spotLength = d, x.rectAreaLength = p, x.hemiLength = m, x.numDirectionalShadows = f, x.numPointShadows = g, x.numSpotShadows = v, r.version = ms++);
    },
    setupView: function setupView(t, e) {
      var n = 0,
          i = 0,
          l = 0,
          h = 0,
          c = 0;
      var u = e.matrixWorldInverse;

      for (var _e98 = 0, _d10 = t.length; _e98 < _d10; _e98++) {
        var _d11 = t[_e98];

        if (_d11.isDirectionalLight) {
          var _t149 = r.directional[n];
          _t149.direction.setFromMatrixPosition(_d11.matrixWorld), s.setFromMatrixPosition(_d11.target.matrixWorld), _t149.direction.sub(s), _t149.direction.transformDirection(u), n++;
        } else if (_d11.isSpotLight) {
          var _t150 = r.spot[l];
          _t150.position.setFromMatrixPosition(_d11.matrixWorld), _t150.position.applyMatrix4(u), _t150.direction.setFromMatrixPosition(_d11.matrixWorld), s.setFromMatrixPosition(_d11.target.matrixWorld), _t150.direction.sub(s), _t150.direction.transformDirection(u), l++;
        } else if (_d11.isRectAreaLight) {
          var _t151 = r.rectArea[h];
          _t151.position.setFromMatrixPosition(_d11.matrixWorld), _t151.position.applyMatrix4(u), o.identity(), a.copy(_d11.matrixWorld), a.premultiply(u), o.extractRotation(a), _t151.halfWidth.set(.5 * _d11.width, 0, 0), _t151.halfHeight.set(0, .5 * _d11.height, 0), _t151.halfWidth.applyMatrix4(o), _t151.halfHeight.applyMatrix4(o), h++;
        } else if (_d11.isPointLight) {
          var _t152 = r.point[i];
          _t152.position.setFromMatrixPosition(_d11.matrixWorld), _t152.position.applyMatrix4(u), i++;
        } else if (_d11.isHemisphereLight) {
          var _t153 = r.hemi[c];
          _t153.direction.setFromMatrixPosition(_d11.matrixWorld), _t153.direction.transformDirection(u), _t153.direction.normalize(), c++;
        }
      }
    },
    state: r
  };
}

function vs(t, e) {
  var n = new gs(t, e),
      i = [],
      r = [];
  return {
    init: function init() {
      i.length = 0, r.length = 0;
    },
    state: {
      lightsArray: i,
      shadowsArray: r,
      lights: n
    },
    setupLights: function setupLights(t) {
      n.setup(i, t);
    },
    setupLightsView: function setupLightsView(t) {
      n.setupView(i, t);
    },
    pushLight: function pushLight(t) {
      i.push(t);
    },
    pushShadow: function pushShadow(t) {
      r.push(t);
    }
  };
}

function ys(t, e) {
  var n = new WeakMap();
  return {
    get: function get(i) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var s;
      return !1 === n.has(i) ? (s = new vs(t, e), n.set(i, [s])) : r >= n.get(i).length ? (s = new vs(t, e), n.get(i).push(s)) : s = n.get(i)[r], s;
    },
    dispose: function dispose() {
      n = new WeakMap();
    }
  };
}

var xs = /*#__PURE__*/function (_en3) {
  _inherits(xs, _en3);

  var _super30 = _createSuper(xs);

  function xs(t) {
    var _this32;

    _classCallCheck(this, xs);

    _this32 = _super30.call(this), _this32.type = "MeshDepthMaterial", _this32.depthPacking = 3200, _this32.map = null, _this32.alphaMap = null, _this32.displacementMap = null, _this32.displacementScale = 1, _this32.displacementBias = 0, _this32.wireframe = !1, _this32.wireframeLinewidth = 1, _this32.fog = !1, _this32.setValues(t);
    return _this32;
  }

  _createClass(xs, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(xs.prototype), "copy", this).call(this, t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
    }
  }]);

  return xs;
}(en);

xs.prototype.isMeshDepthMaterial = !0;

var _s = /*#__PURE__*/function (_en4) {
  _inherits(_s, _en4);

  var _super31 = _createSuper(_s);

  function _s(t) {
    var _this33;

    _classCallCheck(this, _s);

    _this33 = _super31.call(this), _this33.type = "MeshDistanceMaterial", _this33.referencePosition = new zt(), _this33.nearDistance = 1, _this33.farDistance = 1e3, _this33.map = null, _this33.alphaMap = null, _this33.displacementMap = null, _this33.displacementScale = 1, _this33.displacementBias = 0, _this33.fog = !1, _this33.setValues(t);
    return _this33;
  }

  _createClass(_s, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_s.prototype), "copy", this).call(this, t), this.referencePosition.copy(t.referencePosition), this.nearDistance = t.nearDistance, this.farDistance = t.farDistance, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
    }
  }]);

  return _s;
}(en);

_s.prototype.isMeshDistanceMaterial = !0;

function bs(t, e, n) {
  var i = new Qn();
  var r = new mt(),
      s = new mt(),
      a = new Nt(),
      o = new xs({
    depthPacking: 3201
  }),
      l = new _s(),
      h = {},
      c = n.maxTextureSize,
      u = {
    0: 1,
    1: 0,
    2: 2
  },
      d = new Hn({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: {
        value: null
      },
      resolution: {
        value: new mt()
      },
      radius: {
        value: 4
      }
    },
    vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
    fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
  }),
      p = d.clone();
  p.defines.HORIZONTAL_PASS = 1;
  var m = new vn();
  m.setAttribute("position", new an(new Float32Array([-1, -1, .5, 3, -1, .5, -1, 3, .5]), 3));
  var f = new Nn(m, d),
      g = this;

  function v(n, i) {
    var r = e.update(f);
    d.defines.VSM_SAMPLES !== n.blurSamples && (d.defines.VSM_SAMPLES = n.blurSamples, p.defines.VSM_SAMPLES = n.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, t.setRenderTarget(n.mapPass), t.clear(), t.renderBufferDirect(i, null, r, d, f, null), p.uniforms.shadow_pass.value = n.mapPass.texture, p.uniforms.resolution.value = n.mapSize, p.uniforms.radius.value = n.radius, t.setRenderTarget(n.map), t.clear(), t.renderBufferDirect(i, null, r, p, f, null);
  }

  function y(e, n, i, r, s, a) {
    var c = null;
    var d = !0 === i.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;

    if (c = void 0 !== d ? d : !0 === i.isPointLight ? l : o, t.localClippingEnabled && !0 === n.clipShadows && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0) {
      var _t154 = c.uuid,
          _e99 = n.uuid;
      var _i93 = h[_t154];
      void 0 === _i93 && (_i93 = {}, h[_t154] = _i93);
      var _r63 = _i93[_e99];
      void 0 === _r63 && (_r63 = c.clone(), _i93[_e99] = _r63), c = _r63;
    }

    return c.visible = n.visible, c.wireframe = n.wireframe, c.side = 3 === a ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : u[n.side], c.alphaMap = n.alphaMap, c.alphaTest = n.alphaTest, c.clipShadows = n.clipShadows, c.clippingPlanes = n.clippingPlanes, c.clipIntersection = n.clipIntersection, c.displacementMap = n.displacementMap, c.displacementScale = n.displacementScale, c.displacementBias = n.displacementBias, c.wireframeLinewidth = n.wireframeLinewidth, c.linewidth = n.linewidth, !0 === i.isPointLight && !0 === c.isMeshDistanceMaterial && (c.referencePosition.setFromMatrixPosition(i.matrixWorld), c.nearDistance = r, c.farDistance = s), c;
  }

  function x(n, r, s, a, o) {
    if (!1 === n.visible) return;

    if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && 3 === o) && (!n.frustumCulled || i.intersectsObject(n))) {
      n.modelViewMatrix.multiplyMatrices(s.matrixWorldInverse, n.matrixWorld);

      var _i94 = e.update(n),
          _r64 = n.material;

      if (Array.isArray(_r64)) {
        var _e100 = _i94.groups;

        for (var _l21 = 0, _h12 = _e100.length; _l21 < _h12; _l21++) {
          var _h13 = _e100[_l21],
              _c12 = _r64[_h13.materialIndex];

          if (_c12 && _c12.visible) {
            var _e101 = y(n, _c12, a, s.near, s.far, o);

            t.renderBufferDirect(s, null, _i94, _e101, n, _h13);
          }
        }
      } else if (_r64.visible) {
        var _e102 = y(n, _r64, a, s.near, s.far, o);

        t.renderBufferDirect(s, null, _i94, _e102, n, null);
      }
    }

    var l = n.children;

    for (var _t155 = 0, _e103 = l.length; _t155 < _e103; _t155++) {
      x(l[_t155], r, s, a, o);
    }
  }

  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1, this.render = function (e, n, o) {
    if (!1 === g.enabled) return;
    if (!1 === g.autoUpdate && !1 === g.needsUpdate) return;
    if (0 === e.length) return;
    var l = t.getRenderTarget(),
        h = t.getActiveCubeFace(),
        u = t.getActiveMipmapLevel(),
        d = t.state;
    d.setBlending(0), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);

    for (var _l22 = 0, _h14 = e.length; _l22 < _h14; _l22++) {
      var _h15 = e[_l22],
          _u11 = _h15.shadow;

      if (void 0 === _u11) {
        console.warn("THREE.WebGLShadowMap:", _h15, "has no shadow.");
        continue;
      }

      if (!1 === _u11.autoUpdate && !1 === _u11.needsUpdate) continue;
      r.copy(_u11.mapSize);

      var _p9 = _u11.getFrameExtents();

      if (r.multiply(_p9), s.copy(_u11.mapSize), (r.x > c || r.y > c) && (r.x > c && (s.x = Math.floor(c / _p9.x), r.x = s.x * _p9.x, _u11.mapSize.x = s.x), r.y > c && (s.y = Math.floor(c / _p9.y), r.y = s.y * _p9.y, _u11.mapSize.y = s.y)), null !== _u11.map || _u11.isPointLightShadow || 3 !== this.type || (_u11.map = new Ft(r.x, r.y), _u11.map.texture.name = _h15.name + ".shadowMap", _u11.mapPass = new Ft(r.x, r.y), _u11.camera.updateProjectionMatrix()), null === _u11.map) {
        var _t156 = {
          minFilter: 1003,
          magFilter: 1003,
          format: 1023
        };
        _u11.map = new Ft(r.x, r.y, _t156), _u11.map.texture.name = _h15.name + ".shadowMap", _u11.camera.updateProjectionMatrix();
      }

      t.setRenderTarget(_u11.map), t.clear();

      var _m6 = _u11.getViewportCount();

      for (var _t157 = 0; _t157 < _m6; _t157++) {
        var _e104 = _u11.getViewport(_t157);

        a.set(s.x * _e104.x, s.y * _e104.y, s.x * _e104.z, s.y * _e104.w), d.viewport(a), _u11.updateMatrices(_h15, _t157), i = _u11.getFrustum(), x(n, o, _u11.camera, _h15, this.type);
      }

      _u11.isPointLightShadow || 3 !== this.type || v(_u11, o), _u11.needsUpdate = !1;
    }

    g.needsUpdate = !1, t.setRenderTarget(l, h, u);
  };
}

function ws(t, e, n) {
  var i = n.isWebGL2;
  var r = new function () {
    var e = !1;
    var n = new Nt();
    var i = null;
    var r = new Nt(0, 0, 0, 0);
    return {
      setMask: function setMask(n) {
        i === n || e || (t.colorMask(n, n, n, n), i = n);
      },
      setLocked: function setLocked(t) {
        e = t;
      },
      setClear: function setClear(e, i, s, a, o) {
        !0 === o && (e *= a, i *= a, s *= a), n.set(e, i, s, a), !1 === r.equals(n) && (t.clearColor(e, i, s, a), r.copy(n));
      },
      reset: function reset() {
        e = !1, i = null, r.set(-1, 0, 0, 0);
      }
    };
  }(),
      s = new function () {
    var e = !1,
        n = null,
        i = null,
        r = null;
    return {
      setTest: function setTest(t) {
        t ? k(2929) : B(2929);
      },
      setMask: function setMask(i) {
        n === i || e || (t.depthMask(i), n = i);
      },
      setFunc: function setFunc(e) {
        if (i !== e) {
          if (e) switch (e) {
            case 0:
              t.depthFunc(512);
              break;

            case 1:
              t.depthFunc(519);
              break;

            case 2:
              t.depthFunc(513);
              break;

            case 3:
            default:
              t.depthFunc(515);
              break;

            case 4:
              t.depthFunc(514);
              break;

            case 5:
              t.depthFunc(518);
              break;

            case 6:
              t.depthFunc(516);
              break;

            case 7:
              t.depthFunc(517);
          } else t.depthFunc(515);
          i = e;
        }
      },
      setLocked: function setLocked(t) {
        e = t;
      },
      setClear: function setClear(e) {
        r !== e && (t.clearDepth(e), r = e);
      },
      reset: function reset() {
        e = !1, n = null, i = null, r = null;
      }
    };
  }(),
      a = new function () {
    var e = !1,
        n = null,
        i = null,
        r = null,
        s = null,
        a = null,
        o = null,
        l = null,
        h = null;
    return {
      setTest: function setTest(t) {
        e || (t ? k(2960) : B(2960));
      },
      setMask: function setMask(i) {
        n === i || e || (t.stencilMask(i), n = i);
      },
      setFunc: function setFunc(e, n, a) {
        i === e && r === n && s === a || (t.stencilFunc(e, n, a), i = e, r = n, s = a);
      },
      setOp: function setOp(e, n, i) {
        a === e && o === n && l === i || (t.stencilOp(e, n, i), a = e, o = n, l = i);
      },
      setLocked: function setLocked(t) {
        e = t;
      },
      setClear: function setClear(e) {
        h !== e && (t.clearStencil(e), h = e);
      },
      reset: function reset() {
        e = !1, n = null, i = null, r = null, s = null, a = null, o = null, l = null, h = null;
      }
    };
  }();

  var o = {},
      l = {},
      h = new WeakMap(),
      c = [],
      u = null,
      d = !1,
      p = null,
      m = null,
      f = null,
      g = null,
      v = null,
      y = null,
      x = null,
      _ = !1,
      b = null,
      w = null,
      M = null,
      S = null,
      T = null;

  var E = t.getParameter(35661);
  var A = !1,
      R = 0;
  var C = t.getParameter(7938);
  -1 !== C.indexOf("WebGL") ? (R = parseFloat(/^WebGL (\d)/.exec(C)[1]), A = R >= 1) : -1 !== C.indexOf("OpenGL ES") && (R = parseFloat(/^OpenGL ES (\d)/.exec(C)[1]), A = R >= 2);
  var L = null,
      P = {};
  var D = t.getParameter(3088),
      I = t.getParameter(2978),
      O = new Nt().fromArray(D),
      N = new Nt().fromArray(I);

  function F(e, n, i) {
    var r = new Uint8Array(4),
        s = t.createTexture();
    t.bindTexture(e, s), t.texParameteri(e, 10241, 9728), t.texParameteri(e, 10240, 9728);

    for (var _e105 = 0; _e105 < i; _e105++) {
      t.texImage2D(n + _e105, 0, 6408, 1, 1, 0, 6408, 5121, r);
    }

    return s;
  }

  var U = {};

  function k(e) {
    !0 !== o[e] && (t.enable(e), o[e] = !0);
  }

  function B(e) {
    !1 !== o[e] && (t.disable(e), o[e] = !1);
  }

  U[3553] = F(3553, 3553, 1), U[34067] = F(34067, 34069, 6), r.setClear(0, 0, 0, 1), s.setClear(1), a.setClear(0), k(2929), s.setFunc(3), G(!1), W(1), k(2884), V(0);
  var z = {
    100: 32774,
    101: 32778,
    102: 32779
  };
  if (i) z[103] = 32775, z[104] = 32776;else {
    var _t158 = e.get("EXT_blend_minmax");

    null !== _t158 && (z[103] = _t158.MIN_EXT, z[104] = _t158.MAX_EXT);
  }
  var H = {
    200: 0,
    201: 1,
    202: 768,
    204: 770,
    210: 776,
    208: 774,
    206: 772,
    203: 769,
    205: 771,
    209: 775,
    207: 773
  };

  function V(e, n, i, r, s, a, o, l) {
    if (0 !== e) {
      if (!1 === d && (k(3042), d = !0), 5 === e) s = s || n, a = a || i, o = o || r, n === m && s === v || (t.blendEquationSeparate(z[n], z[s]), m = n, v = s), i === f && r === g && a === y && o === x || (t.blendFuncSeparate(H[i], H[r], H[a], H[o]), f = i, g = r, y = a, x = o), p = e, _ = null;else if (e !== p || l !== _) {
        if (100 === m && 100 === v || (t.blendEquation(32774), m = 100, v = 100), l) switch (e) {
          case 1:
            t.blendFuncSeparate(1, 771, 1, 771);
            break;

          case 2:
            t.blendFunc(1, 1);
            break;

          case 3:
            t.blendFuncSeparate(0, 769, 0, 1);
            break;

          case 4:
            t.blendFuncSeparate(0, 768, 0, 770);
            break;

          default:
            console.error("THREE.WebGLState: Invalid blending: ", e);
        } else switch (e) {
          case 1:
            t.blendFuncSeparate(770, 771, 1, 771);
            break;

          case 2:
            t.blendFunc(770, 1);
            break;

          case 3:
            t.blendFuncSeparate(0, 769, 0, 1);
            break;

          case 4:
            t.blendFunc(0, 768);
            break;

          default:
            console.error("THREE.WebGLState: Invalid blending: ", e);
        }
        f = null, g = null, y = null, x = null, p = e, _ = l;
      }
    } else !0 === d && (B(3042), d = !1);
  }

  function G(e) {
    b !== e && (e ? t.frontFace(2304) : t.frontFace(2305), b = e);
  }

  function W(e) {
    0 !== e ? (k(2884), e !== w && (1 === e ? t.cullFace(1029) : 2 === e ? t.cullFace(1028) : t.cullFace(1032))) : B(2884), w = e;
  }

  function j(e, n, i) {
    e ? (k(32823), S === n && T === i || (t.polygonOffset(n, i), S = n, T = i)) : B(32823);
  }

  function q(e) {
    void 0 === e && (e = 33984 + E - 1), L !== e && (t.activeTexture(e), L = e);
  }

  return {
    buffers: {
      color: r,
      depth: s,
      stencil: a
    },
    enable: k,
    disable: B,
    bindFramebuffer: function bindFramebuffer(e, n) {
      return l[e] !== n && (t.bindFramebuffer(e, n), l[e] = n, i && (36009 === e && (l[36160] = n), 36160 === e && (l[36009] = n)), !0);
    },
    drawBuffers: function drawBuffers(i, r) {
      var s = c,
          a = !1;
      if (i) {
        if (s = h.get(r), void 0 === s && (s = [], h.set(r, s)), i.isWebGLMultipleRenderTargets) {
          var _t159 = i.texture;

          if (s.length !== _t159.length || 36064 !== s[0]) {
            for (var _e106 = 0, _n110 = _t159.length; _e106 < _n110; _e106++) {
              s[_e106] = 36064 + _e106;
            }

            s.length = _t159.length, a = !0;
          }
        } else 36064 !== s[0] && (s[0] = 36064, a = !0);
      } else 1029 !== s[0] && (s[0] = 1029, a = !0);
      a && (n.isWebGL2 ? t.drawBuffers(s) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(s));
    },
    useProgram: function useProgram(e) {
      return u !== e && (t.useProgram(e), u = e, !0);
    },
    setBlending: V,
    setMaterial: function setMaterial(t, e) {
      2 === t.side ? B(2884) : k(2884);
      var n = 1 === t.side;
      e && (n = !n), G(n), 1 === t.blending && !1 === t.transparent ? V(0) : V(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.premultipliedAlpha), s.setFunc(t.depthFunc), s.setTest(t.depthTest), s.setMask(t.depthWrite), r.setMask(t.colorWrite);
      var i = t.stencilWrite;
      a.setTest(i), i && (a.setMask(t.stencilWriteMask), a.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), a.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), j(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? k(32926) : B(32926);
    },
    setFlipSided: G,
    setCullFace: W,
    setLineWidth: function setLineWidth(e) {
      e !== M && (A && t.lineWidth(e), M = e);
    },
    setPolygonOffset: j,
    setScissorTest: function setScissorTest(t) {
      t ? k(3089) : B(3089);
    },
    activeTexture: q,
    bindTexture: function bindTexture(e, n) {
      null === L && q();
      var i = P[L];
      void 0 === i && (i = {
        type: void 0,
        texture: void 0
      }, P[L] = i), i.type === e && i.texture === n || (t.bindTexture(e, n || U[e]), i.type = e, i.texture = n);
    },
    unbindTexture: function unbindTexture() {
      var e = P[L];
      void 0 !== e && void 0 !== e.type && (t.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
    },
    compressedTexImage2D: function compressedTexImage2D() {
      try {
        t.compressedTexImage2D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texImage2D: function texImage2D() {
      try {
        t.texImage2D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texImage3D: function texImage3D() {
      try {
        t.texImage3D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texStorage2D: function texStorage2D() {
      try {
        t.texStorage2D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texStorage3D: function texStorage3D() {
      try {
        t.texStorage3D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texSubImage2D: function texSubImage2D() {
      try {
        t.texSubImage2D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texSubImage3D: function texSubImage3D() {
      try {
        t.texSubImage3D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    compressedTexSubImage2D: function compressedTexSubImage2D() {
      try {
        t.compressedTexSubImage2D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    scissor: function scissor(e) {
      !1 === O.equals(e) && (t.scissor(e.x, e.y, e.z, e.w), O.copy(e));
    },
    viewport: function viewport(e) {
      !1 === N.equals(e) && (t.viewport(e.x, e.y, e.z, e.w), N.copy(e));
    },
    reset: function reset() {
      t.disable(3042), t.disable(2884), t.disable(2929), t.disable(32823), t.disable(3089), t.disable(2960), t.disable(32926), t.blendEquation(32774), t.blendFunc(1, 0), t.blendFuncSeparate(1, 0, 1, 0), t.colorMask(!0, !0, !0, !0), t.clearColor(0, 0, 0, 0), t.depthMask(!0), t.depthFunc(513), t.clearDepth(1), t.stencilMask(4294967295), t.stencilFunc(519, 0, 4294967295), t.stencilOp(7680, 7680, 7680), t.clearStencil(0), t.cullFace(1029), t.frontFace(2305), t.polygonOffset(0, 0), t.activeTexture(33984), t.bindFramebuffer(36160, null), !0 === i && (t.bindFramebuffer(36009, null), t.bindFramebuffer(36008, null)), t.useProgram(null), t.lineWidth(1), t.scissor(0, 0, t.canvas.width, t.canvas.height), t.viewport(0, 0, t.canvas.width, t.canvas.height), o = {}, L = null, P = {}, l = {}, h = new WeakMap(), c = [], u = null, d = !1, p = null, m = null, f = null, g = null, v = null, y = null, x = null, _ = !1, b = null, w = null, M = null, S = null, T = null, O.set(0, 0, t.canvas.width, t.canvas.height), N.set(0, 0, t.canvas.width, t.canvas.height), r.reset(), s.reset(), a.reset();
    }
  };
}

function Ms(t, e, n, i, r, s, a) {
  var o = r.isWebGL2,
      l = r.maxTextures,
      h = r.maxCubemapSize,
      c = r.maxTextureSize,
      u = r.maxSamples,
      d = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null,
      p = /OculusBrowser/g.test(navigator.userAgent),
      m = new WeakMap();
  var f;
  var g = new WeakMap();
  var v = !1;

  try {
    v = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
  } catch (t) {}

  function y(t, e) {
    return v ? new OffscreenCanvas(t, e) : vt("canvas");
  }

  function x(t, e, n, i) {
    var r = 1;

    if ((t.width > i || t.height > i) && (r = i / Math.max(t.width, t.height)), r < 1 || !0 === e) {
      if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
        var _i95 = e ? dt : Math.floor,
            _s41 = _i95(r * t.width),
            _a24 = _i95(r * t.height);

        void 0 === f && (f = y(_s41, _a24));

        var _o18 = n ? y(_s41, _a24) : f;

        _o18.width = _s41, _o18.height = _a24;
        return _o18.getContext("2d").drawImage(t, 0, 0, _s41, _a24), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t.width + "x" + t.height + ") to (" + _s41 + "x" + _a24 + ")."), _o18;
      }

      return "data" in t && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t.width + "x" + t.height + ")."), t;
    }

    return t;
  }

  function _(t) {
    return ct(t.width) && ct(t.height);
  }

  function b(t, e) {
    return t.generateMipmaps && e && 1003 !== t.minFilter && 1006 !== t.minFilter;
  }

  function w(e) {
    t.generateMipmap(e);
  }

  function M(n, i, r, s) {
    var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
    if (!1 === o) return i;

    if (null !== n) {
      if (void 0 !== t[n]) return t[n];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
    }

    var l = i;
    return 6403 === i && (5126 === r && (l = 33326), 5131 === r && (l = 33325), 5121 === r && (l = 33321)), 33319 === i && (5126 === r && (l = 33328), 5131 === r && (l = 33327), 5121 === r && (l = 33323)), 6408 === i && (5126 === r && (l = 34836), 5131 === r && (l = 34842), 5121 === r && (l = 3001 === s && !1 === a ? 35907 : 32856), 32819 === r && (l = 32854), 32820 === r && (l = 32855)), 33325 !== l && 33326 !== l && 33327 !== l && 33328 !== l && 34842 !== l && 34836 !== l || e.get("EXT_color_buffer_float"), l;
  }

  function S(t, e, n) {
    return !0 === b(t, n) || t.isFramebufferTexture && 1003 !== t.minFilter && 1006 !== t.minFilter ? Math.log2(Math.max(e.width, e.height)) + 1 : void 0 !== t.mipmaps && t.mipmaps.length > 0 ? t.mipmaps.length : t.isCompressedTexture && Array.isArray(t.image) ? e.mipmaps.length : 1;
  }

  function T(t) {
    return 1003 === t || 1004 === t || 1005 === t ? 9728 : 9729;
  }

  function E(t) {
    var e = t.target;
    e.removeEventListener("dispose", E), function (t) {
      var e = i.get(t);
      if (void 0 === e.__webglInit) return;
      var n = t.source,
          r = g.get(n);

      if (r) {
        var _i96 = r[e.__cacheKey];
        _i96.usedTimes--, 0 === _i96.usedTimes && R(t), 0 === Object.keys(r).length && g.delete(n);
      }

      i.remove(t);
    }(e), e.isVideoTexture && m.delete(e);
  }

  function A(e) {
    var n = e.target;
    n.removeEventListener("dispose", A), function (e) {
      var n = e.texture,
          r = i.get(e),
          s = i.get(n);
      void 0 !== s.__webglTexture && (t.deleteTexture(s.__webglTexture), a.memory.textures--);
      e.depthTexture && e.depthTexture.dispose();
      if (e.isWebGLCubeRenderTarget) for (var _e107 = 0; _e107 < 6; _e107++) {
        t.deleteFramebuffer(r.__webglFramebuffer[_e107]), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer[_e107]);
      } else t.deleteFramebuffer(r.__webglFramebuffer), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer && t.deleteRenderbuffer(r.__webglColorRenderbuffer), r.__webglDepthRenderbuffer && t.deleteRenderbuffer(r.__webglDepthRenderbuffer);
      if (e.isWebGLMultipleRenderTargets) for (var _e108 = 0, _r65 = n.length; _e108 < _r65; _e108++) {
        var _r66 = i.get(n[_e108]);

        _r66.__webglTexture && (t.deleteTexture(_r66.__webglTexture), a.memory.textures--), i.remove(n[_e108]);
      }
      i.remove(n), i.remove(e);
    }(n);
  }

  function R(e) {
    var n = i.get(e);
    t.deleteTexture(n.__webglTexture);
    var r = e.source;
    delete g.get(r)[n.__cacheKey], a.memory.textures--;
  }

  var C = 0;

  function L(t, e) {
    var r = i.get(t);

    if (t.isVideoTexture && function (t) {
      var e = a.render.frame;
      m.get(t) !== e && (m.set(t, e), t.update());
    }(t), !1 === t.isRenderTargetTexture && t.version > 0 && r.__version !== t.version) {
      var _n111 = t.image;
      if (null === _n111) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");else {
        if (!1 !== _n111.complete) return void N(r, t, e);
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      }
    }

    n.activeTexture(33984 + e), n.bindTexture(3553, r.__webglTexture);
  }

  var P = {
    1e3: 10497,
    1001: 33071,
    1002: 33648
  },
      D = {
    1003: 9728,
    1004: 9984,
    1005: 9986,
    1006: 9729,
    1007: 9985,
    1008: 9987
  };

  function I(n, s, a) {
    if (a ? (t.texParameteri(n, 10242, P[s.wrapS]), t.texParameteri(n, 10243, P[s.wrapT]), 32879 !== n && 35866 !== n || t.texParameteri(n, 32882, P[s.wrapR]), t.texParameteri(n, 10240, D[s.magFilter]), t.texParameteri(n, 10241, D[s.minFilter])) : (t.texParameteri(n, 10242, 33071), t.texParameteri(n, 10243, 33071), 32879 !== n && 35866 !== n || t.texParameteri(n, 32882, 33071), 1001 === s.wrapS && 1001 === s.wrapT || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t.texParameteri(n, 10240, T(s.magFilter)), t.texParameteri(n, 10241, T(s.minFilter)), 1003 !== s.minFilter && 1006 !== s.minFilter && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), !0 === e.has("EXT_texture_filter_anisotropic")) {
      var _a25 = e.get("EXT_texture_filter_anisotropic");

      if (1015 === s.type && !1 === e.has("OES_texture_float_linear")) return;
      if (!1 === o && 1016 === s.type && !1 === e.has("OES_texture_half_float_linear")) return;
      (s.anisotropy > 1 || i.get(s).__currentAnisotropy) && (t.texParameterf(n, _a25.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(s.anisotropy, r.getMaxAnisotropy())), i.get(s).__currentAnisotropy = s.anisotropy);
    }
  }

  function O(e, n) {
    var i = !1;
    void 0 === e.__webglInit && (e.__webglInit = !0, n.addEventListener("dispose", E));
    var r = n.source;
    var s = g.get(r);
    void 0 === s && (s = {}, g.set(r, s));

    var o = function (t) {
      var e = [];
      return e.push(t.wrapS), e.push(t.wrapT), e.push(t.magFilter), e.push(t.minFilter), e.push(t.anisotropy), e.push(t.internalFormat), e.push(t.format), e.push(t.type), e.push(t.generateMipmaps), e.push(t.premultiplyAlpha), e.push(t.flipY), e.push(t.unpackAlignment), e.push(t.encoding), e.join();
    }(n);

    if (o !== e.__cacheKey) {
      void 0 === s[o] && (s[o] = {
        texture: t.createTexture(),
        usedTimes: 0
      }, a.memory.textures++, i = !0), s[o].usedTimes++;
      var _r67 = s[e.__cacheKey];
      void 0 !== _r67 && (s[e.__cacheKey].usedTimes--, 0 === _r67.usedTimes && R(n)), e.__cacheKey = o, e.__webglTexture = s[o].texture;
    }

    return i;
  }

  function N(e, i, r) {
    var a = 3553;
    i.isDataArrayTexture && (a = 35866), i.isData3DTexture && (a = 32879);
    var l = O(e, i),
        h = i.source;

    if (n.activeTexture(33984 + r), n.bindTexture(a, e.__webglTexture), h.version !== h.__currentVersion || !0 === l) {
      t.pixelStorei(37440, i.flipY), t.pixelStorei(37441, i.premultiplyAlpha), t.pixelStorei(3317, i.unpackAlignment), t.pixelStorei(37443, 0);

      var _r68 = function (t) {
        return !o && (1001 !== t.wrapS || 1001 !== t.wrapT || 1003 !== t.minFilter && 1006 !== t.minFilter);
      }(i) && !1 === _(i.image);

      var _l23 = x(i.image, _r68, !1, c);

      _l23 = H(i, _l23);

      var _u12 = _(_l23) || o,
          _d12 = s.convert(i.format, i.encoding);

      var _p10,
          _m7 = s.convert(i.type),
          _f4 = M(i.internalFormat, _d12, _m7, i.encoding, i.isVideoTexture);

      I(a, i, _u12);

      var _g4 = i.mipmaps,
          _v5 = o && !0 !== i.isVideoTexture,
          _y4 = void 0 === e.__version,
          _T = S(i, _l23, _u12);

      if (i.isDepthTexture) _f4 = 6402, o ? _f4 = 1015 === i.type ? 36012 : 1014 === i.type ? 33190 : 1020 === i.type ? 35056 : 33189 : 1015 === i.type && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), 1026 === i.format && 6402 === _f4 && 1012 !== i.type && 1014 !== i.type && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), i.type = 1012, _m7 = s.convert(i.type)), 1027 === i.format && 6402 === _f4 && (_f4 = 34041, 1020 !== i.type && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), i.type = 1020, _m7 = s.convert(i.type))), _v5 && _y4 ? n.texStorage2D(3553, 1, _f4, _l23.width, _l23.height) : n.texImage2D(3553, 0, _f4, _l23.width, _l23.height, 0, _d12, _m7, null);else if (i.isDataTexture) {
        if (_g4.length > 0 && _u12) {
          _v5 && _y4 && n.texStorage2D(3553, _T, _f4, _g4[0].width, _g4[0].height);

          for (var _t160 = 0, _e109 = _g4.length; _t160 < _e109; _t160++) {
            _p10 = _g4[_t160], _v5 ? n.texSubImage2D(3553, _t160, 0, 0, _p10.width, _p10.height, _d12, _m7, _p10.data) : n.texImage2D(3553, _t160, _f4, _p10.width, _p10.height, 0, _d12, _m7, _p10.data);
          }

          i.generateMipmaps = !1;
        } else _v5 ? (_y4 && n.texStorage2D(3553, _T, _f4, _l23.width, _l23.height), n.texSubImage2D(3553, 0, 0, 0, _l23.width, _l23.height, _d12, _m7, _l23.data)) : n.texImage2D(3553, 0, _f4, _l23.width, _l23.height, 0, _d12, _m7, _l23.data);
      } else if (i.isCompressedTexture) {
        _v5 && _y4 && n.texStorage2D(3553, _T, _f4, _g4[0].width, _g4[0].height);

        for (var _t161 = 0, _e110 = _g4.length; _t161 < _e110; _t161++) {
          _p10 = _g4[_t161], 1023 !== i.format ? null !== _d12 ? _v5 ? n.compressedTexSubImage2D(3553, _t161, 0, 0, _p10.width, _p10.height, _d12, _p10.data) : n.compressedTexImage2D(3553, _t161, _f4, _p10.width, _p10.height, 0, _p10.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : _v5 ? n.texSubImage2D(3553, _t161, 0, 0, _p10.width, _p10.height, _d12, _m7, _p10.data) : n.texImage2D(3553, _t161, _f4, _p10.width, _p10.height, 0, _d12, _m7, _p10.data);
        }
      } else if (i.isDataArrayTexture) _v5 ? (_y4 && n.texStorage3D(35866, _T, _f4, _l23.width, _l23.height, _l23.depth), n.texSubImage3D(35866, 0, 0, 0, 0, _l23.width, _l23.height, _l23.depth, _d12, _m7, _l23.data)) : n.texImage3D(35866, 0, _f4, _l23.width, _l23.height, _l23.depth, 0, _d12, _m7, _l23.data);else if (i.isData3DTexture) _v5 ? (_y4 && n.texStorage3D(32879, _T, _f4, _l23.width, _l23.height, _l23.depth), n.texSubImage3D(32879, 0, 0, 0, 0, _l23.width, _l23.height, _l23.depth, _d12, _m7, _l23.data)) : n.texImage3D(32879, 0, _f4, _l23.width, _l23.height, _l23.depth, 0, _d12, _m7, _l23.data);else if (i.isFramebufferTexture) _v5 && _y4 ? n.texStorage2D(3553, _T, _f4, _l23.width, _l23.height) : n.texImage2D(3553, 0, _f4, _l23.width, _l23.height, 0, _d12, _m7, null);else if (_g4.length > 0 && _u12) {
        _v5 && _y4 && n.texStorage2D(3553, _T, _f4, _g4[0].width, _g4[0].height);

        for (var _t162 = 0, _e111 = _g4.length; _t162 < _e111; _t162++) {
          _p10 = _g4[_t162], _v5 ? n.texSubImage2D(3553, _t162, 0, 0, _d12, _m7, _p10) : n.texImage2D(3553, _t162, _f4, _d12, _m7, _p10);
        }

        i.generateMipmaps = !1;
      } else _v5 ? (_y4 && n.texStorage2D(3553, _T, _f4, _l23.width, _l23.height), n.texSubImage2D(3553, 0, 0, 0, _d12, _m7, _l23)) : n.texImage2D(3553, 0, _f4, _d12, _m7, _l23);
      b(i, _u12) && w(a), h.__currentVersion = h.version, i.onUpdate && i.onUpdate(i);
    }

    e.__version = i.version;
  }

  function F(e, r, a, o, l) {
    var h = s.convert(a.format, a.encoding),
        c = s.convert(a.type),
        u = M(a.internalFormat, h, c, a.encoding);
    i.get(r).__hasExternalTextures || (32879 === l || 35866 === l ? n.texImage3D(l, 0, u, r.width, r.height, r.depth, 0, h, c, null) : n.texImage2D(l, 0, u, r.width, r.height, 0, h, c, null)), n.bindFramebuffer(36160, e), z(r) ? d.framebufferTexture2DMultisampleEXT(36160, o, l, i.get(a).__webglTexture, 0, B(r)) : t.framebufferTexture2D(36160, o, l, i.get(a).__webglTexture, 0), n.bindFramebuffer(36160, null);
  }

  function U(e, n, i) {
    if (t.bindRenderbuffer(36161, e), n.depthBuffer && !n.stencilBuffer) {
      var _r69 = 33189;

      if (i || z(n)) {
        var _e112 = n.depthTexture;
        _e112 && _e112.isDepthTexture && (1015 === _e112.type ? _r69 = 36012 : 1014 === _e112.type && (_r69 = 33190));

        var _i97 = B(n);

        z(n) ? d.renderbufferStorageMultisampleEXT(36161, _i97, _r69, n.width, n.height) : t.renderbufferStorageMultisample(36161, _i97, _r69, n.width, n.height);
      } else t.renderbufferStorage(36161, _r69, n.width, n.height);

      t.framebufferRenderbuffer(36160, 36096, 36161, e);
    } else if (n.depthBuffer && n.stencilBuffer) {
      var _r70 = B(n);

      i && !1 === z(n) ? t.renderbufferStorageMultisample(36161, _r70, 35056, n.width, n.height) : z(n) ? d.renderbufferStorageMultisampleEXT(36161, _r70, 35056, n.width, n.height) : t.renderbufferStorage(36161, 34041, n.width, n.height), t.framebufferRenderbuffer(36160, 33306, 36161, e);
    } else {
      var _e113 = !0 === n.isWebGLMultipleRenderTargets ? n.texture[0] : n.texture,
          _r71 = s.convert(_e113.format, _e113.encoding),
          _a26 = s.convert(_e113.type),
          _o19 = M(_e113.internalFormat, _r71, _a26, _e113.encoding),
          _l24 = B(n);

      i && !1 === z(n) ? t.renderbufferStorageMultisample(36161, _l24, _o19, n.width, n.height) : z(n) ? d.renderbufferStorageMultisampleEXT(36161, _l24, _o19, n.width, n.height) : t.renderbufferStorage(36161, _o19, n.width, n.height);
    }

    t.bindRenderbuffer(36161, null);
  }

  function k(e) {
    var r = i.get(e),
        s = !0 === e.isWebGLCubeRenderTarget;

    if (e.depthTexture && !r.__autoAllocateDepthBuffer) {
      if (s) throw new Error("target.depthTexture not supported in Cube render targets");
      !function (e, r) {
        if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (n.bindFramebuffer(36160, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        i.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), L(r.depthTexture, 0);

        var s = i.get(r.depthTexture).__webglTexture,
            a = B(r);

        if (1026 === r.depthTexture.format) z(r) ? d.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, s, 0, a) : t.framebufferTexture2D(36160, 36096, 3553, s, 0);else {
          if (1027 !== r.depthTexture.format) throw new Error("Unknown depthTexture format");
          z(r) ? d.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, s, 0, a) : t.framebufferTexture2D(36160, 33306, 3553, s, 0);
        }
      }(r.__webglFramebuffer, e);
    } else if (s) {
      r.__webglDepthbuffer = [];

      for (var _i98 = 0; _i98 < 6; _i98++) {
        n.bindFramebuffer(36160, r.__webglFramebuffer[_i98]), r.__webglDepthbuffer[_i98] = t.createRenderbuffer(), U(r.__webglDepthbuffer[_i98], e, !1);
      }
    } else n.bindFramebuffer(36160, r.__webglFramebuffer), r.__webglDepthbuffer = t.createRenderbuffer(), U(r.__webglDepthbuffer, e, !1);

    n.bindFramebuffer(36160, null);
  }

  function B(t) {
    return Math.min(u, t.samples);
  }

  function z(t) {
    var n = i.get(t);
    return o && t.samples > 0 && !0 === e.has("WEBGL_multisampled_render_to_texture") && !1 !== n.__useRenderToTexture;
  }

  function H(t, n) {
    var i = t.encoding,
        r = t.format,
        s = t.type;
    return !0 === t.isCompressedTexture || !0 === t.isVideoTexture || 1035 === t.format || 3e3 !== i && (3001 === i ? !1 === o ? !0 === e.has("EXT_sRGB") && 1023 === r ? (t.format = 1035, t.minFilter = 1006, t.generateMipmaps = !1) : n = Lt.sRGBToLinear(n) : 1023 === r && 1009 === s || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", i)), n;
  }

  this.allocateTextureUnit = function () {
    var t = C;
    return t >= l && console.warn("THREE.WebGLTextures: Trying to use " + t + " texture units while this GPU supports only " + l), C += 1, t;
  }, this.resetTextureUnits = function () {
    C = 0;
  }, this.setTexture2D = L, this.setTexture2DArray = function (t, e) {
    var r = i.get(t);
    t.version > 0 && r.__version !== t.version ? N(r, t, e) : (n.activeTexture(33984 + e), n.bindTexture(35866, r.__webglTexture));
  }, this.setTexture3D = function (t, e) {
    var r = i.get(t);
    t.version > 0 && r.__version !== t.version ? N(r, t, e) : (n.activeTexture(33984 + e), n.bindTexture(32879, r.__webglTexture));
  }, this.setTextureCube = function (e, r) {
    var a = i.get(e);
    e.version > 0 && a.__version !== e.version ? function (e, i, r) {
      if (6 !== i.image.length) return;
      var a = O(e, i),
          l = i.source;

      if (n.activeTexture(33984 + r), n.bindTexture(34067, e.__webglTexture), l.version !== l.__currentVersion || !0 === a) {
        t.pixelStorei(37440, i.flipY), t.pixelStorei(37441, i.premultiplyAlpha), t.pixelStorei(3317, i.unpackAlignment), t.pixelStorei(37443, 0);

        var _r72 = i.isCompressedTexture || i.image[0].isCompressedTexture,
            _a27 = i.image[0] && i.image[0].isDataTexture,
            _c13 = [];

        for (var _t163 = 0; _t163 < 6; _t163++) {
          _c13[_t163] = _r72 || _a27 ? _a27 ? i.image[_t163].image : i.image[_t163] : x(i.image[_t163], !1, !0, h), _c13[_t163] = H(i, _c13[_t163]);
        }

        var _u13 = _c13[0],
            _d13 = _(_u13) || o,
            _p11 = s.convert(i.format, i.encoding),
            _m8 = s.convert(i.type),
            _f5 = M(i.internalFormat, _p11, _m8, i.encoding),
            _g5 = o && !0 !== i.isVideoTexture,
            _v6 = void 0 === e.__version;

        var _y5,
            _T2 = S(i, _u13, _d13);

        if (I(34067, i, _d13), _r72) {
          _g5 && _v6 && n.texStorage2D(34067, _T2, _f5, _u13.width, _u13.height);

          for (var _t164 = 0; _t164 < 6; _t164++) {
            _y5 = _c13[_t164].mipmaps;

            for (var _e114 = 0; _e114 < _y5.length; _e114++) {
              var _r73 = _y5[_e114];
              1023 !== i.format ? null !== _p11 ? _g5 ? n.compressedTexSubImage2D(34069 + _t164, _e114, 0, 0, _r73.width, _r73.height, _p11, _r73.data) : n.compressedTexImage2D(34069 + _t164, _e114, _f5, _r73.width, _r73.height, 0, _r73.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : _g5 ? n.texSubImage2D(34069 + _t164, _e114, 0, 0, _r73.width, _r73.height, _p11, _m8, _r73.data) : n.texImage2D(34069 + _t164, _e114, _f5, _r73.width, _r73.height, 0, _p11, _m8, _r73.data);
            }
          }
        } else {
          _y5 = i.mipmaps, _g5 && _v6 && (_y5.length > 0 && _T2++, n.texStorage2D(34067, _T2, _f5, _c13[0].width, _c13[0].height));

          for (var _t165 = 0; _t165 < 6; _t165++) {
            if (_a27) {
              _g5 ? n.texSubImage2D(34069 + _t165, 0, 0, 0, _c13[_t165].width, _c13[_t165].height, _p11, _m8, _c13[_t165].data) : n.texImage2D(34069 + _t165, 0, _f5, _c13[_t165].width, _c13[_t165].height, 0, _p11, _m8, _c13[_t165].data);

              for (var _e115 = 0; _e115 < _y5.length; _e115++) {
                var _i99 = _y5[_e115].image[_t165].image;
                _g5 ? n.texSubImage2D(34069 + _t165, _e115 + 1, 0, 0, _i99.width, _i99.height, _p11, _m8, _i99.data) : n.texImage2D(34069 + _t165, _e115 + 1, _f5, _i99.width, _i99.height, 0, _p11, _m8, _i99.data);
              }
            } else {
              _g5 ? n.texSubImage2D(34069 + _t165, 0, 0, 0, _p11, _m8, _c13[_t165]) : n.texImage2D(34069 + _t165, 0, _f5, _p11, _m8, _c13[_t165]);

              for (var _e116 = 0; _e116 < _y5.length; _e116++) {
                var _i100 = _y5[_e116];
                _g5 ? n.texSubImage2D(34069 + _t165, _e116 + 1, 0, 0, _p11, _m8, _i100.image[_t165]) : n.texImage2D(34069 + _t165, _e116 + 1, _f5, _p11, _m8, _i100.image[_t165]);
              }
            }
          }
        }

        b(i, _d13) && w(34067), l.__currentVersion = l.version, i.onUpdate && i.onUpdate(i);
      }

      e.__version = i.version;
    }(a, e, r) : (n.activeTexture(33984 + r), n.bindTexture(34067, a.__webglTexture));
  }, this.rebindTextures = function (t, e, n) {
    var r = i.get(t);
    void 0 !== e && F(r.__webglFramebuffer, t, t.texture, 36064, 3553), void 0 !== n && k(t);
  }, this.setupRenderTarget = function (e) {
    var l = e.texture,
        h = i.get(e),
        c = i.get(l);
    e.addEventListener("dispose", A), !0 !== e.isWebGLMultipleRenderTargets && (void 0 === c.__webglTexture && (c.__webglTexture = t.createTexture()), c.__version = l.version, a.memory.textures++);
    var u = !0 === e.isWebGLCubeRenderTarget,
        d = !0 === e.isWebGLMultipleRenderTargets,
        p = _(e) || o;

    if (u) {
      h.__webglFramebuffer = [];

      for (var _e117 = 0; _e117 < 6; _e117++) {
        h.__webglFramebuffer[_e117] = t.createFramebuffer();
      }
    } else if (h.__webglFramebuffer = t.createFramebuffer(), d) {
      if (r.drawBuffers) {
        var _n112 = e.texture;

        for (var _e118 = 0, _r74 = _n112.length; _e118 < _r74; _e118++) {
          var _r75 = i.get(_n112[_e118]);

          void 0 === _r75.__webglTexture && (_r75.__webglTexture = t.createTexture(), a.memory.textures++);
        }
      } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
    } else if (o && e.samples > 0 && !1 === z(e)) {
      h.__webglMultisampledFramebuffer = t.createFramebuffer(), h.__webglColorRenderbuffer = t.createRenderbuffer(), t.bindRenderbuffer(36161, h.__webglColorRenderbuffer);

      var _i101 = s.convert(l.format, l.encoding),
          _r76 = s.convert(l.type),
          _a28 = M(l.internalFormat, _i101, _r76, l.encoding),
          _o20 = B(e);

      t.renderbufferStorageMultisample(36161, _o20, _a28, e.width, e.height), n.bindFramebuffer(36160, h.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(36160, 36064, 36161, h.__webglColorRenderbuffer), t.bindRenderbuffer(36161, null), e.depthBuffer && (h.__webglDepthRenderbuffer = t.createRenderbuffer(), U(h.__webglDepthRenderbuffer, e, !0)), n.bindFramebuffer(36160, null);
    }

    if (u) {
      n.bindTexture(34067, c.__webglTexture), I(34067, l, p);

      for (var _t166 = 0; _t166 < 6; _t166++) {
        F(h.__webglFramebuffer[_t166], e, l, 36064, 34069 + _t166);
      }

      b(l, p) && w(34067), n.unbindTexture();
    } else if (d) {
      var _t167 = e.texture;

      for (var _r77 = 0, _s42 = _t167.length; _r77 < _s42; _r77++) {
        var _s43 = _t167[_r77],
            _a29 = i.get(_s43);

        n.bindTexture(3553, _a29.__webglTexture), I(3553, _s43, p), F(h.__webglFramebuffer, e, _s43, 36064 + _r77, 3553), b(_s43, p) && w(3553);
      }

      n.unbindTexture();
    } else {
      var _t168 = 3553;
      (e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (o ? _t168 = e.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(_t168, c.__webglTexture), I(_t168, l, p), F(h.__webglFramebuffer, e, l, 36064, _t168), b(l, p) && w(_t168), n.unbindTexture();
    }

    e.depthBuffer && k(e);
  }, this.updateRenderTargetMipmap = function (t) {
    var e = _(t) || o,
        r = !0 === t.isWebGLMultipleRenderTargets ? t.texture : [t.texture];

    for (var _s44 = 0, _a30 = r.length; _s44 < _a30; _s44++) {
      var _a31 = r[_s44];

      if (b(_a31, e)) {
        var _e119 = t.isWebGLCubeRenderTarget ? 34067 : 3553,
            _r78 = i.get(_a31).__webglTexture;

        n.bindTexture(_e119, _r78), w(_e119), n.unbindTexture();
      }
    }
  }, this.updateMultisampleRenderTarget = function (e) {
    if (o && e.samples > 0 && !1 === z(e)) {
      var _r79 = e.width,
          _s45 = e.height;
      var _a32 = 16384;

      var _o21 = [36064],
          _l25 = e.stencilBuffer ? 33306 : 36096;

      e.depthBuffer && _o21.push(_l25);

      var _h16 = i.get(e),
          _c14 = void 0 !== _h16.__ignoreDepthValues && _h16.__ignoreDepthValues;

      !1 === _c14 && (e.depthBuffer && (_a32 |= 256), e.stencilBuffer && (_a32 |= 1024)), n.bindFramebuffer(36008, _h16.__webglMultisampledFramebuffer), n.bindFramebuffer(36009, _h16.__webglFramebuffer), !0 === _c14 && (t.invalidateFramebuffer(36008, [_l25]), t.invalidateFramebuffer(36009, [_l25])), t.blitFramebuffer(0, 0, _r79, _s45, 0, 0, _r79, _s45, _a32, 9728), p && t.invalidateFramebuffer(36008, _o21), n.bindFramebuffer(36008, null), n.bindFramebuffer(36009, _h16.__webglMultisampledFramebuffer);
    }
  }, this.setupDepthRenderbuffer = k, this.setupFrameBufferTexture = F, this.useMultisampledRTT = z;
}

function Ss(t, e, n) {
  var i = n.isWebGL2;
  return {
    convert: function convert(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var r;
      if (1009 === t) return 5121;
      if (1017 === t) return 32819;
      if (1018 === t) return 32820;
      if (1010 === t) return 5120;
      if (1011 === t) return 5122;
      if (1012 === t) return 5123;
      if (1013 === t) return 5124;
      if (1014 === t) return 5125;
      if (1015 === t) return 5126;
      if (1016 === t) return i ? 5131 : (r = e.get("OES_texture_half_float"), null !== r ? r.HALF_FLOAT_OES : null);
      if (1021 === t) return 6406;
      if (1023 === t) return 6408;
      if (1024 === t) return 6409;
      if (1025 === t) return 6410;
      if (1026 === t) return 6402;
      if (1027 === t) return 34041;
      if (1028 === t) return 6403;
      if (1022 === t) return console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228"), 6408;
      if (1035 === t) return r = e.get("EXT_sRGB"), null !== r ? r.SRGB_ALPHA_EXT : null;
      if (1029 === t) return 36244;
      if (1030 === t) return 33319;
      if (1031 === t) return 33320;
      if (1033 === t) return 36249;
      if (33776 === t || 33777 === t || 33778 === t || 33779 === t) if (3001 === n) {
        if (r = e.get("WEBGL_compressed_texture_s3tc_srgb"), null === r) return null;
        if (33776 === t) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
        if (33777 === t) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
        if (33778 === t) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
        if (33779 === t) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
      } else {
        if (r = e.get("WEBGL_compressed_texture_s3tc"), null === r) return null;
        if (33776 === t) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (33777 === t) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (33778 === t) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (33779 === t) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      }

      if (35840 === t || 35841 === t || 35842 === t || 35843 === t) {
        if (r = e.get("WEBGL_compressed_texture_pvrtc"), null === r) return null;
        if (35840 === t) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (35841 === t) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (35842 === t) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (35843 === t) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      }

      if (36196 === t) return r = e.get("WEBGL_compressed_texture_etc1"), null !== r ? r.COMPRESSED_RGB_ETC1_WEBGL : null;

      if (37492 === t || 37496 === t) {
        if (r = e.get("WEBGL_compressed_texture_etc"), null === r) return null;
        if (37492 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
        if (37496 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
      }

      if (37808 === t || 37809 === t || 37810 === t || 37811 === t || 37812 === t || 37813 === t || 37814 === t || 37815 === t || 37816 === t || 37817 === t || 37818 === t || 37819 === t || 37820 === t || 37821 === t) {
        if (r = e.get("WEBGL_compressed_texture_astc"), null === r) return null;
        if (37808 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (37809 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (37810 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (37811 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (37812 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (37813 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (37814 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (37815 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (37816 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (37817 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (37818 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (37819 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (37820 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (37821 === t) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
      }

      if (36492 === t) {
        if (r = e.get("EXT_texture_compression_bptc"), null === r) return null;
        if (36492 === t) return 3001 === n ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
      }

      return 1020 === t ? i ? 34042 : (r = e.get("WEBGL_depth_texture"), null !== r ? r.UNSIGNED_INT_24_8_WEBGL : null) : void 0;
    }
  };
}

var Ts = /*#__PURE__*/function (_Gn) {
  _inherits(Ts, _Gn);

  var _super32 = _createSuper(Ts);

  function Ts() {
    var _this34;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Ts);

    _this34 = _super32.call(this), _this34.cameras = t;
    return _this34;
  }

  return Ts;
}(Gn);

Ts.prototype.isArrayCamera = !0;

var Es = /*#__PURE__*/function (_Ve4) {
  _inherits(Es, _Ve4);

  var _super33 = _createSuper(Es);

  function Es() {
    var _this35;

    _classCallCheck(this, Es);

    _this35 = _super33.call(this), _this35.type = "Group";
    return _this35;
  }

  return Es;
}(Ve);

Es.prototype.isGroup = !0;
var As = {
  type: "move"
};

var Rs = /*#__PURE__*/function () {
  function Rs() {
    _classCallCheck(this, Rs);

    this._targetRay = null, this._grip = null, this._hand = null;
  }

  _createClass(Rs, [{
    key: "getHandSpace",
    value: function getHandSpace() {
      return null === this._hand && (this._hand = new Es(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
        pinching: !1
      }), this._hand;
    }
  }, {
    key: "getTargetRaySpace",
    value: function getTargetRaySpace() {
      return null === this._targetRay && (this._targetRay = new Es(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new zt(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new zt()), this._targetRay;
    }
  }, {
    key: "getGripSpace",
    value: function getGripSpace() {
      return null === this._grip && (this._grip = new Es(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new zt(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new zt()), this._grip;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(t) {
      return null !== this._targetRay && this._targetRay.dispatchEvent(t), null !== this._grip && this._grip.dispatchEvent(t), null !== this._hand && this._hand.dispatchEvent(t), this;
    }
  }, {
    key: "disconnect",
    value: function disconnect(t) {
      return this.dispatchEvent({
        type: "disconnected",
        data: t
      }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
    }
  }, {
    key: "update",
    value: function update(t, e, n) {
      var i = null,
          r = null,
          s = null;
      var a = this._targetRay,
          o = this._grip,
          l = this._hand;
      if (t && "visible-blurred" !== e.session.visibilityState) if (null !== a && (i = e.getPose(t.targetRaySpace, n), null !== i && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent(As))), l && t.hand) {
        s = !0;

        var _iterator7 = _createForOfIteratorHelper(t.hand.values()),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _i103 = _step7.value;

            var _t169 = e.getJointPose(_i103, n);

            if (void 0 === l.joints[_i103.jointName]) {
              var _t170 = new Es();

              _t170.matrixAutoUpdate = !1, _t170.visible = !1, l.joints[_i103.jointName] = _t170, l.add(_t170);
            }

            var _r81 = l.joints[_i103.jointName];
            null !== _t169 && (_r81.matrix.fromArray(_t169.transform.matrix), _r81.matrix.decompose(_r81.position, _r81.rotation, _r81.scale), _r81.jointRadius = _t169.radius), _r81.visible = null !== _t169;
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        var _i102 = l.joints["index-finger-tip"],
            _r80 = l.joints["thumb-tip"],
            _a33 = _i102.position.distanceTo(_r80.position),
            _o22 = .02,
            _h17 = .005;

        l.inputState.pinching && _a33 > _o22 + _h17 ? (l.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: t.handedness,
          target: this
        })) : !l.inputState.pinching && _a33 <= _o22 - _h17 && (l.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: t.handedness,
          target: this
        }));
      } else null !== o && t.gripSpace && (r = e.getPose(t.gripSpace, n), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
      return null !== a && (a.visible = null !== i), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== s), this;
    }
  }]);

  return Rs;
}();

var Cs = /*#__PURE__*/function (_Ot4) {
  _inherits(Cs, _Ot4);

  var _super34 = _createSuper(Cs);

  function Cs(t, e, n, i, r, s, a, o, l, h) {
    var _this36;

    _classCallCheck(this, Cs);

    if (1026 !== (h = void 0 !== h ? h : 1026) && 1027 !== h) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    void 0 === n && 1026 === h && (n = 1012), void 0 === n && 1027 === h && (n = 1020), _this36 = _super34.call(this, null, i, r, s, a, o, h, n, l), _this36.image = {
      width: t,
      height: e
    }, _this36.magFilter = void 0 !== a ? a : 1003, _this36.minFilter = void 0 !== o ? o : 1003, _this36.flipY = !1, _this36.generateMipmaps = !1;
    return _this36;
  }

  return Cs;
}(Ot);

Cs.prototype.isDepthTexture = !0;

var Ls = /*#__PURE__*/function (_et6) {
  _inherits(Ls, _et6);

  var _super35 = _createSuper(Ls);

  function Ls(t, e) {
    var _this37;

    _classCallCheck(this, Ls);

    _this37 = _super35.call(this);

    var n = _assertThisInitialized(_this37);

    var i = null,
        r = 1,
        s = null,
        a = "local-floor",
        o = null,
        l = null,
        h = null,
        c = null,
        u = null;
    var d = e.getContextAttributes();
    var p = null,
        m = null;
    var f = [],
        g = new Map(),
        v = new Gn();
    v.layers.enable(1), v.viewport = new Nt();
    var y = new Gn();
    y.layers.enable(2), y.viewport = new Nt();

    var x = [v, y],
        _ = new Ts();

    _.layers.enable(1), _.layers.enable(2);
    var b = null,
        w = null;

    function M(t) {
      var e = g.get(t.inputSource);
      e && e.dispatchEvent({
        type: t.type,
        data: t.inputSource
      });
    }

    function S() {
      g.forEach(function (t, e) {
        t.disconnect(e);
      }), g.clear(), b = null, w = null, t.setRenderTarget(p), c = null, h = null, l = null, i = null, m = null, L.stop(), n.isPresenting = !1, n.dispatchEvent({
        type: "sessionend"
      });
    }

    function T(t) {
      var e = i.inputSources;

      for (var _t171 = 0; _t171 < f.length; _t171++) {
        g.set(e[_t171], f[_t171]);
      }

      for (var _e120 = 0; _e120 < t.removed.length; _e120++) {
        var _n113 = t.removed[_e120],
            _i104 = g.get(_n113);

        _i104 && (_i104.dispatchEvent({
          type: "disconnected",
          data: _n113
        }), g.delete(_n113));
      }

      for (var _e121 = 0; _e121 < t.added.length; _e121++) {
        var _n114 = t.added[_e121],
            _i105 = g.get(_n114);

        _i105 && _i105.dispatchEvent({
          type: "connected",
          data: _n114
        });
      }
    }

    _this37.cameraAutoUpdate = !0, _this37.enabled = !1, _this37.isPresenting = !1, _this37.getController = function (t) {
      var e = f[t];
      return void 0 === e && (e = new Rs(), f[t] = e), e.getTargetRaySpace();
    }, _this37.getControllerGrip = function (t) {
      var e = f[t];
      return void 0 === e && (e = new Rs(), f[t] = e), e.getGripSpace();
    }, _this37.getHand = function (t) {
      var e = f[t];
      return void 0 === e && (e = new Rs(), f[t] = e), e.getHandSpace();
    }, _this37.setFramebufferScaleFactor = function (t) {
      r = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, _this37.setReferenceSpaceType = function (t) {
      a = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, _this37.getReferenceSpace = function () {
      return s;
    }, _this37.getBaseLayer = function () {
      return null !== h ? h : c;
    }, _this37.getBinding = function () {
      return l;
    }, _this37.getFrame = function () {
      return u;
    }, _this37.getSession = function () {
      return i;
    }, _this37.setSession = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(o) {
        var _n115, _n116, _s46, _a34, _o23;

        return _regeneratorRuntime.wrap(function _callee2$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(i = o, null !== i)) {
                  _context5.next = 33;
                  break;
                }

                p = t.getRenderTarget();
                i.addEventListener("select", M);
                i.addEventListener("selectstart", M);
                i.addEventListener("selectend", M);
                i.addEventListener("squeeze", M);
                i.addEventListener("squeezestart", M);
                i.addEventListener("squeezeend", M);
                i.addEventListener("end", S);
                i.addEventListener("inputsourceschange", T);
                _context5.t0 = !0 !== d.xrCompatible;

                if (!_context5.t0) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 14;
                return e.makeXRCompatible();

              case 14:
                if (!(void 0 === i.renderState.layers || !1 === t.capabilities.isWebGL2)) {
                  _context5.next = 19;
                  break;
                }

                _n115 = {
                  antialias: void 0 !== i.renderState.layers || d.antialias,
                  alpha: d.alpha,
                  depth: d.depth,
                  stencil: d.stencil,
                  framebufferScaleFactor: r
                };
                c = new XRWebGLLayer(i, e, _n115), i.updateRenderState({
                  baseLayer: c
                }), m = new Ft(c.framebufferWidth, c.framebufferHeight, {
                  format: 1023,
                  type: 1009,
                  encoding: t.outputEncoding
                });
                _context5.next = 24;
                break;

              case 19:
                _n116 = null, _s46 = null, _a34 = null;
                d.depth && (_a34 = d.stencil ? 35056 : 33190, _n116 = d.stencil ? 1027 : 1026, _s46 = d.stencil ? 1020 : 1012);
                _o23 = {
                  colorFormat: 3001 === t.outputEncoding ? 35907 : 32856,
                  depthFormat: _a34,
                  scaleFactor: r
                };
                l = new XRWebGLBinding(i, e), h = l.createProjectionLayer(_o23), i.updateRenderState({
                  layers: [h]
                }), m = new Ft(h.textureWidth, h.textureHeight, {
                  format: 1023,
                  type: 1009,
                  depthTexture: new Cs(h.textureWidth, h.textureHeight, _s46, void 0, void 0, void 0, void 0, void 0, void 0, _n116),
                  stencilBuffer: d.stencil,
                  encoding: t.outputEncoding,
                  samples: d.antialias ? 4 : 0
                });
                t.properties.get(m).__ignoreDepthValues = h.ignoreDepthValues;

              case 24:
                m.isXRRenderTarget = !0;
                this.setFoveation(1);
                _context5.next = 28;
                return i.requestReferenceSpace(a);

              case 28:
                s = _context5.sent;
                L.setContext(i);
                L.start();
                n.isPresenting = !0;
                n.dispatchEvent({
                  type: "sessionstart"
                });

              case 33:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x5) {
        return _ref2.apply(this, arguments);
      };
    }();
    var E = new zt(),
        A = new zt();

    function R(t, e) {
      null === e ? t.matrixWorld.copy(t.matrix) : t.matrixWorld.multiplyMatrices(e.matrixWorld, t.matrix), t.matrixWorldInverse.copy(t.matrixWorld).invert();
    }

    _this37.updateCamera = function (t) {
      if (null === i) return;
      _.near = y.near = v.near = t.near, _.far = y.far = v.far = t.far, b === _.near && w === _.far || (i.updateRenderState({
        depthNear: _.near,
        depthFar: _.far
      }), b = _.near, w = _.far);
      var e = t.parent,
          n = _.cameras;
      R(_, e);

      for (var _t172 = 0; _t172 < n.length; _t172++) {
        R(n[_t172], e);
      }

      _.matrixWorld.decompose(_.position, _.quaternion, _.scale), t.position.copy(_.position), t.quaternion.copy(_.quaternion), t.scale.copy(_.scale), t.matrix.copy(_.matrix), t.matrixWorld.copy(_.matrixWorld);
      var r = t.children;

      for (var _t173 = 0, _e122 = r.length; _t173 < _e122; _t173++) {
        r[_t173].updateMatrixWorld(!0);
      }

      2 === n.length ? function (t, e, n) {
        E.setFromMatrixPosition(e.matrixWorld), A.setFromMatrixPosition(n.matrixWorld);
        var i = E.distanceTo(A),
            r = e.projectionMatrix.elements,
            s = n.projectionMatrix.elements,
            a = r[14] / (r[10] - 1),
            o = r[14] / (r[10] + 1),
            l = (r[9] + 1) / r[5],
            h = (r[9] - 1) / r[5],
            c = (r[8] - 1) / r[0],
            u = (s[8] + 1) / s[0],
            d = a * c,
            p = a * u,
            m = i / (-c + u),
            f = m * -c;
        e.matrixWorld.decompose(t.position, t.quaternion, t.scale), t.translateX(f), t.translateZ(m), t.matrixWorld.compose(t.position, t.quaternion, t.scale), t.matrixWorldInverse.copy(t.matrixWorld).invert();

        var g = a + m,
            v = o + m,
            y = d - f,
            x = p + (i - f),
            _ = l * o / v * g,
            b = h * o / v * g;

        t.projectionMatrix.makePerspective(y, x, _, b, g, v);
      }(_, v, y) : _.projectionMatrix.copy(v.projectionMatrix);
    }, _this37.getCamera = function () {
      return _;
    }, _this37.getFoveation = function () {
      return null !== h ? h.fixedFoveation : null !== c ? c.fixedFoveation : void 0;
    }, _this37.setFoveation = function (t) {
      null !== h && (h.fixedFoveation = t), null !== c && void 0 !== c.fixedFoveation && (c.fixedFoveation = t);
    };
    var C = null;
    var L = new ti();
    L.setAnimationLoop(function (e, n) {
      if (o = n.getViewerPose(s), u = n, null !== o) {
        var _e123 = o.views;
        null !== c && (t.setRenderTargetFramebuffer(m, c.framebuffer), t.setRenderTarget(m));

        var _n117 = !1;

        _e123.length !== _.cameras.length && (_.cameras.length = 0, _n117 = !0);

        for (var _i106 = 0; _i106 < _e123.length; _i106++) {
          var _r82 = _e123[_i106];
          var _s47 = null;
          if (null !== c) _s47 = c.getViewport(_r82);else {
            var _e124 = l.getViewSubImage(h, _r82);

            _s47 = _e124.viewport, 0 === _i106 && (t.setRenderTargetTextures(m, _e124.colorTexture, h.ignoreDepthValues ? void 0 : _e124.depthStencilTexture), t.setRenderTarget(m));
          }
          var _a35 = x[_i106];
          _a35.matrix.fromArray(_r82.transform.matrix), _a35.projectionMatrix.fromArray(_r82.projectionMatrix), _a35.viewport.set(_s47.x, _s47.y, _s47.width, _s47.height), 0 === _i106 && _.matrix.copy(_a35.matrix), !0 === _n117 && _.cameras.push(_a35);
        }
      }

      var r = i.inputSources;

      for (var _t174 = 0; _t174 < f.length; _t174++) {
        var _e125 = f[_t174],
            _i107 = r[_t174];

        _e125.update(_i107, n, s);
      }

      C && C(e, n), u = null;
    }), _this37.setAnimationLoop = function (t) {
      C = t;
    }, _this37.dispose = function () {};
    return _this37;
  }

  return Ls;
}(et);

function Ps(t, e) {
  function n(n, i) {
    n.opacity.value = i.opacity, i.color && n.diffuse.value.copy(i.color), i.emissive && n.emissive.value.copy(i.emissive).multiplyScalar(i.emissiveIntensity), i.map && (n.map.value = i.map), i.alphaMap && (n.alphaMap.value = i.alphaMap), i.bumpMap && (n.bumpMap.value = i.bumpMap, n.bumpScale.value = i.bumpScale, 1 === i.side && (n.bumpScale.value *= -1)), i.displacementMap && (n.displacementMap.value = i.displacementMap, n.displacementScale.value = i.displacementScale, n.displacementBias.value = i.displacementBias), i.emissiveMap && (n.emissiveMap.value = i.emissiveMap), i.normalMap && (n.normalMap.value = i.normalMap, n.normalScale.value.copy(i.normalScale), 1 === i.side && n.normalScale.value.negate()), i.specularMap && (n.specularMap.value = i.specularMap), i.alphaTest > 0 && (n.alphaTest.value = i.alphaTest);
    var r = e.get(i).envMap;

    if (r && (n.envMap.value = r, n.flipEnvMap.value = r.isCubeTexture && !1 === r.isRenderTargetTexture ? -1 : 1, n.reflectivity.value = i.reflectivity, n.ior.value = i.ior, n.refractionRatio.value = i.refractionRatio), i.lightMap) {
      n.lightMap.value = i.lightMap;

      var _e126 = !0 !== t.physicallyCorrectLights ? Math.PI : 1;

      n.lightMapIntensity.value = i.lightMapIntensity * _e126;
    }

    var s, a;
    i.aoMap && (n.aoMap.value = i.aoMap, n.aoMapIntensity.value = i.aoMapIntensity), i.map ? s = i.map : i.specularMap ? s = i.specularMap : i.displacementMap ? s = i.displacementMap : i.normalMap ? s = i.normalMap : i.bumpMap ? s = i.bumpMap : i.roughnessMap ? s = i.roughnessMap : i.metalnessMap ? s = i.metalnessMap : i.alphaMap ? s = i.alphaMap : i.emissiveMap ? s = i.emissiveMap : i.clearcoatMap ? s = i.clearcoatMap : i.clearcoatNormalMap ? s = i.clearcoatNormalMap : i.clearcoatRoughnessMap ? s = i.clearcoatRoughnessMap : i.specularIntensityMap ? s = i.specularIntensityMap : i.specularColorMap ? s = i.specularColorMap : i.transmissionMap ? s = i.transmissionMap : i.thicknessMap ? s = i.thicknessMap : i.sheenColorMap ? s = i.sheenColorMap : i.sheenRoughnessMap && (s = i.sheenRoughnessMap), void 0 !== s && (s.isWebGLRenderTarget && (s = s.texture), !0 === s.matrixAutoUpdate && s.updateMatrix(), n.uvTransform.value.copy(s.matrix)), i.aoMap ? a = i.aoMap : i.lightMap && (a = i.lightMap), void 0 !== a && (a.isWebGLRenderTarget && (a = a.texture), !0 === a.matrixAutoUpdate && a.updateMatrix(), n.uv2Transform.value.copy(a.matrix));
  }

  return {
    refreshFogUniforms: function refreshFogUniforms(t, e) {
      t.fogColor.value.copy(e.color), e.isFog ? (t.fogNear.value = e.near, t.fogFar.value = e.far) : e.isFogExp2 && (t.fogDensity.value = e.density);
    },
    refreshMaterialUniforms: function refreshMaterialUniforms(t, i, r, s, a) {
      i.isMeshBasicMaterial || i.isMeshLambertMaterial ? n(t, i) : i.isMeshToonMaterial ? (n(t, i), function (t, e) {
        e.gradientMap && (t.gradientMap.value = e.gradientMap);
      }(t, i)) : i.isMeshPhongMaterial ? (n(t, i), function (t, e) {
        t.specular.value.copy(e.specular), t.shininess.value = Math.max(e.shininess, 1e-4);
      }(t, i)) : i.isMeshStandardMaterial ? (n(t, i), function (t, n) {
        t.roughness.value = n.roughness, t.metalness.value = n.metalness, n.roughnessMap && (t.roughnessMap.value = n.roughnessMap);
        n.metalnessMap && (t.metalnessMap.value = n.metalnessMap);
        e.get(n).envMap && (t.envMapIntensity.value = n.envMapIntensity);
      }(t, i), i.isMeshPhysicalMaterial && function (t, e, n) {
        t.ior.value = e.ior, e.sheen > 0 && (t.sheenColor.value.copy(e.sheenColor).multiplyScalar(e.sheen), t.sheenRoughness.value = e.sheenRoughness, e.sheenColorMap && (t.sheenColorMap.value = e.sheenColorMap), e.sheenRoughnessMap && (t.sheenRoughnessMap.value = e.sheenRoughnessMap));
        e.clearcoat > 0 && (t.clearcoat.value = e.clearcoat, t.clearcoatRoughness.value = e.clearcoatRoughness, e.clearcoatMap && (t.clearcoatMap.value = e.clearcoatMap), e.clearcoatRoughnessMap && (t.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap), e.clearcoatNormalMap && (t.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), t.clearcoatNormalMap.value = e.clearcoatNormalMap, 1 === e.side && t.clearcoatNormalScale.value.negate()));
        e.transmission > 0 && (t.transmission.value = e.transmission, t.transmissionSamplerMap.value = n.texture, t.transmissionSamplerSize.value.set(n.width, n.height), e.transmissionMap && (t.transmissionMap.value = e.transmissionMap), t.thickness.value = e.thickness, e.thicknessMap && (t.thicknessMap.value = e.thicknessMap), t.attenuationDistance.value = e.attenuationDistance, t.attenuationColor.value.copy(e.attenuationColor));
        t.specularIntensity.value = e.specularIntensity, t.specularColor.value.copy(e.specularColor), e.specularIntensityMap && (t.specularIntensityMap.value = e.specularIntensityMap);
        e.specularColorMap && (t.specularColorMap.value = e.specularColorMap);
      }(t, i, a)) : i.isMeshMatcapMaterial ? (n(t, i), function (t, e) {
        e.matcap && (t.matcap.value = e.matcap);
      }(t, i)) : i.isMeshDepthMaterial ? n(t, i) : i.isMeshDistanceMaterial ? (n(t, i), function (t, e) {
        t.referencePosition.value.copy(e.referencePosition), t.nearDistance.value = e.nearDistance, t.farDistance.value = e.farDistance;
      }(t, i)) : i.isMeshNormalMaterial ? n(t, i) : i.isLineBasicMaterial ? (function (t, e) {
        t.diffuse.value.copy(e.color), t.opacity.value = e.opacity;
      }(t, i), i.isLineDashedMaterial && function (t, e) {
        t.dashSize.value = e.dashSize, t.totalSize.value = e.dashSize + e.gapSize, t.scale.value = e.scale;
      }(t, i)) : i.isPointsMaterial ? function (t, e, n, i) {
        t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.size.value = e.size * n, t.scale.value = .5 * i, e.map && (t.map.value = e.map);
        e.alphaMap && (t.alphaMap.value = e.alphaMap);
        e.alphaTest > 0 && (t.alphaTest.value = e.alphaTest);
        var r;
        e.map ? r = e.map : e.alphaMap && (r = e.alphaMap);
        void 0 !== r && (!0 === r.matrixAutoUpdate && r.updateMatrix(), t.uvTransform.value.copy(r.matrix));
      }(t, i, r, s) : i.isSpriteMaterial ? function (t, e) {
        t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.rotation.value = e.rotation, e.map && (t.map.value = e.map);
        e.alphaMap && (t.alphaMap.value = e.alphaMap);
        e.alphaTest > 0 && (t.alphaTest.value = e.alphaTest);
        var n;
        e.map ? n = e.map : e.alphaMap && (n = e.alphaMap);
        void 0 !== n && (!0 === n.matrixAutoUpdate && n.updateMatrix(), t.uvTransform.value.copy(n.matrix));
      }(t, i) : i.isShadowMaterial ? (t.color.value.copy(i.color), t.opacity.value = i.opacity) : i.isShaderMaterial && (i.uniformsNeedUpdate = !1);
    }
  };
}

function Ds() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = void 0 !== t.canvas ? t.canvas : function () {
    var t = vt("canvas");
    return t.style.display = "block", t;
  }(),
      n = void 0 !== t.context ? t.context : null,
      i = void 0 === t.depth || t.depth,
      r = void 0 === t.stencil || t.stencil,
      s = void 0 !== t.antialias && t.antialias,
      a = void 0 === t.premultipliedAlpha || t.premultipliedAlpha,
      o = void 0 !== t.preserveDrawingBuffer && t.preserveDrawingBuffer,
      l = void 0 !== t.powerPreference ? t.powerPreference : "default",
      h = void 0 !== t.failIfMajorPerformanceCaveat && t.failIfMajorPerformanceCaveat;
  var c;
  c = void 0 !== t.context ? n.getContextAttributes().alpha : void 0 !== t.alpha && t.alpha;
  var u = null,
      d = null;
  var p = [],
      m = [];
  this.domElement = e, this.debug = {
    checkShaderErrors: !0
  }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = 3e3, this.physicallyCorrectLights = !1, this.toneMapping = 0, this.toneMappingExposure = 1;
  var f = this;

  var g = !1,
      v = 0,
      y = 0,
      x = null,
      _ = -1,
      b = null;

  var w = new Nt(),
      M = new Nt();
  var S = null,
      T = e.width,
      E = e.height,
      A = 1,
      R = null,
      C = null;
  var L = new Nt(0, 0, T, E),
      P = new Nt(0, 0, T, E);
  var D = !1;
  var I = new Qn();
  var O = !1,
      N = !1,
      F = null;
  var U = new ve(),
      k = new mt(),
      B = new zt(),
      z = {
    background: null,
    fog: null,
    environment: null,
    overrideMaterial: null,
    isScene: !0
  };

  function H() {
    return null === x ? A : 1;
  }

  var V,
      G,
      W,
      j,
      q,
      X,
      Y,
      J,
      Z,
      $,
      K,
      Q,
      tt,
      et,
      nt,
      it,
      rt,
      st,
      at,
      ot,
      lt,
      ht,
      ct,
      ut = n;

  function pt(t, n) {
    for (var _i108 = 0; _i108 < t.length; _i108++) {
      var _r83 = t[_i108],
          _s48 = e.getContext(_r83, n);

      if (null !== _s48) return _s48;
    }

    return null;
  }

  try {
    var _t175 = {
      alpha: !0,
      depth: i,
      stencil: r,
      antialias: s,
      premultipliedAlpha: a,
      preserveDrawingBuffer: o,
      powerPreference: l,
      failIfMajorPerformanceCaveat: h
    };

    if ("setAttribute" in e && e.setAttribute("data-engine", "three.js r139"), e.addEventListener("webglcontextlost", yt, !1), e.addEventListener("webglcontextrestored", xt, !1), null === ut) {
      var _e127 = ["webgl2", "webgl", "experimental-webgl"];
      if (!0 === f.isWebGL1Renderer && _e127.shift(), ut = pt(_e127, _t175), null === ut) throw pt(_e127) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
    }

    void 0 === ut.getShaderPrecisionFormat && (ut.getShaderPrecisionFormat = function () {
      return {
        rangeMin: 1,
        rangeMax: 1,
        precision: 1
      };
    });
  } catch (t) {
    throw console.error("THREE.WebGLRenderer: " + t.message), t;
  }

  function ft() {
    V = new Ai(ut), G = new hi(ut, V, t), V.init(G), ht = new Ss(ut, V, G), W = new ws(ut, V, G), j = new Li(ut), q = new ls(), X = new Ms(ut, V, W, q, G, ht, j), Y = new ui(f), J = new Ei(f), Z = new ei(ut, G), ct = new oi(ut, V, Z, G), $ = new Ri(ut, Z, j, ct), K = new Ni(ut, $, Z, j), at = new Oi(ut, G, X), it = new ci(q), Q = new os(f, Y, J, V, G, ct, it), tt = new Ps(f, q), et = new ds(), nt = new ys(V, G), st = new ai(f, Y, W, K, c, a), rt = new bs(f, K, G), ot = new li(ut, V, j, G), lt = new Ci(ut, V, j, G), j.programs = Q.programs, f.capabilities = G, f.extensions = V, f.properties = q, f.renderLists = et, f.shadowMap = rt, f.state = W, f.info = j;
  }

  ft();
  var gt = new Ls(f, ut);

  function yt(t) {
    t.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
  }

  function xt() {
    console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
    var t = j.autoReset,
        e = rt.enabled,
        n = rt.autoUpdate,
        i = rt.needsUpdate,
        r = rt.type;
    ft(), j.autoReset = t, rt.enabled = e, rt.autoUpdate = n, rt.needsUpdate = i, rt.type = r;
  }

  function _t(t) {
    var e = t.target;
    e.removeEventListener("dispose", _t), function (t) {
      (function (t) {
        var e = q.get(t).programs;
        void 0 !== e && (e.forEach(function (t) {
          Q.releaseProgram(t);
        }), t.isShaderMaterial && Q.releaseShaderCache(t));
      })(t), q.remove(t);
    }(e);
  }

  this.xr = gt, this.getContext = function () {
    return ut;
  }, this.getContextAttributes = function () {
    return ut.getContextAttributes();
  }, this.forceContextLoss = function () {
    var t = V.get("WEBGL_lose_context");
    t && t.loseContext();
  }, this.forceContextRestore = function () {
    var t = V.get("WEBGL_lose_context");
    t && t.restoreContext();
  }, this.getPixelRatio = function () {
    return A;
  }, this.setPixelRatio = function (t) {
    void 0 !== t && (A = t, this.setSize(T, E, !1));
  }, this.getSize = function (t) {
    return t.set(T, E);
  }, this.setSize = function (t, n, i) {
    gt.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (T = t, E = n, e.width = Math.floor(t * A), e.height = Math.floor(n * A), !1 !== i && (e.style.width = t + "px", e.style.height = n + "px"), this.setViewport(0, 0, t, n));
  }, this.getDrawingBufferSize = function (t) {
    return t.set(T * A, E * A).floor();
  }, this.setDrawingBufferSize = function (t, n, i) {
    T = t, E = n, A = i, e.width = Math.floor(t * i), e.height = Math.floor(n * i), this.setViewport(0, 0, t, n);
  }, this.getCurrentViewport = function (t) {
    return t.copy(w);
  }, this.getViewport = function (t) {
    return t.copy(L);
  }, this.setViewport = function (t, e, n, i) {
    t.isVector4 ? L.set(t.x, t.y, t.z, t.w) : L.set(t, e, n, i), W.viewport(w.copy(L).multiplyScalar(A).floor());
  }, this.getScissor = function (t) {
    return t.copy(P);
  }, this.setScissor = function (t, e, n, i) {
    t.isVector4 ? P.set(t.x, t.y, t.z, t.w) : P.set(t, e, n, i), W.scissor(M.copy(P).multiplyScalar(A).floor());
  }, this.getScissorTest = function () {
    return D;
  }, this.setScissorTest = function (t) {
    W.setScissorTest(D = t);
  }, this.setOpaqueSort = function (t) {
    R = t;
  }, this.setTransparentSort = function (t) {
    C = t;
  }, this.getClearColor = function (t) {
    return t.copy(st.getClearColor());
  }, this.setClearColor = function () {
    st.setClearColor.apply(st, arguments);
  }, this.getClearAlpha = function () {
    return st.getClearAlpha();
  }, this.setClearAlpha = function () {
    st.setClearAlpha.apply(st, arguments);
  }, this.clear = function () {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    var i = 0;
    t && (i |= 16384), e && (i |= 256), n && (i |= 1024), ut.clear(i);
  }, this.clearColor = function () {
    this.clear(!0, !1, !1);
  }, this.clearDepth = function () {
    this.clear(!1, !0, !1);
  }, this.clearStencil = function () {
    this.clear(!1, !1, !0);
  }, this.dispose = function () {
    e.removeEventListener("webglcontextlost", yt, !1), e.removeEventListener("webglcontextrestored", xt, !1), et.dispose(), nt.dispose(), q.dispose(), Y.dispose(), J.dispose(), K.dispose(), ct.dispose(), Q.dispose(), gt.dispose(), gt.removeEventListener("sessionstart", wt), gt.removeEventListener("sessionend", Mt), F && (F.dispose(), F = null), St.stop();
  }, this.renderBufferDirect = function (t, e, n, i, r, s) {
    null === e && (e = z);

    var a = r.isMesh && r.matrixWorld.determinant() < 0,
        o = function (t, e, n, i, r) {
      !0 !== e.isScene && (e = z);
      X.resetTextureUnits();
      var s = e.fog,
          a = i.isMeshStandardMaterial ? e.environment : null,
          o = null === x ? f.outputEncoding : !0 === x.isXRRenderTarget ? x.texture.encoding : 3e3,
          l = (i.isMeshStandardMaterial ? J : Y).get(i.envMap || a),
          h = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize,
          c = !!i.normalMap && !!n.attributes.tangent,
          u = !!n.morphAttributes.position,
          p = !!n.morphAttributes.normal,
          m = !!n.morphAttributes.color,
          g = i.toneMapped ? f.toneMapping : 0,
          v = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color,
          y = void 0 !== v ? v.length : 0,
          w = q.get(i),
          M = d.state.lights;

      if (!0 === O && (!0 === N || t !== b)) {
        var _e128 = t === b && i.id === _;

        it.setState(i, t, _e128);
      }

      var S = !1;
      i.version === w.__version ? w.needsLights && w.lightsStateVersion !== M.state.version || w.outputEncoding !== o || r.isInstancedMesh && !1 === w.instancing ? S = !0 : r.isInstancedMesh || !0 !== w.instancing ? r.isSkinnedMesh && !1 === w.skinning ? S = !0 : r.isSkinnedMesh || !0 !== w.skinning ? w.envMap !== l || i.fog && w.fog !== s ? S = !0 : void 0 === w.numClippingPlanes || w.numClippingPlanes === it.numPlanes && w.numIntersection === it.numIntersection ? (w.vertexAlphas !== h || w.vertexTangents !== c || w.morphTargets !== u || w.morphNormals !== p || w.morphColors !== m || w.toneMapping !== g || !0 === G.isWebGL2 && w.morphTargetsCount !== y) && (S = !0) : S = !0 : S = !0 : S = !0 : (S = !0, w.__version = i.version);
      var T = w.currentProgram;
      !0 === S && (T = Ct(i, e, r));
      var R = !1,
          C = !1,
          L = !1;
      var P = T.getUniforms(),
          D = w.uniforms;
      W.useProgram(T.program) && (R = !0, C = !0, L = !0);
      i.id !== _ && (_ = i.id, C = !0);

      if (R || b !== t) {
        if (P.setValue(ut, "projectionMatrix", t.projectionMatrix), G.logarithmicDepthBuffer && P.setValue(ut, "logDepthBufFC", 2 / (Math.log(t.far + 1) / Math.LN2)), b !== t && (b = t, C = !0, L = !0), i.isShaderMaterial || i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshStandardMaterial || i.envMap) {
          var _e129 = P.map.cameraPosition;
          void 0 !== _e129 && _e129.setValue(ut, B.setFromMatrixPosition(t.matrixWorld));
        }

        (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && P.setValue(ut, "isOrthographic", !0 === t.isOrthographicCamera), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial || i.isShadowMaterial || r.isSkinnedMesh) && P.setValue(ut, "viewMatrix", t.matrixWorldInverse);
      }

      if (r.isSkinnedMesh) {
        P.setOptional(ut, r, "bindMatrix"), P.setOptional(ut, r, "bindMatrixInverse");
        var _t176 = r.skeleton;
        _t176 && (G.floatVertexTextures ? (null === _t176.boneTexture && _t176.computeBoneTexture(), P.setValue(ut, "boneTexture", _t176.boneTexture, X), P.setValue(ut, "boneTextureSize", _t176.boneTextureSize)) : P.setOptional(ut, _t176, "boneMatrices"));
      }

      var I = n.morphAttributes;
      (void 0 !== I.position || void 0 !== I.normal || void 0 !== I.color && !0 === G.isWebGL2) && at.update(r, n, i, T);
      (C || w.receiveShadow !== r.receiveShadow) && (w.receiveShadow = r.receiveShadow, P.setValue(ut, "receiveShadow", r.receiveShadow));
      C && (P.setValue(ut, "toneMappingExposure", f.toneMappingExposure), w.needsLights && (k = L, (U = D).ambientLightColor.needsUpdate = k, U.lightProbe.needsUpdate = k, U.directionalLights.needsUpdate = k, U.directionalLightShadows.needsUpdate = k, U.pointLights.needsUpdate = k, U.pointLightShadows.needsUpdate = k, U.spotLights.needsUpdate = k, U.spotLightShadows.needsUpdate = k, U.rectAreaLights.needsUpdate = k, U.hemisphereLights.needsUpdate = k), s && i.fog && tt.refreshFogUniforms(D, s), tt.refreshMaterialUniforms(D, i, A, E, F), Br.upload(ut, w.uniformsList, D, X));
      var U, k;
      i.isShaderMaterial && !0 === i.uniformsNeedUpdate && (Br.upload(ut, w.uniformsList, D, X), i.uniformsNeedUpdate = !1);
      i.isSpriteMaterial && P.setValue(ut, "center", r.center);
      return P.setValue(ut, "modelViewMatrix", r.modelViewMatrix), P.setValue(ut, "normalMatrix", r.normalMatrix), P.setValue(ut, "modelMatrix", r.matrixWorld), T;
    }(t, e, n, i, r);

    W.setMaterial(i, a);
    var l = n.index;
    var h = n.attributes.position;

    if (null === l) {
      if (void 0 === h || 0 === h.count) return;
    } else if (0 === l.count) return;

    var c,
        u = 1;
    !0 === i.wireframe && (l = $.getWireframeAttribute(n), u = 2), ct.setup(r, i, o, n, l);
    var p = ot;
    null !== l && (c = Z.get(l), p = lt, p.setIndex(c));
    var m = null !== l ? l.count : h.count,
        g = n.drawRange.start * u,
        v = n.drawRange.count * u,
        y = null !== s ? s.start * u : 0,
        w = null !== s ? s.count * u : 1 / 0,
        M = Math.max(g, y),
        S = Math.min(m, g + v, y + w) - 1,
        T = Math.max(0, S - M + 1);

    if (0 !== T) {
      if (r.isMesh) !0 === i.wireframe ? (W.setLineWidth(i.wireframeLinewidth * H()), p.setMode(1)) : p.setMode(4);else if (r.isLine) {
        var _t177 = i.linewidth;
        void 0 === _t177 && (_t177 = 1), W.setLineWidth(_t177 * H()), r.isLineSegments ? p.setMode(1) : r.isLineLoop ? p.setMode(2) : p.setMode(3);
      } else r.isPoints ? p.setMode(0) : r.isSprite && p.setMode(4);
      if (r.isInstancedMesh) p.renderInstances(M, T, r.count);else if (n.isInstancedBufferGeometry) {
        var _t178 = Math.min(n.instanceCount, n._maxInstanceCount);

        p.renderInstances(M, T, _t178);
      } else p.render(M, T);
    }
  }, this.compile = function (t, e) {
    d = nt.get(t), d.init(), m.push(d), t.traverseVisible(function (t) {
      t.isLight && t.layers.test(e.layers) && (d.pushLight(t), t.castShadow && d.pushShadow(t));
    }), d.setupLights(f.physicallyCorrectLights), t.traverse(function (e) {
      var n = e.material;
      if (n) if (Array.isArray(n)) for (var _i109 = 0; _i109 < n.length; _i109++) {
        Ct(n[_i109], t, e);
      } else Ct(n, t, e);
    }), m.pop(), d = null;
  };
  var bt = null;

  function wt() {
    St.stop();
  }

  function Mt() {
    St.start();
  }

  var St = new ti();

  function Tt(t, e, n, i) {
    if (!1 === t.visible) return;
    if (t.layers.test(e.layers)) if (t.isGroup) n = t.renderOrder;else if (t.isLOD) !0 === t.autoUpdate && t.update(e);else if (t.isLight) d.pushLight(t), t.castShadow && d.pushShadow(t);else if (t.isSprite) {
      if (!t.frustumCulled || I.intersectsSprite(t)) {
        i && B.setFromMatrixPosition(t.matrixWorld).applyMatrix4(U);

        var _e130 = K.update(t),
            _r84 = t.material;

        _r84.visible && u.push(t, _e130, _r84, n, B.z, null);
      }
    } else if ((t.isMesh || t.isLine || t.isPoints) && (t.isSkinnedMesh && t.skeleton.frame !== j.render.frame && (t.skeleton.update(), t.skeleton.frame = j.render.frame), !t.frustumCulled || I.intersectsObject(t))) {
      i && B.setFromMatrixPosition(t.matrixWorld).applyMatrix4(U);

      var _e131 = K.update(t),
          _r85 = t.material;

      if (Array.isArray(_r85)) {
        var _i110 = _e131.groups;

        for (var _s49 = 0, _a36 = _i110.length; _s49 < _a36; _s49++) {
          var _a37 = _i110[_s49],
              _o24 = _r85[_a37.materialIndex];
          _o24 && _o24.visible && u.push(t, _e131, _o24, n, B.z, _a37);
        }
      } else _r85.visible && u.push(t, _e131, _r85, n, B.z, null);
    }
    var r = t.children;

    for (var _t179 = 0, _s50 = r.length; _t179 < _s50; _t179++) {
      Tt(r[_t179], e, n, i);
    }
  }

  function Et(t, e, n, i) {
    var r = t.opaque,
        a = t.transmissive,
        o = t.transparent;
    d.setupLightsView(n), a.length > 0 && function (t, e, n) {
      var i = G.isWebGL2;
      null === F && (F = new Ft(1, 1, {
        generateMipmaps: !0,
        type: null !== ht.convert(1016) ? 1016 : 1009,
        minFilter: 1008,
        samples: i && !0 === s ? 4 : 0
      }));
      f.getDrawingBufferSize(k), i ? F.setSize(k.x, k.y) : F.setSize(dt(k.x), dt(k.y));
      var r = f.getRenderTarget();
      f.setRenderTarget(F), f.clear();
      var a = f.toneMapping;
      f.toneMapping = 0, At(t, e, n), f.toneMapping = a, X.updateMultisampleRenderTarget(F), X.updateRenderTargetMipmap(F), f.setRenderTarget(r);
    }(r, e, n), i && W.viewport(w.copy(i)), r.length > 0 && At(r, e, n), a.length > 0 && At(a, e, n), o.length > 0 && At(o, e, n), W.buffers.depth.setTest(!0), W.buffers.depth.setMask(!0), W.buffers.color.setMask(!0), W.setPolygonOffset(!1);
  }

  function At(t, e, n) {
    var i = !0 === e.isScene ? e.overrideMaterial : null;

    for (var _r86 = 0, _s51 = t.length; _r86 < _s51; _r86++) {
      var _s52 = t[_r86],
          _a38 = _s52.object,
          _o25 = _s52.geometry,
          _l26 = null === i ? _s52.material : i,
          _h18 = _s52.group;

      _a38.layers.test(n.layers) && Rt(_a38, e, n, _o25, _l26, _h18);
    }
  }

  function Rt(t, e, n, i, r, s) {
    t.onBeforeRender(f, e, n, i, r, s), t.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix), r.onBeforeRender(f, e, n, i, t, s), !0 === r.transparent && 2 === r.side ? (r.side = 1, r.needsUpdate = !0, f.renderBufferDirect(n, e, i, r, t, s), r.side = 0, r.needsUpdate = !0, f.renderBufferDirect(n, e, i, r, t, s), r.side = 2) : f.renderBufferDirect(n, e, i, r, t, s), t.onAfterRender(f, e, n, i, r, s);
  }

  function Ct(t, e, n) {
    !0 !== e.isScene && (e = z);
    var i = q.get(t),
        r = d.state.lights,
        s = d.state.shadowsArray,
        a = r.state.version,
        o = Q.getParameters(t, r.state, s, e, n),
        l = Q.getProgramCacheKey(o);
    var h = i.programs;
    i.environment = t.isMeshStandardMaterial ? e.environment : null, i.fog = e.fog, i.envMap = (t.isMeshStandardMaterial ? J : Y).get(t.envMap || i.environment), void 0 === h && (t.addEventListener("dispose", _t), h = new Map(), i.programs = h);
    var c = h.get(l);

    if (void 0 !== c) {
      if (i.currentProgram === c && i.lightsStateVersion === a) return Lt(t, o), c;
    } else o.uniforms = Q.getUniforms(t), t.onBuild(n, o, f), t.onBeforeCompile(o, f), c = Q.acquireProgram(o, l), h.set(l, c), i.uniforms = o.uniforms;

    var u = i.uniforms;
    (t.isShaderMaterial || t.isRawShaderMaterial) && !0 !== t.clipping || (u.clippingPlanes = it.uniform), Lt(t, o), i.needsLights = function (t) {
      return t.isMeshLambertMaterial || t.isMeshToonMaterial || t.isMeshPhongMaterial || t.isMeshStandardMaterial || t.isShadowMaterial || t.isShaderMaterial && !0 === t.lights;
    }(t), i.lightsStateVersion = a, i.needsLights && (u.ambientLightColor.value = r.state.ambient, u.lightProbe.value = r.state.probe, u.directionalLights.value = r.state.directional, u.directionalLightShadows.value = r.state.directionalShadow, u.spotLights.value = r.state.spot, u.spotLightShadows.value = r.state.spotShadow, u.rectAreaLights.value = r.state.rectArea, u.ltc_1.value = r.state.rectAreaLTC1, u.ltc_2.value = r.state.rectAreaLTC2, u.pointLights.value = r.state.point, u.pointLightShadows.value = r.state.pointShadow, u.hemisphereLights.value = r.state.hemi, u.directionalShadowMap.value = r.state.directionalShadowMap, u.directionalShadowMatrix.value = r.state.directionalShadowMatrix, u.spotShadowMap.value = r.state.spotShadowMap, u.spotShadowMatrix.value = r.state.spotShadowMatrix, u.pointShadowMap.value = r.state.pointShadowMap, u.pointShadowMatrix.value = r.state.pointShadowMatrix);
    var p = c.getUniforms(),
        m = Br.seqWithValue(p.seq, u);
    return i.currentProgram = c, i.uniformsList = m, c;
  }

  function Lt(t, e) {
    var n = q.get(t);
    n.outputEncoding = e.outputEncoding, n.instancing = e.instancing, n.skinning = e.skinning, n.morphTargets = e.morphTargets, n.morphNormals = e.morphNormals, n.morphColors = e.morphColors, n.morphTargetsCount = e.morphTargetsCount, n.numClippingPlanes = e.numClippingPlanes, n.numIntersection = e.numClipIntersection, n.vertexAlphas = e.vertexAlphas, n.vertexTangents = e.vertexTangents, n.toneMapping = e.toneMapping;
  }

  St.setAnimationLoop(function (t) {
    bt && bt(t);
  }), "undefined" != typeof self && St.setContext(self), this.setAnimationLoop = function (t) {
    bt = t, gt.setAnimationLoop(t), null === t ? St.stop() : St.start();
  }, gt.addEventListener("sessionstart", wt), gt.addEventListener("sessionend", Mt), this.render = function (t, e) {
    if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
    if (!0 === g) return;
    !0 === t.autoUpdate && t.updateMatrixWorld(), null === e.parent && e.updateMatrixWorld(), !0 === gt.enabled && !0 === gt.isPresenting && (!0 === gt.cameraAutoUpdate && gt.updateCamera(e), e = gt.getCamera()), !0 === t.isScene && t.onBeforeRender(f, t, e, x), d = nt.get(t, m.length), d.init(), m.push(d), U.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), I.setFromProjectionMatrix(U), N = this.localClippingEnabled, O = it.init(this.clippingPlanes, N, e), u = et.get(t, p.length), u.init(), p.push(u), Tt(t, e, 0, f.sortObjects), u.finish(), !0 === f.sortObjects && u.sort(R, C), !0 === O && it.beginShadows();
    var n = d.state.shadowsArray;

    if (rt.render(n, t, e), !0 === O && it.endShadows(), !0 === this.info.autoReset && this.info.reset(), st.render(u, t), d.setupLights(f.physicallyCorrectLights), e.isArrayCamera) {
      var _n118 = e.cameras;

      for (var _e132 = 0, _i111 = _n118.length; _e132 < _i111; _e132++) {
        var _i112 = _n118[_e132];
        Et(u, t, _i112, _i112.viewport);
      }
    } else Et(u, t, e);

    null !== x && (X.updateMultisampleRenderTarget(x), X.updateRenderTargetMipmap(x)), !0 === t.isScene && t.onAfterRender(f, t, e), ct.resetDefaultState(), _ = -1, b = null, m.pop(), d = m.length > 0 ? m[m.length - 1] : null, p.pop(), u = p.length > 0 ? p[p.length - 1] : null;
  }, this.getActiveCubeFace = function () {
    return v;
  }, this.getActiveMipmapLevel = function () {
    return y;
  }, this.getRenderTarget = function () {
    return x;
  }, this.setRenderTargetTextures = function (t, e, n) {
    q.get(t.texture).__webglTexture = e, q.get(t.depthTexture).__webglTexture = n;
    var i = q.get(t);
    i.__hasExternalTextures = !0, i.__hasExternalTextures && (i.__autoAllocateDepthBuffer = void 0 === n, i.__autoAllocateDepthBuffer || !0 === V.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), i.__useRenderToTexture = !1));
  }, this.setRenderTargetFramebuffer = function (t, e) {
    var n = q.get(t);
    n.__webglFramebuffer = e, n.__useDefaultFramebuffer = void 0 === e;
  }, this.setRenderTarget = function (t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    x = t, v = e, y = n;
    var i = !0;

    if (t) {
      var _e133 = q.get(t);

      void 0 !== _e133.__useDefaultFramebuffer ? (W.bindFramebuffer(36160, null), i = !1) : void 0 === _e133.__webglFramebuffer ? X.setupRenderTarget(t) : _e133.__hasExternalTextures && X.rebindTextures(t, q.get(t.texture).__webglTexture, q.get(t.depthTexture).__webglTexture);
    }

    var r = null,
        s = !1,
        a = !1;

    if (t) {
      var _n119 = t.texture;
      (_n119.isData3DTexture || _n119.isDataArrayTexture) && (a = !0);

      var _i113 = q.get(t).__webglFramebuffer;

      t.isWebGLCubeRenderTarget ? (r = _i113[e], s = !0) : r = G.isWebGL2 && t.samples > 0 && !1 === X.useMultisampledRTT(t) ? q.get(t).__webglMultisampledFramebuffer : _i113, w.copy(t.viewport), M.copy(t.scissor), S = t.scissorTest;
    } else w.copy(L).multiplyScalar(A).floor(), M.copy(P).multiplyScalar(A).floor(), S = D;

    if (W.bindFramebuffer(36160, r) && G.drawBuffers && i && W.drawBuffers(t, r), W.viewport(w), W.scissor(M), W.setScissorTest(S), s) {
      var _i114 = q.get(t.texture);

      ut.framebufferTexture2D(36160, 36064, 34069 + e, _i114.__webglTexture, n);
    } else if (a) {
      var _i115 = q.get(t.texture),
          _r87 = e || 0;

      ut.framebufferTextureLayer(36160, 36064, _i115.__webglTexture, n || 0, _r87);
    }

    _ = -1;
  }, this.readRenderTargetPixels = function (t, e, n, i, r, s, a) {
    if (!t || !t.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");

    var o = q.get(t).__webglFramebuffer;

    if (t.isWebGLCubeRenderTarget && void 0 !== a && (o = o[a]), o) {
      W.bindFramebuffer(36160, o);

      try {
        var _a39 = t.texture,
            _o26 = _a39.format,
            _l27 = _a39.type;
        if (1023 !== _o26 && ht.convert(_o26) !== ut.getParameter(35739)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");

        var _h19 = 1016 === _l27 && (V.has("EXT_color_buffer_half_float") || G.isWebGL2 && V.has("EXT_color_buffer_float"));

        if (!(1009 === _l27 || ht.convert(_l27) === ut.getParameter(35738) || 1015 === _l27 && (G.isWebGL2 || V.has("OES_texture_float") || V.has("WEBGL_color_buffer_float")) || _h19)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
        e >= 0 && e <= t.width - i && n >= 0 && n <= t.height - r && ut.readPixels(e, n, i, r, ht.convert(_o26), ht.convert(_l27), s);
      } finally {
        var _t180 = null !== x ? q.get(x).__webglFramebuffer : null;

        W.bindFramebuffer(36160, _t180);
      }
    }
  }, this.copyFramebufferToTexture = function (t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (!0 !== e.isFramebufferTexture) return void console.error("THREE.WebGLRenderer: copyFramebufferToTexture() can only be used with FramebufferTexture.");
    var i = Math.pow(2, -n),
        r = Math.floor(e.image.width * i),
        s = Math.floor(e.image.height * i);
    X.setTexture2D(e, 0), ut.copyTexSubImage2D(3553, n, 0, 0, t.x, t.y, r, s), W.unbindTexture();
  }, this.copyTextureToTexture = function (t, e, n) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var r = e.image.width,
        s = e.image.height,
        a = ht.convert(n.format),
        o = ht.convert(n.type);
    X.setTexture2D(n, 0), ut.pixelStorei(37440, n.flipY), ut.pixelStorei(37441, n.premultiplyAlpha), ut.pixelStorei(3317, n.unpackAlignment), e.isDataTexture ? ut.texSubImage2D(3553, i, t.x, t.y, r, s, a, o, e.image.data) : e.isCompressedTexture ? ut.compressedTexSubImage2D(3553, i, t.x, t.y, e.mipmaps[0].width, e.mipmaps[0].height, a, e.mipmaps[0].data) : ut.texSubImage2D(3553, i, t.x, t.y, a, o, e.image), 0 === i && n.generateMipmaps && ut.generateMipmap(3553), W.unbindTexture();
  }, this.copyTextureToTexture3D = function (t, e, n, i) {
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    if (f.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
    var s = t.max.x - t.min.x + 1,
        a = t.max.y - t.min.y + 1,
        o = t.max.z - t.min.z + 1,
        l = ht.convert(i.format),
        h = ht.convert(i.type);
    var c;
    if (i.isData3DTexture) X.setTexture3D(i, 0), c = 32879;else {
      if (!i.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
      X.setTexture2DArray(i, 0), c = 35866;
    }
    ut.pixelStorei(37440, i.flipY), ut.pixelStorei(37441, i.premultiplyAlpha), ut.pixelStorei(3317, i.unpackAlignment);
    var u = ut.getParameter(3314),
        d = ut.getParameter(32878),
        p = ut.getParameter(3316),
        m = ut.getParameter(3315),
        g = ut.getParameter(32877),
        v = n.isCompressedTexture ? n.mipmaps[0] : n.image;
    ut.pixelStorei(3314, v.width), ut.pixelStorei(32878, v.height), ut.pixelStorei(3316, t.min.x), ut.pixelStorei(3315, t.min.y), ut.pixelStorei(32877, t.min.z), n.isDataTexture || n.isData3DTexture ? ut.texSubImage3D(c, r, e.x, e.y, e.z, s, a, o, l, h, v.data) : n.isCompressedTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), ut.compressedTexSubImage3D(c, r, e.x, e.y, e.z, s, a, o, l, v.data)) : ut.texSubImage3D(c, r, e.x, e.y, e.z, s, a, o, l, h, v), ut.pixelStorei(3314, u), ut.pixelStorei(32878, d), ut.pixelStorei(3316, p), ut.pixelStorei(3315, m), ut.pixelStorei(32877, g), 0 === r && i.generateMipmaps && ut.generateMipmap(c), W.unbindTexture();
  }, this.initTexture = function (t) {
    X.setTexture2D(t, 0), W.unbindTexture();
  }, this.resetState = function () {
    v = 0, y = 0, x = null, W.reset(), ct.reset();
  }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
    detail: this
  }));
}

Ds.prototype.isWebGLRenderer = !0;

/*#__PURE__*/
(function (_Ds) {
  _inherits(_class6, _Ds);

  var _super36 = _createSuper(_class6);

  function _class6() {
    _classCallCheck(this, _class6);

    return _super36.apply(this, arguments);
  }

  return _class6;
})(Ds).prototype.isWebGL1Renderer = !0;

var Is = /*#__PURE__*/function (_Ve5) {
  _inherits(Is, _Ve5);

  var _super37 = _createSuper(Is);

  function Is() {
    var _this38;

    _classCallCheck(this, Is);

    _this38 = _super37.call(this), _this38.type = "Scene", _this38.background = null, _this38.environment = null, _this38.fog = null, _this38.overrideMaterial = null, _this38.autoUpdate = !0, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
      detail: _assertThisInitialized(_this38)
    }));
    return _this38;
  }

  _createClass(Is, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(Is.prototype), "copy", this).call(this, t, e), null !== t.background && (this.background = t.background.clone()), null !== t.environment && (this.environment = t.environment.clone()), null !== t.fog && (this.fog = t.fog.clone()), null !== t.overrideMaterial && (this.overrideMaterial = t.overrideMaterial.clone()), this.autoUpdate = t.autoUpdate, this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(Is.prototype), "toJSON", this).call(this, t);

      return null !== this.fog && (e.object.fog = this.fog.toJSON()), e;
    }
  }]);

  return Is;
}(Ve);

Is.prototype.isScene = !0;

var Os = /*#__PURE__*/function () {
  function Os(t, e) {
    _classCallCheck(this, Os);

    this.array = t, this.stride = e, this.count = void 0 !== t ? t.length / e : 0, this.usage = 35044, this.updateRange = {
      offset: 0,
      count: -1
    }, this.version = 0, this.uuid = at();
  }

  _createClass(Os, [{
    key: "onUploadCallback",
    value: function onUploadCallback() {}
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }, {
    key: "setUsage",
    value: function setUsage(t) {
      return this.usage = t, this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
    }
  }, {
    key: "copyAt",
    value: function copyAt(t, e, n) {
      t *= this.stride, n *= e.stride;

      for (var _i116 = 0, _r88 = this.stride; _i116 < _r88; _i116++) {
        this.array[t + _i116] = e.array[n + _i116];
      }

      return this;
    }
  }, {
    key: "set",
    value: function set(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.array.set(t, e), this;
    }
  }, {
    key: "clone",
    value: function clone(t) {
      void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = at()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
      var e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]),
          n = new this.constructor(e, this.stride);
      return n.setUsage(this.usage), n;
    }
  }, {
    key: "onUpload",
    value: function onUpload(t) {
      return this.onUploadCallback = t, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      return void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = at()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer))), {
        uuid: this.uuid,
        buffer: this.array.buffer._uuid,
        type: this.array.constructor.name,
        stride: this.stride
      };
    }
  }]);

  return Os;
}();

Os.prototype.isInterleavedBuffer = !0;
var Ns = new zt();

var Fs = /*#__PURE__*/function () {
  function Fs(t, e, n) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

    _classCallCheck(this, Fs);

    this.name = "", this.data = t, this.itemSize = e, this.offset = n, this.normalized = !0 === i;
  }

  _createClass(Fs, [{
    key: "count",
    get: function get() {
      return this.data.count;
    }
  }, {
    key: "array",
    get: function get() {
      return this.data.array;
    }
  }, {
    key: "needsUpdate",
    set: function set(t) {
      this.data.needsUpdate = t;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      for (var _e134 = 0, _n120 = this.data.count; _e134 < _n120; _e134++) {
        Ns.fromBufferAttribute(this, _e134), Ns.applyMatrix4(t), this.setXYZ(_e134, Ns.x, Ns.y, Ns.z);
      }

      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(t) {
      for (var _e135 = 0, _n121 = this.count; _e135 < _n121; _e135++) {
        Ns.fromBufferAttribute(this, _e135), Ns.applyNormalMatrix(t), this.setXYZ(_e135, Ns.x, Ns.y, Ns.z);
      }

      return this;
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(t) {
      for (var _e136 = 0, _n122 = this.count; _e136 < _n122; _e136++) {
        Ns.fromBufferAttribute(this, _e136), Ns.transformDirection(t), this.setXYZ(_e136, Ns.x, Ns.y, Ns.z);
      }

      return this;
    }
  }, {
    key: "setX",
    value: function setX(t, e) {
      return this.data.array[t * this.data.stride + this.offset] = e, this;
    }
  }, {
    key: "setY",
    value: function setY(t, e) {
      return this.data.array[t * this.data.stride + this.offset + 1] = e, this;
    }
  }, {
    key: "setZ",
    value: function setZ(t, e) {
      return this.data.array[t * this.data.stride + this.offset + 2] = e, this;
    }
  }, {
    key: "setW",
    value: function setW(t, e) {
      return this.data.array[t * this.data.stride + this.offset + 3] = e, this;
    }
  }, {
    key: "getX",
    value: function getX(t) {
      return this.data.array[t * this.data.stride + this.offset];
    }
  }, {
    key: "getY",
    value: function getY(t) {
      return this.data.array[t * this.data.stride + this.offset + 1];
    }
  }, {
    key: "getZ",
    value: function getZ(t) {
      return this.data.array[t * this.data.stride + this.offset + 2];
    }
  }, {
    key: "getW",
    value: function getW(t) {
      return this.data.array[t * this.data.stride + this.offset + 3];
    }
  }, {
    key: "setXY",
    value: function setXY(t, e, n) {
      return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this;
    }
  }, {
    key: "setXYZ",
    value: function setXYZ(t, e, n, i) {
      return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this;
    }
  }, {
    key: "setXYZW",
    value: function setXYZW(t, e, n, i, r) {
      return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this.data.array[t + 3] = r, this;
    }
  }, {
    key: "clone",
    value: function clone(t) {
      if (void 0 === t) {
        console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
        var _t181 = [];

        for (var _e137 = 0; _e137 < this.count; _e137++) {
          var _n123 = _e137 * this.data.stride + this.offset;

          for (var _e138 = 0; _e138 < this.itemSize; _e138++) {
            _t181.push(this.data.array[_n123 + _e138]);
          }
        }

        return new an(new this.array.constructor(_t181), this.itemSize, this.normalized);
      }

      return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new Fs(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      if (void 0 === t) {
        console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
        var _t182 = [];

        for (var _e139 = 0; _e139 < this.count; _e139++) {
          var _n124 = _e139 * this.data.stride + this.offset;

          for (var _e140 = 0; _e140 < this.itemSize; _e140++) {
            _t182.push(this.data.array[_n124 + _e140]);
          }
        }

        return {
          itemSize: this.itemSize,
          type: this.array.constructor.name,
          array: _t182,
          normalized: this.normalized
        };
      }

      return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
    }
  }]);

  return Fs;
}();

Fs.prototype.isInterleavedBufferAttribute = !0;

var Us = /*#__PURE__*/function (_en5) {
  _inherits(Us, _en5);

  var _super38 = _createSuper(Us);

  function Us(t) {
    var _this39;

    _classCallCheck(this, Us);

    _this39 = _super38.call(this), _this39.type = "SpriteMaterial", _this39.color = new Rt(16777215), _this39.map = null, _this39.alphaMap = null, _this39.rotation = 0, _this39.sizeAttenuation = !0, _this39.transparent = !0, _this39.setValues(t);
    return _this39;
  }

  _createClass(Us, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Us.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.rotation = t.rotation, this.sizeAttenuation = t.sizeAttenuation, this;
    }
  }]);

  return Us;
}(en);

var ks;
Us.prototype.isSpriteMaterial = !0;
var Bs = new zt(),
    zs = new zt(),
    Hs = new zt(),
    Vs = new mt(),
    Gs = new mt(),
    Ws = new ve(),
    js = new zt(),
    qs = new zt(),
    Xs = new zt(),
    Ys = new mt(),
    Js = new mt(),
    Zs = new mt();

function $s(t, e, n, i, r, s) {
  Vs.subVectors(t, n).addScalar(.5).multiply(i), void 0 !== r ? (Gs.x = s * Vs.x - r * Vs.y, Gs.y = r * Vs.x + s * Vs.y) : Gs.copy(Vs), t.copy(e), t.x += Gs.x, t.y += Gs.y, t.applyMatrix4(Ws);
}

/*#__PURE__*/
(function (_Ve6) {
  _inherits(_class7, _Ve6);

  var _super39 = _createSuper(_class7);

  function _class7(t) {
    var _this40;

    _classCallCheck(this, _class7);

    if (_this40 = _super39.call(this), _this40.type = "Sprite", void 0 === ks) {
      ks = new vn();

      var _t183 = new Float32Array([-.5, -.5, 0, 0, 0, .5, -.5, 0, 1, 0, .5, .5, 0, 1, 1, -.5, .5, 0, 0, 1]),
          _e141 = new Os(_t183, 5);

      ks.setIndex([0, 1, 2, 0, 2, 3]), ks.setAttribute("position", new Fs(_e141, 3, 0, !1)), ks.setAttribute("uv", new Fs(_e141, 2, 3, !1));
    }

    _this40.geometry = ks, _this40.material = void 0 !== t ? t : new Us(), _this40.center = new mt(.5, .5);
    return _possibleConstructorReturn(_this40);
  }

  _createClass(_class7, [{
    key: "raycast",
    value: function raycast(t, e) {
      null === t.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), zs.setFromMatrixScale(this.matrixWorld), Ws.copy(t.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t.camera.matrixWorldInverse, this.matrixWorld), Hs.setFromMatrixPosition(this.modelViewMatrix), t.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && zs.multiplyScalar(-Hs.z);
      var n = this.material.rotation;
      var i, r;
      0 !== n && (r = Math.cos(n), i = Math.sin(n));
      var s = this.center;
      $s(js.set(-.5, -.5, 0), Hs, s, zs, i, r), $s(qs.set(.5, -.5, 0), Hs, s, zs, i, r), $s(Xs.set(.5, .5, 0), Hs, s, zs, i, r), Ys.set(0, 0), Js.set(1, 0), Zs.set(1, 1);
      var a = t.ray.intersectTriangle(js, qs, Xs, !1, Bs);
      if (null === a && ($s(qs.set(-.5, .5, 0), Hs, s, zs, i, r), Js.set(0, 1), a = t.ray.intersectTriangle(js, Xs, qs, !1, Bs), null === a)) return;
      var o = t.ray.origin.distanceTo(Bs);
      o < t.near || o > t.far || e.push({
        distance: o,
        point: Bs.clone(),
        uv: Qe.getUV(Bs, js, qs, Xs, Ys, Js, Zs, new mt()),
        face: null,
        object: this
      });
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class7.prototype), "copy", this).call(this, t), void 0 !== t.center && this.center.copy(t.center), this.material = t.material, this;
    }
  }]);

  return _class7;
})(Ve).prototype.isSprite = !0;
var Ks = new zt(),
    Qs = new Nt(),
    ta = new Nt(),
    ea = new zt(),
    na = new ve();

var ia = /*#__PURE__*/function (_Nn) {
  _inherits(ia, _Nn);

  var _super40 = _createSuper(ia);

  function ia(t, e) {
    var _this41;

    _classCallCheck(this, ia);

    _this41 = _super40.call(this, t, e), _this41.type = "SkinnedMesh", _this41.bindMode = "attached", _this41.bindMatrix = new ve(), _this41.bindMatrixInverse = new ve();
    return _this41;
  }

  _createClass(ia, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ia.prototype), "copy", this).call(this, t), this.bindMode = t.bindMode, this.bindMatrix.copy(t.bindMatrix), this.bindMatrixInverse.copy(t.bindMatrixInverse), this.skeleton = t.skeleton, this;
    }
  }, {
    key: "bind",
    value: function bind(t, e) {
      this.skeleton = t, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
    }
  }, {
    key: "pose",
    value: function pose() {
      this.skeleton.pose();
    }
  }, {
    key: "normalizeSkinWeights",
    value: function normalizeSkinWeights() {
      var t = new Nt(),
          e = this.geometry.attributes.skinWeight;

      for (var _n125 = 0, _i117 = e.count; _n125 < _i117; _n125++) {
        t.fromBufferAttribute(e, _n125);

        var _i118 = 1 / t.manhattanLength();

        _i118 !== 1 / 0 ? t.multiplyScalar(_i118) : t.set(1, 0, 0, 0), e.setXYZW(_n125, t.x, t.y, t.z, t.w);
      }
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      _get(_getPrototypeOf(ia.prototype), "updateMatrixWorld", this).call(this, t), "attached" === this.bindMode ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : "detached" === this.bindMode ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
  }, {
    key: "boneTransform",
    value: function boneTransform(t, e) {
      var n = this.skeleton,
          i = this.geometry;
      Qs.fromBufferAttribute(i.attributes.skinIndex, t), ta.fromBufferAttribute(i.attributes.skinWeight, t), Ks.copy(e).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);

      for (var _t184 = 0; _t184 < 4; _t184++) {
        var _i119 = ta.getComponent(_t184);

        if (0 !== _i119) {
          var _r89 = Qs.getComponent(_t184);

          na.multiplyMatrices(n.bones[_r89].matrixWorld, n.boneInverses[_r89]), e.addScaledVector(ea.copy(Ks).applyMatrix4(na), _i119);
        }
      }

      return e.applyMatrix4(this.bindMatrixInverse);
    }
  }]);

  return ia;
}(Nn);

ia.prototype.isSkinnedMesh = !0;

var ra = /*#__PURE__*/function (_Ve7) {
  _inherits(ra, _Ve7);

  var _super41 = _createSuper(ra);

  function ra() {
    var _this42;

    _classCallCheck(this, ra);

    _this42 = _super41.call(this), _this42.type = "Bone";
    return _this42;
  }

  return ra;
}(Ve);

ra.prototype.isBone = !0;

var sa = /*#__PURE__*/function (_Ot5) {
  _inherits(sa, _Ot5);

  var _super42 = _createSuper(sa);

  function sa() {
    var _this43;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 ? arguments[3] : undefined;
    var r = arguments.length > 4 ? arguments[4] : undefined;
    var s = arguments.length > 5 ? arguments[5] : undefined;
    var a = arguments.length > 6 ? arguments[6] : undefined;
    var o = arguments.length > 7 ? arguments[7] : undefined;
    var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1003;
    var h = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 1003;
    var c = arguments.length > 10 ? arguments[10] : undefined;
    var u = arguments.length > 11 ? arguments[11] : undefined;

    _classCallCheck(this, sa);

    _this43 = _super42.call(this, null, s, a, o, l, h, i, r, c, u), _this43.image = {
      data: t,
      width: e,
      height: n
    }, _this43.generateMipmaps = !1, _this43.flipY = !1, _this43.unpackAlignment = 1;
    return _this43;
  }

  return sa;
}(Ot);

sa.prototype.isDataTexture = !0;
var aa = new ve(),
    oa = new ve();

var la = /*#__PURE__*/function () {
  function la() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, la);

    this.uuid = at(), this.bones = t.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
  }

  _createClass(la, [{
    key: "init",
    value: function init() {
      var t = this.bones,
          e = this.boneInverses;
      if (this.boneMatrices = new Float32Array(16 * t.length), 0 === e.length) this.calculateInverses();else if (t.length !== e.length) {
        console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];

        for (var _t185 = 0, _e142 = this.bones.length; _t185 < _e142; _t185++) {
          this.boneInverses.push(new ve());
        }
      }
    }
  }, {
    key: "calculateInverses",
    value: function calculateInverses() {
      this.boneInverses.length = 0;

      for (var _t186 = 0, _e143 = this.bones.length; _t186 < _e143; _t186++) {
        var _e144 = new ve();

        this.bones[_t186] && _e144.copy(this.bones[_t186].matrixWorld).invert(), this.boneInverses.push(_e144);
      }
    }
  }, {
    key: "pose",
    value: function pose() {
      for (var _t187 = 0, _e145 = this.bones.length; _t187 < _e145; _t187++) {
        var _e146 = this.bones[_t187];
        _e146 && _e146.matrixWorld.copy(this.boneInverses[_t187]).invert();
      }

      for (var _t188 = 0, _e147 = this.bones.length; _t188 < _e147; _t188++) {
        var _e148 = this.bones[_t188];
        _e148 && (_e148.parent && _e148.parent.isBone ? (_e148.matrix.copy(_e148.parent.matrixWorld).invert(), _e148.matrix.multiply(_e148.matrixWorld)) : _e148.matrix.copy(_e148.matrixWorld), _e148.matrix.decompose(_e148.position, _e148.quaternion, _e148.scale));
      }
    }
  }, {
    key: "update",
    value: function update() {
      var t = this.bones,
          e = this.boneInverses,
          n = this.boneMatrices,
          i = this.boneTexture;

      for (var _i120 = 0, _r90 = t.length; _i120 < _r90; _i120++) {
        var _r91 = t[_i120] ? t[_i120].matrixWorld : oa;

        aa.multiplyMatrices(_r91, e[_i120]), aa.toArray(n, 16 * _i120);
      }

      null !== i && (i.needsUpdate = !0);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new la(this.bones, this.boneInverses);
    }
  }, {
    key: "computeBoneTexture",
    value: function computeBoneTexture() {
      var t = Math.sqrt(4 * this.bones.length);
      t = ut(t), t = Math.max(t, 4);
      var e = new Float32Array(t * t * 4);
      e.set(this.boneMatrices);
      var n = new sa(e, t, t, 1023, 1015);
      return n.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = n, this.boneTextureSize = t, this;
    }
  }, {
    key: "getBoneByName",
    value: function getBoneByName(t) {
      for (var _e149 = 0, _n126 = this.bones.length; _e149 < _n126; _e149++) {
        var _n127 = this.bones[_e149];
        if (_n127.name === t) return _n127;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t, e) {
      this.uuid = t.uuid;

      for (var _n128 = 0, _i121 = t.bones.length; _n128 < _i121; _n128++) {
        var _i122 = t.bones[_n128];
        var _r92 = e[_i122];
        void 0 === _r92 && (console.warn("THREE.Skeleton: No bone found with UUID:", _i122), _r92 = new ra()), this.bones.push(_r92), this.boneInverses.push(new ve().fromArray(t.boneInverses[_n128]));
      }

      return this.init(), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        metadata: {
          version: 4.5,
          type: "Skeleton",
          generator: "Skeleton.toJSON"
        },
        bones: [],
        boneInverses: []
      };
      t.uuid = this.uuid;
      var e = this.bones,
          n = this.boneInverses;

      for (var _i123 = 0, _r93 = e.length; _i123 < _r93; _i123++) {
        var _r94 = e[_i123];
        t.bones.push(_r94.uuid);
        var _s53 = n[_i123];
        t.boneInverses.push(_s53.toArray());
      }

      return t;
    }
  }]);

  return la;
}();

var ha = /*#__PURE__*/function (_an5) {
  _inherits(ha, _an5);

  var _super43 = _createSuper(ha);

  function ha(t, e, n) {
    var _this44;

    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, ha);

    "number" == typeof n && (i = n, n = !1, console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.")), _this44 = _super43.call(this, t, e, n), _this44.meshPerAttribute = i;
    return _this44;
  }

  _createClass(ha, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ha.prototype), "copy", this).call(this, t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(ha.prototype), "toJSON", this).call(this);

      return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
    }
  }]);

  return ha;
}(an);

ha.prototype.isInstancedBufferAttribute = !0;
var ca = new ve(),
    ua = new ve(),
    da = [],
    pa = new Nn();

/*#__PURE__*/
(function (_Nn2) {
  _inherits(_class8, _Nn2);

  var _super44 = _createSuper(_class8);

  function _class8(t, e, n) {
    var _this45;

    _classCallCheck(this, _class8);

    _this45 = _super44.call(this, t, e), _this45.instanceMatrix = new ha(new Float32Array(16 * n), 16), _this45.instanceColor = null, _this45.count = n, _this45.frustumCulled = !1;
    return _this45;
  }

  _createClass(_class8, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class8.prototype), "copy", this).call(this, t), this.instanceMatrix.copy(t.instanceMatrix), null !== t.instanceColor && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, this;
    }
  }, {
    key: "getColorAt",
    value: function getColorAt(t, e) {
      e.fromArray(this.instanceColor.array, 3 * t);
    }
  }, {
    key: "getMatrixAt",
    value: function getMatrixAt(t, e) {
      e.fromArray(this.instanceMatrix.array, 16 * t);
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.matrixWorld,
          i = this.count;
      if (pa.geometry = this.geometry, pa.material = this.material, void 0 !== pa.material) for (var _r95 = 0; _r95 < i; _r95++) {
        this.getMatrixAt(_r95, ca), ua.multiplyMatrices(n, ca), pa.matrixWorld = ua, pa.raycast(t, da);

        for (var _t189 = 0, _n129 = da.length; _t189 < _n129; _t189++) {
          var _n130 = da[_t189];
          _n130.instanceId = _r95, _n130.object = this, e.push(_n130);
        }

        da.length = 0;
      }
    }
  }, {
    key: "setColorAt",
    value: function setColorAt(t, e) {
      null === this.instanceColor && (this.instanceColor = new ha(new Float32Array(3 * this.instanceMatrix.count), 3)), e.toArray(this.instanceColor.array, 3 * t);
    }
  }, {
    key: "setMatrixAt",
    value: function setMatrixAt(t, e) {
      e.toArray(this.instanceMatrix.array, 16 * t);
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {}
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }]);

  return _class8;
})(Nn).prototype.isInstancedMesh = !0;

var ma = /*#__PURE__*/function (_en6) {
  _inherits(ma, _en6);

  var _super45 = _createSuper(ma);

  function ma(t) {
    var _this46;

    _classCallCheck(this, ma);

    _this46 = _super45.call(this), _this46.type = "LineBasicMaterial", _this46.color = new Rt(16777215), _this46.linewidth = 1, _this46.linecap = "round", _this46.linejoin = "round", _this46.setValues(t);
    return _this46;
  }

  _createClass(ma, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ma.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this;
    }
  }]);

  return ma;
}(en);

ma.prototype.isLineBasicMaterial = !0;
var fa = new zt(),
    ga = new zt(),
    va = new ve(),
    ya = new ge(),
    xa = new le();

var _a = /*#__PURE__*/function (_Ve8) {
  _inherits(_a, _Ve8);

  var _super46 = _createSuper(_a);

  function _a() {
    var _this47;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new vn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new ma();

    _classCallCheck(this, _a);

    _this47 = _super46.call(this), _this47.type = "Line", _this47.geometry = t, _this47.material = e, _this47.updateMorphTargets();
    return _this47;
  }

  _createClass(_a, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_a.prototype), "copy", this).call(this, t), this.material = t.material, this.geometry = t.geometry, this;
    }
  }, {
    key: "computeLineDistances",
    value: function computeLineDistances() {
      var t = this.geometry;
      if (t.isBufferGeometry) {
        if (null === t.index) {
          var _e150 = t.attributes.position,
              _n131 = [0];

          for (var _t190 = 1, _i124 = _e150.count; _t190 < _i124; _t190++) {
            fa.fromBufferAttribute(_e150, _t190 - 1), ga.fromBufferAttribute(_e150, _t190), _n131[_t190] = _n131[_t190 - 1], _n131[_t190] += fa.distanceTo(ga);
          }

          t.setAttribute("lineDistance", new hn(_n131, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      } else t.isGeometry && console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      return this;
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.geometry,
          i = this.matrixWorld,
          r = t.params.Line.threshold,
          s = n.drawRange;
      if (null === n.boundingSphere && n.computeBoundingSphere(), xa.copy(n.boundingSphere), xa.applyMatrix4(i), xa.radius += r, !1 === t.ray.intersectsSphere(xa)) return;
      va.copy(i).invert(), ya.copy(t.ray).applyMatrix4(va);
      var a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          o = a * a,
          l = new zt(),
          h = new zt(),
          c = new zt(),
          u = new zt(),
          d = this.isLineSegments ? 2 : 1;

      if (n.isBufferGeometry) {
        var _i125 = n.index,
            _r96 = n.attributes.position;

        if (null !== _i125) {
          for (var _n132 = Math.max(0, s.start), _a40 = Math.min(_i125.count, s.start + s.count) - 1; _n132 < _a40; _n132 += d) {
            var _s54 = _i125.getX(_n132),
                _a41 = _i125.getX(_n132 + 1);

            l.fromBufferAttribute(_r96, _s54), h.fromBufferAttribute(_r96, _a41);
            if (ya.distanceSqToSegment(l, h, u, c) > o) continue;
            u.applyMatrix4(this.matrixWorld);

            var _d14 = t.ray.origin.distanceTo(u);

            _d14 < t.near || _d14 > t.far || e.push({
              distance: _d14,
              point: c.clone().applyMatrix4(this.matrixWorld),
              index: _n132,
              face: null,
              faceIndex: null,
              object: this
            });
          }
        } else {
          for (var _n133 = Math.max(0, s.start), _i126 = Math.min(_r96.count, s.start + s.count) - 1; _n133 < _i126; _n133 += d) {
            l.fromBufferAttribute(_r96, _n133), h.fromBufferAttribute(_r96, _n133 + 1);
            if (ya.distanceSqToSegment(l, h, u, c) > o) continue;
            u.applyMatrix4(this.matrixWorld);

            var _i127 = t.ray.origin.distanceTo(u);

            _i127 < t.near || _i127 > t.far || e.push({
              distance: _i127,
              point: c.clone().applyMatrix4(this.matrixWorld),
              index: _n133,
              face: null,
              faceIndex: null,
              object: this
            });
          }
        }
      } else n.isGeometry && console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var t = this.geometry;

      if (t.isBufferGeometry) {
        var _e151 = t.morphAttributes,
            _n134 = Object.keys(_e151);

        if (_n134.length > 0) {
          var _t191 = _e151[_n134[0]];

          if (void 0 !== _t191) {
            this.morphTargetInfluences = [], this.morphTargetDictionary = {};

            for (var _e152 = 0, _n135 = _t191.length; _e152 < _n135; _e152++) {
              var _n136 = _t191[_e152].name || String(_e152);

              this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n136] = _e152;
            }
          }
        }
      } else {
        var _e153 = t.morphTargets;
        void 0 !== _e153 && _e153.length > 0 && console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }]);

  return _a;
}(Ve);

_a.prototype.isLine = !0;
var ba = new zt(),
    wa = new zt();

var Ma = /*#__PURE__*/function (_a42) {
  _inherits(Ma, _a42);

  var _super47 = _createSuper(Ma);

  function Ma(t, e) {
    var _this48;

    _classCallCheck(this, Ma);

    _this48 = _super47.call(this, t, e), _this48.type = "LineSegments";
    return _this48;
  }

  _createClass(Ma, [{
    key: "computeLineDistances",
    value: function computeLineDistances() {
      var t = this.geometry;
      if (t.isBufferGeometry) {
        if (null === t.index) {
          var _e154 = t.attributes.position,
              _n137 = [];

          for (var _t192 = 0, _i128 = _e154.count; _t192 < _i128; _t192 += 2) {
            ba.fromBufferAttribute(_e154, _t192), wa.fromBufferAttribute(_e154, _t192 + 1), _n137[_t192] = 0 === _t192 ? 0 : _n137[_t192 - 1], _n137[_t192 + 1] = _n137[_t192] + ba.distanceTo(wa);
          }

          t.setAttribute("lineDistance", new hn(_n137, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      } else t.isGeometry && console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      return this;
    }
  }]);

  return Ma;
}(_a);

Ma.prototype.isLineSegments = !0;

var Sa = /*#__PURE__*/function (_a43) {
  _inherits(Sa, _a43);

  var _super48 = _createSuper(Sa);

  function Sa(t, e) {
    var _this49;

    _classCallCheck(this, Sa);

    _this49 = _super48.call(this, t, e), _this49.type = "LineLoop";
    return _this49;
  }

  return Sa;
}(_a);

Sa.prototype.isLineLoop = !0;

var Ta = /*#__PURE__*/function (_en7) {
  _inherits(Ta, _en7);

  var _super49 = _createSuper(Ta);

  function Ta(t) {
    var _this50;

    _classCallCheck(this, Ta);

    _this50 = _super49.call(this), _this50.type = "PointsMaterial", _this50.color = new Rt(16777215), _this50.map = null, _this50.alphaMap = null, _this50.size = 1, _this50.sizeAttenuation = !0, _this50.setValues(t);
    return _this50;
  }

  _createClass(Ta, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ta.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.size = t.size, this.sizeAttenuation = t.sizeAttenuation, this;
    }
  }]);

  return Ta;
}(en);

Ta.prototype.isPointsMaterial = !0;
var Ea = new ve(),
    Aa = new ge(),
    Ra = new le(),
    Ca = new zt();

var La = /*#__PURE__*/function (_Ve9) {
  _inherits(La, _Ve9);

  var _super50 = _createSuper(La);

  function La() {
    var _this51;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new vn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Ta();

    _classCallCheck(this, La);

    _this51 = _super50.call(this), _this51.type = "Points", _this51.geometry = t, _this51.material = e, _this51.updateMorphTargets();
    return _this51;
  }

  _createClass(La, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(La.prototype), "copy", this).call(this, t), this.material = t.material, this.geometry = t.geometry, this;
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.geometry,
          i = this.matrixWorld,
          r = t.params.Points.threshold,
          s = n.drawRange;
      if (null === n.boundingSphere && n.computeBoundingSphere(), Ra.copy(n.boundingSphere), Ra.applyMatrix4(i), Ra.radius += r, !1 === t.ray.intersectsSphere(Ra)) return;
      Ea.copy(i).invert(), Aa.copy(t.ray).applyMatrix4(Ea);
      var a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          o = a * a;

      if (n.isBufferGeometry) {
        var _r97 = n.index,
            _a44 = n.attributes.position;

        if (null !== _r97) {
          for (var _n138 = Math.max(0, s.start), _l28 = Math.min(_r97.count, s.start + s.count); _n138 < _l28; _n138++) {
            var _s55 = _r97.getX(_n138);

            Ca.fromBufferAttribute(_a44, _s55), Pa(Ca, _s55, o, i, t, e, this);
          }
        } else {
          for (var _n139 = Math.max(0, s.start), _r98 = Math.min(_a44.count, s.start + s.count); _n139 < _r98; _n139++) {
            Ca.fromBufferAttribute(_a44, _n139), Pa(Ca, _n139, o, i, t, e, this);
          }
        }
      } else console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var t = this.geometry;

      if (t.isBufferGeometry) {
        var _e155 = t.morphAttributes,
            _n140 = Object.keys(_e155);

        if (_n140.length > 0) {
          var _t193 = _e155[_n140[0]];

          if (void 0 !== _t193) {
            this.morphTargetInfluences = [], this.morphTargetDictionary = {};

            for (var _e156 = 0, _n141 = _t193.length; _e156 < _n141; _e156++) {
              var _n142 = _t193[_e156].name || String(_e156);

              this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n142] = _e156;
            }
          }
        }
      } else {
        var _e157 = t.morphTargets;
        void 0 !== _e157 && _e157.length > 0 && console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }]);

  return La;
}(Ve);

function Pa(t, e, n, i, r, s, a) {
  var o = Aa.distanceSqToPoint(t);

  if (o < n) {
    var _n143 = new zt();

    Aa.closestPointToPoint(t, _n143), _n143.applyMatrix4(i);

    var _l29 = r.ray.origin.distanceTo(_n143);

    if (_l29 < r.near || _l29 > r.far) return;
    s.push({
      distance: _l29,
      distanceToRay: Math.sqrt(o),
      point: _n143,
      index: e,
      face: null,
      object: a
    });
  }
}

La.prototype.isPoints = !0;

/*#__PURE__*/
(function (_Ot6) {
  _inherits(_class9, _Ot6);

  var _super51 = _createSuper(_class9);

  function _class9(t, e, n, i, r, s, a, o, l) {
    var _this52;

    _classCallCheck(this, _class9);

    _this52 = _super51.call(this, t, e, n, i, r, s, a, o, l), _this52.minFilter = void 0 !== s ? s : 1006, _this52.magFilter = void 0 !== r ? r : 1006, _this52.generateMipmaps = !1;

    var h = _assertThisInitialized(_this52);

    "requestVideoFrameCallback" in t && t.requestVideoFrameCallback(function e() {
      h.needsUpdate = !0, t.requestVideoFrameCallback(e);
    });
    return _this52;
  }

  _createClass(_class9, [{
    key: "clone",
    value: function clone() {
      return new this.constructor(this.image).copy(this);
    }
  }, {
    key: "update",
    value: function update() {
      var t = this.image;
      !1 === "requestVideoFrameCallback" in t && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
  }]);

  return _class9;
})(Ot).prototype.isVideoTexture = !0;

/*#__PURE__*/
(function (_Ot7) {
  _inherits(_class10, _Ot7);

  var _super52 = _createSuper(_class10);

  function _class10(t, e, n) {
    var _this53;

    _classCallCheck(this, _class10);

    _this53 = _super52.call(this, {
      width: t,
      height: e
    }), _this53.format = n, _this53.magFilter = 1003, _this53.minFilter = 1003, _this53.generateMipmaps = !1, _this53.needsUpdate = !0;
    return _this53;
  }

  return _class10;
})(Ot).prototype.isFramebufferTexture = !0;

var Da = /*#__PURE__*/function (_Ot8) {
  _inherits(Da, _Ot8);

  var _super53 = _createSuper(Da);

  function Da(t, e, n, i, r, s, a, o, l, h, c, u) {
    var _this54;

    _classCallCheck(this, Da);

    _this54 = _super53.call(this, null, s, a, o, l, h, i, r, c, u), _this54.image = {
      width: e,
      height: n
    }, _this54.mipmaps = t, _this54.flipY = !1, _this54.generateMipmaps = !1;
    return _this54;
  }

  return Da;
}(Ot);

Da.prototype.isCompressedTexture = !0;

/*#__PURE__*/
(function (_Ot9) {
  _inherits(_class11, _Ot9);

  var _super54 = _createSuper(_class11);

  function _class11(t, e, n, i, r, s, a, o, l) {
    var _this55;

    _classCallCheck(this, _class11);

    _this55 = _super54.call(this, t, e, n, i, r, s, a, o, l), _this55.needsUpdate = !0;
    return _this55;
  }

  return _class11;
})(Ot).prototype.isCanvasTexture = !0;

var Ia = /*#__PURE__*/function () {
  function Ia() {
    _classCallCheck(this, Ia);

    this.type = "Curve", this.arcLengthDivisions = 200;
  }

  _createClass(Ia, [{
    key: "getPoint",
    value: function getPoint() {
      return console.warn("THREE.Curve: .getPoint() not implemented."), null;
    }
  }, {
    key: "getPointAt",
    value: function getPointAt(t, e) {
      var n = this.getUtoTmapping(t);
      return this.getPoint(n, e);
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var e = [];

      for (var _n144 = 0; _n144 <= t; _n144++) {
        e.push(this.getPoint(_n144 / t));
      }

      return e;
    }
  }, {
    key: "getSpacedPoints",
    value: function getSpacedPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var e = [];

      for (var _n145 = 0; _n145 <= t; _n145++) {
        e.push(this.getPointAt(_n145 / t));
      }

      return e;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var t = this.getLengths();
      return t[t.length - 1];
    }
  }, {
    key: "getLengths",
    value: function getLengths() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.arcLengthDivisions;
      if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
      this.needsUpdate = !1;
      var e = [];
      var n,
          i = this.getPoint(0),
          r = 0;
      e.push(0);

      for (var _s56 = 1; _s56 <= t; _s56++) {
        n = this.getPoint(_s56 / t), r += n.distanceTo(i), e.push(r), i = n;
      }

      return this.cacheArcLengths = e, e;
    }
  }, {
    key: "updateArcLengths",
    value: function updateArcLengths() {
      this.needsUpdate = !0, this.getLengths();
    }
  }, {
    key: "getUtoTmapping",
    value: function getUtoTmapping(t, e) {
      var n = this.getLengths();
      var i = 0;
      var r = n.length;
      var s;
      s = e || t * n[r - 1];
      var a,
          o = 0,
          l = r - 1;

      for (; o <= l;) {
        if (i = Math.floor(o + (l - o) / 2), a = n[i] - s, a < 0) o = i + 1;else {
          if (!(a > 0)) {
            l = i;
            break;
          }

          l = i - 1;
        }
      }

      if (i = l, n[i] === s) return i / (r - 1);
      var h = n[i];
      return (i + (s - h) / (n[i + 1] - h)) / (r - 1);
    }
  }, {
    key: "getTangent",
    value: function getTangent(t, e) {
      var n = 1e-4;
      var i = t - n,
          r = t + n;
      i < 0 && (i = 0), r > 1 && (r = 1);
      var s = this.getPoint(i),
          a = this.getPoint(r),
          o = e || (s.isVector2 ? new mt() : new zt());
      return o.copy(a).sub(s).normalize(), o;
    }
  }, {
    key: "getTangentAt",
    value: function getTangentAt(t, e) {
      var n = this.getUtoTmapping(t);
      return this.getTangent(n, e);
    }
  }, {
    key: "computeFrenetFrames",
    value: function computeFrenetFrames(t, e) {
      var n = new zt(),
          i = [],
          r = [],
          s = [],
          a = new zt(),
          o = new ve();

      for (var _e158 = 0; _e158 <= t; _e158++) {
        var _n146 = _e158 / t;

        i[_e158] = this.getTangentAt(_n146, new zt());
      }

      r[0] = new zt(), s[0] = new zt();
      var l = Number.MAX_VALUE;
      var h = Math.abs(i[0].x),
          c = Math.abs(i[0].y),
          u = Math.abs(i[0].z);
      h <= l && (l = h, n.set(1, 0, 0)), c <= l && (l = c, n.set(0, 1, 0)), u <= l && n.set(0, 0, 1), a.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], a), s[0].crossVectors(i[0], r[0]);

      for (var _e159 = 1; _e159 <= t; _e159++) {
        if (r[_e159] = r[_e159 - 1].clone(), s[_e159] = s[_e159 - 1].clone(), a.crossVectors(i[_e159 - 1], i[_e159]), a.length() > Number.EPSILON) {
          a.normalize();

          var _t194 = Math.acos(ot(i[_e159 - 1].dot(i[_e159]), -1, 1));

          r[_e159].applyMatrix4(o.makeRotationAxis(a, _t194));
        }

        s[_e159].crossVectors(i[_e159], r[_e159]);
      }

      if (!0 === e) {
        var _e160 = Math.acos(ot(r[0].dot(r[t]), -1, 1));

        _e160 /= t, i[0].dot(a.crossVectors(r[0], r[t])) > 0 && (_e160 = -_e160);

        for (var _n147 = 1; _n147 <= t; _n147++) {
          r[_n147].applyMatrix4(o.makeRotationAxis(i[_n147], _e160 * _n147)), s[_n147].crossVectors(i[_n147], r[_n147]);
        }
      }

      return {
        tangents: i,
        normals: r,
        binormals: s
      };
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        metadata: {
          version: 4.5,
          type: "Curve",
          generator: "Curve.toJSON"
        }
      };
      return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
  }]);

  return Ia;
}();

var Oa = /*#__PURE__*/function (_Ia) {
  _inherits(Oa, _Ia);

  var _super55 = _createSuper(Oa);

  function Oa() {
    var _this56;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2 * Math.PI;
    var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
    var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;

    _classCallCheck(this, Oa);

    _this56 = _super55.call(this), _this56.type = "EllipseCurve", _this56.aX = t, _this56.aY = e, _this56.xRadius = n, _this56.yRadius = i, _this56.aStartAngle = r, _this56.aEndAngle = s, _this56.aClockwise = a, _this56.aRotation = o;
    return _this56;
  }

  _createClass(Oa, [{
    key: "getPoint",
    value: function getPoint(t, e) {
      var n = e || new mt(),
          i = 2 * Math.PI;
      var r = this.aEndAngle - this.aStartAngle;
      var s = Math.abs(r) < Number.EPSILON;

      for (; r < 0;) {
        r += i;
      }

      for (; r > i;) {
        r -= i;
      }

      r < Number.EPSILON && (r = s ? 0 : i), !0 !== this.aClockwise || s || (r === i ? r = -i : r -= i);
      var a = this.aStartAngle + t * r;
      var o = this.aX + this.xRadius * Math.cos(a),
          l = this.aY + this.yRadius * Math.sin(a);

      if (0 !== this.aRotation) {
        var _t195 = Math.cos(this.aRotation),
            _e161 = Math.sin(this.aRotation),
            _n148 = o - this.aX,
            _i129 = l - this.aY;

        o = _n148 * _t195 - _i129 * _e161 + this.aX, l = _n148 * _e161 + _i129 * _t195 + this.aY;
      }

      return n.set(o, l);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Oa.prototype), "copy", this).call(this, t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Oa.prototype), "toJSON", this).call(this);

      return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Oa.prototype), "fromJSON", this).call(this, t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
  }]);

  return Oa;
}(Ia);

Oa.prototype.isEllipseCurve = !0;

var Na = /*#__PURE__*/function (_Oa) {
  _inherits(Na, _Oa);

  var _super56 = _createSuper(Na);

  function Na(t, e, n, i, r, s) {
    var _this57;

    _classCallCheck(this, Na);

    _this57 = _super56.call(this, t, e, n, n, i, r, s), _this57.type = "ArcCurve";
    return _this57;
  }

  return Na;
}(Oa);

function Fa() {
  var t = 0,
      e = 0,
      n = 0,
      i = 0;

  function r(r, s, a, o) {
    t = r, e = a, n = -3 * r + 3 * s - 2 * a - o, i = 2 * r - 2 * s + a + o;
  }

  return {
    initCatmullRom: function initCatmullRom(t, e, n, i, s) {
      r(e, n, s * (n - t), s * (i - e));
    },
    initNonuniformCatmullRom: function initNonuniformCatmullRom(t, e, n, i, s, a, o) {
      var l = (e - t) / s - (n - t) / (s + a) + (n - e) / a,
          h = (n - e) / a - (i - e) / (a + o) + (i - n) / o;
      l *= a, h *= a, r(e, n, l, h);
    },
    calc: function calc(r) {
      var s = r * r;
      return t + e * r + n * s + i * (s * r);
    }
  };
}

Na.prototype.isArcCurve = !0;
var Ua = new zt(),
    ka = new Fa(),
    Ba = new Fa(),
    za = new Fa();

var Ha = /*#__PURE__*/function (_Ia2) {
  _inherits(Ha, _Ia2);

  var _super57 = _createSuper(Ha);

  function Ha() {
    var _this58;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "centripetal";
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : .5;

    _classCallCheck(this, Ha);

    _this58 = _super57.call(this), _this58.type = "CatmullRomCurve3", _this58.points = t, _this58.closed = e, _this58.curveType = n, _this58.tension = i;
    return _this58;
  }

  _createClass(Ha, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();
      var n = e,
          i = this.points,
          r = i.length,
          s = (r - (this.closed ? 0 : 1)) * t;
      var a,
          o,
          l = Math.floor(s),
          h = s - l;
      this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r : 0 === h && l === r - 1 && (l = r - 2, h = 1), this.closed || l > 0 ? a = i[(l - 1) % r] : (Ua.subVectors(i[0], i[1]).add(i[0]), a = Ua);
      var c = i[l % r],
          u = i[(l + 1) % r];

      if (this.closed || l + 2 < r ? o = i[(l + 2) % r] : (Ua.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), o = Ua), "centripetal" === this.curveType || "chordal" === this.curveType) {
        var _t196 = "chordal" === this.curveType ? .5 : .25;

        var _e162 = Math.pow(a.distanceToSquared(c), _t196),
            _n149 = Math.pow(c.distanceToSquared(u), _t196),
            _i130 = Math.pow(u.distanceToSquared(o), _t196);

        _n149 < 1e-4 && (_n149 = 1), _e162 < 1e-4 && (_e162 = _n149), _i130 < 1e-4 && (_i130 = _n149), ka.initNonuniformCatmullRom(a.x, c.x, u.x, o.x, _e162, _n149, _i130), Ba.initNonuniformCatmullRom(a.y, c.y, u.y, o.y, _e162, _n149, _i130), za.initNonuniformCatmullRom(a.z, c.z, u.z, o.z, _e162, _n149, _i130);
      } else "catmullrom" === this.curveType && (ka.initCatmullRom(a.x, c.x, u.x, o.x, this.tension), Ba.initCatmullRom(a.y, c.y, u.y, o.y, this.tension), za.initCatmullRom(a.z, c.z, u.z, o.z, this.tension));

      return n.set(ka.calc(h), Ba.calc(h), za.calc(h)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(Ha.prototype), "copy", this).call(this, t), this.points = [];

      for (var _e163 = 0, _n150 = t.points.length; _e163 < _n150; _e163++) {
        var _n151 = t.points[_e163];
        this.points.push(_n151.clone());
      }

      return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ha.prototype), "toJSON", this).call(this);

      t.points = [];

      for (var _e164 = 0, _n152 = this.points.length; _e164 < _n152; _e164++) {
        var _n153 = this.points[_e164];
        t.points.push(_n153.toArray());
      }

      return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(Ha.prototype), "fromJSON", this).call(this, t), this.points = [];

      for (var _e165 = 0, _n154 = t.points.length; _e165 < _n154; _e165++) {
        var _n155 = t.points[_e165];
        this.points.push(new zt().fromArray(_n155));
      }

      return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
  }]);

  return Ha;
}(Ia);

function Va(t, e, n, i, r) {
  var s = .5 * (i - e),
      a = .5 * (r - n),
      o = t * t;
  return (2 * n - 2 * i + s + a) * (t * o) + (-3 * n + 3 * i - 2 * s - a) * o + s * t + n;
}

function Ga(t, e, n, i) {
  return function (t, e) {
    var n = 1 - t;
    return n * n * e;
  }(t, e) + function (t, e) {
    return 2 * (1 - t) * t * e;
  }(t, n) + function (t, e) {
    return t * t * e;
  }(t, i);
}

function Wa(t, e, n, i, r) {
  return function (t, e) {
    var n = 1 - t;
    return n * n * n * e;
  }(t, e) + function (t, e) {
    var n = 1 - t;
    return 3 * n * n * t * e;
  }(t, n) + function (t, e) {
    return 3 * (1 - t) * t * t * e;
  }(t, i) + function (t, e) {
    return t * t * t * e;
  }(t, r);
}

Ha.prototype.isCatmullRomCurve3 = !0;

var ja = /*#__PURE__*/function (_Ia3) {
  _inherits(ja, _Ia3);

  var _super58 = _createSuper(ja);

  function ja() {
    var _this59;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new mt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new mt();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new mt();
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new mt();

    _classCallCheck(this, ja);

    _this59 = _super58.call(this), _this59.type = "CubicBezierCurve", _this59.v0 = t, _this59.v1 = e, _this59.v2 = n, _this59.v3 = i;
    return _this59;
  }

  _createClass(ja, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new mt();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2,
          a = this.v3;
      return n.set(Wa(t, i.x, r.x, s.x, a.x), Wa(t, i.y, r.y, s.y, a.y)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ja.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(ja.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(ja.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
  }]);

  return ja;
}(Ia);

ja.prototype.isCubicBezierCurve = !0;

var qa = /*#__PURE__*/function (_Ia4) {
  _inherits(qa, _Ia4);

  var _super59 = _createSuper(qa);

  function qa() {
    var _this60;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new zt();
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new zt();

    _classCallCheck(this, qa);

    _this60 = _super59.call(this), _this60.type = "CubicBezierCurve3", _this60.v0 = t, _this60.v1 = e, _this60.v2 = n, _this60.v3 = i;
    return _this60;
  }

  _createClass(qa, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2,
          a = this.v3;
      return n.set(Wa(t, i.x, r.x, s.x, a.x), Wa(t, i.y, r.y, s.y, a.y), Wa(t, i.z, r.z, s.z, a.z)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(qa.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(qa.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(qa.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
  }]);

  return qa;
}(Ia);

qa.prototype.isCubicBezierCurve3 = !0;

var Xa = /*#__PURE__*/function (_Ia5) {
  _inherits(Xa, _Ia5);

  var _super60 = _createSuper(Xa);

  function Xa() {
    var _this61;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new mt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new mt();

    _classCallCheck(this, Xa);

    _this61 = _super60.call(this), _this61.type = "LineCurve", _this61.v1 = t, _this61.v2 = e;
    return _this61;
  }

  _createClass(Xa, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new mt();
      var n = e;
      return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
    }
  }, {
    key: "getPointAt",
    value: function getPointAt(t, e) {
      return this.getPoint(t, e);
    }
  }, {
    key: "getTangent",
    value: function getTangent(t, e) {
      var n = e || new mt();
      return n.copy(this.v2).sub(this.v1).normalize(), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Xa.prototype), "copy", this).call(this, t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Xa.prototype), "toJSON", this).call(this);

      return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Xa.prototype), "fromJSON", this).call(this, t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
  }]);

  return Xa;
}(Ia);

Xa.prototype.isLineCurve = !0;

var Ya = /*#__PURE__*/function (_Ia6) {
  _inherits(Ya, _Ia6);

  var _super61 = _createSuper(Ya);

  function Ya() {
    var _this62;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new mt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new mt();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new mt();

    _classCallCheck(this, Ya);

    _this62 = _super61.call(this), _this62.type = "QuadraticBezierCurve", _this62.v0 = t, _this62.v1 = e, _this62.v2 = n;
    return _this62;
  }

  _createClass(Ya, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new mt();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2;
      return n.set(Ga(t, i.x, r.x, s.x), Ga(t, i.y, r.y, s.y)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ya.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ya.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Ya.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
  }]);

  return Ya;
}(Ia);

Ya.prototype.isQuadraticBezierCurve = !0;

var Ja = /*#__PURE__*/function (_Ia7) {
  _inherits(Ja, _Ia7);

  var _super62 = _createSuper(Ja);

  function Ja() {
    var _this63;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new zt();

    _classCallCheck(this, Ja);

    _this63 = _super62.call(this), _this63.type = "QuadraticBezierCurve3", _this63.v0 = t, _this63.v1 = e, _this63.v2 = n;
    return _this63;
  }

  _createClass(Ja, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2;
      return n.set(Ga(t, i.x, r.x, s.x), Ga(t, i.y, r.y, s.y), Ga(t, i.z, r.z, s.z)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ja.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ja.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Ja.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
  }]);

  return Ja;
}(Ia);

Ja.prototype.isQuadraticBezierCurve3 = !0;

var Za = /*#__PURE__*/function (_Ia8) {
  _inherits(Za, _Ia8);

  var _super63 = _createSuper(Za);

  function Za() {
    var _this64;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Za);

    _this64 = _super63.call(this), _this64.type = "SplineCurve", _this64.points = t;
    return _this64;
  }

  _createClass(Za, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new mt();
      var n = e,
          i = this.points,
          r = (i.length - 1) * t,
          s = Math.floor(r),
          a = r - s,
          o = i[0 === s ? s : s - 1],
          l = i[s],
          h = i[s > i.length - 2 ? i.length - 1 : s + 1],
          c = i[s > i.length - 3 ? i.length - 1 : s + 2];
      return n.set(Va(a, o.x, l.x, h.x, c.x), Va(a, o.y, l.y, h.y, c.y)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(Za.prototype), "copy", this).call(this, t), this.points = [];

      for (var _e166 = 0, _n156 = t.points.length; _e166 < _n156; _e166++) {
        var _n157 = t.points[_e166];
        this.points.push(_n157.clone());
      }

      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Za.prototype), "toJSON", this).call(this);

      t.points = [];

      for (var _e167 = 0, _n158 = this.points.length; _e167 < _n158; _e167++) {
        var _n159 = this.points[_e167];
        t.points.push(_n159.toArray());
      }

      return t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(Za.prototype), "fromJSON", this).call(this, t), this.points = [];

      for (var _e168 = 0, _n160 = t.points.length; _e168 < _n160; _e168++) {
        var _n161 = t.points[_e168];
        this.points.push(new mt().fromArray(_n161));
      }

      return this;
    }
  }]);

  return Za;
}(Ia);

Za.prototype.isSplineCurve = !0;
var $a = Object.freeze({
  __proto__: null,
  ArcCurve: Na,
  CatmullRomCurve3: Ha,
  CubicBezierCurve: ja,
  CubicBezierCurve3: qa,
  EllipseCurve: Oa,
  LineCurve: Xa,
  LineCurve3: /*#__PURE__*/function (_Ia9) {
    _inherits(LineCurve3, _Ia9);

    var _super64 = _createSuper(LineCurve3);

    function LineCurve3() {
      var _this65;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zt();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();

      _classCallCheck(this, LineCurve3);

      _this65 = _super64.call(this), _this65.type = "LineCurve3", _this65.isLineCurve3 = !0, _this65.v1 = t, _this65.v2 = e;
      return _this65;
    }

    _createClass(LineCurve3, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new zt();
        var n = e;
        return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
      }
    }, {
      key: "getPointAt",
      value: function getPointAt(t, e) {
        return this.getPoint(t, e);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(LineCurve3.prototype), "copy", this).call(this, t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(LineCurve3.prototype), "toJSON", this).call(this);

        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(LineCurve3.prototype), "fromJSON", this).call(this, t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
      }
    }]);

    return LineCurve3;
  }(Ia),
  QuadraticBezierCurve: Ya,
  QuadraticBezierCurve3: Ja,
  SplineCurve: Za
});

var Ka = /*#__PURE__*/function (_Ia10) {
  _inherits(Ka, _Ia10);

  var _super65 = _createSuper(Ka);

  function Ka() {
    var _this66;

    _classCallCheck(this, Ka);

    _this66 = _super65.call(this), _this66.type = "CurvePath", _this66.curves = [], _this66.autoClose = !1;
    return _this66;
  }

  _createClass(Ka, [{
    key: "add",
    value: function add(t) {
      this.curves.push(t);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      var t = this.curves[0].getPoint(0),
          e = this.curves[this.curves.length - 1].getPoint(1);
      t.equals(e) || this.curves.push(new Xa(e, t));
    }
  }, {
    key: "getPoint",
    value: function getPoint(t, e) {
      var n = t * this.getLength(),
          i = this.getCurveLengths();
      var r = 0;

      for (; r < i.length;) {
        if (i[r] >= n) {
          var _t197 = i[r] - n,
              _s57 = this.curves[r],
              _a45 = _s57.getLength(),
              _o27 = 0 === _a45 ? 0 : 1 - _t197 / _a45;

          return _s57.getPointAt(_o27, e);
        }

        r++;
      }

      return null;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var t = this.getCurveLengths();
      return t[t.length - 1];
    }
  }, {
    key: "updateArcLengths",
    value: function updateArcLengths() {
      this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
  }, {
    key: "getCurveLengths",
    value: function getCurveLengths() {
      if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
      var t = [];
      var e = 0;

      for (var _n162 = 0, _i131 = this.curves.length; _n162 < _i131; _n162++) {
        e += this.curves[_n162].getLength(), t.push(e);
      }

      return this.cacheLengths = t, t;
    }
  }, {
    key: "getSpacedPoints",
    value: function getSpacedPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
      var e = [];

      for (var _n163 = 0; _n163 <= t; _n163++) {
        e.push(this.getPoint(_n163 / t));
      }

      return this.autoClose && e.push(e[0]), e;
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
      var e = [];
      var n;

      for (var _i132 = 0, _r99 = this.curves; _i132 < _r99.length; _i132++) {
        var _s58 = _r99[_i132],
            _a46 = _s58.isEllipseCurve ? 2 * t : _s58.isLineCurve || _s58.isLineCurve3 ? 1 : _s58.isSplineCurve ? t * _s58.points.length : t,
            _o28 = _s58.getPoints(_a46);

        for (var _t198 = 0; _t198 < _o28.length; _t198++) {
          var _i133 = _o28[_t198];
          n && n.equals(_i133) || (e.push(_i133), n = _i133);
        }
      }

      return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(Ka.prototype), "copy", this).call(this, t), this.curves = [];

      for (var _e169 = 0, _n164 = t.curves.length; _e169 < _n164; _e169++) {
        var _n165 = t.curves[_e169];
        this.curves.push(_n165.clone());
      }

      return this.autoClose = t.autoClose, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ka.prototype), "toJSON", this).call(this);

      t.autoClose = this.autoClose, t.curves = [];

      for (var _e170 = 0, _n166 = this.curves.length; _e170 < _n166; _e170++) {
        var _n167 = this.curves[_e170];
        t.curves.push(_n167.toJSON());
      }

      return t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(Ka.prototype), "fromJSON", this).call(this, t), this.autoClose = t.autoClose, this.curves = [];

      for (var _e171 = 0, _n168 = t.curves.length; _e171 < _n168; _e171++) {
        var _n169 = t.curves[_e171];
        this.curves.push(new $a[_n169.type]().fromJSON(_n169));
      }

      return this;
    }
  }]);

  return Ka;
}(Ia);

var Qa = /*#__PURE__*/function (_Ka) {
  _inherits(Qa, _Ka);

  var _super66 = _createSuper(Qa);

  function Qa(t) {
    var _this67;

    _classCallCheck(this, Qa);

    _this67 = _super66.call(this), _this67.type = "Path", _this67.currentPoint = new mt(), t && _this67.setFromPoints(t);
    return _this67;
  }

  _createClass(Qa, [{
    key: "setFromPoints",
    value: function setFromPoints(t) {
      this.moveTo(t[0].x, t[0].y);

      for (var _e172 = 1, _n170 = t.length; _e172 < _n170; _e172++) {
        this.lineTo(t[_e172].x, t[_e172].y);
      }

      return this;
    }
  }, {
    key: "moveTo",
    value: function moveTo(t, e) {
      return this.currentPoint.set(t, e), this;
    }
  }, {
    key: "lineTo",
    value: function lineTo(t, e) {
      var n = new Xa(this.currentPoint.clone(), new mt(t, e));
      return this.curves.push(n), this.currentPoint.set(t, e), this;
    }
  }, {
    key: "quadraticCurveTo",
    value: function quadraticCurveTo(t, e, n, i) {
      var r = new Ya(this.currentPoint.clone(), new mt(t, e), new mt(n, i));
      return this.curves.push(r), this.currentPoint.set(n, i), this;
    }
  }, {
    key: "bezierCurveTo",
    value: function bezierCurveTo(t, e, n, i, r, s) {
      var a = new ja(this.currentPoint.clone(), new mt(t, e), new mt(n, i), new mt(r, s));
      return this.curves.push(a), this.currentPoint.set(r, s), this;
    }
  }, {
    key: "splineThru",
    value: function splineThru(t) {
      var e = [this.currentPoint.clone()].concat(t),
          n = new Za(e);
      return this.curves.push(n), this.currentPoint.copy(t[t.length - 1]), this;
    }
  }, {
    key: "arc",
    value: function arc(t, e, n, i, r, s) {
      var a = this.currentPoint.x,
          o = this.currentPoint.y;
      return this.absarc(t + a, e + o, n, i, r, s), this;
    }
  }, {
    key: "absarc",
    value: function absarc(t, e, n, i, r, s) {
      return this.absellipse(t, e, n, n, i, r, s), this;
    }
  }, {
    key: "ellipse",
    value: function ellipse(t, e, n, i, r, s, a, o) {
      var l = this.currentPoint.x,
          h = this.currentPoint.y;
      return this.absellipse(t + l, e + h, n, i, r, s, a, o), this;
    }
  }, {
    key: "absellipse",
    value: function absellipse(t, e, n, i, r, s, a, o) {
      var l = new Oa(t, e, n, i, r, s, a, o);

      if (this.curves.length > 0) {
        var _t199 = l.getPoint(0);

        _t199.equals(this.currentPoint) || this.lineTo(_t199.x, _t199.y);
      }

      this.curves.push(l);
      var h = l.getPoint(1);
      return this.currentPoint.copy(h), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Qa.prototype), "copy", this).call(this, t), this.currentPoint.copy(t.currentPoint), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Qa.prototype), "toJSON", this).call(this);

      return t.currentPoint = this.currentPoint.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Qa.prototype), "fromJSON", this).call(this, t), this.currentPoint.fromArray(t.currentPoint), this;
    }
  }]);

  return Qa;
}(Ka);

new zt(), new zt(), new zt(), new Qe();

var to = /*#__PURE__*/function (_Qa) {
  _inherits(to, _Qa);

  var _super67 = _createSuper(to);

  function to(t) {
    var _this68;

    _classCallCheck(this, to);

    _this68 = _super67.call(this, t), _this68.uuid = at(), _this68.type = "Shape", _this68.holes = [];
    return _this68;
  }

  _createClass(to, [{
    key: "getPointsHoles",
    value: function getPointsHoles(t) {
      var e = [];

      for (var _n171 = 0, _i134 = this.holes.length; _n171 < _i134; _n171++) {
        e[_n171] = this.holes[_n171].getPoints(t);
      }

      return e;
    }
  }, {
    key: "extractPoints",
    value: function extractPoints(t) {
      return {
        shape: this.getPoints(t),
        holes: this.getPointsHoles(t)
      };
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(to.prototype), "copy", this).call(this, t), this.holes = [];

      for (var _e173 = 0, _n172 = t.holes.length; _e173 < _n172; _e173++) {
        var _n173 = t.holes[_e173];
        this.holes.push(_n173.clone());
      }

      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(to.prototype), "toJSON", this).call(this);

      t.uuid = this.uuid, t.holes = [];

      for (var _e174 = 0, _n174 = this.holes.length; _e174 < _n174; _e174++) {
        var _n175 = this.holes[_e174];
        t.holes.push(_n175.toJSON());
      }

      return t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(to.prototype), "fromJSON", this).call(this, t), this.uuid = t.uuid, this.holes = [];

      for (var _e175 = 0, _n176 = t.holes.length; _e175 < _n176; _e175++) {
        var _n177 = t.holes[_e175];
        this.holes.push(new Qa().fromJSON(_n177));
      }

      return this;
    }
  }]);

  return to;
}(Qa);

var eo = function eo(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var i = e && e.length,
      r = i ? e[0] * n : t.length;
  var s = no(t, 0, r, n, !0);
  var a = [];
  if (!s || s.next === s.prev) return a;
  var o, l, h, c, u, d, p;

  if (i && (s = function (t, e, n, i) {
    var r = [];
    var s, a, o, l, h;

    for (s = 0, a = e.length; s < a; s++) {
      o = e[s] * i, l = s < a - 1 ? e[s + 1] * i : t.length, h = no(t, o, l, i, !1), h === h.next && (h.steiner = !0), r.push(mo(h));
    }

    for (r.sort(ho), s = 0; s < r.length; s++) {
      co(r[s], n), n = io(n, n.next);
    }

    return n;
  }(t, e, s, n)), t.length > 80 * n) {
    o = h = t[0], l = c = t[1];

    for (var _e176 = n; _e176 < r; _e176 += n) {
      u = t[_e176], d = t[_e176 + 1], u < o && (o = u), d < l && (l = d), u > h && (h = u), d > c && (c = d);
    }

    p = Math.max(h - o, c - l), p = 0 !== p ? 1 / p : 0;
  }

  return ro(s, a, n, o, l, p), a;
};

function no(t, e, n, i, r) {
  var s, a;
  if (r === function (t, e, n, i) {
    var r = 0;

    for (var _s59 = e, _a47 = n - i; _s59 < n; _s59 += i) {
      r += (t[_a47] - t[_s59]) * (t[_s59 + 1] + t[_a47 + 1]), _a47 = _s59;
    }

    return r;
  }(t, e, n, i) > 0) for (s = e; s < n; s += i) {
    a = So(s, t[s], t[s + 1], a);
  } else for (s = n - i; s >= e; s -= i) {
    a = So(s, t[s], t[s + 1], a);
  }
  return a && yo(a, a.next) && (To(a), a = a.next), a;
}

function io(t, e) {
  if (!t) return t;
  e || (e = t);
  var n,
      i = t;

  do {
    if (n = !1, i.steiner || !yo(i, i.next) && 0 !== vo(i.prev, i, i.next)) i = i.next;else {
      if (To(i), i = e = i.prev, i === i.next) break;
      n = !0;
    }
  } while (n || i !== e);

  return e;
}

function ro(t, e, n, i, r, s, a) {
  if (!t) return;
  !a && s && function (t, e, n, i) {
    var r = t;

    do {
      null === r.z && (r.z = po(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
    } while (r !== t);

    r.prevZ.nextZ = null, r.prevZ = null, function (t) {
      var e,
          n,
          i,
          r,
          s,
          a,
          o,
          l,
          h = 1;

      do {
        for (n = t, t = null, s = null, a = 0; n;) {
          for (a++, i = n, o = 0, e = 0; e < h && (o++, i = i.nextZ, i); e++) {
            ;
          }

          for (l = h; o > 0 || l > 0 && i;) {
            0 !== o && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, o--) : (r = i, i = i.nextZ, l--), s ? s.nextZ = r : t = r, r.prevZ = s, s = r;
          }

          n = i;
        }

        s.nextZ = null, h *= 2;
      } while (a > 1);
    }(r);
  }(t, i, r, s);
  var o,
      l,
      h = t;

  for (; t.prev !== t.next;) {
    if (o = t.prev, l = t.next, s ? ao(t, i, r, s) : so(t)) e.push(o.i / n), e.push(t.i / n), e.push(l.i / n), To(t), t = l.next, h = l.next;else if ((t = l) === h) {
      a ? 1 === a ? ro(t = oo(io(t), e, n), e, n, i, r, s, 2) : 2 === a && lo(t, e, n, i, r, s) : ro(io(t), e, n, i, r, s, 1);
      break;
    }
  }
}

function so(t) {
  var e = t.prev,
      n = t,
      i = t.next;
  if (vo(e, n, i) >= 0) return !1;
  var r = t.next.next;

  for (; r !== t.prev;) {
    if (fo(e.x, e.y, n.x, n.y, i.x, i.y, r.x, r.y) && vo(r.prev, r, r.next) >= 0) return !1;
    r = r.next;
  }

  return !0;
}

function ao(t, e, n, i) {
  var r = t.prev,
      s = t,
      a = t.next;
  if (vo(r, s, a) >= 0) return !1;
  var o = r.x < s.x ? r.x < a.x ? r.x : a.x : s.x < a.x ? s.x : a.x,
      l = r.y < s.y ? r.y < a.y ? r.y : a.y : s.y < a.y ? s.y : a.y,
      h = r.x > s.x ? r.x > a.x ? r.x : a.x : s.x > a.x ? s.x : a.x,
      c = r.y > s.y ? r.y > a.y ? r.y : a.y : s.y > a.y ? s.y : a.y,
      u = po(o, l, e, n, i),
      d = po(h, c, e, n, i);
  var p = t.prevZ,
      m = t.nextZ;

  for (; p && p.z >= u && m && m.z <= d;) {
    if (p !== t.prev && p !== t.next && fo(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && vo(p.prev, p, p.next) >= 0) return !1;
    if (p = p.prevZ, m !== t.prev && m !== t.next && fo(r.x, r.y, s.x, s.y, a.x, a.y, m.x, m.y) && vo(m.prev, m, m.next) >= 0) return !1;
    m = m.nextZ;
  }

  for (; p && p.z >= u;) {
    if (p !== t.prev && p !== t.next && fo(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && vo(p.prev, p, p.next) >= 0) return !1;
    p = p.prevZ;
  }

  for (; m && m.z <= d;) {
    if (m !== t.prev && m !== t.next && fo(r.x, r.y, s.x, s.y, a.x, a.y, m.x, m.y) && vo(m.prev, m, m.next) >= 0) return !1;
    m = m.nextZ;
  }

  return !0;
}

function oo(t, e, n) {
  var i = t;

  do {
    var _r100 = i.prev,
        _s60 = i.next.next;
    !yo(_r100, _s60) && xo(_r100, i, i.next, _s60) && wo(_r100, _s60) && wo(_s60, _r100) && (e.push(_r100.i / n), e.push(i.i / n), e.push(_s60.i / n), To(i), To(i.next), i = t = _s60), i = i.next;
  } while (i !== t);

  return io(i);
}

function lo(t, e, n, i, r, s) {
  var a = t;

  do {
    var _t200 = a.next.next;

    for (; _t200 !== a.prev;) {
      if (a.i !== _t200.i && go(a, _t200)) {
        var _o29 = Mo(a, _t200);

        return a = io(a, a.next), _o29 = io(_o29, _o29.next), ro(a, e, n, i, r, s), void ro(_o29, e, n, i, r, s);
      }

      _t200 = _t200.next;
    }

    a = a.next;
  } while (a !== t);
}

function ho(t, e) {
  return t.x - e.x;
}

function co(t, e) {
  if (e = function (t, e) {
    var n = e;
    var i = t.x,
        r = t.y;
    var s,
        a = -1 / 0;

    do {
      if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
        var _t201 = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);

        if (_t201 <= i && _t201 > a) {
          if (a = _t201, _t201 === i) {
            if (r === n.y) return n;
            if (r === n.next.y) return n.next;
          }

          s = n.x < n.next.x ? n : n.next;
        }
      }

      n = n.next;
    } while (n !== e);

    if (!s) return null;
    if (i === a) return s;
    var o = s,
        l = s.x,
        h = s.y;
    var c,
        u = 1 / 0;
    n = s;

    do {
      i >= n.x && n.x >= l && i !== n.x && fo(r < h ? i : a, r, l, h, r < h ? a : i, r, n.x, n.y) && (c = Math.abs(r - n.y) / (i - n.x), wo(n, t) && (c < u || c === u && (n.x > s.x || n.x === s.x && uo(s, n))) && (s = n, u = c)), n = n.next;
    } while (n !== o);

    return s;
  }(t, e), e) {
    var _n178 = Mo(e, t);

    io(e, e.next), io(_n178, _n178.next);
  }
}

function uo(t, e) {
  return vo(t.prev, t, e.prev) < 0 && vo(e.next, t, t.next) < 0;
}

function po(t, e, n, i, r) {
  return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - n) * r) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - i) * r) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
}

function mo(t) {
  var e = t,
      n = t;

  do {
    (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
  } while (e !== t);

  return n;
}

function fo(t, e, n, i, r, s, a, o) {
  return (r - a) * (e - o) - (t - a) * (s - o) >= 0 && (t - a) * (i - o) - (n - a) * (e - o) >= 0 && (n - a) * (s - o) - (r - a) * (i - o) >= 0;
}

function go(t, e) {
  return t.next.i !== e.i && t.prev.i !== e.i && !function (t, e) {
    var n = t;

    do {
      if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && xo(n, n.next, t, e)) return !0;
      n = n.next;
    } while (n !== t);

    return !1;
  }(t, e) && (wo(t, e) && wo(e, t) && function (t, e) {
    var n = t,
        i = !1;
    var r = (t.x + e.x) / 2,
        s = (t.y + e.y) / 2;

    do {
      n.y > s != n.next.y > s && n.next.y !== n.y && r < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
    } while (n !== t);

    return i;
  }(t, e) && (vo(t.prev, t, e.prev) || vo(t, e.prev, e)) || yo(t, e) && vo(t.prev, t, t.next) > 0 && vo(e.prev, e, e.next) > 0);
}

function vo(t, e, n) {
  return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
}

function yo(t, e) {
  return t.x === e.x && t.y === e.y;
}

function xo(t, e, n, i) {
  var r = bo(vo(t, e, n)),
      s = bo(vo(t, e, i)),
      a = bo(vo(n, i, t)),
      o = bo(vo(n, i, e));
  return r !== s && a !== o || !(0 !== r || !_o(t, n, e)) || !(0 !== s || !_o(t, i, e)) || !(0 !== a || !_o(n, t, i)) || !(0 !== o || !_o(n, e, i));
}

function _o(t, e, n) {
  return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
}

function bo(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}

function wo(t, e) {
  return vo(t.prev, t, t.next) < 0 ? vo(t, e, t.next) >= 0 && vo(t, t.prev, e) >= 0 : vo(t, e, t.prev) < 0 || vo(t, t.next, e) < 0;
}

function Mo(t, e) {
  var n = new Eo(t.i, t.x, t.y),
      i = new Eo(e.i, e.x, e.y),
      r = t.next,
      s = e.prev;
  return t.next = e, e.prev = t, n.next = r, r.prev = n, i.next = n, n.prev = i, s.next = i, i.prev = s, i;
}

function So(t, e, n, i) {
  var r = new Eo(t, e, n);
  return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
}

function To(t) {
  t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
}

function Eo(t, e, n) {
  this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}

var Ao = /*#__PURE__*/function () {
  function Ao() {
    _classCallCheck(this, Ao);
  }

  _createClass(Ao, null, [{
    key: "area",
    value: function area(t) {
      var e = t.length;
      var n = 0;

      for (var _i135 = e - 1, _r101 = 0; _r101 < e; _i135 = _r101++) {
        n += t[_i135].x * t[_r101].y - t[_r101].x * t[_i135].y;
      }

      return .5 * n;
    }
  }, {
    key: "isClockWise",
    value: function isClockWise(t) {
      return Ao.area(t) < 0;
    }
  }, {
    key: "triangulateShape",
    value: function triangulateShape(t, e) {
      var n = [],
          i = [],
          r = [];
      Ro(t), Co(n, t);
      var s = t.length;
      e.forEach(Ro);

      for (var _t202 = 0; _t202 < e.length; _t202++) {
        i.push(s), s += e[_t202].length, Co(n, e[_t202]);
      }

      var a = eo(n, i);

      for (var _t203 = 0; _t203 < a.length; _t203 += 3) {
        r.push(a.slice(_t203, _t203 + 3));
      }

      return r;
    }
  }]);

  return Ao;
}();

function Ro(t) {
  var e = t.length;
  e > 2 && t[e - 1].equals(t[0]) && t.pop();
}

function Co(t, e) {
  for (var _n179 = 0; _n179 < e.length; _n179++) {
    t.push(e[_n179].x), t.push(e[_n179].y);
  }
}

var Lo = /*#__PURE__*/function (_vn3) {
  _inherits(Lo, _vn3);

  var _super68 = _createSuper(Lo);

  function Lo() {
    var _this69;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new to([new mt(.5, .5), new mt(-.5, .5), new mt(-.5, -.5), new mt(.5, -.5)]);
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Lo);

    _this69 = _super68.call(this), _this69.type = "ExtrudeGeometry", _this69.parameters = {
      shapes: t,
      options: e
    }, t = Array.isArray(t) ? t : [t];

    var n = _assertThisInitialized(_this69),
        i = [],
        r = [];

    for (var _e177 = 0, _n180 = t.length; _e177 < _n180; _e177++) {
      s(t[_e177]);
    }

    function s(t) {
      var s = [],
          a = void 0 !== e.curveSegments ? e.curveSegments : 12,
          o = void 0 !== e.steps ? e.steps : 1;
      var l = void 0 !== e.depth ? e.depth : 1,
          h = void 0 === e.bevelEnabled || e.bevelEnabled,
          c = void 0 !== e.bevelThickness ? e.bevelThickness : .2,
          u = void 0 !== e.bevelSize ? e.bevelSize : c - .1,
          d = void 0 !== e.bevelOffset ? e.bevelOffset : 0,
          p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
      var m = e.extrudePath,
          f = void 0 !== e.UVGenerator ? e.UVGenerator : Po;
      void 0 !== e.amount && (console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth."), l = e.amount);

      var g,
          v,
          y,
          x,
          _,
          b = !1;

      m && (g = m.getSpacedPoints(o), b = !0, h = !1, v = m.computeFrenetFrames(o, !1), y = new zt(), x = new zt(), _ = new zt()), h || (p = 0, c = 0, u = 0, d = 0);
      var w = t.extractPoints(a);
      var M = w.shape;
      var S = w.holes;

      if (!Ao.isClockWise(M)) {
        M = M.reverse();

        for (var _t204 = 0, _e178 = S.length; _t204 < _e178; _t204++) {
          var _e179 = S[_t204];
          Ao.isClockWise(_e179) && (S[_t204] = _e179.reverse());
        }
      }

      var T = Ao.triangulateShape(M, S),
          E = M;

      for (var _t205 = 0, _e180 = S.length; _t205 < _e180; _t205++) {
        var _e181 = S[_t205];
        M = M.concat(_e181);
      }

      function A(t, e, n) {
        return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), e.clone().multiplyScalar(n).add(t);
      }

      var R = M.length,
          C = T.length;

      function L(t, e, n) {
        var i, r, s;
        var a = t.x - e.x,
            o = t.y - e.y,
            l = n.x - t.x,
            h = n.y - t.y,
            c = a * a + o * o,
            u = a * h - o * l;

        if (Math.abs(u) > Number.EPSILON) {
          var _u14 = Math.sqrt(c),
              _d15 = Math.sqrt(l * l + h * h),
              _p12 = e.x - o / _u14,
              _m9 = e.y + a / _u14,
              _f6 = ((n.x - h / _d15 - _p12) * h - (n.y + l / _d15 - _m9) * l) / (a * h - o * l);

          i = _p12 + a * _f6 - t.x, r = _m9 + o * _f6 - t.y;

          var _g6 = i * i + r * r;

          if (_g6 <= 2) return new mt(i, r);
          s = Math.sqrt(_g6 / 2);
        } else {
          var _t206 = !1;

          a > Number.EPSILON ? l > Number.EPSILON && (_t206 = !0) : a < -Number.EPSILON ? l < -Number.EPSILON && (_t206 = !0) : Math.sign(o) === Math.sign(h) && (_t206 = !0), _t206 ? (i = -o, r = a, s = Math.sqrt(c)) : (i = a, r = o, s = Math.sqrt(c / 2));
        }

        return new mt(i / s, r / s);
      }

      var P = [];

      for (var _t207 = 0, _e182 = E.length, _n181 = _e182 - 1, _i136 = _t207 + 1; _t207 < _e182; _t207++, _n181++, _i136++) {
        _n181 === _e182 && (_n181 = 0), _i136 === _e182 && (_i136 = 0), P[_t207] = L(E[_t207], E[_n181], E[_i136]);
      }

      var D = [];
      var I,
          O = P.concat();

      for (var _t208 = 0, _e183 = S.length; _t208 < _e183; _t208++) {
        var _e184 = S[_t208];
        I = [];

        for (var _t209 = 0, _n182 = _e184.length, _i137 = _n182 - 1, _r102 = _t209 + 1; _t209 < _n182; _t209++, _i137++, _r102++) {
          _i137 === _n182 && (_i137 = 0), _r102 === _n182 && (_r102 = 0), I[_t209] = L(_e184[_t209], _e184[_i137], _e184[_r102]);
        }

        D.push(I), O = O.concat(I);
      }

      for (var _t210 = 0; _t210 < p; _t210++) {
        var _e185 = _t210 / p,
            _n183 = c * Math.cos(_e185 * Math.PI / 2),
            _i138 = u * Math.sin(_e185 * Math.PI / 2) + d;

        for (var _t211 = 0, _e186 = E.length; _t211 < _e186; _t211++) {
          var _e187 = A(E[_t211], P[_t211], _i138);

          U(_e187.x, _e187.y, -_n183);
        }

        for (var _t212 = 0, _e188 = S.length; _t212 < _e188; _t212++) {
          var _e189 = S[_t212];
          I = D[_t212];

          for (var _t213 = 0, _r103 = _e189.length; _t213 < _r103; _t213++) {
            var _r104 = A(_e189[_t213], I[_t213], _i138);

            U(_r104.x, _r104.y, -_n183);
          }
        }
      }

      var N = u + d;

      for (var _t214 = 0; _t214 < R; _t214++) {
        var _e190 = h ? A(M[_t214], O[_t214], N) : M[_t214];

        b ? (x.copy(v.normals[0]).multiplyScalar(_e190.x), y.copy(v.binormals[0]).multiplyScalar(_e190.y), _.copy(g[0]).add(x).add(y), U(_.x, _.y, _.z)) : U(_e190.x, _e190.y, 0);
      }

      for (var _t215 = 1; _t215 <= o; _t215++) {
        for (var _e191 = 0; _e191 < R; _e191++) {
          var _n184 = h ? A(M[_e191], O[_e191], N) : M[_e191];

          b ? (x.copy(v.normals[_t215]).multiplyScalar(_n184.x), y.copy(v.binormals[_t215]).multiplyScalar(_n184.y), _.copy(g[_t215]).add(x).add(y), U(_.x, _.y, _.z)) : U(_n184.x, _n184.y, l / o * _t215);
        }
      }

      for (var _t216 = p - 1; _t216 >= 0; _t216--) {
        var _e192 = _t216 / p,
            _n185 = c * Math.cos(_e192 * Math.PI / 2),
            _i139 = u * Math.sin(_e192 * Math.PI / 2) + d;

        for (var _t217 = 0, _e193 = E.length; _t217 < _e193; _t217++) {
          var _e194 = A(E[_t217], P[_t217], _i139);

          U(_e194.x, _e194.y, l + _n185);
        }

        for (var _t218 = 0, _e195 = S.length; _t218 < _e195; _t218++) {
          var _e196 = S[_t218];
          I = D[_t218];

          for (var _t219 = 0, _r105 = _e196.length; _t219 < _r105; _t219++) {
            var _r106 = A(_e196[_t219], I[_t219], _i139);

            b ? U(_r106.x, _r106.y + g[o - 1].y, g[o - 1].x + _n185) : U(_r106.x, _r106.y, l + _n185);
          }
        }
      }

      function F(t, e) {
        var n = t.length;

        for (; --n >= 0;) {
          var _i140 = n;

          var _r107 = n - 1;

          _r107 < 0 && (_r107 = t.length - 1);

          for (var _t220 = 0, _n186 = o + 2 * p; _t220 < _n186; _t220++) {
            var _n187 = R * _t220,
                _s61 = R * (_t220 + 1);

            B(e + _i140 + _n187, e + _r107 + _n187, e + _r107 + _s61, e + _i140 + _s61);
          }
        }
      }

      function U(t, e, n) {
        s.push(t), s.push(e), s.push(n);
      }

      function k(t, e, r) {
        z(t), z(e), z(r);
        var s = i.length / 3,
            a = f.generateTopUV(n, i, s - 3, s - 2, s - 1);
        H(a[0]), H(a[1]), H(a[2]);
      }

      function B(t, e, r, s) {
        z(t), z(e), z(s), z(e), z(r), z(s);
        var a = i.length / 3,
            o = f.generateSideWallUV(n, i, a - 6, a - 3, a - 2, a - 1);
        H(o[0]), H(o[1]), H(o[3]), H(o[1]), H(o[2]), H(o[3]);
      }

      function z(t) {
        i.push(s[3 * t + 0]), i.push(s[3 * t + 1]), i.push(s[3 * t + 2]);
      }

      function H(t) {
        r.push(t.x), r.push(t.y);
      }

      !function () {
        var t = i.length / 3;

        if (h) {
          var _t221 = 0,
              _e197 = R * _t221;

          for (var _t222 = 0; _t222 < C; _t222++) {
            var _n188 = T[_t222];
            k(_n188[2] + _e197, _n188[1] + _e197, _n188[0] + _e197);
          }

          _t221 = o + 2 * p, _e197 = R * _t221;

          for (var _t223 = 0; _t223 < C; _t223++) {
            var _n189 = T[_t223];
            k(_n189[0] + _e197, _n189[1] + _e197, _n189[2] + _e197);
          }
        } else {
          for (var _t224 = 0; _t224 < C; _t224++) {
            var _e198 = T[_t224];
            k(_e198[2], _e198[1], _e198[0]);
          }

          for (var _t225 = 0; _t225 < C; _t225++) {
            var _e199 = T[_t225];
            k(_e199[0] + R * o, _e199[1] + R * o, _e199[2] + R * o);
          }
        }

        n.addGroup(t, i.length / 3 - t, 0);
      }(), function () {
        var t = i.length / 3;
        var e = 0;
        F(E, e), e += E.length;

        for (var _t226 = 0, _n190 = S.length; _t226 < _n190; _t226++) {
          var _n191 = S[_t226];
          F(_n191, e), e += _n191.length;
        }

        n.addGroup(t, i.length / 3 - t, 1);
      }();
    }

    _this69.setAttribute("position", new hn(i, 3)), _this69.setAttribute("uv", new hn(r, 2)), _this69.computeVertexNormals();
    return _this69;
  }

  _createClass(Lo, [{
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Lo.prototype), "toJSON", this).call(this);

      return function (t, e, n) {
        if (n.shapes = [], Array.isArray(t)) for (var _e200 = 0, _i141 = t.length; _e200 < _i141; _e200++) {
          var _i142 = t[_e200];
          n.shapes.push(_i142.uuid);
        } else n.shapes.push(t.uuid);
        void 0 !== e.extrudePath && (n.options.extrudePath = e.extrudePath.toJSON());
        return n;
      }(this.parameters.shapes, this.parameters.options, t);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(t, e) {
      var n = [];

      for (var _i143 = 0, _r108 = t.shapes.length; _i143 < _r108; _i143++) {
        var _r109 = e[t.shapes[_i143]];
        n.push(_r109);
      }

      var i = t.options.extrudePath;
      return void 0 !== i && (t.options.extrudePath = new $a[i.type]().fromJSON(i)), new Lo(n, t.options);
    }
  }]);

  return Lo;
}(vn);

var Po = {
  generateTopUV: function generateTopUV(t, e, n, i, r) {
    var s = e[3 * n],
        a = e[3 * n + 1],
        o = e[3 * i],
        l = e[3 * i + 1],
        h = e[3 * r],
        c = e[3 * r + 1];
    return [new mt(s, a), new mt(o, l), new mt(h, c)];
  },
  generateSideWallUV: function generateSideWallUV(t, e, n, i, r, s) {
    var a = e[3 * n],
        o = e[3 * n + 1],
        l = e[3 * n + 2],
        h = e[3 * i],
        c = e[3 * i + 1],
        u = e[3 * i + 2],
        d = e[3 * r],
        p = e[3 * r + 1],
        m = e[3 * r + 2],
        f = e[3 * s],
        g = e[3 * s + 1],
        v = e[3 * s + 2];
    return Math.abs(o - c) < Math.abs(a - h) ? [new mt(a, 1 - l), new mt(h, 1 - u), new mt(d, 1 - m), new mt(f, 1 - v)] : [new mt(o, 1 - l), new mt(c, 1 - u), new mt(p, 1 - m), new mt(g, 1 - v)];
  }
};

var Do = /*#__PURE__*/function (_vn4) {
  _inherits(Do, _vn4);

  var _super69 = _createSuper(Do);

  function Do() {
    var _this70;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new to([new mt(0, .5), new mt(-.5, -.5), new mt(.5, -.5)]);
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

    _classCallCheck(this, Do);

    _this70 = _super69.call(this), _this70.type = "ShapeGeometry", _this70.parameters = {
      shapes: t,
      curveSegments: e
    };
    var n = [],
        i = [],
        r = [],
        s = [];
    var a = 0,
        o = 0;
    if (!1 === Array.isArray(t)) l(t);else for (var _e201 = 0; _e201 < t.length; _e201++) {
      l(t[_e201]), _this70.addGroup(a, o, _e201), a += o, o = 0;
    }

    function l(t) {
      var a = i.length / 3,
          l = t.extractPoints(e);
      var h = l.shape;
      var c = l.holes;
      !1 === Ao.isClockWise(h) && (h = h.reverse());

      for (var _t227 = 0, _e202 = c.length; _t227 < _e202; _t227++) {
        var _e203 = c[_t227];
        !0 === Ao.isClockWise(_e203) && (c[_t227] = _e203.reverse());
      }

      var u = Ao.triangulateShape(h, c);

      for (var _t228 = 0, _e204 = c.length; _t228 < _e204; _t228++) {
        var _e205 = c[_t228];
        h = h.concat(_e205);
      }

      for (var _t229 = 0, _e206 = h.length; _t229 < _e206; _t229++) {
        var _e207 = h[_t229];
        i.push(_e207.x, _e207.y, 0), r.push(0, 0, 1), s.push(_e207.x, _e207.y);
      }

      for (var _t230 = 0, _e208 = u.length; _t230 < _e208; _t230++) {
        var _e209 = u[_t230],
            _i144 = _e209[0] + a,
            _r110 = _e209[1] + a,
            _s62 = _e209[2] + a;

        n.push(_i144, _r110, _s62), o += 3;
      }
    }

    _this70.setIndex(n), _this70.setAttribute("position", new hn(i, 3)), _this70.setAttribute("normal", new hn(r, 3)), _this70.setAttribute("uv", new hn(s, 2));
    return _this70;
  }

  _createClass(Do, [{
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Do.prototype), "toJSON", this).call(this);

      return function (t, e) {
        if (e.shapes = [], Array.isArray(t)) for (var _n192 = 0, _i145 = t.length; _n192 < _i145; _n192++) {
          var _i146 = t[_n192];
          e.shapes.push(_i146.uuid);
        } else e.shapes.push(t.uuid);
        return e;
      }(this.parameters.shapes, t);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(t, e) {
      var n = [];

      for (var _i147 = 0, _r111 = t.shapes.length; _i147 < _r111; _i147++) {
        var _r112 = e[t.shapes[_i147]];
        n.push(_r112);
      }

      return new Do(n, t.curveSegments);
    }
  }]);

  return Do;
}(vn);

var Io = /*#__PURE__*/function (_en8) {
  _inherits(Io, _en8);

  var _super70 = _createSuper(Io);

  function Io(t) {
    var _this71;

    _classCallCheck(this, Io);

    _this71 = _super70.call(this), _this71.type = "ShadowMaterial", _this71.color = new Rt(0), _this71.transparent = !0, _this71.setValues(t);
    return _this71;
  }

  _createClass(Io, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Io.prototype), "copy", this).call(this, t), this.color.copy(t.color), this;
    }
  }]);

  return Io;
}(en);

Io.prototype.isShadowMaterial = !0;

var Oo = /*#__PURE__*/function (_Hn) {
  _inherits(Oo, _Hn);

  var _super71 = _createSuper(Oo);

  function Oo(t) {
    var _this72;

    _classCallCheck(this, Oo);

    _this72 = _super71.call(this, t), _this72.type = "RawShaderMaterial";
    return _this72;
  }

  return Oo;
}(Hn);

Oo.prototype.isRawShaderMaterial = !0;

var No = /*#__PURE__*/function (_en9) {
  _inherits(No, _en9);

  var _super72 = _createSuper(No);

  function No(t) {
    var _this73;

    _classCallCheck(this, No);

    _this73 = _super72.call(this), _this73.defines = {
      STANDARD: ""
    }, _this73.type = "MeshStandardMaterial", _this73.color = new Rt(16777215), _this73.roughness = 1, _this73.metalness = 0, _this73.map = null, _this73.lightMap = null, _this73.lightMapIntensity = 1, _this73.aoMap = null, _this73.aoMapIntensity = 1, _this73.emissive = new Rt(0), _this73.emissiveIntensity = 1, _this73.emissiveMap = null, _this73.bumpMap = null, _this73.bumpScale = 1, _this73.normalMap = null, _this73.normalMapType = 0, _this73.normalScale = new mt(1, 1), _this73.displacementMap = null, _this73.displacementScale = 1, _this73.displacementBias = 0, _this73.roughnessMap = null, _this73.metalnessMap = null, _this73.alphaMap = null, _this73.envMap = null, _this73.envMapIntensity = 1, _this73.wireframe = !1, _this73.wireframeLinewidth = 1, _this73.wireframeLinecap = "round", _this73.wireframeLinejoin = "round", _this73.flatShading = !1, _this73.setValues(t);
    return _this73;
  }

  _createClass(No, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(No.prototype), "copy", this).call(this, t), this.defines = {
        STANDARD: ""
      }, this.color.copy(t.color), this.roughness = t.roughness, this.metalness = t.metalness, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.roughnessMap = t.roughnessMap, this.metalnessMap = t.metalnessMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapIntensity = t.envMapIntensity, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this;
    }
  }]);

  return No;
}(en);

No.prototype.isMeshStandardMaterial = !0;

var Fo = /*#__PURE__*/function (_No) {
  _inherits(Fo, _No);

  var _super73 = _createSuper(Fo);

  function Fo(t) {
    var _this74;

    _classCallCheck(this, Fo);

    _this74 = _super73.call(this), _this74.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, _this74.type = "MeshPhysicalMaterial", _this74.clearcoatMap = null, _this74.clearcoatRoughness = 0, _this74.clearcoatRoughnessMap = null, _this74.clearcoatNormalScale = new mt(1, 1), _this74.clearcoatNormalMap = null, _this74.ior = 1.5, Object.defineProperty(_assertThisInitialized(_this74), "reflectivity", {
      get: function get() {
        return ot(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function set(t) {
        this.ior = (1 + .4 * t) / (1 - .4 * t);
      }
    }), _this74.sheenColor = new Rt(0), _this74.sheenColorMap = null, _this74.sheenRoughness = 1, _this74.sheenRoughnessMap = null, _this74.transmissionMap = null, _this74.thickness = 0, _this74.thicknessMap = null, _this74.attenuationDistance = 0, _this74.attenuationColor = new Rt(1, 1, 1), _this74.specularIntensity = 1, _this74.specularIntensityMap = null, _this74.specularColor = new Rt(1, 1, 1), _this74.specularColorMap = null, _this74._sheen = 0, _this74._clearcoat = 0, _this74._transmission = 0, _this74.setValues(t);
    return _this74;
  }

  _createClass(Fo, [{
    key: "sheen",
    get: function get() {
      return this._sheen;
    },
    set: function set(t) {
      this._sheen > 0 != t > 0 && this.version++, this._sheen = t;
    }
  }, {
    key: "clearcoat",
    get: function get() {
      return this._clearcoat;
    },
    set: function set(t) {
      this._clearcoat > 0 != t > 0 && this.version++, this._clearcoat = t;
    }
  }, {
    key: "transmission",
    get: function get() {
      return this._transmission;
    },
    set: function set(t) {
      this._transmission > 0 != t > 0 && this.version++, this._transmission = t;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Fo.prototype), "copy", this).call(this, t), this.defines = {
        STANDARD: "",
        PHYSICAL: ""
      }, this.clearcoat = t.clearcoat, this.clearcoatMap = t.clearcoatMap, this.clearcoatRoughness = t.clearcoatRoughness, this.clearcoatRoughnessMap = t.clearcoatRoughnessMap, this.clearcoatNormalMap = t.clearcoatNormalMap, this.clearcoatNormalScale.copy(t.clearcoatNormalScale), this.ior = t.ior, this.sheen = t.sheen, this.sheenColor.copy(t.sheenColor), this.sheenColorMap = t.sheenColorMap, this.sheenRoughness = t.sheenRoughness, this.sheenRoughnessMap = t.sheenRoughnessMap, this.transmission = t.transmission, this.transmissionMap = t.transmissionMap, this.thickness = t.thickness, this.thicknessMap = t.thicknessMap, this.attenuationDistance = t.attenuationDistance, this.attenuationColor.copy(t.attenuationColor), this.specularIntensity = t.specularIntensity, this.specularIntensityMap = t.specularIntensityMap, this.specularColor.copy(t.specularColor), this.specularColorMap = t.specularColorMap, this;
    }
  }]);

  return Fo;
}(No);

Fo.prototype.isMeshPhysicalMaterial = !0;

var Uo = /*#__PURE__*/function (_en10) {
  _inherits(Uo, _en10);

  var _super74 = _createSuper(Uo);

  function Uo(t) {
    var _this75;

    _classCallCheck(this, Uo);

    _this75 = _super74.call(this), _this75.type = "MeshPhongMaterial", _this75.color = new Rt(16777215), _this75.specular = new Rt(1118481), _this75.shininess = 30, _this75.map = null, _this75.lightMap = null, _this75.lightMapIntensity = 1, _this75.aoMap = null, _this75.aoMapIntensity = 1, _this75.emissive = new Rt(0), _this75.emissiveIntensity = 1, _this75.emissiveMap = null, _this75.bumpMap = null, _this75.bumpScale = 1, _this75.normalMap = null, _this75.normalMapType = 0, _this75.normalScale = new mt(1, 1), _this75.displacementMap = null, _this75.displacementScale = 1, _this75.displacementBias = 0, _this75.specularMap = null, _this75.alphaMap = null, _this75.envMap = null, _this75.combine = 0, _this75.reflectivity = 1, _this75.refractionRatio = .98, _this75.wireframe = !1, _this75.wireframeLinewidth = 1, _this75.wireframeLinecap = "round", _this75.wireframeLinejoin = "round", _this75.flatShading = !1, _this75.setValues(t);
    return _this75;
  }

  _createClass(Uo, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Uo.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.specular.copy(t.specular), this.shininess = t.shininess, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this;
    }
  }]);

  return Uo;
}(en);

Uo.prototype.isMeshPhongMaterial = !0;

var ko = /*#__PURE__*/function (_en11) {
  _inherits(ko, _en11);

  var _super75 = _createSuper(ko);

  function ko(t) {
    var _this76;

    _classCallCheck(this, ko);

    _this76 = _super75.call(this), _this76.defines = {
      TOON: ""
    }, _this76.type = "MeshToonMaterial", _this76.color = new Rt(16777215), _this76.map = null, _this76.gradientMap = null, _this76.lightMap = null, _this76.lightMapIntensity = 1, _this76.aoMap = null, _this76.aoMapIntensity = 1, _this76.emissive = new Rt(0), _this76.emissiveIntensity = 1, _this76.emissiveMap = null, _this76.bumpMap = null, _this76.bumpScale = 1, _this76.normalMap = null, _this76.normalMapType = 0, _this76.normalScale = new mt(1, 1), _this76.displacementMap = null, _this76.displacementScale = 1, _this76.displacementBias = 0, _this76.alphaMap = null, _this76.wireframe = !1, _this76.wireframeLinewidth = 1, _this76.wireframeLinecap = "round", _this76.wireframeLinejoin = "round", _this76.setValues(t);
    return _this76;
  }

  _createClass(ko, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ko.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.gradientMap = t.gradientMap, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
    }
  }]);

  return ko;
}(en);

ko.prototype.isMeshToonMaterial = !0;

var Bo = /*#__PURE__*/function (_en12) {
  _inherits(Bo, _en12);

  var _super76 = _createSuper(Bo);

  function Bo(t) {
    var _this77;

    _classCallCheck(this, Bo);

    _this77 = _super76.call(this), _this77.type = "MeshNormalMaterial", _this77.bumpMap = null, _this77.bumpScale = 1, _this77.normalMap = null, _this77.normalMapType = 0, _this77.normalScale = new mt(1, 1), _this77.displacementMap = null, _this77.displacementScale = 1, _this77.displacementBias = 0, _this77.wireframe = !1, _this77.wireframeLinewidth = 1, _this77.fog = !1, _this77.flatShading = !1, _this77.setValues(t);
    return _this77;
  }

  _createClass(Bo, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Bo.prototype), "copy", this).call(this, t), this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.flatShading = t.flatShading, this;
    }
  }]);

  return Bo;
}(en);

Bo.prototype.isMeshNormalMaterial = !0;

var zo = /*#__PURE__*/function (_en13) {
  _inherits(zo, _en13);

  var _super77 = _createSuper(zo);

  function zo(t) {
    var _this78;

    _classCallCheck(this, zo);

    _this78 = _super77.call(this), _this78.type = "MeshLambertMaterial", _this78.color = new Rt(16777215), _this78.map = null, _this78.lightMap = null, _this78.lightMapIntensity = 1, _this78.aoMap = null, _this78.aoMapIntensity = 1, _this78.emissive = new Rt(0), _this78.emissiveIntensity = 1, _this78.emissiveMap = null, _this78.specularMap = null, _this78.alphaMap = null, _this78.envMap = null, _this78.combine = 0, _this78.reflectivity = 1, _this78.refractionRatio = .98, _this78.wireframe = !1, _this78.wireframeLinewidth = 1, _this78.wireframeLinecap = "round", _this78.wireframeLinejoin = "round", _this78.setValues(t);
    return _this78;
  }

  _createClass(zo, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(zo.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
    }
  }]);

  return zo;
}(en);

zo.prototype.isMeshLambertMaterial = !0;

var Ho = /*#__PURE__*/function (_en14) {
  _inherits(Ho, _en14);

  var _super78 = _createSuper(Ho);

  function Ho(t) {
    var _this79;

    _classCallCheck(this, Ho);

    _this79 = _super78.call(this), _this79.defines = {
      MATCAP: ""
    }, _this79.type = "MeshMatcapMaterial", _this79.color = new Rt(16777215), _this79.matcap = null, _this79.map = null, _this79.bumpMap = null, _this79.bumpScale = 1, _this79.normalMap = null, _this79.normalMapType = 0, _this79.normalScale = new mt(1, 1), _this79.displacementMap = null, _this79.displacementScale = 1, _this79.displacementBias = 0, _this79.alphaMap = null, _this79.flatShading = !1, _this79.setValues(t);
    return _this79;
  }

  _createClass(Ho, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ho.prototype), "copy", this).call(this, t), this.defines = {
        MATCAP: ""
      }, this.color.copy(t.color), this.matcap = t.matcap, this.map = t.map, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.flatShading = t.flatShading, this;
    }
  }]);

  return Ho;
}(en);

Ho.prototype.isMeshMatcapMaterial = !0;

var Vo = /*#__PURE__*/function (_ma) {
  _inherits(Vo, _ma);

  var _super79 = _createSuper(Vo);

  function Vo(t) {
    var _this80;

    _classCallCheck(this, Vo);

    _this80 = _super79.call(this), _this80.type = "LineDashedMaterial", _this80.scale = 1, _this80.dashSize = 3, _this80.gapSize = 1, _this80.setValues(t);
    return _this80;
  }

  _createClass(Vo, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Vo.prototype), "copy", this).call(this, t), this.scale = t.scale, this.dashSize = t.dashSize, this.gapSize = t.gapSize, this;
    }
  }]);

  return Vo;
}(ma);

Vo.prototype.isLineDashedMaterial = !0;
var Go = {
  ShadowMaterial: Io,
  SpriteMaterial: Us,
  RawShaderMaterial: Oo,
  ShaderMaterial: Hn,
  PointsMaterial: Ta,
  MeshPhysicalMaterial: Fo,
  MeshStandardMaterial: No,
  MeshPhongMaterial: Uo,
  MeshToonMaterial: ko,
  MeshNormalMaterial: Bo,
  MeshLambertMaterial: zo,
  MeshDepthMaterial: xs,
  MeshDistanceMaterial: _s,
  MeshBasicMaterial: nn,
  MeshMatcapMaterial: Ho,
  LineDashedMaterial: Vo,
  LineBasicMaterial: ma,
  Material: en
};

en.fromType = function (t) {
  return new Go[t]();
};

var Wo = {
  arraySlice: function arraySlice(t, e, n) {
    return Wo.isTypedArray(t) ? new t.constructor(t.subarray(e, void 0 !== n ? n : t.length)) : t.slice(e, n);
  },
  convertArray: function convertArray(t, e, n) {
    return !t || !n && t.constructor === e ? t : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t) : Array.prototype.slice.call(t);
  },
  isTypedArray: function isTypedArray(t) {
    return ArrayBuffer.isView(t) && !(t instanceof DataView);
  },
  getKeyframeOrder: function getKeyframeOrder(t) {
    var e = t.length,
        n = new Array(e);

    for (var _t231 = 0; _t231 !== e; ++_t231) {
      n[_t231] = _t231;
    }

    return n.sort(function (e, n) {
      return t[e] - t[n];
    }), n;
  },
  sortedArray: function sortedArray(t, e, n) {
    var i = t.length,
        r = new t.constructor(i);

    for (var _s63 = 0, _a48 = 0; _a48 !== i; ++_s63) {
      var _i148 = n[_s63] * e;

      for (var _n193 = 0; _n193 !== e; ++_n193) {
        r[_a48++] = t[_i148 + _n193];
      }
    }

    return r;
  },
  flattenJSON: function flattenJSON(t, e, n, i) {
    var r = 1,
        s = t[0];

    for (; void 0 !== s && void 0 === s[i];) {
      s = t[r++];
    }

    if (void 0 === s) return;
    var a = s[i];
    if (void 0 !== a) if (Array.isArray(a)) do {
      a = s[i], void 0 !== a && (e.push(s.time), n.push.apply(n, a)), s = t[r++];
    } while (void 0 !== s);else if (void 0 !== a.toArray) do {
      a = s[i], void 0 !== a && (e.push(s.time), a.toArray(n, n.length)), s = t[r++];
    } while (void 0 !== s);else do {
      a = s[i], void 0 !== a && (e.push(s.time), n.push(a)), s = t[r++];
    } while (void 0 !== s);
  },
  subclip: function subclip(t, e, n, i) {
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
    var s = t.clone();
    s.name = e;
    var a = [];

    for (var _t232 = 0; _t232 < s.tracks.length; ++_t232) {
      var _e210 = s.tracks[_t232],
          _o30 = _e210.getValueSize(),
          _l30 = [],
          _h20 = [];

      for (var _t233 = 0; _t233 < _e210.times.length; ++_t233) {
        var _s64 = _e210.times[_t233] * r;

        if (!(_s64 < n || _s64 >= i)) {
          _l30.push(_e210.times[_t233]);

          for (var _n194 = 0; _n194 < _o30; ++_n194) {
            _h20.push(_e210.values[_t233 * _o30 + _n194]);
          }
        }
      }

      0 !== _l30.length && (_e210.times = Wo.convertArray(_l30, _e210.times.constructor), _e210.values = Wo.convertArray(_h20, _e210.values.constructor), a.push(_e210));
    }

    s.tracks = a;
    var o = 1 / 0;

    for (var _t234 = 0; _t234 < s.tracks.length; ++_t234) {
      o > s.tracks[_t234].times[0] && (o = s.tracks[_t234].times[0]);
    }

    for (var _t235 = 0; _t235 < s.tracks.length; ++_t235) {
      s.tracks[_t235].shift(-1 * o);
    }

    return s.resetDuration(), s;
  },
  makeClipAdditive: function makeClipAdditive(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
    i <= 0 && (i = 30);
    var r = n.tracks.length,
        s = e / i;

    var _loop = function _loop(_e211) {
      var i = n.tracks[_e211],
          r = i.ValueTypeName;
      if ("bool" === r || "string" === r) return "continue";
      var a = t.tracks.find(function (t) {
        return t.name === i.name && t.ValueTypeName === r;
      });
      if (void 0 === a) return "continue";
      var o = 0;
      var l = i.getValueSize();
      i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
      var h = 0;
      var c = a.getValueSize();
      a.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (h = c / 3);
      var u = i.times.length - 1;
      var d = void 0;

      if (s <= i.times[0]) {
        var _t236 = o,
            _e212 = l - o;

        d = Wo.arraySlice(i.values, _t236, _e212);
      } else if (s >= i.times[u]) {
        var _t237 = u * l + o,
            _e213 = _t237 + l - o;

        d = Wo.arraySlice(i.values, _t237, _e213);
      } else {
        var _t238 = i.createInterpolant(),
            _e214 = o,
            _n195 = l - o;

        _t238.evaluate(s), d = Wo.arraySlice(_t238.resultBuffer, _e214, _n195);
      }

      if ("quaternion" === r) {
        new Bt().fromArray(d).normalize().conjugate().toArray(d);
      }

      var p = a.times.length;

      for (var _t239 = 0; _t239 < p; ++_t239) {
        var _e215 = _t239 * c + h;

        if ("quaternion" === r) Bt.multiplyQuaternionsFlat(a.values, _e215, d, 0, a.values, _e215);else {
          var _t240 = c - 2 * h;

          for (var _n196 = 0; _n196 < _t240; ++_n196) {
            a.values[_e215 + _n196] -= d[_n196];
          }
        }
      }
    };

    for (var _e211 = 0; _e211 < r; ++_e211) {
      var _ret = _loop(_e211);

      if (_ret === "continue") continue;
    }

    return t.blendMode = 2501, t;
  }
};

var jo = /*#__PURE__*/function () {
  function jo(t, e, n, i) {
    _classCallCheck(this, jo);

    this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new e.constructor(n), this.sampleValues = e, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
  }

  _createClass(jo, [{
    key: "evaluate",
    value: function evaluate(t) {
      var e = this.parameterPositions;
      var n = this._cachedIndex,
          i = e[n],
          r = e[n - 1];

      t: {
        e: {
          var _s65;

          n: {
            i: if (!(t < i)) {
              for (var _s66 = n + 2;;) {
                if (void 0 === i) {
                  if (t < r) break i;
                  return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, t, r);
                }

                if (n === _s66) break;
                if (r = i, i = e[++n], t < i) break e;
              }

              _s65 = e.length;
              break n;
            }

            if (t >= r) break t;
            {
              var _a49 = e[1];
              t < _a49 && (n = 2, r = _a49);

              for (var _s67 = n - 2;;) {
                if (void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, i);
                if (n === _s67) break;
                if (i = r, r = e[--n - 1], t >= r) break e;
              }

              _s65 = n, n = 0;
            }
          }

          for (; n < _s65;) {
            var _i149 = n + _s65 >>> 1;

            t < e[_i149] ? _s65 = _i149 : n = _i149 + 1;
          }

          if (i = e[n], r = e[n - 1], void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, i);
          if (void 0 === i) return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, r, t);
        }

        this._cachedIndex = n, this.intervalChanged_(n, r, i);
      }

      return this.interpolate_(n, r, t, i);
    }
  }, {
    key: "getSettings_",
    value: function getSettings_() {
      return this.settings || this.DefaultSettings_;
    }
  }, {
    key: "copySampleValue_",
    value: function copySampleValue_(t) {
      var e = this.resultBuffer,
          n = this.sampleValues,
          i = this.valueSize,
          r = t * i;

      for (var _t241 = 0; _t241 !== i; ++_t241) {
        e[_t241] = n[r + _t241];
      }

      return e;
    }
  }, {
    key: "interpolate_",
    value: function interpolate_() {
      throw new Error("call to abstract method");
    }
  }, {
    key: "intervalChanged_",
    value: function intervalChanged_() {}
  }]);

  return jo;
}();

jo.prototype.beforeStart_ = jo.prototype.copySampleValue_, jo.prototype.afterEnd_ = jo.prototype.copySampleValue_;

var qo = /*#__PURE__*/function (_jo) {
  _inherits(qo, _jo);

  var _super80 = _createSuper(qo);

  function qo(t, e, n, i) {
    var _this81;

    _classCallCheck(this, qo);

    _this81 = _super80.call(this, t, e, n, i), _this81._weightPrev = -0, _this81._offsetPrev = -0, _this81._weightNext = -0, _this81._offsetNext = -0, _this81.DefaultSettings_ = {
      endingStart: 2400,
      endingEnd: 2400
    };
    return _this81;
  }

  _createClass(qo, [{
    key: "intervalChanged_",
    value: function intervalChanged_(t, e, n) {
      var i = this.parameterPositions;
      var r = t - 2,
          s = t + 1,
          a = i[r],
          o = i[s];
      if (void 0 === a) switch (this.getSettings_().endingStart) {
        case 2401:
          r = t, a = 2 * e - n;
          break;

        case 2402:
          r = i.length - 2, a = e + i[r] - i[r + 1];
          break;

        default:
          r = t, a = n;
      }
      if (void 0 === o) switch (this.getSettings_().endingEnd) {
        case 2401:
          s = t, o = 2 * n - e;
          break;

        case 2402:
          s = 1, o = n + i[1] - i[0];
          break;

        default:
          s = t - 1, o = e;
      }
      var l = .5 * (n - e),
          h = this.valueSize;
      this._weightPrev = l / (e - a), this._weightNext = l / (o - n), this._offsetPrev = r * h, this._offsetNext = s * h;
    }
  }, {
    key: "interpolate_",
    value: function interpolate_(t, e, n, i) {
      var r = this.resultBuffer,
          s = this.sampleValues,
          a = this.valueSize,
          o = t * a,
          l = o - a,
          h = this._offsetPrev,
          c = this._offsetNext,
          u = this._weightPrev,
          d = this._weightNext,
          p = (n - e) / (i - e),
          m = p * p,
          f = m * p,
          g = -u * f + 2 * u * m - u * p,
          v = (1 + u) * f + (-1.5 - 2 * u) * m + (-.5 + u) * p + 1,
          y = (-1 - d) * f + (1.5 + d) * m + .5 * p,
          x = d * f - d * m;

      for (var _t242 = 0; _t242 !== a; ++_t242) {
        r[_t242] = g * s[h + _t242] + v * s[l + _t242] + y * s[o + _t242] + x * s[c + _t242];
      }

      return r;
    }
  }]);

  return qo;
}(jo);

var Xo = /*#__PURE__*/function (_jo2) {
  _inherits(Xo, _jo2);

  var _super81 = _createSuper(Xo);

  function Xo(t, e, n, i) {
    _classCallCheck(this, Xo);

    return _super81.call(this, t, e, n, i);
  }

  _createClass(Xo, [{
    key: "interpolate_",
    value: function interpolate_(t, e, n, i) {
      var r = this.resultBuffer,
          s = this.sampleValues,
          a = this.valueSize,
          o = t * a,
          l = o - a,
          h = (n - e) / (i - e),
          c = 1 - h;

      for (var _t243 = 0; _t243 !== a; ++_t243) {
        r[_t243] = s[l + _t243] * c + s[o + _t243] * h;
      }

      return r;
    }
  }]);

  return Xo;
}(jo);

var Yo = /*#__PURE__*/function (_jo3) {
  _inherits(Yo, _jo3);

  var _super82 = _createSuper(Yo);

  function Yo(t, e, n, i) {
    _classCallCheck(this, Yo);

    return _super82.call(this, t, e, n, i);
  }

  _createClass(Yo, [{
    key: "interpolate_",
    value: function interpolate_(t) {
      return this.copySampleValue_(t - 1);
    }
  }]);

  return Yo;
}(jo);

var Jo = /*#__PURE__*/function () {
  function Jo(t, e, n, i) {
    _classCallCheck(this, Jo);

    if (void 0 === t) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
    this.name = t, this.times = Wo.convertArray(e, this.TimeBufferType), this.values = Wo.convertArray(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
  }

  _createClass(Jo, [{
    key: "InterpolantFactoryMethodDiscrete",
    value: function InterpolantFactoryMethodDiscrete(t) {
      return new Yo(this.times, this.values, this.getValueSize(), t);
    }
  }, {
    key: "InterpolantFactoryMethodLinear",
    value: function InterpolantFactoryMethodLinear(t) {
      return new Xo(this.times, this.values, this.getValueSize(), t);
    }
  }, {
    key: "InterpolantFactoryMethodSmooth",
    value: function InterpolantFactoryMethodSmooth(t) {
      return new qo(this.times, this.values, this.getValueSize(), t);
    }
  }, {
    key: "setInterpolation",
    value: function setInterpolation(t) {
      var e;

      switch (t) {
        case 2300:
          e = this.InterpolantFactoryMethodDiscrete;
          break;

        case 2301:
          e = this.InterpolantFactoryMethodLinear;
          break;

        case 2302:
          e = this.InterpolantFactoryMethodSmooth;
      }

      if (void 0 === e) {
        var _e216 = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;

        if (void 0 === this.createInterpolant) {
          if (t === this.DefaultInterpolation) throw new Error(_e216);
          this.setInterpolation(this.DefaultInterpolation);
        }

        return console.warn("THREE.KeyframeTrack:", _e216), this;
      }

      return this.createInterpolant = e, this;
    }
  }, {
    key: "getInterpolation",
    value: function getInterpolation() {
      switch (this.createInterpolant) {
        case this.InterpolantFactoryMethodDiscrete:
          return 2300;

        case this.InterpolantFactoryMethodLinear:
          return 2301;

        case this.InterpolantFactoryMethodSmooth:
          return 2302;
      }
    }
  }, {
    key: "getValueSize",
    value: function getValueSize() {
      return this.values.length / this.times.length;
    }
  }, {
    key: "shift",
    value: function shift(t) {
      if (0 !== t) {
        var _e217 = this.times;

        for (var _n197 = 0, _i150 = _e217.length; _n197 !== _i150; ++_n197) {
          _e217[_n197] += t;
        }
      }

      return this;
    }
  }, {
    key: "scale",
    value: function scale(t) {
      if (1 !== t) {
        var _e218 = this.times;

        for (var _n198 = 0, _i151 = _e218.length; _n198 !== _i151; ++_n198) {
          _e218[_n198] *= t;
        }
      }

      return this;
    }
  }, {
    key: "trim",
    value: function trim(t, e) {
      var n = this.times,
          i = n.length;
      var r = 0,
          s = i - 1;

      for (; r !== i && n[r] < t;) {
        ++r;
      }

      for (; -1 !== s && n[s] > e;) {
        --s;
      }

      if (++s, 0 !== r || s !== i) {
        r >= s && (s = Math.max(s, 1), r = s - 1);

        var _t244 = this.getValueSize();

        this.times = Wo.arraySlice(n, r, s), this.values = Wo.arraySlice(this.values, r * _t244, s * _t244);
      }

      return this;
    }
  }, {
    key: "validate",
    value: function validate() {
      var t = !0;
      var e = this.getValueSize();
      e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
      var n = this.times,
          i = this.values,
          r = n.length;
      0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
      var s = null;

      for (var _e219 = 0; _e219 !== r; _e219++) {
        var _i152 = n[_e219];

        if ("number" == typeof _i152 && isNaN(_i152)) {
          console.error("THREE.KeyframeTrack: Time is not a valid number.", this, _e219, _i152), t = !1;
          break;
        }

        if (null !== s && s > _i152) {
          console.error("THREE.KeyframeTrack: Out of order keys.", this, _e219, _i152, s), t = !1;
          break;
        }

        s = _i152;
      }

      if (void 0 !== i && Wo.isTypedArray(i)) for (var _e220 = 0, _n199 = i.length; _e220 !== _n199; ++_e220) {
        var _n200 = i[_e220];

        if (isNaN(_n200)) {
          console.error("THREE.KeyframeTrack: Value is not a valid number.", this, _e220, _n200), t = !1;
          break;
        }
      }
      return t;
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var t = Wo.arraySlice(this.times),
          e = Wo.arraySlice(this.values),
          n = this.getValueSize(),
          i = 2302 === this.getInterpolation(),
          r = t.length - 1;
      var s = 1;

      for (var _a50 = 1; _a50 < r; ++_a50) {
        var _r113 = !1;

        var _o31 = t[_a50];
        if (_o31 !== t[_a50 + 1] && (1 !== _a50 || _o31 !== t[0])) if (i) _r113 = !0;else {
          var _t245 = _a50 * n,
              _i153 = _t245 - n,
              _s68 = _t245 + n;

          for (var _a51 = 0; _a51 !== n; ++_a51) {
            var _n201 = e[_t245 + _a51];

            if (_n201 !== e[_i153 + _a51] || _n201 !== e[_s68 + _a51]) {
              _r113 = !0;
              break;
            }
          }
        }

        if (_r113) {
          if (_a50 !== s) {
            t[s] = t[_a50];

            var _i154 = _a50 * n,
                _r114 = s * n;

            for (var _t246 = 0; _t246 !== n; ++_t246) {
              e[_r114 + _t246] = e[_i154 + _t246];
            }
          }

          ++s;
        }
      }

      if (r > 0) {
        t[s] = t[r];

        for (var _t247 = r * n, _i155 = s * n, _a52 = 0; _a52 !== n; ++_a52) {
          e[_i155 + _a52] = e[_t247 + _a52];
        }

        ++s;
      }

      return s !== t.length ? (this.times = Wo.arraySlice(t, 0, s), this.values = Wo.arraySlice(e, 0, s * n)) : (this.times = t, this.values = e), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      var t = Wo.arraySlice(this.times, 0),
          e = Wo.arraySlice(this.values, 0),
          n = new (0, this.constructor)(this.name, t, e);
      return n.createInterpolant = this.createInterpolant, n;
    }
  }], [{
    key: "toJSON",
    value: function toJSON(t) {
      var e = t.constructor;
      var n;
      if (e.toJSON !== this.toJSON) n = e.toJSON(t);else {
        n = {
          name: t.name,
          times: Wo.convertArray(t.times, Array),
          values: Wo.convertArray(t.values, Array)
        };

        var _e221 = t.getInterpolation();

        _e221 !== t.DefaultInterpolation && (n.interpolation = _e221);
      }
      return n.type = t.ValueTypeName, n;
    }
  }]);

  return Jo;
}();

Jo.prototype.TimeBufferType = Float32Array, Jo.prototype.ValueBufferType = Float32Array, Jo.prototype.DefaultInterpolation = 2301;

var Zo = /*#__PURE__*/function (_Jo) {
  _inherits(Zo, _Jo);

  var _super83 = _createSuper(Zo);

  function Zo() {
    _classCallCheck(this, Zo);

    return _super83.apply(this, arguments);
  }

  return Zo;
}(Jo);

Zo.prototype.ValueTypeName = "bool", Zo.prototype.ValueBufferType = Array, Zo.prototype.DefaultInterpolation = 2300, Zo.prototype.InterpolantFactoryMethodLinear = void 0, Zo.prototype.InterpolantFactoryMethodSmooth = void 0;

var $o = /*#__PURE__*/function (_Jo2) {
  _inherits($o, _Jo2);

  var _super84 = _createSuper($o);

  function $o() {
    _classCallCheck(this, $o);

    return _super84.apply(this, arguments);
  }

  return $o;
}(Jo);

$o.prototype.ValueTypeName = "color";

var Ko = /*#__PURE__*/function (_Jo3) {
  _inherits(Ko, _Jo3);

  var _super85 = _createSuper(Ko);

  function Ko() {
    _classCallCheck(this, Ko);

    return _super85.apply(this, arguments);
  }

  return Ko;
}(Jo);

Ko.prototype.ValueTypeName = "number";

var Qo = /*#__PURE__*/function (_jo4) {
  _inherits(Qo, _jo4);

  var _super86 = _createSuper(Qo);

  function Qo(t, e, n, i) {
    _classCallCheck(this, Qo);

    return _super86.call(this, t, e, n, i);
  }

  _createClass(Qo, [{
    key: "interpolate_",
    value: function interpolate_(t, e, n, i) {
      var r = this.resultBuffer,
          s = this.sampleValues,
          a = this.valueSize,
          o = (n - e) / (i - e);
      var l = t * a;

      for (var _t248 = l + a; l !== _t248; l += 4) {
        Bt.slerpFlat(r, 0, s, l - a, s, l, o);
      }

      return r;
    }
  }]);

  return Qo;
}(jo);

var tl = /*#__PURE__*/function (_Jo4) {
  _inherits(tl, _Jo4);

  var _super87 = _createSuper(tl);

  function tl() {
    _classCallCheck(this, tl);

    return _super87.apply(this, arguments);
  }

  _createClass(tl, [{
    key: "InterpolantFactoryMethodLinear",
    value: function InterpolantFactoryMethodLinear(t) {
      return new Qo(this.times, this.values, this.getValueSize(), t);
    }
  }]);

  return tl;
}(Jo);

tl.prototype.ValueTypeName = "quaternion", tl.prototype.DefaultInterpolation = 2301, tl.prototype.InterpolantFactoryMethodSmooth = void 0;

var el = /*#__PURE__*/function (_Jo5) {
  _inherits(el, _Jo5);

  var _super88 = _createSuper(el);

  function el() {
    _classCallCheck(this, el);

    return _super88.apply(this, arguments);
  }

  return el;
}(Jo);

el.prototype.ValueTypeName = "string", el.prototype.ValueBufferType = Array, el.prototype.DefaultInterpolation = 2300, el.prototype.InterpolantFactoryMethodLinear = void 0, el.prototype.InterpolantFactoryMethodSmooth = void 0;

var nl = /*#__PURE__*/function (_Jo6) {
  _inherits(nl, _Jo6);

  var _super89 = _createSuper(nl);

  function nl() {
    _classCallCheck(this, nl);

    return _super89.apply(this, arguments);
  }

  return nl;
}(Jo);

nl.prototype.ValueTypeName = "vector";

var il = /*#__PURE__*/function () {
  function il(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var n = arguments.length > 2 ? arguments[2] : undefined;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2500;

    _classCallCheck(this, il);

    this.name = t, this.tracks = n, this.duration = e, this.blendMode = i, this.uuid = at(), this.duration < 0 && this.resetDuration();
  }

  _createClass(il, [{
    key: "resetDuration",
    value: function resetDuration() {
      var t = 0;

      for (var _e222 = 0, _n202 = this.tracks.length; _e222 !== _n202; ++_e222) {
        var _n203 = this.tracks[_e222];
        t = Math.max(t, _n203.times[_n203.times.length - 1]);
      }

      return this.duration = t, this;
    }
  }, {
    key: "trim",
    value: function trim() {
      for (var _t249 = 0; _t249 < this.tracks.length; _t249++) {
        this.tracks[_t249].trim(0, this.duration);
      }

      return this;
    }
  }, {
    key: "validate",
    value: function validate() {
      var t = !0;

      for (var _e223 = 0; _e223 < this.tracks.length; _e223++) {
        t = t && this.tracks[_e223].validate();
      }

      return t;
    }
  }, {
    key: "optimize",
    value: function optimize() {
      for (var _t250 = 0; _t250 < this.tracks.length; _t250++) {
        this.tracks[_t250].optimize();
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      var t = [];

      for (var _e224 = 0; _e224 < this.tracks.length; _e224++) {
        t.push(this.tracks[_e224].clone());
      }

      return new this.constructor(this.name, this.duration, t, this.blendMode);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.constructor.toJSON(this);
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      var e = [],
          n = t.tracks,
          i = 1 / (t.fps || 1);

      for (var _t251 = 0, _r115 = n.length; _t251 !== _r115; ++_t251) {
        e.push(rl(n[_t251]).scale(i));
      }

      var r = new this(t.name, t.duration, e, t.blendMode);
      return r.uuid = t.uuid, r;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = [],
          n = t.tracks,
          i = {
        name: t.name,
        duration: t.duration,
        tracks: e,
        uuid: t.uuid,
        blendMode: t.blendMode
      };

      for (var _t252 = 0, _i156 = n.length; _t252 !== _i156; ++_t252) {
        e.push(Jo.toJSON(n[_t252]));
      }

      return i;
    }
  }, {
    key: "CreateFromMorphTargetSequence",
    value: function CreateFromMorphTargetSequence(t, e, n, i) {
      var r = e.length,
          s = [];

      for (var _t253 = 0; _t253 < r; _t253++) {
        var _a53 = [],
            _o32 = [];
        _a53.push((_t253 + r - 1) % r, _t253, (_t253 + 1) % r), _o32.push(0, 1, 0);

        var _l31 = Wo.getKeyframeOrder(_a53);

        _a53 = Wo.sortedArray(_a53, 1, _l31), _o32 = Wo.sortedArray(_o32, 1, _l31), i || 0 !== _a53[0] || (_a53.push(r), _o32.push(_o32[0])), s.push(new Ko(".morphTargetInfluences[" + e[_t253].name + "]", _a53, _o32).scale(1 / n));
      }

      return new this(t, -1, s);
    }
  }, {
    key: "findByName",
    value: function findByName(t, e) {
      var n = t;

      if (!Array.isArray(t)) {
        var _e225 = t;
        n = _e225.geometry && _e225.geometry.animations || _e225.animations;
      }

      for (var _t254 = 0; _t254 < n.length; _t254++) {
        if (n[_t254].name === e) return n[_t254];
      }

      return null;
    }
  }, {
    key: "CreateClipsFromMorphTargetSequences",
    value: function CreateClipsFromMorphTargetSequences(t, e, n) {
      var i = {},
          r = /^([\w-]*?)([\d]+)$/;

      for (var _e226 = 0, _n204 = t.length; _e226 < _n204; _e226++) {
        var _n205 = t[_e226],
            _s69 = _n205.name.match(r);

        if (_s69 && _s69.length > 1) {
          var _t255 = _s69[1];
          var _e227 = i[_t255];
          _e227 || (i[_t255] = _e227 = []), _e227.push(_n205);
        }
      }

      var s = [];

      for (var _t256 in i) {
        s.push(this.CreateFromMorphTargetSequence(_t256, i[_t256], e, n));
      }

      return s;
    }
  }, {
    key: "parseAnimation",
    value: function parseAnimation(t, e) {
      if (!t) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;

      var n = function n(t, e, _n206, i, r) {
        if (0 !== _n206.length) {
          var _s70 = [],
              _a54 = [];
          Wo.flattenJSON(_n206, _s70, _a54, i), 0 !== _s70.length && r.push(new t(e, _s70, _a54));
        }
      },
          i = [],
          r = t.name || "default",
          s = t.fps || 30,
          a = t.blendMode;

      var o = t.length || -1;
      var l = t.hierarchy || [];

      for (var _t257 = 0; _t257 < l.length; _t257++) {
        var _r116 = l[_t257].keys;
        if (_r116 && 0 !== _r116.length) if (_r116[0].morphTargets) {
          var _t258 = {};

          var _e228 = void 0;

          for (_e228 = 0; _e228 < _r116.length; _e228++) {
            if (_r116[_e228].morphTargets) for (var _n207 = 0; _n207 < _r116[_e228].morphTargets.length; _n207++) {
              _t258[_r116[_e228].morphTargets[_n207]] = -1;
            }
          }

          for (var _n208 in _t258) {
            var _t259 = [],
                _s71 = [];

            for (var _i157 = 0; _i157 !== _r116[_e228].morphTargets.length; ++_i157) {
              var _i158 = _r116[_e228];
              _t259.push(_i158.time), _s71.push(_i158.morphTarget === _n208 ? 1 : 0);
            }

            i.push(new Ko(".morphTargetInfluence[" + _n208 + "]", _t259, _s71));
          }

          o = _t258.length * s;
        } else {
          var _s72 = ".bones[" + e[_t257].name + "]";

          n(nl, _s72 + ".position", _r116, "pos", i), n(tl, _s72 + ".quaternion", _r116, "rot", i), n(nl, _s72 + ".scale", _r116, "scl", i);
        }
      }

      if (0 === i.length) return null;
      return new this(r, o, i, a);
    }
  }]);

  return il;
}();

function rl(t) {
  if (void 0 === t.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");

  var e = function (t) {
    switch (t.toLowerCase()) {
      case "scalar":
      case "double":
      case "float":
      case "number":
      case "integer":
        return Ko;

      case "vector":
      case "vector2":
      case "vector3":
      case "vector4":
        return nl;

      case "color":
        return $o;

      case "quaternion":
        return tl;

      case "bool":
      case "boolean":
        return Zo;

      case "string":
        return el;
    }

    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t);
  }(t.type);

  if (void 0 === t.times) {
    var _e229 = [],
        _n209 = [];
    Wo.flattenJSON(t.keys, _e229, _n209, "value"), t.times = _e229, t.values = _n209;
  }

  return void 0 !== e.parse ? e.parse(t) : new e(t.name, t.times, t.values, t.interpolation);
}

var sl = {
  enabled: !1,
  files: {},
  add: function add(t, e) {
    !1 !== this.enabled && (this.files[t] = e);
  },
  get: function get(t) {
    if (!1 !== this.enabled) return this.files[t];
  },
  remove: function remove(t) {
    delete this.files[t];
  },
  clear: function clear() {
    this.files = {};
  }
};
var al = new ( /*#__PURE__*/function () {
  function _class12(t, e, n) {
    _classCallCheck(this, _class12);

    var i = this;
    var r,
        s = !1,
        a = 0,
        o = 0;
    var l = [];
    this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = n, this.itemStart = function (t) {
      o++, !1 === s && void 0 !== i.onStart && i.onStart(t, a, o), s = !0;
    }, this.itemEnd = function (t) {
      a++, void 0 !== i.onProgress && i.onProgress(t, a, o), a === o && (s = !1, void 0 !== i.onLoad && i.onLoad());
    }, this.itemError = function (t) {
      void 0 !== i.onError && i.onError(t);
    }, this.resolveURL = function (t) {
      return r ? r(t) : t;
    }, this.setURLModifier = function (t) {
      return r = t, this;
    }, this.addHandler = function (t, e) {
      return l.push(t, e), this;
    }, this.removeHandler = function (t) {
      var e = l.indexOf(t);
      return -1 !== e && l.splice(e, 2), this;
    }, this.getHandler = function (t) {
      for (var _e230 = 0, _n210 = l.length; _e230 < _n210; _e230 += 2) {
        var _n211 = l[_e230],
            _i159 = l[_e230 + 1];
        if (_n211.global && (_n211.lastIndex = 0), _n211.test(t)) return _i159;
      }

      return null;
    };
  }

  return _class12;
}())();

var ol = /*#__PURE__*/function () {
  function ol(t) {
    _classCallCheck(this, ol);

    this.manager = void 0 !== t ? t : al, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }

  _createClass(ol, [{
    key: "load",
    value: function load() {}
  }, {
    key: "loadAsync",
    value: function loadAsync(t, e) {
      var n = this;
      return new Promise(function (i, r) {
        n.load(t, i, e, r);
      });
    }
  }, {
    key: "parse",
    value: function parse() {}
  }, {
    key: "setCrossOrigin",
    value: function setCrossOrigin(t) {
      return this.crossOrigin = t, this;
    }
  }, {
    key: "setWithCredentials",
    value: function setWithCredentials(t) {
      return this.withCredentials = t, this;
    }
  }, {
    key: "setPath",
    value: function setPath(t) {
      return this.path = t, this;
    }
  }, {
    key: "setResourcePath",
    value: function setResourcePath(t) {
      return this.resourcePath = t, this;
    }
  }, {
    key: "setRequestHeader",
    value: function setRequestHeader(t) {
      return this.requestHeader = t, this;
    }
  }]);

  return ol;
}();

var ll = {};

var hl = /*#__PURE__*/function (_ol) {
  _inherits(hl, _ol);

  var _super90 = _createSuper(hl);

  function hl(t) {
    _classCallCheck(this, hl);

    return _super90.call(this, t);
  }

  _createClass(hl, [{
    key: "load",
    value: function load(t, e, n, i) {
      var _this82 = this;

      void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
      var r = sl.get(t);
      if (void 0 !== r) return this.manager.itemStart(t), setTimeout(function () {
        e && e(r), _this82.manager.itemEnd(t);
      }, 0), r;
      if (void 0 !== ll[t]) return void ll[t].push({
        onLoad: e,
        onProgress: n,
        onError: i
      });
      ll[t] = [], ll[t].push({
        onLoad: e,
        onProgress: n,
        onError: i
      });
      var s = new Request(t, {
        headers: new Headers(this.requestHeader),
        credentials: this.withCredentials ? "include" : "same-origin"
      }),
          a = this.mimeType,
          o = this.responseType;
      fetch(s).then(function (e) {
        if (200 === e.status || 0 === e.status) {
          if (0 === e.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === e.body || void 0 === e.body.getReader) return e;

          var _n212 = ll[t],
              _i160 = e.body.getReader(),
              _r117 = e.headers.get("Content-Length"),
              _s73 = _r117 ? parseInt(_r117) : 0,
              _a55 = 0 !== _s73;

          var _o33 = 0;

          var _l32 = new ReadableStream({
            start: function start(t) {
              !function e() {
                _i160.read().then(function (_ref3) {
                  var i = _ref3.done,
                      r = _ref3.value;
                  if (i) t.close();else {
                    _o33 += r.byteLength;

                    var _i161 = new ProgressEvent("progress", {
                      lengthComputable: _a55,
                      loaded: _o33,
                      total: _s73
                    });

                    for (var _t260 = 0, _e231 = _n212.length; _t260 < _e231; _t260++) {
                      var _e232 = _n212[_t260];
                      _e232.onProgress && _e232.onProgress(_i161);
                    }

                    t.enqueue(r), e();
                  }
                });
              }();
            }
          });

          return new Response(_l32);
        }

        throw Error("fetch for \"".concat(e.url, "\" responded with ").concat(e.status, ": ").concat(e.statusText));
      }).then(function (t) {
        switch (o) {
          case "arraybuffer":
            return t.arrayBuffer();

          case "blob":
            return t.blob();

          case "document":
            return t.text().then(function (t) {
              return new DOMParser().parseFromString(t, a);
            });

          case "json":
            return t.json();

          default:
            if (void 0 === a) return t.text();
            {
              var _e233 = /charset="?([^;"\s]*)"?/i.exec(a),
                  _n213 = _e233 && _e233[1] ? _e233[1].toLowerCase() : void 0,
                  _i162 = new TextDecoder(_n213);

              return t.arrayBuffer().then(function (t) {
                return _i162.decode(t);
              });
            }
        }
      }).then(function (e) {
        sl.add(t, e);
        var n = ll[t];
        delete ll[t];

        for (var _t261 = 0, _i163 = n.length; _t261 < _i163; _t261++) {
          var _i164 = n[_t261];
          _i164.onLoad && _i164.onLoad(e);
        }
      }).catch(function (e) {
        var n = ll[t];
        if (void 0 === n) throw _this82.manager.itemError(t), e;
        delete ll[t];

        for (var _t262 = 0, _i165 = n.length; _t262 < _i165; _t262++) {
          var _i166 = n[_t262];
          _i166.onError && _i166.onError(e);
        }

        _this82.manager.itemError(t);
      }).finally(function () {
        _this82.manager.itemEnd(t);
      }), this.manager.itemStart(t);
    }
  }, {
    key: "setResponseType",
    value: function setResponseType(t) {
      return this.responseType = t, this;
    }
  }, {
    key: "setMimeType",
    value: function setMimeType(t) {
      return this.mimeType = t, this;
    }
  }]);

  return hl;
}(ol);

var cl = /*#__PURE__*/function (_ol2) {
  _inherits(cl, _ol2);

  var _super91 = _createSuper(cl);

  function cl(t) {
    _classCallCheck(this, cl);

    return _super91.call(this, t);
  }

  _createClass(cl, [{
    key: "load",
    value: function load(t, e, n, i) {
      void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
      var r = this,
          s = sl.get(t);
      if (void 0 !== s) return r.manager.itemStart(t), setTimeout(function () {
        e && e(s), r.manager.itemEnd(t);
      }, 0), s;
      var a = vt("img");

      function o() {
        h(), sl.add(t, this), e && e(this), r.manager.itemEnd(t);
      }

      function l(e) {
        h(), i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
      }

      function h() {
        a.removeEventListener("load", o, !1), a.removeEventListener("error", l, !1);
      }

      return a.addEventListener("load", o, !1), a.addEventListener("error", l, !1), "data:" !== t.slice(0, 5) && void 0 !== this.crossOrigin && (a.crossOrigin = this.crossOrigin), r.manager.itemStart(t), a.src = t, a;
    }
  }]);

  return cl;
}(ol);

var ul = /*#__PURE__*/function (_ol3) {
  _inherits(ul, _ol3);

  var _super92 = _createSuper(ul);

  function ul(t) {
    _classCallCheck(this, ul);

    return _super92.call(this, t);
  }

  _createClass(ul, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = new jn(),
          s = new cl(this.manager);
      s.setCrossOrigin(this.crossOrigin), s.setPath(this.path);
      var a = 0;

      function o(n) {
        s.load(t[n], function (t) {
          r.images[n] = t, a++, 6 === a && (r.needsUpdate = !0, e && e(r));
        }, void 0, i);
      }

      for (var _e234 = 0; _e234 < t.length; ++_e234) {
        o(_e234);
      }

      return r;
    }
  }]);

  return ul;
}(ol);

var dl = /*#__PURE__*/function (_ol4) {
  _inherits(dl, _ol4);

  var _super93 = _createSuper(dl);

  function dl(t) {
    _classCallCheck(this, dl);

    return _super93.call(this, t);
  }

  _createClass(dl, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = this,
          s = new sa(),
          a = new hl(this.manager);
      return a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setPath(this.path), a.setWithCredentials(r.withCredentials), a.load(t, function (t) {
        var n = r.parse(t);
        n && (void 0 !== n.image ? s.image = n.image : void 0 !== n.data && (s.image.width = n.width, s.image.height = n.height, s.image.data = n.data), s.wrapS = void 0 !== n.wrapS ? n.wrapS : 1001, s.wrapT = void 0 !== n.wrapT ? n.wrapT : 1001, s.magFilter = void 0 !== n.magFilter ? n.magFilter : 1006, s.minFilter = void 0 !== n.minFilter ? n.minFilter : 1006, s.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.encoding && (s.encoding = n.encoding), void 0 !== n.flipY && (s.flipY = n.flipY), void 0 !== n.format && (s.format = n.format), void 0 !== n.type && (s.type = n.type), void 0 !== n.mipmaps && (s.mipmaps = n.mipmaps, s.minFilter = 1008), 1 === n.mipmapCount && (s.minFilter = 1006), void 0 !== n.generateMipmaps && (s.generateMipmaps = n.generateMipmaps), s.needsUpdate = !0, e && e(s, n));
      }, n, i), s;
    }
  }]);

  return dl;
}(ol);

var pl = /*#__PURE__*/function (_ol5) {
  _inherits(pl, _ol5);

  var _super94 = _createSuper(pl);

  function pl(t) {
    _classCallCheck(this, pl);

    return _super94.call(this, t);
  }

  _createClass(pl, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = new Ot(),
          s = new cl(this.manager);
      return s.setCrossOrigin(this.crossOrigin), s.setPath(this.path), s.load(t, function (t) {
        r.image = t, r.needsUpdate = !0, void 0 !== e && e(r);
      }, n, i), r;
    }
  }]);

  return pl;
}(ol);

var ml = /*#__PURE__*/function (_Ve10) {
  _inherits(ml, _Ve10);

  var _super95 = _createSuper(ml);

  function ml(t) {
    var _this83;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, ml);

    _this83 = _super95.call(this), _this83.type = "Light", _this83.color = new Rt(t), _this83.intensity = e;
    return _this83;
  }

  _createClass(ml, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ml.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.intensity = t.intensity, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(ml.prototype), "toJSON", this).call(this, t);

      return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
    }
  }]);

  return ml;
}(Ve);

ml.prototype.isLight = !0;

/*#__PURE__*/
(function (_ml) {
  _inherits(_class13, _ml);

  var _super96 = _createSuper(_class13);

  function _class13(t, e, n) {
    var _this84;

    _classCallCheck(this, _class13);

    _this84 = _super96.call(this, t, n), _this84.type = "HemisphereLight", _this84.position.copy(Ve.DefaultUp), _this84.updateMatrix(), _this84.groundColor = new Rt(e);
    return _this84;
  }

  _createClass(_class13, [{
    key: "copy",
    value: function copy(t) {
      return ml.prototype.copy.call(this, t), this.groundColor.copy(t.groundColor), this;
    }
  }]);

  return _class13;
})(ml).prototype.isHemisphereLight = !0;
var fl = new ve(),
    gl = new zt(),
    vl = new zt();

var yl = /*#__PURE__*/function () {
  function yl(t) {
    _classCallCheck(this, yl);

    this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new mt(512, 512), this.map = null, this.mapPass = null, this.matrix = new ve(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Qn(), this._frameExtents = new mt(1, 1), this._viewportCount = 1, this._viewports = [new Nt(0, 0, 1, 1)];
  }

  _createClass(yl, [{
    key: "getViewportCount",
    value: function getViewportCount() {
      return this._viewportCount;
    }
  }, {
    key: "getFrustum",
    value: function getFrustum() {
      return this._frustum;
    }
  }, {
    key: "updateMatrices",
    value: function updateMatrices(t) {
      var e = this.camera,
          n = this.matrix;
      gl.setFromMatrixPosition(t.matrixWorld), e.position.copy(gl), vl.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(vl), e.updateMatrixWorld(), fl.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(fl), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(e.projectionMatrix), n.multiply(e.matrixWorldInverse);
    }
  }, {
    key: "getViewport",
    value: function getViewport(t) {
      return this._viewports[t];
    }
  }, {
    key: "getFrameExtents",
    value: function getFrameExtents() {
      return this._frameExtents;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {};
      return 0 !== this.bias && (t.bias = this.bias), 0 !== this.normalBias && (t.normalBias = this.normalBias), 1 !== this.radius && (t.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
  }]);

  return yl;
}();

var xl = /*#__PURE__*/function (_yl) {
  _inherits(xl, _yl);

  var _super97 = _createSuper(xl);

  function xl() {
    var _this85;

    _classCallCheck(this, xl);

    _this85 = _super97.call(this, new Gn(50, 1, .5, 500)), _this85.focus = 1;
    return _this85;
  }

  _createClass(xl, [{
    key: "updateMatrices",
    value: function updateMatrices(t) {
      var e = this.camera,
          n = 2 * st * t.angle * this.focus,
          i = this.mapSize.width / this.mapSize.height,
          r = t.distance || e.far;
      n === e.fov && i === e.aspect && r === e.far || (e.fov = n, e.aspect = i, e.far = r, e.updateProjectionMatrix()), _get(_getPrototypeOf(xl.prototype), "updateMatrices", this).call(this, t);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(xl.prototype), "copy", this).call(this, t), this.focus = t.focus, this;
    }
  }]);

  return xl;
}(yl);

xl.prototype.isSpotLightShadow = !0;

var _l = /*#__PURE__*/function (_ml2) {
  _inherits(_l, _ml2);

  var _super98 = _createSuper(_l);

  function _l(t, e) {
    var _this86;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI / 3;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

    _classCallCheck(this, _l);

    _this86 = _super98.call(this, t, e), _this86.type = "SpotLight", _this86.position.copy(Ve.DefaultUp), _this86.updateMatrix(), _this86.target = new Ve(), _this86.distance = n, _this86.angle = i, _this86.penumbra = r, _this86.decay = s, _this86.shadow = new xl();
    return _this86;
  }

  _createClass(_l, [{
    key: "power",
    get: function get() {
      return this.intensity * Math.PI;
    },
    set: function set(t) {
      this.intensity = t / Math.PI;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.shadow.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_l.prototype), "copy", this).call(this, t), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
  }]);

  return _l;
}(ml);

_l.prototype.isSpotLight = !0;
var bl = new ve(),
    wl = new zt(),
    Ml = new zt();

var Sl = /*#__PURE__*/function (_yl2) {
  _inherits(Sl, _yl2);

  var _super99 = _createSuper(Sl);

  function Sl() {
    var _this87;

    _classCallCheck(this, Sl);

    _this87 = _super99.call(this, new Gn(90, 1, .5, 500)), _this87._frameExtents = new mt(4, 2), _this87._viewportCount = 6, _this87._viewports = [new Nt(2, 1, 1, 1), new Nt(0, 1, 1, 1), new Nt(3, 1, 1, 1), new Nt(1, 1, 1, 1), new Nt(3, 0, 1, 1), new Nt(1, 0, 1, 1)], _this87._cubeDirections = [new zt(1, 0, 0), new zt(-1, 0, 0), new zt(0, 0, 1), new zt(0, 0, -1), new zt(0, 1, 0), new zt(0, -1, 0)], _this87._cubeUps = [new zt(0, 1, 0), new zt(0, 1, 0), new zt(0, 1, 0), new zt(0, 1, 0), new zt(0, 0, 1), new zt(0, 0, -1)];
    return _this87;
  }

  _createClass(Sl, [{
    key: "updateMatrices",
    value: function updateMatrices(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.camera,
          i = this.matrix,
          r = t.distance || n.far;
      r !== n.far && (n.far = r, n.updateProjectionMatrix()), wl.setFromMatrixPosition(t.matrixWorld), n.position.copy(wl), Ml.copy(n.position), Ml.add(this._cubeDirections[e]), n.up.copy(this._cubeUps[e]), n.lookAt(Ml), n.updateMatrixWorld(), i.makeTranslation(-wl.x, -wl.y, -wl.z), bl.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(bl);
    }
  }]);

  return Sl;
}(yl);

Sl.prototype.isPointLightShadow = !0;

var Tl = /*#__PURE__*/function (_ml3) {
  _inherits(Tl, _ml3);

  var _super100 = _createSuper(Tl);

  function Tl(t, e) {
    var _this88;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Tl);

    _this88 = _super100.call(this, t, e), _this88.type = "PointLight", _this88.distance = n, _this88.decay = i, _this88.shadow = new Sl();
    return _this88;
  }

  _createClass(Tl, [{
    key: "power",
    get: function get() {
      return 4 * this.intensity * Math.PI;
    },
    set: function set(t) {
      this.intensity = t / (4 * Math.PI);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.shadow.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Tl.prototype), "copy", this).call(this, t), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
    }
  }]);

  return Tl;
}(ml);

Tl.prototype.isPointLight = !0;

var El = /*#__PURE__*/function (_yl3) {
  _inherits(El, _yl3);

  var _super101 = _createSuper(El);

  function El() {
    _classCallCheck(this, El);

    return _super101.call(this, new di(-5, 5, 5, -5, .5, 500));
  }

  return El;
}(yl);

El.prototype.isDirectionalLightShadow = !0;

var Al = /*#__PURE__*/function (_ml4) {
  _inherits(Al, _ml4);

  var _super102 = _createSuper(Al);

  function Al(t, e) {
    var _this89;

    _classCallCheck(this, Al);

    _this89 = _super102.call(this, t, e), _this89.type = "DirectionalLight", _this89.position.copy(Ve.DefaultUp), _this89.updateMatrix(), _this89.target = new Ve(), _this89.shadow = new El();
    return _this89;
  }

  _createClass(Al, [{
    key: "dispose",
    value: function dispose() {
      this.shadow.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Al.prototype), "copy", this).call(this, t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
  }]);

  return Al;
}(ml);

Al.prototype.isDirectionalLight = !0;

/*#__PURE__*/
(function (_ml5) {
  _inherits(_class14, _ml5);

  var _super103 = _createSuper(_class14);

  function _class14(t, e) {
    var _this90;

    _classCallCheck(this, _class14);

    _this90 = _super103.call(this, t, e), _this90.type = "AmbientLight";
    return _this90;
  }

  return _class14;
})(ml).prototype.isAmbientLight = !0;

/*#__PURE__*/
(function (_ml6) {
  _inherits(_class15, _ml6);

  var _super104 = _createSuper(_class15);

  function _class15(t, e) {
    var _this91;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

    _classCallCheck(this, _class15);

    _this91 = _super104.call(this, t, e), _this91.type = "RectAreaLight", _this91.width = n, _this91.height = i;
    return _this91;
  }

  _createClass(_class15, [{
    key: "power",
    get: function get() {
      return this.intensity * this.width * this.height * Math.PI;
    },
    set: function set(t) {
      this.intensity = t / (this.width * this.height * Math.PI);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class15.prototype), "copy", this).call(this, t), this.width = t.width, this.height = t.height, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(_class15.prototype), "toJSON", this).call(this, t);

      return e.object.width = this.width, e.object.height = this.height, e;
    }
  }]);

  return _class15;
})(ml).prototype.isRectAreaLight = !0;

var Rl = /*#__PURE__*/function () {
  function Rl() {
    _classCallCheck(this, Rl);

    this.coefficients = [];

    for (var _t263 = 0; _t263 < 9; _t263++) {
      this.coefficients.push(new zt());
    }
  }

  _createClass(Rl, [{
    key: "set",
    value: function set(t) {
      for (var _e235 = 0; _e235 < 9; _e235++) {
        this.coefficients[_e235].copy(t[_e235]);
      }

      return this;
    }
  }, {
    key: "zero",
    value: function zero() {
      for (var _t264 = 0; _t264 < 9; _t264++) {
        this.coefficients[_t264].set(0, 0, 0);
      }

      return this;
    }
  }, {
    key: "getAt",
    value: function getAt(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z,
          s = this.coefficients;
      return e.copy(s[0]).multiplyScalar(.282095), e.addScaledVector(s[1], .488603 * i), e.addScaledVector(s[2], .488603 * r), e.addScaledVector(s[3], .488603 * n), e.addScaledVector(s[4], n * i * 1.092548), e.addScaledVector(s[5], i * r * 1.092548), e.addScaledVector(s[6], .315392 * (3 * r * r - 1)), e.addScaledVector(s[7], n * r * 1.092548), e.addScaledVector(s[8], .546274 * (n * n - i * i)), e;
    }
  }, {
    key: "getIrradianceAt",
    value: function getIrradianceAt(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z,
          s = this.coefficients;
      return e.copy(s[0]).multiplyScalar(.886227), e.addScaledVector(s[1], 1.023328 * i), e.addScaledVector(s[2], 1.023328 * r), e.addScaledVector(s[3], 1.023328 * n), e.addScaledVector(s[4], .858086 * n * i), e.addScaledVector(s[5], .858086 * i * r), e.addScaledVector(s[6], .743125 * r * r - .247708), e.addScaledVector(s[7], .858086 * n * r), e.addScaledVector(s[8], .429043 * (n * n - i * i)), e;
    }
  }, {
    key: "add",
    value: function add(t) {
      for (var _e236 = 0; _e236 < 9; _e236++) {
        this.coefficients[_e236].add(t.coefficients[_e236]);
      }

      return this;
    }
  }, {
    key: "addScaledSH",
    value: function addScaledSH(t, e) {
      for (var _n214 = 0; _n214 < 9; _n214++) {
        this.coefficients[_n214].addScaledVector(t.coefficients[_n214], e);
      }

      return this;
    }
  }, {
    key: "scale",
    value: function scale(t) {
      for (var _e237 = 0; _e237 < 9; _e237++) {
        this.coefficients[_e237].multiplyScalar(t);
      }

      return this;
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      for (var _n215 = 0; _n215 < 9; _n215++) {
        this.coefficients[_n215].lerp(t.coefficients[_n215], e);
      }

      return this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      for (var _e238 = 0; _e238 < 9; _e238++) {
        if (!this.coefficients[_e238].equals(t.coefficients[_e238])) return !1;
      }

      return !0;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.set(t.coefficients);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.coefficients;

      for (var _i167 = 0; _i167 < 9; _i167++) {
        n[_i167].fromArray(t, e + 3 * _i167);
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.coefficients;

      for (var _i168 = 0; _i168 < 9; _i168++) {
        n[_i168].toArray(t, e + 3 * _i168);
      }

      return t;
    }
  }], [{
    key: "getBasisAt",
    value: function getBasisAt(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z;
      e[0] = .282095, e[1] = .488603 * i, e[2] = .488603 * r, e[3] = .488603 * n, e[4] = 1.092548 * n * i, e[5] = 1.092548 * i * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * n * r, e[8] = .546274 * (n * n - i * i);
    }
  }]);

  return Rl;
}();

Rl.prototype.isSphericalHarmonics3 = !0;

var Cl = /*#__PURE__*/function (_ml7) {
  _inherits(Cl, _ml7);

  var _super105 = _createSuper(Cl);

  function Cl() {
    var _this92;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Rl();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, Cl);

    _this92 = _super105.call(this, void 0, e), _this92.sh = t;
    return _this92;
  }

  _createClass(Cl, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Cl.prototype), "copy", this).call(this, t), this.sh.copy(t.sh), this;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return this.intensity = t.intensity, this.sh.fromArray(t.sh), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(Cl.prototype), "toJSON", this).call(this, t);

      return e.object.sh = this.sh.toArray(), e;
    }
  }]);

  return Cl;
}(ml);

Cl.prototype.isLightProbe = !0;

var Ll = /*#__PURE__*/function () {
  function Ll() {
    _classCallCheck(this, Ll);
  }

  _createClass(Ll, null, [{
    key: "decodeText",
    value: function decodeText(t) {
      if ("undefined" != typeof TextDecoder) return new TextDecoder().decode(t);
      var e = "";

      for (var _n216 = 0, _i169 = t.length; _n216 < _i169; _n216++) {
        e += String.fromCharCode(t[_n216]);
      }

      try {
        return decodeURIComponent(escape(e));
      } catch (t) {
        return e;
      }
    }
  }, {
    key: "extractUrlBase",
    value: function extractUrlBase(t) {
      var e = t.lastIndexOf("/");
      return -1 === e ? "./" : t.slice(0, e + 1);
    }
  }, {
    key: "resolveURL",
    value: function resolveURL(t, e) {
      return "string" != typeof t || "" === t ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t) || /^data:.*,.*$/i.test(t) || /^blob:.*$/i.test(t) ? t : e + t);
    }
  }]);

  return Ll;
}();

/*#__PURE__*/
(function (_vn5) {
  _inherits(_class16, _vn5);

  var _super106 = _createSuper(_class16);

  function _class16() {
    var _this93;

    _classCallCheck(this, _class16);

    _this93 = _super106.call(this), _this93.type = "InstancedBufferGeometry", _this93.instanceCount = 1 / 0;
    return _this93;
  }

  _createClass(_class16, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class16.prototype), "copy", this).call(this, t), this.instanceCount = t.instanceCount, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(_class16.prototype), "toJSON", this).call(this, this);

      return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
    }
  }]);

  return _class16;
})(vn).prototype.isInstancedBufferGeometry = !0;

var Pl = /*#__PURE__*/function (_ol6) {
  _inherits(Pl, _ol6);

  var _super107 = _createSuper(Pl);

  function Pl(t) {
    var _this94;

    _classCallCheck(this, Pl);

    _this94 = _super107.call(this, t), "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), _this94.options = {
      premultiplyAlpha: "none"
    };
    return _this94;
  }

  _createClass(Pl, [{
    key: "setOptions",
    value: function setOptions(t) {
      return this.options = t, this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
      var r = this,
          s = sl.get(t);
      if (void 0 !== s) return r.manager.itemStart(t), setTimeout(function () {
        e && e(s), r.manager.itemEnd(t);
      }, 0), s;
      var a = {};
      a.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", a.headers = this.requestHeader, fetch(t, a).then(function (t) {
        return t.blob();
      }).then(function (t) {
        return createImageBitmap(t, Object.assign(r.options, {
          colorSpaceConversion: "none"
        }));
      }).then(function (n) {
        sl.add(t, n), e && e(n), r.manager.itemEnd(t);
      }).catch(function (e) {
        i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
      }), r.manager.itemStart(t);
    }
  }]);

  return Pl;
}(ol);

var Dl;
Pl.prototype.isImageBitmapLoader = !0;

var Il = function Il() {
  return void 0 === Dl && (Dl = new (window.AudioContext || window.webkitAudioContext)()), Dl;
};

var Ol = /*#__PURE__*/function (_ol7) {
  _inherits(Ol, _ol7);

  var _super108 = _createSuper(Ol);

  function Ol(t) {
    _classCallCheck(this, Ol);

    return _super108.call(this, t);
  }

  _createClass(Ol, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = this,
          s = new hl(this.manager);
      s.setResponseType("arraybuffer"), s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t, function (n) {
        try {
          var _t265 = n.slice(0);

          Il().decodeAudioData(_t265, function (t) {
            e(t);
          });
        } catch (e) {
          i ? i(e) : console.error(e), r.manager.itemError(t);
        }
      }, n, i);
    }
  }]);

  return Ol;
}(ol);

/*#__PURE__*/
(function (_Cl) {
  _inherits(_class17, _Cl);

  var _super109 = _createSuper(_class17);

  function _class17(t, e) {
    var _this95;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    _classCallCheck(this, _class17);

    _this95 = _super109.call(this, void 0, n);
    var i = new Rt().set(t),
        r = new Rt().set(e),
        s = new zt(i.r, i.g, i.b),
        a = new zt(r.r, r.g, r.b),
        o = Math.sqrt(Math.PI),
        l = o * Math.sqrt(.75);
    _this95.sh.coefficients[0].copy(s).add(a).multiplyScalar(o), _this95.sh.coefficients[1].copy(s).sub(a).multiplyScalar(l);
    return _this95;
  }

  return _class17;
})(Cl).prototype.isHemisphereLightProbe = !0;

/*#__PURE__*/
(function (_Cl2) {
  _inherits(_class18, _Cl2);

  var _super110 = _createSuper(_class18);

  function _class18(t) {
    var _this96;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, _class18);

    _this96 = _super110.call(this, void 0, e);
    var n = new Rt().set(t);

    _this96.sh.coefficients[0].set(n.r, n.g, n.b).multiplyScalar(2 * Math.sqrt(Math.PI));

    return _this96;
  }

  return _class18;
})(Cl).prototype.isAmbientLightProbe = !0;

var Nl = /*#__PURE__*/function () {
  function Nl(t, e, n) {
    _classCallCheck(this, Nl);

    var i, r, s;

    switch (this.binding = t, this.valueSize = n, e) {
      case "quaternion":
        i = this._slerp, r = this._slerpAdditive, s = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * n), this._workIndex = 5;
        break;

      case "string":
      case "bool":
        i = this._select, r = this._select, s = this._setAdditiveIdentityOther, this.buffer = new Array(5 * n);
        break;

      default:
        i = this._lerp, r = this._lerpAdditive, s = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * n);
    }

    this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = s, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
  }

  _createClass(Nl, [{
    key: "accumulate",
    value: function accumulate(t, e) {
      var n = this.buffer,
          i = this.valueSize,
          r = t * i + i;
      var s = this.cumulativeWeight;

      if (0 === s) {
        for (var _t266 = 0; _t266 !== i; ++_t266) {
          n[r + _t266] = n[_t266];
        }

        s = e;
      } else {
        s += e;

        var _t267 = e / s;

        this._mixBufferRegion(n, r, 0, _t267, i);
      }

      this.cumulativeWeight = s;
    }
  }, {
    key: "accumulateAdditive",
    value: function accumulateAdditive(t) {
      var e = this.buffer,
          n = this.valueSize,
          i = n * this._addIndex;
      0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t, n), this.cumulativeWeightAdditive += t;
    }
  }, {
    key: "apply",
    value: function apply(t) {
      var e = this.valueSize,
          n = this.buffer,
          i = t * e + e,
          r = this.cumulativeWeight,
          s = this.cumulativeWeightAdditive,
          a = this.binding;

      if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
        var _t268 = e * this._origIndex;

        this._mixBufferRegion(n, i, _t268, 1 - r, e);
      }

      s > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * e, 1, e);

      for (var _t269 = e, _r118 = e + e; _t269 !== _r118; ++_t269) {
        if (n[_t269] !== n[_t269 + e]) {
          a.setValue(n, i);
          break;
        }
      }
    }
  }, {
    key: "saveOriginalState",
    value: function saveOriginalState() {
      var t = this.binding,
          e = this.buffer,
          n = this.valueSize,
          i = n * this._origIndex;
      t.getValue(e, i);

      for (var _t270 = n, _r119 = i; _t270 !== _r119; ++_t270) {
        e[_t270] = e[i + _t270 % n];
      }

      this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
  }, {
    key: "restoreOriginalState",
    value: function restoreOriginalState() {
      var t = 3 * this.valueSize;
      this.binding.setValue(this.buffer, t);
    }
  }, {
    key: "_setAdditiveIdentityNumeric",
    value: function _setAdditiveIdentityNumeric() {
      var t = this._addIndex * this.valueSize,
          e = t + this.valueSize;

      for (var _n217 = t; _n217 < e; _n217++) {
        this.buffer[_n217] = 0;
      }
    }
  }, {
    key: "_setAdditiveIdentityQuaternion",
    value: function _setAdditiveIdentityQuaternion() {
      this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
  }, {
    key: "_setAdditiveIdentityOther",
    value: function _setAdditiveIdentityOther() {
      var t = this._origIndex * this.valueSize,
          e = this._addIndex * this.valueSize;

      for (var _n218 = 0; _n218 < this.valueSize; _n218++) {
        this.buffer[e + _n218] = this.buffer[t + _n218];
      }
    }
  }, {
    key: "_select",
    value: function _select(t, e, n, i, r) {
      if (i >= .5) for (var _i170 = 0; _i170 !== r; ++_i170) {
        t[e + _i170] = t[n + _i170];
      }
    }
  }, {
    key: "_slerp",
    value: function _slerp(t, e, n, i) {
      Bt.slerpFlat(t, e, t, e, t, n, i);
    }
  }, {
    key: "_slerpAdditive",
    value: function _slerpAdditive(t, e, n, i, r) {
      var s = this._workIndex * r;
      Bt.multiplyQuaternionsFlat(t, s, t, e, t, n), Bt.slerpFlat(t, e, t, e, t, s, i);
    }
  }, {
    key: "_lerp",
    value: function _lerp(t, e, n, i, r) {
      var s = 1 - i;

      for (var _a56 = 0; _a56 !== r; ++_a56) {
        var _r120 = e + _a56;

        t[_r120] = t[_r120] * s + t[n + _a56] * i;
      }
    }
  }, {
    key: "_lerpAdditive",
    value: function _lerpAdditive(t, e, n, i, r) {
      for (var _s74 = 0; _s74 !== r; ++_s74) {
        var _r121 = e + _s74;

        t[_r121] = t[_r121] + t[n + _s74] * i;
      }
    }
  }]);

  return Nl;
}();

var Fl = new RegExp("[\\[\\]\\.:\\/]", "g"),
    Ul = "[^" + "\\[\\]\\.:\\/".replace("\\.", "") + "]",
    kl = /((?:WC+[\/:])*)/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
    Bl = /(WCOD+)?/.source.replace("WCOD", Ul),
    zl = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
    Hl = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
    Vl = new RegExp("^" + kl + Bl + zl + Hl + "$"),
    Gl = ["material", "materials", "bones"];

var Wl = /*#__PURE__*/function () {
  function Wl(t, e, n) {
    _classCallCheck(this, Wl);

    this.path = e, this.parsedPath = n || Wl.parseTrackName(e), this.node = Wl.findNode(t, this.parsedPath.nodeName) || t, this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }

  _createClass(Wl, [{
    key: "_getValue_unavailable",
    value: function _getValue_unavailable() {}
  }, {
    key: "_setValue_unavailable",
    value: function _setValue_unavailable() {}
  }, {
    key: "_getValue_direct",
    value: function _getValue_direct(t, e) {
      t[e] = this.targetObject[this.propertyName];
    }
  }, {
    key: "_getValue_array",
    value: function _getValue_array(t, e) {
      var n = this.resolvedProperty;

      for (var _i171 = 0, _r122 = n.length; _i171 !== _r122; ++_i171) {
        t[e++] = n[_i171];
      }
    }
  }, {
    key: "_getValue_arrayElement",
    value: function _getValue_arrayElement(t, e) {
      t[e] = this.resolvedProperty[this.propertyIndex];
    }
  }, {
    key: "_getValue_toArray",
    value: function _getValue_toArray(t, e) {
      this.resolvedProperty.toArray(t, e);
    }
  }, {
    key: "_setValue_direct",
    value: function _setValue_direct(t, e) {
      this.targetObject[this.propertyName] = t[e];
    }
  }, {
    key: "_setValue_direct_setNeedsUpdate",
    value: function _setValue_direct_setNeedsUpdate(t, e) {
      this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_direct_setMatrixWorldNeedsUpdate",
    value: function _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
      this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_setValue_array",
    value: function _setValue_array(t, e) {
      var n = this.resolvedProperty;

      for (var _i172 = 0, _r123 = n.length; _i172 !== _r123; ++_i172) {
        n[_i172] = t[e++];
      }
    }
  }, {
    key: "_setValue_array_setNeedsUpdate",
    value: function _setValue_array_setNeedsUpdate(t, e) {
      var n = this.resolvedProperty;

      for (var _i173 = 0, _r124 = n.length; _i173 !== _r124; ++_i173) {
        n[_i173] = t[e++];
      }

      this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_array_setMatrixWorldNeedsUpdate",
    value: function _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
      var n = this.resolvedProperty;

      for (var _i174 = 0, _r125 = n.length; _i174 !== _r125; ++_i174) {
        n[_i174] = t[e++];
      }

      this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_setValue_arrayElement",
    value: function _setValue_arrayElement(t, e) {
      this.resolvedProperty[this.propertyIndex] = t[e];
    }
  }, {
    key: "_setValue_arrayElement_setNeedsUpdate",
    value: function _setValue_arrayElement_setNeedsUpdate(t, e) {
      this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_arrayElement_setMatrixWorldNeedsUpdate",
    value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
      this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_setValue_fromArray",
    value: function _setValue_fromArray(t, e) {
      this.resolvedProperty.fromArray(t, e);
    }
  }, {
    key: "_setValue_fromArray_setNeedsUpdate",
    value: function _setValue_fromArray_setNeedsUpdate(t, e) {
      this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_fromArray_setMatrixWorldNeedsUpdate",
    value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
      this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_getValue_unbound",
    value: function _getValue_unbound(t, e) {
      this.bind(), this.getValue(t, e);
    }
  }, {
    key: "_setValue_unbound",
    value: function _setValue_unbound(t, e) {
      this.bind(), this.setValue(t, e);
    }
  }, {
    key: "bind",
    value: function bind() {
      var t = this.node;
      var e = this.parsedPath,
          n = e.objectName,
          i = e.propertyName;
      var r = e.propertyIndex;
      if (t || (t = Wl.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) return void console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");

      if (n) {
        var _i175 = e.objectIndex;

        switch (n) {
          case "materials":
            if (!t.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            if (!t.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            t = t.material.materials;
            break;

          case "bones":
            if (!t.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            t = t.skeleton.bones;

            for (var _e239 = 0; _e239 < t.length; _e239++) {
              if (t[_e239].name === _i175) {
                _i175 = _e239;
                break;
              }
            }

            break;

          default:
            if (void 0 === t[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            t = t[n];
        }

        if (void 0 !== _i175) {
          if (void 0 === t[_i175]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
          t = t[_i175];
        }
      }

      var s = t[i];

      if (void 0 === s) {
        var _n219 = e.nodeName;
        return void console.error("THREE.PropertyBinding: Trying to update property for track: " + _n219 + "." + i + " but it wasn't found.", t);
      }

      var a = this.Versioning.None;
      this.targetObject = t, void 0 !== t.needsUpdate ? a = this.Versioning.NeedsUpdate : void 0 !== t.matrixWorldNeedsUpdate && (a = this.Versioning.MatrixWorldNeedsUpdate);
      var o = this.BindingType.Direct;

      if (void 0 !== r) {
        if ("morphTargetInfluences" === i) {
          if (!t.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          if (!t.geometry.isBufferGeometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
          if (!t.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          void 0 !== t.morphTargetDictionary[r] && (r = t.morphTargetDictionary[r]);
        }

        o = this.BindingType.ArrayElement, this.resolvedProperty = s, this.propertyIndex = r;
      } else void 0 !== s.fromArray && void 0 !== s.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = s) : Array.isArray(s) ? (o = this.BindingType.EntireArray, this.resolvedProperty = s) : this.propertyName = i;

      this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][a];
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
  }], [{
    key: "create",
    value: function create(t, e, n) {
      return t && t.isAnimationObjectGroup ? new Wl.Composite(t, e, n) : new Wl(t, e, n);
    }
  }, {
    key: "sanitizeNodeName",
    value: function sanitizeNodeName(t) {
      return t.replace(/\s/g, "_").replace(Fl, "");
    }
  }, {
    key: "parseTrackName",
    value: function parseTrackName(t) {
      var e = Vl.exec(t);
      if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
      var n = {
        nodeName: e[2],
        objectName: e[3],
        objectIndex: e[4],
        propertyName: e[5],
        propertyIndex: e[6]
      },
          i = n.nodeName && n.nodeName.lastIndexOf(".");

      if (void 0 !== i && -1 !== i) {
        var _t271 = n.nodeName.substring(i + 1);

        -1 !== Gl.indexOf(_t271) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = _t271);
      }

      if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
      return n;
    }
  }, {
    key: "findNode",
    value: function findNode(t, e) {
      if (void 0 === e || "" === e || "." === e || -1 === e || e === t.name || e === t.uuid) return t;

      if (t.skeleton) {
        var _n220 = t.skeleton.getBoneByName(e);

        if (void 0 !== _n220) return _n220;
      }

      if (t.children) {
        var _n221 = function _n221(t) {
          for (var _i177 = 0; _i177 < t.length; _i177++) {
            var _r126 = t[_i177];
            if (_r126.name === e || _r126.uuid === e) return _r126;

            var _s75 = _n221(_r126.children);

            if (_s75) return _s75;
          }

          return null;
        },
            _i176 = _n221(t.children);

        if (_i176) return _i176;
      }

      return null;
    }
  }]);

  return Wl;
}();

Wl.Composite = /*#__PURE__*/function () {
  function _class19(t, e, n) {
    _classCallCheck(this, _class19);

    var i = n || Wl.parseTrackName(e);
    this._targetGroup = t, this._bindings = t.subscribe_(e, i);
  }

  _createClass(_class19, [{
    key: "getValue",
    value: function getValue(t, e) {
      this.bind();
      var n = this._targetGroup.nCachedObjects_,
          i = this._bindings[n];
      void 0 !== i && i.getValue(t, e);
    }
  }, {
    key: "setValue",
    value: function setValue(t, e) {
      var n = this._bindings;

      for (var _i178 = this._targetGroup.nCachedObjects_, _r127 = n.length; _i178 !== _r127; ++_i178) {
        n[_i178].setValue(t, e);
      }
    }
  }, {
    key: "bind",
    value: function bind() {
      var t = this._bindings;

      for (var _e240 = this._targetGroup.nCachedObjects_, _n222 = t.length; _e240 !== _n222; ++_e240) {
        t[_e240].bind();
      }
    }
  }, {
    key: "unbind",
    value: function unbind() {
      var t = this._bindings;

      for (var _e241 = this._targetGroup.nCachedObjects_, _n223 = t.length; _e241 !== _n223; ++_e241) {
        t[_e241].unbind();
      }
    }
  }]);

  return _class19;
}(), Wl.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
}, Wl.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
}, Wl.prototype.GetterByBindingType = [Wl.prototype._getValue_direct, Wl.prototype._getValue_array, Wl.prototype._getValue_arrayElement, Wl.prototype._getValue_toArray], Wl.prototype.SetterByBindingTypeAndVersioning = [[Wl.prototype._setValue_direct, Wl.prototype._setValue_direct_setNeedsUpdate, Wl.prototype._setValue_direct_setMatrixWorldNeedsUpdate], [Wl.prototype._setValue_array, Wl.prototype._setValue_array_setNeedsUpdate, Wl.prototype._setValue_array_setMatrixWorldNeedsUpdate], [Wl.prototype._setValue_arrayElement, Wl.prototype._setValue_arrayElement_setNeedsUpdate, Wl.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate], [Wl.prototype._setValue_fromArray, Wl.prototype._setValue_fromArray_setNeedsUpdate, Wl.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]];

var jl = /*#__PURE__*/function () {
  function jl(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.blendMode;

    _classCallCheck(this, jl);

    this._mixer = t, this._clip = e, this._localRoot = n, this.blendMode = i;
    var r = e.tracks,
        s = r.length,
        a = new Array(s),
        o = {
      endingStart: 2400,
      endingEnd: 2400
    };

    for (var _t272 = 0; _t272 !== s; ++_t272) {
      var _e242 = r[_t272].createInterpolant(null);

      a[_t272] = _e242, _e242.settings = o;
    }

    this._interpolantSettings = o, this._interpolants = a, this._propertyBindings = new Array(s), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = 2201, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
  }

  _createClass(jl, [{
    key: "play",
    value: function play() {
      return this._mixer._activateAction(this), this;
    }
  }, {
    key: "stop",
    value: function stop() {
      return this._mixer._deactivateAction(this), this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
    }
  }, {
    key: "isScheduled",
    value: function isScheduled() {
      return this._mixer._isActiveAction(this);
    }
  }, {
    key: "startAt",
    value: function startAt(t) {
      return this._startTime = t, this;
    }
  }, {
    key: "setLoop",
    value: function setLoop(t, e) {
      return this.loop = t, this.repetitions = e, this;
    }
  }, {
    key: "setEffectiveWeight",
    value: function setEffectiveWeight(t) {
      return this.weight = t, this._effectiveWeight = this.enabled ? t : 0, this.stopFading();
    }
  }, {
    key: "getEffectiveWeight",
    value: function getEffectiveWeight() {
      return this._effectiveWeight;
    }
  }, {
    key: "fadeIn",
    value: function fadeIn(t) {
      return this._scheduleFading(t, 0, 1);
    }
  }, {
    key: "fadeOut",
    value: function fadeOut(t) {
      return this._scheduleFading(t, 1, 0);
    }
  }, {
    key: "crossFadeFrom",
    value: function crossFadeFrom(t, e, n) {
      if (t.fadeOut(e), this.fadeIn(e), n) {
        var _n224 = this._clip.duration,
            _i179 = t._clip.duration,
            _r128 = _i179 / _n224,
            _s76 = _n224 / _i179;

        t.warp(1, _r128, e), this.warp(_s76, 1, e);
      }

      return this;
    }
  }, {
    key: "crossFadeTo",
    value: function crossFadeTo(t, e, n) {
      return t.crossFadeFrom(this, e, n);
    }
  }, {
    key: "stopFading",
    value: function stopFading() {
      var t = this._weightInterpolant;
      return null !== t && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
  }, {
    key: "setEffectiveTimeScale",
    value: function setEffectiveTimeScale(t) {
      return this.timeScale = t, this._effectiveTimeScale = this.paused ? 0 : t, this.stopWarping();
    }
  }, {
    key: "getEffectiveTimeScale",
    value: function getEffectiveTimeScale() {
      return this._effectiveTimeScale;
    }
  }, {
    key: "setDuration",
    value: function setDuration(t) {
      return this.timeScale = this._clip.duration / t, this.stopWarping();
    }
  }, {
    key: "syncWith",
    value: function syncWith(t) {
      return this.time = t.time, this.timeScale = t.timeScale, this.stopWarping();
    }
  }, {
    key: "halt",
    value: function halt(t) {
      return this.warp(this._effectiveTimeScale, 0, t);
    }
  }, {
    key: "warp",
    value: function warp(t, e, n) {
      var i = this._mixer,
          r = i.time,
          s = this.timeScale;
      var a = this._timeScaleInterpolant;
      null === a && (a = i._lendControlInterpolant(), this._timeScaleInterpolant = a);
      var o = a.parameterPositions,
          l = a.sampleValues;
      return o[0] = r, o[1] = r + n, l[0] = t / s, l[1] = e / s, this;
    }
  }, {
    key: "stopWarping",
    value: function stopWarping() {
      var t = this._timeScaleInterpolant;
      return null !== t && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
  }, {
    key: "getMixer",
    value: function getMixer() {
      return this._mixer;
    }
  }, {
    key: "getClip",
    value: function getClip() {
      return this._clip;
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      return this._localRoot || this._mixer._root;
    }
  }, {
    key: "_update",
    value: function _update(t, e, n, i) {
      if (!this.enabled) return void this._updateWeight(t);
      var r = this._startTime;

      if (null !== r) {
        var _i180 = (t - r) * n;

        if (_i180 < 0 || 0 === n) return;
        this._startTime = null, e = n * _i180;
      }

      e *= this._updateTimeScale(t);

      var s = this._updateTime(e),
          a = this._updateWeight(t);

      if (a > 0) {
        var _t273 = this._interpolants,
            _e243 = this._propertyBindings;
        if (2501 === this.blendMode) for (var _n225 = 0, _i181 = _t273.length; _n225 !== _i181; ++_n225) {
          _t273[_n225].evaluate(s), _e243[_n225].accumulateAdditive(a);
        } else for (var _n226 = 0, _r129 = _t273.length; _n226 !== _r129; ++_n226) {
          _t273[_n226].evaluate(s), _e243[_n226].accumulate(i, a);
        }
      }
    }
  }, {
    key: "_updateWeight",
    value: function _updateWeight(t) {
      var e = 0;

      if (this.enabled) {
        e = this.weight;
        var _n227 = this._weightInterpolant;

        if (null !== _n227) {
          var _i182 = _n227.evaluate(t)[0];

          e *= _i182, t > _n227.parameterPositions[1] && (this.stopFading(), 0 === _i182 && (this.enabled = !1));
        }
      }

      return this._effectiveWeight = e, e;
    }
  }, {
    key: "_updateTimeScale",
    value: function _updateTimeScale(t) {
      var e = 0;

      if (!this.paused) {
        e = this.timeScale;
        var _n228 = this._timeScaleInterpolant;

        if (null !== _n228) {
          e *= _n228.evaluate(t)[0], t > _n228.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e);
        }
      }

      return this._effectiveTimeScale = e, e;
    }
  }, {
    key: "_updateTime",
    value: function _updateTime(t) {
      var e = this._clip.duration,
          n = this.loop;
      var i = this.time + t,
          r = this._loopCount;
      var s = 2202 === n;
      if (0 === t) return -1 === r ? i : s && 1 == (1 & r) ? e - i : i;

      if (2200 === n) {
        -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));

        t: {
          if (i >= e) i = e;else {
            if (!(i < 0)) {
              this.time = i;
              break t;
            }

            i = 0;
          }
          this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: t < 0 ? -1 : 1
          });
        }
      } else {
        if (-1 === r && (t >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, s)) : this._setEndings(0 === this.repetitions, !0, s)), i >= e || i < 0) {
          var _n229 = Math.floor(i / e);

          i -= e * _n229, r += Math.abs(_n229);

          var _a57 = this.repetitions - r;

          if (_a57 <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: t > 0 ? 1 : -1
          });else {
            if (1 === _a57) {
              var _e244 = t < 0;

              this._setEndings(_e244, !_e244, s);
            } else this._setEndings(!1, !1, s);

            this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
              type: "loop",
              action: this,
              loopDelta: _n229
            });
          }
        } else this.time = i;

        if (s && 1 == (1 & r)) return e - i;
      }

      return i;
    }
  }, {
    key: "_setEndings",
    value: function _setEndings(t, e, n) {
      var i = this._interpolantSettings;
      n ? (i.endingStart = 2401, i.endingEnd = 2401) : (i.endingStart = t ? this.zeroSlopeAtStart ? 2401 : 2400 : 2402, i.endingEnd = e ? this.zeroSlopeAtEnd ? 2401 : 2400 : 2402);
    }
  }, {
    key: "_scheduleFading",
    value: function _scheduleFading(t, e, n) {
      var i = this._mixer,
          r = i.time;
      var s = this._weightInterpolant;
      null === s && (s = i._lendControlInterpolant(), this._weightInterpolant = s);
      var a = s.parameterPositions,
          o = s.sampleValues;
      return a[0] = r, o[0] = e, a[1] = r + t, o[1] = n, this;
    }
  }]);

  return jl;
}();

var ql = /*#__PURE__*/function (_et7) {
  _inherits(ql, _et7);

  var _super111 = _createSuper(ql);

  function ql(t) {
    var _this97;

    _classCallCheck(this, ql);

    _this97 = _super111.call(this), _this97._root = t, _this97._initMemoryManager(), _this97._accuIndex = 0, _this97.time = 0, _this97.timeScale = 1;
    return _this97;
  }

  _createClass(ql, [{
    key: "_bindAction",
    value: function _bindAction(t, e) {
      var n = t._localRoot || this._root,
          i = t._clip.tracks,
          r = i.length,
          s = t._propertyBindings,
          a = t._interpolants,
          o = n.uuid,
          l = this._bindingsByRootAndName;
      var h = l[o];
      void 0 === h && (h = {}, l[o] = h);

      for (var _t274 = 0; _t274 !== r; ++_t274) {
        var _r130 = i[_t274],
            _l33 = _r130.name;
        var _c15 = h[_l33];
        if (void 0 !== _c15) ++_c15.referenceCount, s[_t274] = _c15;else {
          if (_c15 = s[_t274], void 0 !== _c15) {
            null === _c15._cacheIndex && (++_c15.referenceCount, this._addInactiveBinding(_c15, o, _l33));
            continue;
          }

          var _i183 = e && e._propertyBindings[_t274].binding.parsedPath;

          _c15 = new Nl(Wl.create(n, _l33, _i183), _r130.ValueTypeName, _r130.getValueSize()), ++_c15.referenceCount, this._addInactiveBinding(_c15, o, _l33), s[_t274] = _c15;
        }
        a[_t274].resultBuffer = _c15.buffer;
      }
    }
  }, {
    key: "_activateAction",
    value: function _activateAction(t) {
      if (!this._isActiveAction(t)) {
        if (null === t._cacheIndex) {
          var _e246 = (t._localRoot || this._root).uuid,
              _n230 = t._clip.uuid,
              _i184 = this._actionsByClip[_n230];
          this._bindAction(t, _i184 && _i184.knownActions[0]), this._addInactiveAction(t, _n230, _e246);
        }

        var _e245 = t._propertyBindings;

        for (var _t275 = 0, _n231 = _e245.length; _t275 !== _n231; ++_t275) {
          var _n232 = _e245[_t275];
          0 == _n232.useCount++ && (this._lendBinding(_n232), _n232.saveOriginalState());
        }

        this._lendAction(t);
      }
    }
  }, {
    key: "_deactivateAction",
    value: function _deactivateAction(t) {
      if (this._isActiveAction(t)) {
        var _e247 = t._propertyBindings;

        for (var _t276 = 0, _n233 = _e247.length; _t276 !== _n233; ++_t276) {
          var _n234 = _e247[_t276];
          0 == --_n234.useCount && (_n234.restoreOriginalState(), this._takeBackBinding(_n234));
        }

        this._takeBackAction(t);
      }
    }
  }, {
    key: "_initMemoryManager",
    value: function _initMemoryManager() {
      this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
      var t = this;
      this.stats = {
        actions: {
          get total() {
            return t._actions.length;
          },

          get inUse() {
            return t._nActiveActions;
          }

        },
        bindings: {
          get total() {
            return t._bindings.length;
          },

          get inUse() {
            return t._nActiveBindings;
          }

        },
        controlInterpolants: {
          get total() {
            return t._controlInterpolants.length;
          },

          get inUse() {
            return t._nActiveControlInterpolants;
          }

        }
      };
    }
  }, {
    key: "_isActiveAction",
    value: function _isActiveAction(t) {
      var e = t._cacheIndex;
      return null !== e && e < this._nActiveActions;
    }
  }, {
    key: "_addInactiveAction",
    value: function _addInactiveAction(t, e, n) {
      var i = this._actions,
          r = this._actionsByClip;
      var s = r[e];
      if (void 0 === s) s = {
        knownActions: [t],
        actionByRoot: {}
      }, t._byClipCacheIndex = 0, r[e] = s;else {
        var _e248 = s.knownActions;
        t._byClipCacheIndex = _e248.length, _e248.push(t);
      }
      t._cacheIndex = i.length, i.push(t), s.actionByRoot[n] = t;
    }
  }, {
    key: "_removeInactiveAction",
    value: function _removeInactiveAction(t) {
      var e = this._actions,
          n = e[e.length - 1],
          i = t._cacheIndex;
      n._cacheIndex = i, e[i] = n, e.pop(), t._cacheIndex = null;
      var r = t._clip.uuid,
          s = this._actionsByClip,
          a = s[r],
          o = a.knownActions,
          l = o[o.length - 1],
          h = t._byClipCacheIndex;
      l._byClipCacheIndex = h, o[h] = l, o.pop(), t._byClipCacheIndex = null;
      delete a.actionByRoot[(t._localRoot || this._root).uuid], 0 === o.length && delete s[r], this._removeInactiveBindingsForAction(t);
    }
  }, {
    key: "_removeInactiveBindingsForAction",
    value: function _removeInactiveBindingsForAction(t) {
      var e = t._propertyBindings;

      for (var _t277 = 0, _n235 = e.length; _t277 !== _n235; ++_t277) {
        var _n236 = e[_t277];
        0 == --_n236.referenceCount && this._removeInactiveBinding(_n236);
      }
    }
  }, {
    key: "_lendAction",
    value: function _lendAction(t) {
      var e = this._actions,
          n = t._cacheIndex,
          i = this._nActiveActions++,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_takeBackAction",
    value: function _takeBackAction(t) {
      var e = this._actions,
          n = t._cacheIndex,
          i = --this._nActiveActions,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_addInactiveBinding",
    value: function _addInactiveBinding(t, e, n) {
      var i = this._bindingsByRootAndName,
          r = this._bindings;
      var s = i[e];
      void 0 === s && (s = {}, i[e] = s), s[n] = t, t._cacheIndex = r.length, r.push(t);
    }
  }, {
    key: "_removeInactiveBinding",
    value: function _removeInactiveBinding(t) {
      var e = this._bindings,
          n = t.binding,
          i = n.rootNode.uuid,
          r = n.path,
          s = this._bindingsByRootAndName,
          a = s[i],
          o = e[e.length - 1],
          l = t._cacheIndex;
      o._cacheIndex = l, e[l] = o, e.pop(), delete a[r], 0 === Object.keys(a).length && delete s[i];
    }
  }, {
    key: "_lendBinding",
    value: function _lendBinding(t) {
      var e = this._bindings,
          n = t._cacheIndex,
          i = this._nActiveBindings++,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_takeBackBinding",
    value: function _takeBackBinding(t) {
      var e = this._bindings,
          n = t._cacheIndex,
          i = --this._nActiveBindings,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_lendControlInterpolant",
    value: function _lendControlInterpolant() {
      var t = this._controlInterpolants,
          e = this._nActiveControlInterpolants++;
      var n = t[e];
      return void 0 === n && (n = new Xo(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer), n.__cacheIndex = e, t[e] = n), n;
    }
  }, {
    key: "_takeBackControlInterpolant",
    value: function _takeBackControlInterpolant(t) {
      var e = this._controlInterpolants,
          n = t.__cacheIndex,
          i = --this._nActiveControlInterpolants,
          r = e[i];
      t.__cacheIndex = i, e[i] = t, r.__cacheIndex = n, e[n] = r;
    }
  }, {
    key: "clipAction",
    value: function clipAction(t, e, n) {
      var i = e || this._root,
          r = i.uuid;
      var s = "string" == typeof t ? il.findByName(i, t) : t;
      var a = null !== s ? s.uuid : t,
          o = this._actionsByClip[a];
      var l = null;

      if (void 0 === n && (n = null !== s ? s.blendMode : 2500), void 0 !== o) {
        var _t278 = o.actionByRoot[r];
        if (void 0 !== _t278 && _t278.blendMode === n) return _t278;
        l = o.knownActions[0], null === s && (s = l._clip);
      }

      if (null === s) return null;
      var h = new jl(this, s, e, n);
      return this._bindAction(h, l), this._addInactiveAction(h, a, r), h;
    }
  }, {
    key: "existingAction",
    value: function existingAction(t, e) {
      var n = e || this._root,
          i = n.uuid,
          r = "string" == typeof t ? il.findByName(n, t) : t,
          s = r ? r.uuid : t,
          a = this._actionsByClip[s];
      return void 0 !== a && a.actionByRoot[i] || null;
    }
  }, {
    key: "stopAllAction",
    value: function stopAllAction() {
      var t = this._actions;

      for (var _e249 = this._nActiveActions - 1; _e249 >= 0; --_e249) {
        t[_e249].stop();
      }

      return this;
    }
  }, {
    key: "update",
    value: function update(t) {
      t *= this.timeScale;
      var e = this._actions,
          n = this._nActiveActions,
          i = this.time += t,
          r = Math.sign(t),
          s = this._accuIndex ^= 1;

      for (var _a58 = 0; _a58 !== n; ++_a58) {
        e[_a58]._update(i, t, r, s);
      }

      var a = this._bindings,
          o = this._nActiveBindings;

      for (var _t279 = 0; _t279 !== o; ++_t279) {
        a[_t279].apply(s);
      }

      return this;
    }
  }, {
    key: "setTime",
    value: function setTime(t) {
      this.time = 0;

      for (var _t280 = 0; _t280 < this._actions.length; _t280++) {
        this._actions[_t280].time = 0;
      }

      return this.update(t);
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      return this._root;
    }
  }, {
    key: "uncacheClip",
    value: function uncacheClip(t) {
      var e = this._actions,
          n = t.uuid,
          i = this._actionsByClip,
          r = i[n];

      if (void 0 !== r) {
        var _t281 = r.knownActions;

        for (var _n237 = 0, _i185 = _t281.length; _n237 !== _i185; ++_n237) {
          var _i186 = _t281[_n237];

          this._deactivateAction(_i186);

          var _r131 = _i186._cacheIndex,
              _s77 = e[e.length - 1];
          _i186._cacheIndex = null, _i186._byClipCacheIndex = null, _s77._cacheIndex = _r131, e[_r131] = _s77, e.pop(), this._removeInactiveBindingsForAction(_i186);
        }

        delete i[n];
      }
    }
  }, {
    key: "uncacheRoot",
    value: function uncacheRoot(t) {
      var e = t.uuid,
          n = this._actionsByClip;

      for (var _t282 in n) {
        var _i187 = n[_t282].actionByRoot[e];
        void 0 !== _i187 && (this._deactivateAction(_i187), this._removeInactiveAction(_i187));
      }

      var i = this._bindingsByRootAndName[e];
      if (void 0 !== i) for (var _t283 in i) {
        var _e250 = i[_t283];
        _e250.restoreOriginalState(), this._removeInactiveBinding(_e250);
      }
    }
  }, {
    key: "uncacheAction",
    value: function uncacheAction(t, e) {
      var n = this.existingAction(t, e);
      null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
    }
  }]);

  return ql;
}(et);

ql.prototype._controlInterpolantsResultBuffer = new Float32Array(1);

/*#__PURE__*/
(function (_Os) {
  _inherits(_class20, _Os);

  var _super112 = _createSuper(_class20);

  function _class20(t, e) {
    var _this98;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    _classCallCheck(this, _class20);

    _this98 = _super112.call(this, t, e), _this98.meshPerAttribute = n;
    return _this98;
  }

  _createClass(_class20, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class20.prototype), "copy", this).call(this, t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
  }, {
    key: "clone",
    value: function clone(t) {
      var e = _get(_getPrototypeOf(_class20.prototype), "clone", this).call(this, t);

      return e.meshPerAttribute = this.meshPerAttribute, e;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(_class20.prototype), "toJSON", this).call(this, t);

      return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
    }
  }]);

  return _class20;
})(Os).prototype.isInstancedInterleavedBuffer = !0;

function Xl(t, e) {
  return t.distance - e.distance;
}

function Yl(t, e, n, i) {
  if (t.layers.test(e.layers) && t.raycast(e, n), !0 === i) {
    var _i188 = t.children;

    for (var _t284 = 0, _r132 = _i188.length; _t284 < _r132; _t284++) {
      Yl(_i188[_t284], e, n, !0);
    }
  }
}

var Jl = /*#__PURE__*/function () {
  function Jl() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Jl);

    return this.radius = t, this.phi = e, this.theta = n, this;
  }

  _createClass(Jl, [{
    key: "set",
    value: function set(t, e, n) {
      return this.radius = t, this.phi = e, this.theta = n, this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
    }
  }, {
    key: "makeSafe",
    value: function makeSafe() {
      var t = 1e-6;
      return this.phi = Math.max(t, Math.min(Math.PI - t, this.phi)), this;
    }
  }, {
    key: "setFromVector3",
    value: function setFromVector3(t) {
      return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
  }, {
    key: "setFromCartesianCoords",
    value: function setFromCartesianCoords(t, e, n) {
      return this.radius = Math.sqrt(t * t + e * e + n * n), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, n), this.phi = Math.acos(ot(e / this.radius, -1, 1))), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Jl;
}();

var Zl = new zt(),
    $l = new ve(),
    Kl = new ve();

function Ql(t) {
  var e = [];
  !0 === t.isBone && e.push(t);

  for (var _n238 = 0; _n238 < t.children.length; _n238++) {
    e.push.apply(e, Ql(t.children[_n238]));
  }

  return e;
}

var th = /*#__PURE__*/function () {
  function th() {
    _classCallCheck(this, th);
  }

  _createClass(th, null, [{
    key: "toHalfFloat",
    value: function toHalfFloat(t) {
      Math.abs(t) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), t = ot(t, -65504, 65504), nh[0] = t;
      var e = ih[0],
          n = e >> 23 & 511;
      return rh[n] + ((8388607 & e) >> sh[n]);
    }
  }, {
    key: "fromHalfFloat",
    value: function fromHalfFloat(t) {
      var e = t >> 10;
      return ih[0] = ah[lh[e] + (1023 & t)] + oh[e], nh[0];
    }
  }]);

  return th;
}();

var eh = new ArrayBuffer(4),
    nh = new Float32Array(eh),
    ih = new Uint32Array(eh),
    rh = new Uint32Array(512),
    sh = new Uint32Array(512);

for (var _t285 = 0; _t285 < 256; ++_t285) {
  var _e251 = _t285 - 127;

  _e251 < -27 ? (rh[_t285] = 0, rh[256 | _t285] = 32768, sh[_t285] = 24, sh[256 | _t285] = 24) : _e251 < -14 ? (rh[_t285] = 1024 >> -_e251 - 14, rh[256 | _t285] = 1024 >> -_e251 - 14 | 32768, sh[_t285] = -_e251 - 1, sh[256 | _t285] = -_e251 - 1) : _e251 <= 15 ? (rh[_t285] = _e251 + 15 << 10, rh[256 | _t285] = _e251 + 15 << 10 | 32768, sh[_t285] = 13, sh[256 | _t285] = 13) : _e251 < 128 ? (rh[_t285] = 31744, rh[256 | _t285] = 64512, sh[_t285] = 24, sh[256 | _t285] = 24) : (rh[_t285] = 31744, rh[256 | _t285] = 64512, sh[_t285] = 13, sh[256 | _t285] = 13);
}

var ah = new Uint32Array(2048),
    oh = new Uint32Array(64),
    lh = new Uint32Array(64);

for (var _t286 = 1; _t286 < 1024; ++_t286) {
  var _e252 = _t286 << 13,
      _n239 = 0;

  for (; 0 == (8388608 & _e252);) {
    _e252 <<= 1, _n239 -= 8388608;
  }

  _e252 &= -8388609, _n239 += 947912704, ah[_t286] = _e252 | _n239;
}

for (var _t287 = 1024; _t287 < 2048; ++_t287) {
  ah[_t287] = 939524096 + (_t287 - 1024 << 13);
}

for (var _t288 = 1; _t288 < 31; ++_t288) {
  oh[_t288] = _t288 << 23;
}

oh[31] = 1199570944, oh[32] = 2147483648;

for (var _t289 = 33; _t289 < 63; ++_t289) {
  oh[_t289] = 2147483648 + (_t289 - 32 << 23);
}

oh[63] = 3347054592;

for (var _t290 = 1; _t290 < 64; ++_t290) {
  32 !== _t290 && (lh[_t290] = 1024);
}

Ia.create = function (t, e) {
  return console.log("THREE.Curve.create() has been deprecated"), t.prototype = Object.create(Ia.prototype), t.prototype.constructor = t, t.prototype.getPoint = e, t;
}, Qa.prototype.fromPoints = function (t) {
  return console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints()."), this.setFromPoints(t);
}, /*#__PURE__*/function (_Ma) {
  _inherits(_class21, _Ma);

  var _super113 = _createSuper(_class21);

  function _class21() {
    var _this99;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4473924;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8947848;

    _classCallCheck(this, _class21);

    n = new Rt(n), i = new Rt(i);
    var r = e / 2,
        s = t / e,
        a = t / 2,
        o = [],
        l = [];

    for (var _t291 = 0, _h21 = 0, _c16 = -a; _t291 <= e; _t291++, _c16 += s) {
      o.push(-a, 0, _c16, a, 0, _c16), o.push(_c16, 0, -a, _c16, 0, a);

      var _e253 = _t291 === r ? n : i;

      _e253.toArray(l, _h21), _h21 += 3, _e253.toArray(l, _h21), _h21 += 3, _e253.toArray(l, _h21), _h21 += 3, _e253.toArray(l, _h21), _h21 += 3;
    }

    var h = new vn();
    h.setAttribute("position", new hn(o, 3)), h.setAttribute("color", new hn(l, 3));
    _this99 = _super113.call(this, h, new ma({
      vertexColors: !0,
      toneMapped: !1
    })), _this99.type = "GridHelper";
    return _this99;
  }

  return _class21;
}(Ma).prototype.setColors = function () {
  console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
}, /*#__PURE__*/function (_Ma2) {
  _inherits(_class22, _Ma2);

  var _super114 = _createSuper(_class22);

  function _class22(t) {
    var _this100;

    _classCallCheck(this, _class22);

    var e = Ql(t),
        n = new vn(),
        i = [],
        r = [],
        s = new Rt(0, 0, 1),
        a = new Rt(0, 1, 0);

    for (var _t292 = 0; _t292 < e.length; _t292++) {
      var _n240 = e[_t292];
      _n240.parent && _n240.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(s.r, s.g, s.b), r.push(a.r, a.g, a.b));
    }

    n.setAttribute("position", new hn(i, 3)), n.setAttribute("color", new hn(r, 3));
    _this100 = _super114.call(this, n, new ma({
      vertexColors: !0,
      depthTest: !1,
      depthWrite: !1,
      toneMapped: !1,
      transparent: !0
    })), _this100.type = "SkeletonHelper", _this100.isSkeletonHelper = !0, _this100.root = t, _this100.bones = e, _this100.matrix = t.matrixWorld, _this100.matrixAutoUpdate = !1;
    return _this100;
  }

  _createClass(_class22, [{
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      var e = this.bones,
          n = this.geometry,
          i = n.getAttribute("position");
      Kl.copy(this.root.matrixWorld).invert();

      for (var _t293 = 0, _n241 = 0; _t293 < e.length; _t293++) {
        var _r133 = e[_t293];
        _r133.parent && _r133.parent.isBone && ($l.multiplyMatrices(Kl, _r133.matrixWorld), Zl.setFromMatrixPosition($l), i.setXYZ(_n241, Zl.x, Zl.y, Zl.z), $l.multiplyMatrices(Kl, _r133.parent.matrixWorld), Zl.setFromMatrixPosition($l), i.setXYZ(_n241 + 1, Zl.x, Zl.y, Zl.z), _n241 += 2);
      }

      n.getAttribute("position").needsUpdate = !0, _get(_getPrototypeOf(_class22.prototype), "updateMatrixWorld", this).call(this, t);
    }
  }]);

  return _class22;
}(Ma).prototype.update = function () {
  console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
}, ol.prototype.extractUrlBase = function (t) {
  return console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead."), Ll.extractUrlBase(t);
}, ol.Handlers = {
  add: function add() {
    console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
  },
  get: function get() {
    console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
  }
}, Gt.prototype.center = function (t) {
  return console.warn("THREE.Box3: .center() has been renamed to .getCenter()."), this.getCenter(t);
}, Gt.prototype.empty = function () {
  return console.warn("THREE.Box3: .empty() has been renamed to .isEmpty()."), this.isEmpty();
}, Gt.prototype.isIntersectionBox = function (t) {
  return console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t);
}, Gt.prototype.isIntersectionSphere = function (t) {
  return console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t);
}, Gt.prototype.size = function (t) {
  return console.warn("THREE.Box3: .size() has been renamed to .getSize()."), this.getSize(t);
}, Ae.prototype.toVector3 = function () {
  console.error("THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead");
}, le.prototype.empty = function () {
  return console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty()."), this.isEmpty();
}, Qn.prototype.setFromMatrix = function (t) {
  return console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix()."), this.setFromProjectionMatrix(t);
}, ft.prototype.flattenToArrayOffset = function (t, e) {
  return console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t, e);
}, ft.prototype.multiplyVector3 = function (t) {
  return console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead."), t.applyMatrix3(this);
}, ft.prototype.multiplyVector3Array = function () {
  console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
}, ft.prototype.applyToBufferAttribute = function (t) {
  return console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead."), t.applyMatrix3(this);
}, ft.prototype.applyToVector3Array = function () {
  console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
}, ft.prototype.getInverse = function (t) {
  return console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t).invert();
}, ve.prototype.extractPosition = function (t) {
  return console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition()."), this.copyPosition(t);
}, ve.prototype.flattenToArrayOffset = function (t, e) {
  return console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t, e);
}, ve.prototype.getPosition = function () {
  return console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead."), new zt().setFromMatrixColumn(this, 3);
}, ve.prototype.setRotationFromQuaternion = function (t) {
  return console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion()."), this.makeRotationFromQuaternion(t);
}, ve.prototype.multiplyToArray = function () {
  console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
}, ve.prototype.multiplyVector3 = function (t) {
  return console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ve.prototype.multiplyVector4 = function (t) {
  return console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ve.prototype.multiplyVector3Array = function () {
  console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
}, ve.prototype.rotateAxis = function (t) {
  console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead."), t.transformDirection(this);
}, ve.prototype.crossVector = function (t) {
  return console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ve.prototype.translate = function () {
  console.error("THREE.Matrix4: .translate() has been removed.");
}, ve.prototype.rotateX = function () {
  console.error("THREE.Matrix4: .rotateX() has been removed.");
}, ve.prototype.rotateY = function () {
  console.error("THREE.Matrix4: .rotateY() has been removed.");
}, ve.prototype.rotateZ = function () {
  console.error("THREE.Matrix4: .rotateZ() has been removed.");
}, ve.prototype.rotateByAxis = function () {
  console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
}, ve.prototype.applyToBufferAttribute = function (t) {
  return console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ve.prototype.applyToVector3Array = function () {
  console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
}, ve.prototype.makeFrustum = function (t, e, n, i, r, s) {
  return console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead."), this.makePerspective(t, e, i, n, r, s);
}, ve.prototype.getInverse = function (t) {
  return console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t).invert();
}, Zn.prototype.isIntersectionLine = function (t) {
  return console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine()."), this.intersectsLine(t);
}, Bt.prototype.multiplyVector3 = function (t) {
  return console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead."), t.applyQuaternion(this);
}, Bt.prototype.inverse = function () {
  return console.warn("THREE.Quaternion: .inverse() has been renamed to invert()."), this.invert();
}, ge.prototype.isIntersectionBox = function (t) {
  return console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t);
}, ge.prototype.isIntersectionPlane = function (t) {
  return console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane()."), this.intersectsPlane(t);
}, ge.prototype.isIntersectionSphere = function (t) {
  return console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t);
}, Qe.prototype.area = function () {
  return console.warn("THREE.Triangle: .area() has been renamed to .getArea()."), this.getArea();
}, Qe.prototype.barycoordFromPoint = function (t, e) {
  return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), this.getBarycoord(t, e);
}, Qe.prototype.midpoint = function (t) {
  return console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint()."), this.getMidpoint(t);
}, Qe.prototypenormal = function (t) {
  return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), this.getNormal(t);
}, Qe.prototype.plane = function (t) {
  return console.warn("THREE.Triangle: .plane() has been renamed to .getPlane()."), this.getPlane(t);
}, Qe.barycoordFromPoint = function (t, e, n, i, r) {
  return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), Qe.getBarycoord(t, e, n, i, r);
}, Qe.normal = function (t, e, n, i) {
  return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), Qe.getNormal(t, e, n, i);
}, to.prototype.extractAllPoints = function (t) {
  return console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead."), this.extractPoints(t);
}, to.prototype.extrude = function (t) {
  return console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead."), new Lo(this, t);
}, to.prototype.makeGeometry = function (t) {
  return console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead."), new Do(this, t);
}, mt.prototype.fromAttribute = function (t, e, n) {
  return console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
}, mt.prototype.distanceToManhattan = function (t) {
  return console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t);
}, mt.prototype.lengthManhattan = function () {
  return console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, zt.prototype.setEulerFromRotationMatrix = function () {
  console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
}, zt.prototype.setEulerFromQuaternion = function () {
  console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
}, zt.prototype.getPositionFromMatrix = function (t) {
  return console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition()."), this.setFromMatrixPosition(t);
}, zt.prototype.getScaleFromMatrix = function (t) {
  return console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale()."), this.setFromMatrixScale(t);
}, zt.prototype.getColumnFromMatrix = function (t, e) {
  return console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn()."), this.setFromMatrixColumn(e, t);
}, zt.prototype.applyProjection = function (t) {
  return console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead."), this.applyMatrix4(t);
}, zt.prototype.fromAttribute = function (t, e, n) {
  return console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
}, zt.prototype.distanceToManhattan = function (t) {
  return console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t);
}, zt.prototype.lengthManhattan = function () {
  return console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, Nt.prototype.fromAttribute = function (t, e, n) {
  return console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
}, Nt.prototype.lengthManhattan = function () {
  return console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, Ve.prototype.getChildByName = function (t) {
  return console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName()."), this.getObjectByName(t);
}, Ve.prototype.renderDepth = function () {
  console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
}, Ve.prototype.translate = function (t, e) {
  return console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead."), this.translateOnAxis(e, t);
}, Ve.prototype.getWorldRotation = function () {
  console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
}, Ve.prototype.applyMatrix = function (t) {
  return console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
}, Object.defineProperties(Ve.prototype, {
  eulerOrder: {
    get: function get() {
      return console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order;
    },
    set: function set(t) {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order = t;
    }
  },
  useQuaternion: {
    get: function get() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    },
    set: function set() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    }
  }
}), Nn.prototype.setDrawMode = function () {
  console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
}, Object.defineProperties(Nn.prototype, {
  drawMode: {
    get: function get() {
      return console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode."), 0;
    },
    set: function set() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
    }
  }
}), ia.prototype.initBones = function () {
  console.error("THREE.SkinnedMesh: initBones() has been removed.");
}, Gn.prototype.setLens = function (t, e) {
  console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup."), void 0 !== e && (this.filmGauge = e), this.setFocalLength(t);
}, Object.defineProperties(ml.prototype, {
  onlyShadow: {
    set: function set() {
      console.warn("THREE.Light: .onlyShadow has been removed.");
    }
  },
  shadowCameraFov: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov."), this.shadow.camera.fov = t;
    }
  },
  shadowCameraLeft: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left."), this.shadow.camera.left = t;
    }
  },
  shadowCameraRight: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right."), this.shadow.camera.right = t;
    }
  },
  shadowCameraTop: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top."), this.shadow.camera.top = t;
    }
  },
  shadowCameraBottom: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom."), this.shadow.camera.bottom = t;
    }
  },
  shadowCameraNear: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near."), this.shadow.camera.near = t;
    }
  },
  shadowCameraFar: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far."), this.shadow.camera.far = t;
    }
  },
  shadowCameraVisible: {
    set: function set() {
      console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
    }
  },
  shadowBias: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowBias is now .shadow.bias."), this.shadow.bias = t;
    }
  },
  shadowDarkness: {
    set: function set() {
      console.warn("THREE.Light: .shadowDarkness has been removed.");
    }
  },
  shadowMapWidth: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width."), this.shadow.mapSize.width = t;
    }
  },
  shadowMapHeight: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height."), this.shadow.mapSize.height = t;
    }
  }
}), Object.defineProperties(an.prototype, {
  length: {
    get: function get() {
      return console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead."), this.array.length;
    }
  },
  dynamic: {
    get: function get() {
      return console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), 35048 === this.usage;
    },
    set: function set() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), this.setUsage(35048);
    }
  }
}), an.prototype.setDynamic = function (t) {
  return console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t ? 35048 : 35044), this;
}, an.prototype.copyIndicesArray = function () {
  console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, an.prototype.setArray = function () {
  console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
}, vn.prototype.addIndex = function (t) {
  console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex()."), this.setIndex(t);
}, vn.prototype.addAttribute = function (t, e) {
  return console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute()."), e && e.isBufferAttribute || e && e.isInterleavedBufferAttribute ? "index" === t ? (console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), this.setIndex(e), this) : this.setAttribute(t, e) : (console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), this.setAttribute(t, new an(arguments[1], arguments[2])));
}, vn.prototype.addDrawCall = function (t, e, n) {
  void 0 !== n && console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset."), console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup()."), this.addGroup(t, e);
}, vn.prototype.clearDrawCalls = function () {
  console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups()."), this.clearGroups();
}, vn.prototype.computeOffsets = function () {
  console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
}, vn.prototype.removeAttribute = function (t) {
  return console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute()."), this.deleteAttribute(t);
}, vn.prototype.applyMatrix = function (t) {
  return console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
}, Object.defineProperties(vn.prototype, {
  drawcalls: {
    get: function get() {
      return console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups."), this.groups;
    }
  },
  offsets: {
    get: function get() {
      return console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups."), this.groups;
    }
  }
}), Os.prototype.setDynamic = function (t) {
  return console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t ? 35048 : 35044), this;
}, Os.prototype.setArray = function () {
  console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
}, Lo.prototype.getArrays = function () {
  console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
}, Lo.prototype.addShapeList = function () {
  console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
}, Lo.prototype.addShape = function () {
  console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
}, Is.prototype.dispose = function () {
  console.error("THREE.Scene: .dispose() has been removed.");
}, Object.defineProperties(en.prototype, {
  wrapAround: {
    get: function get() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    },
    set: function set() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    }
  },
  overdraw: {
    get: function get() {
      console.warn("THREE.Material: .overdraw has been removed.");
    },
    set: function set() {
      console.warn("THREE.Material: .overdraw has been removed.");
    }
  },
  wrapRGB: {
    get: function get() {
      return console.warn("THREE.Material: .wrapRGB has been removed."), new Rt();
    }
  },
  shading: {
    get: function get() {
      console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
    },
    set: function set(t) {
      console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === t;
    }
  },
  stencilMask: {
    get: function get() {
      return console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask;
    },
    set: function set(t) {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask = t;
    }
  },
  vertexTangents: {
    get: function get() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    },
    set: function set() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    }
  }
}), Object.defineProperties(Hn.prototype, {
  derivatives: {
    get: function get() {
      return console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives;
    },
    set: function set(t) {
      console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives = t;
    }
  }
}), Ds.prototype.clearTarget = function (t, e, n, i) {
  console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead."), this.setRenderTarget(t), this.clear(e, n, i);
}, Ds.prototype.animate = function (t) {
  console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop()."), this.setAnimationLoop(t);
}, Ds.prototype.getCurrentRenderTarget = function () {
  return console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget()."), this.getRenderTarget();
}, Ds.prototype.getMaxAnisotropy = function () {
  return console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy()."), this.capabilities.getMaxAnisotropy();
}, Ds.prototype.getPrecision = function () {
  return console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision."), this.capabilities.precision;
}, Ds.prototype.resetGLState = function () {
  return console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset()."), this.state.reset();
}, Ds.prototype.supportsFloatTextures = function () {
  return console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."), this.extensions.get("OES_texture_float");
}, Ds.prototype.supportsHalfFloatTextures = function () {
  return console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."), this.extensions.get("OES_texture_half_float");
}, Ds.prototype.supportsStandardDerivatives = function () {
  return console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."), this.extensions.get("OES_standard_derivatives");
}, Ds.prototype.supportsCompressedTextureS3TC = function () {
  return console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."), this.extensions.get("WEBGL_compressed_texture_s3tc");
}, Ds.prototype.supportsCompressedTexturePVRTC = function () {
  return console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."), this.extensions.get("WEBGL_compressed_texture_pvrtc");
}, Ds.prototype.supportsBlendMinMax = function () {
  return console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."), this.extensions.get("EXT_blend_minmax");
}, Ds.prototype.supportsVertexTextures = function () {
  return console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures."), this.capabilities.vertexTextures;
}, Ds.prototype.supportsInstancedArrays = function () {
  return console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."), this.extensions.get("ANGLE_instanced_arrays");
}, Ds.prototype.enableScissorTest = function (t) {
  console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest()."), this.setScissorTest(t);
}, Ds.prototype.initMaterial = function () {
  console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
}, Ds.prototype.addPrePlugin = function () {
  console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
}, Ds.prototype.addPostPlugin = function () {
  console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
}, Ds.prototype.updateShadowMap = function () {
  console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
}, Ds.prototype.setFaceCulling = function () {
  console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
}, Ds.prototype.allocTextureUnit = function () {
  console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
}, Ds.prototype.setTexture = function () {
  console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
}, Ds.prototype.setTexture2D = function () {
  console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
}, Ds.prototype.setTextureCube = function () {
  console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
}, Ds.prototype.getActiveMipMapLevel = function () {
  return console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel()."), this.getActiveMipmapLevel();
}, Object.defineProperties(Ds.prototype, {
  shadowMapEnabled: {
    get: function get() {
      return this.shadowMap.enabled;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled."), this.shadowMap.enabled = t;
    }
  },
  shadowMapType: {
    get: function get() {
      return this.shadowMap.type;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type."), this.shadowMap.type = t;
    }
  },
  shadowMapCullFace: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  context: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead."), this.getContext();
    }
  },
  vr: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr"), this.xr;
    }
  },
  gammaInput: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead."), !1;
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
    }
  },
  gammaOutput: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), !1;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), this.outputEncoding = !0 === t ? 3001 : 3e3;
    }
  },
  toneMappingWhitePoint: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed."), 1;
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
    }
  },
  gammaFactor: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .gammaFactor has been removed."), 2;
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
    }
  }
}), Object.defineProperties(bs.prototype, {
  cullFace: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  renderReverseSided: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
    }
  },
  renderSingleSided: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
    }
  }
}), Object.defineProperties(Ft.prototype, {
  wrapS: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS = t;
    }
  },
  wrapT: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT = t;
    }
  },
  magFilter: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter = t;
    }
  },
  minFilter: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter = t;
    }
  },
  anisotropy: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy = t;
    }
  },
  offset: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset = t;
    }
  },
  repeat: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat = t;
    }
  },
  format: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format = t;
    }
  },
  type: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type = t;
    }
  },
  generateMipmaps: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps = t;
    }
  }
}), /*#__PURE__*/function (_Ve11) {
  _inherits(_class23, _Ve11);

  var _super115 = _createSuper(_class23);

  function _class23(t) {
    var _this101;

    _classCallCheck(this, _class23);

    _this101 = _super115.call(this), _this101.type = "Audio", _this101.listener = t, _this101.context = t.context, _this101.gain = _this101.context.createGain(), _this101.gain.connect(t.getInput()), _this101.autoplay = !1, _this101.buffer = null, _this101.detune = 0, _this101.loop = !1, _this101.loopStart = 0, _this101.loopEnd = 0, _this101.offset = 0, _this101.duration = void 0, _this101.playbackRate = 1, _this101.isPlaying = !1, _this101.hasPlaybackControl = !0, _this101.source = null, _this101.sourceType = "empty", _this101._startedAt = 0, _this101._progress = 0, _this101._connected = !1, _this101.filters = [];
    return _this101;
  }

  _createClass(_class23, [{
    key: "getOutput",
    value: function getOutput() {
      return this.gain;
    }
  }, {
    key: "setNodeSource",
    value: function setNodeSource(t) {
      return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t, this.connect(), this;
    }
  }, {
    key: "setMediaElementSource",
    value: function setMediaElementSource(t) {
      return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t), this.connect(), this;
    }
  }, {
    key: "setMediaStreamSource",
    value: function setMediaStreamSource(t) {
      return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t), this.connect(), this;
    }
  }, {
    key: "setBuffer",
    value: function setBuffer(t) {
      return this.buffer = t, this.sourceType = "buffer", this.autoplay && this.play(), this;
    }
  }, {
    key: "play",
    value: function play() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
      if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
      this._startedAt = this.context.currentTime + t;
      var e = this.context.createBufferSource();
      return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!1 !== this.hasPlaybackControl) return this._progress = 0, this.source.stop(), this.source.onended = null, this.isPlaying = !1, this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "connect",
    value: function connect() {
      if (this.filters.length > 0) {
        this.source.connect(this.filters[0]);

        for (var _t294 = 1, _e254 = this.filters.length; _t294 < _e254; _t294++) {
          this.filters[_t294 - 1].connect(this.filters[_t294]);
        }

        this.filters[this.filters.length - 1].connect(this.getOutput());
      } else this.source.connect(this.getOutput());

      return this._connected = !0, this;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.filters.length > 0) {
        this.source.disconnect(this.filters[0]);

        for (var _t295 = 1, _e255 = this.filters.length; _t295 < _e255; _t295++) {
          this.filters[_t295 - 1].disconnect(this.filters[_t295]);
        }

        this.filters[this.filters.length - 1].disconnect(this.getOutput());
      } else this.source.disconnect(this.getOutput());

      return this._connected = !1, this;
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.filters;
    }
  }, {
    key: "setFilters",
    value: function setFilters(t) {
      return t || (t = []), !0 === this._connected ? (this.disconnect(), this.filters = t.slice(), this.connect()) : this.filters = t.slice(), this;
    }
  }, {
    key: "setDetune",
    value: function setDetune(t) {
      if (this.detune = t, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
    }
  }, {
    key: "getDetune",
    value: function getDetune() {
      return this.detune;
    }
  }, {
    key: "getFilter",
    value: function getFilter() {
      return this.getFilters()[0];
    }
  }, {
    key: "setFilter",
    value: function setFilter(t) {
      return this.setFilters(t ? [t] : []);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(t) {
      if (!1 !== this.hasPlaybackControl) return this.playbackRate = t, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.playbackRate;
    }
  }, {
    key: "onEnded",
    value: function onEnded() {
      this.isPlaying = !1;
    }
  }, {
    key: "getLoop",
    value: function getLoop() {
      return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
    }
  }, {
    key: "setLoop",
    value: function setLoop(t) {
      if (!1 !== this.hasPlaybackControl) return this.loop = t, !0 === this.isPlaying && (this.source.loop = this.loop), this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "setLoopStart",
    value: function setLoopStart(t) {
      return this.loopStart = t, this;
    }
  }, {
    key: "setLoopEnd",
    value: function setLoopEnd(t) {
      return this.loopEnd = t, this;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.gain.gain.value;
    }
  }, {
    key: "setVolume",
    value: function setVolume(t) {
      return this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01), this;
    }
  }]);

  return _class23;
}(Ve).prototype.load = function (t) {
  console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
  var e = this;
  return new Ol().load(t, function (t) {
    e.setBuffer(t);
  }), this;
}, Wn.prototype.updateCubeMap = function (t, e) {
  return console.warn("THREE.CubeCamera: .updateCubeMap() is now .update()."), this.update(t, e);
}, Wn.prototype.clear = function (t, e, n, i) {
  return console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear()."), this.renderTarget.clear(t, e, n, i);
}, Lt.crossOrigin = void 0, Lt.loadTexture = function (t, e, n, i) {
  console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
  var r = new pl();
  r.setCrossOrigin(this.crossOrigin);
  var s = r.load(t, n, void 0, i);
  return e && (s.mapping = e), s;
}, Lt.loadTextureCube = function (t, e, n, i) {
  console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
  var r = new ul();
  r.setCrossOrigin(this.crossOrigin);
  var s = r.load(t, n, void 0, i);
  return e && (s.mapping = e), s;
}, Lt.loadCompressedTexture = function () {
  console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
}, Lt.loadCompressedTextureCube = function () {
  console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
}, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
  detail: {
    revision: "139"
  }
})), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = "139");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var hh = null != navigator.xr && null != self.XRSession && null != navigator.xr.isSessionSupported,
    ch = hh && self.XRSession.prototype.requestHitTestSource,
    uh = null != self.ResizeObserver,
    dh = null != self.IntersectionObserver,
    ph = ch;
(function () {
  var t = navigator.userAgent || navigator.vendor || self.opera;
  var e = !1;
  (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0);
})(), /\bCrOS\b/.test(navigator.userAgent);

var mh = /android/i.test(navigator.userAgent),
    fh = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
    gh = function () {
  var t = document.createElement("a");
  return Boolean(t.relList && t.relList.supports && t.relList.supports("ar"));
}();

/Safari\//.test(navigator.userAgent);
var vh = /firefox/i.test(navigator.userAgent),
    yh = /OculusBrowser/.test(navigator.userAgent);
fh && /CriOS\//.test(navigator.userAgent);
var xh = mh && !vh && !yh;
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _h = U(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n<style>\n:host {\n  display: block;\n  position: relative;\n  contain: strict;\n  width: 300px;\n  height: 150px;\n}\n\n/* NOTE: This ruleset is our integration surface area with the\n * :focus-visible polyfill.\n *\n * @see https://github.com/WICG/focus-visible/pull/196 */\n:host([data-js-focus-visible]:focus:not(.focus-visible)),\n:host([data-js-focus-visible]) :focus:not(.focus-visible) {\n  outline: none;\n}\n\n.container {\n  position: relative;\n}\n\n.userInput {\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: relative;\n  overflow: hidden;\n}\n\ncanvas {\n  position: absolute;\n  display: none;\n  pointer-events: none;\n  /* NOTE(cdata): Chrome 76 and below apparently have a bug\n   * that causes our canvas not to display pixels unless it is\n   * on its own render layer\n   * @see https://github.com/google/model-viewer/pull/755#issuecomment-536597893\n   */\n  transform: translateZ(0);\n}\n\ncanvas.show {\n  display: block;\n}\n\n/* Adapted from HTML5 Boilerplate\n *\n * @see https://github.com/h5bp/html5-boilerplate/blob/ceb4620c78fc82e13534fc44202a3f168754873f/dist/css/main.css#L122-L133 */\n.screen-reader-only {\n  border: 0;\n  left: 0;\n  top: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n  pointer-events: none;\n}\n\n.slot {\n  position: absolute;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.slot > * {\n  pointer-events: initial;\n}\n\n.annotation-wrapper ::slotted(*) {\n  opacity: var(--max-hotspot-opacity, 1);\n  transition: opacity 0.3s;\n}\n\n.pointer-tumbling .annotation-wrapper ::slotted(*) {\n  pointer-events: none;\n}\n\n.annotation-wrapper ::slotted(*) {\n  pointer-events: initial;\n}\n\n.annotation-wrapper.hide ::slotted(*) {\n  opacity: var(--min-hotspot-opacity, 0.25);\n}\n\n.slot.poster {\n  opacity: 0;\n  transition: opacity 0.3s 0.3s;\n  background-color: inherit;\n}\n\n.slot.poster.show {\n  opacity: 1;\n  transition: none;\n}\n\n.slot.poster.quick {\n  transition: none;\n}\n\n.slot.poster > * {\n  pointer-events: initial;\n}\n\n.slot.poster:not(.show) > * {\n  pointer-events: none;\n}\n\n#default-poster {\n  width: 100%;\n  height: 100%;\n  /* The default poster is a <button> so we need to set display\n   * to prevent it from being affected by text-align: */\n  display: block;\n  position: absolute;\n  border: none;\n  padding: 0;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: var(--poster-color, #fff);\n  background-image: var(--poster-image, none);\n}\n\n#default-progress-bar {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n#default-progress-bar > .mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--progress-mask, #fff);\n  transition: opacity 0.3s;\n  opacity: 0.2;\n}\n\n#default-progress-bar > .bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: var(--progress-bar-height, 5px);\n  background-color: var(--progress-bar-color, rgba(0, 0, 0, 0.4));\n  transition: transform 0.09s;\n  transform-origin: top left;\n  transform: scaleX(0);\n  overflow: hidden;\n}\n\n#default-progress-bar > .bar.hide {\n  transition: opacity 0.3s 1s;\n  opacity: 0;\n}\n\n.slot.interaction-prompt {\n  display: var(--interaction-prompt-display, flex);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  align-items: center;\n  justify-content: center;\n\n  opacity: 0;\n  will-change: opacity;\n  overflow: hidden;\n  transition: opacity 0.3s;\n}\n\n.slot.interaction-prompt.visible {\n  opacity: 1;\n}\n\n.slot.interaction-prompt > .animated-container {\n  will-change: transform, opacity;\n}\n\n.slot.interaction-prompt > * {\n  pointer-events: none;\n}\n\n.slot.ar-button {\n  -moz-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n\n  display: var(--ar-button-display, block);\n}\n\n.slot.ar-button:not(.enabled) {\n  display: none;\n}\n\n.fab {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  background-color: #fff;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 100px;\n}\n\n.fab > * {\n  opacity: 0.87;\n}\n\n#default-ar-button {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  transform: scale(var(--ar-button-scale, 1));\n  transform-origin: bottom right;\n}\n\n.slot.pan-target {\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: 50%;\n  top: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  background-color: transparent;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n#default-pan-target {\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  border: 1px solid white;\n  box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.8);\n}\n\n.slot.default {\n  pointer-events: none;\n}\n\n.slot.progress-bar {\n  pointer-events: none;\n}\n\n.slot.exit-webxr-ar-button {\n  pointer-events: none;\n}\n\n.slot.exit-webxr-ar-button:not(.enabled) {\n  display: none;\n}\n\n#default-exit-webxr-ar-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 40px;\n  height: 40px;\n  box-sizing: border-box;\n}\n\n#default-exit-webxr-ar-button > svg {\n  fill: #fff;\n}\n</style>\n<div class=\"container\">\n  <div class=\"userInput\" tabindex=\"0\" role=\"img\"\n      aria-label=\"3D model\">\n      <div class=\"slot canvas\">\n        <slot name=\"canvas\">\n          <canvas></canvas>\n        </slot>\n      </div>\n      \n  </div>\n\n  <!-- NOTE(cdata): We need to wrap slots because browsers without ShadowDOM\n        will have their <slot> elements removed by ShadyCSS -->\n  <div class=\"slot poster\">\n    <slot name=\"poster\">\n      <button type=\"button\" id=\"default-poster\" aria-hidden=\"true\" aria-label=\"Loading 3D model\"></button>\n    </slot>\n  </div>\n\n  <div class=\"slot ar-button\">\n    <slot name=\"ar-button\">\n      <a id=\"default-ar-button\" part=\"default-ar-button\" class=\"fab\"\n          tabindex=\"2\"\n          aria-label=\"View in your space\">\n        ", "\n      </a>\n    </slot>\n  </div>\n\n  <div class=\"slot pan-target\">\n    <slot name=\"pan-target\">\n      <div id=\"default-pan-target\">      \n      </div>\n    </slot>\n  </div>\n\n  <div class=\"slot interaction-prompt\">\n    <div class=\"animated-container\">\n      <slot name=\"interaction-prompt\" aria-hidden=\"true\">\n        ", "\n      </slot>\n    </div>\n  </div>\n\n  <div class=\"slot default\">\n    <slot></slot>\n\n    <div class=\"slot progress-bar\">\n      <slot name=\"progress-bar\">\n        <div id=\"default-progress-bar\" aria-hidden=\"true\">\n          <div class=\"mask\" part=\"default-progress-mask\"></div>\n          <div class=\"bar\" part=\"default-progress-bar\"></div>\n        </div>\n      </slot>\n    </div>\n    \n    <div class=\"slot exit-webxr-ar-button\">\n      <slot name=\"exit-webxr-ar-button\">\n        <a id=\"default-exit-webxr-ar-button\" part=\"default-exit-webxr-ar-button\"\n            tabindex=\"3\"\n            aria-label=\"Exit AR\"\n            aria-hidden=\"true\">\n          ", "\n        </a>\n      </slot>\n    </div>\n  </div>\n</div>\n<div class=\"screen-reader-only\" role=\"region\" aria-label=\"Live announcements\">\n  <span id=\"status\" role=\"status\"></span>\n</div>"])), U(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n<svg version=\"1.1\" id=\"view_x5F_in_x5F_AR_x5F_icon\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"24px\" height=\"24px\"\n\t viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\">\n<rect id=\"Bounding_Box\" x=\"0\" y=\"0\" fill=\"none\" width=\"24\" height=\"24\"/>\n<g id=\"Art_layer\">\n\t<path d=\"M3,4c0-0.55,0.45-1,1-1h2V1H4C2.35,1,1,2.35,1,4v2h2V4z\"/>\n\t<path d=\"M20,3c0.55,0,1,0.45,1,1v2h2V4c0-1.65-1.35-3-3-3h-2v2H20z\"/>\n\t<path d=\"M4,21c-0.55,0-1-0.45-1-1v-2H1v2c0,1.65,1.35,3,3,3h2v-2H4z\"/>\n\t<path d=\"M20,21c0.55,0,1-0.45,1-1v-2h2v2c0,1.65-1.35,3-3,3h-2v-2H20z\"/>\n\t<g>\n\t\t<path d=\"M18.25,7.6l-5.5-3.18c-0.46-0.27-1.04-0.27-1.5,0L5.75,7.6C5.29,7.87,5,8.36,5,8.9v6.35c0,0.54,0.29,1.03,0.75,1.3\n\t\t\tl5.5,3.18c0.46,0.27,1.04,0.27,1.5,0l5.5-3.18c0.46-0.27,0.75-0.76,0.75-1.3V8.9C19,8.36,18.71,7.87,18.25,7.6z M7,14.96v-4.62\n\t\t\tl4,2.32v4.61L7,14.96z M12,10.93L8,8.61l4-2.31l4,2.31L12,10.93z M13,17.27v-4.61l4-2.32v4.62L13,17.27z\"/>\n\t</g>\n</g>\n</svg>"]))), U(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"36\">\n    <defs>\n        <path id=\"A\" d=\"M.001.232h24.997V36H.001z\" />\n    </defs>\n    <g transform=\"translate(-11 -4)\" fill=\"none\" fill-rule=\"evenodd\">\n        <path fill-opacity=\"0\" fill=\"#fff\" d=\"M0 0h44v44H0z\" />\n        <g transform=\"translate(11 3)\">\n            <path d=\"M8.733 11.165c.04-1.108.766-2.027 1.743-2.307a2.54 2.54 0 0 1 .628-.089c.16 0 .314.017.463.044 1.088.2 1.9 1.092 1.9 2.16v8.88h1.26c2.943-1.39 5-4.45 5-8.025a9.01 9.01 0 0 0-1.9-5.56l-.43-.5c-.765-.838-1.683-1.522-2.712-2-1.057-.49-2.226-.77-3.46-.77s-2.4.278-3.46.77c-1.03.478-1.947 1.162-2.71 2l-.43.5a9.01 9.01 0 0 0-1.9 5.56 9.04 9.04 0 0 0 .094 1.305c.03.21.088.41.13.617l.136.624c.083.286.196.56.305.832l.124.333a8.78 8.78 0 0 0 .509.953l.065.122a8.69 8.69 0 0 0 3.521 3.191l1.11.537v-9.178z\" fill-opacity=\".5\" fill=\"#e4e4e4\" />\n            <path d=\"M22.94 26.218l-2.76 7.74c-.172.485-.676.8-1.253.8H12.24c-1.606 0-3.092-.68-3.98-1.82-1.592-2.048-3.647-3.822-6.11-5.27-.095-.055-.15-.137-.152-.23-.004-.1.046-.196.193-.297.56-.393 1.234-.6 1.926-.6a3.43 3.43 0 0 1 .691.069l4.922.994V10.972c0-.663.615-1.203 1.37-1.203s1.373.54 1.373 1.203v9.882h2.953c.273 0 .533.073.757.21l6.257 3.874c.027.017.045.042.07.06.41.296.586.77.426 1.22M4.1 16.614c-.024-.04-.042-.083-.065-.122a8.69 8.69 0 0 1-.509-.953c-.048-.107-.08-.223-.124-.333l-.305-.832c-.058-.202-.09-.416-.136-.624l-.13-.617a9.03 9.03 0 0 1-.094-1.305c0-2.107.714-4.04 1.9-5.56l.43-.5c.764-.84 1.682-1.523 2.71-2 1.058-.49 2.226-.77 3.46-.77s2.402.28 3.46.77c1.03.477 1.947 1.16 2.712 2l.428.5a9 9 0 0 1 1.901 5.559c0 3.577-2.056 6.636-5 8.026h-1.26v-8.882c0-1.067-.822-1.96-1.9-2.16-.15-.028-.304-.044-.463-.044-.22 0-.427.037-.628.09-.977.28-1.703 1.198-1.743 2.306v9.178l-1.11-.537C6.18 19.098 4.96 18 4.1 16.614M22.97 24.09l-6.256-3.874c-.102-.063-.218-.098-.33-.144 2.683-1.8 4.354-4.855 4.354-8.243 0-.486-.037-.964-.104-1.43a9.97 9.97 0 0 0-1.57-4.128l-.295-.408-.066-.092a10.05 10.05 0 0 0-.949-1.078c-.342-.334-.708-.643-1.094-.922-1.155-.834-2.492-1.412-3.94-1.65l-.732-.088-.748-.03a9.29 9.29 0 0 0-1.482.119c-1.447.238-2.786.816-3.94 1.65a9.33 9.33 0 0 0-.813.686 9.59 9.59 0 0 0-.845.877l-.385.437-.36.5-.288.468-.418.778-.04.09c-.593 1.28-.93 2.71-.93 4.222 0 3.832 2.182 7.342 5.56 8.938l1.437.68v4.946L5 25.64a4.44 4.44 0 0 0-.888-.086c-.017 0-.034.003-.05.003-.252.004-.503.033-.75.08a5.08 5.08 0 0 0-.237.056c-.193.046-.382.107-.568.18-.075.03-.15.057-.225.1-.25.114-.494.244-.723.405a1.31 1.31 0 0 0-.566 1.122 1.28 1.28 0 0 0 .645 1.051C4 29.925 5.96 31.614 7.473 33.563a5.06 5.06 0 0 0 .434.491c1.086 1.082 2.656 1.713 4.326 1.715h6.697c.748-.001 1.43-.333 1.858-.872.142-.18.256-.38.336-.602l2.757-7.74c.094-.26.13-.53.112-.794s-.088-.52-.203-.76a2.19 2.19 0 0 0-.821-.91\" fill-opacity=\".6\" fill=\"#000\" />\n            <path d=\"M22.444 24.94l-6.257-3.874a1.45 1.45 0 0 0-.757-.211h-2.953v-9.88c0-.663-.616-1.203-1.373-1.203s-1.37.54-1.37 1.203v16.643l-4.922-.994a3.44 3.44 0 0 0-.692-.069 3.35 3.35 0 0 0-1.925.598c-.147.102-.198.198-.194.298.004.094.058.176.153.23 2.462 1.448 4.517 3.22 6.11 5.27.887 1.14 2.373 1.82 3.98 1.82h6.686c.577 0 1.08-.326 1.253-.8l2.76-7.74c.16-.448-.017-.923-.426-1.22-.025-.02-.043-.043-.07-.06z\" fill=\"#fff\" />\n            <g transform=\"translate(0 .769)\">\n                <mask id=\"B\" fill=\"#fff\">\n                    <use xlink:href=\"#A\" />\n                </mask>\n                <path d=\"M23.993 24.992a1.96 1.96 0 0 1-.111.794l-2.758 7.74c-.08.22-.194.423-.336.602-.427.54-1.11.87-1.857.872h-6.698c-1.67-.002-3.24-.633-4.326-1.715-.154-.154-.3-.318-.434-.49C5.96 30.846 4 29.157 1.646 27.773c-.385-.225-.626-.618-.645-1.05a1.31 1.31 0 0 1 .566-1.122 4.56 4.56 0 0 1 .723-.405l.225-.1a4.3 4.3 0 0 1 .568-.18l.237-.056c.248-.046.5-.075.75-.08.018 0 .034-.003.05-.003.303-.001.597.027.89.086l3.722.752V20.68l-1.436-.68c-3.377-1.596-5.56-5.106-5.56-8.938 0-1.51.336-2.94.93-4.222.015-.03.025-.06.04-.09.127-.267.268-.525.418-.778.093-.16.186-.316.288-.468.063-.095.133-.186.2-.277L3.773 5c.118-.155.26-.29.385-.437.266-.3.544-.604.845-.877a9.33 9.33 0 0 1 .813-.686C6.97 2.167 8.31 1.59 9.757 1.35a9.27 9.27 0 0 1 1.481-.119 8.82 8.82 0 0 1 .748.031c.247.02.49.05.733.088 1.448.238 2.786.816 3.94 1.65.387.28.752.588 1.094.922a9.94 9.94 0 0 1 .949 1.078l.066.092c.102.133.203.268.295.408a9.97 9.97 0 0 1 1.571 4.128c.066.467.103.945.103 1.43 0 3.388-1.67 6.453-4.353 8.243.11.046.227.08.33.144l6.256 3.874c.37.23.645.55.82.9.115.24.185.498.203.76m.697-1.195c-.265-.55-.677-1.007-1.194-1.326l-5.323-3.297c2.255-2.037 3.564-4.97 3.564-8.114 0-2.19-.637-4.304-1.84-6.114-.126-.188-.26-.37-.4-.552-.645-.848-1.402-1.6-2.252-2.204C15.472.91 13.393.232 11.238.232A10.21 10.21 0 0 0 5.23 2.19c-.848.614-1.606 1.356-2.253 2.205-.136.18-.272.363-.398.55C1.374 6.756.737 8.87.737 11.06c0 4.218 2.407 8.08 6.133 9.842l.863.41v3.092l-2.525-.51c-.356-.07-.717-.106-1.076-.106a5.45 5.45 0 0 0-3.14.996c-.653.46-1.022 1.202-.99 1.983a2.28 2.28 0 0 0 1.138 1.872c2.24 1.318 4.106 2.923 5.543 4.772 1.26 1.62 3.333 2.59 5.55 2.592h6.698c1.42-.001 2.68-.86 3.134-2.138l2.76-7.74c.272-.757.224-1.584-.134-2.325\" fill-opacity=\".05\" fill=\"#000\" mask=\"url(#B)\" />\n            </g>\n        </g>\n    </g>\n</svg>"])))
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
, U(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" fill=\"#000000\">\n    <!-- NOTE(cdata): This SVG filter is a stop-gap until we can implement\n         support for dynamic re-coloring of UI components -->\n    <defs>\n      <filter id=\"drop-shadow\" x=\"-100%\" y=\"-100%\" width=\"300%\" height=\"300%\">\n        <feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"1\"/>\n        <feOffset dx=\"0\" dy=\"0\" result=\"offsetblur\"/>\n        <feFlood flood-color=\"#000000\"/>\n        <feComposite in2=\"offsetblur\" operator=\"in\"/>\n        <feMerge>\n          <feMergeNode/>\n          <feMergeNode in=\"SourceGraphic\"/>\n        </feMerge>\n      </filter>\n    </defs>\n    <path filter=\"url(#drop-shadow)\" d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"/>\n    <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n</svg>"])))
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
),
    bh = new WeakMap();

function wh() {
  var t, e;

  function n(t, e, n, i, r, s) {
    var a = s.num_components(),
        o = n.num_points() * a,
        l = o * r.BYTES_PER_ELEMENT,
        h = function (t, e) {
      switch (e) {
        case Float32Array:
          return t.DT_FLOAT32;

        case Int8Array:
          return t.DT_INT8;

        case Int16Array:
          return t.DT_INT16;

        case Int32Array:
          return t.DT_INT32;

        case Uint8Array:
          return t.DT_UINT8;

        case Uint16Array:
          return t.DT_UINT16;

        case Uint32Array:
          return t.DT_UINT32;
      }
    }(t, r),
        c = t._malloc(l);

    e.GetAttributeDataArrayForAllPoints(n, s, h, l, c);
    var u = new r(t.HEAPF32.buffer, c, o).slice();
    return t._free(c), {
      name: i,
      array: u,
      itemSize: a
    };
  }

  onmessage = function onmessage(i) {
    var r = i.data;

    switch (r.type) {
      case "init":
        t = r.decoderConfig, e = new Promise(function (e) {
          t.onModuleLoaded = function (t) {
            e({
              draco: t
            });
          }, DracoDecoderModule(t);
        });
        break;

      case "decode":
        var _i189 = r.buffer,
            _s78 = r.taskConfig;
        e.then(function (t) {
          var e = t.draco,
              a = new e.Decoder(),
              o = new e.DecoderBuffer();
          o.Init(new Int8Array(_i189), _i189.byteLength);

          try {
            var _t296 = function (t, e, i, r) {
              var s = r.attributeIDs,
                  a = r.attributeTypes;
              var o, l;
              var h = e.GetEncodedGeometryType(i);
              if (h === t.TRIANGULAR_MESH) o = new t.Mesh(), l = e.DecodeBufferToMesh(i, o);else {
                if (h !== t.POINT_CLOUD) throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
                o = new t.PointCloud(), l = e.DecodeBufferToPointCloud(i, o);
              }
              if (!l.ok() || 0 === o.ptr) throw new Error("THREE.DRACOLoader: Decoding failed: " + l.error_msg());
              var c = {
                index: null,
                attributes: []
              };

              for (var _i191 in s) {
                var _l34 = self[a[_i191]];

                var _h22 = void 0,
                    _u15 = void 0;

                if (r.useUniqueIDs) _u15 = s[_i191], _h22 = e.GetAttributeByUniqueId(o, _u15);else {
                  if (_u15 = e.GetAttributeId(o, t[s[_i191]]), -1 === _u15) continue;
                  _h22 = e.GetAttribute(o, _u15);
                }
                c.attributes.push(n(t, e, o, _i191, _l34, _h22));
              }

              h === t.TRIANGULAR_MESH && (c.index = function (t, e, n) {
                var i = 3 * n.num_faces(),
                    r = 4 * i,
                    s = t._malloc(r);

                e.GetTrianglesUInt32Array(n, r, s);
                var a = new Uint32Array(t.HEAPF32.buffer, s, i).slice();
                return t._free(s), {
                  array: a,
                  itemSize: 1
                };
              }(t, e, o));
              return t.destroy(o), c;
            }(e, a, o, _s78),
                _i190 = _t296.attributes.map(function (t) {
              return t.array.buffer;
            });

            _t296.index && _i190.push(_t296.index.array.buffer), self.postMessage({
              type: "decode",
              id: r.id,
              geometry: _t296
            }, _i190);
          } catch (t) {
            console.error(t), self.postMessage({
              type: "error",
              id: r.id,
              error: t.message
            });
          } finally {
            e.destroy(o), e.destroy(a);
          }
        });
    }
  };
}

var Mh = /*#__PURE__*/function (_ol8) {
  _inherits(Mh, _ol8);

  var _super116 = _createSuper(Mh);

  function Mh(t) {
    var _this102;

    _classCallCheck(this, Mh);

    _this102 = _super116.call(this, t), _this102.dracoLoader = null, _this102.ktx2Loader = null, _this102.meshoptDecoder = null, _this102.pluginCallbacks = [], _this102.register(function (t) {
      return new Rh(t);
    }), _this102.register(function (t) {
      return new Oh(t);
    }), _this102.register(function (t) {
      return new Nh(t);
    }), _this102.register(function (t) {
      return new Ch(t);
    }), _this102.register(function (t) {
      return new Lh(t);
    }), _this102.register(function (t) {
      return new Ph(t);
    }), _this102.register(function (t) {
      return new Dh(t);
    }), _this102.register(function (t) {
      return new Ih(t);
    }), _this102.register(function (t) {
      return new Eh(t);
    }), _this102.register(function (t) {
      return new Fh(t);
    });
    return _this102;
  }

  _createClass(Mh, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = this;
      var s;
      s = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : Ll.extractUrlBase(t), this.manager.itemStart(t);

      var a = function a(e) {
        i ? i(e) : console.error(e), r.manager.itemError(t), r.manager.itemEnd(t);
      },
          o = new hl(this.manager);

      o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(t, function (n) {
        try {
          r.parse(n, s, function (n) {
            e(n), r.manager.itemEnd(t);
          }, a);
        } catch (t) {
          a(t);
        }
      }, n, a);
    }
  }, {
    key: "setDRACOLoader",
    value: function setDRACOLoader(t) {
      return this.dracoLoader = t, this;
    }
  }, {
    key: "setDDSLoader",
    value: function setDDSLoader() {
      throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
  }, {
    key: "setKTX2Loader",
    value: function setKTX2Loader(t) {
      return this.ktx2Loader = t, this;
    }
  }, {
    key: "setMeshoptDecoder",
    value: function setMeshoptDecoder(t) {
      return this.meshoptDecoder = t, this;
    }
  }, {
    key: "register",
    value: function register(t) {
      return -1 === this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.push(t), this;
    }
  }, {
    key: "unregister",
    value: function unregister(t) {
      return -1 !== this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t), 1), this;
    }
  }, {
    key: "parse",
    value: function parse(t, e, n, i) {
      var r;
      var s = {},
          a = {};
      if ("string" == typeof t) r = t;else {
        if (Ll.decodeText(new Uint8Array(t, 0, 4)) === Uh) {
          try {
            s[Th.KHR_BINARY_GLTF] = new zh(t);
          } catch (t) {
            return void (i && i(t));
          }

          r = s[Th.KHR_BINARY_GLTF].content;
        } else r = Ll.decodeText(new Uint8Array(t));
      }
      var o = JSON.parse(r);
      if (void 0 === o.asset || o.asset.version[0] < 2) return void (i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
      var l = new xc(o, {
        path: e || this.resourcePath || "",
        crossOrigin: this.crossOrigin,
        requestHeader: this.requestHeader,
        manager: this.manager,
        ktx2Loader: this.ktx2Loader,
        meshoptDecoder: this.meshoptDecoder
      });
      l.fileLoader.setRequestHeader(this.requestHeader);

      for (var _t297 = 0; _t297 < this.pluginCallbacks.length; _t297++) {
        var _e256 = this.pluginCallbacks[_t297](l);

        a[_e256.name] = _e256, s[_e256.name] = !0;
      }

      if (o.extensionsUsed) for (var _t298 = 0; _t298 < o.extensionsUsed.length; ++_t298) {
        var _e257 = o.extensionsUsed[_t298],
            _n242 = o.extensionsRequired || [];

        switch (_e257) {
          case Th.KHR_MATERIALS_UNLIT:
            s[_e257] = new Ah();
            break;

          case Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
            s[_e257] = new Wh();
            break;

          case Th.KHR_DRACO_MESH_COMPRESSION:
            s[_e257] = new Hh(o, this.dracoLoader);
            break;

          case Th.KHR_TEXTURE_TRANSFORM:
            s[_e257] = new Vh();
            break;

          case Th.KHR_MESH_QUANTIZATION:
            s[_e257] = new jh();
            break;

          default:
            _n242.indexOf(_e257) >= 0 && void 0 === a[_e257] && console.warn('THREE.GLTFLoader: Unknown extension "' + _e257 + '".');
        }
      }
      l.setExtensions(s), l.setPlugins(a), l.parse(n, i);
    }
  }, {
    key: "parseAsync",
    value: function parseAsync(t, e) {
      var n = this;
      return new Promise(function (i, r) {
        n.parse(t, e, i, r);
      });
    }
  }]);

  return Mh;
}(ol);

function Sh() {
  var t = {};
  return {
    get: function get(e) {
      return t[e];
    },
    add: function add(e, n) {
      t[e] = n;
    },
    remove: function remove(e) {
      delete t[e];
    },
    removeAll: function removeAll() {
      t = {};
    }
  };
}

var Th = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS: "KHR_materials_pbrSpecularGlossiness",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression"
};

var Eh = /*#__PURE__*/function () {
  function Eh(t) {
    _classCallCheck(this, Eh);

    this.parser = t, this.name = Th.KHR_LIGHTS_PUNCTUAL, this.cache = {
      refs: {},
      uses: {}
    };
  }

  _createClass(Eh, [{
    key: "_markDefs",
    value: function _markDefs() {
      var t = this.parser,
          e = this.parser.json.nodes || [];

      for (var _n243 = 0, _i192 = e.length; _n243 < _i192; _n243++) {
        var _i193 = e[_n243];
        _i193.extensions && _i193.extensions[this.name] && void 0 !== _i193.extensions[this.name].light && t._addNodeRef(this.cache, _i193.extensions[this.name].light);
      }
    }
  }, {
    key: "_loadLight",
    value: function _loadLight(t) {
      var e = this.parser,
          n = "light:" + t;
      var i = e.cache.get(n);
      if (i) return i;
      var r = e.json,
          s = ((r.extensions && r.extensions[this.name] || {}).lights || [])[t];
      var a;
      var o = new Rt(16777215);
      void 0 !== s.color && o.fromArray(s.color);
      var l = void 0 !== s.range ? s.range : 0;

      switch (s.type) {
        case "directional":
          a = new Al(o), a.target.position.set(0, 0, -1), a.add(a.target);
          break;

        case "point":
          a = new Tl(o), a.distance = l;
          break;

        case "spot":
          a = new _l(o), a.distance = l, s.spot = s.spot || {}, s.spot.innerConeAngle = void 0 !== s.spot.innerConeAngle ? s.spot.innerConeAngle : 0, s.spot.outerConeAngle = void 0 !== s.spot.outerConeAngle ? s.spot.outerConeAngle : Math.PI / 4, a.angle = s.spot.outerConeAngle, a.penumbra = 1 - s.spot.innerConeAngle / s.spot.outerConeAngle, a.target.position.set(0, 0, -1), a.add(a.target);
          break;

        default:
          throw new Error("THREE.GLTFLoader: Unexpected light type: " + s.type);
      }

      return a.position.set(0, 0, 0), a.decay = 2, void 0 !== s.intensity && (a.intensity = s.intensity), a.name = e.createUniqueName(s.name || "light_" + t), i = Promise.resolve(a), e.cache.add(n, i), i;
    }
  }, {
    key: "createNodeAttachment",
    value: function createNodeAttachment(t) {
      var e = this,
          n = this.parser,
          i = n.json.nodes[t],
          r = (i.extensions && i.extensions[this.name] || {}).light;
      return void 0 === r ? null : this._loadLight(r).then(function (t) {
        return n._getNodeRef(e.cache, r, t);
      });
    }
  }]);

  return Eh;
}();

var Ah = /*#__PURE__*/function () {
  function Ah() {
    _classCallCheck(this, Ah);

    this.name = Th.KHR_MATERIALS_UNLIT;
  }

  _createClass(Ah, [{
    key: "getMaterialType",
    value: function getMaterialType() {
      return nn;
    }
  }, {
    key: "extendParams",
    value: function extendParams(t, e, n) {
      var i = [];
      t.color = new Rt(1, 1, 1), t.opacity = 1;
      var r = e.pbrMetallicRoughness;

      if (r) {
        if (Array.isArray(r.baseColorFactor)) {
          var _e258 = r.baseColorFactor;
          t.color.fromArray(_e258), t.opacity = _e258[3];
        }

        void 0 !== r.baseColorTexture && i.push(n.assignTexture(t, "map", r.baseColorTexture, 3001));
      }

      return Promise.all(i);
    }
  }]);

  return Ah;
}();

var Rh = /*#__PURE__*/function () {
  function Rh(t) {
    _classCallCheck(this, Rh);

    this.parser = t, this.name = Th.KHR_MATERIALS_CLEARCOAT;
  }

  _createClass(Rh, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Fo : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];

      if (void 0 !== s.clearcoatFactor && (e.clearcoat = s.clearcoatFactor), void 0 !== s.clearcoatTexture && r.push(n.assignTexture(e, "clearcoatMap", s.clearcoatTexture)), void 0 !== s.clearcoatRoughnessFactor && (e.clearcoatRoughness = s.clearcoatRoughnessFactor), void 0 !== s.clearcoatRoughnessTexture && r.push(n.assignTexture(e, "clearcoatRoughnessMap", s.clearcoatRoughnessTexture)), void 0 !== s.clearcoatNormalTexture && (r.push(n.assignTexture(e, "clearcoatNormalMap", s.clearcoatNormalTexture)), void 0 !== s.clearcoatNormalTexture.scale)) {
        var _t299 = s.clearcoatNormalTexture.scale;
        e.clearcoatNormalScale = new mt(_t299, _t299);
      }

      return Promise.all(r);
    }
  }]);

  return Rh;
}();

var Ch = /*#__PURE__*/function () {
  function Ch(t) {
    _classCallCheck(this, Ch);

    this.parser = t, this.name = Th.KHR_MATERIALS_SHEEN;
  }

  _createClass(Ch, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Fo : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [];
      e.sheenColor = new Rt(0, 0, 0), e.sheenRoughness = 0, e.sheen = 1;
      var s = i.extensions[this.name];
      return void 0 !== s.sheenColorFactor && e.sheenColor.fromArray(s.sheenColorFactor), void 0 !== s.sheenRoughnessFactor && (e.sheenRoughness = s.sheenRoughnessFactor), void 0 !== s.sheenColorTexture && r.push(n.assignTexture(e, "sheenColorMap", s.sheenColorTexture, 3001)), void 0 !== s.sheenRoughnessTexture && r.push(n.assignTexture(e, "sheenRoughnessMap", s.sheenRoughnessTexture)), Promise.all(r);
    }
  }]);

  return Ch;
}();

var Lh = /*#__PURE__*/function () {
  function Lh(t) {
    _classCallCheck(this, Lh);

    this.parser = t, this.name = Th.KHR_MATERIALS_TRANSMISSION;
  }

  _createClass(Lh, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Fo : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];
      return void 0 !== s.transmissionFactor && (e.transmission = s.transmissionFactor), void 0 !== s.transmissionTexture && r.push(n.assignTexture(e, "transmissionMap", s.transmissionTexture)), Promise.all(r);
    }
  }]);

  return Lh;
}();

var Ph = /*#__PURE__*/function () {
  function Ph(t) {
    _classCallCheck(this, Ph);

    this.parser = t, this.name = Th.KHR_MATERIALS_VOLUME;
  }

  _createClass(Ph, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Fo : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];
      e.thickness = void 0 !== s.thicknessFactor ? s.thicknessFactor : 0, void 0 !== s.thicknessTexture && r.push(n.assignTexture(e, "thicknessMap", s.thicknessTexture)), e.attenuationDistance = s.attenuationDistance || 0;
      var a = s.attenuationColor || [1, 1, 1];
      return e.attenuationColor = new Rt(a[0], a[1], a[2]), Promise.all(r);
    }
  }]);

  return Ph;
}();

var Dh = /*#__PURE__*/function () {
  function Dh(t) {
    _classCallCheck(this, Dh);

    this.parser = t, this.name = Th.KHR_MATERIALS_IOR;
  }

  _createClass(Dh, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Fo : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser.json.materials[t];
      if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
      var i = n.extensions[this.name];
      return e.ior = void 0 !== i.ior ? i.ior : 1.5, Promise.resolve();
    }
  }]);

  return Dh;
}();

var Ih = /*#__PURE__*/function () {
  function Ih(t) {
    _classCallCheck(this, Ih);

    this.parser = t, this.name = Th.KHR_MATERIALS_SPECULAR;
  }

  _createClass(Ih, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Fo : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];
      e.specularIntensity = void 0 !== s.specularFactor ? s.specularFactor : 1, void 0 !== s.specularTexture && r.push(n.assignTexture(e, "specularIntensityMap", s.specularTexture));
      var a = s.specularColorFactor || [1, 1, 1];
      return e.specularColor = new Rt(a[0], a[1], a[2]), void 0 !== s.specularColorTexture && r.push(n.assignTexture(e, "specularColorMap", s.specularColorTexture, 3001)), Promise.all(r);
    }
  }]);

  return Ih;
}();

var Oh = /*#__PURE__*/function () {
  function Oh(t) {
    _classCallCheck(this, Oh);

    this.parser = t, this.name = Th.KHR_TEXTURE_BASISU;
  }

  _createClass(Oh, [{
    key: "loadTexture",
    value: function loadTexture(t) {
      var e = this.parser,
          n = e.json,
          i = n.textures[t];
      if (!i.extensions || !i.extensions[this.name]) return null;
      var r = i.extensions[this.name],
          s = e.options.ktx2Loader;

      if (!s) {
        if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
        return null;
      }

      return e.loadTextureImage(t, r.source, s);
    }
  }]);

  return Oh;
}();

var Nh = /*#__PURE__*/function () {
  function Nh(t) {
    _classCallCheck(this, Nh);

    this.parser = t, this.name = Th.EXT_TEXTURE_WEBP, this.isSupported = null;
  }

  _createClass(Nh, [{
    key: "loadTexture",
    value: function loadTexture(t) {
      var e = this.name,
          n = this.parser,
          i = n.json,
          r = i.textures[t];
      if (!r.extensions || !r.extensions[e]) return null;
      var s = r.extensions[e],
          a = i.images[s.source];
      var o = n.textureLoader;

      if (a.uri) {
        var _t300 = n.options.manager.getHandler(a.uri);

        null !== _t300 && (o = _t300);
      }

      return this.detectSupport().then(function (r) {
        if (r) return n.loadTextureImage(t, s.source, o);
        if (i.extensionsRequired && i.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
        return n.loadTexture(t);
      });
    }
  }, {
    key: "detectSupport",
    value: function detectSupport() {
      return this.isSupported || (this.isSupported = new Promise(function (t) {
        var e = new Image();
        e.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", e.onload = e.onerror = function () {
          t(1 === e.height);
        };
      })), this.isSupported;
    }
  }]);

  return Nh;
}();

var Fh = /*#__PURE__*/function () {
  function Fh(t) {
    _classCallCheck(this, Fh);

    this.name = Th.EXT_MESHOPT_COMPRESSION, this.parser = t;
  }

  _createClass(Fh, [{
    key: "loadBufferView",
    value: function loadBufferView(t) {
      var e = this.parser.json,
          n = e.bufferViews[t];

      if (n.extensions && n.extensions[this.name]) {
        var _t301 = n.extensions[this.name],
            _i194 = this.parser.getDependency("buffer", _t301.buffer),
            _r134 = this.parser.options.meshoptDecoder;

        if (!_r134 || !_r134.supported) {
          if (e.extensionsRequired && e.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
          return null;
        }

        return Promise.all([_i194, _r134.ready]).then(function (e) {
          var n = _t301.byteOffset || 0,
              i = _t301.byteLength || 0,
              s = _t301.count,
              a = _t301.byteStride,
              o = new ArrayBuffer(s * a),
              l = new Uint8Array(e[0], n, i);
          return _r134.decodeGltfBuffer(new Uint8Array(o), s, a, l, _t301.mode, _t301.filter), o;
        });
      }

      return null;
    }
  }]);

  return Fh;
}();

var Uh = "glTF",
    kh = 1313821514,
    Bh = 5130562;

var zh = function zh(t) {
  _classCallCheck(this, zh);

  this.name = Th.KHR_BINARY_GLTF, this.content = null, this.body = null;
  var e = new DataView(t, 0, 12);
  if (this.header = {
    magic: Ll.decodeText(new Uint8Array(t.slice(0, 4))),
    version: e.getUint32(4, !0),
    length: e.getUint32(8, !0)
  }, this.header.magic !== Uh) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
  if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
  var n = this.header.length - 12,
      i = new DataView(t, 12);
  var r = 0;

  for (; r < n;) {
    var _e259 = i.getUint32(r, !0);

    r += 4;

    var _n244 = i.getUint32(r, !0);

    if (r += 4, _n244 === kh) {
      var _n245 = new Uint8Array(t, 12 + r, _e259);

      this.content = Ll.decodeText(_n245);
    } else if (_n244 === Bh) {
      var _n246 = 12 + r;

      this.body = t.slice(_n246, _n246 + _e259);
    }

    r += _e259;
  }

  if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
};

var Hh = /*#__PURE__*/function () {
  function Hh(t, e) {
    _classCallCheck(this, Hh);

    if (!e) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    this.name = Th.KHR_DRACO_MESH_COMPRESSION, this.json = t, this.dracoLoader = e, this.dracoLoader.preload();
  }

  _createClass(Hh, [{
    key: "decodePrimitive",
    value: function decodePrimitive(t, e) {
      var n = this.json,
          i = this.dracoLoader,
          r = t.extensions[this.name].bufferView,
          s = t.extensions[this.name].attributes,
          a = {},
          o = {},
          l = {};

      for (var _t302 in s) {
        var _e260 = ac[_t302] || _t302.toLowerCase();

        a[_e260] = s[_t302];
      }

      for (var _e261 in t.attributes) {
        var _i195 = ac[_e261] || _e261.toLowerCase();

        if (void 0 !== s[_e261]) {
          var _r135 = n.accessors[t.attributes[_e261]],
              _s79 = nc[_r135.componentType];
          l[_i195] = _s79, o[_i195] = !0 === _r135.normalized;
        }
      }

      return e.getDependency("bufferView", r).then(function (t) {
        return new Promise(function (e) {
          i.decodeDracoFile(t, function (t) {
            for (var _e262 in t.attributes) {
              var _n247 = t.attributes[_e262],
                  _i196 = o[_e262];
              void 0 !== _i196 && (_n247.normalized = _i196);
            }

            e(t);
          }, a, l);
        });
      });
    }
  }]);

  return Hh;
}();

var Vh = /*#__PURE__*/function () {
  function Vh() {
    _classCallCheck(this, Vh);

    this.name = Th.KHR_TEXTURE_TRANSFORM;
  }

  _createClass(Vh, [{
    key: "extendTexture",
    value: function extendTexture(t, e) {
      return void 0 !== e.texCoord && console.warn('THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.'), void 0 === e.offset && void 0 === e.rotation && void 0 === e.scale || (t = t.clone(), void 0 !== e.offset && t.offset.fromArray(e.offset), void 0 !== e.rotation && (t.rotation = e.rotation), void 0 !== e.scale && t.repeat.fromArray(e.scale), t.needsUpdate = !0), t;
    }
  }]);

  return Vh;
}();

var Gh = /*#__PURE__*/function (_No2) {
  _inherits(Gh, _No2);

  var _super117 = _createSuper(Gh);

  function Gh(t) {
    var _this103;

    _classCallCheck(this, Gh);

    _this103 = _super117.call(this), _this103.isGLTFSpecularGlossinessMaterial = !0;
    var e = ["#ifdef USE_SPECULARMAP", "\tuniform sampler2D specularMap;", "#endif"].join("\n"),
        n = ["#ifdef USE_GLOSSINESSMAP", "\tuniform sampler2D glossinessMap;", "#endif"].join("\n"),
        i = ["vec3 specularFactor = specular;", "#ifdef USE_SPECULARMAP", "\tvec4 texelSpecular = texture2D( specularMap, vUv );", "\t// reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture", "\tspecularFactor *= texelSpecular.rgb;", "#endif"].join("\n"),
        r = ["float glossinessFactor = glossiness;", "#ifdef USE_GLOSSINESSMAP", "\tvec4 texelGlossiness = texture2D( glossinessMap, vUv );", "\t// reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture", "\tglossinessFactor *= texelGlossiness.a;", "#endif"].join("\n"),
        s = ["PhysicalMaterial material;", "material.diffuseColor = diffuseColor.rgb * ( 1. - max( specularFactor.r, max( specularFactor.g, specularFactor.b ) ) );", "vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );", "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );", "material.roughness = max( 1.0 - glossinessFactor, 0.0525 ); // 0.0525 corresponds to the base mip of a 256 cubemap.", "material.roughness += geometryRoughness;", "material.roughness = min( material.roughness, 1.0 );", "material.specularColor = specularFactor;"].join("\n"),
        a = {
      specular: {
        value: new Rt().setHex(16777215)
      },
      glossiness: {
        value: 1
      },
      specularMap: {
        value: null
      },
      glossinessMap: {
        value: null
      }
    };
    _this103._extraUniforms = a, _this103.onBeforeCompile = function (t) {
      for (var _e263 in a) {
        t.uniforms[_e263] = a[_e263];
      }

      t.fragmentShader = t.fragmentShader.replace("uniform float roughness;", "uniform vec3 specular;").replace("uniform float metalness;", "uniform float glossiness;").replace("#include <roughnessmap_pars_fragment>", e).replace("#include <metalnessmap_pars_fragment>", n).replace("#include <roughnessmap_fragment>", i).replace("#include <metalnessmap_fragment>", r).replace("#include <lights_physical_fragment>", s);
    }, Object.defineProperties(_assertThisInitialized(_this103), {
      specular: {
        get: function get() {
          return a.specular.value;
        },
        set: function set(t) {
          a.specular.value = t;
        }
      },
      specularMap: {
        get: function get() {
          return a.specularMap.value;
        },
        set: function set(t) {
          a.specularMap.value = t, t ? this.defines.USE_SPECULARMAP = "" : delete this.defines.USE_SPECULARMAP;
        }
      },
      glossiness: {
        get: function get() {
          return a.glossiness.value;
        },
        set: function set(t) {
          a.glossiness.value = t;
        }
      },
      glossinessMap: {
        get: function get() {
          return a.glossinessMap.value;
        },
        set: function set(t) {
          a.glossinessMap.value = t, t ? (this.defines.USE_GLOSSINESSMAP = "", this.defines.USE_UV = "") : (delete this.defines.USE_GLOSSINESSMAP, delete this.defines.USE_UV);
        }
      }
    }), delete _this103.metalness, delete _this103.roughness, delete _this103.metalnessMap, delete _this103.roughnessMap, _this103.setValues(t);
    return _this103;
  }

  _createClass(Gh, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Gh.prototype), "copy", this).call(this, t), this.specularMap = t.specularMap, this.specular.copy(t.specular), this.glossinessMap = t.glossinessMap, this.glossiness = t.glossiness, delete this.metalness, delete this.roughness, delete this.metalnessMap, delete this.roughnessMap, this;
    }
  }]);

  return Gh;
}(No);

var Wh = /*#__PURE__*/function () {
  function Wh() {
    _classCallCheck(this, Wh);

    this.name = Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS, this.specularGlossinessParams = ["color", "map", "lightMap", "lightMapIntensity", "aoMap", "aoMapIntensity", "emissive", "emissiveIntensity", "emissiveMap", "bumpMap", "bumpScale", "normalMap", "normalMapType", "displacementMap", "displacementScale", "displacementBias", "specularMap", "specular", "glossinessMap", "glossiness", "alphaMap", "envMap", "envMapIntensity"];
  }

  _createClass(Wh, [{
    key: "getMaterialType",
    value: function getMaterialType() {
      return Gh;
    }
  }, {
    key: "extendParams",
    value: function extendParams(t, e, n) {
      var i = e.extensions[this.name];
      t.color = new Rt(1, 1, 1), t.opacity = 1;
      var r = [];

      if (Array.isArray(i.diffuseFactor)) {
        var _e264 = i.diffuseFactor;
        t.color.fromArray(_e264), t.opacity = _e264[3];
      }

      if (void 0 !== i.diffuseTexture && r.push(n.assignTexture(t, "map", i.diffuseTexture, 3001)), t.emissive = new Rt(0, 0, 0), t.glossiness = void 0 !== i.glossinessFactor ? i.glossinessFactor : 1, t.specular = new Rt(1, 1, 1), Array.isArray(i.specularFactor) && t.specular.fromArray(i.specularFactor), void 0 !== i.specularGlossinessTexture) {
        var _e265 = i.specularGlossinessTexture;
        r.push(n.assignTexture(t, "glossinessMap", _e265)), r.push(n.assignTexture(t, "specularMap", _e265, 3001));
      }

      return Promise.all(r);
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(t) {
      var e = new Gh(t);
      return e.fog = !0, e.color = t.color, e.map = void 0 === t.map ? null : t.map, e.lightMap = null, e.lightMapIntensity = 1, e.aoMap = void 0 === t.aoMap ? null : t.aoMap, e.aoMapIntensity = 1, e.emissive = t.emissive, e.emissiveIntensity = 1, e.emissiveMap = void 0 === t.emissiveMap ? null : t.emissiveMap, e.bumpMap = void 0 === t.bumpMap ? null : t.bumpMap, e.bumpScale = 1, e.normalMap = void 0 === t.normalMap ? null : t.normalMap, e.normalMapType = 0, t.normalScale && (e.normalScale = t.normalScale), e.displacementMap = null, e.displacementScale = 1, e.displacementBias = 0, e.specularMap = void 0 === t.specularMap ? null : t.specularMap, e.specular = t.specular, e.glossinessMap = void 0 === t.glossinessMap ? null : t.glossinessMap, e.glossiness = t.glossiness, e.alphaMap = null, e.envMap = void 0 === t.envMap ? null : t.envMap, e.envMapIntensity = 1, e;
    }
  }]);

  return Wh;
}();

var jh = function jh() {
  _classCallCheck(this, jh);

  this.name = Th.KHR_MESH_QUANTIZATION;
};

var qh = /*#__PURE__*/function (_jo5) {
  _inherits(qh, _jo5);

  var _super118 = _createSuper(qh);

  function qh(t, e, n, i) {
    _classCallCheck(this, qh);

    return _super118.call(this, t, e, n, i);
  }

  _createClass(qh, [{
    key: "copySampleValue_",
    value: function copySampleValue_(t) {
      var e = this.resultBuffer,
          n = this.sampleValues,
          i = this.valueSize,
          r = t * i * 3 + i;

      for (var _t303 = 0; _t303 !== i; _t303++) {
        e[_t303] = n[r + _t303];
      }

      return e;
    }
  }]);

  return qh;
}(jo);

qh.prototype.beforeStart_ = qh.prototype.copySampleValue_, qh.prototype.afterEnd_ = qh.prototype.copySampleValue_, qh.prototype.interpolate_ = function (t, e, n, i) {
  var r = this.resultBuffer,
      s = this.sampleValues,
      a = this.valueSize,
      o = 2 * a,
      l = 3 * a,
      h = i - e,
      c = (n - e) / h,
      u = c * c,
      d = u * c,
      p = t * l,
      m = p - l,
      f = -2 * d + 3 * u,
      g = d - u,
      v = 1 - f,
      y = g - u + c;

  for (var _t304 = 0; _t304 !== a; _t304++) {
    var _e266 = s[m + _t304 + a],
        _n248 = s[m + _t304 + o] * h,
        _i197 = s[p + _t304 + a],
        _l35 = s[p + _t304] * h;

    r[_t304] = v * _e266 + y * _n248 + f * _i197 + g * _l35;
  }

  return r;
};
var Xh = new Bt();

var Yh = /*#__PURE__*/function (_qh) {
  _inherits(Yh, _qh);

  var _super119 = _createSuper(Yh);

  function Yh() {
    _classCallCheck(this, Yh);

    return _super119.apply(this, arguments);
  }

  _createClass(Yh, [{
    key: "interpolate_",
    value: function interpolate_(t, e, n, i) {
      var r = _get(_getPrototypeOf(Yh.prototype), "interpolate_", this).call(this, t, e, n, i);

      return Xh.fromArray(r).normalize().toArray(r), r;
    }
  }]);

  return Yh;
}(qh);

var Jh = 0,
    Zh = 1,
    $h = 2,
    Kh = 3,
    Qh = 4,
    tc = 5,
    ec = 6,
    nc = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
},
    ic = {
  9728: 1003,
  9729: 1006,
  9984: 1004,
  9985: 1007,
  9986: 1005,
  9987: 1008
},
    rc = {
  33071: 1001,
  33648: 1002,
  10497: 1e3
},
    sc = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
},
    ac = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv2",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
},
    oc = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
},
    lc = {
  CUBICSPLINE: void 0,
  LINEAR: 2301,
  STEP: 2300
},
    hc = "OPAQUE",
    cc = "MASK",
    uc = "BLEND";

function dc(t) {
  return void 0 === t.DefaultMaterial && (t.DefaultMaterial = new No({
    color: 16777215,
    emissive: 0,
    metalness: 1,
    roughness: 1,
    transparent: !1,
    depthTest: !0,
    side: 0
  })), t.DefaultMaterial;
}

function pc(t, e, n) {
  for (var _i198 in n.extensions) {
    void 0 === t[_i198] && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[_i198] = n.extensions[_i198]);
  }
}

function mc(t, e) {
  void 0 !== e.extras && ("object" == typeof e.extras ? Object.assign(t.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}

function fc(t, e) {
  if (t.updateMorphTargets(), void 0 !== e.weights) for (var _n249 = 0, _i199 = e.weights.length; _n249 < _i199; _n249++) {
    t.morphTargetInfluences[_n249] = e.weights[_n249];
  }

  if (e.extras && Array.isArray(e.extras.targetNames)) {
    var _n250 = e.extras.targetNames;

    if (t.morphTargetInfluences.length === _n250.length) {
      t.morphTargetDictionary = {};

      for (var _e267 = 0, _i200 = _n250.length; _e267 < _i200; _e267++) {
        t.morphTargetDictionary[_n250[_e267]] = _e267;
      }
    } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
  }
}

function gc(t) {
  var e = t.extensions && t.extensions[Th.KHR_DRACO_MESH_COMPRESSION];
  var n;
  return n = e ? "draco:" + e.bufferView + ":" + e.indices + ":" + vc(e.attributes) : t.indices + ":" + vc(t.attributes) + ":" + t.mode, n;
}

function vc(t) {
  var e = "";
  var n = Object.keys(t).sort();

  for (var _i201 = 0, _r136 = n.length; _i201 < _r136; _i201++) {
    e += n[_i201] + ":" + t[n[_i201]] + ";";
  }

  return e;
}

function yc(t) {
  switch (t) {
    case Int8Array:
      return 1 / 127;

    case Uint8Array:
      return 1 / 255;

    case Int16Array:
      return 1 / 32767;

    case Uint16Array:
      return 1 / 65535;

    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}

var xc = /*#__PURE__*/function () {
  function xc() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, xc);

    this.json = t, this.extensions = {}, this.plugins = {}, this.options = e, this.cache = new Sh(), this.associations = new Map(), this.primitiveCache = {}, this.meshCache = {
      refs: {},
      uses: {}
    }, this.cameraCache = {
      refs: {},
      uses: {}
    }, this.lightCache = {
      refs: {},
      uses: {}
    }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {}, "undefined" != typeof createImageBitmap && !1 === /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? this.textureLoader = new Pl(this.options.manager) : this.textureLoader = new pl(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new hl(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
  }

  _createClass(xc, [{
    key: "setExtensions",
    value: function setExtensions(t) {
      this.extensions = t;
    }
  }, {
    key: "setPlugins",
    value: function setPlugins(t) {
      this.plugins = t;
    }
  }, {
    key: "parse",
    value: function parse(t, e) {
      var n = this,
          i = this.json,
          r = this.extensions;
      this.cache.removeAll(), this._invokeAll(function (t) {
        return t._markDefs && t._markDefs();
      }), Promise.all(this._invokeAll(function (t) {
        return t.beforeRoot && t.beforeRoot();
      })).then(function () {
        return Promise.all([n.getDependencies("scene"), n.getDependencies("animation"), n.getDependencies("camera")]);
      }).then(function (e) {
        var s = {
          scene: e[0][i.scene || 0],
          scenes: e[0],
          animations: e[1],
          cameras: e[2],
          asset: i.asset,
          parser: n,
          userData: {}
        };
        pc(r, s, i), mc(s, i), Promise.all(n._invokeAll(function (t) {
          return t.afterRoot && t.afterRoot(s);
        })).then(function () {
          t(s);
        });
      }).catch(e);
    }
  }, {
    key: "_markDefs",
    value: function _markDefs() {
      var t = this.json.nodes || [],
          e = this.json.skins || [],
          n = this.json.meshes || [];

      for (var _n251 = 0, _i202 = e.length; _n251 < _i202; _n251++) {
        var _i203 = e[_n251].joints;

        for (var _e268 = 0, _n252 = _i203.length; _e268 < _n252; _e268++) {
          t[_i203[_e268]].isBone = !0;
        }
      }

      for (var _e269 = 0, _i204 = t.length; _e269 < _i204; _e269++) {
        var _i205 = t[_e269];
        void 0 !== _i205.mesh && (this._addNodeRef(this.meshCache, _i205.mesh), void 0 !== _i205.skin && (n[_i205.mesh].isSkinnedMesh = !0)), void 0 !== _i205.camera && this._addNodeRef(this.cameraCache, _i205.camera);
      }
    }
  }, {
    key: "_addNodeRef",
    value: function _addNodeRef(t, e) {
      void 0 !== e && (void 0 === t.refs[e] && (t.refs[e] = t.uses[e] = 0), t.refs[e]++);
    }
  }, {
    key: "_getNodeRef",
    value: function _getNodeRef(t, e, n) {
      var _this104 = this;

      if (t.refs[e] <= 1) return n;

      var i = n.clone(),
          r = function r(t, e) {
        var n = _this104.associations.get(t);

        null != n && _this104.associations.set(e, n);

        var _iterator8 = _createForOfIteratorHelper(t.children.entries()),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _step8$value = _slicedToArray(_step8.value, 2),
                _n253 = _step8$value[0],
                _i206 = _step8$value[1];

            r(_i206, e.children[_n253]);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      };

      return r(n, i), i.name += "_instance_" + t.uses[e]++, i;
    }
  }, {
    key: "_invokeOne",
    value: function _invokeOne(t) {
      var e = Object.values(this.plugins);
      e.push(this);

      for (var _n254 = 0; _n254 < e.length; _n254++) {
        var _i207 = t(e[_n254]);

        if (_i207) return _i207;
      }

      return null;
    }
  }, {
    key: "_invokeAll",
    value: function _invokeAll(t) {
      var e = Object.values(this.plugins);
      e.unshift(this);
      var n = [];

      for (var _i208 = 0; _i208 < e.length; _i208++) {
        var _r137 = t(e[_i208]);

        _r137 && n.push(_r137);
      }

      return n;
    }
  }, {
    key: "getDependency",
    value: function getDependency(t, e) {
      var n = t + ":" + e;
      var i = this.cache.get(n);

      if (!i) {
        switch (t) {
          case "scene":
            i = this.loadScene(e);
            break;

          case "node":
            i = this.loadNode(e);
            break;

          case "mesh":
            i = this._invokeOne(function (t) {
              return t.loadMesh && t.loadMesh(e);
            });
            break;

          case "accessor":
            i = this.loadAccessor(e);
            break;

          case "bufferView":
            i = this._invokeOne(function (t) {
              return t.loadBufferView && t.loadBufferView(e);
            });
            break;

          case "buffer":
            i = this.loadBuffer(e);
            break;

          case "material":
            i = this._invokeOne(function (t) {
              return t.loadMaterial && t.loadMaterial(e);
            });
            break;

          case "texture":
            i = this._invokeOne(function (t) {
              return t.loadTexture && t.loadTexture(e);
            });
            break;

          case "skin":
            i = this.loadSkin(e);
            break;

          case "animation":
            i = this.loadAnimation(e);
            break;

          case "camera":
            i = this.loadCamera(e);
            break;

          default:
            throw new Error("Unknown type: " + t);
        }

        this.cache.add(n, i);
      }

      return i;
    }
  }, {
    key: "getDependencies",
    value: function getDependencies(t) {
      var e = this.cache.get(t);

      if (!e) {
        var _n255 = this,
            _i209 = this.json[t + ("mesh" === t ? "es" : "s")] || [];

        e = Promise.all(_i209.map(function (e, i) {
          return _n255.getDependency(t, i);
        })), this.cache.add(t, e);
      }

      return e;
    }
  }, {
    key: "loadBuffer",
    value: function loadBuffer(t) {
      var e = this.json.buffers[t],
          n = this.fileLoader;
      if (e.type && "arraybuffer" !== e.type) throw new Error("THREE.GLTFLoader: " + e.type + " buffer type is not supported.");
      if (void 0 === e.uri && 0 === t) return Promise.resolve(this.extensions[Th.KHR_BINARY_GLTF].body);
      var i = this.options;
      return new Promise(function (t, r) {
        n.load(Ll.resolveURL(e.uri, i.path), t, void 0, function () {
          r(new Error('THREE.GLTFLoader: Failed to load buffer "' + e.uri + '".'));
        });
      });
    }
  }, {
    key: "loadBufferView",
    value: function loadBufferView(t) {
      var e = this.json.bufferViews[t];
      return this.getDependency("buffer", e.buffer).then(function (t) {
        var n = e.byteLength || 0,
            i = e.byteOffset || 0;
        return t.slice(i, i + n);
      });
    }
  }, {
    key: "loadAccessor",
    value: function loadAccessor(t) {
      var e = this,
          n = this.json,
          i = this.json.accessors[t];
      if (void 0 === i.bufferView && void 0 === i.sparse) return Promise.resolve(null);
      var r = [];
      return void 0 !== i.bufferView ? r.push(this.getDependency("bufferView", i.bufferView)) : r.push(null), void 0 !== i.sparse && (r.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(r).then(function (t) {
        var r = t[0],
            s = sc[i.type],
            a = nc[i.componentType],
            o = a.BYTES_PER_ELEMENT,
            l = o * s,
            h = i.byteOffset || 0,
            c = void 0 !== i.bufferView ? n.bufferViews[i.bufferView].byteStride : void 0,
            u = !0 === i.normalized;
        var d, p;

        if (c && c !== l) {
          var _t305 = Math.floor(h / c),
              _n256 = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + _t305 + ":" + i.count;

          var _l36 = e.cache.get(_n256);

          _l36 || (d = new a(r, _t305 * c, i.count * c / o), _l36 = new Os(d, c / o), e.cache.add(_n256, _l36)), p = new Fs(_l36, s, h % c / o, u);
        } else d = null === r ? new a(i.count * s) : new a(r, h, i.count * s), p = new an(d, s, u);

        if (void 0 !== i.sparse) {
          var _e270 = sc.SCALAR,
              _n257 = nc[i.sparse.indices.componentType],
              _o34 = i.sparse.indices.byteOffset || 0,
              _l37 = i.sparse.values.byteOffset || 0,
              _h23 = new _n257(t[1], _o34, i.sparse.count * _e270),
              _c17 = new a(t[2], _l37, i.sparse.count * s);

          null !== r && (p = new an(p.array.slice(), p.itemSize, p.normalized));

          for (var _t306 = 0, _e271 = _h23.length; _t306 < _e271; _t306++) {
            var _e272 = _h23[_t306];
            if (p.setX(_e272, _c17[_t306 * s]), s >= 2 && p.setY(_e272, _c17[_t306 * s + 1]), s >= 3 && p.setZ(_e272, _c17[_t306 * s + 2]), s >= 4 && p.setW(_e272, _c17[_t306 * s + 3]), s >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
          }
        }

        return p;
      });
    }
  }, {
    key: "loadTexture",
    value: function loadTexture(t) {
      var e = this.json,
          n = this.options,
          i = e.textures[t].source,
          r = e.images[i];
      var s = this.textureLoader;

      if (r.uri) {
        var _t307 = n.manager.getHandler(r.uri);

        null !== _t307 && (s = _t307);
      }

      return this.loadTextureImage(t, i, s);
    }
  }, {
    key: "loadTextureImage",
    value: function loadTextureImage(t, e, n) {
      var i = this,
          r = this.json,
          s = r.textures[t],
          a = r.images[e],
          o = (a.uri || a.bufferView) + ":" + s.sampler;
      if (this.textureCache[o]) return this.textureCache[o];
      var l = this.loadImageSource(e, n).then(function (e) {
        e.flipY = !1, s.name && (e.name = s.name);
        var n = (r.samplers || {})[s.sampler] || {};
        return e.magFilter = ic[n.magFilter] || 1006, e.minFilter = ic[n.minFilter] || 1008, e.wrapS = rc[n.wrapS] || 1e3, e.wrapT = rc[n.wrapT] || 1e3, i.associations.set(e, {
          textures: t
        }), e;
      }).catch(function () {
        return null;
      });
      return this.textureCache[o] = l, l;
    }
  }, {
    key: "loadImageSource",
    value: function loadImageSource(t, e) {
      var n = this,
          i = this.json,
          r = this.options;
      if (void 0 !== this.sourceCache[t]) return this.sourceCache[t].then(function (t) {
        return t.clone();
      });
      var s = i.images[t],
          a = self.URL || self.webkitURL;
      var o = s.uri || "",
          l = !1;
      if (void 0 !== s.bufferView) o = n.getDependency("bufferView", s.bufferView).then(function (t) {
        l = !0;
        var e = new Blob([t], {
          type: s.mimeType
        });
        return o = a.createObjectURL(e), o;
      });else if (void 0 === s.uri) throw new Error("THREE.GLTFLoader: Image " + t + " is missing URI and bufferView");
      var h = Promise.resolve(o).then(function (t) {
        return new Promise(function (n, i) {
          var s = n;
          !0 === e.isImageBitmapLoader && (s = function s(t) {
            var e = new Ot(t);
            e.needsUpdate = !0, n(e);
          }), e.load(Ll.resolveURL(t, r.path), s, void 0, i);
        });
      }).then(function (t) {
        var e;
        return !0 === l && a.revokeObjectURL(o), t.userData.mimeType = s.mimeType || ((e = s.uri).search(/\.jpe?g($|\?)/i) > 0 || 0 === e.search(/^data\:image\/jpeg/) ? "image/jpeg" : e.search(/\.webp($|\?)/i) > 0 || 0 === e.search(/^data\:image\/webp/) ? "image/webp" : "image/png"), t;
      }).catch(function (t) {
        throw console.error("THREE.GLTFLoader: Couldn't load texture", o), t;
      });
      return this.sourceCache[t] = h, h;
    }
  }, {
    key: "assignTexture",
    value: function assignTexture(t, e, n, i) {
      var r = this;
      return this.getDependency("texture", n.index).then(function (s) {
        if (void 0 === n.texCoord || 0 == n.texCoord || "aoMap" === e && 1 == n.texCoord || console.warn("THREE.GLTFLoader: Custom UV set " + n.texCoord + " for texture " + e + " not yet supported."), r.extensions[Th.KHR_TEXTURE_TRANSFORM]) {
          var _t308 = void 0 !== n.extensions ? n.extensions[Th.KHR_TEXTURE_TRANSFORM] : void 0;

          if (_t308) {
            var _e273 = r.associations.get(s);

            s = r.extensions[Th.KHR_TEXTURE_TRANSFORM].extendTexture(s, _t308), r.associations.set(s, _e273);
          }
        }

        return void 0 !== i && (s.encoding = i), t[e] = s, s;
      });
    }
  }, {
    key: "assignFinalMaterial",
    value: function assignFinalMaterial(t) {
      var e = t.geometry;
      var n = t.material;
      var i = void 0 === e.attributes.tangent,
          r = void 0 !== e.attributes.color,
          s = void 0 === e.attributes.normal;

      if (t.isPoints) {
        var _t309 = "PointsMaterial:" + n.uuid;

        var _e274 = this.cache.get(_t309);

        _e274 || (_e274 = new Ta(), en.prototype.copy.call(_e274, n), _e274.color.copy(n.color), _e274.map = n.map, _e274.sizeAttenuation = !1, this.cache.add(_t309, _e274)), n = _e274;
      } else if (t.isLine) {
        var _t310 = "LineBasicMaterial:" + n.uuid;

        var _e275 = this.cache.get(_t310);

        _e275 || (_e275 = new ma(), en.prototype.copy.call(_e275, n), _e275.color.copy(n.color), this.cache.add(_t310, _e275)), n = _e275;
      }

      if (i || r || s) {
        var _t311 = "ClonedMaterial:" + n.uuid + ":";

        n.isGLTFSpecularGlossinessMaterial && (_t311 += "specular-glossiness:"), i && (_t311 += "derivative-tangents:"), r && (_t311 += "vertex-colors:"), s && (_t311 += "flat-shading:");

        var _e276 = this.cache.get(_t311);

        _e276 || (_e276 = n.clone(), r && (_e276.vertexColors = !0), s && (_e276.flatShading = !0), i && (_e276.normalScale && (_e276.normalScale.y *= -1), _e276.clearcoatNormalScale && (_e276.clearcoatNormalScale.y *= -1)), this.cache.add(_t311, _e276), this.associations.set(_e276, this.associations.get(n))), n = _e276;
      }

      n.aoMap && void 0 === e.attributes.uv2 && void 0 !== e.attributes.uv && e.setAttribute("uv2", e.attributes.uv), t.material = n;
    }
  }, {
    key: "getMaterialType",
    value: function getMaterialType() {
      return No;
    }
  }, {
    key: "loadMaterial",
    value: function loadMaterial(t) {
      var e = this,
          n = this.json,
          i = this.extensions,
          r = n.materials[t];
      var s;
      var a = {},
          o = r.extensions || {},
          l = [];

      if (o[Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {
        var _t312 = i[Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
        s = _t312.getMaterialType(), l.push(_t312.extendParams(a, r, e));
      } else if (o[Th.KHR_MATERIALS_UNLIT]) {
        var _t313 = i[Th.KHR_MATERIALS_UNLIT];
        s = _t313.getMaterialType(), l.push(_t313.extendParams(a, r, e));
      } else {
        var _n258 = r.pbrMetallicRoughness || {};

        if (a.color = new Rt(1, 1, 1), a.opacity = 1, Array.isArray(_n258.baseColorFactor)) {
          var _t314 = _n258.baseColorFactor;
          a.color.fromArray(_t314), a.opacity = _t314[3];
        }

        void 0 !== _n258.baseColorTexture && l.push(e.assignTexture(a, "map", _n258.baseColorTexture, 3001)), a.metalness = void 0 !== _n258.metallicFactor ? _n258.metallicFactor : 1, a.roughness = void 0 !== _n258.roughnessFactor ? _n258.roughnessFactor : 1, void 0 !== _n258.metallicRoughnessTexture && (l.push(e.assignTexture(a, "metalnessMap", _n258.metallicRoughnessTexture)), l.push(e.assignTexture(a, "roughnessMap", _n258.metallicRoughnessTexture))), s = this._invokeOne(function (e) {
          return e.getMaterialType && e.getMaterialType(t);
        }), l.push(Promise.all(this._invokeAll(function (e) {
          return e.extendMaterialParams && e.extendMaterialParams(t, a);
        })));
      }

      !0 === r.doubleSided && (a.side = 2);
      var h = r.alphaMode || hc;

      if (h === uc ? (a.transparent = !0, a.depthWrite = !1) : (a.transparent = !1, h === cc && (a.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && s !== nn && (l.push(e.assignTexture(a, "normalMap", r.normalTexture)), a.normalScale = new mt(1, 1), void 0 !== r.normalTexture.scale)) {
        var _t315 = r.normalTexture.scale;
        a.normalScale.set(_t315, _t315);
      }

      return void 0 !== r.occlusionTexture && s !== nn && (l.push(e.assignTexture(a, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (a.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && s !== nn && (a.emissive = new Rt().fromArray(r.emissiveFactor)), void 0 !== r.emissiveTexture && s !== nn && l.push(e.assignTexture(a, "emissiveMap", r.emissiveTexture, 3001)), Promise.all(l).then(function () {
        var n;
        return n = s === Gh ? i[Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].createMaterial(a) : new s(a), r.name && (n.name = r.name), mc(n, r), e.associations.set(n, {
          materials: t
        }), r.extensions && pc(i, n, r), n;
      });
    }
  }, {
    key: "createUniqueName",
    value: function createUniqueName(t) {
      var e = Wl.sanitizeNodeName(t || "");
      var n = e;

      for (var _t316 = 1; this.nodeNamesUsed[n]; ++_t316) {
        n = e + "_" + _t316;
      }

      return this.nodeNamesUsed[n] = !0, n;
    }
  }, {
    key: "loadGeometries",
    value: function loadGeometries(t) {
      var e = this,
          n = this.extensions,
          i = this.primitiveCache;

      function r(t) {
        return n[Th.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(t, e).then(function (n) {
          return bc(n, t, e);
        });
      }

      var s = [];

      for (var _n259 = 0, _a59 = t.length; _n259 < _a59; _n259++) {
        var _a60 = t[_n259],
            _o35 = gc(_a60),
            _l38 = i[_o35];

        if (_l38) s.push(_l38.promise);else {
          var _t317 = void 0;

          _t317 = _a60.extensions && _a60.extensions[Th.KHR_DRACO_MESH_COMPRESSION] ? r(_a60) : bc(new vn(), _a60, e), i[_o35] = {
            primitive: _a60,
            promise: _t317
          }, s.push(_t317);
        }
      }

      return Promise.all(s);
    }
  }, {
    key: "loadMesh",
    value: function loadMesh(t) {
      var e = this,
          n = this.json,
          i = this.extensions,
          r = n.meshes[t],
          s = r.primitives,
          a = [];

      for (var _t318 = 0, _e277 = s.length; _t318 < _e277; _t318++) {
        var _e278 = void 0 === s[_t318].material ? dc(this.cache) : this.getDependency("material", s[_t318].material);

        a.push(_e278);
      }

      return a.push(e.loadGeometries(s)), Promise.all(a).then(function (n) {
        var a = n.slice(0, n.length - 1),
            o = n[n.length - 1],
            l = [];

        for (var _n260 = 0, _h24 = o.length; _n260 < _h24; _n260++) {
          var _h25 = o[_n260],
              _c18 = s[_n260];

          var _u16 = void 0;

          var _d16 = a[_n260];
          if (_c18.mode === Qh || _c18.mode === tc || _c18.mode === ec || void 0 === _c18.mode) _u16 = !0 === r.isSkinnedMesh ? new ia(_h25, _d16) : new Nn(_h25, _d16), !0 !== _u16.isSkinnedMesh || _u16.geometry.attributes.skinWeight.normalized || _u16.normalizeSkinWeights(), _c18.mode === tc ? _u16.geometry = wc(_u16.geometry, 1) : _c18.mode === ec && (_u16.geometry = wc(_u16.geometry, 2));else if (_c18.mode === Zh) _u16 = new Ma(_h25, _d16);else if (_c18.mode === Kh) _u16 = new _a(_h25, _d16);else if (_c18.mode === $h) _u16 = new Sa(_h25, _d16);else {
            if (_c18.mode !== Jh) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + _c18.mode);
            _u16 = new La(_h25, _d16);
          }
          Object.keys(_u16.geometry.morphAttributes).length > 0 && fc(_u16, r), _u16.name = e.createUniqueName(r.name || "mesh_" + t), mc(_u16, r), _c18.extensions && pc(i, _u16, _c18), e.assignFinalMaterial(_u16), l.push(_u16);
        }

        for (var _n261 = 0, _i210 = l.length; _n261 < _i210; _n261++) {
          e.associations.set(l[_n261], {
            meshes: t,
            primitives: _n261
          });
        }

        if (1 === l.length) return l[0];
        var h = new Es();
        e.associations.set(h, {
          meshes: t
        });

        for (var _t319 = 0, _e279 = l.length; _t319 < _e279; _t319++) {
          h.add(l[_t319]);
        }

        return h;
      });
    }
  }, {
    key: "loadCamera",
    value: function loadCamera(t) {
      var e;
      var n = this.json.cameras[t],
          i = n[n.type];
      if (i) return "perspective" === n.type ? e = new Gn(pt.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : "orthographic" === n.type && (e = new di(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (e.name = this.createUniqueName(n.name)), mc(e, n), Promise.resolve(e);
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
    }
  }, {
    key: "loadSkin",
    value: function loadSkin(t) {
      var e = this.json.skins[t],
          n = {
        joints: e.joints
      };
      return void 0 === e.inverseBindMatrices ? Promise.resolve(n) : this.getDependency("accessor", e.inverseBindMatrices).then(function (t) {
        return n.inverseBindMatrices = t, n;
      });
    }
  }, {
    key: "loadAnimation",
    value: function loadAnimation(t) {
      var e = this.json.animations[t],
          n = [],
          i = [],
          r = [],
          s = [],
          a = [];

      for (var _t320 = 0, _o36 = e.channels.length; _t320 < _o36; _t320++) {
        var _o37 = e.channels[_t320],
            _l39 = e.samplers[_o37.sampler],
            _h26 = _o37.target,
            _c19 = void 0 !== _h26.node ? _h26.node : _h26.id,
            _u17 = void 0 !== e.parameters ? e.parameters[_l39.input] : _l39.input,
            _d17 = void 0 !== e.parameters ? e.parameters[_l39.output] : _l39.output;

        n.push(this.getDependency("node", _c19)), i.push(this.getDependency("accessor", _u17)), r.push(this.getDependency("accessor", _d17)), s.push(_l39), a.push(_h26);
      }

      return Promise.all([Promise.all(n), Promise.all(i), Promise.all(r), Promise.all(s), Promise.all(a)]).then(function (n) {
        var i = n[0],
            r = n[1],
            s = n[2],
            a = n[3],
            o = n[4],
            l = [];

        var _loop2 = function _loop2(_t321, _e280) {
          var e = i[_t321],
              n = r[_t321],
              h = s[_t321],
              c = a[_t321],
              u = o[_t321];
          if (void 0 === e) return "continue";
          var d = void 0;

          switch (e.updateMatrix(), e.matrixAutoUpdate = !0, oc[u.path]) {
            case oc.weights:
              d = Ko;
              break;

            case oc.rotation:
              d = tl;
              break;

            default:
              d = nl;
          }

          var p = e.name ? e.name : e.uuid,
              m = void 0 !== c.interpolation ? lc[c.interpolation] : 2301,
              f = [];
          oc[u.path] === oc.weights ? e.traverse(function (t) {
            t.morphTargetInfluences && f.push(t.name ? t.name : t.uuid);
          }) : f.push(p);
          var g = h.array;

          if (h.normalized) {
            var _t322 = yc(g.constructor),
                _e281 = new Float32Array(g.length);

            for (var _n262 = 0, _i211 = g.length; _n262 < _i211; _n262++) {
              _e281[_n262] = g[_n262] * _t322;
            }

            g = _e281;
          }

          for (var _t323 = 0, _e282 = f.length; _t323 < _e282; _t323++) {
            var _e283 = new d(f[_t323] + "." + oc[u.path], n.array, g, m);

            "CUBICSPLINE" === c.interpolation && (_e283.createInterpolant = function (t) {
              return new (this instanceof tl ? Yh : qh)(this.times, this.values, this.getValueSize() / 3, t);
            }, _e283.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0), l.push(_e283);
          }
        };

        for (var _t321 = 0, _e280 = i.length; _t321 < _e280; _t321++) {
          var _ret2 = _loop2(_t321, _e280);

          if (_ret2 === "continue") continue;
        }

        var h = e.name ? e.name : "animation_" + t;
        return new il(h, void 0, l);
      });
    }
  }, {
    key: "createNodeMesh",
    value: function createNodeMesh(t) {
      var e = this.json,
          n = this,
          i = e.nodes[t];
      return void 0 === i.mesh ? null : n.getDependency("mesh", i.mesh).then(function (t) {
        var e = n._getNodeRef(n.meshCache, i.mesh, t);

        return void 0 !== i.weights && e.traverse(function (t) {
          if (t.isMesh) for (var _e284 = 0, _n263 = i.weights.length; _e284 < _n263; _e284++) {
            t.morphTargetInfluences[_e284] = i.weights[_e284];
          }
        }), e;
      });
    }
  }, {
    key: "loadNode",
    value: function loadNode(t) {
      var e = this.json,
          n = this.extensions,
          i = this,
          r = e.nodes[t],
          s = r.name ? i.createUniqueName(r.name) : "";
      return function () {
        var e = [],
            n = i._invokeOne(function (e) {
          return e.createNodeMesh && e.createNodeMesh(t);
        });

        return n && e.push(n), void 0 !== r.camera && e.push(i.getDependency("camera", r.camera).then(function (t) {
          return i._getNodeRef(i.cameraCache, r.camera, t);
        })), i._invokeAll(function (e) {
          return e.createNodeAttachment && e.createNodeAttachment(t);
        }).forEach(function (t) {
          e.push(t);
        }), Promise.all(e);
      }().then(function (e) {
        var a;
        if (a = !0 === r.isBone ? new ra() : e.length > 1 ? new Es() : 1 === e.length ? e[0] : new Ve(), a !== e[0]) for (var _t324 = 0, _n264 = e.length; _t324 < _n264; _t324++) {
          a.add(e[_t324]);
        }

        if (r.name && (a.userData.name = r.name, a.name = s), mc(a, r), r.extensions && pc(n, a, r), void 0 !== r.matrix) {
          var _t325 = new ve();

          _t325.fromArray(r.matrix), a.applyMatrix4(_t325);
        } else void 0 !== r.translation && a.position.fromArray(r.translation), void 0 !== r.rotation && a.quaternion.fromArray(r.rotation), void 0 !== r.scale && a.scale.fromArray(r.scale);

        return i.associations.has(a) || i.associations.set(a, {}), i.associations.get(a).nodes = t, a;
      });
    }
  }, {
    key: "loadScene",
    value: function loadScene(t) {
      var e = this.json,
          n = this.extensions,
          i = this.json.scenes[t],
          r = this,
          s = new Es();
      i.name && (s.name = r.createUniqueName(i.name)), mc(s, i), i.extensions && pc(n, s, i);
      var a = i.nodes || [],
          o = [];

      for (var _t326 = 0, _n265 = a.length; _t326 < _n265; _t326++) {
        o.push(_c(a[_t326], s, e, r));
      }

      return Promise.all(o).then(function () {
        return r.associations = function (t) {
          var e = new Map();

          var _iterator9 = _createForOfIteratorHelper(r.associations),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var _step9$value = _slicedToArray(_step9.value, 2),
                  _t327 = _step9$value[0],
                  _n266 = _step9$value[1];

              (_t327 instanceof en || _t327 instanceof Ot) && e.set(_t327, _n266);
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }

          return t.traverse(function (t) {
            var n = r.associations.get(t);
            null != n && e.set(t, n);
          }), e;
        }(s), s;
      });
    }
  }]);

  return xc;
}();

function _c(t, e, n, i) {
  var r = n.nodes[t];
  return i.getDependency("node", t).then(function (t) {
    if (void 0 === r.skin) return t;
    var e;
    return i.getDependency("skin", r.skin).then(function (t) {
      e = t;
      var n = [];

      for (var _t328 = 0, _r138 = e.joints.length; _t328 < _r138; _t328++) {
        n.push(i.getDependency("node", e.joints[_t328]));
      }

      return Promise.all(n);
    }).then(function (n) {
      return t.traverse(function (t) {
        if (!t.isMesh) return;
        var i = [],
            r = [];

        for (var _t329 = 0, _s80 = n.length; _t329 < _s80; _t329++) {
          var _s81 = n[_t329];

          if (_s81) {
            i.push(_s81);

            var _n267 = new ve();

            void 0 !== e.inverseBindMatrices && _n267.fromArray(e.inverseBindMatrices.array, 16 * _t329), r.push(_n267);
          } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', e.joints[_t329]);
        }

        t.bind(new la(i, r), t.matrixWorld);
      }), t;
    });
  }).then(function (t) {
    e.add(t);
    var s = [];

    if (r.children) {
      var _e285 = r.children;

      for (var _r139 = 0, _a61 = _e285.length; _r139 < _a61; _r139++) {
        var _a62 = _e285[_r139];
        s.push(_c(_a62, t, n, i));
      }
    }

    return Promise.all(s);
  });
}

function bc(t, e, n) {
  var i = e.attributes,
      r = [];

  function s(e, i) {
    return n.getDependency("accessor", e).then(function (e) {
      t.setAttribute(i, e);
    });
  }

  for (var _e286 in i) {
    var _n268 = ac[_e286] || _e286.toLowerCase();

    _n268 in t.attributes || r.push(s(i[_e286], _n268));
  }

  if (void 0 !== e.indices && !t.index) {
    var _i212 = n.getDependency("accessor", e.indices).then(function (e) {
      t.setIndex(e);
    });

    r.push(_i212);
  }

  return mc(t, e), function (t, e, n) {
    var i = e.attributes,
        r = new Gt();
    if (void 0 === i.POSITION) return;
    {
      var _t330 = n.json.accessors[i.POSITION],
          _e287 = _t330.min,
          _s82 = _t330.max;
      if (void 0 === _e287 || void 0 === _s82) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");

      if (r.set(new zt(_e287[0], _e287[1], _e287[2]), new zt(_s82[0], _s82[1], _s82[2])), _t330.normalized) {
        var _e288 = yc(nc[_t330.componentType]);

        r.min.multiplyScalar(_e288), r.max.multiplyScalar(_e288);
      }
    }
    var s = e.targets;

    if (void 0 !== s) {
      var _t331 = new zt(),
          _e289 = new zt();

      for (var _i213 = 0, _r140 = s.length; _i213 < _r140; _i213++) {
        var _r141 = s[_i213];

        if (void 0 !== _r141.POSITION) {
          var _i214 = n.json.accessors[_r141.POSITION],
              _s83 = _i214.min,
              _a63 = _i214.max;

          if (void 0 !== _s83 && void 0 !== _a63) {
            if (_e289.setX(Math.max(Math.abs(_s83[0]), Math.abs(_a63[0]))), _e289.setY(Math.max(Math.abs(_s83[1]), Math.abs(_a63[1]))), _e289.setZ(Math.max(Math.abs(_s83[2]), Math.abs(_a63[2]))), _i214.normalized) {
              var _t332 = yc(nc[_i214.componentType]);

              _e289.multiplyScalar(_t332);
            }

            _t331.max(_e289);
          } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        }
      }

      r.expandByVector(_t331);
    }

    t.boundingBox = r;
    var a = new le();
    r.getCenter(a.center), a.radius = r.min.distanceTo(r.max) / 2, t.boundingSphere = a;
  }(t, e, n), Promise.all(r).then(function () {
    return void 0 !== e.targets ? function (t, e, n) {
      var i = !1,
          r = !1,
          s = !1;

      for (var _t333 = 0, _n269 = e.length; _t333 < _n269; _t333++) {
        var _n270 = e[_t333];
        if (void 0 !== _n270.POSITION && (i = !0), void 0 !== _n270.NORMAL && (r = !0), void 0 !== _n270.COLOR_0 && (s = !0), i && r && s) break;
      }

      if (!i && !r && !s) return Promise.resolve(t);
      var a = [],
          o = [],
          l = [];

      for (var _h27 = 0, _c20 = e.length; _h27 < _c20; _h27++) {
        var _c21 = e[_h27];

        if (i) {
          var _e290 = void 0 !== _c21.POSITION ? n.getDependency("accessor", _c21.POSITION) : t.attributes.position;

          a.push(_e290);
        }

        if (r) {
          var _e291 = void 0 !== _c21.NORMAL ? n.getDependency("accessor", _c21.NORMAL) : t.attributes.normal;

          o.push(_e291);
        }

        if (s) {
          var _e292 = void 0 !== _c21.COLOR_0 ? n.getDependency("accessor", _c21.COLOR_0) : t.attributes.color;

          l.push(_e292);
        }
      }

      return Promise.all([Promise.all(a), Promise.all(o), Promise.all(l)]).then(function (e) {
        var n = e[0],
            a = e[1],
            o = e[2];
        return i && (t.morphAttributes.position = n), r && (t.morphAttributes.normal = a), s && (t.morphAttributes.color = o), t.morphTargetsRelative = !0, t;
      });
    }(t, e.targets, n) : t;
  });
}

function wc(t, e) {
  var n = t.getIndex();

  if (null === n) {
    var _e293 = [],
        _i215 = t.getAttribute("position");

    if (void 0 === _i215) return console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), t;

    for (var _t334 = 0; _t334 < _i215.count; _t334++) {
      _e293.push(_t334);
    }

    t.setIndex(_e293), n = t.getIndex();
  }

  var i = n.count - 2,
      r = [];
  if (2 === e) for (var _t335 = 1; _t335 <= i; _t335++) {
    r.push(n.getX(0)), r.push(n.getX(_t335)), r.push(n.getX(_t335 + 1));
  } else for (var _t336 = 0; _t336 < i; _t336++) {
    _t336 % 2 == 0 ? (r.push(n.getX(_t336)), r.push(n.getX(_t336 + 1)), r.push(n.getX(_t336 + 2))) : (r.push(n.getX(_t336 + 2)), r.push(n.getX(_t336 + 1)), r.push(n.getX(_t336)));
  }
  r.length / 3 !== i && console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
  var s = t.clone();
  return s.setIndex(r), s;
}

var Mc = /*#__PURE__*/function () {
  function Mc() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;

    _classCallCheck(this, Mc);

    this.pool = t, this.queue = [], this.workers = [], this.workersResolve = [], this.workerStatus = 0;
  }

  _createClass(Mc, [{
    key: "_initWorker",
    value: function _initWorker(t) {
      if (!this.workers[t]) {
        var _e294 = this.workerCreator();

        _e294.addEventListener("message", this._onMessage.bind(this, t)), this.workers[t] = _e294;
      }
    }
  }, {
    key: "_getIdleWorker",
    value: function _getIdleWorker() {
      for (var _t337 = 0; _t337 < this.pool; _t337++) {
        if (!(this.workerStatus & 1 << _t337)) return _t337;
      }

      return -1;
    }
  }, {
    key: "_onMessage",
    value: function _onMessage(t, e) {
      var n = this.workersResolve[t];

      if (n && n(e), this.queue.length) {
        var _this$queue$shift = this.queue.shift(),
            _e295 = _this$queue$shift.resolve,
            _n271 = _this$queue$shift.msg,
            _i216 = _this$queue$shift.transfer;

        this.workersResolve[t] = _e295, this.workers[t].postMessage(_n271, _i216);
      } else this.workerStatus ^= 1 << t;
    }
  }, {
    key: "setWorkerCreator",
    value: function setWorkerCreator(t) {
      this.workerCreator = t;
    }
  }, {
    key: "setWorkerLimit",
    value: function setWorkerLimit(t) {
      this.pool = t;
    }
  }, {
    key: "postMessage",
    value: function postMessage(t, e) {
      var _this105 = this;

      return new Promise(function (n) {
        var i = _this105._getIdleWorker();

        -1 !== i ? (_this105._initWorker(i), _this105.workerStatus |= 1 << i, _this105.workersResolve[i] = n, _this105.workers[i].postMessage(t, e)) : _this105.queue.push({
          resolve: n,
          msg: t,
          transfer: e
        });
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.workers.forEach(function (t) {
        return t.terminate();
      }), this.workersResolve.length = 0, this.workers.length = 0, this.queue.length = 0, this.workerStatus = 0;
    }
  }]);

  return Mc;
}();

var Sc = new WeakMap();
var Tc = 0;

var Ec = /*#__PURE__*/function (_ol9) {
  _inherits(Ec, _ol9);

  var _super120 = _createSuper(Ec);

  function Ec(t) {
    var _this106;

    _classCallCheck(this, Ec);

    _this106 = _super120.call(this, t), _this106.transcoderPath = "", _this106.transcoderBinary = null, _this106.transcoderPending = null, _this106.workerPool = new Mc(), _this106.workerSourceURL = "", _this106.workerConfig = null, "undefined" != typeof MSC_TRANSCODER && console.warn('THREE.KTX2Loader: Please update to latest "basis_transcoder". "msc_basis_transcoder" is no longer supported in three.js r125+.');
    return _this106;
  }

  _createClass(Ec, [{
    key: "setTranscoderPath",
    value: function setTranscoderPath(t) {
      return this.transcoderPath = t, this;
    }
  }, {
    key: "setWorkerLimit",
    value: function setWorkerLimit(t) {
      return this.workerPool.setWorkerLimit(t), this;
    }
  }, {
    key: "detectSupport",
    value: function detectSupport(t) {
      return this.workerConfig = {
        astcSupported: t.extensions.has("WEBGL_compressed_texture_astc"),
        etc1Supported: t.extensions.has("WEBGL_compressed_texture_etc1"),
        etc2Supported: t.extensions.has("WEBGL_compressed_texture_etc"),
        dxtSupported: t.extensions.has("WEBGL_compressed_texture_s3tc"),
        bptcSupported: t.extensions.has("EXT_texture_compression_bptc"),
        pvrtcSupported: t.extensions.has("WEBGL_compressed_texture_pvrtc") || t.extensions.has("WEBKIT_WEBGL_compressed_texture_pvrtc")
      }, t.capabilities.isWebGL2 && (this.workerConfig.etc1Supported = !1), this;
    }
  }, {
    key: "init",
    value: function init() {
      var _this107 = this;

      if (!this.transcoderPending) {
        var _t338 = new hl(this.manager);

        _t338.setPath(this.transcoderPath), _t338.setWithCredentials(this.withCredentials);

        var _e296 = _t338.loadAsync("basis_transcoder.js"),
            _n272 = new hl(this.manager);

        _n272.setPath(this.transcoderPath), _n272.setResponseType("arraybuffer"), _n272.setWithCredentials(this.withCredentials);

        var _i217 = _n272.loadAsync("basis_transcoder.wasm");

        this.transcoderPending = Promise.all([_e296, _i217]).then(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              t = _ref5[0],
              e = _ref5[1];

          var n = Ec.BasisWorker.toString(),
              i = ["/* constants */", "let _EngineFormat = " + JSON.stringify(Ec.EngineFormat), "let _TranscoderFormat = " + JSON.stringify(Ec.TranscoderFormat), "let _BasisFormat = " + JSON.stringify(Ec.BasisFormat), "/* basis_transcoder.js */", t, "/* worker */", n.substring(n.indexOf("{") + 1, n.lastIndexOf("}"))].join("\n");
          _this107.workerSourceURL = URL.createObjectURL(new Blob([i])), _this107.transcoderBinary = e, _this107.workerPool.setWorkerCreator(function () {
            var t = new Worker(_this107.workerSourceURL),
                e = _this107.transcoderBinary.slice(0);

            return t.postMessage({
              type: "init",
              config: _this107.workerConfig,
              transcoderBinary: e
            }, [e]), t;
          });
        }), Tc > 0 && console.warn("THREE.KTX2Loader: Multiple active KTX2 loaders may cause performance issues. Use a single KTX2Loader instance, or call .dispose() on old instances."), Tc++;
      }

      return this.transcoderPending;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      var _this108 = this;

      if (null === this.workerConfig) throw new Error("THREE.KTX2Loader: Missing initialization with `.detectSupport( renderer )`.");
      var r = new hl(this.manager);
      r.setResponseType("arraybuffer"), r.setWithCredentials(this.withCredentials);
      var s = new Da();
      return r.load(t, function (t) {
        if (Sc.has(t)) {
          return Sc.get(t).promise.then(e).catch(i);
        }

        _this108._createTexture([t]).then(function (t) {
          s.copy(t), s.needsUpdate = !0, e && e(s);
        }).catch(i);
      }, n, i), s;
    }
  }, {
    key: "_createTextureFrom",
    value: function _createTextureFrom(t) {
      var e = t.mipmaps,
          n = t.width,
          i = t.height,
          r = t.format,
          s = t.type,
          a = t.error,
          o = t.dfdTransferFn,
          l = t.dfdFlags;
      if ("error" === s) return Promise.reject(a);
      var h = new Da(e, n, i, r, 1009);
      return h.minFilter = 1 === e.length ? 1006 : 1008, h.magFilter = 1006, h.generateMipmaps = !1, h.needsUpdate = !0, h.encoding = 2 === o ? 3001 : 3e3, h.premultiplyAlpha = !!(1 & l), h;
    }
  }, {
    key: "_createTexture",
    value: function _createTexture(t) {
      var _this109 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = e,
          i = this.init().then(function () {
        return _this109.workerPool.postMessage({
          type: "transcode",
          buffers: t,
          taskConfig: n
        }, t);
      }).then(function (t) {
        return _this109._createTextureFrom(t.data);
      });
      return Sc.set(t[0], {
        promise: i
      }), i;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      return this.workerPool.dispose(), this.workerSourceURL && URL.revokeObjectURL(this.workerSourceURL), Tc--, this;
    }
  }]);

  return Ec;
}(ol);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ac, Rc;
Ec.BasisFormat = {
  ETC1S: 0,
  UASTC_4x4: 1
}, Ec.TranscoderFormat = {
  ETC1: 0,
  ETC2: 1,
  BC1: 2,
  BC3: 3,
  BC4: 4,
  BC5: 5,
  BC7_M6_OPAQUE_ONLY: 6,
  BC7_M5: 7,
  PVRTC1_4_RGB: 8,
  PVRTC1_4_RGBA: 9,
  ASTC_4x4: 10,
  ATC_RGB: 11,
  ATC_RGBA_INTERPOLATED_ALPHA: 12,
  RGBA32: 13,
  RGB565: 14,
  BGR565: 15,
  RGBA4444: 16
}, Ec.EngineFormat = {
  RGBAFormat: 1023,
  RGBA_ASTC_4x4_Format: 37808,
  RGBA_BPTC_Format: 36492,
  RGBA_ETC2_EAC_Format: 37496,
  RGBA_PVRTC_4BPPV1_Format: 35842,
  RGBA_S3TC_DXT5_Format: 33779,
  RGB_ETC1_Format: 36196,
  RGB_ETC2_Format: 37492,
  RGB_PVRTC_4BPPV1_Format: 35840,
  RGB_S3TC_DXT1_Format: 33776
}, Ec.BasisWorker = function () {
  var t, e, n;
  var i = _EngineFormat,
      r = _TranscoderFormat,
      s = _BasisFormat;
  self.addEventListener("message", function (a) {
    var c = a.data;

    switch (c.type) {
      case "init":
        t = c.config, u = c.transcoderBinary, e = new Promise(function (t) {
          n = {
            wasmBinary: u,
            onRuntimeInitialized: t
          }, BASIS(n);
        }).then(function () {
          n.initializeBasis(), void 0 === n.KTX2File && console.warn("THREE.KTX2Loader: Please update Basis Universal transcoder.");
        });
        break;

      case "transcode":
        e.then(function () {
          try {
            var _ref6 = function (e) {
              var a = new n.KTX2File(new Uint8Array(e));

              function c() {
                a.close(), a.delete();
              }

              if (!a.isValid()) throw c(), new Error("THREE.KTX2Loader:\tInvalid or unsupported .ktx2 file");

              var u = a.isUASTC() ? s.UASTC_4x4 : s.ETC1S,
                  d = a.getWidth(),
                  p = a.getHeight(),
                  m = a.getLevels(),
                  f = a.getHasAlpha(),
                  g = a.getDFDTransferFunc(),
                  v = a.getDFDFlags(),
                  _ref7 = function (e, n, a, c) {
                var u, d;
                var p = e === s.ETC1S ? o : l;

                for (var _i218 = 0; _i218 < p.length; _i218++) {
                  var _r142 = p[_i218];
                  if (t[_r142.if] && _r142.basisFormat.includes(e) && !(c && _r142.transcoderFormat.length < 2) && (!_r142.needsPowerOfTwo || h(n) && h(a))) return u = _r142.transcoderFormat[c ? 1 : 0], d = _r142.engineFormat[c ? 1 : 0], {
                    transcoderFormat: u,
                    engineFormat: d
                  };
                }

                return console.warn("THREE.KTX2Loader: No suitable compressed texture format found. Decoding to RGBA32."), u = r.RGBA32, d = i.RGBAFormat, {
                  transcoderFormat: u,
                  engineFormat: d
                };
              }(u, d, p, f),
                  y = _ref7.transcoderFormat,
                  x = _ref7.engineFormat;

              if (!d || !p || !m) throw c(), new Error("THREE.KTX2Loader:\tInvalid texture");
              if (!a.startTranscoding()) throw c(), new Error("THREE.KTX2Loader: .startTranscoding failed");
              var _ = [];

              for (var _t339 = 0; _t339 < m; _t339++) {
                var _e298 = a.getImageLevelInfo(_t339, 0, 0),
                    _n273 = _e298.origWidth,
                    _i219 = _e298.origHeight,
                    _r143 = new Uint8Array(a.getImageTranscodedSizeInBytes(_t339, 0, 0, y));

                if (!a.transcodeImage(_r143, _t339, 0, 0, y, 0, -1, -1)) throw c(), new Error("THREE.KTX2Loader: .transcodeImage failed.");

                _.push({
                  data: _r143,
                  width: _n273,
                  height: _i219
                });
              }

              return c(), {
                width: d,
                height: p,
                hasAlpha: f,
                mipmaps: _,
                format: x,
                dfdTransferFn: g,
                dfdFlags: v
              };
            }(c.buffers[0]),
                _e297 = _ref6.width,
                _a64 = _ref6.height,
                _u18 = _ref6.hasAlpha,
                _d18 = _ref6.mipmaps,
                _p13 = _ref6.format,
                _m10 = _ref6.dfdTransferFn,
                _f7 = _ref6.dfdFlags,
                _g7 = [];

            for (var _t340 = 0; _t340 < _d18.length; ++_t340) {
              _g7.push(_d18[_t340].data.buffer);
            }

            self.postMessage({
              type: "transcode",
              id: c.id,
              width: _e297,
              height: _a64,
              hasAlpha: _u18,
              mipmaps: _d18,
              format: _p13,
              dfdTransferFn: _m10,
              dfdFlags: _f7
            }, _g7);
          } catch (t) {
            console.error(t), self.postMessage({
              type: "error",
              id: c.id,
              error: t.message
            });
          }
        });
    }

    var u;
  });
  var a = [{
    if: "astcSupported",
    basisFormat: [s.UASTC_4x4],
    transcoderFormat: [r.ASTC_4x4, r.ASTC_4x4],
    engineFormat: [i.RGBA_ASTC_4x4_Format, i.RGBA_ASTC_4x4_Format],
    priorityETC1S: 1 / 0,
    priorityUASTC: 1,
    needsPowerOfTwo: !1
  }, {
    if: "bptcSupported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.BC7_M5, r.BC7_M5],
    engineFormat: [i.RGBA_BPTC_Format, i.RGBA_BPTC_Format],
    priorityETC1S: 3,
    priorityUASTC: 2,
    needsPowerOfTwo: !1
  }, {
    if: "dxtSupported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.BC1, r.BC3],
    engineFormat: [i.RGB_S3TC_DXT1_Format, i.RGBA_S3TC_DXT5_Format],
    priorityETC1S: 4,
    priorityUASTC: 5,
    needsPowerOfTwo: !1
  }, {
    if: "etc2Supported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.ETC1, r.ETC2],
    engineFormat: [i.RGB_ETC2_Format, i.RGBA_ETC2_EAC_Format],
    priorityETC1S: 1,
    priorityUASTC: 3,
    needsPowerOfTwo: !1
  }, {
    if: "etc1Supported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.ETC1],
    engineFormat: [i.RGB_ETC1_Format],
    priorityETC1S: 2,
    priorityUASTC: 4,
    needsPowerOfTwo: !1
  }, {
    if: "pvrtcSupported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.PVRTC1_4_RGB, r.PVRTC1_4_RGBA],
    engineFormat: [i.RGB_PVRTC_4BPPV1_Format, i.RGBA_PVRTC_4BPPV1_Format],
    priorityETC1S: 5,
    priorityUASTC: 6,
    needsPowerOfTwo: !0
  }],
      o = a.sort(function (t, e) {
    return t.priorityETC1S - e.priorityETC1S;
  }),
      l = a.sort(function (t, e) {
    return t.priorityUASTC - e.priorityUASTC;
  });

  function h(t) {
    return t <= 2 || 0 == (t & t - 1) && 0 !== t;
  }
};
var Cc = Symbol("retainerCount"),
    Lc = Symbol("recentlyUsed"),
    Pc = Symbol("evict"),
    Dc = Symbol("evictionThreshold"),
    Ic = Symbol("cache");

var Oc = /*#__PURE__*/function (_ref8) {
  function Oc(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

    _classCallCheck(this, Oc);

    this[Ac] = new Map(), this[Rc] = [], this[Ic] = t, this[Dc] = e;
  }

  _createClass(Oc, [{
    key: "evictionThreshold",
    get: function get() {
      return this[Dc];
    },
    set: function set(t) {
      this[Dc] = t, this[Pc]();
    }
  }, {
    key: "cache",
    get: function get() {
      return this[Ic];
    }
  }, {
    key: "retainerCount",
    value: function retainerCount(t) {
      return this[Cc].get(t) || 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this[Cc].clear(), this[Lc] = [];
    }
  }, {
    key: "retain",
    value: function retain(t) {
      this[Cc].has(t) || this[Cc].set(t, 0), this[Cc].set(t, this[Cc].get(t) + 1);
      var e = this[Lc].indexOf(t);
      -1 !== e && this[Lc].splice(e, 1), this[Lc].unshift(t), this[Pc]();
    }
  }, {
    key: "release",
    value: function release(t) {
      this[Cc].has(t) && this[Cc].set(t, Math.max(this[Cc].get(t) - 1, 0)), this[Pc]();
    }
  }, {
    key: _ref8,
    value: function value() {
      if (!(this[Lc].length < this[Dc])) for (var _t341 = this[Lc].length - 1; _t341 >= this[Dc]; --_t341) {
        var _e299 = this[Lc][_t341];
        0 === this[Cc].get(_e299) && (this[Ic].delete(_e299), this[Lc].splice(_t341, 1));
      }
    }
  }]);

  return Oc;
}((Ac = Cc, Rc = Lc, Pc));
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Nc = function Nc(t) {
  var e = new Map();

  var _iterator10 = _createForOfIteratorHelper(t.mappings),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var _n274 = _step10.value;

      var _iterator11 = _createForOfIteratorHelper(_n274.variants),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _t342 = _step11.value;
          e.set(_t342, {
            material: null,
            gltfMaterialIndex: _n274.material
          });
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  return e;
};

var Fc = /*#__PURE__*/function () {
  function Fc(t) {
    _classCallCheck(this, Fc);

    this.parser = t, this.name = "KHR_materials_variants";
  }

  _createClass(Fc, [{
    key: "afterRoot",
    value: function afterRoot(t) {
      var _this110 = this;

      var e = this.parser,
          n = e.json;
      if (void 0 === n.extensions || void 0 === n.extensions[this.name]) return null;

      var i = function (t) {
        var e = [],
            n = new Set();

        var _iterator12 = _createForOfIteratorHelper(t),
            _step12;

        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _i220 = _step12.value;
            var _t343 = _i220,
                _r144 = 0;

            for (; n.has(_t343);) {
              _t343 = _i220 + "." + ++_r144;
            }

            n.add(_t343), e.push(_t343);
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }

        return e;
      }((n.extensions[this.name].variants || []).map(function (t) {
        return t.name;
      }));

      var _iterator13 = _createForOfIteratorHelper(t.scenes),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _i221 = _step13.value;

          _i221.traverse(function (t) {
            var i = t;
            if (!i.isMesh) return;
            var r = e.associations.get(i);
            if (null == r || null == r.meshes || null == r.primitives) return;
            var s = n.meshes[r.meshes].primitives[r.primitives].extensions;
            s && s[_this110.name] && (i.userData.variantMaterials = Nc(s[_this110.name]));
          });
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      return t.userData.variants = i, Promise.resolve();
    }
  }]);

  return Fc;
}();
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Uc, kc;
var Bc = new Map(),
    zc = new Map();
var Hc;
var Vc = new ( /*#__PURE__*/function (_ol10) {
  _inherits(_class24, _ol10);

  var _super121 = _createSuper(_class24);

  function _class24(t) {
    var _this111;

    _classCallCheck(this, _class24);

    _this111 = _super121.call(this, t), _this111.decoderPath = "", _this111.decoderConfig = {}, _this111.decoderBinary = null, _this111.decoderPending = null, _this111.workerLimit = 4, _this111.workerPool = [], _this111.workerNextTaskID = 1, _this111.workerSourceURL = "", _this111.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    }, _this111.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
    return _this111;
  }

  _createClass(_class24, [{
    key: "setDecoderPath",
    value: function setDecoderPath(t) {
      return this.decoderPath = t, this;
    }
  }, {
    key: "setDecoderConfig",
    value: function setDecoderConfig(t) {
      return this.decoderConfig = t, this;
    }
  }, {
    key: "setWorkerLimit",
    value: function setWorkerLimit(t) {
      return this.workerLimit = t, this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      var _this112 = this;

      var r = new hl(this.manager);
      r.setPath(this.path), r.setResponseType("arraybuffer"), r.setRequestHeader(this.requestHeader), r.setWithCredentials(this.withCredentials), r.load(t, function (t) {
        var n = {
          attributeIDs: _this112.defaultAttributeIDs,
          attributeTypes: _this112.defaultAttributeTypes,
          useUniqueIDs: !1
        };

        _this112.decodeGeometry(t, n).then(e).catch(i);
      }, n, i);
    }
  }, {
    key: "decodeDracoFile",
    value: function decodeDracoFile(t, e, n, i) {
      var r = {
        attributeIDs: n || this.defaultAttributeIDs,
        attributeTypes: i || this.defaultAttributeTypes,
        useUniqueIDs: !!n
      };
      this.decodeGeometry(t, r).then(e);
    }
  }, {
    key: "decodeGeometry",
    value: function decodeGeometry(t, e) {
      var _this113 = this;

      for (var _t344 in e.attributeTypes) {
        var _n275 = e.attributeTypes[_t344];
        void 0 !== _n275.BYTES_PER_ELEMENT && (e.attributeTypes[_t344] = _n275.name);
      }

      var n = JSON.stringify(e);

      if (bh.has(t)) {
        var _e300 = bh.get(t);

        if (_e300.key === n) return _e300.promise;
        if (0 === t.byteLength) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
      }

      var i;

      var r = this.workerNextTaskID++,
          s = t.byteLength,
          a = this._getWorker(r, s).then(function (n) {
        return i = n, new Promise(function (n, s) {
          i._callbacks[r] = {
            resolve: n,
            reject: s
          }, i.postMessage({
            type: "decode",
            id: r,
            taskConfig: e,
            buffer: t
          }, [t]);
        });
      }).then(function (t) {
        return _this113._createGeometry(t.geometry);
      });

      return a.catch(function () {
        return !0;
      }).then(function () {
        i && r && _this113._releaseTask(i, r);
      }), bh.set(t, {
        key: n,
        promise: a
      }), a;
    }
  }, {
    key: "_createGeometry",
    value: function _createGeometry(t) {
      var e = new vn();
      t.index && e.setIndex(new an(t.index.array, 1));

      for (var _n276 = 0; _n276 < t.attributes.length; _n276++) {
        var _i222 = t.attributes[_n276],
            _r145 = _i222.name,
            _s84 = _i222.array,
            _a65 = _i222.itemSize;
        e.setAttribute(_r145, new an(_s84, _a65));
      }

      return e;
    }
  }, {
    key: "_loadLibrary",
    value: function _loadLibrary(t, e) {
      var n = new hl(this.manager);
      return n.setPath(this.decoderPath), n.setResponseType(e), n.setWithCredentials(this.withCredentials), new Promise(function (e, i) {
        n.load(t, e, void 0, i);
      });
    }
  }, {
    key: "preload",
    value: function preload() {
      return this._initDecoder(), this;
    }
  }, {
    key: "_initDecoder",
    value: function _initDecoder() {
      var _this114 = this;

      if (this.decoderPending) return this.decoderPending;
      var t = "object" != typeof WebAssembly || "js" === this.decoderConfig.type,
          e = [];
      return t ? e.push(this._loadLibrary("draco_decoder.js", "text")) : (e.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), e.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(e).then(function (e) {
        var n = e[0];
        t || (_this114.decoderConfig.wasmBinary = e[1]);
        var i = wh.toString(),
            r = ["/* draco decoder */", n, "", "/* worker */", i.substring(i.indexOf("{") + 1, i.lastIndexOf("}"))].join("\n");
        _this114.workerSourceURL = URL.createObjectURL(new Blob([r]));
      }), this.decoderPending;
    }
  }, {
    key: "_getWorker",
    value: function _getWorker(t, e) {
      var _this115 = this;

      return this._initDecoder().then(function () {
        if (_this115.workerPool.length < _this115.workerLimit) {
          var _t345 = new Worker(_this115.workerSourceURL);

          _t345._callbacks = {}, _t345._taskCosts = {}, _t345._taskLoad = 0, _t345.postMessage({
            type: "init",
            decoderConfig: _this115.decoderConfig
          }), _t345.onmessage = function (e) {
            var n = e.data;

            switch (n.type) {
              case "decode":
                _t345._callbacks[n.id].resolve(n);

                break;

              case "error":
                _t345._callbacks[n.id].reject(n);

                break;

              default:
                console.error('THREE.DRACOLoader: Unexpected message, "' + n.type + '"');
            }
          }, _this115.workerPool.push(_t345);
        } else _this115.workerPool.sort(function (t, e) {
          return t._taskLoad > e._taskLoad ? -1 : 1;
        });

        var n = _this115.workerPool[_this115.workerPool.length - 1];
        return n._taskCosts[t] = e, n._taskLoad += e, n;
      });
    }
  }, {
    key: "_releaseTask",
    value: function _releaseTask(t, e) {
      t._taskLoad -= t._taskCosts[e], delete t._callbacks[e], delete t._taskCosts[e];
    }
  }, {
    key: "debug",
    value: function debug() {
      console.log("Task load: ", this.workerPool.map(function (t) {
        return t._taskLoad;
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      for (var _t346 = 0; _t346 < this.workerPool.length; ++_t346) {
        this.workerPool[_t346].terminate();
      }

      return this.workerPool.length = 0, this;
    }
  }]);

  return _class24;
}(ol))();
var Gc;
var Wc = new Ec();
var jc, qc;
var Xc = Symbol("loader"),
    Yc = Symbol("evictionPolicy"),
    Jc = Symbol("GLTFInstance");

var Zc = /*#__PURE__*/function (_et8, _ref9) {
  _inherits(Zc, _et8);

  var _super122 = _createSuper(Zc);

  function Zc(t) {
    var _this116;

    _classCallCheck(this, Zc);

    _this116 = _super122.call(this), _this116[kc] = new Mh().register(function (t) {
      return new Fc(t);
    }), _this116[Jc] = t, _this116[Xc].setDRACOLoader(Vc), _this116[Xc].setKTX2Loader(Wc);
    return _this116;
  }

  _createClass(Zc, [{
    key: _ref9,
    get: function get() {
      return this.constructor[Yc];
    }
  }, {
    key: "preload",
    value: function () {
      var _preload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t, e) {
        var n,
            _e301,
            _i223,
            _r146,
            _args6 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                n = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : function () {};

                if (!(this[Xc].setWithCredentials(Zc.withCredentials), this.dispatchEvent({
                  type: "preload",
                  element: e,
                  src: t
                }), !Bc.has(t))) {
                  _context6.next = 11;
                  break;
                }

                _context6.t0 = null != qc;

                if (!_context6.t0) {
                  _context6.next = 9;
                  break;
                }

                _context6.t1 = this[Xc];
                _context6.next = 7;
                return qc;

              case 7:
                _context6.t2 = _context6.sent;

                _context6.t1.setMeshoptDecoder.call(_context6.t1, _context6.t2);

              case 9:
                _e301 = function (t, e) {
                  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

                  var i = function i(t) {
                    var e = t.loaded / t.total;
                    n(Math.max(0, Math.min(1, isFinite(e) ? e : 1)));
                  };

                  return new Promise(function (n, r) {
                    e.load(t, n, i, r);
                  });
                }(t, this[Xc], function (t) {
                  n(.8 * t);
                }), _i223 = this[Jc], _r146 = _e301.then(function (t) {
                  return _i223.prepare(t);
                }).then(function (t) {
                  return n(.9), new _i223(t);
                }).catch(function (t) {
                  return console.error(t), new _i223();
                });
                Bc.set(t, _r146);

              case 11:
                _context6.next = 13;
                return Bc.get(t);

              case 13:
                zc.set(t, !0);
                n && n(1);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee3, this);
      }));

      function preload(_x6, _x7) {
        return _preload.apply(this, arguments);
      }

      return preload;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t, e) {
        var _this117 = this;

        var n,
            i,
            r,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                n = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : function () {};
                _context7.next = 3;
                return this.preload(t, e, n);

              case 3:
                _context7.next = 5;
                return Bc.get(t);

              case 5:
                i = _context7.sent;
                _context7.next = 8;
                return i.clone();

              case 8:
                r = _context7.sent;
                return _context7.abrupt("return", (this[Yc].retain(t), r.dispose = function () {
                  var e = r.dispose;
                  var n = !1;
                  return function () {
                    n || (n = !0, e.apply(r), _this117[Yc].release(t));
                  };
                }(), r));

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee4, this);
      }));

      function load(_x8, _x9) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }], [{
    key: "setDRACODecoderLocation",
    value: function setDRACODecoderLocation(t) {
      Hc = t, Vc.setDecoderPath(t);
    }
  }, {
    key: "getDRACODecoderLocation",
    value: function getDRACODecoderLocation() {
      return Hc;
    }
  }, {
    key: "setKTX2TranscoderLocation",
    value: function setKTX2TranscoderLocation(t) {
      Gc = t, Wc.setTranscoderPath(t);
    }
  }, {
    key: "getKTX2TranscoderLocation",
    value: function getKTX2TranscoderLocation() {
      return Gc;
    }
  }, {
    key: "setMeshoptDecoderLocation",
    value: function setMeshoptDecoderLocation(t) {
      var e;
      jc !== t && (jc = t, qc = (e = t, new Promise(function (t, n) {
        var i = document.createElement("script");
        document.body.appendChild(i), i.onload = t, i.onerror = n, i.async = !0, i.src = e;
      })).then(function () {
        return MeshoptDecoder.ready;
      }).then(function () {
        return MeshoptDecoder;
      }));
    }
  }, {
    key: "getMeshoptDecoderLocation",
    value: function getMeshoptDecoderLocation() {
      return jc;
    }
  }, {
    key: "initializeKTX2Loader",
    value: function initializeKTX2Loader(t) {
      Wc.detectSupport(t);
    }
  }, {
    key: "cache",
    get: function get() {
      return Bc;
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      var _this118 = this;

      Bc.forEach(function (t, e) {
        _this118.delete(e);
      }), this[Yc].reset();
    }
  }, {
    key: "has",
    value: function has(t) {
      return Bc.has(t);
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee5$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.has(t)) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                e = Bc.get(t);
                zc.delete(t), Bc.delete(t);
                _context8.next = 6;
                return e;

              case 6:
                _context8.sent.dispose();

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x10) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "hasFinishedLoading",
    value: function hasFinishedLoading(t) {
      return !!zc.get(t);
    }
  }]);

  return Zc;
}(et, (Uc = Yc, kc = Xc, Yc));

Zc[Uc] = new Oc(Zc);

var $c = /*#__PURE__*/function (_Ve12) {
  _inherits($c, _Ve12);

  var _super123 = _createSuper($c);

  function $c() {
    var _this119;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement("div");

    _classCallCheck(this, $c);

    _this119 = _super123.call(this), _this119.element = t, _this119.element.style.position = "absolute", _this119.element.style.userSelect = "none", _this119.element.setAttribute("draggable", !1), _this119.addEventListener("removed", function () {
      this.traverse(function (t) {
        t.element instanceof Element && null !== t.element.parentNode && t.element.parentNode.removeChild(t.element);
      });
    });
    return _this119;
  }

  _createClass($c, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf($c.prototype), "copy", this).call(this, t, e), this.element = t.element.cloneNode(!0), this;
    }
  }]);

  return $c;
}(Ve);

$c.prototype.isCSS2DObject = !0;
var Kc = new zt(),
    Qc = new ve(),
    tu = new ve(),
    eu = new zt(),
    nu = new zt();

var iu = function iu() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, iu);

  var e = this;
  var n, i, r, s;
  var a = {
    objects: new WeakMap()
  },
      o = void 0 !== t.element ? t.element : document.createElement("div");

  function l(t, n, i) {
    if (t.isCSS2DObject) {
      Kc.setFromMatrixPosition(t.matrixWorld), Kc.applyMatrix4(tu);

      var _l40 = !0 === t.visible && Kc.z >= -1 && Kc.z <= 1 && !0 === t.layers.test(i.layers);

      if (t.element.style.display = !0 === _l40 ? "" : "none", !0 === _l40) {
        t.onBeforeRender(e, n, i);
        var _a66 = t.element;
        /apple/i.test(navigator.vendor) ? _a66.style.transform = "translate(-50%,-50%) translate(" + Math.round(Kc.x * r + r) + "px," + Math.round(-Kc.y * s + s) + "px)" : _a66.style.transform = "translate(-50%,-50%) translate(" + (Kc.x * r + r) + "px," + (-Kc.y * s + s) + "px)", _a66.parentNode !== o && o.appendChild(_a66), t.onAfterRender(e, n, i);
      }

      var _c22 = {
        distanceToCameraSquared: h(i, t)
      };
      a.objects.set(t, _c22);
    }

    for (var _e302 = 0, _r147 = t.children.length; _e302 < _r147; _e302++) {
      l(t.children[_e302], n, i);
    }
  }

  function h(t, e) {
    return eu.setFromMatrixPosition(t.matrixWorld), nu.setFromMatrixPosition(e.matrixWorld), eu.distanceToSquared(nu);
  }

  o.style.overflow = "hidden", this.domElement = o, this.getSize = function () {
    return {
      width: n,
      height: i
    };
  }, this.render = function (t, e) {
    !0 === t.autoUpdate && t.updateMatrixWorld(), null === e.parent && e.updateMatrixWorld(), Qc.copy(e.matrixWorldInverse), tu.multiplyMatrices(e.projectionMatrix, Qc), l(t, t, e), function (t) {
      var e = function (t) {
        var e = [];
        return t.traverse(function (t) {
          t.isCSS2DObject && e.push(t);
        }), e;
      }(t).sort(function (t, e) {
        if (t.renderOrder !== e.renderOrder) return e.renderOrder - t.renderOrder;
        return a.objects.get(t).distanceToCameraSquared - a.objects.get(e).distanceToCameraSquared;
      }),
          n = e.length;

      for (var _t347 = 0, _i224 = e.length; _t347 < _i224; _t347++) {
        e[_t347].element.style.zIndex = n - _t347;
      }
    }(t);
  }, this.setSize = function (t, e) {
    n = t, i = e, r = n / 2, s = i / 2, o.style.width = t + "px", o.style.height = e + "px";
  };
};
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ru = function ru(t) {
  return t && "null" !== t ? au(t) : null;
},
    su = function su() {
  if (ph) return;
  var t = [];
  throw hh || t.push("WebXR Device API"), ch || t.push("WebXR Hit Test API"), new Error("The following APIs are required for AR, but are missing in this browser: ".concat(t.join(", ")));
},
    au = function au(t) {
  return new URL(t, window.location.toString()).toString();
},
    ou = function ou(t, e) {
  var n = null;
  return function () {
    for (var _len2 = arguments.length, i = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      i[_key2] = arguments[_key2];
    }

    null != n && self.clearTimeout(n), n = self.setTimeout(function () {
      n = null, t.apply(void 0, i);
    }, e);
  };
},
    lu = function lu(t, e, n) {
  return Math.max(e, Math.min(n, t));
},
    hu = function () {
  var t = function () {
    var t;
    if (null === (t = document.documentElement.getAttribute("itemtype")) || void 0 === t ? void 0 : t.includes("schema.org/SearchResultsPage")) return !0;
    var e = null != document.head ? Array.from(document.head.querySelectorAll("meta")) : [];

    var _iterator14 = _createForOfIteratorHelper(e),
        _step14;

    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var _t348 = _step14.value;
        if ("viewport" === _t348.name) return !0;
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }

    return !1;
  }();

  return t || console.warn('No <meta name="viewport"> detected; <model-viewer> will cap pixel density at 1.'), function () {
    return t ? window.devicePixelRatio : 1;
  };
}(),
    cu = function () {
  var t = new RegExp("[?&]model-viewer-debug-mode(&|$)");
  return function () {
    return self.ModelViewerElement && self.ModelViewerElement.debugMode || self.location && self.location.search && self.location.search.match(t);
  };
}(),
    uu = function uu() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (e) {
    return setTimeout(e, t);
  });
};

var du = /*#__PURE__*/function () {
  function du() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

    _classCallCheck(this, du);

    this.velocity = 0, this.naturalFrequency = 0, this.setDecayTime(t);
  }

  _createClass(du, [{
    key: "setDecayTime",
    value: function setDecayTime(t) {
      this.naturalFrequency = 1 / Math.max(.001, t);
    }
  }, {
    key: "update",
    value: function update(t, e, n, i) {
      var r = 2e-4 * this.naturalFrequency;
      if (null == t || 0 === i) return e;
      if (t === e && 0 === this.velocity) return e;
      if (n < 0) return t;
      var s = t - e,
          a = this.velocity + this.naturalFrequency * s,
          o = s + n * a,
          l = Math.exp(-this.naturalFrequency * n),
          h = (a - this.naturalFrequency * o) * l,
          c = -this.naturalFrequency * (h + a * l);
      return Math.abs(h) < r * Math.abs(i) && c * s >= 0 ? (this.velocity = 0, e) : (this.velocity = h, e + o * l);
    }
  }]);

  return du;
}();
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var pu = function pu(t, e) {
  return {
    type: "number",
    number: t,
    unit: e
  };
},
    mu = function () {
  var t = {};
  return function (e) {
    var n = e;
    if (n in t) return t[n];
    var i = [];
    var r = 0;

    for (; e;) {
      if (++r > 1e3) {
        e = "";
        break;
      }

      var _t349 = fu(e),
          _n277 = _t349.nodes[0];

      if (null == _n277 || 0 === _n277.terms.length) break;
      i.push(_n277), e = _t349.remainingInput;
    }

    return t[n] = i;
  };
}(),
    fu = function () {
  var t = /^(\-\-|[a-z\u0240-\uffff])/i,
      e = /^([\*\+\/]|[\-]\s)/i,
      n = /^[\),]/;
  return function (i) {
    var r = [];

    for (; i.length && (i = i.trim(), !n.test(i));) {
      if ("(" === i[0]) {
        var _xu = xu(i),
            _t350 = _xu.nodes,
            _e303 = _xu.remainingInput;

        i = _e303, r.push({
          type: "function",
          name: {
            type: "ident",
            value: "calc"
          },
          arguments: _t350
        });
      } else if (t.test(i)) {
        var _t351 = gu(i),
            _e304 = _t351.nodes[0];

        if ("(" === (i = _t351.remainingInput)[0]) {
          var _xu2 = xu(i),
              _t352 = _xu2.nodes,
              _n278 = _xu2.remainingInput;

          r.push({
            type: "function",
            name: _e304,
            arguments: _t352
          }), i = _n278;
        } else r.push(_e304);
      } else if (e.test(i)) r.push({
        type: "operator",
        value: i[0]
      }), i = i.slice(1);else {
        var _ref10 = "#" === i[0] ? yu(i) : vu(i),
            _t353 = _ref10.nodes,
            _e305 = _ref10.remainingInput;

        if (0 === _t353.length) break;
        r.push(_t353[0]), i = _e305;
      }
    }

    return {
      nodes: [{
        type: "expression",
        terms: r
      }],
      remainingInput: i
    };
  };
}(),
    gu = function () {
  var t = /[^a-z0-9_\-\u0240-\uffff]/i;
  return function (e) {
    var n = e.match(t);
    return {
      nodes: [{
        type: "ident",
        value: null == n ? e : e.substr(0, n.index)
      }],
      remainingInput: null == n ? "" : e.substr(n.index)
    };
  };
}(),
    vu = function () {
  var t = /[\+\-]?(\d+[\.]\d+|\d+|[\.]\d+)([eE][\+\-]?\d+)?/,
      e = /^[a-z%]+/i,
      n = /^(m|mm|cm|rad|deg|[%])$/;
  return function (i) {
    var r = i.match(t),
        s = null == r ? "0" : r[0],
        a = (i = null == s ? i : i.slice(s.length)).match(e);
    var o = null != a && "" !== a[0] ? a[0] : null;
    var l = null == a ? i : i.slice(o.length);
    return null == o || n.test(o) || (o = null), {
      nodes: [{
        type: "number",
        number: parseFloat(s) || 0,
        unit: o
      }],
      remainingInput: l
    };
  };
}(),
    yu = function () {
  var t = /^[a-f0-9]*/i;
  return function (e) {
    var n = (e = e.slice(1).trim()).match(t);
    return {
      nodes: null == n ? [] : [{
        type: "hex",
        value: n[0]
      }],
      remainingInput: null == n ? e : e.slice(n[0].length)
    };
  };
}(),
    xu = function xu(t) {
  var e = [];

  for (t = t.slice(1).trim(); t.length;) {
    var _n279 = fu(t);

    if (e.push(_n279.nodes[0]), "," === (t = _n279.remainingInput.trim())[0]) t = t.slice(1).trim();else if (")" === t[0]) {
      t = t.slice(1);
      break;
    }
  }

  return {
    nodes: e,
    remainingInput: t
  };
},
    _u = Symbol("visitedTypes");

var bu = /*#__PURE__*/function () {
  function bu(t) {
    _classCallCheck(this, bu);

    this[_u] = t;
  }

  _createClass(bu, [{
    key: "walk",
    value: function walk(t, e) {
      var n = t.slice();

      for (; n.length;) {
        var _t354 = n.shift();

        switch (this[_u].indexOf(_t354.type) > -1 && e(_t354), _t354.type) {
          case "expression":
            n.unshift.apply(n, _toConsumableArray(_t354.terms));
            break;

          case "function":
            n.unshift.apply(n, [_t354.name].concat(_toConsumableArray(_t354.arguments)));
        }
      }
    }
  }]);

  return bu;
}();

var wu = Object.freeze({
  type: "number",
  number: 0,
  unit: null
}),
    Mu = function Mu(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n = t.number,
      i = t.unit;

  if (isFinite(n)) {
    if ("rad" === t.unit || null == t.unit) return t;
  } else n = e, i = "rad";

  return {
    type: "number",
    number: ("deg" === i && null != n ? n : 0) * Math.PI / 180,
    unit: "rad"
  };
},
    Su = function Su(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n,
      i = t.number,
      r = t.unit;

  if (isFinite(i)) {
    if ("m" === t.unit) return t;
  } else i = e, r = "m";

  switch (r) {
    default:
      n = 1;
      break;

    case "cm":
      n = .01;
      break;

    case "mm":
      n = .001;
  }

  return {
    type: "number",
    number: n * i,
    unit: "m"
  };
},
    Tu = function () {
  var t = function t(_t355) {
    return _t355;
  },
      e = {
    rad: t,
    deg: Mu,
    m: t,
    mm: Su,
    cm: Su
  };

  return function (t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : wu;
    isFinite(t.number) || (t.number = n.number, t.unit = n.unit);
    var i = t.unit;
    if (null == i) return t;
    var r = e[i];
    return null == r ? n : r(t);
  };
}();
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Eu = /*#__PURE__*/function (_$c) {
  _inherits(Eu, _$c);

  var _super124 = _createSuper(Eu);

  function Eu(t) {
    var _this120;

    _classCallCheck(this, Eu);

    _this120 = _super124.call(this, document.createElement("div")), _this120.normal = new zt(0, 1, 0), _this120.initialized = !1, _this120.referenceCount = 1, _this120.pivot = document.createElement("div"), _this120.slot = document.createElement("slot"), _this120.element.classList.add("annotation-wrapper"), _this120.slot.name = t.name, _this120.element.appendChild(_this120.pivot), _this120.pivot.appendChild(_this120.slot), _this120.updatePosition(t.position), _this120.updateNormal(t.normal);
    return _this120;
  }

  _createClass(Eu, [{
    key: "facingCamera",
    get: function get() {
      return !this.element.classList.contains("hide");
    }
  }, {
    key: "show",
    value: function show() {
      this.facingCamera && this.initialized || this.updateVisibility(!0);
    }
  }, {
    key: "hide",
    value: function hide() {
      !this.facingCamera && this.initialized || this.updateVisibility(!1);
    }
  }, {
    key: "increment",
    value: function increment() {
      this.referenceCount++;
    }
  }, {
    key: "decrement",
    value: function decrement() {
      return this.referenceCount > 0 && --this.referenceCount, 0 === this.referenceCount;
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(t) {
      if (null == t) return;
      var e = mu(t)[0].terms;

      for (var _t356 = 0; _t356 < 3; ++_t356) {
        this.position.setComponent(_t356, Tu(e[_t356]).number);
      }

      this.updateMatrixWorld();
    }
  }, {
    key: "updateNormal",
    value: function updateNormal(t) {
      if (null == t) return;
      var e = mu(t)[0].terms;

      for (var _t357 = 0; _t357 < 3; ++_t357) {
        this.normal.setComponent(_t357, Tu(e[_t357]).number);
      }
    }
  }, {
    key: "orient",
    value: function orient(t) {
      this.pivot.style.transform = "rotate(".concat(t, "rad)");
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility(t) {
      t ? this.element.classList.remove("hide") : this.element.classList.add("hide"), this.slot.assignedNodes().forEach(function (e) {
        if (e.nodeType !== Node.ELEMENT_NODE) return;
        var n = e,
            i = n.dataset.visibilityAttribute;

        if (null != i) {
          var _e306 = "data-".concat(i);

          t ? n.setAttribute(_e306, "") : n.removeAttribute(_e306);
        }

        n.dispatchEvent(new CustomEvent("hotspot-visibility", {
          detail: {
            visible: t
          }
        }));
      }), this.initialized = !0;
    }
  }]);

  return Eu;
}($c);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Au = function Au(t, e, n) {
  var i = n;
  var r = new zt();
  return t.traverseVisible(function (t) {
    var n, s;
    t.updateWorldMatrix(!1, !1);
    var a = t.geometry;
    if (void 0 !== a) if (a.isGeometry) {
      var _o38 = a.vertices;

      for (n = 0, s = _o38.length; n < s; n++) {
        r.copy(_o38[n]), t.isSkinnedMesh ? t.boneTransform(n, r) : r.applyMatrix4(t.matrixWorld), i = e(i, r);
      }
    } else if (a.isBufferGeometry) {
      var _o39 = a.attributes.position;

      if (void 0 !== _o39) {
        var _a67 = function (t) {
          if (!t.normalized) return 1;
          var e = t.array;
          return e instanceof Int8Array ? 1 / 127 : e instanceof Uint8Array ? 1 / 255 : e instanceof Int16Array ? 1 / 32767 : e instanceof Uint16Array ? 1 / 65535 : 1;
        }(_o39);

        for (n = 0, s = _o39.count; n < s; n++) {
          r.fromBufferAttribute(_o39, n), r.multiplyScalar(_a67), t.isSkinnedMesh ? t.boneTransform(n, r) : r.applyMatrix4(t.matrixWorld), i = e(i, r);
        }
      }
    }
  }), i;
},
    Ru = {
  uniforms: {
    tDiffuse: {
      value: null
    },
    h: {
      value: 1 / 512
    }
  },
  vertexShader: "\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvUv = uv;\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n\t\t}",
  fragmentShader: "\n\n\t\tuniform sampler2D tDiffuse;\n\t\tuniform float h;\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvec4 sum = vec4( 0.0 );\n\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 4.0 * h, vUv.y ) ) * 0.051;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 3.0 * h, vUv.y ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 2.0 * h, vUv.y ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 1.0 * h, vUv.y ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y ) ) * 0.1633;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 1.0 * h, vUv.y ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 2.0 * h, vUv.y ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 3.0 * h, vUv.y ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 4.0 * h, vUv.y ) ) * 0.051;\n\n\t\t\tgl_FragColor = sum;\n\n\t\t}"
},
    Cu = {
  uniforms: {
    tDiffuse: {
      value: null
    },
    v: {
      value: 1 / 512
    }
  },
  vertexShader: "\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvUv = uv;\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n\t\t}",
  fragmentShader: "\n\n\t\tuniform sampler2D tDiffuse;\n\t\tuniform float v;\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvec4 sum = vec4( 0.0 );\n\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 4.0 * v ) ) * 0.051;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 3.0 * v ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 2.0 * v ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 1.0 * v ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y ) ) * 0.1633;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 1.0 * v ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 2.0 * v ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 3.0 * v ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 4.0 * v ) ) * 0.051;\n\n\t\t\tgl_FragColor = sum;\n\n\t\t}"
},
    Lu = [];

for (var _t358 = 0; _t358 < 256; _t358++) {
  Lu[_t358] = (_t358 < 16 ? "0" : "") + _t358.toString(16);
}

function Pu(t, e, n) {
  return (1 - n) * t + n * e;
}
/* @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Du = /*#__PURE__*/function (_Ve13) {
  _inherits(Du, _Ve13);

  var _super125 = _createSuper(Du);

  function Du(t, e, n) {
    var _this121;

    _classCallCheck(this, Du);

    _this121 = _super125.call(this), _this121.camera = new di(), _this121.renderTarget = null, _this121.renderTargetBlur = null, _this121.depthMaterial = new xs(), _this121.horizontalBlurMaterial = new Hn(Ru), _this121.verticalBlurMaterial = new Hn(Cu), _this121.intensity = 0, _this121.softness = 1, _this121.boundingBox = new Gt(), _this121.size = new zt(), _this121.maxDimension = 0, _this121.isAnimated = !1, _this121.needsUpdate = !1;

    var _assertThisInitialize = _assertThisInitialized(_this121),
        i = _assertThisInitialize.camera;

    i.rotation.x = Math.PI / 2, i.left = -.5, i.right = .5, i.bottom = -.5, i.top = .5, _this121.add(i);
    var r = new ni(),
        s = new nn({
      opacity: 1,
      transparent: !0,
      side: 1
    });
    _this121.floor = new Nn(r, s), _this121.floor.userData.shadow = !0, i.add(_this121.floor), _this121.blurPlane = new Nn(r), _this121.blurPlane.visible = !1, i.add(_this121.blurPlane), t.target.add(_assertThisInitialized(_this121)), _this121.depthMaterial.onBeforeCompile = function (t) {
      t.fragmentShader = t.fragmentShader.replace("gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );", "gl_FragColor = vec4( vec3( 0.0 ), ( 1.0 - fragCoordZ ) * opacity );");
    }, _this121.horizontalBlurMaterial.depthTest = !1, _this121.verticalBlurMaterial.depthTest = !1, _this121.setScene(t, e, n);
    return _this121;
  }

  _createClass(Du, [{
    key: "setScene",
    value: function setScene(t, e, n) {
      var i = this.boundingBox,
          r = this.size,
          s = this.rotation,
          a = this.position;

      if (this.isAnimated = t.animationNames.length > 0, this.boundingBox.copy(t.boundingBox), this.size.copy(t.size), this.maxDimension = Math.max(r.x, r.y, r.z) * (this.isAnimated ? 2 : 1), this.boundingBox.getCenter(a), "back" === n) {
        var _ref11, _ref12, _ref13;

        var _t359 = i.min,
            _e307 = i.max;
        (_ref11 = [_t359.z, _t359.y], _t359.y = _ref11[0], _t359.z = _ref11[1], _ref11), (_ref12 = [_e307.z, _e307.y], _e307.y = _ref12[0], _e307.z = _ref12[1], _ref12), (_ref13 = [r.z, r.y], r.y = _ref13[0], r.z = _ref13[1], _ref13), s.x = Math.PI / 2, s.y = Math.PI;
      } else s.x = 0, s.y = 0;

      if (this.isAnimated) {
        var _t360 = i.min.y,
            _e308 = i.max.y;
        r.y = this.maxDimension, i.expandByVector(r.subScalar(this.maxDimension).multiplyScalar(-.5)), i.min.y = _t360, i.max.y = _e308, r.set(this.maxDimension, _e308 - _t360, this.maxDimension);
      }

      "bottom" === n ? a.y = i.min.y : a.z = i.min.y, this.setSoftness(e);
    }
  }, {
    key: "setSoftness",
    value: function setSoftness(t) {
      this.softness = t;
      var e = this.size,
          n = this.camera,
          i = this.isAnimated ? 2 : 1,
          r = i * Math.pow(2, 9 - 3 * t);
      this.setMapSize(r);
      var s = e.y / 2,
          a = e.y * i;
      n.near = 0, n.far = Pu(a, s, t), this.depthMaterial.opacity = 1 / t, n.updateProjectionMatrix(), this.setIntensity(this.intensity), this.setOffset(0);
    }
  }, {
    key: "setMapSize",
    value: function setMapSize(t) {
      var e = this.size;
      this.isAnimated && (t *= 2);
      var n = Math.floor(e.x > e.z ? t : t * e.x / e.z),
          i = Math.floor(e.x > e.z ? t * e.z / e.x : t),
          r = 10 + n,
          s = 10 + i;

      if (null == this.renderTarget || this.renderTarget.width === r && this.renderTarget.height === s || (this.renderTarget.dispose(), this.renderTarget = null, this.renderTargetBlur.dispose(), this.renderTargetBlur = null), null == this.renderTarget) {
        var _t361 = {
          format: 1023
        };
        this.renderTarget = new Ft(r, s, _t361), this.renderTargetBlur = new Ft(r, s, _t361), this.floor.material.map = this.renderTarget.texture;
      }

      this.camera.scale.set(e.x * (1 + 10 / n), e.z * (1 + 10 / i), 1), this.needsUpdate = !0;
    }
  }, {
    key: "setIntensity",
    value: function setIntensity(t) {
      this.intensity = t, t > 0 ? (this.visible = !0, this.floor.visible = !0, this.floor.material.opacity = t * Pu(.3, 1, this.softness * this.softness)) : (this.visible = !1, this.floor.visible = !1);
    }
  }, {
    key: "getIntensity",
    value: function getIntensity() {
      return this.intensity;
    }
  }, {
    key: "setOffset",
    value: function setOffset(t) {
      this.floor.position.z = -t + .001 * this.maxDimension;
    }
  }, {
    key: "render",
    value: function render(t, e) {
      e.overrideMaterial = this.depthMaterial;
      var n = t.getClearAlpha();
      t.setClearAlpha(0), this.floor.visible = !1;
      var i = t.xr.enabled;
      t.xr.enabled = !1;
      var r = t.getRenderTarget();
      t.setRenderTarget(this.renderTarget), t.render(e, this.camera), e.overrideMaterial = null, this.floor.visible = !0, this.blurShadow(t), t.xr.enabled = i, t.setRenderTarget(r), t.setClearAlpha(n);
    }
  }, {
    key: "blurShadow",
    value: function blurShadow(t) {
      var e = this.camera,
          n = this.horizontalBlurMaterial,
          i = this.verticalBlurMaterial,
          r = this.renderTarget,
          s = this.renderTargetBlur,
          a = this.blurPlane;
      a.visible = !0, a.material = n, n.uniforms.h.value = 1 / this.renderTarget.width, n.uniforms.tDiffuse.value = this.renderTarget.texture, t.setRenderTarget(s), t.render(a, e), a.material = i, i.uniforms.v.value = 1 / this.renderTarget.height, i.uniforms.tDiffuse.value = this.renderTargetBlur.texture, t.setRenderTarget(r), t.render(a, e), a.visible = !1;
    }
  }]);

  return Du;
}(Ve);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Iu = new zt(),
    Ou = new zt(),
    Nu = new zt(),
    Fu = new ( /*#__PURE__*/function () {
  function _class25(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1 / 0;

    _classCallCheck(this, _class25);

    this.ray = new ge(t, e), this.near = n, this.far = i, this.camera = null, this.layers = new Re(), this.params = {
      Mesh: {},
      Line: {
        threshold: 1
      },
      LOD: {},
      Points: {
        threshold: 1
      },
      Sprite: {}
    };
  }

  _createClass(_class25, [{
    key: "set",
    value: function set(t, e) {
      this.ray.set(t, e);
    }
  }, {
    key: "setFromCamera",
    value: function setFromCamera(t, e) {
      e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
  }, {
    key: "intersectObject",
    value: function intersectObject(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return Yl(t, this, n, e), n.sort(Xl), n;
    }
  }, {
    key: "intersectObjects",
    value: function intersectObjects(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      for (var _i225 = 0, _r148 = t.length; _i225 < _r148; _i225++) {
        Yl(t[_i225], this, n, e);
      }

      return n.sort(Xl), n;
    }
  }]);

  return _class25;
}())(),
    Uu = new zt(),
    ku = new mt();

var Bu = /*#__PURE__*/function (_Is) {
  _inherits(Bu, _Is);

  var _super126 = _createSuper(Bu);

  function Bu(_ref14) {
    var _this122;

    var t = _ref14.canvas,
        e = _ref14.element,
        n = _ref14.width,
        i = _ref14.height;

    _classCallCheck(this, Bu);

    _this122 = _super126.call(this), _this122.context = null, _this122.annotationRenderer = new iu(), _this122.schemaElement = document.createElement("script"), _this122.width = 1, _this122.height = 1, _this122.aspect = 1, _this122.renderCount = 0, _this122.externalRenderer = null, _this122.camera = new Gn(45, 1, .1, 100), _this122.xrCamera = null, _this122.url = null, _this122.target = new Ve(), _this122.modelContainer = new Ve(), _this122.animationNames = [], _this122.boundingBox = new Gt(), _this122.boundingSphere = new le(), _this122.size = new zt(), _this122.idealAspect = 0, _this122.framedFoVDeg = 0, _this122.shadow = null, _this122.shadowIntensity = 0, _this122.shadowSoftness = 1, _this122.bakedShadows = Array(), _this122.exposure = 1, _this122.canScale = !0, _this122.tightBounds = !1, _this122.isDirty = !1, _this122.goalTarget = new zt(), _this122.targetDamperX = new du(), _this122.targetDamperY = new du(), _this122.targetDamperZ = new du(), _this122._currentGLTF = null, _this122.cancelPendingSourceChange = null, _this122.animationsByName = new Map(), _this122.currentAnimationAction = null, _this122.name = "ModelScene", _this122.element = e, _this122.canvas = t, _this122.camera = new Gn(45, 1, .1, 100), _this122.camera.name = "MainCamera", _this122.add(_this122.target), _this122.setSize(n, i), _this122.target.name = "Target", _this122.modelContainer.name = "ModelContainer", _this122.target.add(_this122.modelContainer), _this122.mixer = new ql(_this122.modelContainer);
    var r = _this122.annotationRenderer.domElement,
        s = r.style;
    s.display = "none", s.pointerEvents = "none", s.position = "absolute", s.top = "0", _this122.element.shadowRoot.querySelector(".default").appendChild(r), _this122.schemaElement.setAttribute("type", "application/ld+json");
    return _this122;
  }

  _createClass(Bu, [{
    key: "createContext",
    value: function createContext() {
      this.context = this.canvas.getContext("2d");
    }
  }, {
    key: "getCamera",
    value: function getCamera() {
      return null != this.xrCamera ? this.xrCamera : this.camera;
    }
  }, {
    key: "queueRender",
    value: function queueRender() {
      this.isDirty = !0;
    }
  }, {
    key: "shouldRender",
    value: function shouldRender() {
      return this.isDirty;
    }
  }, {
    key: "hasRendered",
    value: function hasRendered() {
      this.isDirty = !1;
    }
  }, {
    key: "setObject",
    value: function () {
      var _setObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t) {
        return _regeneratorRuntime.wrap(function _callee6$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.reset();
                this.modelContainer.add(t);
                _context9.next = 4;
                return this.setupScene();

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee6, this);
      }));

      function setObject(_x11) {
        return _setObject.apply(this, arguments);
      }

      return setObject;
    }()
  }, {
    key: "setSource",
    value: function () {
      var _setSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t) {
        var _this123 = this;

        var e,
            _t362,
            n,
            _n280,
            i,
            r,
            s,
            _iterator15,
            _step15,
            _t363,
            _args11 = arguments;

        return _regeneratorRuntime.wrap(function _callee8$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                e = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : function () {};

                if (!(!t || t === this.url)) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt("return", void e(1));

              case 3:
                if (!(this.reset(), this.url = t, null != this.externalRenderer)) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 6;
                return this.externalRenderer.load(e);

              case 6:
                _t362 = _context11.sent;
                return _context11.abrupt("return", (this.boundingSphere.radius = _t362.framedRadius, this.idealAspect = _t362.fieldOfViewAspect, void this.dispatchEvent({
                  type: "model-load",
                  url: this.url
                })));

              case 8:
                null != this.cancelPendingSourceChange && (this.cancelPendingSourceChange(), this.cancelPendingSourceChange = null);
                _context11.prev = 9;
                _context11.next = 12;
                return new Promise( /*#__PURE__*/function () {
                  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(n, i) {
                    return _regeneratorRuntime.wrap(function _callee7$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _this123.cancelPendingSourceChange = function () {
                              return i();
                            };

                            _context10.prev = 1;
                            _context10.t0 = n;
                            _context10.next = 5;
                            return _this123.element[Ep].loader.load(t, _this123.element, e);

                          case 5:
                            _context10.t1 = _context10.sent;
                            (0, _context10.t0)(_context10.t1);
                            _context10.next = 12;
                            break;

                          case 9:
                            _context10.prev = 9;
                            _context10.t2 = _context10["catch"](1);
                            i(_context10.t2);

                          case 12:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee7, null, [[1, 9]]);
                  }));

                  return function (_x13, _x14) {
                    return _ref15.apply(this, arguments);
                  };
                }());

              case 12:
                n = _context11.sent;
                _context11.next = 20;
                break;

              case 15:
                _context11.prev = 15;
                _context11.t0 = _context11["catch"](9);

                if (!(null == _context11.t0)) {
                  _context11.next = 19;
                  break;
                }

                return _context11.abrupt("return");

              case 19:
                throw _context11.t0;

              case 20:
                this.reset(), this.url = t, this._currentGLTF = n, null != n && this.modelContainer.add(n.scene);
                _n280 = n, i = _n280.animations, r = new Map(), s = [];
                _iterator15 = _createForOfIteratorHelper(i);

                try {
                  for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                    _t363 = _step15.value;
                    r.set(_t363.name, _t363), s.push(_t363.name);
                  }
                } catch (err) {
                  _iterator15.e(err);
                } finally {
                  _iterator15.f();
                }

                this.animations = i;
                this.animationsByName = r;
                this.animationNames = s;
                _context11.next = 29;
                return this.setupScene();

              case 29:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee8, this, [[9, 15]]);
      }));

      function setSource(_x12) {
        return _setSource.apply(this, arguments);
      }

      return setSource;
    }()
  }, {
    key: "setupScene",
    value: function () {
      var _setupScene = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.updateBoundingBox();
                _context12.next = 3;
                return this.updateFraming();

              case 3:
                this.updateShadow();
                this.setShadowIntensity(this.shadowIntensity);
                this.dispatchEvent({
                  type: "model-load",
                  url: this.url
                });

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee9, this);
      }));

      function setupScene() {
        return _setupScene.apply(this, arguments);
      }

      return setupScene;
    }()
  }, {
    key: "reset",
    value: function reset() {
      this.url = null, this.queueRender(), null != this.shadow && this.shadow.setIntensity(0);
      var t = this._currentGLTF;

      if (null != t) {
        var _iterator16 = _createForOfIteratorHelper(this.modelContainer.children),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _t364 = _step16.value;
            this.modelContainer.remove(_t364);
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }

        t.dispose(), this._currentGLTF = null;
      }

      null != this.currentAnimationAction && (this.currentAnimationAction.stop(), this.currentAnimationAction = null), this.mixer.stopAllAction(), this.mixer.uncacheRoot(this);
    }
  }, {
    key: "currentGLTF",
    get: function get() {
      return this._currentGLTF;
    }
  }, {
    key: "setSize",
    value: function setSize(t, e) {
      if (this.width !== t || this.height !== e) {
        if (this.width = Math.max(t, 1), this.height = Math.max(e, 1), this.annotationRenderer.setSize(t, e), this.aspect = this.width / this.height, null != this.externalRenderer) {
          var n = hu();
          this.externalRenderer.resize(t * n, e * n);
        }

        this.queueRender();
      }
    }
  }, {
    key: "findBakedShadows",
    value: function findBakedShadows(t) {
      var _this124 = this;

      var e = new Gt();
      t.traverse(function (t) {
        var n = t;
        if (!n.isMesh) return;
        var i = n.material;
        if (!i.isMeshBasicMaterial || !i.transparent) return;
        e.setFromObject(n);
        var r = e.getSize(Uu),
            s = Math.min(r.x, r.y, r.z);
        Math.max(r.x, r.y, r.z) < 100 * s || (_this124.bakedShadows.push(n), n.userData.shadow = !0);
      });
    }
  }, {
    key: "updateBoundingBox",
    value: function updateBoundingBox() {
      if (this.target.remove(this.modelContainer), this.findBakedShadows(this.modelContainer), !0 === this.tightBounds) {
        var _t365 = function _t365(t, e) {
          return t.expandByPoint(e);
        };

        this.setBakedShadowVisibility(!1), this.boundingBox = Au(this.modelContainer, _t365, new Gt()), this.boundingBox.isEmpty() && (this.setBakedShadowVisibility(!0), this.bakedShadows = [], this.boundingBox = Au(this.modelContainer, _t365, new Gt())), this.setBakedShadowVisibility();
      } else this.boundingBox.setFromObject(this.modelContainer);

      this.boundingBox.getSize(this.size), this.target.add(this.modelContainer);
    }
  }, {
    key: "updateFraming",
    value: function () {
      var _updateFraming = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this125 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee10$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.target.remove(this.modelContainer), this.setBakedShadowVisibility(!1);
                t = this.boundingSphere.center;

                if (!(!0 === this.tightBounds)) {
                  _context13.next = 8;
                  break;
                }

                _context13.next = 5;
                return this.element.requestUpdate("cameraTarget");

              case 5:
                t.copy(this.getTarget());
                _context13.next = 9;
                break;

              case 8:
                this.boundingBox.getCenter(t);

              case 9:
                this.boundingSphere.radius = Math.sqrt(Au(this.modelContainer, function (e, n) {
                  return Math.max(e, t.distanceToSquared(n));
                }, 0));
                this.idealAspect = Au(this.modelContainer, function (e, n) {
                  n.sub(t);
                  var i = Math.sqrt(n.x * n.x + n.z * n.z);
                  return Math.max(e, i / (_this125.idealCameraDistance() - Math.abs(n.y)));
                }, 0) / Math.tan(this.framedFoVDeg / 2 * Math.PI / 180), this.setBakedShadowVisibility(), this.target.add(this.modelContainer);

              case 11:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateFraming() {
        return _updateFraming.apply(this, arguments);
      }

      return updateFraming;
    }()
  }, {
    key: "setBakedShadowVisibility",
    value: function setBakedShadowVisibility() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.shadowIntensity <= 0;

      var _iterator17 = _createForOfIteratorHelper(this.bakedShadows),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _e309 = _step17.value;
          _e309.visible = t;
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }, {
    key: "idealCameraDistance",
    value: function idealCameraDistance() {
      var t = this.framedFoVDeg / 2 * Math.PI / 180;
      return this.boundingSphere.radius / Math.sin(t);
    }
  }, {
    key: "adjustedFoV",
    value: function adjustedFoV(t) {
      var e = Math.tan(t / 2 * Math.PI / 180) * Math.max(1, this.idealAspect / this.aspect);
      return 2 * Math.atan(e) * 180 / Math.PI;
    }
  }, {
    key: "getNDC",
    value: function getNDC(t, e) {
      if (null != this.xrCamera) ku.set(t / window.screen.width, e / window.screen.height);else {
        var n = this.element.getBoundingClientRect();
        ku.set((t - n.x) / this.width, (e - n.y) / this.height);
      }
      return ku.multiplyScalar(2).subScalar(1), ku.y *= -1, ku;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return {
        width: this.width,
        height: this.height
      };
    }
  }, {
    key: "setTarget",
    value: function setTarget(t, e, n) {
      this.goalTarget.set(-t, -e, -n);
    }
  }, {
    key: "setTargetDamperDecayTime",
    value: function setTargetDamperDecayTime(t) {
      this.targetDamperX.setDecayTime(t), this.targetDamperY.setDecayTime(t), this.targetDamperZ.setDecayTime(t);
    }
  }, {
    key: "getTarget",
    value: function getTarget() {
      return Uu.copy(this.goalTarget).multiplyScalar(-1);
    }
  }, {
    key: "jumpToGoal",
    value: function jumpToGoal() {
      this.updateTarget(1e4);
    }
  }, {
    key: "updateTarget",
    value: function updateTarget(t) {
      var e = this.goalTarget,
          n = this.target.position;

      if (!e.equals(n)) {
        var _i226 = this.boundingSphere.radius / 10;

        var _r149 = n.x,
            _s85 = n.y,
            _a68 = n.z;
        _r149 = this.targetDamperX.update(_r149, e.x, t, _i226), _s85 = this.targetDamperY.update(_s85, e.y, t, _i226), _a68 = this.targetDamperZ.update(_a68, e.z, t, _i226), this.target.position.set(_r149, _s85, _a68), this.target.updateMatrixWorld(), this.queueRender();
      }
    }
  }, {
    key: "pointTowards",
    value: function pointTowards(t, e) {
      var _this$position = this.position,
          n = _this$position.x,
          i = _this$position.z;
      this.yaw = Math.atan2(t - n, e - i);
    }
  }, {
    key: "yaw",
    get: function get() {
      return this.rotation.y;
    },
    set: function set(t) {
      this.rotation.y = t, this.queueRender();
    }
  }, {
    key: "animationTime",
    get: function get() {
      if (null != this.currentAnimationAction) {
        var _t366 = Math.max(this.currentAnimationAction._loopCount, 0);

        return 2202 === this.currentAnimationAction.loop && 1 == (1 & _t366) ? this.duration - this.currentAnimationAction.time : this.currentAnimationAction.time;
      }

      return 0;
    },
    set: function set(t) {
      this.mixer.setTime(t), this.queueShadowRender();
    }
  }, {
    key: "animationTimeScale",
    get: function get() {
      return this.mixer.timeScale;
    },
    set: function set(t) {
      this.mixer.timeScale = t;
    }
  }, {
    key: "duration",
    get: function get() {
      return null != this.currentAnimationAction && this.currentAnimationAction.getClip() ? this.currentAnimationAction.getClip().duration : 0;
    }
  }, {
    key: "hasActiveAnimation",
    get: function get() {
      return null != this.currentAnimationAction;
    }
  }, {
    key: "playAnimation",
    value: function playAnimation() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2201;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1 / 0;
      if (null == this._currentGLTF) return;
      var r = this.animations;
      if (null == r || 0 === r.length) return void console.warn("Cannot play animation (model does not have any animations)");
      var s = null;

      if (null != t && (s = this.animationsByName.get(t), null == s)) {
        var _e310 = parseInt(t);

        !isNaN(_e310) && _e310 >= 0 && _e310 < r.length && (s = r[_e310]);
      }

      null == s && (s = r[0]);

      try {
        var _t367 = this.currentAnimationAction,
            _r150 = this.mixer.clipAction(s, this);

        this.currentAnimationAction = _r150, this.element.paused ? this.mixer.stopAllAction() : (_r150.paused = !1, null != _t367 && _r150 !== _t367 ? _r150.crossFadeFrom(_t367, e, !1) : this.animationTimeScale > 0 && this.animationTime == this.duration && (this.animationTime = 0)), _r150.setLoop(n, i), _r150.enabled = !0, _r150.clampWhenFinished = !0, _r150.play();
      } catch (t) {
        console.error(t);
      }
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      this.currentAnimationAction = null, this.mixer.stopAllAction();
    }
  }, {
    key: "updateAnimation",
    value: function updateAnimation(t) {
      this.mixer.update(t), this.queueShadowRender();
    }
  }, {
    key: "subscribeMixerEvent",
    value: function subscribeMixerEvent(t, e) {
      this.mixer.addEventListener(t, e);
    }
  }, {
    key: "updateShadow",
    value: function updateShadow() {
      var t = this.shadow;

      if (null != t) {
        var _e311 = "wall" === this.element.arPlacement ? "back" : "bottom";

        t.setScene(this, this.shadowSoftness, _e311), t.needsUpdate = !0;
      }
    }
  }, {
    key: "renderShadow",
    value: function renderShadow(t) {
      var e = this.shadow;
      null != e && 1 == e.needsUpdate && (e.render(t, this), e.needsUpdate = !1);
    }
  }, {
    key: "queueShadowRender",
    value: function queueShadowRender() {
      null != this.shadow && (this.shadow.needsUpdate = !0);
    }
  }, {
    key: "setShadowIntensity",
    value: function setShadowIntensity(t) {
      if (this.shadowIntensity = t, null != this._currentGLTF && (this.setBakedShadowVisibility(), !(t <= 0 && null == this.shadow))) {
        if (null == this.shadow) {
          var _t368 = "wall" === this.element.arPlacement ? "back" : "bottom";

          this.shadow = new Du(this, this.shadowSoftness, _t368);
        }

        this.shadow.setIntensity(t);
      }
    }
  }, {
    key: "setShadowSoftness",
    value: function setShadowSoftness(t) {
      this.shadowSoftness = t;
      var e = this.shadow;
      null != e && e.setSoftness(t);
    }
  }, {
    key: "setShadowOffset",
    value: function setShadowOffset(t) {
      var e = this.shadow;
      null != e && e.setOffset(t);
    }
  }, {
    key: "raycaster",
    get: function get() {
      return Fu;
    }
  }, {
    key: "positionAndNormalFromPoint",
    value: function positionAndNormalFromPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      this.raycaster.setFromCamera(t, this.getCamera());
      var n = this.raycaster.intersectObject(e, !0).find(function (t) {
        return !t.object.userData.shadow;
      });
      return null == n || null == n.face ? null : null == n.uv ? {
        position: n.point,
        normal: n.face.normal,
        uv: null
      } : (n.face.normal.applyNormalMatrix(new ft().getNormalMatrix(n.object.matrixWorld)), {
        position: n.point,
        normal: n.face.normal,
        uv: n.uv
      });
    }
  }, {
    key: "addHotspot",
    value: function addHotspot(t) {
      this.target.add(t), this.annotationRenderer.domElement.appendChild(t.element);
    }
  }, {
    key: "removeHotspot",
    value: function removeHotspot(t) {
      this.target.remove(t);
    }
  }, {
    key: "forHotspots",
    value: function forHotspots(t) {
      var e = this.target.children;

      for (var n = 0, _i227 = e.length; n < _i227; n++) {
        var _i228 = e[n];
        _i228 instanceof Eu && t(_i228);
      }
    }
  }, {
    key: "updateHotspots",
    value: function updateHotspots(t) {
      var _this126 = this;

      this.forHotspots(function (e) {
        Iu.copy(t), Ou.setFromMatrixPosition(e.matrixWorld), Iu.sub(Ou), Nu.copy(e.normal).transformDirection(_this126.target.matrixWorld), Iu.dot(Nu) < 0 ? e.hide() : e.show();
      });
    }
  }, {
    key: "orientHotspots",
    value: function orientHotspots(t) {
      this.forHotspots(function (e) {
        e.orient(t);
      });
    }
  }, {
    key: "setHotspotsVisibility",
    value: function setHotspotsVisibility(t) {
      this.forHotspots(function (e) {
        e.visible = t;
      });
    }
  }, {
    key: "updateSchema",
    value: function updateSchema(t) {
      var e;
      var n = this.schemaElement,
          i = this.element,
          r = i.alt,
          s = i.poster,
          a = i.iosSrc;

      if (null != t) {
        var _i229 = [{
          "@type": "MediaObject",
          contentUrl: t,
          encodingFormat: "gltf" === (null === (e = t.split(".").pop()) || void 0 === e ? void 0 : e.toLowerCase()) ? "model/gltf+json" : "model/gltf-binary"
        }];
        a && _i229.push({
          "@type": "MediaObject",
          contentUrl: a,
          encodingFormat: "model/vnd.usdz+zip"
        });
        var _o40 = {
          "@context": "http://schema.org/",
          "@type": "3DModel",
          image: null != s ? s : void 0,
          name: null != r ? r : void 0,
          encoding: _i229
        };
        n.textContent = JSON.stringify(_o40), document.head.appendChild(n);
      } else null != n.parentElement && n.parentElement.removeChild(n);
    }
  }]);

  return Bu;
}(Is);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var zu = function zu(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var Hu = Symbol("currentEnvironmentMap"),
    Vu = Symbol("applyEnvironmentMap"),
    Gu = Symbol("updateEnvironment"),
    Wu = Symbol("cancelEnvironmentUpdate"),
    ju = Symbol("onPreload");

var qu = /*#__PURE__*/function () {
  function qu(t, e, n, i, r) {
    var _this127 = this;

    _classCallCheck(this, qu);

    this.xrLight = t, this.renderer = e, this.lightProbe = n, this.xrWebGLBinding = null, this.estimationStartCallback = r, this.frameCallback = this.onXRFrame.bind(this);
    var s = e.xr.getSession();

    if (i && "XRWebGLBinding" in window) {
      var _n281 = new qn(16);

      t.environment = _n281.texture;

      var _i230 = e.getContext();

      switch (s.preferredReflectionFormat) {
        case "srgba8":
          _i230.getExtension("EXT_sRGB");

          break;

        case "rgba16f":
          _i230.getExtension("OES_texture_half_float");

      }

      this.xrWebGLBinding = new XRWebGLBinding(s, _i230), this.lightProbe.addEventListener("reflectionchange", function () {
        _this127.updateReflection();
      });
    }

    s.requestAnimationFrame(this.frameCallback);
  }

  _createClass(qu, [{
    key: "updateReflection",
    value: function updateReflection() {
      var t = this.renderer.properties.get(this.xrLight.environment);

      if (t) {
        var _e312 = this.xrWebGLBinding.getReflectionCubeMap(this.lightProbe);

        _e312 && (t.__webglTexture = _e312, this.xrLight.environment.needsPMREMUpdate = !0);
      }
    }
  }, {
    key: "onXRFrame",
    value: function onXRFrame(t, e) {
      if (!this.xrLight) return;
      e.session.requestAnimationFrame(this.frameCallback);
      var n = e.getLightEstimate(this.lightProbe);

      if (n) {
        this.xrLight.lightProbe.sh.fromArray(n.sphericalHarmonicsCoefficients), this.xrLight.lightProbe.intensity = 1;

        var _t369 = Math.max(1, Math.max(n.primaryLightIntensity.x, Math.max(n.primaryLightIntensity.y, n.primaryLightIntensity.z)));

        this.xrLight.directionalLight.color.setRGB(n.primaryLightIntensity.x / _t369, n.primaryLightIntensity.y / _t369, n.primaryLightIntensity.z / _t369), this.xrLight.directionalLight.intensity = _t369, this.xrLight.directionalLight.position.copy(n.primaryLightDirection), this.estimationStartCallback && (this.estimationStartCallback(), this.estimationStartCallback = null);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.xrLight = null, this.renderer = null, this.lightProbe = null, this.xrWebGLBinding = null;
    }
  }]);

  return qu;
}();

var Xu = /*#__PURE__*/function (_Es) {
  _inherits(Xu, _Es);

  var _super127 = _createSuper(Xu);

  function Xu(t) {
    var _this128;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;

    _classCallCheck(this, Xu);

    _this128 = _super127.call(this), _this128.lightProbe = new Cl(), _this128.lightProbe.intensity = 0, _this128.add(_this128.lightProbe), _this128.directionalLight = new Al(), _this128.directionalLight.intensity = 0, _this128.add(_this128.directionalLight), _this128.environment = null;
    var n = null,
        i = !1;
    t.xr.addEventListener("sessionstart", function () {
      var r = t.xr.getSession();
      "requestLightProbe" in r && r.requestLightProbe({
        reflectionFormat: r.preferredReflectionFormat
      }).then(function (r) {
        n = new qu(_assertThisInitialized(_this128), t, r, e, function () {
          i = !0, _this128.dispatchEvent({
            type: "estimationstart"
          });
        });
      });
    }), t.xr.addEventListener("sessionend", function () {
      n && (n.dispose(), n = null), i && _this128.dispatchEvent({
        type: "estimationend"
      });
    }), _this128.dispose = function () {
      n && (n.dispose(), n = null), _this128.remove(_this128.lightProbe), _this128.lightProbe = null, _this128.remove(_this128.directionalLight), _this128.directionalLight = null, _this128.environment = null;
    };
    return _this128;
  }

  return Xu;
}(Es);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Yu = Math.PI / 24,
    Ju = new mt(),
    Zu = function Zu(t, e, n) {
  var i = e > 0 ? n > 0 ? 0 : -Math.PI / 2 : n > 0 ? Math.PI / 2 : Math.PI;

  for (var _r151 = 0; _r151 <= 12; ++_r151) {
    t.push(e + .17 * Math.cos(i), n + .17 * Math.sin(i), 0, e + .2 * Math.cos(i), n + .2 * Math.sin(i), 0), i += Yu;
  }
};

var $u = /*#__PURE__*/function (_Nn3) {
  _inherits($u, _Nn3);

  var _super128 = _createSuper($u);

  function $u(t, e) {
    var _this129;

    _classCallCheck(this, $u);

    var n = new vn(),
        i = [],
        r = [],
        s = t.size,
        a = t.boundingBox,
        o = s.x / 2,
        l = ("back" === e ? s.y : s.z) / 2;
    Zu(r, o, l), Zu(r, -o, l), Zu(r, -o, -l), Zu(r, o, -l);
    var h = r.length / 3;

    for (var _t370 = 0; _t370 < h - 2; _t370 += 2) {
      i.push(_t370, _t370 + 1, _t370 + 3, _t370, _t370 + 3, _t370 + 2);
    }

    var c = h - 2;
    i.push(c, c + 1, 1, c, 1, 0), n.setAttribute("position", new hn(r, 3)), n.setIndex(i), _this129 = _super128.call(this, n), _this129.side = e;
    var u = _this129.material;

    switch (u.side = 0, u.transparent = !0, u.opacity = 0, _this129.goalOpacity = 0, _this129.opacityDamper = new du(), _this129.hitPlane = new Nn(new ni(2 * (o + .2), 2 * (l + .2))), _this129.hitPlane.visible = !1, _this129.add(_this129.hitPlane), a.getCenter(_this129.position), e) {
      case "bottom":
        _this129.rotateX(-Math.PI / 2), _this129.shadowHeight = a.min.y, _this129.position.y = _this129.shadowHeight;
        break;

      case "back":
        _this129.shadowHeight = a.min.z, _this129.position.z = _this129.shadowHeight;
    }

    t.target.add(_assertThisInitialized(_this129)), _this129.offsetHeight = 0;
    return _this129;
  }

  _createClass($u, [{
    key: "getHit",
    value: function getHit(t, e, n) {
      Ju.set(e, -n), this.hitPlane.visible = !0;
      var i = t.positionAndNormalFromPoint(Ju, this.hitPlane);
      return this.hitPlane.visible = !1, null == i ? null : i.position;
    }
  }, {
    key: "getExpandedHit",
    value: function getExpandedHit(t, e, n) {
      this.hitPlane.scale.set(1e3, 1e3, 1e3);
      var i = this.getHit(t, e, n);
      return this.hitPlane.scale.set(1, 1, 1), i;
    }
  }, {
    key: "offsetHeight",
    get: function get() {
      return "back" === this.side ? this.position.z - this.shadowHeight : this.position.y - this.shadowHeight;
    },
    set: function set(t) {
      t -= .001, "back" === this.side ? this.position.z = this.shadowHeight + t : this.position.y = this.shadowHeight + t;
    }
  }, {
    key: "show",
    set: function set(t) {
      this.goalOpacity = t ? .75 : 0;
    }
  }, {
    key: "updateOpacity",
    value: function updateOpacity(t) {
      var e = this.material;
      e.opacity = this.opacityDamper.update(e.opacity, this.goalOpacity, t, 1), this.visible = e.opacity > 0;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var t;
      var _this$hitPlane = this.hitPlane,
          e = _this$hitPlane.geometry,
          n = _this$hitPlane.material;
      e.dispose(), n.dispose(), this.geometry.dispose(), this.material.dispose(), null === (t = this.parent) || void 0 === t || t.remove(this);
    }
  }]);

  return $u;
}(Nn);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ku = "not-presenting",
    Qu = "session-started",
    td = "object-placed",
    ed = "failed",
    nd = "tracking",
    id = "not-tracking",
    rd = new zt(),
    sd = new ve(),
    ad = new zt(),
    od = new Gn(45, 1, .1, 100);

var ld = /*#__PURE__*/function (_et9) {
  _inherits(ld, _et9);

  var _super129 = _createSuper(ld);

  function ld(t) {
    var _this130;

    _classCallCheck(this, ld);

    _this130 = _super129.call(this), _this130.renderer = t, _this130.currentSession = null, _this130.placeOnWall = !1, _this130.placementBox = null, _this130.lastTick = null, _this130.turntableRotation = null, _this130.oldShadowIntensity = null, _this130.oldBackground = null, _this130.oldEnvironment = null, _this130.frame = null, _this130.initialHitSource = null, _this130.transientHitTestSource = null, _this130.inputSource = null, _this130._presentedScene = null, _this130.resolveCleanup = null, _this130.exitWebXRButtonContainer = null, _this130.overlay = null, _this130.xrLight = null, _this130.tracking = !0, _this130.frames = 0, _this130.initialized = !1, _this130.oldTarget = new zt(), _this130.placementComplete = !1, _this130.isTranslating = !1, _this130.isRotating = !1, _this130.isTwoFingering = !1, _this130.lastDragPosition = new zt(), _this130.firstRatio = 0, _this130.lastAngle = 0, _this130.goalPosition = new zt(), _this130.goalYaw = 0, _this130.goalScale = 1, _this130.xDamper = new du(), _this130.yDamper = new du(), _this130.zDamper = new du(), _this130.yawDamper = new du(), _this130.scaleDamper = new du(), _this130.onExitWebXRButtonContainerClick = function () {
      return _this130.stopPresenting();
    }, _this130.onUpdateScene = function () {
      null != _this130.placementBox && _this130.isPresenting && (_this130.placementBox.dispose(), _this130.placementBox = new $u(_this130.presentedScene, _this130.placeOnWall ? "back" : "bottom"));
    }, _this130.onSelectStart = function (t) {
      var e = _this130.transientHitTestSource;
      if (null == e) return;

      var n = _this130.frame.getHitTestResultsForTransientInput(e),
          i = _this130.presentedScene,
          r = _this130.placementBox;

      if (1 === n.length) {
        _this130.inputSource = t.inputSource;

        var _e313 = _this130.inputSource.gamepad.axes,
            _n282 = r.getHit(_this130.presentedScene, _e313[0], _e313[1]);

        r.show = !0, null != _n282 ? (_this130.isTranslating = !0, _this130.lastDragPosition.copy(_n282)) : !1 === _this130.placeOnWall && (_this130.isRotating = !0, _this130.lastAngle = 1.5 * _e313[0]);
      } else if (2 === n.length) {
        r.show = !0, _this130.isTwoFingering = !0;

        var _this130$fingerPolar = _this130.fingerPolar(n),
            _t371 = _this130$fingerPolar.separation;

        _this130.firstRatio = _t371 / i.scale.x;
      }
    }, _this130.onSelectEnd = function () {
      _this130.isTranslating = !1, _this130.isRotating = !1, _this130.isTwoFingering = !1, _this130.inputSource = null, _this130.goalPosition.y += _this130.placementBox.offsetHeight * _this130.presentedScene.scale.x, _this130.placementBox.show = !1;
    }, _this130.threeRenderer = t.threeRenderer, _this130.threeRenderer.xr.enabled = !0;
    return _this130;
  }

  _createClass(ld, [{
    key: "resolveARSession",
    value: function () {
      var _resolveARSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var t;
        return _regeneratorRuntime.wrap(function _callee11$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                su();
                _context14.next = 3;
                return navigator.xr.requestSession("immersive-ar", {
                  requiredFeatures: ["hit-test"],
                  optionalFeatures: ["dom-overlay", "light-estimation"],
                  domOverlay: {
                    root: this.overlay
                  }
                });

              case 3:
                t = _context14.sent;
                this.threeRenderer.xr.setReferenceSpaceType("local");
                _context14.next = 7;
                return this.threeRenderer.xr.setSession(t);

              case 7:
                this.threeRenderer.xr.cameraAutoUpdate = !1;
                return _context14.abrupt("return", t);

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee11, this);
      }));

      function resolveARSession() {
        return _resolveARSession.apply(this, arguments);
      }

      return resolveARSession;
    }()
  }, {
    key: "presentedScene",
    get: function get() {
      return this._presentedScene;
    }
  }, {
    key: "supportsPresentation",
    value: function () {
      var _supportsPresentation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                su();
                _context15.next = 4;
                return navigator.xr.isSessionSupported("immersive-ar");

              case 4:
                return _context15.abrupt("return", _context15.sent);

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", (console.warn("Request to present in WebXR denied:"), console.warn(_context15.t0), console.warn("Falling back to next ar-mode"), !1));

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee12, null, [[0, 7]]);
      }));

      function supportsPresentation() {
        return _supportsPresentation.apply(this, arguments);
      }

      return supportsPresentation;
    }()
  }, {
    key: "present",
    value: function () {
      var _present = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t) {
        var _this131 = this;

        var e,
            n,
            i,
            r,
            s,
            a,
            o,
            _args16 = arguments;
        return _regeneratorRuntime.wrap(function _callee13$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                e = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : !1;
                this.isPresenting && console.warn("Cannot present while a model is already presenting");
                n = new Promise(function (t, e) {
                  requestAnimationFrame(function () {
                    return t();
                  });
                });
                t.setHotspotsVisibility(!1);
                t.queueRender();
                _context16.next = 7;
                return n;

              case 7:
                this._presentedScene = t;
                this.overlay = t.element.shadowRoot.querySelector("div.default");
                !0 === e && (this.xrLight = new Xu(this.threeRenderer), this.xrLight.addEventListener("estimationstart", function () {
                  if (!_this131.isPresenting || null == _this131.xrLight) return;
                  var t = _this131.presentedScene;
                  t.add(_this131.xrLight), _this131.oldEnvironment = t.environment, t.environment = _this131.xrLight.environment;
                }));
                _context16.next = 12;
                return this.resolveARSession();

              case 12:
                i = _context16.sent;
                i.addEventListener("end", function () {
                  _this131.postSessionCleanup();
                }, {
                  once: !0
                });
                r = t.element.shadowRoot.querySelector(".slot.exit-webxr-ar-button");
                r.classList.add("enabled"), r.addEventListener("click", this.onExitWebXRButtonContainerClick), this.exitWebXRButtonContainer = r;
                _context16.next = 18;
                return i.requestReferenceSpace("viewer");

              case 18:
                s = _context16.sent;
                this.tracking = !0, this.frames = 0, this.initialized = !1, this.turntableRotation = t.yaw, this.goalYaw = t.yaw, this.goalScale = 1, this.oldBackground = t.background, t.background = null, this.oldShadowIntensity = t.shadowIntensity, t.setShadowIntensity(.01), this.oldTarget.copy(t.getTarget()), t.addEventListener("model-load", this.onUpdateScene);
                a = 20 * Math.PI / 180, o = !0 === this.placeOnWall ? void 0 : new XRRay(new DOMPoint(0, 0, 0), {
                  x: 0,
                  y: -Math.sin(a),
                  z: -Math.cos(a)
                });
                i.requestHitTestSource({
                  space: s,
                  offsetRay: o
                }).then(function (t) {
                  _this131.initialHitSource = t;
                }), this.currentSession = i, this.placementBox = new $u(t, this.placeOnWall ? "back" : "bottom"), this.placementComplete = !1, this.lastTick = performance.now(), this.dispatchEvent({
                  type: "status",
                  status: Qu
                });

              case 22:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee13, this);
      }));

      function present(_x15) {
        return _present.apply(this, arguments);
      }

      return present;
    }()
  }, {
    key: "stopPresenting",
    value: function () {
      var _stopPresenting = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this132 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee14$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.isPresenting) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt("return");

              case 2:
                t = new Promise(function (t) {
                  _this132.resolveCleanup = t;
                });
                _context17.prev = 3;
                _context17.next = 6;
                return this.currentSession.end();

              case 6:
                _context17.next = 8;
                return t;

              case 8:
                _context17.next = 13;
                break;

              case 10:
                _context17.prev = 10;
                _context17.t0 = _context17["catch"](3);
                console.warn("Error while trying to end WebXR AR session"), console.warn(_context17.t0), this.postSessionCleanup();

              case 13:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee14, this, [[3, 10]]);
      }));

      function stopPresenting() {
        return _stopPresenting.apply(this, arguments);
      }

      return stopPresenting;
    }()
  }, {
    key: "isPresenting",
    get: function get() {
      return null != this.presentedScene;
    }
  }, {
    key: "target",
    get: function get() {
      return this.oldTarget;
    }
  }, {
    key: "updateTarget",
    value: function updateTarget() {
      var t = this.presentedScene;

      if (null != t) {
        var _e314 = t.getTarget();

        this.oldTarget.copy(_e314), this.placeOnWall ? _e314.z = t.boundingBox.min.z : _e314.y = t.boundingBox.min.y, t.setTarget(_e314.x, _e314.y, _e314.z);
      }
    }
  }, {
    key: "postSessionCleanup",
    value: function postSessionCleanup() {
      var t = this.currentSession;
      null != t && (t.removeEventListener("selectstart", this.onSelectStart), t.removeEventListener("selectend", this.onSelectEnd), this.currentSession = null);
      var e = this.presentedScene;

      if (null != e) {
        var _t372 = e.element;
        null != this.xrLight && (e.remove(this.xrLight), null != this.oldEnvironment && (e.environment = this.oldEnvironment, this.oldEnvironment = null), this.xrLight.dispose(), this.xrLight = null), e.position.set(0, 0, 0), e.scale.set(1, 1, 1), e.setShadowOffset(0);
        var _n283 = this.turntableRotation;
        null != _n283 && (e.yaw = _n283);
        var _i231 = this.oldShadowIntensity;
        null != _i231 && e.setShadowIntensity(_i231);
        var _r152 = this.oldBackground;
        null != _r152 && (e.background = _r152);
        var _s86 = this.oldTarget;
        e.setTarget(_s86.x, _s86.y, _s86.z), e.xrCamera = null, e.removeEventListener("model-load", this.onUpdateScene), e.orientHotspots(0), _t372.requestUpdate("cameraTarget"), _t372.requestUpdate("maxCameraOrbit"), _t372[Tp](_t372.getBoundingClientRect());
      }

      this.renderer.height = 0;
      var n = this.exitWebXRButtonContainer;
      null != n && (n.classList.remove("enabled"), n.removeEventListener("click", this.onExitWebXRButtonContainerClick), this.exitWebXRButtonContainer = null);
      var i = this.transientHitTestSource;
      null != i && (i.cancel(), this.transientHitTestSource = null);
      var r = this.initialHitSource;
      null != r && (r.cancel(), this.initialHitSource = null), null != this.placementBox && (this.placementBox.dispose(), this.placementBox = null), this.lastTick = null, this.turntableRotation = null, this.oldShadowIntensity = null, this.oldBackground = null, this._presentedScene = null, this.frame = null, this.inputSource = null, this.overlay = null, null != this.resolveCleanup && this.resolveCleanup(), this.dispatchEvent({
        type: "status",
        status: Ku
      });
    }
  }, {
    key: "updateView",
    value: function updateView(t) {
      var e = this.presentedScene,
          n = this.threeRenderer.xr;
      n.updateCamera(od), e.xrCamera = n.getCamera();
      var i = e.getCamera().matrixWorld.elements;

      if (e.orientHotspots(Math.atan2(i[1], i[5])), this.initialized || (this.placeInitially(), this.initialized = !0), t.requestViewportScale && t.recommendedViewportScale) {
        var _e315 = t.recommendedViewportScale;
        t.requestViewportScale(Math.max(_e315, .25));
      }

      var r = this.currentSession.renderState.baseLayer.getViewport(t);
      this.threeRenderer.setViewport(r.x, r.y, r.width, r.height);
    }
  }, {
    key: "placeInitially",
    value: function placeInitially() {
      var _this133 = this;

      var t = this.presentedScene,
          e = t.position,
          n = t.element,
          i = t.getCamera(),
          _this$overlay$getBoun = this.overlay.getBoundingClientRect(),
          r = _this$overlay$getBoun.width,
          s = _this$overlay$getBoun.height;

      t.setSize(r, s), i.projectionMatrixInverse.copy(i.projectionMatrix).invert();

      var _n$getCameraOrbit = n.getCameraOrbit(),
          a = _n$getCameraOrbit.theta,
          o = _n$getCameraOrbit.radius,
          l = i.getWorldDirection(rd);

      t.yaw = Math.atan2(-l.x, -l.z) - a, this.goalYaw = t.yaw, e.copy(i.position).add(l.multiplyScalar(o)), this.updateTarget();
      var h = t.getTarget();
      e.add(h).sub(this.oldTarget), this.goalPosition.copy(e), t.setHotspotsVisibility(!0);
      var c = this.frame.session;
      c.addEventListener("selectstart", this.onSelectStart), c.addEventListener("selectend", this.onSelectEnd), c.requestHitTestSourceForTransientInput({
        profile: "generic-touchscreen"
      }).then(function (t) {
        _this133.transientHitTestSource = t;
      });
    }
  }, {
    key: "getTouchLocation",
    value: function getTouchLocation() {
      var t = this.inputSource.gamepad.axes;
      var e = this.placementBox.getExpandedHit(this.presentedScene, t[0], t[1]);
      return null != e && (rd.copy(e).sub(this.presentedScene.getCamera().position), rd.length() > 10) ? null : e;
    }
  }, {
    key: "getHitPoint",
    value: function getHitPoint(t) {
      var e = this.threeRenderer.xr.getReferenceSpace(),
          n = t.getPose(e);
      if (null == n) return null;
      var i = sd.fromArray(n.transform.matrix);
      return !0 === this.placeOnWall && (this.goalYaw = Math.atan2(i.elements[4], i.elements[6])), i.elements[5] > .75 !== this.placeOnWall ? ad.setFromMatrixPosition(i) : null;
    }
  }, {
    key: "moveToFloor",
    value: function moveToFloor(t) {
      var e = this.initialHitSource;
      if (null == e) return;
      var n = t.getHitTestResults(e);
      if (0 == n.length) return;
      var i = n[0],
          r = this.getHitPoint(i);
      null != r && (this.placementBox.show = !0, this.isTranslating || (this.placeOnWall ? this.goalPosition.copy(r) : this.goalPosition.y = r.y), e.cancel(), this.initialHitSource = null, this.dispatchEvent({
        type: "status",
        status: td
      }));
    }
  }, {
    key: "fingerPolar",
    value: function fingerPolar(t) {
      var e = t[0].inputSource.gamepad.axes,
          n = t[1].inputSource.gamepad.axes,
          i = n[0] - e[0],
          r = n[1] - e[1],
          s = Math.atan2(r, i);
      var a = this.lastAngle - s;
      return a > Math.PI ? a -= 2 * Math.PI : a < -Math.PI && (a += 2 * Math.PI), this.lastAngle = s, {
        separation: Math.sqrt(i * i + r * r),
        deltaYaw: a
      };
    }
  }, {
    key: "processInput",
    value: function processInput(t) {
      var _this134 = this;

      var e = this.transientHitTestSource;
      if (null == e) return;
      if (!this.isTranslating && !this.isTwoFingering && !this.isRotating) return;
      var n = t.getHitTestResultsForTransientInput(e),
          i = this.presentedScene,
          r = i.scale.x;
      if (this.isTwoFingering) {
        if (n.length < 2) this.isTwoFingering = !1;else {
          var _this$fingerPolar = this.fingerPolar(n),
              _t373 = _this$fingerPolar.separation,
              _e316 = _this$fingerPolar.deltaYaw;

          if (!1 === this.placeOnWall && (this.goalYaw += _e316), i.canScale) {
            var _e317 = _t373 / this.firstRatio;

            this.goalScale = _e317 < 1.3 && _e317 > .7692307692307692 ? 1 : _e317;
          }
        }
      } else if (2 !== n.length) {
        if (this.isRotating) {
          var _t374 = 1.5 * this.inputSource.gamepad.axes[0];

          this.goalYaw += _t374 - this.lastAngle, this.lastAngle = _t374;
        } else this.isTranslating && n.forEach(function (t) {
          if (t.inputSource !== _this134.inputSource) return;
          var e = null;

          if (t.results.length > 0 && (e = _this134.getHitPoint(t.results[0])), null == e && (e = _this134.getTouchLocation()), null != e) {
            if (_this134.goalPosition.sub(_this134.lastDragPosition), !1 === _this134.placeOnWall) {
              var _t375 = e.y - _this134.lastDragPosition.y;

              if (_t375 < 0) {
                _this134.placementBox.offsetHeight = _t375 / r, _this134.presentedScene.setShadowOffset(_t375);

                var _n284 = rd.copy(i.getCamera().position),
                    _s87 = -_t375 / (_n284.y - e.y);

                _n284.multiplyScalar(_s87), e.multiplyScalar(1 - _s87).add(_n284);
              }
            }

            _this134.goalPosition.add(e), _this134.lastDragPosition.copy(e);
          }
        });
      } else {
        this.isTranslating = !1, this.isRotating = !1, this.isTwoFingering = !0;

        var _this$fingerPolar2 = this.fingerPolar(n),
            _t376 = _this$fingerPolar2.separation;

        this.firstRatio = _t376 / r;
      }
    }
  }, {
    key: "moveScene",
    value: function moveScene(t) {
      var e = this.presentedScene,
          n = e.position,
          i = e.yaw,
          r = e.boundingSphere.radius,
          s = this.goalPosition,
          a = e.scale.x,
          o = this.placementBox;

      if (!s.equals(n) || this.goalScale !== a) {
        var _i232 = n.x,
            _l41 = n.y,
            _h28 = n.z;
        _i232 = this.xDamper.update(_i232, s.x, t, r), _l41 = this.yDamper.update(_l41, s.y, t, r), _h28 = this.zDamper.update(_h28, s.z, t, r), n.set(_i232, _l41, _h28);

        var _c23 = this.scaleDamper.update(a, this.goalScale, t, 1);

        if (e.scale.set(_c23, _c23, _c23), !this.isTranslating) {
          var _t377 = s.y - _l41;

          this.placementComplete && !1 === this.placeOnWall ? (o.offsetHeight = _t377 / _c23, e.setShadowOffset(_t377)) : 0 === _t377 && (this.placementComplete = !0, o.show = !1, e.setShadowIntensity(.8));
        }
      }

      o.updateOpacity(t), e.updateTarget(t), e.yaw = this.yawDamper.update(i, this.goalYaw, t, Math.PI);
    }
  }, {
    key: "onWebXRFrame",
    value: function onWebXRFrame(t, e) {
      this.frame = e, ++this.frames;
      var n = this.threeRenderer.xr.getReferenceSpace(),
          i = e.getViewerPose(n);
      null == i && !0 === this.tracking && this.frames > 30 && (this.tracking = !1, this.dispatchEvent({
        type: "tracking",
        status: id
      }));
      var r = this.presentedScene;
      if (null == i || null == r || !r.element[Pp]()) return void this.threeRenderer.clear();
      !1 === this.tracking && (this.tracking = !0, this.dispatchEvent({
        type: "tracking",
        status: nd
      }));
      var s = !0;

      var _iterator18 = _createForOfIteratorHelper(i.views),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _n285 = _step18.value;

          if (this.updateView(_n285), s) {
            this.moveToFloor(e), this.processInput(e);

            var _n286 = t - this.lastTick;

            this.moveScene(_n286), this.renderer.preRender(r, t, _n286), this.lastTick = t, r.renderShadow(this.threeRenderer);
          }

          this.threeRenderer.render(r, r.getCamera()), s = !1;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }
  }]);

  return ld;
}(et);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var hd = /*#__PURE__*/function () {
  function hd(t) {
    _classCallCheck(this, hd);

    t.threeRenderer.debug = {
      checkShaderErrors: !0
    }, Promise.resolve().then(function () {
      self.dispatchEvent(new CustomEvent("model-viewer-renderer-debug", {
        detail: {
          renderer: t,
          THREE: {
            ShaderMaterial: Hn,
            Texture: Ot,
            Mesh: Nn,
            Scene: Is,
            PlaneBufferGeometry: ni,
            OrthographicCamera: di,
            WebGLRenderTarget: Ft
          }
        }
      }));
    });
  }

  _createClass(hd, [{
    key: "addScene",
    value: function addScene(t) {
      self.dispatchEvent(new CustomEvent("model-viewer-scene-added-debug", {
        detail: {
          scene: t
        }
      }));
    }
  }, {
    key: "removeScene",
    value: function removeScene(t) {
      self.dispatchEvent(new CustomEvent("model-viewer-scene-removed-debug", {
        detail: {
          scene: t
        }
      }));
    }
  }]);

  return hd;
}();

function cd(t) {
  var e = new Map(),
      n = new Map(),
      i = t.clone();
  return ud(t, i, function (t, i) {
    e.set(i, t), n.set(t, i);
  }), i.traverse(function (t) {
    if (!t.isSkinnedMesh) return;
    var i = t,
        r = e.get(t),
        s = r.skeleton.bones;
    i.skeleton = r.skeleton.clone(), i.bindMatrix.copy(r.bindMatrix), i.skeleton.bones = s.map(function (t) {
      return n.get(t);
    }), i.bind(i.skeleton, i.bindMatrix);
  }), i;
}

function ud(t, e, n) {
  n(t, e);

  for (var _i233 = 0; _i233 < t.children.length; _i233++) {
    ud(t.children[_i233], e.children[_i233], n);
  }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var dd = Symbol("prepared"),
    pd = Symbol("prepare"),
    md = Symbol("preparedGLTF"),
    fd = Symbol("clone");

var gd = /*#__PURE__*/function () {
  function gd(t) {
    _classCallCheck(this, gd);

    this[md] = t;
  }

  _createClass(gd, [{
    key: "parser",
    get: function get() {
      return this[md].parser;
    }
  }, {
    key: "animations",
    get: function get() {
      return this[md].animations;
    }
  }, {
    key: "scene",
    get: function get() {
      return this[md].scene;
    }
  }, {
    key: "scenes",
    get: function get() {
      return this[md].scenes;
    }
  }, {
    key: "cameras",
    get: function get() {
      return this[md].cameras;
    }
  }, {
    key: "asset",
    get: function get() {
      return this[md].asset;
    }
  }, {
    key: "userData",
    get: function get() {
      return this[md].userData;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new (0, this.constructor)(this[fd]());
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.scenes.forEach(function (t) {
        t.traverse(function (t) {
          if (!t.isMesh) return;
          var e = t;
          (Array.isArray(e.material) ? e.material : [e.material]).forEach(function (t) {
            for (var _e318 in t) {
              var n = t[_e318];
              n instanceof Ot && n.dispose();
            }

            t.dispose();
          }), e.geometry.dispose();
        });
      });
    }
  }, {
    key: fd,
    value: function value() {
      var t = this[md],
          e = cd(this.scene);
      vd(e, this.scene);
      var n = [e],
          i = t.userData ? Object.assign({}, t.userData) : {};
      return Object.assign(Object.assign({}, t), {
        scene: e,
        scenes: n,
        userData: i
      });
    }
  }], [{
    key: "prepare",
    value: function prepare(t) {
      if (null == t.scene) throw new Error("Model does not have a scene");
      if (t[dd]) return t;
      var e = this[pd](t);
      return e[dd] = !0, e;
    }
  }, {
    key: pd,
    value: function value(t) {
      var e = t.scene,
          n = [e];
      return Object.assign(Object.assign({}, t), {
        scene: e,
        scenes: n
      });
    }
  }]);

  return gd;
}();

var vd = function vd(t, e) {
  yd(t, e, function (t, e) {
    void 0 !== e.userData.variantMaterials && (t.userData.variantMaterials = new Map(e.userData.variantMaterials)), void 0 !== e.userData.variantData && (t.userData.variantData = e.userData.variantData), void 0 !== e.userData.originalMaterial && (t.userData.originalMaterial = e.userData.originalMaterial);
  });
},
    yd = function yd(t, e, n) {
  n(t, e);

  for (var _i234 = 0; _i234 < t.children.length; _i234++) {
    yd(t.children[_i234], e.children[_i234], n);
  }
},
    xd = Symbol("threeGLTF"),
    _d = Symbol("gltf"),
    bd = Symbol("gltfElementMap"),
    wd = Symbol("threeObjectMap"),
    Md = Symbol("parallelTraverseThreeScene"),
    Sd = Symbol("correlateOriginalThreeGLTF"),
    Td = Symbol("correlateCloneThreeGLTF");

var Ed = /*#__PURE__*/function () {
  function Ed(t, e, n, i) {
    _classCallCheck(this, Ed);

    this[xd] = t, this[_d] = e, this[bd] = i, this[wd] = n;
  }

  _createClass(Ed, [{
    key: "threeGLTF",
    get: function get() {
      return this[xd];
    }
  }, {
    key: "gltf",
    get: function get() {
      return this[_d];
    }
  }, {
    key: "gltfElementMap",
    get: function get() {
      return this[bd];
    }
  }, {
    key: "threeObjectMap",
    get: function get() {
      return this[wd];
    }
  }], [{
    key: "from",
    value: function from(t, e) {
      return null != e ? this[Td](t, e) : this[Sd](t);
    }
  }, {
    key: Sd,
    value: function value(t) {
      var e = t.parser.json,
          n = t.parser.associations,
          i = new Map(),
          r = {
        name: "Default"
      },
          s = {
        type: "materials",
        index: -1
      };

      var _iterator19 = _createForOfIteratorHelper(n.keys()),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _t378 = _step19.value;
          _t378 instanceof en && null == n.get(_t378) && (s.index < 0 && (null == e.materials && (e.materials = []), s.index = e.materials.length, e.materials.push(r)), _t378.name = r.name, n.set(_t378, {
            materials: s.index
          }));
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      var _iterator20 = _createForOfIteratorHelper(n),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _step20$value = _slicedToArray(_step20.value, 2),
              _t379 = _step20$value[0],
              _r153 = _step20$value[1];

          if (_r153) {
            var _e319 = _t379;
            _e319.userData = _e319.userData || {}, _e319.userData.associations = _r153;
          }

          for (var _n287 in _r153) {
            if (null != _n287 && "primitives" !== _n287) {
              var _s88 = _n287,
                  _a69 = (e[_s88] || [])[_r153[_s88]];
              if (null == _a69) continue;

              var _o41 = i.get(_a69);

              null == _o41 && (_o41 = new Set(), i.set(_a69, _o41)), _o41.add(_t379);
            }
          }
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }

      return new Ed(t, e, n, i);
    }
  }, {
    key: Td,
    value: function value(t, e) {
      var n = e.threeGLTF,
          i = e.gltf,
          r = JSON.parse(JSON.stringify(i)),
          s = new Map(),
          a = new Map();

      for (var _i235 = 0; _i235 < n.scenes.length; _i235++) {
        this[Md](n.scenes[_i235], t.scenes[_i235], function (t, n) {
          var i = e.threeObjectMap.get(t);
          if (null != i) for (var _t380 in i) {
            if (null != _t380 && "primitives" !== _t380) {
              var _e320 = _t380,
                  _o42 = i[_e320],
                  _l42 = r[_e320][_o42],
                  _h29 = s.get(n) || {};

              _h29[_e320] = _o42, s.set(n, _h29);

              var _c24 = a.get(_l42) || new Set();

              _c24.add(n), a.set(_l42, _c24);
            }
          }
        });
      }

      return new Ed(t, r, s, a);
    }
  }, {
    key: Md,
    value: function value(t, e, n) {
      var i = function i(t, e) {
        if (n(t, e), t.isObject3D) {
          if (t.isMesh) if (Array.isArray(t.material)) for (var _n288 = 0; _n288 < t.material.length; ++_n288) {
            i(t.material[_n288], e.material[_n288]);
          } else i(t.material, e.material);

          for (var _n289 = 0; _n289 < t.children.length; ++_n289) {
            i(t.children[_n289], e.children[_n289]);
          }
        }
      };

      i(t, e);
    }
  }]);

  return Ed;
}();
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ad = Symbol("correlatedSceneGraph");

var Rd = /*#__PURE__*/function (_gd) {
  _inherits(Rd, _gd);

  var _super130 = _createSuper(Rd);

  function Rd() {
    _classCallCheck(this, Rd);

    return _super130.apply(this, arguments);
  }

  _createClass(Rd, [{
    key: "correlatedSceneGraph",
    get: function get() {
      return this[md][Ad];
    }
  }, {
    key: fd,
    value: function value() {
      var t = _get(_getPrototypeOf(Rd.prototype), fd, this).call(this),
          e = new Map();

      return t.scene.traverse(function (t) {
        if (t.isMesh) {
          var n = t,
              _i236 = n.material;

          if (null != _i236) {
            if (e.has(_i236.uuid)) return void (n.material = e.get(_i236.uuid));
            n.material = _i236.clone(), e.set(_i236.uuid, n.material);
          }
        }
      }), t[Ad] = Ed.from(t, this.correlatedSceneGraph), t;
    }
  }], [{
    key: pd,
    value: function value(t) {
      var e = _get(_getPrototypeOf(Rd), pd, this).call(this, t);

      null == e[Ad] && (e[Ad] = Ed.from(e));
      var n = e.scene,
          i = new le(void 0, 1 / 0);
      return n.traverse(function (t) {
        t.renderOrder = 1e3, t.frustumCulled = !1, t.name || (t.name = t.uuid);
        var e = t;

        if (e.isMesh) {
          e.castShadow = !0, e.isSkinnedMesh && (e.geometry.boundingSphere = i, e.geometry.boundingBox = null);
          var _t381 = e.material;
          !0 === _t381.isMeshBasicMaterial && (_t381.toneMapped = !1), _t381.shadowSide = 0;
        }
      }), e;
    }
  }]);

  return Rd;
}(gd);
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Cd = /*#__PURE__*/function (_Is2) {
  _inherits(Cd, _Is2);

  var _super131 = _createSuper(Cd);

  function Cd() {
    var _this135;

    _classCallCheck(this, Cd);

    _this135 = _super131.call(this), _this135.position.y = -3.5;
    var t = new Un();
    t.deleteAttribute("uv");
    var e = new No({
      metalness: 0,
      side: 1
    }),
        n = new No({
      metalness: 0
    }),
        i = new Tl(16777215, 500, 28, 2);
    i.position.set(.418, 16.199, .3), _this135.add(i);
    var r = new Nn(t, e);
    r.position.set(-.757, 13.219, .717), r.scale.set(31.713, 28.305, 28.591), _this135.add(r);
    var s = new Nn(t, n);
    s.position.set(-10.906, 2.009, 1.846), s.rotation.set(0, -.195, 0), s.scale.set(2.328, 7.905, 4.651), _this135.add(s);
    var a = new Nn(t, n);
    a.position.set(-5.607, -.754, -.758), a.rotation.set(0, .994, 0), a.scale.set(1.97, 1.534, 3.955), _this135.add(a);
    var o = new Nn(t, n);
    o.position.set(6.167, .857, 7.803), o.rotation.set(0, .561, 0), o.scale.set(3.927, 6.285, 3.687), _this135.add(o);
    var l = new Nn(t, n);
    l.position.set(-2.017, .018, 6.124), l.rotation.set(0, .333, 0), l.scale.set(2.002, 4.566, 2.064), _this135.add(l);
    var h = new Nn(t, n);
    h.position.set(2.291, -.756, -2.621), h.rotation.set(0, -.286, 0), h.scale.set(1.546, 1.552, 1.496), _this135.add(h);
    var c = new Nn(t, n);
    c.position.set(-2.193, -.369, -5.547), c.rotation.set(0, .516, 0), c.scale.set(3.875, 3.487, 2.986), _this135.add(c);
    var u = new Nn(t, _this135.createAreaLightMaterial(50));
    u.position.set(-16.116, 14.37, 8.208), u.scale.set(.1, 2.428, 2.739), _this135.add(u);
    var d = new Nn(t, _this135.createAreaLightMaterial(50));
    d.position.set(-16.109, 18.021, -8.207), d.scale.set(.1, 2.425, 2.751), _this135.add(d);
    var p = new Nn(t, _this135.createAreaLightMaterial(17));
    p.position.set(14.904, 12.198, -1.832), p.scale.set(.15, 4.265, 6.331), _this135.add(p);
    var m = new Nn(t, _this135.createAreaLightMaterial(43));
    m.position.set(-.462, 8.89, 14.52), m.scale.set(4.38, 5.441, .088), _this135.add(m);
    var f = new Nn(t, _this135.createAreaLightMaterial(20));
    f.position.set(3.235, 11.486, -12.541), f.scale.set(2.5, 2, .1), _this135.add(f);
    var g = new Nn(t, _this135.createAreaLightMaterial(100));
    g.position.set(0, 20, 0), g.scale.set(1, .1, 1), _this135.add(g);
    return _this135;
  }

  _createClass(Cd, [{
    key: "createAreaLightMaterial",
    value: function createAreaLightMaterial(t) {
      var e = new nn();
      return e.color.setScalar(t), e;
    }
  }]);

  return Cd;
}(Is);
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ld = /*#__PURE__*/function (_Is3) {
  _inherits(Ld, _Is3);

  var _super132 = _createSuper(Ld);

  function Ld() {
    var _this136;

    _classCallCheck(this, Ld);

    _this136 = _super132.call(this), _this136.position.y = -3.5;
    var t = new Un();
    t.deleteAttribute("uv");
    var e = new No({
      metalness: 0,
      side: 1
    }),
        n = new No({
      metalness: 0
    }),
        i = new Tl(16777215, 400, 28, 2);
    i.position.set(.5, 14, .5), _this136.add(i);
    var r = new Nn(t, e);
    r.position.set(0, 13.2, 0), r.scale.set(31.5, 28.5, 31.5), _this136.add(r);
    var s = new Nn(t, n);
    s.position.set(-10.906, -1, 1.846), s.rotation.set(0, -.195, 0), s.scale.set(2.328, 7.905, 4.651), _this136.add(s);
    var a = new Nn(t, n);
    a.position.set(-5.607, -.754, -.758), a.rotation.set(0, .994, 0), a.scale.set(1.97, 1.534, 3.955), _this136.add(a);
    var o = new Nn(t, n);
    o.position.set(6.167, -.16, 7.803), o.rotation.set(0, .561, 0), o.scale.set(3.927, 6.285, 3.687), _this136.add(o);
    var l = new Nn(t, n);
    l.position.set(-2.017, .018, 6.124), l.rotation.set(0, .333, 0), l.scale.set(2.002, 4.566, 2.064), _this136.add(l);
    var h = new Nn(t, n);
    h.position.set(2.291, -.756, -2.621), h.rotation.set(0, -.286, 0), h.scale.set(1.546, 1.552, 1.496), _this136.add(h);
    var c = new Nn(t, n);
    c.position.set(-2.193, -.369, -5.547), c.rotation.set(0, .516, 0), c.scale.set(3.875, 3.487, 2.986), _this136.add(c);
    var u = new Nn(t, _this136.createAreaLightMaterial(80));
    u.position.set(-14, 10, 8), u.scale.set(.1, 2.5, 2.5), _this136.add(u);
    var d = new Nn(t, _this136.createAreaLightMaterial(80));
    d.position.set(-14, 14, -4), d.scale.set(.1, 2.5, 2.5), _this136.add(d);
    var p = new Nn(t, _this136.createAreaLightMaterial(23));
    p.position.set(14, 12, 0), p.scale.set(.1, 5, 5), _this136.add(p);
    var m = new Nn(t, _this136.createAreaLightMaterial(16));
    m.position.set(0, 9, 14), m.scale.set(5, 5, .1), _this136.add(m);
    var f = new Nn(t, _this136.createAreaLightMaterial(80));
    f.position.set(7, 8, -14), f.scale.set(2.5, 2.5, .1), _this136.add(f);
    var g = new Nn(t, _this136.createAreaLightMaterial(80));
    g.position.set(-7, 16, -14), g.scale.set(2.5, 2.5, .1), _this136.add(g);
    var v = new Nn(t, _this136.createAreaLightMaterial(1));
    v.position.set(0, 20, 0), v.scale.set(.1, .1, .1), _this136.add(v);
    return _this136;
  }

  _createClass(Ld, [{
    key: "createAreaLightMaterial",
    value: function createAreaLightMaterial(t) {
      var e = new nn();
      return e.color.setScalar(t), e;
    }
  }]);

  return Ld;
}(Is);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Pd = /\.hdr(\.js)?$/,
    Dd = new pl(),
    Id = new ( /*#__PURE__*/function (_dl) {
  _inherits(_class26, _dl);

  var _super133 = _createSuper(_class26);

  function _class26(t) {
    var _this137;

    _classCallCheck(this, _class26);

    _this137 = _super133.call(this, t), _this137.type = 1016;
    return _this137;
  }

  _createClass(_class26, [{
    key: "parse",
    value: function parse(t) {
      var e = function e(t, _e321) {
        switch (t) {
          case 1:
            console.error("THREE.RGBELoader Read Error: " + (_e321 || ""));
            break;

          case 2:
            console.error("THREE.RGBELoader Write Error: " + (_e321 || ""));
            break;

          case 3:
            console.error("THREE.RGBELoader Bad File Format: " + (_e321 || ""));
            break;

          default:
            console.error("THREE.RGBELoader: Error: " + (_e321 || ""));
        }

        return -1;
      },
          n = function n(t, e, _n290) {
        e = e || 1024;
        var i = t.pos,
            r = -1,
            s = 0,
            a = "",
            o = String.fromCharCode.apply(null, new Uint16Array(t.subarray(i, i + 128)));

        for (; 0 > (r = o.indexOf("\n")) && s < e && i < t.byteLength;) {
          a += o, s += o.length, i += 128, o += String.fromCharCode.apply(null, new Uint16Array(t.subarray(i, i + 128)));
        }

        return -1 < r && (!1 !== _n290 && (t.pos += s + r + 1), a + o.slice(0, r));
      },
          i = function i(t, e, n, _i237) {
        var r = t[e + 3],
            s = Math.pow(2, r - 128) / 255;
        n[_i237 + 0] = t[e + 0] * s, n[_i237 + 1] = t[e + 1] * s, n[_i237 + 2] = t[e + 2] * s, n[_i237 + 3] = 1;
      },
          r = function r(t, e, n, i) {
        var r = t[e + 3],
            s = Math.pow(2, r - 128) / 255;
        n[i + 0] = th.toHalfFloat(Math.min(t[e + 0] * s, 65504)), n[i + 1] = th.toHalfFloat(Math.min(t[e + 1] * s, 65504)), n[i + 2] = th.toHalfFloat(Math.min(t[e + 2] * s, 65504)), n[i + 3] = th.toHalfFloat(1);
      },
          s = new Uint8Array(t);

      s.pos = 0;

      var a = function (t) {
        var i = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/,
            r = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/,
            s = /^\s*FORMAT=(\S+)\s*$/,
            a = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/,
            o = {
          valid: 0,
          string: "",
          comments: "",
          programtype: "RGBE",
          format: "",
          gamma: 1,
          exposure: 1,
          width: 0,
          height: 0
        };
        var l, h;
        if (t.pos >= t.byteLength || !(l = n(t))) return e(1, "no header found");
        if (!(h = l.match(/^#\?(\S+)/))) return e(3, "bad initial token");

        for (o.valid |= 1, o.programtype = h[1], o.string += l + "\n"; l = n(t), !1 !== l;) {
          if (o.string += l + "\n", "#" !== l.charAt(0)) {
            if ((h = l.match(i)) && (o.gamma = parseFloat(h[1])), (h = l.match(r)) && (o.exposure = parseFloat(h[1])), (h = l.match(s)) && (o.valid |= 2, o.format = h[1]), (h = l.match(a)) && (o.valid |= 4, o.height = parseInt(h[1], 10), o.width = parseInt(h[2], 10)), 2 & o.valid && 4 & o.valid) break;
          } else o.comments += l + "\n";
        }

        return 2 & o.valid ? 4 & o.valid ? o : e(3, "missing image size specifier") : e(3, "missing format specifier");
      }(s);

      if (-1 !== a) {
        var _t382 = a.width,
            _n291 = a.height,
            _o43 = function (t, n, i) {
          var r = n;
          if (r < 8 || r > 32767 || 2 !== t[0] || 2 !== t[1] || 128 & t[2]) return new Uint8Array(t);
          if (r !== (t[2] << 8 | t[3])) return e(3, "wrong scanline width");
          var s = new Uint8Array(4 * n * i);
          if (!s.length) return e(4, "unable to allocate buffer space");
          var a = 0,
              o = 0;
          var l = 4 * r,
              h = new Uint8Array(4),
              c = new Uint8Array(l);
          var u = i;

          for (; u > 0 && o < t.byteLength;) {
            if (o + 4 > t.byteLength) return e(1);
            if (h[0] = t[o++], h[1] = t[o++], h[2] = t[o++], h[3] = t[o++], 2 != h[0] || 2 != h[1] || (h[2] << 8 | h[3]) != r) return e(3, "bad rgbe scanline format");

            var _n292 = void 0,
                _i238 = 0;

            for (; _i238 < l && o < t.byteLength;) {
              _n292 = t[o++];

              var _r154 = _n292 > 128;

              if (_r154 && (_n292 -= 128), 0 === _n292 || _i238 + _n292 > l) return e(3, "bad scanline data");

              if (_r154) {
                var _e322 = t[o++];

                for (var _t383 = 0; _t383 < _n292; _t383++) {
                  c[_i238++] = _e322;
                }
              } else c.set(t.subarray(o, o + _n292), _i238), _i238 += _n292, o += _n292;
            }

            var _d19 = r;

            for (var _t384 = 0; _t384 < _d19; _t384++) {
              var _e323 = 0;
              s[a] = c[_t384 + _e323], _e323 += r, s[a + 1] = c[_t384 + _e323], _e323 += r, s[a + 2] = c[_t384 + _e323], _e323 += r, s[a + 3] = c[_t384 + _e323], a += 4;
            }

            u--;
          }

          return s;
        }(s.subarray(s.pos), _t382, _n291);

        if (-1 !== _o43) {
          var _e324, _s89, _l43, _h30;

          switch (this.type) {
            case 1015:
              _h30 = _o43.length / 4;

              var _t385 = new Float32Array(4 * _h30);

              for (var _e325 = 0; _e325 < _h30; _e325++) {
                i(_o43, 4 * _e325, _t385, 4 * _e325);
              }

              _e324 = _t385, _l43 = 1015;
              break;

            case 1016:
              _h30 = _o43.length / 4;

              var _n293 = new Uint16Array(4 * _h30);

              for (var _t386 = 0; _t386 < _h30; _t386++) {
                r(_o43, 4 * _t386, _n293, 4 * _t386);
              }

              _e324 = _n293, _l43 = 1016;
              break;

            default:
              console.error("THREE.RGBELoader: unsupported type: ", this.type);
          }

          return {
            width: _t382,
            height: _n291,
            data: _e324,
            header: a.string,
            gamma: a.gamma,
            exposure: a.exposure,
            format: _s89,
            type: _l43
          };
        }
      }

      return null;
    }
  }, {
    key: "setDataType",
    value: function setDataType(t) {
      return this.type = t, this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      return _get(_getPrototypeOf(_class26.prototype), "load", this).call(this, t, function (t, n) {
        switch (t.type) {
          case 1015:
          case 1016:
            t.encoding = 3e3, t.minFilter = 1006, t.magFilter = 1006, t.generateMipmaps = !1, t.flipY = !0;
        }

        e && e(t, n);
      }, n, i);
    }
  }]);

  return _class26;
}(dl))();
Id.setDataType(1016);

var Od = /*#__PURE__*/function (_et10) {
  _inherits(Od, _et10);

  var _super134 = _createSuper(Od);

  function Od(t) {
    var _this138;

    _classCallCheck(this, Od);

    _this138 = _super134.call(this), _this138.threeRenderer = t, _this138.generatedEnvironmentMap = null, _this138.generatedEnvironmentMapAlt = null, _this138.skyboxCache = new Map(), _this138.blurMaterial = null, _this138.blurScene = null;
    return _this138;
  }

  _createClass(Od, [{
    key: "load",
    value: function () {
      var _load2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(t) {
        var e,
            n,
            _i239,
            _r155,
            _args18 = arguments;

        return _regeneratorRuntime.wrap(function _callee15$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                e = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : function () {};
                _context18.prev = 1;
                n = Pd.test(t);
                _i239 = n ? Id : Dd;
                _context18.next = 6;
                return new Promise(function (n, r) {
                  return _i239.load(t, n, function (t) {
                    e(t.loaded / t.total * .9);
                  }, r);
                });

              case 6:
                _r155 = _context18.sent;
                return _context18.abrupt("return", (e(1), _r155.name = t, _r155.mapping = 303, n || (_r155.encoding = 3001), _r155));

              case 8:
                _context18.prev = 8;
                e && e(1);
                return _context18.finish(8);

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee15, null, [[1,, 8, 11]]);
      }));

      function load(_x16) {
        return _load2.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "generateEnvironmentMapAndSkybox",
    value: function () {
      var _generateEnvironmentMapAndSkybox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var t,
            e,
            n,
            i,
            r,
            s,
            a,
            _yield$Promise$all,
            _yield$Promise$all2,
            o,
            l,
            _args19 = arguments;

        return _regeneratorRuntime.wrap(function _callee16$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                t = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : null;
                e = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : null;
                n = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : {};
                i = n.progressTracker, r = "neutral" === e;
                !0 === r && (e = null), e = ru(e);
                a = Promise.resolve(null);
                t && (a = this.loadEquirectFromUrl(t, i)), s = e ? this.loadEquirectFromUrl(e, i) : t ? this.loadEquirectFromUrl(t, i) : !0 === r ? this.loadGeneratedEnvironmentMapAlt() : this.loadGeneratedEnvironmentMap();
                _context19.next = 9;
                return Promise.all([s, a]);

              case 9:
                _yield$Promise$all = _context19.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                o = _yield$Promise$all2[0];
                l = _yield$Promise$all2[1];

                if (!(null == o)) {
                  _context19.next = 15;
                  break;
                }

                throw new Error("Failed to load environment map.");

              case 15:
                return _context19.abrupt("return", {
                  environmentMap: o,
                  skybox: l
                });

              case 16:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee16, this);
      }));

      function generateEnvironmentMapAndSkybox() {
        return _generateEnvironmentMapAndSkybox.apply(this, arguments);
      }

      return generateEnvironmentMapAndSkybox;
    }()
  }, {
    key: "loadEquirectFromUrl",
    value: function () {
      var _loadEquirectFromUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(t, e) {
        var n, _i240;

        return _regeneratorRuntime.wrap(function _callee17$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (!this.skyboxCache.has(t)) {
                  n = e ? e.beginActivity() : function () {}, _i240 = this.load(t, n);
                  this.skyboxCache.set(t, _i240);
                }

                return _context20.abrupt("return", this.skyboxCache.get(t));

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee17, this);
      }));

      function loadEquirectFromUrl(_x17, _x18) {
        return _loadEquirectFromUrl.apply(this, arguments);
      }

      return loadEquirectFromUrl;
    }()
  }, {
    key: "GenerateEnvironmentMap",
    value: function () {
      var _GenerateEnvironmentMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t, e) {
        var n, i, r, s, a, o;
        return _regeneratorRuntime.wrap(function _callee18$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return uu();

              case 2:
                n = this.threeRenderer, i = new qn(256, {
                  generateMipmaps: !1,
                  type: 1016,
                  format: 1023,
                  encoding: 3e3,
                  depthBuffer: !0
                }), r = new Wn(.1, 100, i), s = r.renderTarget.texture;
                s.name = e;
                a = n.outputEncoding, o = n.toneMapping;
                return _context21.abrupt("return", (n.toneMapping = 0, n.outputEncoding = 3e3, r.update(n, t), this.blurCubemap(i, .04), n.toneMapping = o, n.outputEncoding = a, s));

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee18, this);
      }));

      function GenerateEnvironmentMap(_x19, _x20) {
        return _GenerateEnvironmentMap.apply(this, arguments);
      }

      return GenerateEnvironmentMap;
    }()
  }, {
    key: "loadGeneratedEnvironmentMap",
    value: function () {
      var _loadGeneratedEnvironmentMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", (null == this.generatedEnvironmentMap && (this.generatedEnvironmentMap = this.GenerateEnvironmentMap(new Cd(), "default")), this.generatedEnvironmentMap));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee19, this);
      }));

      function loadGeneratedEnvironmentMap() {
        return _loadGeneratedEnvironmentMap.apply(this, arguments);
      }

      return loadGeneratedEnvironmentMap;
    }()
  }, {
    key: "loadGeneratedEnvironmentMapAlt",
    value: function () {
      var _loadGeneratedEnvironmentMapAlt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", (null == this.generatedEnvironmentMapAlt && (this.generatedEnvironmentMapAlt = this.GenerateEnvironmentMap(new Ld(), "neutral")), this.generatedEnvironmentMapAlt));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee20, this);
      }));

      function loadGeneratedEnvironmentMapAlt() {
        return _loadGeneratedEnvironmentMapAlt.apply(this, arguments);
      }

      return loadGeneratedEnvironmentMapAlt;
    }()
  }, {
    key: "blurCubemap",
    value: function blurCubemap(t, e) {
      if (null == this.blurMaterial) {
        this.blurMaterial = this.getBlurShader(20);

        var _t387 = new Un(),
            _e326 = new Nn(_t387, this.blurMaterial);

        this.blurScene = new Is(), this.blurScene.add(_e326);
      }

      var n = t.clone();
      this.halfblur(t, n, e, "latitudinal"), this.halfblur(n, t, e, "longitudinal");
    }
  }, {
    key: "halfblur",
    value: function halfblur(t, e, n, i) {
      var r = t.width,
          s = isFinite(n) ? Math.PI / (2 * r) : 2 * Math.PI / 39,
          a = n / s,
          o = isFinite(n) ? 1 + Math.floor(3 * a) : 20;
      o > 20 && console.warn("sigmaRadians, ".concat(n, ", is too large and will clip, as it requested ").concat(o, " samples when the maximum is set to 20"));
      var l = [];
      var h = 0;

      for (var _t388 = 0; _t388 < 20; ++_t388) {
        var _e327 = _t388 / a,
            _n294 = Math.exp(-_e327 * _e327 / 2);

        l.push(_n294), 0 == _t388 ? h += _n294 : _t388 < o && (h += 2 * _n294);
      }

      for (var _t389 = 0; _t389 < l.length; _t389++) {
        l[_t389] = l[_t389] / h;
      }

      var c = this.blurMaterial.uniforms;
      c.envMap.value = t.texture, c.samples.value = o, c.weights.value = l, c.latitudinal.value = "latitudinal" === i, c.dTheta.value = s;
      new Wn(.1, 100, e).update(this.threeRenderer, this.blurScene);
    }
  }, {
    key: "getBlurShader",
    value: function getBlurShader(t) {
      var e = new Float32Array(t),
          n = new zt(0, 1, 0);
      return new Hn({
        name: "SphericalGaussianBlur",
        defines: {
          n: t
        },
        uniforms: {
          envMap: {
            value: null
          },
          samples: {
            value: 1
          },
          weights: {
            value: e
          },
          latitudinal: {
            value: !1
          },
          dTheta: {
            value: 0
          },
          poleAxis: {
            value: n
          }
        },
        vertexShader: "\n      \n      varying vec3 vOutputDirection;\n  \n      void main() {\n  \n        vOutputDirection = vec3( position );\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n  \n      }\n    ",
        fragmentShader: "\n        varying vec3 vOutputDirection;\n  \n        uniform samplerCube envMap;\n        uniform int samples;\n        uniform float weights[ n ];\n        uniform bool latitudinal;\n        uniform float dTheta;\n        uniform vec3 poleAxis;\n  \n        vec3 getSample( float theta, vec3 axis ) {\n  \n          float cosTheta = cos( theta );\n          // Rodrigues' axis-angle rotation\n          vec3 sampleDirection = vOutputDirection * cosTheta\n            + cross( axis, vOutputDirection ) * sin( theta )\n            + axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n  \n          return vec3( textureCube( envMap, sampleDirection ) );\n  \n        }\n  \n        void main() {\n  \n          vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n  \n          if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n  \n            axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n  \n          }\n  \n          axis = normalize( axis );\n  \n          gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n          gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n  \n          for ( int i = 1; i < n; i++ ) {\n  \n            if ( i >= samples ) {\n  \n              break;\n  \n            }\n  \n            float theta = dTheta * float( i );\n            gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n            gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n  \n          }\n        }\n      ",
        blending: 0,
        depthTest: !1,
        depthWrite: !1,
        side: 1
      });
    }
  }, {
    key: "dispose",
    value: function () {
      var _dispose2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _iterator21, _step21, _step21$value, _t390;

        return _regeneratorRuntime.wrap(function _callee21$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _iterator21 = _createForOfIteratorHelper(this.skyboxCache);
                _context24.prev = 1;

                _iterator21.s();

              case 3:
                if ((_step21 = _iterator21.n()).done) {
                  _context24.next = 10;
                  break;
                }

                _step21$value = _slicedToArray(_step21.value, 2), _t390 = _step21$value[1];
                _context24.next = 7;
                return _t390;

              case 7:
                _context24.sent.dispose();

              case 8:
                _context24.next = 3;
                break;

              case 10:
                _context24.next = 15;
                break;

              case 12:
                _context24.prev = 12;
                _context24.t0 = _context24["catch"](1);

                _iterator21.e(_context24.t0);

              case 15:
                _context24.prev = 15;

                _iterator21.f();

                return _context24.finish(15);

              case 18:
                _context24.t1 = null != this.generatedEnvironmentMap;

                if (!_context24.t1) {
                  _context24.next = 24;
                  break;
                }

                _context24.next = 22;
                return this.generatedEnvironmentMap;

              case 22:
                _context24.sent.dispose();

                this.generatedEnvironmentMap = null;

              case 24:
                _context24.t2 = null != this.generatedEnvironmentMapAlt;

                if (!_context24.t2) {
                  _context24.next = 30;
                  break;
                }

                _context24.next = 28;
                return this.generatedEnvironmentMapAlt;

              case 28:
                _context24.sent.dispose();

                this.generatedEnvironmentMapAlt = null;

              case 30:
                null != this.blurMaterial && this.blurMaterial.dispose();

              case 31:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee21, this, [[1, 12, 15, 18]]);
      }));

      function dispose() {
        return _dispose2.apply(this, arguments);
      }

      return dispose;
    }()
  }]);

  return Od;
}(et);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Nd = [1, .79, .62, .5, .4, .31, .25];

var Fd = /*#__PURE__*/function (_et11) {
  _inherits(Fd, _et11);

  var _super135 = _createSuper(Fd);

  function Fd(t) {
    var _this139;

    _classCallCheck(this, Fd);

    _this139 = _super135.call(this), _this139.loader = new Zc(Rd), _this139.width = 0, _this139.height = 0, _this139.dpr = 1, _this139.debugger = null, _this139.scenes = new Set(), _this139.multipleScenesVisible = !1, _this139.scaleStep = 0, _this139.lastStep = 3, _this139.avgFrameDuration = 22, _this139.onWebGLContextLost = function (t) {
      _this139.dispatchEvent({
        type: "contextlost",
        sourceEvent: t
      });
    }, _this139.onWebGLContextRestored = function () {
      var t;
      null === (t = _this139.textureUtils) || void 0 === t || t.dispose(), _this139.textureUtils = new Od(_this139.threeRenderer);

      var _iterator22 = _createForOfIteratorHelper(_this139.scenes),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _t391 = _step22.value;

          _t391.element[Gu]();
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }, _this139.dpr = hu(), _this139.canvas3D = document.createElement("canvas"), _this139.canvas3D.id = "webgl-canvas";

    try {
      _this139.threeRenderer = new Ds({
        canvas: _this139.canvas3D,
        alpha: !0,
        antialias: !0,
        powerPreference: t.powerPreference,
        preserveDrawingBuffer: !0
      }), _this139.threeRenderer.autoClear = !0, _this139.threeRenderer.outputEncoding = 3001, _this139.threeRenderer.physicallyCorrectLights = !0, _this139.threeRenderer.setPixelRatio(1), _this139.debugger = t.debug ? new hd(_assertThisInitialized(_this139)) : null, _this139.threeRenderer.debug = {
        checkShaderErrors: !!_this139.debugger
      }, _this139.threeRenderer.toneMapping = 4;
    } catch (t) {
      console.warn(t);
    }

    _this139.arRenderer = new ld(_assertThisInitialized(_this139)), _this139.textureUtils = _this139.canRender ? new Od(_this139.threeRenderer) : null, Zc.initializeKTX2Loader(_this139.threeRenderer), _this139.canvas3D.addEventListener("webglcontextlost", _this139.onWebGLContextLost), _this139.canvas3D.addEventListener("webglcontextrestored", _this139.onWebGLContextRestored), _this139.updateRendererSize(), _this139.lastTick = performance.now(), _this139.avgFrameDuration = 0;
    return _this139;
  }

  _createClass(Fd, [{
    key: "canRender",
    get: function get() {
      return null != this.threeRenderer;
    }
  }, {
    key: "scaleFactor",
    get: function get() {
      return Nd[this.scaleStep];
    }
  }, {
    key: "minScale",
    set: function set(t) {
      var e = 1;

      for (; e < Nd.length && !(Nd[e] < t);) {
        ++e;
      }

      this.lastStep = e - 1;
    }
  }, {
    key: "updateRendererSize",
    value: function updateRendererSize() {
      var t = hu();

      if (t !== this.dpr) {
        var _iterator23 = _createForOfIteratorHelper(this.scenes),
            _step23;

        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var _t392 = _step23.value;
            var _e328 = _t392.element;

            _e328[op](_e328.getBoundingClientRect());
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      }

      var e = 0,
          n = 0;

      var _iterator24 = _createForOfIteratorHelper(this.scenes),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _t393 = _step24.value;
          e = Math.max(e, _t393.width), n = Math.max(n, _t393.height);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }

      if (e === this.width && n === this.height && t === this.dpr) return;
      this.width = e, this.height = n, this.dpr = t, this.canRender && this.threeRenderer.setSize(e * t, n * t, !1);
      var i = this.scaleFactor,
          r = e / i,
          s = n / i;
      this.canvas3D.style.width = "".concat(r, "px"), this.canvas3D.style.height = "".concat(s, "px");

      var _iterator25 = _createForOfIteratorHelper(this.scenes),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _i241 = _step25.value;
          var _a70 = _i241.canvas;
          _a70.width = Math.round(e * t), _a70.height = Math.round(n * t), _a70.style.width = "".concat(r, "px"), _a70.style.height = "".concat(s, "px"), _i241.queueRender();
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }
  }, {
    key: "updateRendererScale",
    value: function updateRendererScale() {
      var t = this.scaleStep;
      if (this.avgFrameDuration > 26 ? ++this.scaleStep : this.avgFrameDuration < 18 && this.scaleStep > 0 && --this.scaleStep, this.scaleStep = Math.min(this.scaleStep, this.lastStep), t == this.scaleStep) return;
      var e = this.scaleFactor;
      this.avgFrameDuration = 22;
      var n = this.width / e,
          i = this.height / e;
      this.canvas3D.style.width = "".concat(n, "px"), this.canvas3D.style.height = "".concat(i, "px");

      var _iterator26 = _createForOfIteratorHelper(this.scenes),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _t394 = _step26.value;
          var _e329 = _t394.canvas.style;
          _e329.width = "".concat(n, "px"), _e329.height = "".concat(i, "px"), _t394.queueRender(), this.dispatchRenderScale(_t394);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }
  }, {
    key: "dispatchRenderScale",
    value: function dispatchRenderScale(t) {
      var e = this.scaleFactor,
          n = this.dpr * e,
          i = e < 1 ? "GPU throttling" : this.dpr !== window.devicePixelRatio ? "No meta viewport tag" : "";
      t.element.dispatchEvent(new CustomEvent("render-scale", {
        detail: {
          reportedDpr: window.devicePixelRatio,
          renderedDpr: n,
          minimumDpr: this.dpr * Nd[this.lastStep],
          pixelWidth: Math.ceil(t.width * n),
          pixelHeight: Math.ceil(t.height * n),
          reason: i
        }
      }));
    }
  }, {
    key: "registerScene",
    value: function registerScene(t) {
      var _this140 = this;

      this.scenes.add(t);
      var e = t.canvas,
          n = this.scaleFactor;
      e.width = Math.round(this.width * this.dpr), e.height = Math.round(this.height * this.dpr), e.style.width = this.width / n + "px", e.style.height = this.height / n + "px", this.multipleScenesVisible && e.classList.add("show"), t.queueRender(), this.dispatchRenderScale(t), this.canRender && this.scenes.size > 0 && this.threeRenderer.setAnimationLoop(function (t, e) {
        return _this140.render(t, e);
      }), null != this.debugger && this.debugger.addScene(t);
    }
  }, {
    key: "unregisterScene",
    value: function unregisterScene(t) {
      this.scenes.delete(t), this.canRender && 0 === this.scenes.size && this.threeRenderer.setAnimationLoop(null), null != this.debugger && this.debugger.removeScene(t);
    }
  }, {
    key: "displayCanvas",
    value: function displayCanvas(t) {
      return this.multipleScenesVisible ? t.element[_p] : this.canvas3D;
    }
  }, {
    key: "selectCanvas",
    value: function selectCanvas() {
      var t = 0,
          e = null;

      var _iterator27 = _createForOfIteratorHelper(this.scenes),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _n295 = _step27.value;
          var _i242 = _n295.element;
          _i242.modelIsVisible && null == _n295.externalRenderer && (++t, e = _n295.canvas);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }

      if (null == e) return;
      var n = t > 1,
          i = this.canvas3D;

      if (n !== this.multipleScenesVisible || !n && i.parentElement !== e.parentElement) {
        this.multipleScenesVisible = n, n && i.classList.remove("show");

        var _iterator28 = _createForOfIteratorHelper(this.scenes),
            _step28;

        try {
          for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
            var _t395 = _step28.value;
            if (null != _t395.externalRenderer) continue;
            var _r156 = _t395.element[_p];
            n ? (_r156.classList.add("show"), _t395.queueRender()) : _t395.canvas === e && (_t395.canvas.parentElement.appendChild(i), i.classList.add("show"), _r156.classList.remove("show"), _t395.queueRender());
          }
        } catch (err) {
          _iterator28.e(err);
        } finally {
          _iterator28.f();
        }
      }
    }
  }, {
    key: "orderedScenes",
    value: function orderedScenes() {
      var t = [];

      for (var _i243 = 0, _arr = [!1, !0]; _i243 < _arr.length; _i243++) {
        var _e330 = _arr[_i243];

        var _iterator29 = _createForOfIteratorHelper(this.scenes),
            _step29;

        try {
          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
            var n = _step29.value;
            n.element.modelIsVisible === _e330 && t.push(n);
          }
        } catch (err) {
          _iterator29.e(err);
        } finally {
          _iterator29.f();
        }
      }

      return t;
    }
  }, {
    key: "isPresenting",
    get: function get() {
      return this.arRenderer.isPresenting;
    }
  }, {
    key: "preRender",
    value: function preRender(t, e, n) {
      var i = t.element,
          r = t.exposure;
      i[Mp](e, n);
      var s = "number" == typeof r && !self.isNaN(r);
      this.threeRenderer.toneMappingExposure = s ? r : 1;
    }
  }, {
    key: "render",
    value: function render(t, e) {
      if (null != e) return void this.arRenderer.onWebXRFrame(t, e);
      var n = t - this.lastTick;
      if (this.lastTick = t, !this.canRender || this.isPresenting) return;
      this.avgFrameDuration += lu(.2 * (n - this.avgFrameDuration), -2, 2), this.selectCanvas(), this.updateRendererSize(), this.updateRendererScale();
      var i = this.dpr,
          r = this.scaleFactor;

      var _iterator30 = _createForOfIteratorHelper(this.orderedScenes()),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var _e331 = _step30.value;
          var _s90 = _e331.element;
          if (!_s90.modelIsVisible && _e331.renderCount > 0) continue;
          if (this.preRender(_e331, t, n), !_e331.shouldRender()) continue;

          if (null != _e331.externalRenderer) {
            var _t396 = _e331.getCamera();

            _t396.updateMatrix();

            var _n296 = _t396.matrix,
                _i244 = _t396.projectionMatrix,
                _r157 = _n296.elements.slice(),
                _s91 = _e331.getTarget();

            _r157[12] += _s91.x, _r157[13] += _s91.y, _r157[14] += _s91.z, _e331.externalRenderer.render({
              viewMatrix: _r157,
              projectionMatrix: _i244.elements
            });
            continue;
          }

          if (!_s90.modelIsVisible && !this.multipleScenesVisible) {
            var _iterator31 = _createForOfIteratorHelper(this.scenes),
                _step31;

            try {
              for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                var _t397 = _step31.value;
                _t397.element.modelIsVisible && _t397.queueRender();
              }
            } catch (err) {
              _iterator31.e(err);
            } finally {
              _iterator31.f();
            }
          }

          var _a71 = Math.min(Math.ceil(_e331.width * r * i), this.canvas3D.width),
              _o44 = Math.min(Math.ceil(_e331.height * r * i), this.canvas3D.height);

          if (_e331.renderShadow(this.threeRenderer), this.threeRenderer.setRenderTarget(null), this.threeRenderer.setViewport(0, Math.floor(this.height * i) - _o44, _a71, _o44), this.threeRenderer.render(_e331, _e331.camera), this.multipleScenesVisible) {
            null == _e331.context && _e331.createContext();
            var _t398 = _e331.context;
            _t398.clearRect(0, 0, _a71, _o44), _t398.drawImage(this.canvas3D, 0, 0, _a71, _o44, 0, 0, _a71, _o44);
          }

          _e331.hasRendered(), _s90.loaded && ++_e331.renderCount;
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      null != this.textureUtils && this.textureUtils.dispose(), null != this.threeRenderer && this.threeRenderer.dispose(), this.textureUtils = null, this.threeRenderer = null;
      var t = [];

      var _iterator32 = _createForOfIteratorHelper(this.scenes),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _e332 = _step32.value;
          t.push(_e332.element);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }

      return this.canvas3D.removeEventListener("webglcontextlost", this.onWebGLContextLost), this.canvas3D.removeEventListener("webglcontextrestored", this.onWebGLContextRestored), t;
    }
  }], [{
    key: "singleton",
    get: function get() {
      return this._singleton;
    }
  }, {
    key: "resetSingleton",
    value: function resetSingleton() {
      var t = this._singleton.dispose();

      var _iterator33 = _createForOfIteratorHelper(t),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var _e333 = _step33.value;

          _e333.disconnectedCallback();
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }

      this._singleton = new Fd({
        powerPreference: (self.ModelViewerElement || {}).powerPreference || "high-performance",
        debug: cu()
      });

      var _iterator34 = _createForOfIteratorHelper(t),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var _e334 = _step34.value;

          _e334.connectedCallback();
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    }
  }]);

  return Fd;
}(et);

Fd._singleton = new Fd({
  powerPreference: (self.ModelViewerElement || {}).powerPreference || "high-performance",
  debug: cu()
});
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Ud = /*#__PURE__*/function (_EventTarget) {
  _inherits(Ud, _EventTarget);

  var _super136 = _createSuper(Ud);

  function Ud() {
    var _this141;

    _classCallCheck(this, Ud);

    _this141 = _super136.apply(this, arguments), _this141.ongoingActivities = new Set(), _this141.totalProgress = 0;
    return _this141;
  }

  _createClass(Ud, [{
    key: "ongoingActivityCount",
    get: function get() {
      return this.ongoingActivities.size;
    }
  }, {
    key: "beginActivity",
    value: function beginActivity() {
      var _this142 = this;

      var t = {
        progress: 0,
        completed: !1
      };
      return this.ongoingActivities.add(t), 1 === this.ongoingActivityCount && this.announceTotalProgress(t, 0), function (e) {
        var n;
        return n = Math.max(lu(e, 0, 1), t.progress), n !== t.progress && _this142.announceTotalProgress(t, n), t.progress;
      };
    }
  }, {
    key: "announceTotalProgress",
    value: function announceTotalProgress(t, e) {
      var n = 0,
          i = 0;
      1 == e && (t.completed = !0);

      var _iterator35 = _createForOfIteratorHelper(this.ongoingActivities),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var _t399 = _step35.value;
          var _e335 = _t399.progress;
          n += 1 - _e335, !0 === _t399.completed && i++;
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }

      var r = t.progress;
      t.progress = e, this.totalProgress += (e - r) * (1 - this.totalProgress) / n;
      var s = i === this.ongoingActivityCount ? 1 : this.totalProgress;
      this.dispatchEvent(new CustomEvent("progress", {
        detail: {
          totalProgress: s
        }
      })), i === this.ongoingActivityCount && (this.totalProgress = 0, this.ongoingActivities.clear());
    }
  }]);

  return Ud;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var kd,
    Bd,
    zd,
    Hd,
    Vd,
    Gd,
    Wd,
    jd,
    qd,
    Xd,
    Yd,
    Jd,
    Zd = function Zd(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var $d = document.createElement("canvas"),
    Kd = Symbol("fallbackResizeHandler"),
    Qd = Symbol("defaultAriaLabel"),
    tp = Symbol("resizeObserver"),
    ep = Symbol("clearModelTimeout"),
    np = Symbol("onContextLost"),
    ip = Symbol("loaded"),
    rp = Symbol("status"),
    sp = Symbol("onFocus"),
    ap = Symbol("onBlur"),
    op = Symbol("updateSize"),
    lp = Symbol("intersectionObserver"),
    hp = Symbol("isElementInViewport"),
    cp = Symbol("announceModelVisibility"),
    up = Symbol("ariaLabel"),
    dp = Symbol("altDefaulted"),
    pp = Symbol("statusElement"),
    mp = Symbol("updateStatus"),
    fp = Symbol("loadedTime"),
    gp = Symbol("updateSource"),
    vp = Symbol("markLoaded"),
    yp = Symbol("container"),
    xp = Symbol("input"),
    _p = Symbol("canvas"),
    bp = Symbol("scene"),
    wp = Symbol("needsRender"),
    Mp = Symbol("tick"),
    Sp = Symbol("onModelLoad"),
    Tp = Symbol("onResize"),
    Ep = Symbol("renderer"),
    Ap = Symbol("progressTracker"),
    Rp = Symbol("getLoaded"),
    Cp = Symbol("getModelIsVisible"),
    Lp = Symbol("shouldAttemptPreload"),
    Pp = Symbol("sceneIsReady"),
    Dp = Symbol("hasTransitioned"),
    Ip = function Ip(t) {
  return {
    x: t.x,
    y: t.y,
    z: t.z,
    toString: function toString() {
      return "".concat(this.x, "m ").concat(this.y, "m ").concat(this.z, "m");
    }
  };
},
    Op = function Op(t) {
  return {
    u: t.x,
    v: t.y,
    toString: function toString() {
      return "".concat(this.u, " ").concat(this.v);
    }
  };
};

var Np = /*#__PURE__*/function (_X2, _ref16, _ref17, _ref18) {
  _inherits(Np, _X2);

  var _super137 = _createSuper(Np);

  function Np() {
    var _this143;

    _classCallCheck(this, Np);

    _this143 = _super137.call(this), _this143.alt = null, _this143.src = null, _this143.withCredentials = !1, _this143[kd] = !1, _this143[Bd] = !1, _this143[zd] = 0, _this143[Hd] = null, _this143[Vd] = ou(function () {
      var t = _this143.getBoundingClientRect();

      _this143[op](t);
    }, 50), _this143[Gd] = ou(function (t) {
      var e = _this143.modelIsVisible;
      e !== t && _this143.dispatchEvent(new CustomEvent("model-visibility", {
        detail: {
          visible: e
        }
      }));
    }, 0), _this143[Wd] = null, _this143[jd] = null, _this143[qd] = new Ud(), _this143[Xd] = function () {
      _this143[pp].textContent = _this143[rp];
    }, _this143[Yd] = function () {
      _this143[pp].textContent = "";
    }, _this143[Jd] = function (t) {
      _this143.dispatchEvent(new CustomEvent("error", {
        detail: {
          type: "webglcontextlost",
          sourceError: t.sourceEvent
        }
      }));
    }, _this143.attachShadow({
      mode: "open"
    });
    var t = _this143.shadowRoot;
    var e, n;

    if (function (t) {
      N(_h, t);
    }(t), _this143[yp] = t.querySelector(".container"), _this143[xp] = t.querySelector(".userInput"), _this143[_p] = t.querySelector("canvas"), _this143[pp] = t.querySelector("#status"), _this143[Qd] = _this143[xp].getAttribute("aria-label"), _this143.isConnected) {
      var _t400 = _this143.getBoundingClientRect();

      e = _t400.width, n = _t400.height;
    } else e = 300, n = 150;

    _this143[bp] = new Bu({
      canvas: _this143[_p],
      element: _assertThisInitialized(_this143),
      width: e,
      height: n
    }), _this143[bp].addEventListener("model-load", /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(t) {
        return _regeneratorRuntime.wrap(function _callee22$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this143[vp]();

                _this143[Sp]();

                _context25.next = 4;
                return uu();

              case 4:
                _this143.dispatchEvent(new CustomEvent("load", {
                  detail: {
                    url: t.url
                  }
                }));

              case 5:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee22);
      }));

      return function (_x21) {
        return _ref19.apply(this, arguments);
      };
    }()), Promise.resolve().then(function () {
      _this143[op](_this143.getBoundingClientRect());
    }), uh && (_this143[tp] = new ResizeObserver(function (t) {
      if (!_this143[Ep].isPresenting) {
        var _iterator36 = _createForOfIteratorHelper(t),
            _step36;

        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var _e336 = _step36.value;
            _e336.target === _assertThisInitialized(_this143) && _this143[op](_e336.contentRect);
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }
      }
    })), dh ? _this143[lp] = new IntersectionObserver(function (t) {
      var _iterator37 = _createForOfIteratorHelper(t),
          _step37;

      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var _e337 = _step37.value;

          if (_e337.target === _assertThisInitialized(_this143)) {
            var _t401 = _this143.modelIsVisible;
            _this143[hp] = _e337.isIntersecting, _this143[cp](_t401), _this143[hp] && !_this143[Pp]() && _this143[gp]();
          }
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0
    }) : _this143[hp] = !0;
    return _this143;
  }

  _createClass(Np, [{
    key: "loaded",
    get: function get() {
      return this[Rp]();
    }
  }, {
    key: _ref16,
    get: function get() {
      return Fd.singleton;
    }
  }, {
    key: "modelIsVisible",
    get: function get() {
      return this[Cp]();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(Np.prototype), "connectedCallback", this) && _get(_getPrototypeOf(Np.prototype), "connectedCallback", this).call(this), uh ? this[tp].observe(this) : self.addEventListener("resize", this[Kd]), dh && this[lp].observe(this), this.addEventListener("focus", this[sp]), this.addEventListener("blur", this[ap]);
      var t = this[Ep];
      t.addEventListener("contextlost", this[np]), t.registerScene(this[bp]), null != this[ep] && (self.clearTimeout(this[ep]), this[ep] = null, this.requestUpdate("src", null));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this144 = this;

      _get(_getPrototypeOf(Np.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(Np.prototype), "disconnectedCallback", this).call(this), uh ? this[tp].unobserve(this) : self.removeEventListener("resize", this[Kd]), dh && this[lp].unobserve(this), this.removeEventListener("focus", this[sp]), this.removeEventListener("blur", this[ap]);
      var t = this[Ep];
      t.removeEventListener("contextlost", this[np]), t.unregisterScene(this[bp]), this[ep] = self.setTimeout(function () {
        _this144[bp].reset();
      }, 1e3);
    }
  }, {
    key: "updated",
    value: function updated(t) {
      _get(_getPrototypeOf(Np.prototype), "updated", this).call(this, t), t.has("src") && (null == this.src ? (this[ip] = !1, this[fp] = 0, this[bp].reset()) : this.src !== this[bp].url && (this[ip] = !1, this[fp] = 0, this[gp]())), t.has("alt") && this[xp].setAttribute("aria-label", this[up]), t.has("withCredentials") && (Zc.withCredentials = this.withCredentials);
    }
  }, {
    key: "toDataURL",
    value: function toDataURL(t, e) {
      return this[Ep].displayCanvas(this[bp]).toDataURL(t, e);
    }
  }, {
    key: "toBlob",
    value: function () {
      var _toBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(t) {
        var _this145 = this;

        var e, n, i, _this$bp, r, s, a, o, _this$Ep, l, h, c, u, d, p, _t402, _t403;

        return _regeneratorRuntime.wrap(function _callee25$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                e = t ? t.mimeType : void 0, n = t ? t.qualityArgument : void 0, i = t ? t.idealAspect : void 0, _this$bp = this[bp], r = _this$bp.width, s = _this$bp.height, a = _this$bp.idealAspect, o = _this$bp.aspect, _this$Ep = this[Ep], l = _this$Ep.dpr, h = _this$Ep.scaleFactor;
                c = r * h * l, u = s * h * l, d = 0, p = 0;
                if (!0 === i) if (a > o) {
                  _t402 = u;
                  u = Math.round(c / a), p = (_t402 - u) / 2;
                } else {
                  _t403 = c;
                  c = Math.round(u * a), d = (_t403 - c) / 2;
                }
                $d.width = c, $d.height = u;
                _context28.prev = 4;
                return _context28.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(t, i) {
                    return _regeneratorRuntime.wrap(function _callee24$(_context27) {
                      while (1) {
                        switch (_context27.prev = _context27.next) {
                          case 0:
                            $d.getContext("2d").drawImage(_this145[Ep].displayCanvas(_this145[bp]), d, p, c, u, 0, 0, c, u);

                            if (!(!$d.msToBlob || e && "image/png" !== e)) {
                              _context27.next = 14;
                              break;
                            }

                            if (!$d.toBlob) {
                              _context27.next = 6;
                              break;
                            }

                            _context27.t1 = void $d.toBlob(function (e) {
                              if (!e) return i(new Error("Unable to retrieve canvas blob"));
                              t(e);
                            }, e, n);
                            _context27.next = 11;
                            break;

                          case 6:
                            _context27.t2 = t;
                            _context27.next = 9;
                            return function () {
                              var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t) {
                                return _regeneratorRuntime.wrap(function _callee23$(_context26) {
                                  while (1) {
                                    switch (_context26.prev = _context26.next) {
                                      case 0:
                                        return _context26.abrupt("return", new Promise(function (e, n) {
                                          var i = t.match(/data:(.*);/);
                                          if (!i) return n(new Error("".concat(t, " is not a valid data Url")));
                                          var r = i[1],
                                              s = t.replace(/data:image\/\w+;base64,/, ""),
                                              a = atob(s),
                                              o = [];

                                          for (var _t404 = 0; _t404 < a.length; _t404 += 512) {
                                            var _e338 = a.slice(_t404, _t404 + 512),
                                                _n297 = new Array(_e338.length);

                                            for (var _t405 = 0; _t405 < _e338.length; _t405++) {
                                              _n297[_t405] = _e338.charCodeAt(_t405);
                                            }

                                            var _i245 = new Uint8Array(_n297);

                                            o.push(_i245);
                                          }

                                          e(new Blob(o, {
                                            type: r
                                          }));
                                        }));

                                      case 1:
                                      case "end":
                                        return _context26.stop();
                                    }
                                  }
                                }, _callee23);
                              }));

                              return function (_x25) {
                                return _ref21.apply(this, arguments);
                              };
                            }()($d.toDataURL(e, n));

                          case 9:
                            _context27.t3 = _context27.sent;
                            _context27.t1 = (0, _context27.t2)(_context27.t3);

                          case 11:
                            _context27.t0 = _context27.t1;
                            _context27.next = 15;
                            break;

                          case 14:
                            _context27.t0 = t($d.msToBlob());

                          case 15:
                            return _context27.abrupt("return", _context27.t0);

                          case 16:
                          case "end":
                            return _context27.stop();
                        }
                      }
                    }, _callee24);
                  }));

                  return function (_x23, _x24) {
                    return _ref20.apply(this, arguments);
                  };
                }()));

              case 6:
                _context28.prev = 6;
                this[op]({
                  width: r,
                  height: s
                });
                return _context28.finish(6);

              case 9:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee25, this, [[4,, 6, 9]]);
      }));

      function toBlob(_x22) {
        return _toBlob.apply(this, arguments);
      }

      return toBlob;
    }()
  }, {
    key: "registerRenderer",
    value: function registerRenderer(t) {
      this[bp].externalRenderer = t;
    }
  }, {
    key: "unregisterRenderer",
    value: function unregisterRenderer() {
      this[bp].externalRenderer = null;
    }
  }, {
    key: up,
    get: function get() {
      return this[dp];
    }
  }, {
    key: dp,
    get: function get() {
      return null == this.alt || "null" === this.alt ? this[Qd] : this.alt;
    }
  }, {
    key: Rp,
    value: function value() {
      return this[ip];
    }
  }, {
    key: Cp,
    value: function value() {
      return this.loaded && this[hp];
    }
  }, {
    key: Dp,
    value: function value() {
      return this.modelIsVisible;
    }
  }, {
    key: Lp,
    value: function value() {
      return !!this.src && this[hp];
    }
  }, {
    key: Pp,
    value: function value() {
      return this[ip];
    }
  }, {
    key: op,
    value: function value(_ref22) {
      var t = _ref22.width,
          e = _ref22.height;
      this[yp].style.width = "".concat(t, "px"), this[yp].style.height = "".concat(e, "px"), this[Tp]({
        width: parseFloat(t),
        height: parseFloat(e)
      });
    }
  }, {
    key: Mp,
    value: function value(t, e) {}
  }, {
    key: vp,
    value: function value() {
      this[ip] || (this[ip] = !0, this[fp] = performance.now());
    }
  }, {
    key: wp,
    value: function value() {
      this[bp].queueRender();
    }
  }, {
    key: Sp,
    value: function value() {}
  }, {
    key: mp,
    value: function value(t) {
      this[rp] = t;
      var e = this.getRootNode();
      null != e && e.activeElement === this && this[pp].textContent != t && (this[pp].textContent = t);
    }
  }, {
    key: _ref17,
    value: function value(t) {
      this[bp].setSize(t.width, t.height);
    }
  }, {
    key: _ref18,
    value: function () {
      var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var t, e, n;
        return _regeneratorRuntime.wrap(function _callee26$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!(this.loaded || !this[Lp]())) {
                  _context29.next = 2;
                  break;
                }

                return _context29.abrupt("return");

              case 2:
                t = this[Ap].beginActivity(), e = this.src;
                _context29.prev = 3;
                _context29.next = 6;
                return this[bp].setSource(e, function (e) {
                  return t(.95 * e);
                });

              case 6:
                n = {
                  url: e
                };
                this.dispatchEvent(new CustomEvent("preload", {
                  detail: n
                }));
                _context29.next = 13;
                break;

              case 10:
                _context29.prev = 10;
                _context29.t0 = _context29["catch"](3);
                this.dispatchEvent(new CustomEvent("error", {
                  detail: _context29.t0
                }));

              case 13:
                _context29.prev = 13;
                requestAnimationFrame(function () {
                  requestAnimationFrame(function () {
                    t(1);
                  });
                });
                return _context29.finish(13);

              case 16:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee26, this, [[3, 10, 13, 16]]);
      }));

      function value() {
        return _value.apply(this, arguments);
      }

      return value;
    }()
  }], [{
    key: "is",
    get: function get() {
      return "model-viewer";
    }
  }, {
    key: "modelCacheSize",
    get: function get() {
      return Zc[Yc].evictionThreshold;
    },
    set: function set(t) {
      Zc[Yc].evictionThreshold = t;
    }
  }, {
    key: "minimumRenderScale",
    get: function get() {
      return Fd.singleton.minScale;
    },
    set: function set(t) {
      t > 1 && console.warn("<model-viewer> minimumRenderScale has been clamped to a maximum value of 1."), t <= 0 && console.warn("<model-viewer> minimumRenderScale has been clamped to a minimum value of 0.25."), Fd.singleton.minScale = t;
    }
  }]);

  return Np;
}(X, (kd = hp, Bd = ip, zd = fp, Hd = ep, Vd = Kd, Gd = cp, Wd = tp, jd = lp, qd = Ap, Ep), (Xd = sp, Yd = ap, Tp), (Jd = np, gp));

Zd([J({
  type: String
})], Np.prototype, "alt", void 0), Zd([J({
  type: String
})], Np.prototype, "src", void 0), Zd([J({
  type: Boolean,
  attribute: "with-credentials"
})], Np.prototype, "withCredentials", void 0);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Fp = function Fp(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var Up = Symbol("changeAnimation"),
    kp = Symbol("paused"),
    Bp = {
  repetitions: 1 / 0,
  pingpong: !1
},
    zp = Symbol("hotspotMap"),
    Hp = Symbol("mutationCallback"),
    Vp = Symbol("observer"),
    Gp = Symbol("addHotspot"),
    Wp = Symbol("removeHotspot"),
    jp = new ve(),
    qp = new ft();
/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.6.9
*/

var Xp = function Xp(t) {
  return URL.createObjectURL(new Blob([t], {
    type: "text/javascript"
  }));
};

try {
  URL.revokeObjectURL(Xp(""));
} catch (t) {
  Xp = function Xp(t) {
    return "data:application/javascript;charset=UTF-8," + encodeURI(t);
  };
}

var Yp = Uint8Array,
    Jp = Uint16Array,
    Zp = Uint32Array,
    $p = new Yp([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]),
    Kp = new Yp([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]),
    Qp = new Yp([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
    tm = function tm(t, e) {
  for (var n = new Jp(31), i = 0; i < 31; ++i) {
    n[i] = e += 1 << t[i - 1];
  }

  var r = new Zp(n[30]);

  for (i = 1; i < 30; ++i) {
    for (var s = n[i]; s < n[i + 1]; ++s) {
      r[s] = s - n[i] << 5 | i;
    }
  }

  return [n, r];
},
    em = tm($p, 2),
    nm = em[0],
    im = em[1];

nm[28] = 258, im[258] = 28;

for (var rm = tm(Kp, 0)[1], sm = new Jp(32768), am = 0; am < 32768; ++am) {
  var om = (43690 & am) >>> 1 | (21845 & am) << 1;
  om = (61680 & (om = (52428 & om) >>> 2 | (13107 & om) << 2)) >>> 4 | (3855 & om) << 4, sm[am] = ((65280 & om) >>> 8 | (255 & om) << 8) >>> 1;
}

var lm = function lm(t, e, n) {
  for (var i = t.length, r = 0, s = new Jp(e); r < i; ++r) {
    ++s[t[r] - 1];
  }

  var a,
      o = new Jp(e);

  for (r = 0; r < e; ++r) {
    o[r] = o[r - 1] + s[r - 1] << 1;
  }

  if (n) {
    a = new Jp(1 << e);
    var l = 15 - e;

    for (r = 0; r < i; ++r) {
      if (t[r]) for (var h = r << 4 | t[r], c = e - t[r], u = o[t[r] - 1]++ << c, d = u | (1 << c) - 1; u <= d; ++u) {
        a[sm[u] >>> l] = h;
      }
    }
  } else for (a = new Jp(i), r = 0; r < i; ++r) {
    t[r] && (a[r] = sm[o[t[r] - 1]++] >>> 15 - t[r]);
  }

  return a;
},
    hm = new Yp(288);

for (am = 0; am < 144; ++am) {
  hm[am] = 8;
}

for (am = 144; am < 256; ++am) {
  hm[am] = 9;
}

for (am = 256; am < 280; ++am) {
  hm[am] = 7;
}

for (am = 280; am < 288; ++am) {
  hm[am] = 8;
}

var cm = new Yp(32);

for (am = 0; am < 32; ++am) {
  cm[am] = 5;
}

var um = lm(hm, 9, 0),
    dm = lm(cm, 5, 0),
    pm = function pm(t) {
  return (t / 8 | 0) + (7 & t && 1);
},
    mm = function mm(t, e, n) {
  (null == e || e < 0) && (e = 0), (null == n || n > t.length) && (n = t.length);
  var i = new (t instanceof Jp ? Jp : t instanceof Zp ? Zp : Yp)(n - e);
  return i.set(t.subarray(e, n)), i;
},
    fm = function fm(t, e, n) {
  n <<= 7 & e;
  var i = e / 8 | 0;
  t[i] |= n, t[i + 1] |= n >>> 8;
},
    gm = function gm(t, e, n) {
  n <<= 7 & e;
  var i = e / 8 | 0;
  t[i] |= n, t[i + 1] |= n >>> 8, t[i + 2] |= n >>> 16;
},
    vm = function vm(t, e) {
  for (var n = [], i = 0; i < t.length; ++i) {
    t[i] && n.push({
      s: i,
      f: t[i]
    });
  }

  var r = n.length,
      s = n.slice();
  if (!r) return [Sm, 0];

  if (1 == r) {
    var a = new Yp(n[0].s + 1);
    return a[n[0].s] = 1, [a, 1];
  }

  n.sort(function (t, e) {
    return t.f - e.f;
  }), n.push({
    s: -1,
    f: 25001
  });
  var o = n[0],
      l = n[1],
      h = 0,
      c = 1,
      u = 2;

  for (n[0] = {
    s: -1,
    f: o.f + l.f,
    l: o,
    r: l
  }; c != r - 1;) {
    o = n[n[h].f < n[u].f ? h++ : u++], l = n[h != c && n[h].f < n[u].f ? h++ : u++], n[c++] = {
      s: -1,
      f: o.f + l.f,
      l: o,
      r: l
    };
  }

  var d = s[0].s;

  for (i = 1; i < r; ++i) {
    s[i].s > d && (d = s[i].s);
  }

  var p = new Jp(d + 1),
      m = ym(n[c - 1], p, 0);

  if (m > e) {
    i = 0;
    var f = 0,
        g = m - e,
        v = 1 << g;

    for (s.sort(function (t, e) {
      return p[e.s] - p[t.s] || t.f - e.f;
    }); i < r; ++i) {
      var y = s[i].s;
      if (!(p[y] > e)) break;
      f += v - (1 << m - p[y]), p[y] = e;
    }

    for (f >>>= g; f > 0;) {
      var x = s[i].s;
      p[x] < e ? f -= 1 << e - p[x]++ - 1 : ++i;
    }

    for (; i >= 0 && f; --i) {
      var _ = s[i].s;
      p[_] == e && (--p[_], ++f);
    }

    m = e;
  }

  return [new Yp(p), m];
},
    ym = function ym(t, e, n) {
  return -1 == t.s ? Math.max(ym(t.l, e, n + 1), ym(t.r, e, n + 1)) : e[t.s] = n;
},
    xm = function xm(t) {
  for (var e = t.length; e && !t[--e];) {
    ;
  }

  for (var n = new Jp(++e), i = 0, r = t[0], s = 1, a = function a(t) {
    n[i++] = t;
  }, o = 1; o <= e; ++o) {
    if (t[o] == r && o != e) ++s;else {
      if (!r && s > 2) {
        for (; s > 138; s -= 138) {
          a(32754);
        }

        s > 2 && (a(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
      } else if (s > 3) {
        for (a(r), --s; s > 6; s -= 6) {
          a(8304);
        }

        s > 2 && (a(s - 3 << 5 | 8208), s = 0);
      }

      for (; s--;) {
        a(r);
      }

      s = 1, r = t[o];
    }
  }

  return [n.subarray(0, i), e];
},
    _m = function _m(t, e) {
  for (var n = 0, i = 0; i < e.length; ++i) {
    n += t[i] * e[i];
  }

  return n;
},
    bm = function bm(t, e, n) {
  var i = n.length,
      r = pm(e + 2);
  t[r] = 255 & i, t[r + 1] = i >>> 8, t[r + 2] = 255 ^ t[r], t[r + 3] = 255 ^ t[r + 1];

  for (var s = 0; s < i; ++s) {
    t[r + s + 4] = n[s];
  }

  return 8 * (r + 4 + i);
},
    wm = function wm(t, e, n, i, r, s, a, o, l, h, c) {
  fm(e, c++, n), ++r[256];

  for (var u = vm(r, 15), d = u[0], p = u[1], m = vm(s, 15), f = m[0], g = m[1], v = xm(d), y = v[0], x = v[1], _ = xm(f), b = _[0], w = _[1], M = new Jp(19), S = 0; S < y.length; ++S) {
    M[31 & y[S]]++;
  }

  for (S = 0; S < b.length; ++S) {
    M[31 & b[S]]++;
  }

  for (var T = vm(M, 7), E = T[0], A = T[1], R = 19; R > 4 && !E[Qp[R - 1]]; --R) {
    ;
  }

  var C,
      L,
      P,
      D,
      I = h + 5 << 3,
      O = _m(r, hm) + _m(s, cm) + a,
      N = _m(r, d) + _m(s, f) + a + 14 + 3 * R + _m(M, E) + (2 * M[16] + 3 * M[17] + 7 * M[18]);
  if (I <= O && I <= N) return bm(e, c, t.subarray(l, l + h));

  if (fm(e, c, 1 + (N < O)), c += 2, N < O) {
    C = lm(d, p, 0), L = d, P = lm(f, g, 0), D = f;
    var F = lm(E, A, 0);
    fm(e, c, x - 257), fm(e, c + 5, w - 1), fm(e, c + 10, R - 4), c += 14;

    for (S = 0; S < R; ++S) {
      fm(e, c + 3 * S, E[Qp[S]]);
    }

    c += 3 * R;

    for (var U = [y, b], k = 0; k < 2; ++k) {
      var B = U[k];

      for (S = 0; S < B.length; ++S) {
        var z = 31 & B[S];
        fm(e, c, F[z]), c += E[z], z > 15 && (fm(e, c, B[S] >>> 5 & 127), c += B[S] >>> 12);
      }
    }
  } else C = um, L = hm, P = dm, D = cm;

  for (S = 0; S < o; ++S) {
    if (i[S] > 255) {
      z = i[S] >>> 18 & 31;
      gm(e, c, C[z + 257]), c += L[z + 257], z > 7 && (fm(e, c, i[S] >>> 23 & 31), c += $p[z]);
      var H = 31 & i[S];
      gm(e, c, P[H]), c += D[H], H > 3 && (gm(e, c, i[S] >>> 5 & 8191), c += Kp[H]);
    } else gm(e, c, C[i[S]]), c += L[i[S]];
  }

  return gm(e, c, C[256]), c + L[256];
},
    Mm = new Zp([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]),
    Sm = new Yp(0),
    Tm = function () {
  for (var t = new Zp(256), e = 0; e < 256; ++e) {
    for (var n = e, i = 9; --i;) {
      n = (1 & n && 3988292384) ^ n >>> 1;
    }

    t[e] = n;
  }

  return t;
}(),
    Em = function Em() {
  var t = -1;
  return {
    p: function p(e) {
      for (var n = t, i = 0; i < e.length; ++i) {
        n = Tm[255 & n ^ e[i]] ^ n >>> 8;
      }

      t = n;
    },
    d: function d() {
      return ~t;
    }
  };
},
    Am = function Am(t, e, n, i, r) {
  return function (t, e, n, i, r, s) {
    var a = t.length,
        o = new Yp(i + a + 5 * (1 + Math.ceil(a / 7e3)) + r),
        l = o.subarray(i, o.length - r),
        h = 0;
    if (!e || a < 8) for (var c = 0; c <= a; c += 65535) {
      var u = c + 65535;
      u < a ? h = bm(l, h, t.subarray(c, u)) : (l[c] = s, h = bm(l, h, t.subarray(c, a)));
    } else {
      for (var d = Mm[e - 1], p = d >>> 13, m = 8191 & d, f = (1 << n) - 1, g = new Jp(32768), v = new Jp(f + 1), y = Math.ceil(n / 3), x = 2 * y, _ = function _(e) {
        return (t[e] ^ t[e + 1] << y ^ t[e + 2] << x) & f;
      }, b = new Zp(25e3), w = new Jp(288), M = new Jp(32), S = 0, T = 0, E = (c = 0, 0), A = 0, R = 0; c < a; ++c) {
        var C = _(c),
            L = 32767 & c,
            P = v[C];

        if (g[L] = P, v[C] = L, A <= c) {
          var D = a - c;

          if ((S > 7e3 || E > 24576) && D > 423) {
            h = wm(t, l, 0, b, w, M, T, E, R, c - R, h), E = S = T = 0, R = c;

            for (var I = 0; I < 286; ++I) {
              w[I] = 0;
            }

            for (I = 0; I < 30; ++I) {
              M[I] = 0;
            }
          }

          var O = 2,
              N = 0,
              F = m,
              U = L - P & 32767;
          if (D > 2 && C == _(c - U)) for (var k = Math.min(p, D) - 1, B = Math.min(32767, c), z = Math.min(258, D); U <= B && --F && L != P;) {
            if (t[c + O] == t[c + O - U]) {
              for (var H = 0; H < z && t[c + H] == t[c + H - U]; ++H) {
                ;
              }

              if (H > O) {
                if (O = H, N = U, H > k) break;
                var V = Math.min(U, H - 2),
                    G = 0;

                for (I = 0; I < V; ++I) {
                  var W = c - U + I + 32768 & 32767,
                      j = W - g[W] + 32768 & 32767;
                  j > G && (G = j, P = W);
                }
              }
            }

            U += (L = P) - (P = g[L]) + 32768 & 32767;
          }

          if (N) {
            b[E++] = 268435456 | im[O] << 18 | rm[N];
            var q = 31 & im[O],
                X = 31 & rm[N];
            T += $p[q] + Kp[X], ++w[257 + q], ++M[X], A = c + O, ++S;
          } else b[E++] = t[c], ++w[t[c]];
        }
      }

      h = wm(t, l, s, b, w, M, T, E, R, c - R, h), !s && 7 & h && (h = bm(l, h + 1, Sm));
    }
    return mm(o, 0, i + pm(h) + r);
  }(t, null == e.level ? 6 : e.level, null == e.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + e.mem, n, i, !r);
},
    Rm = function Rm(t, e) {
  var n = {};

  for (var i in t) {
    n[i] = t[i];
  }

  for (var i in e) {
    n[i] = e[i];
  }

  return n;
},
    Cm = function Cm(t, e, n) {
  for (; n; ++e) {
    t[e] = n, n >>>= 8;
  }
};

function Lm(t, e) {
  return Am(t, e || {}, 0, 0);
}

var Pm = function Pm(t, e, n, i) {
  for (var r in t) {
    var s = t[r],
        a = e + r;
    s instanceof Yp ? n[a] = [s, i] : Array.isArray(s) ? n[a] = [s[0], Rm(i, s[1])] : Pm(s, a + "/", n, i);
  }
},
    Dm = "undefined" != typeof TextEncoder && new TextEncoder(),
    Im = "undefined" != typeof TextDecoder && new TextDecoder();

try {
  Im.decode(Sm, {
    stream: !0
  }), 1;
} catch (t) {}

function Om(t, e) {
  if (e) {
    for (var n = new Yp(t.length), i = 0; i < t.length; ++i) {
      n[i] = t.charCodeAt(i);
    }

    return n;
  }

  if (Dm) return Dm.encode(t);

  var r = t.length,
      s = new Yp(t.length + (t.length >> 1)),
      a = 0,
      o = function o(t) {
    s[a++] = t;
  };

  for (i = 0; i < r; ++i) {
    if (a + 5 > s.length) {
      var l = new Yp(a + 8 + (r - i << 1));
      l.set(s), s = l;
    }

    var h = t.charCodeAt(i);
    h < 128 || e ? o(h) : h < 2048 ? (o(192 | h >> 6), o(128 | 63 & h)) : h > 55295 && h < 57344 ? (o(240 | (h = 65536 + (1047552 & h) | 1023 & t.charCodeAt(++i)) >> 18), o(128 | h >> 12 & 63), o(128 | h >> 6 & 63), o(128 | 63 & h)) : (o(224 | h >> 12), o(128 | h >> 6 & 63), o(128 | 63 & h));
  }

  return mm(s, 0, a);
}

var Nm = function Nm(t) {
  var e = 0;
  if (t) for (var n in t) {
    var i = t[n].length;
    if (i > 65535) throw "extra field too long";
    e += i + 4;
  }
  return e;
},
    Fm = function Fm(t, e, n, i, r, s, a, o) {
  var l = i.length,
      h = n.extra,
      c = o && o.length,
      u = Nm(h);
  Cm(t, e, null != a ? 33639248 : 67324752), e += 4, null != a && (t[e++] = 20, t[e++] = n.os), t[e] = 20, e += 2, t[e++] = n.flag << 1 | (null == s && 8), t[e++] = r && 8, t[e++] = 255 & n.compression, t[e++] = n.compression >> 8;
  var d = new Date(null == n.mtime ? Date.now() : n.mtime),
      p = d.getFullYear() - 1980;
  if (p < 0 || p > 119) throw "date not in range 1980-2099";
  if (Cm(t, e, p << 25 | d.getMonth() + 1 << 21 | d.getDate() << 16 | d.getHours() << 11 | d.getMinutes() << 5 | d.getSeconds() >>> 1), e += 4, null != s && (Cm(t, e, n.crc), Cm(t, e + 4, s), Cm(t, e + 8, n.size)), Cm(t, e + 12, l), Cm(t, e + 14, u), e += 16, null != a && (Cm(t, e, c), Cm(t, e + 6, n.attrs), Cm(t, e + 10, a), e += 14), t.set(i, e), e += l, u) for (var m in h) {
    var f = h[m],
        g = f.length;
    Cm(t, e, +m), Cm(t, e + 2, g), t.set(f, e + 4), e += 4 + g;
  }
  return c && (t.set(o, e), e += c), e;
};

function Um(t, e) {
  e || (e = {});
  var n = {},
      i = [];
  Pm(t, "", n, e);
  var r = 0,
      s = 0;

  for (var a in n) {
    var o = n[a],
        l = o[0],
        h = o[1],
        c = 0 == h.level ? 0 : 8,
        u = (M = Om(a)).length,
        d = h.comment,
        p = d && Om(d),
        m = p && p.length,
        f = Nm(h.extra);
    if (u > 65535) throw "filename too long";
    var g = c ? Lm(l, h) : l,
        v = g.length,
        y = Em();
    y.p(l), i.push(Rm(h, {
      size: l.length,
      crc: y.d(),
      c: g,
      f: M,
      m: p,
      u: u != a.length || p && d.length != m,
      o: r,
      compression: c
    })), r += 30 + u + f + v, s += 76 + 2 * (u + f) + (m || 0) + v;
  }

  for (var x = new Yp(s + 22), _ = r, b = s - r, w = 0; w < i.length; ++w) {
    var M = i[w];
    Fm(x, M.o, M, M.f, M.u, M.c.length);
    var S = 30 + M.f.length + Nm(M.extra);
    x.set(M.c, M.o + S), Fm(x, r, M, M.f, M.u, M.c.length, M.o, M.m), r += 16 + S + (M.m ? M.m.length : 0);
  }

  return function (t, e, n, i, r) {
    Cm(t, e, 101010256), Cm(t, e + 8, n), Cm(t, e + 10, n), Cm(t, e + 12, i), Cm(t, e + 16, r);
  }(x, r, i.length, b, _), x;
}

var km = /*#__PURE__*/function () {
  function km() {
    _classCallCheck(this, km);
  }

  _createClass(km, [{
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(t) {
        var e, n, i, r, _loop3, _t409, s, _t410, _n298, _i248, _r161;

        return _regeneratorRuntime.wrap(function _callee27$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                e = {};
                e["model.usda"] = null;
                n = zm();
                i = {}, r = {};
                t.traverseVisible(function (t) {
                  if (t.isMesh) if (t.material.isMeshStandardMaterial) {
                    var _r158 = t.geometry,
                        _s92 = t.material,
                        _a72 = "geometries/Geometry_" + _r158.id + ".usd";

                    if (!(_a72 in e)) {
                      var _t406 = function (t) {
                        return "\ndef \"Geometry\"\n{\n  ".concat(function (t) {
                          var e = "Geometry",
                              n = t.attributes,
                              i = n.position.count;
                          return "\n    def Mesh \"".concat(e, "\"\n    {\n        int[] faceVertexCounts = [").concat(function (t) {
                            var e = null !== t.index ? t.index.count : t.attributes.position.count;
                            return Array(e / 3).fill(3).join(", ");
                          }(t), "]\n        int[] faceVertexIndices = [").concat(function (t) {
                            var e = t.index,
                                n = [];
                            if (null !== e) for (var _t407 = 0; _t407 < e.count; _t407++) {
                              n.push(e.getX(_t407));
                            } else {
                              var _e339 = t.attributes.position.count;

                              for (var _t408 = 0; _t408 < _e339; _t408++) {
                                n.push(_t408);
                              }
                            }
                            return n.join(", ");
                          }(t), "]\n        normal3f[] normals = [").concat(Vm(n.normal, i), "] (\n            interpolation = \"vertex\"\n        )\n        point3f[] points = [").concat(Vm(n.position, i), "]\n        float2[] primvars:st = [").concat(function (t, e) {
                            if (void 0 === t) return console.warn("USDZExporter: UVs missing."), Array(e).fill("(0, 0)").join(", ");
                            var n = [];

                            for (var _e340 = 0; _e340 < t.count; _e340++) {
                              var _i246 = t.getX(_e340),
                                  _r159 = t.getY(_e340);

                              n.push("(".concat(_i246.toPrecision(7), ", ").concat(1 - _r159.toPrecision(7), ")"));
                            }

                            return n.join(", ");
                          }(n.uv, i), "] (\n            interpolation = \"vertex\"\n        )\n        uniform token subdivisionScheme = \"none\"\n    }\n");
                        }(t), "\n}\n");
                      }(_r158);

                      e[_a72] = function (t) {
                        var e = zm();
                        return e += t, Om(e);
                      }(_t406);
                    }

                    _s92.uuid in i || (i[_s92.uuid] = _s92), n += function (t, e, n) {
                      var i = "Object_" + t.id,
                          r = function (t) {
                        var e = t.elements;
                        return "( ".concat(Hm(e, 0), ", ").concat(Hm(e, 4), ", ").concat(Hm(e, 8), ", ").concat(Hm(e, 12), " )");
                      }(t.matrixWorld);

                      t.matrixWorld.determinant() < 0 && console.warn("THREE.USDZExporter: USDZ does not support negative scales", t);
                      return "def Xform \"".concat(i, "\" (\n    prepend references = @./geometries/Geometry_").concat(e.id, ".usd@</Geometry>\n)\n{\n    matrix4d xformOp:transform = ").concat(r, "\n    uniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n    rel material:binding = </Materials/Material_").concat(n.id, ">\n}\n\n");
                    }(t, _r158, _s92);
                  } else console.warn("THREE.USDZExporter: Unsupported material type (USDZ only supports MeshStandardMaterial)", t);
                }), n += function (t, e) {
                  var n = [];

                  for (var _i247 in t) {
                    var _r160 = t[_i247];
                    n.push(Gm(_r160, e));
                  }

                  return "def \"Materials\"\n{\n".concat(n.join(""), "\n}\n\n");
                }(i, r), e["model.usda"] = Om(n), n = null;
                _loop3 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop3(_t409) {
                  var n, i, s, a, o;
                  return _regeneratorRuntime.wrap(function _loop3$(_context30) {
                    while (1) {
                      switch (_context30.prev = _context30.next) {
                        case 0:
                          n = r[_t409];
                          i = _t409.split("_")[1];
                          s = 1023 === n.format;
                          a = Bm(n.image, i);
                          _context30.next = 6;
                          return new Promise(function (t) {
                            return a.toBlob(t, s ? "image/png" : "image/jpeg", 1);
                          });

                        case 6:
                          o = _context30.sent;
                          _context30.t0 = Uint8Array;
                          _context30.next = 10;
                          return o.arrayBuffer();

                        case 10:
                          _context30.t1 = _context30.sent;
                          e["textures/Texture_".concat(_t409, ".").concat(s ? "png" : "jpg")] = new _context30.t0(_context30.t1);

                        case 12:
                        case "end":
                          return _context30.stop();
                      }
                    }
                  }, _loop3);
                });
                _context31.t0 = _regeneratorRuntime.keys(r);

              case 7:
                if ((_context31.t1 = _context31.t0()).done) {
                  _context31.next = 12;
                  break;
                }

                _t409 = _context31.t1.value;
                return _context31.delegateYield(_loop3(_t409), "t2", 10);

              case 10:
                _context31.next = 7;
                break;

              case 12:
                s = 0;

                for (_t410 in e) {
                  _n298 = e[_t410];
                  s += 34 + _t410.length;
                  _i248 = 63 & s;

                  if (4 !== _i248) {
                    _r161 = new Uint8Array(64 - _i248);
                    e[_t410] = [_n298, {
                      extra: {
                        12345: _r161
                      }
                    }];
                  }

                  s = _n298.length;
                }

                return _context31.abrupt("return", Um(e, {
                  level: 0
                }));

              case 15:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee27);
      }));

      function parse(_x26) {
        return _parse.apply(this, arguments);
      }

      return parse;
    }()
  }]);

  return km;
}();

function Bm(t, e) {
  if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t instanceof OffscreenCanvas || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
    var n = 1024 / Math.max(t.width, t.height),
        _i249 = document.createElement("canvas");

    _i249.width = t.width * Math.min(1, n), _i249.height = t.height * Math.min(1, n);

    var _r162 = _i249.getContext("2d");

    if (_r162.drawImage(t, 0, 0, _i249.width, _i249.height), void 0 !== e) {
      var _t411 = parseInt(e, 16),
          _n299 = (_t411 >> 16 & 255) / 255,
          _s93 = (_t411 >> 8 & 255) / 255,
          _a73 = (255 & _t411) / 255,
          _o45 = _r162.getImageData(0, 0, _i249.width, _i249.height),
          _l44 = _o45.data;

      for (var _t412 = 0; _t412 < _l44.length; _t412 += 4) {
        _l44[_t412 + 0] = _l44[_t412 + 0] * _n299, _l44[_t412 + 1] = _l44[_t412 + 1] * _s93, _l44[_t412 + 2] = _l44[_t412 + 2] * _a73;
      }

      _r162.putImageData(_o45, 0, 0);
    }

    return _i249;
  }
}

function zm() {
  return '#usda 1.0\n(\n    customLayerData = {\n        string creator = "Three.js USDZExporter"\n    }\n    metersPerUnit = 1\n    upAxis = "Y"\n)\n\n';
}

function Hm(t, e) {
  return "(".concat(t[e + 0], ", ").concat(t[e + 1], ", ").concat(t[e + 2], ", ").concat(t[e + 3], ")");
}

function Vm(t, e) {
  if (void 0 === t) return console.warn("USDZExporter: Normals missing."), Array(e).fill("(0, 0, 0)").join(", ");
  var n = [];

  for (var _e341 = 0; _e341 < t.count; _e341++) {
    var _i250 = t.getX(_e341),
        _r163 = t.getY(_e341),
        _s94 = t.getZ(_e341);

    n.push("(".concat(_i250.toPrecision(7), ", ").concat(_r163.toPrecision(7), ", ").concat(_s94.toPrecision(7), ")"));
  }

  return n.join(", ");
}

function Gm(t, e) {
  var n = "            ",
      i = [],
      r = [];

  function s(n, i, r) {
    var s = n.id + (r ? "_" + r.getHexString() : ""),
        a = 1023 === n.format;
    return e[s] = n, "\n        def Shader \"Transform2d_".concat(i, "\" (\n            sdrMetadata = {\n                string role = \"math\"\n            }\n        )\n        {\n            uniform token info:id = \"UsdTransform2d\"\n            float2 inputs:in.connect = </Materials/Material_").concat(t.id, "/uvReader_st.outputs:result>\n            float2 inputs:scale = ").concat(jm(n.repeat), "\n            float2 inputs:translation = ").concat(jm(n.offset), "\n            float2 outputs:result\n        }\n\n        def Shader \"Texture_").concat(n.id, "_").concat(i, "\"\n        {\n            uniform token info:id = \"UsdUVTexture\"\n            asset inputs:file = @textures/Texture_").concat(s, ".").concat(a ? "png" : "jpg", "@\n            float2 inputs:st.connect = </Materials/Material_").concat(t.id, "/Transform2d_").concat(i, ".outputs:result>\n            token inputs:wrapS = \"repeat\"\n            token inputs:wrapT = \"repeat\"\n            float outputs:r\n            float outputs:g\n            float outputs:b\n            float3 outputs:rgb\n            ").concat(t.transparent || t.alphaTest > 0 ? "float outputs:a" : "", "\n        }");
  }

  return null !== t.map ? (i.push("".concat(n, "color3f inputs:diffuseColor.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.map.id, "_diffuse.outputs:rgb>")), t.transparent ? i.push("".concat(n, "float inputs:opacity.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.map.id, "_diffuse.outputs:a>")) : t.alphaTest > 0 && (i.push("".concat(n, "float inputs:opacity.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.map.id, "_diffuse.outputs:a>")), i.push("".concat(n, "float inputs:opacityThreshold = ").concat(t.alphaTest))), r.push(s(t.map, "diffuse", t.color))) : i.push("".concat(n, "color3f inputs:diffuseColor = ").concat(Wm(t.color))), null !== t.emissiveMap ? (i.push("".concat(n, "color3f inputs:emissiveColor.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.emissiveMap.id, "_emissive.outputs:rgb>")), r.push(s(t.emissiveMap, "emissive"))) : t.emissive.getHex() > 0 && i.push("".concat(n, "color3f inputs:emissiveColor = ").concat(Wm(t.emissive))), null !== t.normalMap && (i.push("".concat(n, "normal3f inputs:normal.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.normalMap.id, "_normal.outputs:rgb>")), r.push(s(t.normalMap, "normal"))), null !== t.aoMap && (i.push("".concat(n, "float inputs:occlusion.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.aoMap.id, "_occlusion.outputs:r>")), r.push(s(t.aoMap, "occlusion"))), null !== t.roughnessMap && 1 === t.roughness ? (i.push("".concat(n, "float inputs:roughness.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.roughnessMap.id, "_roughness.outputs:g>")), r.push(s(t.roughnessMap, "roughness"))) : i.push("".concat(n, "float inputs:roughness = ").concat(t.roughness)), null !== t.metalnessMap && 1 === t.metalness ? (i.push("".concat(n, "float inputs:metallic.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.metalnessMap.id, "_metallic.outputs:b>")), r.push(s(t.metalnessMap, "metallic"))) : i.push("".concat(n, "float inputs:metallic = ").concat(t.metalness)), null !== t.alphaMap ? (i.push("".concat(n, "float inputs:opacity.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.alphaMap.id, "_opacity.outputs:r>")), i.push("".concat(n, "float inputs:opacityThreshold = 0.0001")), r.push(s(t.alphaMap, "opacity"))) : i.push("".concat(n, "float inputs:opacity = ").concat(t.opacity)), t.isMeshPhysicalMaterial && (i.push("".concat(n, "float inputs:clearcoat = ").concat(t.clearcoat)), i.push("".concat(n, "float inputs:clearcoatRoughness = ").concat(t.clearcoatRoughness)), i.push("".concat(n, "float inputs:ior = ").concat(t.ior))), "\n    def Material \"Material_".concat(t.id, "\"\n    {\n        def Shader \"PreviewSurface\"\n        {\n            uniform token info:id = \"UsdPreviewSurface\"\n").concat(i.join("\n"), "\n            int inputs:useSpecularWorkflow = 0\n            token outputs:surface\n        }\n\n        token outputs:surface.connect = </Materials/Material_").concat(t.id, "/PreviewSurface.outputs:surface>\n        token inputs:frame:stPrimvarName = \"st\"\n\n        def Shader \"uvReader_st\"\n        {\n            uniform token info:id = \"UsdPrimvarReader_float2\"\n            token inputs:varname.connect = </Materials/Material_").concat(t.id, ".inputs:frame:stPrimvarName>\n            float2 inputs:fallback = (0.0, 0.0)\n            float2 outputs:result\n        }\n\n").concat(r.join("\n"), "\n\n    }\n");
}

function Wm(t) {
  return "(".concat(t.r, ", ").concat(t.g, ", ").concat(t.b, ")");
}

function jm(t) {
  return "(".concat(t.x, ", ").concat(t.y, ")");
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var qm = function qm(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var Xm = !1,
    Ym = !1;
var Jm = (Zm = ["quick-look", "scene-viewer", "webxr", "none"], function (t) {
  try {
    var _e342 = mu(t),
        n = (_e342.length ? _e342[0].terms : []).filter(function (t) {
      return t && "ident" === t.type;
    }).map(function (t) {
      return t.value;
    }).filter(function (t) {
      return Zm.indexOf(t) > -1;
    }),
        _i251 = new Set();

    var _iterator38 = _createForOfIteratorHelper(n),
        _step38;

    try {
      for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
        var _t413 = _step38.value;

        _i251.add(_t413);
      }
    } catch (err) {
      _iterator38.e(err);
    } finally {
      _iterator38.f();
    }

    return _i251;
  } catch (t) {}

  return new Set();
});
var Zm;
var $m = "quick-look",
    Km = "scene-viewer",
    Qm = "webxr",
    tf = "none",
    ef = Symbol("arButtonContainer"),
    nf = Symbol("enterARWithWebXR"),
    rf = Symbol("openSceneViewer"),
    sf = Symbol("openIOSARQuickLook"),
    af = Symbol("canActivateAR"),
    of = Symbol("arMode"),
    lf = Symbol("arModes"),
    hf = Symbol("arAnchor"),
    cf = Symbol("preload"),
    uf = Symbol("onARButtonContainerClick"),
    df = Symbol("onARStatus"),
    pf = Symbol("onARTracking"),
    mf = Symbol("onARTap"),
    ff = Symbol("selectARMode"),
    gf = Symbol("triggerLoad");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var vf, yf, xf;

var _f = Symbol("evaluate"),
    bf = Symbol("lastValue");

var wf = /*#__PURE__*/function () {
  function wf() {
    _classCallCheck(this, wf);

    this[vf] = null;
  }

  _createClass(wf, [{
    key: "isConstant",
    get: function get() {
      return !1;
    }
  }, {
    key: "evaluate",
    value: function evaluate() {
      return this.isConstant && null != this[bf] || (this[bf] = this[_f]()), this[bf];
    }
  }], [{
    key: "evaluatableFor",
    value: function evaluatableFor(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : wu;
      if (t instanceof wf) return t;
      if ("number" === t.type) return "%" === t.unit ? new Tf(t, e) : t;

      switch (t.name.value) {
        case "calc":
          return new Lf(t, e);

        case "env":
          return new Af(t);
      }

      return wu;
    }
  }, {
    key: "evaluate",
    value: function evaluate(t) {
      return t instanceof wf ? t.evaluate() : t;
    }
  }, {
    key: "isConstant",
    value: function isConstant(t) {
      return !(t instanceof wf) || t.isConstant;
    }
  }, {
    key: "applyIntrinsics",
    value: function applyIntrinsics(t, e) {
      var n = e.basis,
          i = e.keywords,
          r = i.auto;
      return n.map(function (e, n) {
        var s = null == r[n] ? e : r[n];
        var a = t[n] ? t[n] : s;

        if ("ident" === a.type) {
          var _t414 = a.value;
          _t414 in i && (a = i[_t414][n]);
        }

        return null != a && "ident" !== a.type || (a = s), "%" === a.unit ? pu(a.number / 100 * e.number, e.unit) : (a = Tu(a, e), a.unit !== e.unit ? e : a);
      });
    }
  }]);

  return wf;
}();

vf = bf;
var Mf = Symbol("percentage"),
    Sf = Symbol("basis");

var Tf = /*#__PURE__*/function (_wf) {
  _inherits(Tf, _wf);

  var _super138 = _createSuper(Tf);

  function Tf(t, e) {
    var _this146;

    _classCallCheck(this, Tf);

    _this146 = _super138.call(this), _this146[Mf] = t, _this146[Sf] = e;
    return _this146;
  }

  _createClass(Tf, [{
    key: "isConstant",
    get: function get() {
      return !0;
    }
  }, {
    key: _f,
    value: function value() {
      return pu(this[Mf].number / 100 * this[Sf].number, this[Sf].unit);
    }
  }]);

  return Tf;
}(wf);

var Ef = Symbol("identNode");

var Af = /*#__PURE__*/function (_wf2, _ref23) {
  _inherits(Af, _wf2);

  var _super139 = _createSuper(Af);

  function Af(t) {
    var _this147;

    _classCallCheck(this, Af);

    _this147 = _super139.call(this), _this147[yf] = null;
    var e = t.arguments.length ? t.arguments[0].terms[0] : null;
    null != e && "ident" === e.type && (_this147[Ef] = e);
    return _this147;
  }

  _createClass(Af, [{
    key: "isConstant",
    get: function get() {
      return !1;
    }
  }, {
    key: _ref23,
    value: function value() {
      if (null != this[Ef] && "window-scroll-y" === this[Ef].value) {
        return {
          type: "number",
          number: window.pageYOffset / (Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight) || 0,
          unit: null
        };
      }

      return wu;
    }
  }]);

  return Af;
}(wf, (yf = Ef, _f));

var Rf = /[\*\/]/,
    Cf = Symbol("evalutor");

var Lf = /*#__PURE__*/function (_wf3, _ref24) {
  _inherits(Lf, _wf3);

  var _super140 = _createSuper(Lf);

  function Lf(t) {
    var _this148;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : wu;

    _classCallCheck(this, Lf);

    if (_this148 = _super140.call(this), _this148[xf] = null, 1 !== t.arguments.length) return _possibleConstructorReturn(_this148);
    var n = t.arguments[0].terms.slice(),
        i = [];

    for (; n.length;) {
      var _t415 = n.shift();

      if (i.length > 0) {
        var _n300 = i[i.length - 1];

        if ("operator" === _n300.type && Rf.test(_n300.value)) {
          var _n301 = i.pop(),
              _r164 = i.pop();

          if (null == _r164) return _possibleConstructorReturn(_this148);
          i.push(new Of(_n301, wf.evaluatableFor(_r164, e), wf.evaluatableFor(_t415, e)));
          continue;
        }
      }

      i.push("operator" === _t415.type ? _t415 : wf.evaluatableFor(_t415, e));
    }

    for (; i.length > 2;) {
      var _i$splice = i.splice(0, 3),
          _i$splice2 = _slicedToArray(_i$splice, 3),
          _t416 = _i$splice2[0],
          _n302 = _i$splice2[1],
          _r165 = _i$splice2[2];

      if ("operator" !== _n302.type) return _possibleConstructorReturn(_this148);
      i.unshift(new Of(_n302, wf.evaluatableFor(_t416, e), wf.evaluatableFor(_r165, e)));
    }

    1 === i.length && (_this148[Cf] = i[0]);
    return _possibleConstructorReturn(_this148);
  }

  _createClass(Lf, [{
    key: "isConstant",
    get: function get() {
      return null == this[Cf] || wf.isConstant(this[Cf]);
    }
  }, {
    key: _ref24,
    value: function value() {
      return null != this[Cf] ? wf.evaluate(this[Cf]) : wu;
    }
  }]);

  return Lf;
}(wf, (xf = Cf, _f));

var Pf = Symbol("operator"),
    Df = Symbol("left"),
    If = Symbol("right");

var Of = /*#__PURE__*/function (_wf4) {
  _inherits(Of, _wf4);

  var _super141 = _createSuper(Of);

  function Of(t, e, n) {
    var _this149;

    _classCallCheck(this, Of);

    _this149 = _super141.call(this), _this149[Pf] = t, _this149[Df] = e, _this149[If] = n;
    return _this149;
  }

  _createClass(Of, [{
    key: "isConstant",
    get: function get() {
      return wf.isConstant(this[Df]) && wf.isConstant(this[If]);
    }
  }, {
    key: _f,
    value: function value() {
      var t = Tu(wf.evaluate(this[Df])),
          e = Tu(wf.evaluate(this[If])),
          n = t.number,
          i = t.unit,
          r = e.number,
          s = e.unit;
      if (null != s && null != i && s != i) return wu;
      var a = i || s;
      var o;

      switch (this[Pf].value) {
        case "+":
          o = n + r;
          break;

        case "-":
          o = n - r;
          break;

        case "/":
          o = n / r;
          break;

        case "*":
          o = n * r;
          break;

        default:
          return wu;
      }

      return {
        type: "number",
        number: o,
        unit: a
      };
    }
  }]);

  return Of;
}(wf);

var Nf = Symbol("evaluatables"),
    Ff = Symbol("intrinsics");

var Uf = /*#__PURE__*/function (_wf5) {
  _inherits(Uf, _wf5);

  var _super142 = _createSuper(Uf);

  function Uf(t, e) {
    var _this150;

    _classCallCheck(this, Uf);

    _this150 = _super142.call(this), _this150[Ff] = e;
    var n = t[0],
        i = null != n ? n.terms : [];
    _this150[Nf] = e.basis.map(function (t, e) {
      var n = i[e];
      return null == n ? {
        type: "ident",
        value: "auto"
      } : "ident" === n.type ? n : wf.evaluatableFor(n, t);
    });
    return _this150;
  }

  _createClass(Uf, [{
    key: "isConstant",
    get: function get() {
      var _iterator39 = _createForOfIteratorHelper(this[Nf]),
          _step39;

      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var _t417 = _step39.value;
          if (!wf.isConstant(_t417)) return !1;
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }

      return !0;
    }
  }, {
    key: _f,
    value: function value() {
      var t = this[Nf].map(function (t) {
        return wf.evaluate(t);
      });
      return wf.applyIntrinsics(t, this[Ff]).map(function (t) {
        return t.number;
      });
    }
  }]);

  return Uf;
}(wf);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var kf, Bf, zf, Hf;
var Vf = Symbol("instances"),
    Gf = Symbol("activateListener"),
    Wf = Symbol("deactivateListener"),
    jf = Symbol("notifyInstances"),
    qf = Symbol("notify"),
    Xf = Symbol("callback");

var Yf = /*#__PURE__*/function (_ref25) {
  function Yf(t) {
    _classCallCheck(this, Yf);

    this[Xf] = t;
  }

  _createClass(Yf, [{
    key: "observe",
    value: function observe() {
      0 === Yf[Vf].size && Yf[Gf](), Yf[Vf].add(this);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      Yf[Vf].delete(this), 0 === Yf[Vf].size && Yf[Wf]();
    }
  }, {
    key: qf,
    value: function value() {
      this[Xf]();
    }
  }], [{
    key: jf,
    value: function value() {
      var _iterator40 = _createForOfIteratorHelper(Yf[Vf]),
          _step40;

      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var _t418 = _step40.value;

          _t418[qf]();
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
    }
  }, {
    key: _ref25,
    value: function value() {
      window.addEventListener("scroll", this[jf], {
        passive: !0
      });
    }
  }, {
    key: Wf,
    value: function value() {
      window.removeEventListener("scroll", this[jf]);
    }
  }]);

  return Yf;
}((kf = Vf, Gf));

Yf[kf] = new Set();
var Jf = Symbol("computeStyleCallback"),
    Zf = Symbol("astWalker"),
    $f = Symbol("dependencies"),
    Kf = Symbol("onScroll");

var Qf = /*#__PURE__*/function () {
  function Qf(t) {
    var _this151 = this;

    _classCallCheck(this, Qf);

    this[Bf] = {}, this[zf] = new bu(["function"]), this[Hf] = function () {
      _this151[Jf]({
        relatedState: "window-scroll"
      });
    }, this[Jf] = t;
  }

  _createClass(Qf, [{
    key: "observeEffectsFor",
    value: function observeEffectsFor(t) {
      var _this152 = this;

      var e = {},
          n = this[$f];
      this[Zf].walk(t, function (t) {
        var i = t.name,
            r = t.arguments[0].terms[0];
        if ("env" === i.value && null != r && "ident" === r.type && "window-scroll-y" === r.value) if (null == e["window-scroll"]) {
          var _t419 = "window-scroll" in n ? n["window-scroll"] : new Yf(_this152[Kf]);

          _t419.observe(), delete n["window-scroll"], e["window-scroll"] = _t419;
        }
      });

      for (var _t420 in n) {
        n[_t420].disconnect();
      }

      this[$f] = e;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      for (var _t421 in this[$f]) {
        this[$f][_t421].disconnect();
      }
    }
  }]);

  return Qf;
}();

Bf = $f, zf = Zf, Hf = Kf;
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var tg = function tg(t) {
  var e = t.observeEffects || !1,
      n = t.intrinsics instanceof Function ? t.intrinsics : function () {
    return t.intrinsics;
  };
  return function (i, r) {
    var _Object$definePropert;

    var s = i.updated,
        a = i.connectedCallback,
        o = i.disconnectedCallback,
        l = Symbol("".concat(r, "StyleEffector")),
        h = Symbol("".concat(r, "StyleEvaluator")),
        c = Symbol("".concat(r, "UpdateEvaluator")),
        u = Symbol("".concat(r, "EvaluateAndSync"));
    Object.defineProperties(i, (_Object$definePropert = {}, _defineProperty(_Object$definePropert, l, {
      value: null,
      writable: !0
    }), _defineProperty(_Object$definePropert, h, {
      value: null,
      writable: !0
    }), _defineProperty(_Object$definePropert, c, {
      value: function value() {
        var _this153 = this;

        var t = mu(this[r]);
        this[h] = new Uf(t, n(this)), null == this[l] && e && (this[l] = new Qf(function () {
          return _this153[u]();
        })), null != this[l] && this[l].observeEffectsFor(t);
      }
    }), _defineProperty(_Object$definePropert, u, {
      value: function value() {
        if (null == this[h]) return;
        var e = this[h].evaluate();
        this[t.updateHandler](e);
      }
    }), _defineProperty(_Object$definePropert, "updated", {
      value: function value(t) {
        t.has(r) && (this[c](), this[u]()), s.call(this, t);
      }
    }), _defineProperty(_Object$definePropert, "connectedCallback", {
      value: function value() {
        a.call(this), this.requestUpdate(r, this[r]);
      }
    }), _defineProperty(_Object$definePropert, "disconnectedCallback", {
      value: function value() {
        o.call(this), null != this[l] && (this[l].dispose(), this[l] = null);
      }
    }), _Object$definePropert));
  };
},
    eg = new mt(),
    ng = new zt(),
    ig = Object.freeze({
  minimumRadius: 0,
  maximumRadius: 1 / 0,
  minimumPolarAngle: Math.PI / 8,
  maximumPolarAngle: Math.PI - Math.PI / 8,
  minimumAzimuthalAngle: -1 / 0,
  maximumAzimuthalAngle: 1 / 0,
  minimumFieldOfView: 10,
  maximumFieldOfView: 45,
  interactionPolicy: "always-allow",
  touchAction: "pan-y"
}),
    rg = Math.PI / 8,
    sg = 33,
    ag = 34,
    og = 37,
    lg = 38,
    hg = 39,
    cg = 40,
    ug = "user-interaction",
    dg = "none";
/* @license
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var pg = /*#__PURE__*/function (_et12) {
  _inherits(pg, _et12);

  var _super143 = _createSuper(pg);

  function pg(t, e, n) {
    var _this154;

    _classCallCheck(this, pg);

    _this154 = _super143.call(this), _this154.camera = t, _this154.element = e, _this154.scene = n, _this154.sensitivity = 1, _this154._interactionEnabled = !1, _this154._disableZoom = !1, _this154.isUserChange = !1, _this154.isUserPointing = !1, _this154.enablePan = !0, _this154.panProjection = new ft(), _this154.panPerPixel = 0, _this154.spherical = new Jl(), _this154.goalSpherical = new Jl(), _this154.thetaDamper = new du(), _this154.phiDamper = new du(), _this154.radiusDamper = new du(), _this154.logFov = Math.log(ig.maximumFieldOfView), _this154.goalLogFov = _this154.logFov, _this154.fovDamper = new du(), _this154.touchMode = null, _this154.lastPointerPosition = {
      clientX: 0,
      clientY: 0
    }, _this154.startPointerPosition = {
      clientX: 0,
      clientY: 0
    }, _this154.touchDecided = !1, _this154.onMouseMove = function (t) {
      _this154.panPerPixel > 0 ? _this154.movePan(t.clientX, t.clientY) : _this154.handleSinglePointerMove(t), t.cancelable && t.preventDefault();
    }, _this154.onTouchMove = function (t) {
      null !== _this154.touchMode && (_this154.touchMode(t), null !== _this154.touchMode && t.cancelable && t.preventDefault());
    }, _this154.touchModeZoom = function (t) {
      var e = t.targetTouches;

      if (_this154.lastTouches.length > 1 && e.length > 1) {
        if (!_this154._disableZoom) {
          var _t422 = .04 * (_this154.twoTouchDistance(_this154.lastTouches[0], _this154.lastTouches[1]) - _this154.twoTouchDistance(e[0], e[1])) / 10;

          _this154.userAdjustOrbit(0, 0, _t422);
        }

        if (_this154.panPerPixel > 0) {
          var _t423 = .5 * (e[0].clientX + e[1].clientX),
              _n303 = .5 * (e[0].clientY + e[1].clientY);

          _this154.movePan(_t423, _n303);
        }

        _this154.lastTouches = e;
      }
    }, _this154.touchModeRotate = function (t) {
      var e = t.targetTouches,
          n = _this154._options.touchAction;

      if (!_this154.touchDecided && "none" !== n) {
        _this154.touchDecided = !0;

        var _e$ = e[0],
            _t424 = _e$.clientX,
            _i252 = _e$.clientY,
            _r166 = Math.abs(_t424 - _this154.lastPointerPosition.clientX),
            _s95 = Math.abs(_i252 - _this154.lastPointerPosition.clientY);

        if ("pan-y" === n && _s95 > _r166 || "pan-x" === n && _r166 > _s95) return void (_this154.touchMode = null);
      }

      _this154.handleSinglePointerMove(e[0]), _this154.lastTouches = e;
    }, _this154.onMouseDown = function (t) {
      _this154.onPointerDown(function () {
        self.addEventListener("mousemove", _this154.onMouseMove), self.addEventListener("mouseup", _this154.onMouseUp, {
          once: !0
        }), _this154.enablePan && (2 === t.button || t.ctrlKey || t.metaKey || t.shiftKey) && _this154.initializePan(), _this154.lastPointerPosition.clientX = t.clientX, _this154.lastPointerPosition.clientY = t.clientY, _this154.startPointerPosition.clientX = t.clientX, _this154.startPointerPosition.clientY = t.clientY, _this154.element.style.cursor = "grabbing";
      });
    }, _this154.onTouchStart = function (t) {
      _this154.onPointerDown(function () {
        var e = t.targetTouches,
            n = t.changedTouches,
            i = t.touches;
        e.length === n.length && (_this154.touchMode = null, _this154.touchDecided = !1), e.length === i.length && _this154.onTouchChange(t);
      });
    }, _this154.onMouseUp = function (t) {
      self.removeEventListener("mousemove", _this154.onMouseMove), _this154.panPerPixel > 0 ? _this154.resetRadius() : _this154.recenter(t), _this154.onPointerUp();
    }, _this154.onTouchEnd = function (t) {
      t.targetTouches.length > 0 && null !== _this154.touchMode && _this154.onTouchChange(t), 0 === t.targetTouches.length && (_this154.panPerPixel > 0 ? _this154.resetRadius() : _this154.recenter(t.changedTouches[0])), _this154.onPointerUp();
    }, _this154.onWheel = function (t) {
      if (!_this154.canInteract) return;
      var e = t.deltaY * (1 == t.deltaMode ? 18 : 1) * .04 / 30;
      _this154.userAdjustOrbit(0, 0, e), t.cancelable && t.preventDefault();
    }, _this154.onKeyDown = function (t) {
      var e = !1;

      switch (t.keyCode) {
        case sg:
          e = !0, _this154.userAdjustOrbit(0, 0, .04);
          break;

        case ag:
          e = !0, _this154.userAdjustOrbit(0, 0, -.04);
          break;

        case lg:
          e = !0, _this154.userAdjustOrbit(0, -rg, 0);
          break;

        case cg:
          e = !0, _this154.userAdjustOrbit(0, rg, 0);
          break;

        case og:
          e = !0, _this154.userAdjustOrbit(-rg, 0, 0);
          break;

        case hg:
          e = !0, _this154.userAdjustOrbit(rg, 0, 0);
      }

      e && t.cancelable && t.preventDefault();
    }, _this154._options = Object.assign({}, ig), _this154.setOrbit(0, Math.PI / 2, 1), _this154.setFieldOfView(100), _this154.jumpToGoal();
    return _this154;
  }

  _createClass(pg, [{
    key: "interactionEnabled",
    get: function get() {
      return this._interactionEnabled;
    }
  }, {
    key: "enableInteraction",
    value: function enableInteraction() {
      if (!1 === this._interactionEnabled) {
        var _t425 = this.element;
        _t425.addEventListener("mousedown", this.onMouseDown), this._disableZoom || _t425.addEventListener("wheel", this.onWheel), _t425.addEventListener("keydown", this.onKeyDown), _t425.addEventListener("touchstart", this.onTouchStart, {
          passive: !0
        }), _t425.addEventListener("touchmove", this.onTouchMove, {
          passive: !1
        }), _t425.addEventListener("touchend", this.onTouchEnd), this.element.style.cursor = "grab", this._interactionEnabled = !0, this.updateTouchActionStyle();
      }
    }
  }, {
    key: "disableInteraction",
    value: function disableInteraction() {
      if (!0 === this._interactionEnabled) {
        var _t426 = this.element;
        self.removeEventListener("mousemove", this.onMouseMove), _t426.removeEventListener("mousedown", this.onMouseDown), this._disableZoom || _t426.removeEventListener("wheel", this.onWheel), _t426.removeEventListener("keydown", this.onKeyDown), _t426.removeEventListener("touchstart", this.onTouchStart), _t426.removeEventListener("touchmove", this.onTouchMove), self.removeEventListener("mouseup", this.onMouseUp), _t426.removeEventListener("touchend", this.onTouchEnd), _t426.style.cursor = "", this.touchMode = null, this._interactionEnabled = !1, this.updateTouchActionStyle();
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "disableZoom",
    set: function set(t) {
      this._disableZoom != t && (this._disableZoom = t, !0 === t ? this.element.removeEventListener("wheel", this.onWheel) : this.element.addEventListener("wheel", this.onWheel), this.updateTouchActionStyle());
    }
  }, {
    key: "getCameraSpherical",
    value: function getCameraSpherical() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Jl();
      return t.copy(this.spherical);
    }
  }, {
    key: "getFieldOfView",
    value: function getFieldOfView() {
      return this.camera.fov;
    }
  }, {
    key: "applyOptions",
    value: function applyOptions(t) {
      Object.assign(this._options, t), this.setOrbit(), this.setFieldOfView(Math.exp(this.goalLogFov));
    }
  }, {
    key: "updateNearFar",
    value: function updateNearFar(t, e) {
      this.camera.near = Math.max(t, e / 1e3), this.camera.far = e, this.camera.updateProjectionMatrix();
    }
  }, {
    key: "updateAspect",
    value: function updateAspect(t) {
      this.camera.aspect = t, this.camera.updateProjectionMatrix();
    }
  }, {
    key: "setOrbit",
    value: function setOrbit() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.goalSpherical.theta;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.goalSpherical.phi;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.goalSpherical.radius;
      var _this$_options = this._options,
          i = _this$_options.minimumAzimuthalAngle,
          r = _this$_options.maximumAzimuthalAngle,
          s = _this$_options.minimumPolarAngle,
          a = _this$_options.maximumPolarAngle,
          o = _this$_options.minimumRadius,
          l = _this$_options.maximumRadius,
          _this$goalSpherical = this.goalSpherical,
          h = _this$goalSpherical.theta,
          c = _this$goalSpherical.phi,
          u = _this$goalSpherical.radius,
          d = lu(t, i, r);
      isFinite(i) || isFinite(r) || (this.spherical.theta = this.wrapAngle(this.spherical.theta - d) + d);
      var p = lu(e, s, a),
          m = lu(n, o, l);
      return (d !== h || p !== c || m !== u) && (this.goalSpherical.theta = d, this.goalSpherical.phi = p, this.goalSpherical.radius = m, this.goalSpherical.makeSafe(), this.isUserChange = !1, !0);
    }
  }, {
    key: "setRadius",
    value: function setRadius(t) {
      this.goalSpherical.radius = t, this.setOrbit();
    }
  }, {
    key: "setFieldOfView",
    value: function setFieldOfView(t) {
      var _this$_options2 = this._options,
          e = _this$_options2.minimumFieldOfView,
          n = _this$_options2.maximumFieldOfView;
      t = lu(t, e, n), this.goalLogFov = Math.log(t);
    }
  }, {
    key: "setDamperDecayTime",
    value: function setDamperDecayTime(t) {
      this.thetaDamper.setDecayTime(t), this.phiDamper.setDecayTime(t), this.radiusDamper.setDecayTime(t), this.fovDamper.setDecayTime(t);
    }
  }, {
    key: "adjustOrbit",
    value: function adjustOrbit(t, e, n) {
      var _this$goalSpherical2 = this.goalSpherical,
          i = _this$goalSpherical2.theta,
          r = _this$goalSpherical2.phi,
          s = _this$goalSpherical2.radius,
          _this$_options3 = this._options,
          a = _this$_options3.minimumRadius,
          o = _this$_options3.maximumRadius,
          l = _this$_options3.minimumFieldOfView,
          h = _this$_options3.maximumFieldOfView,
          c = this.spherical.theta - i,
          u = Math.PI - .001,
          d = i - lu(t, -u - c, u - c),
          p = r - e,
          m = 0 === n ? 0 : ((n > 0 ? o : a) - s) / (Math.log(n > 0 ? h : l) - this.goalLogFov),
          f = s + n * (isFinite(m) ? m : 2 * (o - a));

      if (this.setOrbit(d, p, f), 0 !== n) {
        var _t427 = this.goalLogFov + n;

        this.setFieldOfView(Math.exp(_t427));
      }
    }
  }, {
    key: "jumpToGoal",
    value: function jumpToGoal() {
      this.update(0, 1e4);
    }
  }, {
    key: "update",
    value: function update(t, e) {
      if (this.isStationary()) return;
      var _this$_options4 = this._options,
          n = _this$_options4.maximumPolarAngle,
          i = _this$_options4.maximumRadius,
          r = this.spherical.theta - this.goalSpherical.theta;
      Math.abs(r) > Math.PI && !isFinite(this._options.minimumAzimuthalAngle) && !isFinite(this._options.maximumAzimuthalAngle) && (this.spherical.theta -= 2 * Math.sign(r) * Math.PI), this.spherical.theta = this.thetaDamper.update(this.spherical.theta, this.goalSpherical.theta, e, Math.PI), this.spherical.phi = this.phiDamper.update(this.spherical.phi, this.goalSpherical.phi, e, n), this.spherical.radius = this.radiusDamper.update(this.spherical.radius, this.goalSpherical.radius, e, i), this.logFov = this.fovDamper.update(this.logFov, this.goalLogFov, e, 1), this.moveCamera();
    }
  }, {
    key: "updateTouchActionStyle",
    value: function updateTouchActionStyle() {
      var t = this.element.style;

      if (this._interactionEnabled) {
        var _e343 = this._options.touchAction;
        this._disableZoom && "none" !== _e343 ? t.touchAction = "manipulation" : t.touchAction = _e343;
      } else t.touchAction = "";
    }
  }, {
    key: "isStationary",
    value: function isStationary() {
      return this.goalSpherical.theta === this.spherical.theta && this.goalSpherical.phi === this.spherical.phi && this.goalSpherical.radius === this.spherical.radius && this.goalLogFov === this.logFov;
    }
  }, {
    key: "moveCamera",
    value: function moveCamera() {
      this.spherical.makeSafe(), this.camera.position.setFromSpherical(this.spherical), this.camera.setRotationFromEuler(new Ae(this.spherical.phi - Math.PI / 2, this.spherical.theta, 0, "YXZ")), this.camera.fov !== Math.exp(this.logFov) && (this.camera.fov = Math.exp(this.logFov), this.camera.updateProjectionMatrix());
      var t = this.isUserChange ? ug : dg;
      this.dispatchEvent({
        type: "change",
        source: t
      });
    }
  }, {
    key: "canInteract",
    get: function get() {
      if ("allow-when-focused" == this._options.interactionPolicy) {
        return this.element.getRootNode().activeElement === this.element;
      }

      return "always-allow" === this._options.interactionPolicy;
    }
  }, {
    key: "userAdjustOrbit",
    value: function userAdjustOrbit(t, e, n) {
      this.adjustOrbit(t * this.sensitivity, e * this.sensitivity, n), this.isUserChange = !0, this.dispatchEvent({
        type: "change",
        source: ug
      });
    }
  }, {
    key: "wrapAngle",
    value: function wrapAngle(t) {
      var e = (t + Math.PI) / (2 * Math.PI);
      return 2 * (e - Math.floor(e)) * Math.PI - Math.PI;
    }
  }, {
    key: "pixelLengthToSphericalAngle",
    value: function pixelLengthToSphericalAngle(t) {
      return 2 * Math.PI * t / this.element.clientHeight;
    }
  }, {
    key: "twoTouchDistance",
    value: function twoTouchDistance(t, e) {
      var n = t.clientX,
          i = t.clientY,
          r = e.clientX,
          s = e.clientY,
          a = r - n,
          o = s - i;
      return Math.sqrt(a * a + o * o);
    }
  }, {
    key: "handleSinglePointerMove",
    value: function handleSinglePointerMove(t) {
      var e = t.clientX,
          n = t.clientY,
          i = this.pixelLengthToSphericalAngle(e - this.lastPointerPosition.clientX),
          r = this.pixelLengthToSphericalAngle(n - this.lastPointerPosition.clientY);
      this.lastPointerPosition.clientX = e, this.lastPointerPosition.clientY = n, !1 === this.isUserPointing && (this.isUserPointing = !0, this.dispatchEvent({
        type: "pointer-change-start",
        pointer: Object.assign({}, t)
      })), this.userAdjustOrbit(i, r, 0);
    }
  }, {
    key: "initializePan",
    value: function initializePan() {
      this.scene.element[zg].style.opacity = 1;
      var _this$spherical = this.spherical,
          t = _this$spherical.theta,
          e = _this$spherical.phi,
          n = t - this.scene.yaw;
      this.panPerPixel = .018 / this.scene.height, this.panProjection.set(-Math.cos(n), -Math.cos(e) * Math.sin(n), 0, 0, Math.sin(e), 0, Math.sin(n), -Math.cos(e) * Math.cos(n), 0);
    }
  }, {
    key: "movePan",
    value: function movePan(t, e) {
      var n = this.scene,
          i = this.lastPointerPosition,
          r = ng.set(t - i.clientX, e - i.clientY, 0),
          s = this.spherical.radius * Math.exp(this.logFov) * this.panPerPixel;
      r.multiplyScalar(s), i.clientX = t, i.clientY = e;
      var a = n.getTarget();
      a.add(r.applyMatrix3(this.panProjection)), n.boundingSphere.clampPoint(a, a), n.setTarget(a.x, a.y, a.z);
    }
  }, {
    key: "recenter",
    value: function recenter(t) {
      var e = this.scene;
      if (e.element[zg].style.opacity = 0, !this.enablePan || Math.abs(t.clientX - this.startPointerPosition.clientX) > 2 || Math.abs(t.clientY - this.startPointerPosition.clientY) > 2) return;
      var n = e.positionAndNormalFromPoint(e.getNDC(t.clientX, t.clientY));

      if (null == n) {
        var _t428 = e.element.cameraTarget;
        e.element.cameraTarget = "", e.element.cameraTarget = _t428, this.userAdjustOrbit(0, 0, 1);
      } else e.target.worldToLocal(n.position), e.setTarget(n.position.x, n.position.y, n.position.z);
    }
  }, {
    key: "resetRadius",
    value: function resetRadius() {
      var t = this.scene;
      if (t.element[zg].style.opacity = 0, !this.enablePan || 0 === this.panPerPixel) return;
      var e = t.positionAndNormalFromPoint(eg.set(0, 0));
      if (null == e) return;
      t.target.worldToLocal(e.position);
      var n = t.getTarget(),
          _this$spherical2 = this.spherical,
          i = _this$spherical2.theta,
          r = _this$spherical2.phi,
          s = i - t.yaw,
          a = ng.set(Math.sin(r) * Math.sin(s), Math.cos(r), Math.sin(r) * Math.cos(s)),
          o = a.dot(e.position.sub(n));
      n.add(a.multiplyScalar(o)), t.setTarget(n.x, n.y, n.z), this.setOrbit(void 0, void 0, this.goalSpherical.radius - o);
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(t) {
      this.canInteract && (this.isUserPointing = !1, t());
    }
  }, {
    key: "onTouchChange",
    value: function onTouchChange(t) {
      var e = t.targetTouches,
          n = t.changedTouches;

      switch (e.length) {
        default:
        case 1:
          this.touchMode = this.touchModeRotate, this.lastPointerPosition.clientX = e[0].clientX, this.lastPointerPosition.clientY = e[0].clientY, e[0].identifier === n[0].identifier ? (this.startPointerPosition.clientX = e[0].clientX, this.startPointerPosition.clientY = e[0].clientY) : this.resetRadius();
          break;

        case 2:
          if (this.touchMode = this.touchDecided && null === this.touchMode ? null : this.touchModeZoom, this.touchDecided = !0, this.enablePan && null != this.touchMode) {
            this.initializePan();

            var _t429 = .5 * (e[0].clientX + e[1].clientX),
                _n304 = .5 * (e[0].clientY + e[1].clientY);

            this.lastPointerPosition.clientX = _t429, this.lastPointerPosition.clientY = _n304, this.startPointerPosition.clientX = _t429, this.startPointerPosition.clientY = _n304;
          }

      }

      this.lastTouches = e;
    }
  }, {
    key: "onPointerUp",
    value: function onPointerUp() {
      this.element.style.cursor = "grab", this.panPerPixel = 0, this.isUserPointing && this.dispatchEvent({
        type: "pointer-change-end",
        pointer: Object.assign({}, this.lastPointerPosition)
      });
    }
  }]);

  return pg;
}(et);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var mg = function mg(t) {
  return t < .5 ? 2 * t * t : (4 - 2 * t) * t - 1;
},
    fg = function fg(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : mg;
  return function (i) {
    return t + (e - t) * n(i);
  };
},
    gg = function gg(t, e) {
  var n = [],
      i = [];
  var r = t;

  for (var _t430 = 0; _t430 < e.length; ++_t430) {
    var _s96 = e[_t430],
        _a74 = _s96.value,
        _o46 = _s96.frames,
        _l45 = _s96.ease || mg,
        _h31 = fg(r, _a74, _l45);

    n.push(_h31), i.push(_o46), r = _a74;
  }

  return function (t, e) {
    var n = e.reduce(function (t, e) {
      return t + e;
    }, 0),
        i = e.map(function (t) {
      return t / n;
    });
    return function (e) {
      var n = 0,
          r = 1 / 0,
          s = function s() {
        return 0;
      };

      for (var _a75 = 0; _a75 < i.length && (r = i[_a75], s = t[_a75], !(e <= n + r)); ++_a75) {
        n += r;
      }

      return s((e - n) / r);
    };
  }(n, i);
};
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var vg = function vg(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var yg = gg(0, [{
  frames: 5,
  value: -1
}, {
  frames: 1,
  value: -1
}, {
  frames: 8,
  value: 1
}, {
  frames: 1,
  value: 1
}, {
  frames: 5,
  value: 0
}, {
  frames: 18,
  value: 0
}]),
    xg = gg(0, [{
  frames: 1,
  value: 1
}, {
  frames: 5,
  value: 1
}, {
  frames: 1,
  value: 0
}, {
  frames: 6,
  value: 0
}]),
    _g = ["front", "right", "back", "left"],
    bg = ["upper-", "", "lower-"],
    wg = "auto",
    Mg = "when-focused",
    Sg = "wiggle",
    Tg = "always-allow",
    Eg = "pan-y",
    Ag = function Ag(t) {
  var e = t.enablePan ? 30 : 45;
  return {
    basis: [Mu(pu(e, "deg"))],
    keywords: {
      auto: [null]
    }
  };
},
    Rg = function Rg(t) {
  var e = t.enablePan ? 12 : 25;
  return {
    basis: [Mu(pu(e, "deg"))],
    keywords: {
      auto: [null]
    }
  };
},
    Cg = function () {
  var t = mu("0deg 75deg 105%")[0].terms,
      e = Tu(t[0]),
      n = Tu(t[1]);
  return function (t) {
    var i = t[bp].idealCameraDistance();
    return {
      basis: [e, n, pu(i, "m")],
      keywords: {
        auto: [null, null, pu(105, "%")]
      }
    };
  };
}(),
    Lg = function Lg(t) {
  var e = 1.1 * t[bp].boundingSphere.radius * (t.enablePan ? 2 : 1);
  return {
    basis: [pu(-1 / 0, "rad"), pu(Math.PI / 8, "rad"), pu(e, "m")],
    keywords: {
      auto: [null, null, null]
    }
  };
},
    Pg = function Pg(t) {
  var e = Cg(t),
      n = new Uf([], e).evaluate()[2];
  return {
    basis: [pu(1 / 0, "rad"), pu(Math.PI - Math.PI / 8, "rad"), pu(n, "m")],
    keywords: {
      auto: [null, null, null]
    }
  };
},
    Dg = function Dg(t) {
  var e = t[bp].boundingBox.getCenter(new zt());
  return {
    basis: [pu(e.x, "m"), pu(e.y, "m"), pu(e.z, "m")],
    keywords: {
      auto: [null, null, null]
    }
  };
},
    Ig = function Ig(t) {
  t.preventDefault();
},
    Og = Math.PI / 2,
    Ng = Math.PI / 3,
    Fg = Og / 2,
    Ug = 2 * Math.PI,
    kg = Symbol("controls"),
    Bg = Symbol("promptElement"),
    zg = Symbol("panElement"),
    Hg = Symbol("promptAnimatedContainer"),
    Vg = Symbol("deferInteractionPrompt"),
    Gg = Symbol("updateAria"),
    Wg = Symbol("updateCameraForRadius"),
    jg = Symbol("onBlur"),
    qg = Symbol("onFocus"),
    Xg = Symbol("onChange"),
    Yg = Symbol("onPointerChange"),
    Jg = Symbol("waitingToPromptUser"),
    Zg = Symbol("userHasInteracted"),
    $g = Symbol("promptElementVisibleTime"),
    Kg = Symbol("lastPromptOffset"),
    Qg = Symbol("focusedTime"),
    tv = Symbol("lastSpherical"),
    ev = Symbol("jumpCamera"),
    nv = Symbol("initialized"),
    iv = Symbol("maintainThetaPhi"),
    rv = Symbol("syncCameraOrbit"),
    sv = Symbol("syncFieldOfView"),
    av = Symbol("syncCameraTarget"),
    ov = Symbol("syncMinCameraOrbit"),
    lv = Symbol("syncMaxCameraOrbit"),
    hv = Symbol("syncMinFieldOfView"),
    cv = Symbol("syncMaxFieldOfView");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var uv = function uv(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var dv = "auto",
    pv = "manual",
    mv = "auto",
    fv = "eager",
    gv = "interaction",
    vv = Symbol("defaultProgressBarElement"),
    yv = Symbol("defaultProgressMaskElement"),
    xv = Symbol("posterContainerElement"),
    _v = Symbol("defaultPosterElement"),
    bv = Symbol("posterDismissalSource"),
    wv = Symbol("hidePoster"),
    Mv = Symbol("modelIsRevealed"),
    Sv = Symbol("updateProgressBar"),
    Tv = Symbol("lastReportedProgress"),
    Ev = Symbol("transitioned"),
    Av = Symbol("onTransitionEnd"),
    Rv = Symbol("ariaLabelCallToAction"),
    Cv = Symbol("onClick"),
    Lv = Symbol("onKeydown"),
    Pv = Symbol("onProgress");

var Dv = /*#__PURE__*/function () {
  function Dv() {
    _classCallCheck(this, Dv);

    this.pluginCallbacks = [], this.register(function (t) {
      return new ay(t);
    }), this.register(function (t) {
      return new oy(t);
    }), this.register(function (t) {
      return new ly(t);
    }), this.register(function (t) {
      return new cy(t);
    }), this.register(function (t) {
      return new uy(t);
    }), this.register(function (t) {
      return new hy(t);
    });
  }

  _createClass(Dv, [{
    key: "register",
    value: function register(t) {
      return -1 === this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.push(t), this;
    }
  }, {
    key: "unregister",
    value: function unregister(t) {
      return -1 !== this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t), 1), this;
    }
  }, {
    key: "parse",
    value: function parse(t, e, n, i) {
      "object" == typeof n && (console.warn("THREE.GLTFExporter: parse() expects options as the fourth argument now."), i = n);
      var r = new sy(),
          s = [];

      for (var _t431 = 0, _e344 = this.pluginCallbacks.length; _t431 < _e344; _t431++) {
        s.push(this.pluginCallbacks[_t431](r));
      }

      r.setPlugins(s), r.write(t, e, i).catch(n);
    }
  }, {
    key: "parseAsync",
    value: function parseAsync(t, e) {
      var n = this;
      return new Promise(function (i, r) {
        n.parse(t, i, r, e);
      });
    }
  }]);

  return Dv;
}();

var Iv = 0,
    Ov = 1,
    Nv = 2,
    Fv = 3,
    Uv = 4,
    kv = 5121,
    Bv = 5123,
    zv = 5126,
    Hv = 5125,
    Vv = 34962,
    Gv = 34963,
    Wv = 9728,
    jv = 9729,
    qv = 9984,
    Xv = 9985,
    Yv = 9986,
    Jv = 9987,
    Zv = 33071,
    $v = 33648,
    Kv = 10497,
    Qv = {};
Qv[1003] = Wv, Qv[1004] = qv, Qv[1005] = Yv, Qv[1006] = jv, Qv[1007] = Xv, Qv[1008] = Jv, Qv[1001] = Zv, Qv[1e3] = Kv, Qv[1002] = $v;
var ty = {
  scale: "scale",
  position: "translation",
  quaternion: "rotation",
  morphTargetInfluences: "weights"
};

function ey(t, e) {
  return t.length === e.length && t.every(function (t, n) {
    return t === e[n];
  });
}

function ny(t) {
  return 4 * Math.ceil(t / 4);
}

function iy(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n = ny(t.byteLength);

  if (n !== t.byteLength) {
    var _i253 = new Uint8Array(n);

    if (_i253.set(new Uint8Array(t)), 0 !== e) for (var _r167 = t.byteLength; _r167 < n; _r167++) {
      _i253[_r167] = e;
    }
    return _i253.buffer;
  }

  return t;
}

var ry = null;

var sy = /*#__PURE__*/function () {
  function sy() {
    _classCallCheck(this, sy);

    this.plugins = [], this.options = {}, this.pending = [], this.buffers = [], this.byteOffset = 0, this.buffers = [], this.nodeMap = new Map(), this.skins = [], this.extensionsUsed = {}, this.uids = new Map(), this.uid = 0, this.json = {
      asset: {
        version: "2.0",
        generator: "THREE.GLTFExporter"
      }
    }, this.cache = {
      meshes: new Map(),
      attributes: new Map(),
      attributesNormalized: new Map(),
      materials: new Map(),
      textures: new Map(),
      images: new Map()
    };
  }

  _createClass(sy, [{
    key: "setPlugins",
    value: function setPlugins(t) {
      this.plugins = t;
    }
  }, {
    key: "write",
    value: function () {
      var _write = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(t, e, n) {
        var i, r, s, a, o, l, _t432, _t433;

        return _regeneratorRuntime.wrap(function _callee28$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                this.options = Object.assign({}, {
                  binary: !1,
                  trs: !1,
                  onlyVisible: !0,
                  truncateDrawRange: !0,
                  embedImages: !0,
                  maxTextureSize: 1 / 0,
                  animations: [],
                  includeCustomExtensions: !1
                }, n);
                this.options.animations.length > 0 && (this.options.trs = !0);
                this.processInput(t);
                _context32.next = 5;
                return Promise.all(this.pending);

              case 5:
                i = this, r = i.buffers, s = i.json;
                n = i.options;
                a = i.extensionsUsed, o = new Blob(r, {
                  type: "application/octet-stream"
                }), l = Object.keys(a);

                if (l.length > 0 && (s.extensionsUsed = l), s.buffers && s.buffers.length > 0 && (s.buffers[0].byteLength = o.size), !0 === n.binary) {
                  _t432 = new window.FileReader();
                  _t432.readAsArrayBuffer(o), _t432.onloadend = function () {
                    var n = iy(_t432.result),
                        i = new DataView(new ArrayBuffer(8));
                    i.setUint32(0, n.byteLength, !0), i.setUint32(4, 5130562, !0);
                    var r = iy(function (t) {
                      if (void 0 !== window.TextEncoder) return new TextEncoder().encode(t).buffer;
                      var e = new Uint8Array(new ArrayBuffer(t.length));

                      for (var _n305 = 0, _i254 = t.length; _n305 < _i254; _n305++) {
                        var _i255 = t.charCodeAt(_n305);

                        e[_n305] = _i255 > 255 ? 32 : _i255;
                      }

                      return e.buffer;
                    }(JSON.stringify(s)), 32),
                        a = new DataView(new ArrayBuffer(8));
                    a.setUint32(0, r.byteLength, !0), a.setUint32(4, 1313821514, !0);
                    var o = new ArrayBuffer(12),
                        l = new DataView(o);
                    l.setUint32(0, 1179937895, !0), l.setUint32(4, 2, !0);
                    var h = 12 + a.byteLength + r.byteLength + i.byteLength + n.byteLength;
                    l.setUint32(8, h, !0);
                    var c = new Blob([o, a, r, i, n], {
                      type: "application/octet-stream"
                    }),
                        u = new window.FileReader();
                    u.readAsArrayBuffer(c), u.onloadend = function () {
                      e(u.result);
                    };
                  };
                } else if (s.buffers && s.buffers.length > 0) {
                  _t433 = new window.FileReader();
                  _t433.readAsDataURL(o), _t433.onloadend = function () {
                    var n = _t433.result;
                    s.buffers[0].uri = n, e(s);
                  };
                } else e(s);

              case 9:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee28, this);
      }));

      function write(_x27, _x28, _x29) {
        return _write.apply(this, arguments);
      }

      return write;
    }()
  }, {
    key: "serializeUserData",
    value: function serializeUserData(t, e) {
      if (0 === Object.keys(t.userData).length) return;
      var n = this.options,
          i = this.extensionsUsed;

      try {
        var _r168 = JSON.parse(JSON.stringify(t.userData));

        if (n.includeCustomExtensions && _r168.gltfExtensions) {
          void 0 === e.extensions && (e.extensions = {});

          for (var _t434 in _r168.gltfExtensions) {
            e.extensions[_t434] = _r168.gltfExtensions[_t434], i[_t434] = !0;
          }

          delete _r168.gltfExtensions;
        }

        Object.keys(_r168).length > 0 && (e.extras = _r168);
      } catch (e) {
        console.warn("THREE.GLTFExporter: userData of '" + t.name + "' won't be serialized because of JSON.stringify error - " + e.message);
      }
    }
  }, {
    key: "getUID",
    value: function getUID(t) {
      return this.uids.has(t) || this.uids.set(t, this.uid++), this.uids.get(t);
    }
  }, {
    key: "isNormalizedNormalAttribute",
    value: function isNormalizedNormalAttribute(t) {
      if (this.cache.attributesNormalized.has(t)) return !1;
      var e = new zt();

      for (var n = 0, _i256 = t.count; n < _i256; n++) {
        if (Math.abs(e.fromBufferAttribute(t, n).length() - 1) > 5e-4) return !1;
      }

      return !0;
    }
  }, {
    key: "createNormalizedNormalAttribute",
    value: function createNormalizedNormalAttribute(t) {
      var e = this.cache;
      if (e.attributesNormalized.has(t)) return e.attributesNormalized.get(t);
      var n = t.clone(),
          i = new zt();

      for (var _t435 = 0, _e345 = n.count; _t435 < _e345; _t435++) {
        i.fromBufferAttribute(n, _t435), 0 === i.x && 0 === i.y && 0 === i.z ? i.setX(1) : i.normalize(), n.setXYZ(_t435, i.x, i.y, i.z);
      }

      return e.attributesNormalized.set(t, n), n;
    }
  }, {
    key: "applyTextureTransform",
    value: function applyTextureTransform(t, e) {
      var n = !1;
      var i = {};
      0 === e.offset.x && 0 === e.offset.y || (i.offset = e.offset.toArray(), n = !0), 0 !== e.rotation && (i.rotation = e.rotation, n = !0), 1 === e.repeat.x && 1 === e.repeat.y || (i.scale = e.repeat.toArray(), n = !0), n && (t.extensions = t.extensions || {}, t.extensions.KHR_texture_transform = i, this.extensionsUsed.KHR_texture_transform = !0);
    }
  }, {
    key: "buildMetalRoughTexture",
    value: function buildMetalRoughTexture(t, e) {
      if (t === e) return t;
      console.warn("THREE.GLTFExporter: Merged metalnessMap and roughnessMap textures.");
      var n = t === null || t === void 0 ? void 0 : t.image,
          i = e === null || e === void 0 ? void 0 : e.image,
          r = Math.max((n === null || n === void 0 ? void 0 : n.width) || 0, (i === null || i === void 0 ? void 0 : i.width) || 0),
          s = Math.max((n === null || n === void 0 ? void 0 : n.height) || 0, (i === null || i === void 0 ? void 0 : i.height) || 0),
          a = document.createElement("canvas");
      a.width = r, a.height = s;
      var o = a.getContext("2d");
      o.fillStyle = "#00ffff", o.fillRect(0, 0, r, s);
      var l = o.getImageData(0, 0, r, s);

      if (n) {
        o.drawImage(n, 0, 0, r, s);
        var _t436 = o.getImageData(0, 0, r, s).data;

        for (var _e346 = 2; _e346 < _t436.length; _e346 += 4) {
          l.data[_e346] = _t436[_e346];
        }
      }

      if (i) {
        o.drawImage(i, 0, 0, r, s);
        var _t437 = o.getImageData(0, 0, r, s).data;

        for (var _e347 = 1; _e347 < _t437.length; _e347 += 4) {
          l.data[_e347] = _t437[_e347];
        }
      }

      o.putImageData(l, 0, 0);
      var h = (t || e).clone();
      return h.source = new Pt(a), h;
    }
  }, {
    key: "processBuffer",
    value: function processBuffer(t) {
      var e = this.json,
          n = this.buffers;
      return e.buffers || (e.buffers = [{
        byteLength: 0
      }]), n.push(t), 0;
    }
  }, {
    key: "processBufferView",
    value: function processBufferView(t, e, n, i, r) {
      var s = this.json;
      var a;
      s.bufferViews || (s.bufferViews = []), a = e === kv ? 1 : e === Bv ? 2 : 4;
      var o = ny(i * t.itemSize * a),
          l = new DataView(new ArrayBuffer(o));
      var h = 0;

      for (var _r169 = n; _r169 < n + i; _r169++) {
        for (var _n306 = 0; _n306 < t.itemSize; _n306++) {
          var _i257 = void 0;

          t.itemSize > 4 ? _i257 = t.array[_r169 * t.itemSize + _n306] : 0 === _n306 ? _i257 = t.getX(_r169) : 1 === _n306 ? _i257 = t.getY(_r169) : 2 === _n306 ? _i257 = t.getZ(_r169) : 3 === _n306 && (_i257 = t.getW(_r169)), e === zv ? l.setFloat32(h, _i257, !0) : e === Hv ? l.setUint32(h, _i257, !0) : e === Bv ? l.setUint16(h, _i257, !0) : e === kv && l.setUint8(h, _i257), h += a;
        }
      }

      var c = {
        buffer: this.processBuffer(l.buffer),
        byteOffset: this.byteOffset,
        byteLength: o
      };
      void 0 !== r && (c.target = r), r === Vv && (c.byteStride = t.itemSize * a), this.byteOffset += o, s.bufferViews.push(c);
      return {
        id: s.bufferViews.length - 1,
        byteLength: 0
      };
    }
  }, {
    key: "processBufferViewImage",
    value: function processBufferViewImage(t) {
      var e = this,
          n = e.json;
      return n.bufferViews || (n.bufferViews = []), new Promise(function (i) {
        var r = new window.FileReader();
        r.readAsArrayBuffer(t), r.onloadend = function () {
          var t = iy(r.result),
              s = {
            buffer: e.processBuffer(t),
            byteOffset: e.byteOffset,
            byteLength: t.byteLength
          };
          e.byteOffset += t.byteLength, i(n.bufferViews.push(s) - 1);
        };
      });
    }
  }, {
    key: "processAccessor",
    value: function processAccessor(t, e, n, i) {
      var r = this.options,
          s = this.json;
      var a;
      if (t.array.constructor === Float32Array) a = zv;else if (t.array.constructor === Uint32Array) a = Hv;else if (t.array.constructor === Uint16Array) a = Bv;else {
        if (t.array.constructor !== Uint8Array) throw new Error("THREE.GLTFExporter: Unsupported bufferAttribute component type.");
        a = kv;
      }

      if (void 0 === n && (n = 0), void 0 === i && (i = t.count), r.truncateDrawRange && void 0 !== e && null === e.index) {
        var _r170 = n + i,
            _s97 = e.drawRange.count === 1 / 0 ? t.count : e.drawRange.start + e.drawRange.count;

        n = Math.max(n, e.drawRange.start), (i = Math.min(_r170, _s97) - n) < 0 && (i = 0);
      }

      if (0 === i) return null;

      var o = function (t, e, n) {
        var i = {
          min: new Array(t.itemSize).fill(Number.POSITIVE_INFINITY),
          max: new Array(t.itemSize).fill(Number.NEGATIVE_INFINITY)
        };

        for (var _r171 = e; _r171 < e + n; _r171++) {
          for (var _e348 = 0; _e348 < t.itemSize; _e348++) {
            var _n307 = void 0;

            t.itemSize > 4 ? _n307 = t.array[_r171 * t.itemSize + _e348] : 0 === _e348 ? _n307 = t.getX(_r171) : 1 === _e348 ? _n307 = t.getY(_r171) : 2 === _e348 ? _n307 = t.getZ(_r171) : 3 === _e348 && (_n307 = t.getW(_r171)), i.min[_e348] = Math.min(i.min[_e348], _n307), i.max[_e348] = Math.max(i.max[_e348], _n307);
          }
        }

        return i;
      }(t, n, i);

      var l;
      void 0 !== e && (l = t === e.index ? Gv : Vv);
      var h = this.processBufferView(t, a, n, i, l),
          c = {
        bufferView: h.id,
        byteOffset: h.byteOffset,
        componentType: a,
        count: i,
        max: o.max,
        min: o.min,
        type: {
          1: "SCALAR",
          2: "VEC2",
          3: "VEC3",
          4: "VEC4",
          16: "MAT4"
        }[t.itemSize]
      };
      return !0 === t.normalized && (c.normalized = !0), s.accessors || (s.accessors = []), s.accessors.push(c) - 1;
    }
  }, {
    key: "processImage",
    value: function processImage(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "image/png";
      var r = this,
          s = r.cache,
          a = r.json,
          o = r.options,
          l = r.pending;
      s.images.has(t) || s.images.set(t, {});
      var h = s.images.get(t),
          c = i + ":flipY/" + n.toString();
      if (void 0 !== h[c]) return h[c];
      a.images || (a.images = []);
      var u = {
        mimeType: i
      };

      if (o.embedImages) {
        var _s98 = ry = ry || document.createElement("canvas");

        _s98.width = Math.min(t.width, o.maxTextureSize), _s98.height = Math.min(t.height, o.maxTextureSize);

        var _a76 = _s98.getContext("2d");

        if (!0 === n && (_a76.translate(0, _s98.height), _a76.scale(1, -1)), "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t instanceof OffscreenCanvas || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) _a76.drawImage(t, 0, 0, _s98.width, _s98.height);else {
          1023 !== e && console.error("GLTFExporter: Only RGBAFormat is supported."), (t.width > o.maxTextureSize || t.height > o.maxTextureSize) && console.warn("GLTFExporter: Image size is bigger than maxTextureSize", t);

          var _n308 = new Uint8ClampedArray(t.height * t.width * 4);

          for (var _e349 = 0; _e349 < _n308.length; _e349 += 4) {
            _n308[_e349 + 0] = t.data[_e349 + 0], _n308[_e349 + 1] = t.data[_e349 + 1], _n308[_e349 + 2] = t.data[_e349 + 2], _n308[_e349 + 3] = t.data[_e349 + 3];
          }

          _a76.putImageData(new ImageData(_n308, t.width, t.height), 0, 0);
        }
        !0 === o.binary ? l.push(new Promise(function (t) {
          _s98.toBlob(function (e) {
            r.processBufferViewImage(e).then(function (e) {
              u.bufferView = e, t();
            });
          }, i);
        })) : u.uri = _s98.toDataURL(i);
      } else u.uri = t.src;

      var d = a.images.push(u) - 1;
      return h[c] = d, d;
    }
  }, {
    key: "processSampler",
    value: function processSampler(t) {
      var e = this.json;
      e.samplers || (e.samplers = []);
      var n = {
        magFilter: Qv[t.magFilter],
        minFilter: Qv[t.minFilter],
        wrapS: Qv[t.wrapS],
        wrapT: Qv[t.wrapT]
      };
      return e.samplers.push(n) - 1;
    }
  }, {
    key: "processTexture",
    value: function processTexture(t) {
      var e = this.cache,
          n = this.json;
      if (e.textures.has(t)) return e.textures.get(t);
      n.textures || (n.textures = []);
      var i = t.userData.mimeType;
      "image/webp" === i && (i = "image/png");
      var r = {
        sampler: this.processSampler(t),
        source: this.processImage(t.image, t.format, t.flipY, i)
      };
      t.name && (r.name = t.name), this._invokeAll(function (e) {
        e.writeTexture && e.writeTexture(t, r);
      });
      var s = n.textures.push(r) - 1;
      return e.textures.set(t, s), s;
    }
  }, {
    key: "processMaterial",
    value: function processMaterial(t) {
      var e = this.cache,
          n = this.json;
      if (e.materials.has(t)) return e.materials.get(t);
      if (t.isShaderMaterial) return console.warn("GLTFExporter: THREE.ShaderMaterial not supported."), null;
      n.materials || (n.materials = []);
      var i = {
        pbrMetallicRoughness: {}
      };
      !0 !== t.isMeshStandardMaterial && !0 !== t.isMeshBasicMaterial && console.warn("GLTFExporter: Use MeshStandardMaterial or MeshBasicMaterial for best results.");
      var r = t.color.toArray().concat([t.opacity]);

      if (ey(r, [1, 1, 1, 1]) || (i.pbrMetallicRoughness.baseColorFactor = r), t.isMeshStandardMaterial ? (i.pbrMetallicRoughness.metallicFactor = t.metalness, i.pbrMetallicRoughness.roughnessFactor = t.roughness) : (i.pbrMetallicRoughness.metallicFactor = .5, i.pbrMetallicRoughness.roughnessFactor = .5), t.metalnessMap || t.roughnessMap) {
        var _e350 = this.buildMetalRoughTexture(t.metalnessMap, t.roughnessMap),
            _n309 = {
          index: this.processTexture(_e350)
        };

        this.applyTextureTransform(_n309, _e350), i.pbrMetallicRoughness.metallicRoughnessTexture = _n309;
      }

      if (t.map) {
        var _e351 = {
          index: this.processTexture(t.map)
        };
        this.applyTextureTransform(_e351, t.map), i.pbrMetallicRoughness.baseColorTexture = _e351;
      }

      if (t.emissive) {
        var _e352 = t.emissive.clone().multiplyScalar(t.emissiveIntensity),
            _n310 = Math.max(_e352.r, _e352.g, _e352.b);

        if (_n310 > 1 && (_e352.multiplyScalar(1 / _n310), console.warn("THREE.GLTFExporter: Some emissive components exceed 1; emissive has been limited")), _n310 > 0 && (i.emissiveFactor = _e352.toArray()), t.emissiveMap) {
          var _e353 = {
            index: this.processTexture(t.emissiveMap)
          };
          this.applyTextureTransform(_e353, t.emissiveMap), i.emissiveTexture = _e353;
        }
      }

      if (t.normalMap) {
        var _e354 = {
          index: this.processTexture(t.normalMap)
        };
        t.normalScale && 1 !== t.normalScale.x && (_e354.scale = t.normalScale.x), this.applyTextureTransform(_e354, t.normalMap), i.normalTexture = _e354;
      }

      if (t.aoMap) {
        var _e355 = {
          index: this.processTexture(t.aoMap),
          texCoord: 1
        };
        1 !== t.aoMapIntensity && (_e355.strength = t.aoMapIntensity), this.applyTextureTransform(_e355, t.aoMap), i.occlusionTexture = _e355;
      }

      t.transparent ? i.alphaMode = "BLEND" : t.alphaTest > 0 && (i.alphaMode = "MASK", i.alphaCutoff = t.alphaTest), 2 === t.side && (i.doubleSided = !0), "" !== t.name && (i.name = t.name), this.serializeUserData(t, i), this._invokeAll(function (e) {
        e.writeMaterial && e.writeMaterial(t, i);
      });
      var s = n.materials.push(i) - 1;
      return e.materials.set(t, s), s;
    }
  }, {
    key: "processMesh",
    value: function processMesh(t) {
      var e = this.cache,
          n = this.json,
          i = [t.geometry.uuid];
      if (Array.isArray(t.material)) for (var _e356 = 0, _n311 = t.material.length; _e356 < _n311; _e356++) {
        i.push(t.material[_e356].uuid);
      } else i.push(t.material.uuid);
      var r = i.join(":");
      if (e.meshes.has(r)) return e.meshes.get(r);
      var s = t.geometry;
      var a;
      if (a = t.isLineSegments ? Ov : t.isLineLoop ? Nv : t.isLine ? Fv : t.isPoints ? Iv : t.material.wireframe ? Ov : Uv, !0 !== s.isBufferGeometry) throw new Error("THREE.GLTFExporter: Geometry is not of type THREE.BufferGeometry.");
      var o = {},
          l = {},
          h = [],
          c = [],
          u = {
        uv: "TEXCOORD_0",
        uv2: "TEXCOORD_1",
        color: "COLOR_0",
        skinWeight: "WEIGHTS_0",
        skinIndex: "JOINTS_0"
      },
          d = s.getAttribute("normal");
      void 0 === d || this.isNormalizedNormalAttribute(d) || (console.warn("THREE.GLTFExporter: Creating normalized normal attribute from the non-normalized one."), s.setAttribute("normal", this.createNormalizedNormalAttribute(d)));
      var p = null;

      for (var _t438 in s.attributes) {
        if ("morph" === _t438.slice(0, 5)) continue;
        var _n312 = s.attributes[_t438];
        _t438 = u[_t438] || _t438.toUpperCase();

        if (/^(POSITION|NORMAL|TANGENT|TEXCOORD_\d+|COLOR_\d+|JOINTS_\d+|WEIGHTS_\d+)$/.test(_t438) || (_t438 = "_" + _t438), e.attributes.has(this.getUID(_n312))) {
          l[_t438] = e.attributes.get(this.getUID(_n312));
          continue;
        }

        p = null;
        var _i258 = _n312.array;
        "JOINTS_0" !== _t438 || _i258 instanceof Uint16Array || _i258 instanceof Uint8Array || (console.warn('GLTFExporter: Attribute "skinIndex" converted to type UNSIGNED_SHORT.'), p = new an(new Uint16Array(_i258), _n312.itemSize, _n312.normalized));

        var _r172 = this.processAccessor(p || _n312, s);

        null !== _r172 && (l[_t438] = _r172, e.attributes.set(this.getUID(_n312), _r172));
      }

      if (void 0 !== d && s.setAttribute("normal", d), 0 === Object.keys(l).length) return null;

      if (void 0 !== t.morphTargetInfluences && t.morphTargetInfluences.length > 0) {
        var _n313 = [],
            _i259 = [],
            _r173 = {};
        if (void 0 !== t.morphTargetDictionary) for (var _e357 in t.morphTargetDictionary) {
          _r173[t.morphTargetDictionary[_e357]] = _e357;
        }

        for (var _a77 = 0; _a77 < t.morphTargetInfluences.length; ++_a77) {
          var _o47 = {};

          var _l46 = !1;

          for (var _t439 in s.morphAttributes) {
            if ("position" !== _t439 && "normal" !== _t439) {
              _l46 || (console.warn("GLTFExporter: Only POSITION and NORMAL morph are supported."), _l46 = !0);
              continue;
            }

            var _n314 = s.morphAttributes[_t439][_a77],
                _i260 = _t439.toUpperCase(),
                _r174 = s.attributes[_t439];

            if (e.attributes.has(this.getUID(_n314))) {
              _o47[_i260] = e.attributes.get(this.getUID(_n314));
              continue;
            }

            var _h32 = _n314.clone();

            if (!s.morphTargetsRelative) for (var _t440 = 0, _e358 = _n314.count; _t440 < _e358; _t440++) {
              _h32.setXYZ(_t440, _n314.getX(_t440) - _r174.getX(_t440), _n314.getY(_t440) - _r174.getY(_t440), _n314.getZ(_t440) - _r174.getZ(_t440));
            }
            _o47[_i260] = this.processAccessor(_h32, s), e.attributes.set(this.getUID(_r174), _o47[_i260]);
          }

          c.push(_o47), _n313.push(t.morphTargetInfluences[_a77]), void 0 !== t.morphTargetDictionary && _i259.push(_r173[_a77]);
        }

        o.weights = _n313, _i259.length > 0 && (o.extras = {}, o.extras.targetNames = _i259);
      }

      var m = Array.isArray(t.material);
      if (m && 0 === s.groups.length) return null;
      var f = m ? t.material : [t.material],
          g = m ? s.groups : [{
        materialIndex: 0,
        start: void 0,
        count: void 0
      }];

      for (var _t441 = 0, _n315 = g.length; _t441 < _n315; _t441++) {
        var _n316 = {
          mode: a,
          attributes: l
        };

        if (this.serializeUserData(s, _n316), c.length > 0 && (_n316.targets = c), null !== s.index) {
          var _i262 = this.getUID(s.index);

          void 0 === g[_t441].start && void 0 === g[_t441].count || (_i262 += ":" + g[_t441].start + ":" + g[_t441].count), e.attributes.has(_i262) ? _n316.indices = e.attributes.get(_i262) : (_n316.indices = this.processAccessor(s.index, s, g[_t441].start, g[_t441].count), e.attributes.set(_i262, _n316.indices)), null === _n316.indices && delete _n316.indices;
        }

        var _i261 = this.processMaterial(f[g[_t441].materialIndex]);

        null !== _i261 && (_n316.material = _i261), h.push(_n316);
      }

      o.primitives = h, n.meshes || (n.meshes = []), this._invokeAll(function (e) {
        e.writeMesh && e.writeMesh(t, o);
      });
      var v = n.meshes.push(o) - 1;
      return e.meshes.set(r, v), v;
    }
  }, {
    key: "processCamera",
    value: function processCamera(t) {
      var e = this.json;
      e.cameras || (e.cameras = []);
      var n = t.isOrthographicCamera,
          i = {
        type: n ? "orthographic" : "perspective"
      };
      return n ? i.orthographic = {
        xmag: 2 * t.right,
        ymag: 2 * t.top,
        zfar: t.far <= 0 ? .001 : t.far,
        znear: t.near < 0 ? 0 : t.near
      } : i.perspective = {
        aspectRatio: t.aspect,
        yfov: pt.degToRad(t.fov),
        zfar: t.far <= 0 ? .001 : t.far,
        znear: t.near < 0 ? 0 : t.near
      }, "" !== t.name && (i.name = t.type), e.cameras.push(i) - 1;
    }
  }, {
    key: "processAnimation",
    value: function processAnimation(t, e) {
      var n = this.json,
          i = this.nodeMap;
      n.animations || (n.animations = []);
      var r = (t = Dv.Utils.mergeMorphTargetTracks(t.clone(), e)).tracks,
          s = [],
          a = [];

      for (var _t442 = 0; _t442 < r.length; ++_t442) {
        var _n317 = r[_t442],
            _o48 = Wl.parseTrackName(_n317.name);

        var _l47 = Wl.findNode(e, _o48.nodeName);

        var _h33 = ty[_o48.propertyName];
        if ("bones" === _o48.objectName && (_l47 = !0 === _l47.isSkinnedMesh ? _l47.skeleton.getBoneByName(_o48.objectIndex) : void 0), !_l47 || !_h33) return console.warn('THREE.GLTFExporter: Could not export animation track "%s".', _n317.name), null;
        var _c25 = 1;

        var _u19 = void 0,
            _d20 = _n317.values.length / _n317.times.length;

        _h33 === ty.morphTargetInfluences && (_d20 /= _l47.morphTargetInfluences.length), !0 === _n317.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline ? (_u19 = "CUBICSPLINE", _d20 /= 3) : _u19 = 2300 === _n317.getInterpolation() ? "STEP" : "LINEAR", a.push({
          input: this.processAccessor(new an(_n317.times, _c25)),
          output: this.processAccessor(new an(_n317.values, _d20)),
          interpolation: _u19
        }), s.push({
          sampler: a.length - 1,
          target: {
            node: i.get(_l47),
            path: _h33
          }
        });
      }

      return n.animations.push({
        name: t.name || "clip_" + n.animations.length,
        samplers: a,
        channels: s
      }), n.animations.length - 1;
    }
  }, {
    key: "processSkin",
    value: function processSkin(t) {
      var e = this.json,
          n = this.nodeMap,
          i = e.nodes[n.get(t)],
          r = t.skeleton;
      if (void 0 === r) return null;
      var s = t.skeleton.bones[0];
      if (void 0 === s) return null;
      var a = [],
          o = new Float32Array(16 * r.bones.length),
          l = new ve();

      for (var _e359 = 0; _e359 < r.bones.length; ++_e359) {
        a.push(n.get(r.bones[_e359])), l.copy(r.boneInverses[_e359]), l.multiply(t.bindMatrix).toArray(o, 16 * _e359);
      }

      void 0 === e.skins && (e.skins = []), e.skins.push({
        inverseBindMatrices: this.processAccessor(new an(o, 16)),
        joints: a,
        skeleton: n.get(s)
      });
      return i.skin = e.skins.length - 1;
    }
  }, {
    key: "processNode",
    value: function processNode(t) {
      var e = this.json,
          n = this.options,
          i = this.nodeMap;
      e.nodes || (e.nodes = []);
      var r = {};

      if (n.trs) {
        var _e360 = t.quaternion.toArray(),
            _n318 = t.position.toArray(),
            _i263 = t.scale.toArray();

        ey(_e360, [0, 0, 0, 1]) || (r.rotation = _e360), ey(_n318, [0, 0, 0]) || (r.translation = _n318), ey(_i263, [1, 1, 1]) || (r.scale = _i263);
      } else t.matrixAutoUpdate && t.updateMatrix(), !1 === ey(t.matrix.elements, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]) && (r.matrix = t.matrix.elements);

      if ("" !== t.name && (r.name = String(t.name)), this.serializeUserData(t, r), t.isMesh || t.isLine || t.isPoints) {
        var _e361 = this.processMesh(t);

        null !== _e361 && (r.mesh = _e361);
      } else t.isCamera && (r.camera = this.processCamera(t));

      if (t.isSkinnedMesh && this.skins.push(t), t.children.length > 0) {
        var _e362 = [];

        for (var _i264 = 0, _r175 = t.children.length; _i264 < _r175; _i264++) {
          var _r176 = t.children[_i264];

          if (_r176.visible || !1 === n.onlyVisible) {
            var _t443 = this.processNode(_r176);

            null !== _t443 && _e362.push(_t443);
          }
        }

        _e362.length > 0 && (r.children = _e362);
      }

      this._invokeAll(function (e) {
        e.writeNode && e.writeNode(t, r);
      });

      var s = e.nodes.push(r) - 1;
      return i.set(t, s), s;
    }
  }, {
    key: "processScene",
    value: function processScene(t) {
      var e = this.json,
          n = this.options;
      e.scenes || (e.scenes = [], e.scene = 0);
      var i = {};
      "" !== t.name && (i.name = t.name), e.scenes.push(i);
      var r = [];

      for (var _e363 = 0, _i265 = t.children.length; _e363 < _i265; _e363++) {
        var _i266 = t.children[_e363];

        if (_i266.visible || !1 === n.onlyVisible) {
          var _t444 = this.processNode(_i266);

          null !== _t444 && r.push(_t444);
        }
      }

      r.length > 0 && (i.nodes = r), this.serializeUserData(t, i);
    }
  }, {
    key: "processObjects",
    value: function processObjects(t) {
      var e = new Is();
      e.name = "AuxScene";

      for (var n = 0; n < t.length; n++) {
        e.children.push(t[n]);
      }

      this.processScene(e);
    }
  }, {
    key: "processInput",
    value: function processInput(t) {
      var e = this.options;
      t = t instanceof Array ? t : [t], this._invokeAll(function (e) {
        e.beforeParse && e.beforeParse(t);
      });
      var n = [];

      for (var _e364 = 0; _e364 < t.length; _e364++) {
        t[_e364] instanceof Is ? this.processScene(t[_e364]) : n.push(t[_e364]);
      }

      n.length > 0 && this.processObjects(n);

      for (var _t445 = 0; _t445 < this.skins.length; ++_t445) {
        this.processSkin(this.skins[_t445]);
      }

      for (var _n319 = 0; _n319 < e.animations.length; ++_n319) {
        this.processAnimation(e.animations[_n319], t[0]);
      }

      this._invokeAll(function (e) {
        e.afterParse && e.afterParse(t);
      });
    }
  }, {
    key: "_invokeAll",
    value: function _invokeAll(t) {
      for (var _e365 = 0, n = this.plugins.length; _e365 < n; _e365++) {
        t(this.plugins[_e365]);
      }
    }
  }]);

  return sy;
}();

var ay = /*#__PURE__*/function () {
  function ay(t) {
    _classCallCheck(this, ay);

    this.writer = t, this.name = "KHR_lights_punctual";
  }

  _createClass(ay, [{
    key: "writeNode",
    value: function writeNode(t, e) {
      if (!t.isLight) return;
      if (!t.isDirectionalLight && !t.isPointLight && !t.isSpotLight) return void console.warn("THREE.GLTFExporter: Only directional, point, and spot lights are supported.", t);
      var n = this.writer,
          i = n.json,
          r = n.extensionsUsed,
          s = {};
      t.name && (s.name = t.name), s.color = t.color.toArray(), s.intensity = t.intensity, t.isDirectionalLight ? s.type = "directional" : t.isPointLight ? (s.type = "point", t.distance > 0 && (s.range = t.distance)) : t.isSpotLight && (s.type = "spot", t.distance > 0 && (s.range = t.distance), s.spot = {}, s.spot.innerConeAngle = (t.penumbra - 1) * t.angle * -1, s.spot.outerConeAngle = t.angle), void 0 !== t.decay && 2 !== t.decay && console.warn("THREE.GLTFExporter: Light decay may be lost. glTF is physically-based, and expects light.decay=2."), !t.target || t.target.parent === t && 0 === t.target.position.x && 0 === t.target.position.y && -1 === t.target.position.z || console.warn("THREE.GLTFExporter: Light direction may be lost. For best results, make light.target a child of the light with position 0,0,-1."), r[this.name] || (i.extensions = i.extensions || {}, i.extensions[this.name] = {
        lights: []
      }, r[this.name] = !0);
      var a = i.extensions[this.name].lights;
      a.push(s), e.extensions = e.extensions || {}, e.extensions[this.name] = {
        light: a.length - 1
      };
    }
  }]);

  return ay;
}();

var oy = /*#__PURE__*/function () {
  function oy(t) {
    _classCallCheck(this, oy);

    this.writer = t, this.name = "KHR_materials_unlit";
  }

  _createClass(oy, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isMeshBasicMaterial) return;
      var n = this.writer.extensionsUsed;
      e.extensions = e.extensions || {}, e.extensions[this.name] = {}, n[this.name] = !0, e.pbrMetallicRoughness.metallicFactor = 0, e.pbrMetallicRoughness.roughnessFactor = .9;
    }
  }]);

  return oy;
}();

var ly = /*#__PURE__*/function () {
  function ly(t) {
    _classCallCheck(this, ly);

    this.writer = t, this.name = "KHR_materials_pbrSpecularGlossiness";
  }

  _createClass(ly, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isGLTFSpecularGlossinessMaterial) return;
      var n = this.writer,
          i = n.extensionsUsed,
          r = {};
      e.pbrMetallicRoughness.baseColorFactor && (r.diffuseFactor = e.pbrMetallicRoughness.baseColorFactor);
      var s = [1, 1, 1];

      if (t.specular.toArray(s, 0), r.specularFactor = s, r.glossinessFactor = t.glossiness, e.pbrMetallicRoughness.baseColorTexture && (r.diffuseTexture = e.pbrMetallicRoughness.baseColorTexture), t.specularMap) {
        var _e366 = {
          index: n.processTexture(t.specularMap)
        };
        n.applyTextureTransform(_e366, t.specularMap), r.specularGlossinessTexture = _e366;
      }

      e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
  }]);

  return ly;
}();

var hy = /*#__PURE__*/function () {
  function hy(t) {
    _classCallCheck(this, hy);

    this.writer = t, this.name = "KHR_materials_clearcoat";
  }

  _createClass(hy, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isMeshPhysicalMaterial) return;
      var n = this.writer,
          i = n.extensionsUsed,
          r = {};

      if (r.clearcoatFactor = t.clearcoat, t.clearcoatMap) {
        var _e367 = {
          index: n.processTexture(t.clearcoatMap)
        };
        n.applyTextureTransform(_e367, t.clearcoatMap), r.clearcoatTexture = _e367;
      }

      if (r.clearcoatRoughnessFactor = t.clearcoatRoughness, t.clearcoatRoughnessMap) {
        var _e368 = {
          index: n.processTexture(t.clearcoatRoughnessMap)
        };
        n.applyTextureTransform(_e368, t.clearcoatRoughnessMap), r.clearcoatRoughnessTexture = _e368;
      }

      if (t.clearcoatNormalMap) {
        var _e369 = {
          index: n.processTexture(t.clearcoatNormalMap)
        };
        n.applyTextureTransform(_e369, t.clearcoatNormalMap), r.clearcoatNormalTexture = _e369;
      }

      e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
  }]);

  return hy;
}();

var cy = /*#__PURE__*/function () {
  function cy(t) {
    _classCallCheck(this, cy);

    this.writer = t, this.name = "KHR_materials_transmission";
  }

  _createClass(cy, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isMeshPhysicalMaterial || 0 === t.transmission) return;
      var n = this.writer,
          i = n.extensionsUsed,
          r = {};

      if (r.transmissionFactor = t.transmission, t.transmissionMap) {
        var _e370 = {
          index: n.processTexture(t.transmissionMap)
        };
        n.applyTextureTransform(_e370, t.transmissionMap), r.transmissionTexture = _e370;
      }

      e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
  }]);

  return cy;
}();

var uy = /*#__PURE__*/function () {
  function uy(t) {
    _classCallCheck(this, uy);

    this.writer = t, this.name = "KHR_materials_volume";
  }

  _createClass(uy, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isMeshPhysicalMaterial || 0 === t.transmission) return;
      var n = this.writer,
          i = n.extensionsUsed,
          r = {};

      if (r.thicknessFactor = t.thickness, t.thicknessMap) {
        var _e371 = {
          index: n.processTexture(t.thicknessMap)
        };
        n.applyTextureTransform(_e371, t.thicknessMap), r.thicknessTexture = _e371;
      }

      r.attenuationDistance = t.attenuationDistance, r.attenuationColor = t.attenuationColor.toArray(), e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
  }]);

  return uy;
}();

Dv.Utils = {
  insertKeyframe: function insertKeyframe(t, e) {
    var n = .001,
        i = t.getValueSize(),
        r = new t.TimeBufferType(t.times.length + 1),
        s = new t.ValueBufferType(t.values.length + i),
        a = t.createInterpolant(new t.ValueBufferType(i));
    var o;

    if (0 === t.times.length) {
      r[0] = e;

      for (var _t446 = 0; _t446 < i; _t446++) {
        s[_t446] = 0;
      }

      o = 0;
    } else if (e < t.times[0]) {
      if (Math.abs(t.times[0] - e) < n) return 0;
      r[0] = e, r.set(t.times, 1), s.set(a.evaluate(e), 0), s.set(t.values, i), o = 0;
    } else if (e > t.times[t.times.length - 1]) {
      if (Math.abs(t.times[t.times.length - 1] - e) < n) return t.times.length - 1;
      r[r.length - 1] = e, r.set(t.times, 0), s.set(t.values, 0), s.set(a.evaluate(e), t.values.length), o = r.length - 1;
    } else for (var _l48 = 0; _l48 < t.times.length; _l48++) {
      if (Math.abs(t.times[_l48] - e) < n) return _l48;

      if (t.times[_l48] < e && t.times[_l48 + 1] > e) {
        r.set(t.times.slice(0, _l48 + 1), 0), r[_l48 + 1] = e, r.set(t.times.slice(_l48 + 1), _l48 + 2), s.set(t.values.slice(0, (_l48 + 1) * i), 0), s.set(a.evaluate(e), (_l48 + 1) * i), s.set(t.values.slice((_l48 + 1) * i), (_l48 + 2) * i), o = _l48 + 1;
        break;
      }
    }

    return t.times = r, t.values = s, o;
  },
  mergeMorphTargetTracks: function mergeMorphTargetTracks(t, e) {
    var n = [],
        i = {},
        r = t.tracks;

    for (var _t447 = 0; _t447 < r.length; ++_t447) {
      var _s99 = r[_t447];

      var _a78 = Wl.parseTrackName(_s99.name),
          _o49 = Wl.findNode(e, _a78.nodeName);

      if ("morphTargetInfluences" !== _a78.propertyName || void 0 === _a78.propertyIndex) {
        n.push(_s99);
        continue;
      }

      if (_s99.createInterpolant !== _s99.InterpolantFactoryMethodDiscrete && _s99.createInterpolant !== _s99.InterpolantFactoryMethodLinear) {
        if (_s99.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) throw new Error("THREE.GLTFExporter: Cannot merge tracks with glTF CUBICSPLINE interpolation.");
        console.warn("THREE.GLTFExporter: Morph target interpolation mode not yet supported. Using LINEAR instead."), _s99 = _s99.clone(), _s99.setInterpolation(2301);
      }

      var _l49 = _o49.morphTargetInfluences.length,
          _h34 = _o49.morphTargetDictionary[_a78.propertyIndex];
      if (void 0 === _h34) throw new Error("THREE.GLTFExporter: Morph target name not found: " + _a78.propertyIndex);

      var _c26 = void 0;

      if (void 0 === i[_o49.uuid]) {
        _c26 = _s99.clone();

        var _t448 = new _c26.ValueBufferType(_l49 * _c26.times.length);

        for (var _e372 = 0; _e372 < _c26.times.length; _e372++) {
          _t448[_e372 * _l49 + _h34] = _c26.values[_e372];
        }

        _c26.name = (_a78.nodeName || "") + ".morphTargetInfluences", _c26.values = _t448, i[_o49.uuid] = _c26, n.push(_c26);
        continue;
      }

      var _u20 = _s99.createInterpolant(new _s99.ValueBufferType(1));

      _c26 = i[_o49.uuid];

      for (var _t449 = 0; _t449 < _c26.times.length; _t449++) {
        _c26.values[_t449 * _l49 + _h34] = _u20.evaluate(_c26.times[_t449]);
      }

      for (var _t450 = 0; _t450 < _s99.times.length; _t450++) {
        var _e373 = this.insertKeyframe(_c26, _s99.times[_t450]);

        _c26.values[_e373 * _l49 + _h34] = _s99.values[_t450];
      }
    }

    return t.tracks = n, t;
  }
};
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var dy = function dy(t) {
  return void 0 !== t.material && t.userData && t.userData.variantMaterials && !!Array.from(t.userData.variantMaterials.values()).filter(function (t) {
    return py(t.material);
  });
},
    py = function py(t) {
  return t && t.isMaterial && !Array.isArray(t);
};

var my = /*#__PURE__*/function () {
  function my(t) {
    _classCallCheck(this, my);

    this.writer = t, this.name = "KHR_materials_variants", this.variantNames = [];
  }

  _createClass(my, [{
    key: "beforeParse",
    value: function beforeParse(t) {
      var _this155 = this;

      var e = new Set();

      var _iterator41 = _createForOfIteratorHelper(t),
          _step41;

      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var n = _step41.value;
          n.traverse(function (t) {
            if (!dy(t)) return;
            var n = t.userData.variantMaterials,
                i = t.userData.variantData;

            var _iterator42 = _createForOfIteratorHelper(i),
                _step42;

            try {
              for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                var _step42$value = _slicedToArray(_step42.value, 2),
                    _t451 = _step42$value[0],
                    _r177 = _step42$value[1];

                var _i267 = n.get(_r177.index);

                py(_i267.material) && e.add(_t451);
              }
            } catch (err) {
              _iterator42.e(err);
            } finally {
              _iterator42.f();
            }
          });
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }

      e.forEach(function (t) {
        return _this155.variantNames.push(t);
      });
    }
  }, {
    key: "writeMesh",
    value: function writeMesh(t, e) {
      if (!dy(t)) return;
      var n = t.userData,
          i = n.variantMaterials,
          r = n.variantData,
          s = new Map(),
          a = new Map(),
          o = Array.from(r.values()).sort(function (t, e) {
        return t.index - e.index;
      });

      var _iterator43 = _createForOfIteratorHelper(o.entries()),
          _step43;

      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var _step43$value = _slicedToArray(_step43.value, 2),
              _t452 = _step43$value[0],
              _e374 = _step43$value[1];

          a.set(_e374.index, _t452);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }

      var _iterator44 = _createForOfIteratorHelper(r.values()),
          _step44;

      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var _t453 = _step44.value;
          var _e375 = i.get(_t453.index).material;
          if (!py(_e375)) continue;

          var _n320 = this.writer.processMaterial(_e375);

          s.has(_n320) || s.set(_n320, {
            material: _n320,
            variants: []
          }), s.get(_n320).variants.push(a.get(_t453.index));
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }

      var l = Array.from(s.values()).map(function (t) {
        return t.variants.sort(function (t, e) {
          return t - e;
        }) && t;
      }).sort(function (t, e) {
        return t.material - e.material;
      });
      if (0 === l.length) return;
      var h = py(n.originalMaterial) ? this.writer.processMaterial(n.originalMaterial) : -1;

      var _iterator45 = _createForOfIteratorHelper(e.primitives),
          _step45;

      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var _t454 = _step45.value;
          h >= 0 && (_t454.material = h), _t454.extensions = _t454.extensions || {}, _t454.extensions[this.name] = {
            mappings: l
          };
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
    }
  }, {
    key: "afterParse",
    value: function afterParse() {
      if (0 === this.variantNames.length) return;
      var t = this.writer.json;
      t.extensions = t.extensions || {};
      var e = this.variantNames.map(function (t) {
        return {
          name: t
        };
      });
      t.extensions[this.name] = {
        variants: e
      }, this.writer.extensionsUsed[this.name] = !0;
    }
  }]);

  return my;
}();
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var fy = Symbol("correlatedObjects"),
    gy = Symbol("sourceObject"),
    vy = Symbol("onUpdate");

var yy = function yy(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  _classCallCheck(this, yy);

  this[vy] = t, this[gy] = e, this[fy] = n;
};
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var xy = new cl(),
    _y = new nn(),
    by = new ni(2, 2);

var wy = 0;
var My = Symbol("threeTexture");

var Sy = /*#__PURE__*/function (_yy) {
  _inherits(Sy, _yy);

  var _super144 = _createSuper(Sy);

  function Sy(t, e, n) {
    _classCallCheck(this, Sy);

    return _super144.call(this, t, n = null != n ? n : {
      name: e && e.image && e.image.src ? e.image.src.split("/").pop() : "adhoc_image",
      uri: e && e.image && e.image.src ? e.image.src : "adhoc_image" + wy++
    }, new Set(e ? [e] : []));
  }

  _createClass(Sy, [{
    key: My,
    get: function get() {
      var t;
      return console.assert(null != this[fy] && this[fy].size > 0, "Image correlated object is undefined"), null === (t = this[fy]) || void 0 === t ? void 0 : t.values().next().value;
    }
  }, {
    key: "name",
    get: function get() {
      return this[gy].name || "";
    }
  }, {
    key: "uri",
    get: function get() {
      return this[gy].uri;
    }
  }, {
    key: "bufferView",
    get: function get() {
      return this[gy].bufferView;
    }
  }, {
    key: "type",
    get: function get() {
      return null != this.uri ? "external" : "embedded";
    }
  }, {
    key: "name",
    set: function set(t) {
      this[gy].name = t;
    }
  }, {
    key: "setURI",
    value: function () {
      var _setURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(t) {
        var e, n;
        return _regeneratorRuntime.wrap(function _callee29$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                this[gy].uri = t, this[gy].name = t.split("/").pop();
                _context33.next = 3;
                return new Promise(function (e, n) {
                  xy.load(t, e, void 0, n);
                });

              case 3:
                e = _context33.sent;
                n = this[My];
                n.image = e, n.needsUpdate = !0, this[vy]();

              case 6:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee29, this);
      }));

      function setURI(_x30) {
        return _setURI.apply(this, arguments);
      }

      return setURI;
    }()
  }, {
    key: "createThumbnail",
    value: function () {
      var _createThumbnail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(t, e) {
        var n, i, r, s, a, o, l, h;
        return _regeneratorRuntime.wrap(function _callee31$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                n = new Is();
                _y.map = this[My];
                i = new Nn(by, _y);
                n.add(i);
                r = new di(-1, 1, 1, -1, 0, 1), s = Fd.singleton.threeRenderer, a = new Ft(t, e);
                s.setRenderTarget(a), s.render(n, r), s.setRenderTarget(null);
                o = new Uint8Array(t * e * 4);
                s.readRenderTargetPixels(a, 0, 0, t, e, o), $d.width = t, $d.height = e;
                l = $d.getContext("2d"), h = l.createImageData(t, e);
                return _context35.abrupt("return", (h.data.set(o), l.putImageData(h, 0, 0), new Promise( /*#__PURE__*/function () {
                  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(t, e) {
                    return _regeneratorRuntime.wrap(function _callee30$(_context34) {
                      while (1) {
                        switch (_context34.prev = _context34.next) {
                          case 0:
                            $d.toBlob(function (n) {
                              if (!n) return e("Failed to capture thumbnail.");
                              t(URL.createObjectURL(n));
                            }, "image/png");

                          case 1:
                          case "end":
                            return _context34.stop();
                        }
                      }
                    }, _callee30);
                  }));

                  return function (_x33, _x34) {
                    return _ref26.apply(this, arguments);
                  };
                }())));

              case 10:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee31, this);
      }));

      function createThumbnail(_x31, _x32) {
        return _createThumbnail.apply(this, arguments);
      }

      return createThumbnail;
    }()
  }]);

  return Sy;
}(yy);

var Ty, Ey;
!function (t) {
  t[t.Nearest = 9728] = "Nearest", t[t.Linear = 9729] = "Linear", t[t.NearestMipmapNearest = 9984] = "NearestMipmapNearest", t[t.LinearMipmapNearest = 9985] = "LinearMipmapNearest", t[t.NearestMipmapLinear = 9986] = "NearestMipmapLinear", t[t.LinearMipmapLinear = 9987] = "LinearMipmapLinear";
}(Ty || (Ty = {})), function (t) {
  t[t.ClampToEdge = 33071] = "ClampToEdge", t[t.MirroredRepeat = 33648] = "MirroredRepeat", t[t.Repeat = 10497] = "Repeat";
}(Ey || (Ey = {}));
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Ay = function () {
  var t = [Ty.Nearest, Ty.Linear, Ty.NearestMipmapNearest, Ty.LinearMipmapLinear, Ty.NearestMipmapLinear, Ty.LinearMipmapLinear];
  return function (e) {
    return t.indexOf(e) > -1;
  };
}(),
    Ry = function () {
  var t = [Ty.Nearest, Ty.Linear];
  return function (e) {
    return t.indexOf(e) > -1;
  };
}(),
    Cy = function () {
  var t = [Ey.ClampToEdge, Ey.MirroredRepeat, Ey.Repeat];
  return function (e) {
    return t.indexOf(e) > -1;
  };
}(),
    Ly = Symbol("threeTextures"),
    Py = Symbol("setProperty"),
    Dy = Symbol("sourceSampler");

var Iy = /*#__PURE__*/function (_yy2) {
  _inherits(Iy, _yy2);

  var _super145 = _createSuper(Iy);

  function Iy(t, e, n) {
    var _this156;

    _classCallCheck(this, Iy);

    null == (n = null != n ? n : {}).minFilter && (n.minFilter = e ? e.minFilter : Ty.LinearMipmapLinear), null == n.magFilter && (n.magFilter = e ? e.magFilter : Ty.Linear), null == n.wrapS && (n.wrapS = e ? e.wrapS : Ey.Repeat), null == n.wrapT && (n.wrapT = e ? e.wrapT : Ey.Repeat), _this156 = _super145.call(this, t, n, new Set(e ? [e] : []));
    return _this156;
  }

  _createClass(Iy, [{
    key: Ly,
    get: function get() {
      return console.assert(null != this[fy] && this[fy].size > 0, "Sampler correlated object is undefined"), this[fy];
    }
  }, {
    key: Dy,
    get: function get() {
      return console.assert(null != this[gy], "Sampler source is undefined"), this[gy];
    }
  }, {
    key: "name",
    get: function get() {
      return this[gy].name || "";
    }
  }, {
    key: "minFilter",
    get: function get() {
      return this[Dy].minFilter;
    }
  }, {
    key: "magFilter",
    get: function get() {
      return this[Dy].magFilter;
    }
  }, {
    key: "wrapS",
    get: function get() {
      return this[Dy].wrapS;
    }
  }, {
    key: "wrapT",
    get: function get() {
      return this[Dy].wrapT;
    }
  }, {
    key: "setMinFilter",
    value: function setMinFilter(t) {
      this[Py]("minFilter", t);
    }
  }, {
    key: "setMagFilter",
    value: function setMagFilter(t) {
      this[Py]("magFilter", t);
    }
  }, {
    key: "setWrapS",
    value: function setWrapS(t) {
      this[Py]("wrapS", t);
    }
  }, {
    key: "setWrapT",
    value: function setWrapT(t) {
      this[Py]("wrapT", t);
    }
  }, {
    key: Py,
    value: function value(t, e) {
      var n = this[Dy];

      if (null != n) {
        if (function (t, e) {
          switch (t) {
            case "minFilter":
              return Ay(e);

            case "magFilter":
              return Ry(e);

            case "wrapS":
            case "wrapT":
              return Cy(e);

            default:
              throw new Error("Cannot configure property \"".concat(t, "\" on Sampler"));
          }
        }(t, e)) {
          n[t] = e;

          var _iterator46 = _createForOfIteratorHelper(this[Ly]),
              _step46;

          try {
            for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
              var _n321 = _step46.value;
              _n321[t] = e, _n321.needsUpdate = !0;
            }
          } catch (err) {
            _iterator46.e(err);
          } finally {
            _iterator46.f();
          }
        }

        this[vy]();
      }
    }
  }]);

  return Iy;
}(yy);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Oy = Symbol("image"),
    Ny = Symbol("sampler");

var Fy = /*#__PURE__*/function (_yy3) {
  _inherits(Fy, _yy3);

  var _super146 = _createSuper(Fy);

  function Fy(t, e) {
    var _this157;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    _classCallCheck(this, Fy);

    _this157 = _super146.call(this, t, n || {}, new Set(e ? [e] : [])), _this157[Ny] = new Iy(t, e, i), _this157[Oy] = new Sy(t, e, r);
    return _this157;
  }

  _createClass(Fy, [{
    key: "name",
    get: function get() {
      return this[gy].name || "";
    },
    set: function set(t) {
      this[gy].name = t;
    }
  }, {
    key: "sampler",
    get: function get() {
      return this[Ny];
    }
  }, {
    key: "source",
    get: function get() {
      return this[Oy];
    }
  }]);

  return Fy;
}(yy);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Uy, ky;
var By = Symbol("texture"),
    zy = Symbol("transform"),
    Hy = Symbol("materials"),
    Vy = Symbol("usage");
var Gy;
!function (t) {
  t[t.Base = 0] = "Base", t[t.MetallicRoughness = 1] = "MetallicRoughness", t[t.Normal = 2] = "Normal", t[t.Occlusion = 3] = "Occlusion", t[t.Emissive = 4] = "Emissive";
}(Gy || (Gy = {}));

var Wy = /*#__PURE__*/function () {
  function Wy(t, e, n, i, r, s) {
    _classCallCheck(this, Wy);

    if (this[Uy] = null, this[ky] = {
      rotation: 0,
      scale: new mt(1, 1),
      offset: new mt(0, 0)
    }, s && n) {
      var _e376 = r.textures ? r.textures[s.index] : null,
          _i268 = _e376 && r.samplers ? r.samplers[_e376.sampler] : null,
          _a79 = _e376 && r.images ? r.images[_e376.source] : null;

      this[zy].rotation = n.rotation, this[zy].scale.copy(n.repeat), this[zy].offset.copy(n.offset), this[By] = new Fy(t, n, _e376, _i268, _a79);
    }

    this.onUpdate = t, this[Hy] = i, this[Vy] = e;
  }

  _createClass(Wy, [{
    key: "texture",
    get: function get() {
      return this[By];
    }
  }, {
    key: "setTexture",
    value: function setTexture(t) {
      var e = null != t ? t.source[My] : null;
      var n = 3001;

      if (this[By] = t, this[Hy]) {
        var _iterator47 = _createForOfIteratorHelper(this[Hy]),
            _step47;

        try {
          for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
            var _t455 = _step47.value;

            switch (this[Vy]) {
              case Gy.Base:
                _t455.map = e;
                break;

              case Gy.MetallicRoughness:
                n = 3e3, _t455.metalnessMap = e, _t455.roughnessMap = e;
                break;

              case Gy.Normal:
                n = 3e3, _t455.normalMap = e;
                break;

              case Gy.Occlusion:
                n = 3e3, _t455.aoMap = e;
                break;

              case Gy.Emissive:
                _t455.emissiveMap = e;
            }

            _t455.needsUpdate = !0;
          }
        } catch (err) {
          _iterator47.e(err);
        } finally {
          _iterator47.f();
        }
      }

      e && (e.encoding = n, e.rotation = this[zy].rotation, e.repeat = this[zy].scale, e.offset = this[zy].offset), this.onUpdate();
    }
  }]);

  return Wy;
}();

Uy = By, ky = zy;
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var jy = Symbol("threeMaterials"),
    qy = Symbol("baseColorTexture"),
    Xy = Symbol("metallicRoughnessTexture");

var Yy = /*#__PURE__*/function (_yy4) {
  _inherits(Yy, _yy4);

  var _super147 = _createSuper(Yy);

  function Yy(t, e, n, i) {
    var _this158;

    _classCallCheck(this, Yy);

    _this158 = _super147.call(this, t, n, i), null == n.baseColorFactor && (n.baseColorFactor = [1, 1, 1, 1]), null == n.roughnessFactor && (n.roughnessFactor = 1), null == n.metallicFactor && (n.metallicFactor = 1);
    var r = n.baseColorTexture,
        s = n.metallicRoughnessTexture,
        _i$values$next$value = i.values().next().value,
        a = _i$values$next$value.map,
        o = _i$values$next$value.metalnessMap;
    _this158[qy] = new Wy(t, Gy.Base, a, i, e, r || null), _this158[Xy] = new Wy(t, Gy.MetallicRoughness, o, i, e, s || null);
    return _this158;
  }

  _createClass(Yy, [{
    key: jy,
    get: function get() {
      return this[fy];
    }
  }, {
    key: "baseColorFactor",
    get: function get() {
      return this[gy].baseColorFactor;
    }
  }, {
    key: "metallicFactor",
    get: function get() {
      return this[gy].metallicFactor;
    }
  }, {
    key: "roughnessFactor",
    get: function get() {
      return this[gy].roughnessFactor;
    }
  }, {
    key: "baseColorTexture",
    get: function get() {
      return this[qy];
    }
  }, {
    key: "metallicRoughnessTexture",
    get: function get() {
      return this[Xy];
    }
  }, {
    key: "setBaseColorFactor",
    value: function setBaseColorFactor(t) {
      var _iterator48 = _createForOfIteratorHelper(this[jy]),
          _step48;

      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var _e377 = _step48.value;
          _e377.color.fromArray(t), _e377.opacity = t[3];
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }

      this[gy].baseColorFactor = t, this[vy]();
    }
  }, {
    key: "setMetallicFactor",
    value: function setMetallicFactor(t) {
      var _iterator49 = _createForOfIteratorHelper(this[jy]),
          _step49;

      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var _e378 = _step49.value;
          _e378.metalness = t;
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }

      this[gy].metallicFactor = t, this[vy]();
    }
  }, {
    key: "setRoughnessFactor",
    value: function setRoughnessFactor(t) {
      var _iterator50 = _createForOfIteratorHelper(this[jy]),
          _step50;

      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var _e379 = _step50.value;
          _e379.roughness = t;
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }

      this[gy].roughnessFactor = t, this[vy]();
    }
  }]);

  return Yy;
}(yy);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Jy;
var Zy = Symbol("pbrMetallicRoughness"),
    $y = Symbol("normalTexture"),
    Ky = Symbol("occlusionTexture"),
    Qy = Symbol("emissiveTexture"),
    tx = Symbol("backingThreeMaterial"),
    ex = Symbol("applyAlphaCutoff"),
    nx = Symbol("lazyLoadGLTFInfo"),
    ix = Symbol("initialize"),
    rx = Symbol("getLoadedMaterial"),
    sx = Symbol("ensureMaterialIsLoaded"),
    ax = Symbol("gltfIndex"),
    ox = Symbol("setActive"),
    lx = Symbol("variantIndices"),
    hx = Symbol("isActive"),
    cx = Symbol("variantSet"),
    ux = Symbol("modelVariants");

var dx = /*#__PURE__*/function (_yy5, _ref27) {
  _inherits(dx, _yy5);

  var _super148 = _createSuper(dx);

  function dx(t, e, n, i, r, s, a, o) {
    var _this159;

    _classCallCheck(this, dx);

    _this159 = _super148.call(this, t, n, a), _this159[Jy] = new Set(), _this159[ax] = i, _this159[hx] = r, _this159[ux] = s, null == o ? _this159[ix](e) : _this159[nx] = o;
    return _this159;
  }

  _createClass(dx, [{
    key: _ref27,
    get: function get() {
      return this[fy].values().next().value;
    }
  }, {
    key: ix,
    value: function value(t) {
      var e = this[vy],
          n = this[gy],
          i = this[fy];
      n.extensions && n.extensions.KHR_materials_pbrSpecularGlossiness && console.warn("Material ".concat(n.name, " uses a deprecated extension\n          \"KHR_materials_pbrSpecularGlossiness\", please use\n          \"pbrMetallicRoughness\" instead. Specular Glossiness materials are\n          currently supported for rendering, but not for our scene-graph API,\n          nor for auto-generation of USDZ for Quick Look.")), null == n.pbrMetallicRoughness && (n.pbrMetallicRoughness = {}), this[Zy] = new Yy(e, t, n.pbrMetallicRoughness, i), null == n.emissiveFactor && (n.emissiveFactor = [0, 0, 0]), null == n.doubleSided && (n.doubleSided = !1), null == n.alphaMode && (n.alphaMode = "OPAQUE"), null == n.alphaCutoff && (n.alphaCutoff = .5);
      var r = n.normalTexture,
          s = n.occlusionTexture,
          a = n.emissiveTexture,
          _i$values$next$value2 = i.values().next().value,
          o = _i$values$next$value2.normalMap,
          l = _i$values$next$value2.aoMap,
          h = _i$values$next$value2.emissiveMap;
      this[$y] = new Wy(e, Gy.Normal, o, i, t, r || null), this[Ky] = new Wy(e, Gy.Occlusion, l, i, t, s || null), this[Qy] = new Wy(e, Gy.Emissive, h, i, t, a || null);
    }
  }, {
    key: rx,
    value: function () {
      var _value2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        var _yield$this$nx$doLazy, _t456, _e380;

        return _regeneratorRuntime.wrap(function _callee33$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if (!(null != this[nx])) {
                  _context37.next = 7;
                  break;
                }

                _context37.next = 3;
                return this[nx].doLazyLoad();

              case 3:
                _yield$this$nx$doLazy = _context37.sent;
                _t456 = _yield$this$nx$doLazy.set;
                _e380 = _yield$this$nx$doLazy.material;
                return _context37.abrupt("return", (this[fy] = _t456, this[ix](this[nx].gltf), this[nx] = void 0, this.ensureLoaded = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
                  return _regeneratorRuntime.wrap(function _callee32$(_context36) {
                    while (1) {
                      switch (_context36.prev = _context36.next) {
                        case 0:
                        case "end":
                          return _context36.stop();
                      }
                    }
                  }, _callee32);
                })), _e380));

              case 7:
                return _context37.abrupt("return", this[fy].values().next().value);

              case 8:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee33, this);
      }));

      function value() {
        return _value2.apply(this, arguments);
      }

      return value;
    }()
  }, {
    key: sx,
    value: function value() {
      if (null != this[nx]) throw new Error("Material \"".concat(this.name, "\" has not been loaded, call 'await\n    myMaterial.ensureLoaded()' before using an unloaded material."));
    }
  }, {
    key: "ensureLoaded",
    value: function () {
      var _ensureLoaded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this[rx]();

              case 2:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee34, this);
      }));

      function ensureLoaded() {
        return _ensureLoaded.apply(this, arguments);
      }

      return ensureLoaded;
    }()
  }, {
    key: "isLoaded",
    get: function get() {
      return null == this[nx];
    }
  }, {
    key: "isActive",
    get: function get() {
      return this[hx];
    }
  }, {
    key: ox,
    value: function value(t) {
      this[hx] = t;
    }
  }, {
    key: "name",
    get: function get() {
      return this[gy].name;
    }
  }, {
    key: "name",
    set: function set(t) {
      var e = this[gy];

      if (null != e && (e.name = t), null != this[fy]) {
        var _iterator51 = _createForOfIteratorHelper(this[fy]),
            _step51;

        try {
          for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
            var _e381 = _step51.value;
            _e381.name = t;
          }
        } catch (err) {
          _iterator51.e(err);
        } finally {
          _iterator51.f();
        }
      }
    }
  }, {
    key: "pbrMetallicRoughness",
    get: function get() {
      return this[sx](), this[Zy];
    }
  }, {
    key: "normalTexture",
    get: function get() {
      return this[sx](), this[$y];
    }
  }, {
    key: "occlusionTexture",
    get: function get() {
      return this[sx](), this[Ky];
    }
  }, {
    key: "emissiveTexture",
    get: function get() {
      return this[sx](), this[Qy];
    }
  }, {
    key: "emissiveFactor",
    get: function get() {
      return this[sx](), this[gy].emissiveFactor;
    }
  }, {
    key: "index",
    get: function get() {
      return this[ax];
    }
  }, {
    key: lx,
    value: function value() {
      return this[cx];
    }
  }, {
    key: "hasVariant",
    value: function hasVariant(t) {
      var e = this[ux].get(t);
      return null != e && this[cx].has(e.index);
    }
  }, {
    key: "setEmissiveFactor",
    value: function setEmissiveFactor(t) {
      this[sx]();

      var _iterator52 = _createForOfIteratorHelper(this[fy]),
          _step52;

      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var _e382 = _step52.value;

          _e382.emissive.fromArray(t);
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }

      this[gy].emissiveFactor = t, this[vy]();
    }
  }, {
    key: ex,
    value: function value() {
      this[sx]();
      var t = this[gy];

      var _iterator53 = _createForOfIteratorHelper(this[fy]),
          _step53;

      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _e383 = _step53.value;
          "MASK" === this[gy].alphaMode ? _e383.alphaTest = t.alphaCutoff : _e383.alphaTest = void 0, _e383.needsUpdate = !0;
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }
  }, {
    key: "setAlphaCutoff",
    value: function setAlphaCutoff(t) {
      this[sx](), this[gy].alphaCutoff = t, this[ex](), this[vy]();
    }
  }, {
    key: "getAlphaCutoff",
    value: function getAlphaCutoff() {
      return this[sx](), this[gy].alphaCutoff;
    }
  }, {
    key: "setDoubleSided",
    value: function setDoubleSided(t) {
      this[sx]();

      var _iterator54 = _createForOfIteratorHelper(this[fy]),
          _step54;

      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var _e384 = _step54.value;
          _e384.side = t ? 2 : 0, _e384.needsUpdate = !0;
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }

      this[gy].doubleSided = t, this[vy]();
    }
  }, {
    key: "getDoubleSided",
    value: function getDoubleSided() {
      return this[sx](), this[gy].doubleSided;
    }
  }, {
    key: "setAlphaMode",
    value: function setAlphaMode(t) {
      this[sx]();

      var e = function e(t, _e385) {
        t.transparent = _e385, t.depthWrite = !_e385;
      };

      this[gy].alphaMode = t;

      var _iterator55 = _createForOfIteratorHelper(this[fy]),
          _step55;

      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var n = _step55.value;
          e(n, "BLEND" === t), this[ex](), n.needsUpdate = !0;
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }

      this[vy]();
    }
  }, {
    key: "getAlphaMode",
    value: function getAlphaMode() {
      return this[sx](), this[gy].alphaMode;
    }
  }]);

  return dx;
}(yy, (Jy = cx, tx));

var px, mx, fx;

var gx = Symbol("materials"),
    vx = Symbol("variantToMaterialMap"),
    yx = Symbol("modelVariants"),
    xx = Symbol("mesh"),
    _x = Symbol("children"),
    bx = Symbol("initialMaterialIdx"),
    wx = Symbol("activeMaterialIdx");

var Mx = function Mx(t) {
  _classCallCheck(this, Mx);

  this.name = "", this[px] = new Array(), this.name = t;
};

px = _x;

var Sx = /*#__PURE__*/function (_Mx) {
  _inherits(Sx, _Mx);

  var _super149 = _createSuper(Sx);

  function Sx(t, e, n, i) {
    var _this160;

    _classCallCheck(this, Sx);

    _this160 = _super149.call(this, t.name), _this160[mx] = new Map(), _this160[fx] = new Map(), _this160[xx] = t;
    var r = i.gltf,
        s = i.threeGLTF,
        a = i.threeObjectMap;
    _this160[yx] = n, _this160.mesh.userData.variantData = n;
    var o = a.get(t.material);
    null != o.materials ? _this160[bx] = _this160[wx] = o.materials : console.error("Primitive (".concat(t.name, ") missing initial material reference."));
    var l = t.userData.associations || {};
    if (null == l.meshes) return _possibleConstructorReturn(_this160, void console.error("Mesh is missing primitive index association"));
    var h = ((r.meshes || [])[l.meshes].primitives || [])[l.primitives];

    if (null != h) {
      if (null != h.material) _this160[gx].set(h.material, e[h.material]);else {
        var _t457 = e.findIndex(function (t) {
          return "Default" === t.name;
        });

        _t457 >= 0 ? _this160[gx].set(_t457, e[_t457]) : console.warn("gltfPrimitive has no material!");
      }

      if (h.extensions && h.extensions.KHR_materials_variants) {
        var _t458 = h.extensions.KHR_materials_variants,
            _i269 = s.parser.json.extensions.KHR_materials_variants.variants;

        var _iterator56 = _createForOfIteratorHelper(_t458.mappings),
            _step56;

        try {
          for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
            var _r178 = _step56.value;
            var _t459 = e[_r178.material];

            _this160[gx].set(_r178.material, _t459);

            var _iterator57 = _createForOfIteratorHelper(_r178.variants),
                _step57;

            try {
              for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
                var _e386 = _step57.value;
                var _r179 = _i269[_e386].name;
                _this160[vx].set(_e386, _t459), _t459[lx]().add(_e386), n.has(_r179) || n.set(_r179, {
                  name: _r179,
                  index: _e386
                });
              }
            } catch (err) {
              _iterator57.e(err);
            } finally {
              _iterator57.f();
            }
          }
        } catch (err) {
          _iterator56.e(err);
        } finally {
          _iterator56.f();
        }
      }
    } else console.error("Mesh primitive definition is missing.");

    return _this160;
  }

  _createClass(Sx, [{
    key: "mesh",
    get: function get() {
      return this[xx];
    }
  }, {
    key: "setActiveMaterial",
    value: function () {
      var _setActiveMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee35$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                e = this[gx].get(t);
                _context39.t0 = null != e;

                if (!_context39.t0) {
                  _context39.next = 7;
                  break;
                }

                _context39.next = 5;
                return e[rx]();

              case 5:
                this.mesh.material = _context39.sent;
                this[wx] = t;

              case 7:
                return _context39.abrupt("return", this.mesh.material);

              case 8:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee35, this);
      }));

      function setActiveMaterial(_x35) {
        return _setActiveMaterial.apply(this, arguments);
      }

      return setActiveMaterial;
    }()
  }, {
    key: "getActiveMaterial",
    value: function getActiveMaterial() {
      return this[gx].get(this[wx]);
    }
  }, {
    key: "getMaterial",
    value: function getMaterial(t) {
      return this[gx].get(t);
    }
  }, {
    key: "enableVariant",
    value: function () {
      var _enableVariant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(t) {
        var _e387;

        return _regeneratorRuntime.wrap(function _callee36$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (!(null == t)) {
                  _context40.next = 2;
                  break;
                }

                return _context40.abrupt("return", this.setActiveMaterial(this[bx]));

              case 2:
                if (!(null != this[vx] && this[yx].has(t))) {
                  _context40.next = 5;
                  break;
                }

                _e387 = this[yx].get(t);
                return _context40.abrupt("return", this.enableVariantHelper(_e387.index));

              case 5:
                return _context40.abrupt("return", null);

              case 6:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee36, this);
      }));

      function enableVariant(_x36) {
        return _enableVariant.apply(this, arguments);
      }

      return enableVariant;
    }()
  }, {
    key: "enableVariantHelper",
    value: function () {
      var _enableVariantHelper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(t) {
        var _e388;

        return _regeneratorRuntime.wrap(function _callee37$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (!(null != this[vx] && null != t)) {
                  _context41.next = 4;
                  break;
                }

                _e388 = this[vx].get(t);

                if (!(null != _e388)) {
                  _context41.next = 4;
                  break;
                }

                return _context41.abrupt("return", this.setActiveMaterial(_e388.index));

              case 4:
                return _context41.abrupt("return", null);

              case 5:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee37, this);
      }));

      function enableVariantHelper(_x37) {
        return _enableVariantHelper.apply(this, arguments);
      }

      return enableVariantHelper;
    }()
  }, {
    key: "instantiateVariants",
    value: function () {
      var _instantiateVariants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var _iterator58, _step58, _t460, _e389;

        return _regeneratorRuntime.wrap(function _callee38$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (!(null != this[vx])) {
                  _context42.next = 22;
                  break;
                }

                _iterator58 = _createForOfIteratorHelper(this[vx].keys());
                _context42.prev = 2;

                _iterator58.s();

              case 4:
                if ((_step58 = _iterator58.n()).done) {
                  _context42.next = 14;
                  break;
                }

                _t460 = _step58.value;

                if (!(null != this.mesh.userData.variantMaterials.get(_t460).material)) {
                  _context42.next = 8;
                  break;
                }

                return _context42.abrupt("continue", 12);

              case 8:
                _context42.next = 10;
                return this.enableVariantHelper(_t460);

              case 10:
                _e389 = _context42.sent;
                null != _e389 && (this.mesh.userData.variantMaterials.get(_t460).material = _e389);

              case 12:
                _context42.next = 4;
                break;

              case 14:
                _context42.next = 19;
                break;

              case 16:
                _context42.prev = 16;
                _context42.t0 = _context42["catch"](2);

                _iterator58.e(_context42.t0);

              case 19:
                _context42.prev = 19;

                _iterator58.f();

                return _context42.finish(19);

              case 22:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee38, this, [[2, 16, 19, 22]]);
      }));

      function instantiateVariants() {
        return _instantiateVariants.apply(this, arguments);
      }

      return instantiateVariants;
    }()
  }, {
    key: "variantInfo",
    get: function get() {
      return this[vx];
    }
  }, {
    key: "addVariant",
    value: function addVariant(t, e) {
      if (!this.ensureVariantIsUnused(e)) return !1;
      this[yx].has(e) || this[yx].set(e, {
        name: e,
        index: this[yx].size
      });
      var n = this[yx].get(e).index;
      return t[lx]().add(n), this[vx].set(n, t), this[gx].set(t.index, t), this.updateVariantUserData(n, t), !0;
    }
  }, {
    key: "deleteVariant",
    value: function deleteVariant(t) {
      if (this.variantInfo.has(t)) {
        this.variantInfo.delete(t);
        var _e390 = this.mesh.userData.variantMaterials;
        null != _e390 && _e390.delete(t);
      }
    }
  }, {
    key: "updateVariantUserData",
    value: function updateVariantUserData(t, e) {
      e[lx]().add(t), this.mesh.userData.variantData = this[yx], this.mesh.userData.variantMaterials = this.mesh.userData.variantMaterials || new Map();
      this.mesh.userData.variantMaterials.set(t, {
        material: e[fy].values().next().value,
        gltfMaterialIndex: e.index
      });
    }
  }, {
    key: "ensureVariantIsUnused",
    value: function ensureVariantIsUnused(t) {
      var e = this[yx].get(t);
      return null == e || !this.variantInfo.has(e.index) || (console.warn("Primitive cannot add variant '".concat(t, "' for this material, it already exists.")), !1);
    }
  }]);

  return Sx;
}(Mx);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Tx, Ex, Ax, Rx, Cx, Lx;
mx = gx, fx = vx;
var Px = Symbol("materials"),
    Dx = Symbol("hierarchy"),
    Ix = Symbol("roots"),
    Ox = Symbol("primitives"),
    Nx = Symbol("correlatedSceneGraph"),
    Fx = Symbol("prepareVariantsForExport"),
    Ux = Symbol("switchVariant"),
    kx = Symbol("threeScene"),
    Bx = Symbol("materialsFromPoint"),
    zx = Symbol("materialFromPoint"),
    Hx = Symbol("variantData"),
    Vx = Symbol("availableVariants"),
    Gx = Symbol("modelOnUpdate"),
    Wx = Symbol("cloneMaterial");

var jx = function jx(t, e, n, i) {
  _classCallCheck(this, jx);

  this.gltf = t, this.gltfElementMap = e, this.mapKey = n, this.doLazyLoad = i;
};

var qx = /*#__PURE__*/function (_ref29) {
  function qx(t) {
    var _this161 = this;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    _classCallCheck(this, qx);

    this[Tx] = new Array(), this[Ex] = new Array(), this[Ax] = new Array(), this[Rx] = new Array(), this[Cx] = function () {}, this[Lx] = new Map(), this[Gx] = e, this[Nx] = t;
    var n = t.gltf,
        i = t.threeGLTF,
        r = t.gltfElementMap;
    this[kx] = i.scene;

    var _iterator59 = _createForOfIteratorHelper(n.materials.entries()),
        _step59;

    try {
      for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
        var _step59$value = _slicedToArray(_step59.value, 2),
            _t462 = _step59$value[0],
            _s100 = _step59$value[1];

        var _a80 = r.get(_s100);

        if (null != _a80) this[Px].push(new dx(e, n, _s100, _t462, !0, this[Hx], _a80));else {
          (function () {
            var s = (n.materials || [])[_t462],
                o = _t462,
                l = /*#__PURE__*/function () {
              var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
                var t, e;
                return _regeneratorRuntime.wrap(function _callee39$(_context43) {
                  while (1) {
                    switch (_context43.prev = _context43.next) {
                      case 0:
                        _context43.next = 2;
                        return i.parser.getDependency("material", o);

                      case 2:
                        t = _context43.sent;
                        e = new Set();
                        return _context43.abrupt("return", (r.set(s, e), e.add(t), {
                          set: e,
                          material: t
                        }));

                      case 5:
                      case "end":
                        return _context43.stop();
                    }
                  }
                }, _callee39);
              }));

              return function l() {
                return _ref30.apply(this, arguments);
              };
            }();

            _this161[Px].push(new dx(e, n, s, _t462, !1, _this161[Hx], _a80, new jx(n, r, s, l)));
          })();
        }
      }
    } catch (err) {
      _iterator59.e(err);
    } finally {
      _iterator59.f();
    }

    var s = new Map(),
        a = new Array();

    var _iterator60 = _createForOfIteratorHelper(i.scene.children),
        _step60;

    try {
      for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
        var _t463 = _step60.value;
        a.push(_t463);
      }
    } catch (err) {
      _iterator60.e(err);
    } finally {
      _iterator60.f();
    }

    for (; a.length > 0;) {
      var _e391 = a.pop();

      var _n322 = null;
      _e391 instanceof Nn ? (_n322 = new Sx(_e391, this.materials, this[Hx], t), this[Ox].push(_n322)) : _n322 = new Mx(_e391.name);

      var _i270 = s.get(_e391);

      null != _i270 ? _i270[_x].push(_n322) : this[Ix].push(_n322), this[Dx].push(_n322);

      var _iterator61 = _createForOfIteratorHelper(_e391.children),
          _step61;

      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var _t461 = _step61.value;
          a.push(_t461), s.set(_e391, _n322);
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
    }
  }

  _createClass(qx, [{
    key: "materials",
    get: function get() {
      return this[Px];
    }
  }, {
    key: _ref29,
    value: function value() {
      var t = Array.from(this[Hx].values());
      return t.sort(function (t, e) {
        return t.index - e.index;
      }), t.map(function (t) {
        return t.name;
      });
    }
  }, {
    key: "getMaterialByName",
    value: function getMaterialByName(t) {
      var e = this[Px].filter(function (e) {
        return e.name === t;
      });
      return e.length > 0 ? e[0] : null;
    }
  }, {
    key: Bx,
    value: function value(t) {
      var _this162 = this;

      return t.intersectObject(this[kx], !0).map(function (t) {
        var e = _this162[Dx].find(function (e) {
          if (e instanceof Sx) {
            if (e.mesh === t.object) return !0;
          }

          return !1;
        });

        return null != e ? e.getActiveMaterial() : null;
      });
    }
  }, {
    key: zx,
    value: function value(t) {
      var e = this[Bx](t);
      return e.length > 0 ? e[0] : null;
    }
  }, {
    key: Ux,
    value: function () {
      var _value3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(t) {
        var _iterator62, _step62, _e392, _iterator63, _step63, _t464, _iterator64, _step64, _t465;

        return _regeneratorRuntime.wrap(function _callee40$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _iterator62 = _createForOfIteratorHelper(this[Ox]);
                _context44.prev = 1;

                _iterator62.s();

              case 3:
                if ((_step62 = _iterator62.n()).done) {
                  _context44.next = 9;
                  break;
                }

                _e392 = _step62.value;
                _context44.next = 7;
                return _e392.enableVariant(t);

              case 7:
                _context44.next = 3;
                break;

              case 9:
                _context44.next = 14;
                break;

              case 11:
                _context44.prev = 11;
                _context44.t0 = _context44["catch"](1);

                _iterator62.e(_context44.t0);

              case 14:
                _context44.prev = 14;

                _iterator62.f();

                return _context44.finish(14);

              case 17:
                _iterator63 = _createForOfIteratorHelper(this.materials);

                try {
                  for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
                    _t464 = _step63.value;

                    _t464[ox](!1);
                  }
                } catch (err) {
                  _iterator63.e(err);
                } finally {
                  _iterator63.f();
                }

                _iterator64 = _createForOfIteratorHelper(this[Ox]);

                try {
                  for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
                    _t465 = _step64.value;

                    this.materials[_t465.getActiveMaterial().index][ox](!0);
                  }
                } catch (err) {
                  _iterator64.e(err);
                } finally {
                  _iterator64.f();
                }

              case 21:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee40, this, [[1, 11, 14, 17]]);
      }));

      function value(_x38) {
        return _value3.apply(this, arguments);
      }

      return value;
    }()
  }, {
    key: Fx,
    value: function () {
      var _value4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var t, _iterator65, _step65, _e393;

        return _regeneratorRuntime.wrap(function _callee41$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                t = new Array();
                _iterator65 = _createForOfIteratorHelper(this[Ox]);

                try {
                  for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
                    _e393 = _step65.value;
                    t.push(_e393.instantiateVariants());
                  }
                } catch (err) {
                  _iterator65.e(err);
                } finally {
                  _iterator65.f();
                }

                _context45.next = 5;
                return Promise.all(t);

              case 5:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee41, this);
      }));

      function value() {
        return _value4.apply(this, arguments);
      }

      return value;
    }()
  }, {
    key: Wx,
    value: function value(t, e) {
      var n = this.materials[t];
      n.isLoaded || console.error("Cloning an unloaded material,\n           call 'material.ensureLoaded() before cloning the material.");
      var i = n[fy],
          r = JSON.parse(JSON.stringify(n[gy]));
      r.name = e;
      this[Nx].gltf.materials.push(r);
      var s = new Set();

      var _iterator66 = _createForOfIteratorHelper(i.entries()),
          _step66;

      try {
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var _step66$value = _slicedToArray(_step66.value, 2),
              _t466 = _step66$value[0],
              _n323 = _step66$value[1];

          var _r180 = _n323.clone();

          _r180.name = e + (i.size > 1 ? "_inst" + _t466 : ""), s.add(_r180);
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }

      var a = new dx(this[Gx], this[Nx].gltf, r, this[Px].length, !1, this[Hx], s);
      return this[Px].push(a), a;
    }
  }, {
    key: "createMaterialInstanceForVariant",
    value: function createMaterialInstanceForVariant(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var r = null;

      var _iterator67 = _createForOfIteratorHelper(this[Ox]),
          _step67;

      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var _i271 = _step67.value;

          var _s101 = this[Hx].get(n);

          null != _s101 && _i271.variantInfo.has(_s101.index) || null != _i271.getMaterial(t) && (this.hasVariant(n) || this.createVariant(n), null == r && (r = this[Wx](t, e)), _i271.addVariant(r, n));
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }

      if (i && null != r) {
        r[ox](!0), this.materials[t][ox](!1);

        var _iterator68 = _createForOfIteratorHelper(this[Ox]),
            _step68;

        try {
          for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
            var _t467 = _step68.value;

            _t467.enableVariant(n);
          }
        } catch (err) {
          _iterator68.e(err);
        } finally {
          _iterator68.f();
        }
      }

      return r;
    }
  }, {
    key: "createVariant",
    value: function createVariant(t) {
      this[Hx].has(t) ? console.warn("Variant '".concat(t, "'' already exists")) : this[Hx].set(t, {
        name: t,
        index: this[Hx].size
      });
    }
  }, {
    key: "hasVariant",
    value: function hasVariant(t) {
      return this[Hx].has(t);
    }
  }, {
    key: "setMaterialToVariant",
    value: function setMaterialToVariant(t, e) {
      if (null != this[Vx]().find(function (t) {
        return t === e;
      })) {
        if (t < 0 || t >= this.materials.length) console.error("setMaterialToVariant(): materialIndex is out of bounds.");else {
          var _iterator69 = _createForOfIteratorHelper(this[Ox]),
              _step69;

          try {
            for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
              var n = _step69.value;

              var _i272 = n.getMaterial(t);

              null != _i272 && n.addVariant(_i272, e);
            }
          } catch (err) {
            _iterator69.e(err);
          } finally {
            _iterator69.f();
          }
        }
      } else console.warn("Can't add material to '".concat(e, "', the variant does not exist.'"));
    }
  }, {
    key: "updateVariantName",
    value: function updateVariantName(t, e) {
      var n = this[Hx].get(t);
      null != n && (n.name = e, this[Hx].set(e, n), this[Hx].delete(t));
    }
  }, {
    key: "deleteVariant",
    value: function deleteVariant(t) {
      var e = this[Hx].get(t);

      if (null != e) {
        var _iterator70 = _createForOfIteratorHelper(this.materials),
            _step70;

        try {
          for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
            var n = _step70.value;
            n.hasVariant(t) && n[cx].delete(e.index);
          }
        } catch (err) {
          _iterator70.e(err);
        } finally {
          _iterator70.f();
        }

        var _iterator71 = _createForOfIteratorHelper(this[Ox]),
            _step71;

        try {
          for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
            var _t468 = _step71.value;

            _t468.deleteVariant(e.index);
          }
        } catch (err) {
          _iterator71.e(err);
        } finally {
          _iterator71.f();
        }

        this[Hx].delete(t);
      }
    }
  }]);

  return qx;
}((Tx = Px, Ex = Dx, Ax = Ix, Rx = Ox, Cx = Gx, Lx = Hx, Vx));
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Xx = function Xx(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var Yx = Symbol("currentGLTF"),
    Jx = Symbol("model"),
    Zx = Symbol("getOnUpdateMethod"),
    $x = Symbol("textureLoader"),
    Kx = Symbol("originalGltfJson");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Qx = function Qx(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var t_ = Math.PI / 32,
    e_ = {
  basis: [Mu(pu(t_, "rad"))],
  keywords: {
    auto: [null]
  }
},
    n_ = Symbol("autoRotateStartTime"),
    i_ = Symbol("radiansPerSecond"),
    r_ = Symbol("syncRotationRate"),
    s_ = Symbol("onCameraChange"),
    a_ = function (t) {
  var e, n, i;

  var r = /*#__PURE__*/function (_t469, _ref31) {
    _inherits(r, _t469);

    var _super150 = _createSuper(r);

    function r() {
      var _this163;

      _classCallCheck(this, r);

      _this163 = _super150.apply(this, arguments), _this163[e] = new Map(), _this163[n] = function (t) {
        t.forEach(function (t) {
          t instanceof MutationRecord && "childList" !== t.type || (t.addedNodes.forEach(function (t) {
            _this163[Gp](t);
          }), t.removedNodes.forEach(function (t) {
            _this163[Wp](t);
          }), _this163[wp]());
        });
      }, _this163[i] = new MutationObserver(_this163[Hp]);
      return _this163;
    }

    _createClass(r, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(r.prototype), "connectedCallback", this).call(this);

        for (var _t470 = 0; _t470 < this.children.length; ++_t470) {
          this[Gp](this.children[_t470]);
        }

        var _self = self,
            t = _self.ShadyDOM;
        null == t ? this[Vp].observe(this, {
          childList: !0
        }) : this[Vp] = t.observeChildren(this, this[Hp]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(r.prototype), "disconnectedCallback", this).call(this);

        var _self2 = self,
            t = _self2.ShadyDOM;
        null == t ? this[Vp].disconnect() : t.unobserveChildren(this[Vp]);
      }
    }, {
      key: _ref31,
      value: function value(t, e) {
        _get(_getPrototypeOf(r.prototype), Mp, this).call(this, t, e);

        var n = this[bp],
            i = n.annotationRenderer,
            _r181 = n.getCamera();

        n.shouldRender() && (n.updateHotspots(_r181.position), i.domElement.style.display = "", i.render(n, _r181));
      }
    }, {
      key: "updateHotspot",
      value: function updateHotspot(t) {
        var e = this[zp].get(t.name);
        null != e && (e.updatePosition(t.position), e.updateNormal(t.normal), this[wp]());
      }
    }, {
      key: "positionAndNormalFromPoint",
      value: function positionAndNormalFromPoint(t, e) {
        var n = this[bp],
            i = n.getNDC(t, e),
            _r182 = n.positionAndNormalFromPoint(i);

        if (null == _r182) return null;
        jp.copy(n.target.matrixWorld).invert();
        var s = Ip(_r182.position.applyMatrix4(jp));
        qp.getNormalMatrix(jp);
        var a = Ip(_r182.normal.applyNormalMatrix(qp));
        var o = null;
        return null != _r182.uv && (o = Op(_r182.uv)), {
          position: s,
          normal: a,
          uv: o
        };
      }
    }, {
      key: Gp,
      value: function value(t) {
        if (!(t instanceof HTMLElement && 0 === t.slot.indexOf("hotspot"))) return;
        var e = this[zp].get(t.slot);
        null != e ? e.increment() : (e = new Eu({
          name: t.slot,
          position: t.dataset.position,
          normal: t.dataset.normal
        }), this[zp].set(t.slot, e), this[bp].addHotspot(e)), this[bp].queueRender();
      }
    }, {
      key: Wp,
      value: function value(t) {
        if (!(t instanceof HTMLElement)) return;
        var e = this[zp].get(t.slot);
        e && (e.decrement() && (this[bp].removeHotspot(e), this[zp].delete(t.slot)), this[bp].queueRender());
      }
    }]);

    return r;
  }(t, (e = zp, n = Hp, i = Vp, Mp));

  return r;
}(function (t) {
  var e, n, i, r;

  var s = /*#__PURE__*/function (_t471, _ref32) {
    _inherits(s, _t471);

    var _super151 = _createSuper(s);

    function s() {
      var _this164;

      _classCallCheck(this, s);

      _this164 = _super151.apply(this, arguments), _this164[e] = void 0, _this164[n] = null, _this164[i] = new pl(), _this164[r] = null, _this164.variantName = null, _this164.orientation = "0 0 0", _this164.scale = "1 1 1";
      return _this164;
    }

    _createClass(s, [{
      key: "model",
      get: function get() {
        return this[Jx];
      }
    }, {
      key: "availableVariants",
      get: function get() {
        return this.model ? this.model[Vx]() : [];
      }
    }, {
      key: "originalGltfJson",
      get: function get() {
        return this[Kx];
      }
    }, {
      key: _ref32,
      value: function value() {
        var _this165 = this;

        return function () {
          _this165[wp]();
        };
      }
    }, {
      key: "createTexture",
      value: function () {
        var _createTexture2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(t) {
          var _this166 = this;

          var e,
              n,
              i,
              _args46 = arguments;
          return _regeneratorRuntime.wrap(function _callee42$(_context46) {
            while (1) {
              switch (_context46.prev = _context46.next) {
                case 0:
                  e = _args46.length > 1 && _args46[1] !== undefined ? _args46[1] : "image/png";
                  n = this[Yx];
                  _context46.next = 4;
                  return new Promise(function (e) {
                    return _this166[$x].load(t, e);
                  });

                case 4:
                  i = _context46.sent;
                  return _context46.abrupt("return", n && i ? (i.encoding = 3001, i.wrapS = 1e3, i.wrapT = 1e3, i.flipY = !1, i.userData.mimeType = e, new Fy(this[Zx](), i)) : null);

                case 6:
                case "end":
                  return _context46.stop();
              }
            }
          }, _callee42, this);
        }));

        function createTexture(_x39) {
          return _createTexture2.apply(this, arguments);
        }

        return createTexture;
      }()
    }, {
      key: "updated",
      value: function () {
        var _updated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(t) {
          var _t472, _e394, _t473, _e395, _n324, _i273, _r183, _s104;

          return _regeneratorRuntime.wrap(function _callee43$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  if (!(_get(_getPrototypeOf(s.prototype), "updated", this).call(this, t), t.has("variantName"))) {
                    _context47.next = 8;
                    break;
                  }

                  _t472 = this[Yx], _e394 = this.variantName;
                  _context47.t0 = null != _t472;

                  if (!_context47.t0) {
                    _context47.next = 8;
                    break;
                  }

                  _context47.next = 6;
                  return this[Jx][Ux](_e394);

                case 6:
                  this[wp]();
                  this.dispatchEvent(new CustomEvent("variant-applied"));

                case 8:
                  if (t.has("orientation") || t.has("scale")) {
                    _t473 = this[bp].modelContainer, _e395 = mu(this.orientation)[0].terms, _n324 = Tu(_e395[0]).number, _i273 = Tu(_e395[1]).number, _r183 = Tu(_e395[2]).number;

                    _t473.quaternion.setFromEuler(new Ae(_i273, _r183, _n324, "YXZ"));

                    _s104 = mu(this.scale)[0].terms;
                    _t473.scale.set(_s104[0].number, _s104[1].number, _s104[2].number), this[bp].updateBoundingBox(), this[bp].updateShadow(), this[Ep].arRenderer.onUpdateScene(), this[wp]();
                  }

                case 9:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee43, this);
        }));

        function updated(_x40) {
          return _updated.apply(this, arguments);
        }

        return updated;
      }()
    }, {
      key: Sp,
      value: function value() {
        _get(_getPrototypeOf(s.prototype), Sp, this).call(this);

        var t = this[bp].currentGLTF;

        if (null != t) {
          var _e396 = t.correlatedSceneGraph;
          null != _e396 && t !== this[Yx] && (this[Jx] = new qx(_e396, this[Zx]()), this[Kx] = JSON.parse(JSON.stringify(_e396.gltf))), "variants" in t.userData && this.requestUpdate("variantName");
        }

        this[Yx] = t, this.dispatchEvent(new CustomEvent("scene-graph-ready"));
      }
    }, {
      key: "exportScene",
      value: function () {
        var _exportScene = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(t) {
          var _this167 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee45$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  e = this[bp];
                  return _context49.abrupt("return", new Promise( /*#__PURE__*/function () {
                    var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(n) {
                      var i, r, _s103;

                      return _regeneratorRuntime.wrap(function _callee44$(_context48) {
                        while (1) {
                          switch (_context48.prev = _context48.next) {
                            case 0:
                              i = {
                                binary: !0,
                                onlyVisible: !0,
                                maxTextureSize: 1 / 0,
                                forcePowerOfTwoTextures: !1,
                                includeCustomExtensions: !1,
                                embedImages: !0
                              };
                              Object.assign(i, t), i.animations = e.animations, i.truncateDrawRange = !0;
                              r = e.shadow;
                              _s103 = !1;
                              null != r && (_s103 = r.visible, r.visible = !1);
                              _context48.next = 7;
                              return _this167[Jx][Fx]();

                            case 7:
                              new Dv().register(function (t) {
                                return new my(t);
                              }).parse(e.modelContainer.children[0], function (t) {
                                return n(new Blob([i.binary ? t : JSON.stringify(t)], {
                                  type: i.binary ? "application/octet-stream" : "application/json"
                                }));
                              }, i), null != r && (r.visible = _s103);

                            case 8:
                            case "end":
                              return _context48.stop();
                          }
                        }
                      }, _callee44);
                    }));

                    return function (_x42) {
                      return _ref33.apply(this, arguments);
                    };
                  }()));

                case 2:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee45, this);
        }));

        function exportScene(_x41) {
          return _exportScene.apply(this, arguments);
        }

        return exportScene;
      }()
    }, {
      key: "materialFromPoint",
      value: function materialFromPoint(t, e) {
        var n = this[bp],
            i = n.getNDC(t, e);
        return n.raycaster.setFromCamera(i, n.getCamera()), this[Jx][zx](n.raycaster);
      }
    }]);

    return s;
  }(t, (e = Jx, n = Yx, i = $x, r = Kx, Zx));

  return Xx([J({
    type: String,
    attribute: "variant-name"
  })], s.prototype, "variantName", void 0), Xx([J({
    type: String,
    attribute: "orientation"
  })], s.prototype, "orientation", void 0), Xx([J({
    type: String,
    attribute: "scale"
  })], s.prototype, "scale", void 0), s;
}(function (t) {
  var e, n, i;

  var r = /*#__PURE__*/function (_t474, _ref34) {
    _inherits(r, _t474);

    var _super152 = _createSuper(r);

    function r() {
      var _this168;

      _classCallCheck(this, r);

      _this168 = _super152.apply(this, arguments), _this168.autoRotate = !1, _this168.autoRotateDelay = 3e3, _this168.rotationPerSecond = "auto", _this168[e] = performance.now(), _this168[n] = 0, _this168[i] = function (t) {
        _this168.autoRotate && "user-interaction" === t.detail.source && (_this168[n_] = performance.now());
      };
      return _this168;
    }

    _createClass(r, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(r.prototype), "connectedCallback", this).call(this), this.addEventListener("camera-change", this[s_]), this[n_] = performance.now();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(r.prototype), "disconnectedCallback", this).call(this), this.removeEventListener("camera-change", this[s_]), this[n_] = performance.now();
      }
    }, {
      key: "updated",
      value: function updated(t) {
        _get(_getPrototypeOf(r.prototype), "updated", this).call(this, t), t.has("autoRotate") && (this[n_] = performance.now());
      }
    }, {
      key: _ref34,
      value: function value(t) {
        this[i_] = t[0];
      }
    }, {
      key: Mp,
      value: function value(t, e) {
        if (_get(_getPrototypeOf(r.prototype), Mp, this).call(this, t, e), !this.autoRotate || !this[Dp]() || this[Ep].isPresenting) return;
        var n = Math.min(e, t - this[n_] - this.autoRotateDelay);
        n > 0 && (this[bp].yaw = this.turntableRotation + this[i_] * n * .001);
      }
    }, {
      key: "turntableRotation",
      get: function get() {
        return this[bp].yaw;
      }
    }, {
      key: "resetTurntableRotation",
      value: function resetTurntableRotation() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this[bp].yaw = t;
      }
    }]);

    return r;
  }(t, (e = n_, n = i_, r_));

  return i = s_, Qx([J({
    type: Boolean,
    attribute: "auto-rotate"
  })], r.prototype, "autoRotate", void 0), Qx([J({
    type: Number,
    attribute: "auto-rotate-delay"
  })], r.prototype, "autoRotateDelay", void 0), Qx([tg({
    intrinsics: e_,
    updateHandler: r_
  }), J({
    type: String,
    attribute: "rotation-per-second"
  })], r.prototype, "rotationPerSecond", void 0), r;
}(function (t) {
  var e, n, i;

  var r = /*#__PURE__*/function (_t475, _ref35) {
    _inherits(r, _t475);

    var _super153 = _createSuper(r);

    function r() {
      var _this169;

      _classCallCheck(this, r);

      _this169 = _super153.apply(this, arguments), _this169.environmentImage = null, _this169.skyboxImage = null, _this169.shadowIntensity = 0, _this169.shadowSoftness = 1, _this169.exposure = 1, _this169[e] = null, _this169[n] = null, _this169[i] = function (t) {
        t.element === _assertThisInitialized(_this169) && _this169[Gu]();
      };
      return _this169;
    }

    _createClass(r, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(r.prototype), "connectedCallback", this).call(this), this[Ep].loader.addEventListener("preload", this[ju]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(r.prototype), "disconnectedCallback", this).call(this), this[Ep].loader.removeEventListener("preload", this[ju]);
      }
    }, {
      key: "updated",
      value: function updated(t) {
        _get(_getPrototypeOf(r.prototype), "updated", this).call(this, t), t.has("shadowIntensity") && (this[bp].setShadowIntensity(.5 * this.shadowIntensity), this[wp]()), t.has("shadowSoftness") && (this[bp].setShadowSoftness(this.shadowSoftness), this[wp]()), t.has("exposure") && (this[bp].exposure = this.exposure, this[wp]()), (t.has("environmentImage") || t.has("skyboxImage")) && this[Lp]() && this[Gu]();
      }
    }, {
      key: "hasBakedShadow",
      value: function hasBakedShadow() {
        return this[bp].bakedShadows.length > 0;
      }
    }, {
      key: _ref35,
      value: function value() {
        _get(_getPrototypeOf(r.prototype), Sp, this).call(this), null != this[Hu] && this[Vu](this[Hu]);
      }
    }, {
      key: Gu,
      value: function () {
        var _value5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
          var _this170 = this;

          var t, e, n, _yield$Promise, _i274, _r186;

          return _regeneratorRuntime.wrap(function _callee47$(_context51) {
            while (1) {
              switch (_context51.prev = _context51.next) {
                case 0:
                  t = this.skyboxImage, e = this.environmentImage;
                  null != this[Wu] && (this[Wu](), this[Wu] = null);
                  n = this[Ep].textureUtils;

                  if (!(null != n)) {
                    _context51.next = 17;
                    break;
                  }

                  _context51.prev = 4;
                  _context51.next = 7;
                  return new Promise( /*#__PURE__*/function () {
                    var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(i, _r185) {
                      var s;
                      return _regeneratorRuntime.wrap(function _callee46$(_context50) {
                        while (1) {
                          switch (_context50.prev = _context50.next) {
                            case 0:
                              s = n.generateEnvironmentMapAndSkybox(ru(t), e, {
                                progressTracker: _this170[Ap]
                              });

                              _this170[Wu] = function () {
                                return _r185(s);
                              };

                              _context50.t0 = i;
                              _context50.next = 5;
                              return s;

                            case 5:
                              _context50.t1 = _context50.sent;
                              (0, _context50.t0)(_context50.t1);

                            case 7:
                            case "end":
                              return _context50.stop();
                          }
                        }
                      }, _callee46);
                    }));

                    return function (_x43, _x44) {
                      return _ref36.apply(this, arguments);
                    };
                  }());

                case 7:
                  _yield$Promise = _context51.sent;
                  _i274 = _yield$Promise.environmentMap;
                  _r186 = _yield$Promise.skybox;
                  this[bp].background = null != _r186 ? _r186.name === _i274.name ? _i274 : _r186 : null, this[Vu](_i274), this[bp].dispatchEvent({
                    type: "envmap-update"
                  });
                  _context51.next = 17;
                  break;

                case 13:
                  _context51.prev = 13;
                  _context51.t0 = _context51["catch"](4);

                  if (!(_context51.t0 instanceof Error)) {
                    _context51.next = 17;
                    break;
                  }

                  throw this[Vu](null), _context51.t0;

                case 17:
                case "end":
                  return _context51.stop();
              }
            }
          }, _callee47, this, [[4, 13]]);
        }));

        function value() {
          return _value5.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: Vu,
      value: function value(t) {
        this[bp].environment !== t && (this[Hu] = t, this[bp].environment = this[Hu], this.dispatchEvent(new CustomEvent("environment-change")), this[wp]());
      }
    }]);

    return r;
  }(t, (e = Hu, n = Wu, i = ju, Sp));

  return zu([J({
    type: String,
    attribute: "environment-image"
  })], r.prototype, "environmentImage", void 0), zu([J({
    type: String,
    attribute: "skybox-image"
  })], r.prototype, "skyboxImage", void 0), zu([J({
    type: Number,
    attribute: "shadow-intensity"
  })], r.prototype, "shadowIntensity", void 0), zu([J({
    type: Number,
    attribute: "shadow-softness"
  })], r.prototype, "shadowSoftness", void 0), zu([J({
    type: Number
  })], r.prototype, "exposure", void 0), r;
}(function (t) {
  var e, n, i, r, s, a, o, l, h, c, u, d, p, m, f, g, v;

  var y = /*#__PURE__*/function (_t476, _ref37) {
    _inherits(y, _t476);

    var _super154 = _createSuper(y);

    function y() {
      var _this171;

      _classCallCheck(this, y);

      _this171 = _super154.apply(this, arguments), _this171.cameraControls = !1, _this171.cameraOrbit = "0deg 75deg 105%", _this171.cameraTarget = "auto auto auto", _this171.fieldOfView = "auto", _this171.minCameraOrbit = "auto", _this171.maxCameraOrbit = "auto", _this171.minFieldOfView = "auto", _this171.maxFieldOfView = "auto", _this171.interactionPromptThreshold = 3e3, _this171.interactionPromptStyle = Sg, _this171.interactionPrompt = wg, _this171.interactionPolicy = Tg, _this171.orbitSensitivity = 1, _this171.touchAction = Eg, _this171.disableZoom = !1, _this171.enablePan = !1, _this171.interpolationDecay = 50, _this171.bounds = "legacy", _this171[e] = _this171.shadowRoot.querySelector(".interaction-prompt"), _this171[n] = _this171.shadowRoot.querySelector(".interaction-prompt > .animated-container"), _this171[i] = _this171.shadowRoot.querySelector(".pan-target"), _this171[r] = 1 / 0, _this171[s] = 0, _this171[a] = 1 / 0, _this171[o] = !1, _this171[l] = !1, _this171[h] = new pg(_this171[bp].camera, _this171[xp], _this171[bp]), _this171[c] = new Jl(), _this171[u] = !1, _this171[d] = !1, _this171[p] = !1, _this171[m] = function () {
        isFinite(_this171[Qg]) || (_this171[Qg] = performance.now()), _this171.interactionPrompt !== Mg || _this171[Zg] || (_this171[Jg] = !0);
      }, _this171[f] = function () {
        _this171.interactionPrompt === Mg && (_this171[Jg] = !1, _this171[Bg].classList.remove("visible"), _this171[$g] = 1 / 0, _this171[Qg] = 1 / 0);
      }, _this171[g] = function (_ref38) {
        var t = _ref38.source;
        _this171[Gg](), _this171[wp](), t === ug && (_this171[Zg] = !0, _this171[Vg]()), _this171.dispatchEvent(new CustomEvent("camera-change", {
          detail: {
            source: t
          }
        }));
      }, _this171[v] = function (t) {
        "pointer-change-start" === t.type ? _this171[yp].classList.add("pointer-tumbling") : _this171[yp].classList.remove("pointer-tumbling");
      };
      return _this171;
    }

    _createClass(y, [{
      key: "getCameraOrbit",
      value: function getCameraOrbit() {
        var _this$tv = this[tv],
            t = _this$tv.theta,
            e = _this$tv.phi,
            n = _this$tv.radius;
        return {
          theta: t,
          phi: e,
          radius: n,
          toString: function toString() {
            return "".concat(this.theta, "rad ").concat(this.phi, "rad ").concat(this.radius, "m");
          }
        };
      }
    }, {
      key: "getCameraTarget",
      value: function getCameraTarget() {
        return Ip(this[Ep].isPresenting ? this[Ep].arRenderer.target : this[bp].getTarget());
      }
    }, {
      key: "getFieldOfView",
      value: function getFieldOfView() {
        return this[kg].getFieldOfView();
      }
    }, {
      key: "getMinimumFieldOfView",
      value: function getMinimumFieldOfView() {
        return this[kg].options.minimumFieldOfView;
      }
    }, {
      key: "getMaximumFieldOfView",
      value: function getMaximumFieldOfView() {
        return this[kg].options.maximumFieldOfView;
      }
    }, {
      key: "getIdealAspect",
      value: function getIdealAspect() {
        return this[bp].idealAspect;
      }
    }, {
      key: "jumpCameraToGoal",
      value: function jumpCameraToGoal() {
        this[ev] = !0, this.requestUpdate(ev, !1);
      }
    }, {
      key: "resetInteractionPrompt",
      value: function resetInteractionPrompt() {
        this[Kg] = 0, this[$g] = 1 / 0, this[Zg] = !1, this[Jg] = this.interactionPrompt === wg && this.cameraControls;
      }
    }, {
      key: "zoom",
      value: function zoom(t) {
        var e = new WheelEvent("wheel", {
          deltaY: -30 * t
        });
        this[xp].dispatchEvent(e);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(y.prototype), "connectedCallback", this).call(this), this[kg].addEventListener("change", this[Xg]), this[kg].addEventListener("pointer-change-start", this[Yg]), this[kg].addEventListener("pointer-change-end", this[Yg]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(y.prototype), "disconnectedCallback", this).call(this), this[kg].removeEventListener("change", this[Xg]), this[kg].removeEventListener("pointer-change-start", this[Yg]), this[kg].removeEventListener("pointer-change-end", this[Yg]);
      }
    }, {
      key: "updated",
      value: function updated(t) {
        var _this172 = this;

        _get(_getPrototypeOf(y.prototype), "updated", this).call(this, t);

        var e = this[kg],
            n = this[xp];

        if (t.has("cameraControls") && (this.cameraControls ? (e.enableInteraction(), this.interactionPrompt === wg && (this[Jg] = !0), n.addEventListener("focus", this[qg]), n.addEventListener("blur", this[jg])) : (n.removeEventListener("focus", this[qg]), n.removeEventListener("blur", this[jg]), e.disableInteraction(), this[Vg]()), this[xp].setAttribute("aria-label", this[up])), t.has("disableZoom") && (e.disableZoom = this.disableZoom), t.has("enablePan") && (e.enablePan = this.enablePan, this.enablePan ? this.addEventListener("contextmenu", Ig) : this.removeEventListener("contextmenu", Ig)), t.has("bounds") && (this[bp].tightBounds = "tight" === this.bounds), (t.has("interactionPrompt") || t.has("cameraControls") || t.has("src")) && (this.interactionPrompt === wg && this.cameraControls && !this[Zg] ? this[Jg] = !0 : this[Vg]()), t.has("interactionPromptStyle") && this[Bg].classList.toggle("wiggle", this.interactionPromptStyle === Sg), t.has("interactionPolicy")) {
          var _t477 = this.interactionPolicy;
          e.applyOptions({
            interactionPolicy: _t477
          });
        }

        if (t.has("touchAction")) {
          var _t478 = this.touchAction;
          e.applyOptions({
            touchAction: _t478
          }), e.updateTouchActionStyle();
        }

        t.has("orbitSensitivity") && (e.sensitivity = this.orbitSensitivity), t.has("interpolationDecay") && (e.setDamperDecayTime(this.interpolationDecay), this[bp].setTargetDamperDecayTime(this.interpolationDecay)), !0 === this[ev] && Promise.resolve().then(function () {
          e.jumpToGoal(), _this172[bp].jumpToGoal(), _this172[ev] = !1;
        });
      }
    }, {
      key: "updateFraming",
      value: function () {
        var _updateFraming2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
          var t, e, n, i;
          return _regeneratorRuntime.wrap(function _callee48$(_context52) {
            while (1) {
              switch (_context52.prev = _context52.next) {
                case 0:
                  t = this[bp], e = t.adjustedFoV(t.framedFoVDeg);
                  _context52.next = 3;
                  return t.updateFraming();

                case 3:
                  n = t.adjustedFoV(t.framedFoVDeg), i = this[kg].getFieldOfView() / e;
                  this[kg].setFieldOfView(n * i);
                  this[iv] = !0;
                  this.requestUpdate("maxFieldOfView");
                  this.requestUpdate("fieldOfView");
                  this.requestUpdate("minCameraOrbit");
                  this.requestUpdate("maxCameraOrbit");
                  _context52.next = 12;
                  return this.requestUpdate("cameraOrbit");

                case 12:
                case "end":
                  return _context52.stop();
              }
            }
          }, _callee48, this);
        }));

        function updateFraming() {
          return _updateFraming2.apply(this, arguments);
        }

        return updateFraming;
      }()
    }, {
      key: _ref37,
      value: function value(t) {
        var e = this[bp];
        e.framedFoVDeg = 180 * t[0] / Math.PI, this[kg].setFieldOfView(e.adjustedFoV(e.framedFoVDeg));
      }
    }, {
      key: rv,
      value: function value(t) {
        if (this[iv]) {
          var _this$getCameraOrbit = this.getCameraOrbit(),
              _e397 = _this$getCameraOrbit.theta,
              _n325 = _this$getCameraOrbit.phi;

          t[0] = _e397, t[1] = _n325, this[iv] = !1;
        }

        this[kg].setOrbit(t[0], t[1], t[2]);
      }
    }, {
      key: ov,
      value: function value(t) {
        this[kg].applyOptions({
          minimumAzimuthalAngle: t[0],
          minimumPolarAngle: t[1],
          minimumRadius: t[2]
        }), this.jumpCameraToGoal();
      }
    }, {
      key: lv,
      value: function value(t) {
        this[kg].applyOptions({
          maximumAzimuthalAngle: t[0],
          maximumPolarAngle: t[1],
          maximumRadius: t[2]
        }), this[Wg](t[2]), this.jumpCameraToGoal();
      }
    }, {
      key: hv,
      value: function value(t) {
        this[kg].applyOptions({
          minimumFieldOfView: 180 * t[0] / Math.PI
        }), this.jumpCameraToGoal();
      }
    }, {
      key: cv,
      value: function value(t) {
        var e = this[bp].adjustedFoV(180 * t[0] / Math.PI);
        this[kg].applyOptions({
          maximumFieldOfView: e
        }), this.jumpCameraToGoal();
      }
    }, {
      key: av,
      value: function value(t) {
        var _t479 = _slicedToArray(t, 3),
            e = _t479[0],
            n = _t479[1],
            i = _t479[2];

        this[Ep].arRenderer.isPresenting || this[bp].setTarget(e, n, i), this[Ep].arRenderer.updateTarget();
      }
    }, {
      key: Mp,
      value: function value(t, e) {
        if (_get(_getPrototypeOf(y.prototype), Mp, this).call(this, t, e), this[Ep].isPresenting || !this[Dp]()) return;
        var n = performance.now();

        if (this[Jg]) {
          var _t480 = this.interactionPrompt === wg ? this[fp] : this[Qg];

          this.loaded && n > _t480 + this.interactionPromptThreshold && (this[Jg] = !1, this[$g] = n, this[Bg].classList.add("visible"));
        }

        if (isFinite(this[$g]) && this.interactionPromptStyle === Sg) {
          var _t481 = this[bp],
              _e398 = (n - this[$g]) / 5e3 % 1,
              _i275 = yg(_e398),
              _r187 = xg(_e398);

          if (this[Hg].style.opacity = "".concat(_r187), _i275 !== this[Kg]) {
            var _e399 = _i275 * _t481.width * .05,
                _n326 = (_i275 - this[Kg]) * Math.PI / 16;

            this[Hg].style.transform = "translateX(".concat(_e399, "px)"), this[kg].adjustOrbit(_n326, 0, 0), this[Kg] = _i275;
          }
        }

        this[kg].update(t, e), this[bp].updateTarget(e);
      }
    }, {
      key: Vg,
      value: function value() {
        this[Jg] = !1, this[Bg].classList.remove("visible"), this[$g] = 1 / 0;
      }
    }, {
      key: Wg,
      value: function value(t) {
        var e = 2 * Math.max(this[bp].boundingSphere.radius, t);
        this[kg].updateNearFar(0, e);
      }
    }, {
      key: Gg,
      value: function value() {
        var _this$kg$getCameraSph = this[kg].getCameraSpherical(this[tv]),
            t = _this$kg$getCameraSph.theta,
            e = _this$kg$getCameraSph.phi,
            n = (4 + Math.floor((t % Ug + Fg) / Og)) % 4,
            i = Math.floor(e / Ng),
            r = _g[n],
            s = bg[i];

        this[mp]("View from stage ".concat(s).concat(r));
      }
    }, {
      key: up,
      get: function get() {
        return _get(_getPrototypeOf(y.prototype), up, this) + (this.cameraControls ? ". Use mouse, touch or arrow keys to move." : "");
      }
    }, {
      key: Tp,
      value: function () {
        var _value6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(t) {
          var e, n, i, r, s;
          return _regeneratorRuntime.wrap(function _callee49$(_context53) {
            while (1) {
              switch (_context53.prev = _context53.next) {
                case 0:
                  e = this[kg], n = this[bp], i = n.adjustedFoV(n.framedFoVDeg);

                  _get(_getPrototypeOf(y.prototype), Tp, this).call(this, t);

                  r = n.adjustedFoV(n.framedFoVDeg) / i, s = e.getFieldOfView() * (isFinite(r) ? r : 1);
                  e.updateAspect(this[bp].aspect);
                  _context53.next = 6;
                  return this.requestUpdate("maxFieldOfView", this.maxFieldOfView);

                case 6:
                  this[kg].setFieldOfView(s);
                  this.jumpCameraToGoal();

                case 8:
                case "end":
                  return _context53.stop();
              }
            }
          }, _callee49, this);
        }));

        function value(_x45) {
          return _value6.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: Sp,
      value: function value() {
        _get(_getPrototypeOf(y.prototype), Sp, this).call(this), this[nv] ? this[iv] = !0 : this[nv] = !0, this.requestUpdate("maxFieldOfView", this.maxFieldOfView), this.requestUpdate("fieldOfView", this.fieldOfView), this.requestUpdate("minCameraOrbit", this.minCameraOrbit), this.requestUpdate("maxCameraOrbit", this.maxCameraOrbit), this.requestUpdate("cameraOrbit", this.cameraOrbit), this.requestUpdate("cameraTarget", this.cameraTarget), this.jumpCameraToGoal();
      }
    }]);

    return y;
  }(t, (e = Bg, n = Hg, i = zg, r = Qg, s = Kg, a = $g, o = Zg, l = Jg, h = kg, c = tv, u = ev, d = nv, p = iv, sv));

  return m = qg, f = jg, g = Xg, v = Yg, vg([J({
    type: Boolean,
    attribute: "camera-controls"
  })], y.prototype, "cameraControls", void 0), vg([tg({
    intrinsics: Cg,
    observeEffects: !0,
    updateHandler: rv
  }), J({
    type: String,
    attribute: "camera-orbit",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], y.prototype, "cameraOrbit", void 0), vg([tg({
    intrinsics: Dg,
    observeEffects: !0,
    updateHandler: av
  }), J({
    type: String,
    attribute: "camera-target",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], y.prototype, "cameraTarget", void 0), vg([tg({
    intrinsics: Ag,
    observeEffects: !0,
    updateHandler: sv
  }), J({
    type: String,
    attribute: "field-of-view",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], y.prototype, "fieldOfView", void 0), vg([tg({
    intrinsics: Lg,
    updateHandler: ov
  }), J({
    type: String,
    attribute: "min-camera-orbit",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], y.prototype, "minCameraOrbit", void 0), vg([tg({
    intrinsics: Pg,
    updateHandler: lv
  }), J({
    type: String,
    attribute: "max-camera-orbit",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], y.prototype, "maxCameraOrbit", void 0), vg([tg({
    intrinsics: Rg,
    updateHandler: hv
  }), J({
    type: String,
    attribute: "min-field-of-view",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], y.prototype, "minFieldOfView", void 0), vg([tg({
    intrinsics: Ag,
    updateHandler: cv
  }), J({
    type: String,
    attribute: "max-field-of-view",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], y.prototype, "maxFieldOfView", void 0), vg([J({
    type: Number,
    attribute: "interaction-prompt-threshold"
  })], y.prototype, "interactionPromptThreshold", void 0), vg([J({
    type: String,
    attribute: "interaction-prompt-style"
  })], y.prototype, "interactionPromptStyle", void 0), vg([J({
    type: String,
    attribute: "interaction-prompt"
  })], y.prototype, "interactionPrompt", void 0), vg([J({
    type: String,
    attribute: "interaction-policy"
  })], y.prototype, "interactionPolicy", void 0), vg([J({
    type: Number,
    attribute: "orbit-sensitivity"
  })], y.prototype, "orbitSensitivity", void 0), vg([J({
    type: String,
    attribute: "touch-action"
  })], y.prototype, "touchAction", void 0), vg([J({
    type: Boolean,
    attribute: "disable-zoom"
  })], y.prototype, "disableZoom", void 0), vg([J({
    type: Boolean,
    attribute: "enable-pan"
  })], y.prototype, "enablePan", void 0), vg([J({
    type: Number,
    attribute: "interpolation-decay"
  })], y.prototype, "interpolationDecay", void 0), vg([J({
    type: String,
    attribute: "bounds"
  })], y.prototype, "bounds", void 0), y;
}(function (t) {
  var e, n, i, r, s, a, o, l, h, c;

  var u = /*#__PURE__*/function (_t482, _ref39) {
    _inherits(u, _t482);

    var _super155 = _createSuper(u);

    function u() {
      var _this173;

      _classCallCheck(this, u);

      _this173 = _super155.apply(this, arguments), _this173.ar = !1, _this173.arScale = "auto", _this173.arPlacement = "floor", _this173.arModes = "webxr scene-viewer", _this173.iosSrc = null, _this173.xrEnvironment = !1, _this173[e] = !1, _this173[n] = _this173.shadowRoot.querySelector(".ar-button"), _this173[i] = document.createElement("a"), _this173[r] = new Set(), _this173[s] = tf, _this173[a] = !1, _this173[o] = function (t) {
        t.preventDefault(), _this173.activateAR();
      }, _this173[l] = function (_ref40) {
        var t = _ref40.status;
        t !== Ku && _this173[Ep].arRenderer.presentedScene !== _this173[bp] || (_this173.setAttribute("ar-status", t), _this173.dispatchEvent(new CustomEvent("ar-status", {
          detail: {
            status: t
          }
        })), t === Ku ? _this173.removeAttribute("ar-tracking") : t === Qu && _this173.setAttribute("ar-tracking", nd));
      }, _this173[h] = function (_ref41) {
        var t = _ref41.status;
        _this173.setAttribute("ar-tracking", t), _this173.dispatchEvent(new CustomEvent("ar-tracking", {
          detail: {
            status: t
          }
        }));
      }, _this173[c] = function (t) {
        "_apple_ar_quicklook_button_tapped" == t.data && _this173.dispatchEvent(new CustomEvent("quick-look-button-tapped"));
      };
      return _this173;
    }

    _createClass(u, [{
      key: "canActivateAR",
      get: function get() {
        return this[of] !== tf;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(u.prototype), "connectedCallback", this).call(this), this[Ep].arRenderer.addEventListener("status", this[df]), this.setAttribute("ar-status", Ku), this[Ep].arRenderer.addEventListener("tracking", this[pf]), this[hf].addEventListener("message", this[mf]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(u.prototype), "disconnectedCallback", this).call(this), this[Ep].arRenderer.removeEventListener("status", this[df]), this[Ep].arRenderer.removeEventListener("tracking", this[pf]), this[hf].removeEventListener("message", this[mf]);
      }
    }, {
      key: "update",
      value: function () {
        var _update2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(t) {
          return _regeneratorRuntime.wrap(function _callee50$(_context54) {
            while (1) {
              switch (_context54.prev = _context54.next) {
                case 0:
                  _get(_getPrototypeOf(u.prototype), "update", this).call(this, t), t.has("arScale") && (this[bp].canScale = "fixed" !== this.arScale), t.has("arPlacement") && (this[bp].updateShadow(), this[wp]()), (t.has("ar") || t.has("arModes") || t.has("src") || t.has("iosSrc")) && (t.has("arModes") && (this[lf] = Jm(this.arModes)), this[ff]());

                case 1:
                case "end":
                  return _context54.stop();
              }
            }
          }, _callee50, this);
        }));

        function update(_x46) {
          return _update2.apply(this, arguments);
        }

        return update;
      }()
    }, {
      key: "activateAR",
      value: function () {
        var _activateAR = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
          return _regeneratorRuntime.wrap(function _callee51$(_context55) {
            while (1) {
              switch (_context55.prev = _context55.next) {
                case 0:
                  _context55.t0 = this[of];
                  _context55.next = _context55.t0 === $m ? 3 : _context55.t0 === Qm ? 5 : _context55.t0 === Km ? 8 : 10;
                  break;

                case 3:
                  this[sf]();
                  return _context55.abrupt("break", 11);

                case 5:
                  _context55.next = 7;
                  return this[nf]();

                case 7:
                  return _context55.abrupt("break", 11);

                case 8:
                  this[rf]();
                  return _context55.abrupt("break", 11);

                case 10:
                  console.warn("No AR Mode can be activated. This is probably due to missing configuration or device capabilities");

                case 11:
                case "end":
                  return _context55.stop();
              }
            }
          }, _callee51, this);
        }));

        function activateAR() {
          return _activateAR.apply(this, arguments);
        }

        return activateAR;
      }()
    }, {
      key: _ref39,
      value: function () {
        var _value7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
          var _iterator72, _step72, _t483, _t484;

          return _regeneratorRuntime.wrap(function _callee52$(_context56) {
            while (1) {
              switch (_context56.prev = _context56.next) {
                case 0:
                  if (!(this[of] = tf, this.ar)) {
                    _context56.next = 32;
                    break;
                  }

                  if (!(null != this.src)) {
                    _context56.next = 31;
                    break;
                  }

                  _iterator72 = _createForOfIteratorHelper(this[lf]);
                  _context56.prev = 3;

                  _iterator72.s();

                case 5:
                  if ((_step72 = _iterator72.n()).done) {
                    _context56.next = 23;
                    break;
                  }

                  _t483 = _step72.value;
                  _context56.t0 = "webxr" === _t483 && ph && !Xm;

                  if (!_context56.t0) {
                    _context56.next = 12;
                    break;
                  }

                  _context56.next = 11;
                  return this[Ep].arRenderer.supportsPresentation();

                case 11:
                  _context56.t0 = _context56.sent;

                case 12:
                  if (!_context56.t0) {
                    _context56.next = 15;
                    break;
                  }

                  this[of] = Qm;
                  return _context56.abrupt("break", 23);

                case 15:
                  if (!("scene-viewer" === _t483 && xh && !Ym)) {
                    _context56.next = 18;
                    break;
                  }

                  this[of] = Km;
                  return _context56.abrupt("break", 23);

                case 18:
                  if (!("quick-look" === _t483 && gh)) {
                    _context56.next = 21;
                    break;
                  }

                  this[of] = $m;
                  return _context56.abrupt("break", 23);

                case 21:
                  _context56.next = 5;
                  break;

                case 23:
                  _context56.next = 28;
                  break;

                case 25:
                  _context56.prev = 25;
                  _context56.t1 = _context56["catch"](3);

                  _iterator72.e(_context56.t1);

                case 28:
                  _context56.prev = 28;

                  _iterator72.f();

                  return _context56.finish(28);

                case 31:
                  !this.canActivateAR && null != this.iosSrc && gh && (this[of] = $m);

                case 32:
                  if (this.canActivateAR) this[ef].classList.add("enabled"), this[ef].addEventListener("click", this[uf]);else if (this[ef].classList.contains("enabled")) {
                    this[ef].removeEventListener("click", this[uf]), this[ef].classList.remove("enabled");
                    _t484 = ed;
                    this.setAttribute("ar-status", _t484), this.dispatchEvent(new CustomEvent("ar-status", {
                      detail: {
                        status: _t484
                      }
                    }));
                  }

                case 33:
                case "end":
                  return _context56.stop();
              }
            }
          }, _callee52, this, [[3, 25, 28, 31]]);
        }));

        function value() {
          return _value7.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: nf,
      value: function () {
        var _value8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
          var _t485;

          return _regeneratorRuntime.wrap(function _callee53$(_context57) {
            while (1) {
              switch (_context57.prev = _context57.next) {
                case 0:
                  console.log("Attempting to present in AR with WebXR...");
                  _context57.next = 3;
                  return this[gf]();

                case 3:
                  _context57.prev = 3;
                  this[ef].removeEventListener("click", this[uf]);
                  _t485 = this[Ep].arRenderer;
                  _t485.placeOnWall = "wall" === this.arPlacement;
                  _context57.next = 9;
                  return _t485.present(this[bp], this.xrEnvironment);

                case 9:
                  _context57.next = 22;
                  break;

                case 11:
                  _context57.prev = 11;
                  _context57.t0 = _context57["catch"](3);
                  console.warn("Error while trying to present in AR with WebXR");
                  console.error(_context57.t0);
                  _context57.next = 17;
                  return this[Ep].arRenderer.stopPresenting();

                case 17:
                  Xm = !0;
                  console.warn("Falling back to next ar-mode");
                  _context57.next = 21;
                  return this[ff]();

                case 21:
                  this.activateAR();

                case 22:
                  _context57.prev = 22;
                  this[ff]();
                  return _context57.finish(22);

                case 25:
                case "end":
                  return _context57.stop();
              }
            }
          }, _callee53, this, [[3, 11, 22, 25]]);
        }));

        function value() {
          return _value8.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: gf,
      value: function () {
        var _value9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
          return _regeneratorRuntime.wrap(function _callee54$(_context58) {
            while (1) {
              switch (_context58.prev = _context58.next) {
                case 0:
                  _context58.t0 = this.loaded;

                  if (_context58.t0) {
                    _context58.next = 7;
                    break;
                  }

                  this[cf] = !0;
                  this[gp]();
                  _context58.next = 6;
                  return function (t, e) {
                    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    return new Promise(function (i) {
                      t.addEventListener(e, function r(s) {
                        n && !n(s) || (i(s), t.removeEventListener(e, r));
                      });
                    });
                  }
                  /* @license
                   * Copyright 2020 Google LLC. All Rights Reserved.
                   * Licensed under the Apache License, Version 2.0 (the 'License');
                   * you may not use this file except in compliance with the License.
                   * You may obtain a copy of the License at
                   *
                   *     http://www.apache.org/licenses/LICENSE-2.0
                   *
                   * Unless required by applicable law or agreed to in writing, software
                   * distributed under the License is distributed on an 'AS IS' BASIS,
                   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                   * See the License for the specific language governing permissions and
                   * limitations under the License.
                   */
                  (this, "load");

                case 6:
                  this[cf] = !1;

                case 7:
                case "end":
                  return _context58.stop();
              }
            }
          }, _callee54, this);
        }));

        function value() {
          return _value9.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: Lp,
      value: function value() {
        return _get(_getPrototypeOf(u.prototype), Lp, this).call(this) || this[cf];
      }
    }, {
      key: rf,
      value: function value() {
        var _this174 = this;

        var t = self.location.toString(),
            e = new URL(t),
            n = new URL(this.src, t),
            i = new URLSearchParams(n.search);

        if (e.hash = "#model-viewer-no-ar-fallback", i.set("mode", "ar_preferred"), i.has("disable_occlusion") || i.set("disable_occlusion", "true"), "fixed" === this.arScale && i.set("resizable", "false"), "wall" === this.arPlacement && i.set("enable_vertical_placement", "true"), i.has("sound")) {
          var _e400 = new URL(i.get("sound"), t);

          i.set("sound", _e400.toString());
        }

        if (i.has("link")) {
          var _e401 = new URL(i.get("link"), t);

          i.set("link", _e401.toString());
        }

        var r = "intent://arvr.google.com/scene-viewer/1.0?".concat(i.toString() + "&file=" + encodeURIComponent(n.toString()), "#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=").concat(encodeURIComponent(e.toString()), ";end;");
        self.addEventListener("hashchange", function () {
          "#model-viewer-no-ar-fallback" === self.location.hash && (Ym = !0, self.history.back(), console.warn("Error while trying to present in AR with Scene Viewer"), console.warn("Falling back to next ar-mode"), _this174[ff]());
        }, {
          once: !0
        }), this[hf].setAttribute("href", r), console.log("Attempting to present in AR with Scene Viewer..."), this[hf].click();
      }
    }, {
      key: sf,
      value: function () {
        var _value10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
          var t, e, n, i, r;
          return _regeneratorRuntime.wrap(function _callee55$(_context59) {
            while (1) {
              switch (_context59.prev = _context59.next) {
                case 0:
                  t = !this.iosSrc;
                  this[ef].classList.remove("enabled");

                  if (!t) {
                    _context59.next = 8;
                    break;
                  }

                  _context59.next = 5;
                  return this.prepareUSDZ();

                case 5:
                  _context59.t0 = _context59.sent;
                  _context59.next = 9;
                  break;

                case 8:
                  _context59.t0 = this.iosSrc;

                case 9:
                  e = _context59.t0;
                  n = new URL(e, self.location.toString());
                  "fixed" === this.arScale && (n.hash && (n.hash += "&"), n.hash += "allowsContentScaling=0");
                  i = this[hf];
                  i.setAttribute("rel", "ar");
                  r = document.createElement("img");
                  i.appendChild(r), i.setAttribute("href", n.toString()), t && i.setAttribute("download", "model.usdz"), console.log("Attempting to present in AR with Quick Look..."), i.click(), i.removeChild(r), t && URL.revokeObjectURL(e), this[ef].classList.add("enabled");

                case 16:
                case "end":
                  return _context59.stop();
              }
            }
          }, _callee55, this);
        }));

        function value() {
          return _value10.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: "prepareUSDZ",
      value: function () {
        var _prepareUSDZ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
          var t, e, n, i, r, s, a, o;
          return _regeneratorRuntime.wrap(function _callee56$(_context60) {
            while (1) {
              switch (_context60.prev = _context60.next) {
                case 0:
                  t = this[Ap].beginActivity();
                  _context60.next = 3;
                  return this[gf]();

                case 3:
                  e = this[bp], n = e.shadow;
                  i = !1;
                  null != n && (i = n.visible, n.visible = !1), t(.2);
                  r = new km();
                  _context60.next = 9;
                  return r.parse(e.modelContainer);

                case 9:
                  s = _context60.sent;
                  a = new Blob([s], {
                    type: "model/vnd.usdz+zip"
                  });
                  o = URL.createObjectURL(a);
                  return _context60.abrupt("return", (t(1), null != n && (n.visible = i), o));

                case 13:
                case "end":
                  return _context60.stop();
              }
            }
          }, _callee56, this);
        }));

        function prepareUSDZ() {
          return _prepareUSDZ.apply(this, arguments);
        }

        return prepareUSDZ;
      }()
    }]);

    return u;
  }(t, (e = af, n = ef, i = hf, r = lf, s = of, a = cf, o = uf, l = df, h = pf, c = mf, ff));

  return qm([J({
    type: Boolean,
    attribute: "ar"
  })], u.prototype, "ar", void 0), qm([J({
    type: String,
    attribute: "ar-scale"
  })], u.prototype, "arScale", void 0), qm([J({
    type: String,
    attribute: "ar-placement"
  })], u.prototype, "arPlacement", void 0), qm([J({
    type: String,
    attribute: "ar-modes"
  })], u.prototype, "arModes", void 0), qm([J({
    type: String,
    attribute: "ios-src"
  })], u.prototype, "iosSrc", void 0), qm([J({
    type: Boolean,
    attribute: "xr-environment"
  })], u.prototype, "xrEnvironment", void 0), u;
}(function (t) {
  var e, n, i, r, s, a, o, l, h, c, u, d, p, m;

  var f = /*#__PURE__*/function (_t486, _ref42, _ref43) {
    _inherits(f, _t486);

    var _super156 = _createSuper(f);

    function f() {
      var _this175;

      _classCallCheck(this, f);

      for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        t[_key3] = arguments[_key3];
      }

      _this175 = _super156.call.apply(_super156, [this].concat(t)), _this175.poster = null, _this175.reveal = dv, _this175.loading = mv, _this175.generateSchema = !1, _this175.seamlessPoster = !1, _this175[e] = !1, _this175[n] = !1, _this175[i] = 0, _this175[r] = null, _this175[s] = _this175.shadowRoot.querySelector(".slot.poster"), _this175[a] = _this175.shadowRoot.querySelector("#default-poster"), _this175[o] = _this175.shadowRoot.querySelector("#default-progress-bar > .bar"), _this175[l] = _this175.shadowRoot.querySelector("#default-progress-bar > .mask"), _this175[h] = _this175[_v].getAttribute("aria-label"), _this175[c] = function (t, e) {
        var n = null;

        var i = function i() {
          null == n && (t.apply(void 0, arguments), n = self.setTimeout(function () {
            return n = null;
          }, e));
        };

        return i.flush = function () {
          null != n && (self.clearTimeout(n), n = null);
        }, i;
      }(function (t) {
        var e = _this175[vv].parentNode;
        requestAnimationFrame(function () {
          _this175[yv].style.opacity = "" + .2 * (1 - t), _this175[vv].style.transform = "scaleX(".concat(t, ")"), 0 === t && (e.removeChild(_this175[vv]), e.appendChild(_this175[vv])), 1 === t ? _this175[vv].classList.add("hide") : _this175[vv].classList.remove("hide");
        });
      }, 100), _this175[u] = function () {
        _this175.reveal !== pv && _this175.reveal !== dv && _this175.dismissPoster();
      }, _this175[d] = function (t) {
        if (_this175.reveal !== pv) switch (t.keyCode) {
          case 32:
          case 13:
            _this175.dismissPoster();

        }
      }, _this175[p] = function (t) {
        var e = t.detail.totalProgress;
        _this175[Tv] = Math.max(e, _this175[Tv]), 1 === e && (_this175[Sv].flush(), !_this175[Pp]() || null == _this175[bv] && _this175.reveal !== dv || _this175[wv]()), _this175[Sv](e), _this175.dispatchEvent(new CustomEvent("progress", {
          detail: {
            totalProgress: e
          }
        }));
      }, _this175[m] = function () {
        _this175[Ev] = !0;

        var t = _this175.getRootNode();

        t && t.activeElement === _assertThisInitialized(_this175) && _this175[xp].focus();
        var e = _this175[_v];
        e.setAttribute("aria-hidden", "true"), e.tabIndex = -1, _this175.dispatchEvent(new CustomEvent("poster-dismissed"));
      };

      var _f8 = self.ModelViewerElement || {},
          g = _f8.dracoDecoderLocation || "https://www.gstatic.com/draco/versioned/decoders/1.4.1/";

      Zc.setDRACODecoderLocation(g);
      var v = _f8.ktx2TranscoderLocation || "https://www.gstatic.com/basis-universal/versioned/2021-04-15-ba1c3e4/";
      Zc.setKTX2TranscoderLocation(v), _f8.meshoptDecoderLocation && Zc.setMeshoptDecoderLocation(_f8.meshoptDecoderLocation);
      return _this175;
    }

    _createClass(f, [{
      key: "dismissPoster",
      value: function dismissPoster() {
        this[Pp]() ? this[wv]() : (this[bv] = gv, this[gp]());
      }
    }, {
      key: "showPoster",
      value: function showPoster() {
        var t = this[xv],
            e = this[_v];
        e.removeAttribute("tabindex"), e.removeAttribute("aria-hidden"), t.classList.add("show");
        var n = this.modelIsVisible;
        this[Mv] = !1, this[cp](n), this[Ev] = !1;
      }
    }, {
      key: "getDimensions",
      value: function getDimensions() {
        return Ip(this[bp].size);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(f.prototype), "connectedCallback", this).call(this), this[xv].addEventListener("click", this[Cv]), this[xv].addEventListener("keydown", this[Lv]), this[Ap].addEventListener("progress", this[Pv]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(f.prototype), "disconnectedCallback", this).call(this), this[xv].removeEventListener("click", this[Cv]), this[xv].removeEventListener("keydown", this[Lv]), this[Ap].removeEventListener("progress", this[Pv]);
      }
    }, {
      key: "updated",
      value: function () {
        var _updated2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(t) {
          return _regeneratorRuntime.wrap(function _callee57$(_context61) {
            while (1) {
              switch (_context61.prev = _context61.next) {
                case 0:
                  _get(_getPrototypeOf(f.prototype), "updated", this).call(this, t), t.has("poster") && null != this.poster && (this[_v].style.backgroundImage = "url(".concat(this.poster, ")")), t.has("alt") && this[_v].setAttribute("aria-label", this[dp]), (t.has("reveal") || t.has("loading")) && this[gp](), t.has("generateSchema") && (!0 === this.generateSchema ? this[bp].updateSchema(this.src) : this[bp].updateSchema(null)), t.has("seamlessPoster") && (!0 === this.seamlessPoster ? this[xv].classList.add("quick") : this[xv].classList.remove("quick"));

                case 1:
                case "end":
                  return _context61.stop();
              }
            }
          }, _callee57, this);
        }));

        function updated(_x47) {
          return _updated2.apply(this, arguments);
        }

        return updated;
      }()
    }, {
      key: _ref42,
      value: function value() {
        return !!this.src && (null != this[bv] || this.loading === fv || this.reveal === dv && this[hp]);
      }
    }, {
      key: Pp,
      value: function value() {
        var t = this.src;
        return !!t && _get(_getPrototypeOf(f.prototype), Pp, this).call(this) && 1 === this[Tv];
      }
    }, {
      key: _ref43,
      value: function value() {
        var _this176 = this;

        this[bv] = null;
        var t = this[xv];

        if (t.classList.contains("show")) {
          var _e402 = this.modelIsVisible;
          this[Mv] = !0, this[cp](_e402), requestAnimationFrame(function () {
            t.classList.remove("show"), !0 === _this176.seamlessPoster ? _this176[Av]() : t.addEventListener("transitionend", _this176[Av], {
              once: !0
            });
          });
        } else this[Ev] = !0;
      }
    }, {
      key: Cp,
      value: function value() {
        return _get(_getPrototypeOf(f.prototype), Cp, this).call(this) && this[Mv];
      }
    }, {
      key: Dp,
      value: function value() {
        return _get(_getPrototypeOf(f.prototype), Dp, this).call(this) && this[Ev];
      }
    }, {
      key: gp,
      value: function () {
        var _value11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
          return _regeneratorRuntime.wrap(function _callee58$(_context62) {
            while (1) {
              switch (_context62.prev = _context62.next) {
                case 0:
                  this[Tv] = 0;
                  !0 === this.generateSchema && this[bp].updateSchema(this.src);
                  null != this[bp].currentGLTF && null != this.src && this[Lp]() || this.showPoster();
                  this[mp]("Loading");
                  _context62.next = 6;
                  return _get(_getPrototypeOf(f.prototype), gp, this).call(this);

                case 6:
                case "end":
                  return _context62.stop();
              }
            }
          }, _callee58, this);
        }));

        function value() {
          return _value11.apply(this, arguments);
        }

        return value;
      }()
    }], [{
      key: "dracoDecoderLocation",
      get: function get() {
        return Zc.getDRACODecoderLocation();
      },
      set: function set(t) {
        Zc.setDRACODecoderLocation(t);
      }
    }, {
      key: "ktx2TranscoderLocation",
      get: function get() {
        return Zc.getKTX2TranscoderLocation();
      },
      set: function set(t) {
        Zc.setKTX2TranscoderLocation(t);
      }
    }, {
      key: "meshoptDecoderLocation",
      get: function get() {
        return Zc.getMeshoptDecoderLocation();
      },
      set: function set(t) {
        Zc.setMeshoptDecoderLocation(t);
      }
    }, {
      key: "mapURLs",
      value: function mapURLs(t) {
        Fd.singleton.loader[Xc].manager.setURLModifier(t);
      }
    }]);

    return f;
  }(t, (e = Mv, n = Ev, i = Tv, r = bv, s = xv, a = _v, o = vv, l = yv, h = Rv, c = Sv, u = Cv, d = Lv, p = Pv, Lp), (m = Av, wv));

  return uv([J({
    type: String
  })], f.prototype, "poster", void 0), uv([J({
    type: String
  })], f.prototype, "reveal", void 0), uv([J({
    type: String
  })], f.prototype, "loading", void 0), uv([J({
    type: Boolean,
    attribute: "generate-schema"
  })], f.prototype, "generateSchema", void 0), uv([J({
    type: Boolean,
    attribute: "seamless-poster"
  })], f.prototype, "seamlessPoster", void 0), f;
}(function (t) {
  var e;

  var n = /*#__PURE__*/function (_t487, _ref44) {
    _inherits(n, _t487);

    var _super157 = _createSuper(n);

    function n() {
      var _this177;

      _classCallCheck(this, n);

      for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        t[_key4] = arguments[_key4];
      }

      _this177 = _super157.call(this, t), _this177.autoplay = !1, _this177.animationName = void 0, _this177.animationCrossfadeDuration = 300, _this177[e] = !0, _this177[bp].subscribeMixerEvent("loop", function (t) {
        var e = t.action._loopCount;

        _this177.dispatchEvent(new CustomEvent("loop", {
          detail: {
            count: e
          }
        }));
      }), _this177[bp].subscribeMixerEvent("finished", function () {
        _this177[kp] = !0, _this177.dispatchEvent(new CustomEvent("finished"));
      });
      return _this177;
    }

    _createClass(n, [{
      key: "availableAnimations",
      get: function get() {
        return this.loaded ? this[bp].animationNames : [];
      }
    }, {
      key: "duration",
      get: function get() {
        return this[bp].duration;
      }
    }, {
      key: "paused",
      get: function get() {
        return this[kp];
      }
    }, {
      key: "currentTime",
      get: function get() {
        return this[bp].animationTime;
      },
      set: function set(t) {
        this[bp].animationTime = t, this[wp]();
      }
    }, {
      key: "timeScale",
      get: function get() {
        return this[bp].animationTimeScale;
      },
      set: function set(t) {
        this[bp].animationTimeScale = t;
      }
    }, {
      key: "pause",
      value: function pause() {
        this[kp] || (this[kp] = !0, this.dispatchEvent(new CustomEvent("pause")));
      }
    }, {
      key: "play",
      value: function play(t) {
        this.availableAnimations.length > 0 && (this[kp] = !1, this[Up](t), this.dispatchEvent(new CustomEvent("play")));
      }
    }, {
      key: _ref44,
      value: function value() {
        _get(_getPrototypeOf(n.prototype), Sp, this).call(this), this[kp] = !0, this.autoplay && this.play();
      }
    }, {
      key: Mp,
      value: function value(t, e) {
        _get(_getPrototypeOf(n.prototype), Mp, this).call(this, t, e), this[kp] || !this[Dp]() && !this[Ep].isPresenting || (this[bp].updateAnimation(e / 1e3), this[wp]());
      }
    }, {
      key: "updated",
      value: function updated(t) {
        _get(_getPrototypeOf(n.prototype), "updated", this).call(this, t), t.has("autoplay") && this.autoplay && this.play(), t.has("animationName") && this[Up]();
      }
    }, {
      key: gp,
      value: function () {
        var _value12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
          return _regeneratorRuntime.wrap(function _callee59$(_context63) {
            while (1) {
              switch (_context63.prev = _context63.next) {
                case 0:
                  return _context63.abrupt("return", (this[bp].stopAnimation(), _get(_getPrototypeOf(n.prototype), gp, this).call(this)));

                case 1:
                case "end":
                  return _context63.stop();
              }
            }
          }, _callee59, this);
        }));

        function value() {
          return _value12.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: Up,
      value: function value() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Bp;
        var e;

        var _n327 = null !== (e = t.repetitions) && void 0 !== e ? e : 1 / 0,
            i = t.pingpong ? 2202 : 1 === _n327 ? 2200 : 2201;

        this[bp].playAnimation(this.animationName, this.animationCrossfadeDuration / 1e3, i, _n327), this[kp] && (this[bp].updateAnimation(0), this[wp]());
      }
    }]);

    return n;
  }(t, (e = kp, Sp));

  return Fp([J({
    type: Boolean
  })], n.prototype, "autoplay", void 0), Fp([J({
    type: String,
    attribute: "animation-name"
  })], n.prototype, "animationName", void 0), Fp([J({
    type: Number,
    attribute: "animation-crossfade-duration"
  })], n.prototype, "animationCrossfadeDuration", void 0), n;
}(function (t) {
  var e;
  var n = Symbol("endPolyfillCoordination");
  return e = n, /*#__PURE__*/function (_t488) {
    _inherits(_class27, _t488);

    var _super158 = _createSuper(_class27);

    function _class27() {
      var _this178;

      _classCallCheck(this, _class27);

      _this178 = _super158.apply(this, arguments), _this178[e] = null;
      return _this178;
    }

    _createClass(_class27, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(_class27.prototype), "connectedCallback", this) && _get(_getPrototypeOf(_class27.prototype), "connectedCallback", this).call(this), null == this[n] && (this[n] = function (t) {
          if (null == t.shadowRoot || t.hasAttribute("data-js-focus-visible")) return function () {};

          if (!self.applyFocusVisiblePolyfill) {
            var _e403 = function _e403() {
              self.applyFocusVisiblePolyfill(t.shadowRoot);
            };

            return self.addEventListener("focus-visible-polyfill-ready", _e403, {
              once: !0
            }), function () {
              self.removeEventListener("focus-visible-polyfill-ready", _e403);
            };
          }

          return self.applyFocusVisiblePolyfill(t.shadowRoot), function () {};
        }(this));
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(_class27.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(_class27.prototype), "disconnectedCallback", this).call(this), null != this[n] && (this[n](), this[n] = null);
      }
    }]);

    return _class27;
  }(t);
}(Np)))))))));

customElements.define("model-viewer", a_);
export { a_ as ModelViewerElement };